webpackJsonp([27180705640166],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(586);
	
	__webpack_require__(36);
	
	__webpack_require__(226);
	
	__webpack_require__(593);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  styled: true,
	  createGlobal: true,
	  createReset: true,
	  lighten: true,
	  darken: true
	};
	Object.defineProperty(exports, "createGlobal", {
	  enumerable: true,
	  get: function get() {
	    return _global.createGlobal;
	  }
	});
	Object.defineProperty(exports, "createReset", {
	  enumerable: true,
	  get: function get() {
	    return _global.createReset;
	  }
	});
	Object.defineProperty(exports, "lighten", {
	  enumerable: true,
	  get: function get() {
	    return _utils.lightenColor;
	  }
	});
	Object.defineProperty(exports, "darken", {
	  enumerable: true,
	  get: function get() {
	    return _utils.darkenColor;
	  }
	});
	exports.styled = void 0;
	
	var _styled2 = _interopRequireDefault(__webpack_require__(465));
	
	var _base = __webpack_require__(156);
	
	Object.keys(_base).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _base[key];
	    }
	  });
	});
	
	var _types = __webpack_require__(561);
	
	Object.keys(_types).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _types[key];
	    }
	  });
	});
	
	var _core = __webpack_require__(137);
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _core[key];
	    }
	  });
	});
	
	var _emotionTheming = __webpack_require__(770);
	
	Object.keys(_emotionTheming).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _emotionTheming[key];
	    }
	  });
	});
	
	var _global = __webpack_require__(558);
	
	var _create = __webpack_require__(556);
	
	Object.keys(_create).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _create[key];
	    }
	  });
	});
	
	var _convert = __webpack_require__(347);
	
	Object.keys(_convert).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _convert[key];
	    }
	  });
	});
	
	var _ensure = __webpack_require__(557);
	
	Object.keys(_ensure).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ensure[key];
	    }
	  });
	});
	
	var _utils = __webpack_require__(348);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var styled = _styled2["default"];
	exports.styled = styled;

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
	
	function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
	
	function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 * @private
	 */
	var ERRORS = {
	  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
	  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
	  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
	  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
	  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
	  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
	  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
	  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
	  "9": "Please provide a number of steps to the modularScale helper.\n\n",
	  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
	  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
	  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
	  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
	  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
	  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
	  "16": "You must provide a template to this method.\n\n",
	  "17": "You passed an unsupported selector state to this method.\n\n",
	  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
	  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
	  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
	  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
	  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
	  "23": "fontFace expects a name of a font-family.\n\n",
	  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
	  "25": "fontFace expects localFonts to be an array.\n\n",
	  "26": "fontFace expects fileFormats to be an array.\n\n",
	  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
	  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
	  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
	  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
	  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
	  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
	  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
	  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
	  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
	  "36": "Property must be a string value.\n\n",
	  "37": "Syntax Error at %s.\n\n",
	  "38": "Formula contains a function that needs parentheses at %s.\n\n",
	  "39": "Formula is missing closing parenthesis at %s.\n\n",
	  "40": "Formula has too many closing parentheses at %s.\n\n",
	  "41": "All values in a formula must have the same unit or be unitless.\n\n",
	  "42": "Please provide a number of steps to the modularScale helper.\n\n",
	  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
	  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
	  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
	  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
	  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
	  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
	  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
	  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
	  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
	  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
	  "53": "fontFace expects localFonts to be an array.\n\n",
	  "54": "fontFace expects fileFormats to be an array.\n\n",
	  "55": "fontFace expects a name of a font-family.\n\n",
	  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
	  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
	  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
	  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
	  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
	  "61": "Property must be a string value.\n\n",
	  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
	  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
	  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
	  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
	  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
	  "67": "You must provide a template to this method.\n\n",
	  "68": "You passed an unsupported selector state to this method.\n\n",
	  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
	  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
	  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
	  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n"
	};
	/**
	 * super basic version of sprintf
	 * @private
	 */
	
	function format() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var a = args[0];
	  var b = [];
	  var c;
	
	  for (c = 1; c < args.length; c += 1) {
	    b.push(args[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	  return a;
	}
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 * @private
	 */
	
	
	var PolishedError =
	/*#__PURE__*/
	function (_Error) {
	  _inheritsLoose(PolishedError, _Error);
	
	  function PolishedError(code) {
	    var _this;
	
	    if (true) {
	      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/master/src/internalHelpers/errors.md#" + code + " for more information.") || this;
	    } else {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
	    }
	
	    return _assertThisInitialized(_this);
	  }
	
	  return PolishedError;
	}(
	/*#__PURE__*/
	_wrapNativeSuper(Error));
	
	exports["default"] = PolishedError;
	module.exports = exports.default;

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TemplateTag = __webpack_require__(638);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TemplateTag2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9UZW1wbGF0ZVRhZy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL1RlbXBsYXRlVGFnJztcbiJdfQ==

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _trimResultTransformer = __webpack_require__(677);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _trimResultTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90cmltUmVzdWx0VHJhbnNmb3JtZXIvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuIl19

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _math =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1020));
	
	exports.math = _math["default"];
	
	var _directionalProperty =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(79));
	
	exports.directionalProperty = _directionalProperty["default"];
	
	var _em =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1012));
	
	exports.em = _em["default"];
	
	var _getValueAndUnit =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1013));
	
	exports.getValueAndUnit = _getValueAndUnit["default"];
	
	var _modularScale =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1014));
	
	exports.modularScale = _modularScale["default"];
	
	var _rem =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1015));
	
	exports.rem = _rem["default"];
	
	var _stripUnit =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(129));
	
	exports.stripUnit = _stripUnit["default"];
	
	var _between =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(441));
	
	exports.between = _between["default"];
	
	var _clearFix =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1021));
	
	exports.clearFix = _clearFix["default"];
	
	var _cover =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1022));
	
	exports.cover = _cover["default"];
	
	var _ellipsis =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1023));
	
	exports.ellipsis = _ellipsis["default"];
	
	var _fluidRange =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1024));
	
	exports.fluidRange = _fluidRange["default"];
	
	var _fontFace =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1025));
	
	exports.fontFace = _fontFace["default"];
	
	var _hideText =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1026));
	
	exports.hideText = _hideText["default"];
	
	var _hideVisually =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1027));
	
	exports.hideVisually = _hideVisually["default"];
	
	var _hiDPI =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(442));
	
	exports.hiDPI = _hiDPI["default"];
	
	var _linearGradient =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1028));
	
	exports.linearGradient = _linearGradient["default"];
	
	var _normalize =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1029));
	
	exports.normalize = _normalize["default"];
	
	var _radialGradient =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1030));
	
	exports.radialGradient = _radialGradient["default"];
	
	var _retinaImage =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1031));
	
	exports.retinaImage = _retinaImage["default"];
	
	var _timingFunctions =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1032));
	
	exports.timingFunctions = _timingFunctions["default"];
	
	var _triangle =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1033));
	
	exports.triangle = _triangle["default"];
	
	var _wordWrap =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1034));
	
	exports.wordWrap = _wordWrap["default"];
	
	var _adjustHue =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(993));
	
	exports.adjustHue = _adjustHue["default"];
	
	var _complement =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(994));
	
	exports.complement = _complement["default"];
	
	var _darken =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(995));
	
	exports.darken = _darken["default"];
	
	var _desaturate =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(996));
	
	exports.desaturate = _desaturate["default"];
	
	var _getContrast =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(434));
	
	exports.getContrast = _getContrast["default"];
	
	var _getLuminance =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(266));
	
	exports.getLuminance = _getLuminance["default"];
	
	var _grayscale =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(997));
	
	exports.grayscale = _grayscale["default"];
	
	var _hsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(267));
	
	exports.hsl = _hsl["default"];
	
	var _hsla =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(268));
	
	exports.hsla = _hsla["default"];
	
	var _hslToColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(998));
	
	exports.hslToColorString = _hslToColorString["default"];
	
	var _invert =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(999));
	
	exports.invert = _invert["default"];
	
	var _lighten =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1000));
	
	exports.lighten = _lighten["default"];
	
	var _meetsContrastGuidelines =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1001));
	
	exports.meetsContrastGuidelines = _meetsContrastGuidelines["default"];
	
	var _mix =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(269));
	
	exports.mix = _mix["default"];
	
	var _opacify =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1002));
	
	exports.opacify = _opacify["default"];
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	exports.parseToHsl = _parseToHsl["default"];
	
	var _parseToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(71));
	
	exports.parseToRgb = _parseToRgb["default"];
	
	var _readableColor =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1003));
	
	exports.readableColor = _readableColor["default"];
	
	var _rgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(184));
	
	exports.rgb = _rgb["default"];
	
	var _rgba =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(97));
	
	exports.rgba = _rgba["default"];
	
	var _rgbToColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1004));
	
	exports.rgbToColorString = _rgbToColorString["default"];
	
	var _saturate =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1005));
	
	exports.saturate = _saturate["default"];
	
	var _setHue =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1006));
	
	exports.setHue = _setHue["default"];
	
	var _setLightness =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1007));
	
	exports.setLightness = _setLightness["default"];
	
	var _setSaturation =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1008));
	
	exports.setSaturation = _setSaturation["default"];
	
	var _shade =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1009));
	
	exports.shade = _shade["default"];
	
	var _tint =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1010));
	
	exports.tint = _tint["default"];
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	exports.toColorString = _toColorString["default"];
	
	var _transparentize =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1011));
	
	exports.transparentize = _transparentize["default"];
	
	var _animation =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1035));
	
	exports.animation = _animation["default"];
	
	var _backgroundImages =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1036));
	
	exports.backgroundImages = _backgroundImages["default"];
	
	var _backgrounds =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1037));
	
	exports.backgrounds = _backgrounds["default"];
	
	var _border =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1038));
	
	exports.border = _border["default"];
	
	var _borderColor =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1039));
	
	exports.borderColor = _borderColor["default"];
	
	var _borderRadius =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1040));
	
	exports.borderRadius = _borderRadius["default"];
	
	var _borderStyle =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1041));
	
	exports.borderStyle = _borderStyle["default"];
	
	var _borderWidth =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1042));
	
	exports.borderWidth = _borderWidth["default"];
	
	var _buttons =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1043));
	
	exports.buttons = _buttons["default"];
	
	var _margin =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1044));
	
	exports.margin = _margin["default"];
	
	var _padding =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1045));
	
	exports.padding = _padding["default"];
	
	var _position =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1046));
	
	exports.position = _position["default"];
	
	var _size =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1047));
	
	exports.size = _size["default"];
	
	var _textInputs =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1048));
	
	exports.textInputs = _textInputs["default"];
	
	var _transitions =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1049));
	
	exports.transitions = _transitions["default"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = curry;
	
	// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
	// eslint-disable-next-line no-unused-vars
	// eslint-disable-next-line no-unused-vars
	// eslint-disable-next-line no-redeclare
	function curried(f, length, acc) {
	  return function fn() {
	    // eslint-disable-next-line prefer-rest-params
	    var combined = acc.concat(Array.prototype.slice.call(arguments));
	    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
	  };
	} // eslint-disable-next-line no-redeclare
	
	
	function curry(f) {
	  // eslint-disable-line no-redeclare
	  return curried(f, f.length, []);
	}
	
	module.exports = exports.default;

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = toColorString;
	
	var _hsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(267));
	
	var _hsla =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(268));
	
	var _rgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(184));
	
	var _rgba =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(97));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var isRgb = function isRgb(color) {
	  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
	};
	
	var isRgba = function isRgba(color) {
	  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
	};
	
	var isHsl = function isHsl(color) {
	  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
	};
	
	var isHsla = function isHsla(color) {
	  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
	};
	/**
	 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
	 * This util is useful in case you only know on runtime which color object is
	 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
	 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
	 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
	 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
	 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
	 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
	 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#ffcd64";
	 *   background: "rgba(255,205,100,0.72)";
	 *   background: "#00f";
	 *   background: "rgba(179,25,25,0.72)";
	 * }
	 */
	
	
	function toColorString(color) {
	  if (typeof color !== 'object') throw new _errors["default"](8);
	  if (isRgba(color)) return (0, _rgba["default"])(color);
	  if (isRgb(color)) return (0, _rgb["default"])(color);
	  if (isHsla(color)) return (0, _hsla["default"])(color);
	  if (isHsl(color)) return (0, _hsl["default"])(color);
	  throw new _errors["default"](8);
	}
	
	module.exports = exports.default;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var Stylis = _interopDefault(__webpack_require__(1116));
	var _insertRulePlugin = _interopDefault(__webpack_require__(1115));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var unitless = _interopDefault(__webpack_require__(291));
	var reactIs = __webpack_require__(1056);
	var memoize = _interopDefault(__webpack_require__(989));
	var PropTypes = _interopDefault(__webpack_require__(4));
	var validAttr = _interopDefault(__webpack_require__(288));
	var merge = _interopDefault(__webpack_require__(990));
	
	// 
	
	var interleave = (function (strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var isPlainObject = (function (x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
	});
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	function isFunction(test) {
	  return typeof test === 'function';
	}
	
	// 
	
	function getComponentName(target) {
	  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
	}
	
	// 
	function isStatelessFunction(test) {
	  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
	}
	
	// 
	function isStyledComponent(target) {
	  return target && typeof target.styledComponentId === 'string';
	}
	
	// 
	
	var SC_ATTR = typeof process !== 'undefined' && (({"NODE_ENV":"production","PUBLIC_DIR":"/Users/nithapu/workspace/storybookjs/storybook/docs/public"}).REACT_APP_SC_ATTR || ({"NODE_ENV":"production","PUBLIC_DIR":"/Users/nithapu/workspace/storybookjs/storybook/docs/public"}).SC_ATTR) || 'data-styled';
	
	var SC_VERSION_ATTR = 'data-styled-version';
	
	var SC_STREAM_ATTR = 'data-styled-streamed';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (({"NODE_ENV":"production","PUBLIC_DIR":"/Users/nithapu/workspace/storybookjs/storybook/docs/public"}).REACT_APP_SC_DISABLE_SPEEDY || ({"NODE_ENV":"production","PUBLIC_DIR":"/Users/nithapu/workspace/storybookjs/storybook/docs/public"}).SC_DISABLE_SPEEDY) || ("production") !== 'production';
	
	// Shared empty execution context when generating static styles
	var STATIC_EXECUTION_CONTEXT = {};
	
	// 
	
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 */
	var ERRORS =  false ? {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
	  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
	  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
	} : {};
	
	/**
	 * super basic version of sprintf
	 */
	function format() {
	  var a = arguments.length <= 0 ? undefined : arguments[0];
	  var b = [];
	
	  for (var c = 1, len = arguments.length; c < len; c += 1) {
	    b.push(arguments.length <= c ? undefined : arguments[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	
	  return a;
	}
	
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	var StyledComponentsError = function (_Error) {
	  inherits(StyledComponentsError, _Error);
	
	  function StyledComponentsError(code) {
	    classCallCheck(this, StyledComponentsError);
	
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    if (true) {
	      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
	    } else {
	      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
	    }
	    return possibleConstructorReturn(_this);
	  }
	
	  return StyledComponentsError;
	}(Error);
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = (function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	});
	
	// 
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	var _componentId = void 0;
	var _selector = void 0;
	var _selectorRegexp = void 0;
	
	var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
	  if (
	  // the first self-ref is always untouched
	  offset > 0 &&
	  // there should be at least two self-refs to do a replacement (.b > .b)
	  string.slice(0, offset).indexOf(_selector) !== -1 &&
	  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
	  string.slice(offset - _selector.length, offset) !== _selector) {
	    return '.' + _componentId;
	  }
	
	  return match;
	};
	
	/**
	 * When writing a style like
	 *
	 * & + & {
	 *   color: red;
	 * }
	 *
	 * The second ampersand should be a reference to the static component class. stylis
	 * has no knowledge of static class so we have to intelligently replace the base selector.
	 */
	var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
	  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
	    // eslint-disable-next-line no-param-reassign
	    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
	  }
	};
	
	stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	function stringifyRules(rules, selector, prefix) {
	  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';
	
	  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  // stylis has no concept of state to be passed to plugins
	  // but since JS is single=threaded, we can rely on that to ensure
	  // these properties stay in sync with the current stylis run
	  _componentId = componentId;
	  _selector = selector;
	  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	}
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = (function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	});
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = tag.ownerDocument.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = tag.ownerDocument.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new StyledComponentsError(10);
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var targetDocument = document;
	  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;
	
	  var el = targetDocument.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	  el.setAttribute(SC_VERSION_ATTR, "4.4.1");
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(targetDocument.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new StyledComponentsError(6);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whether getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    // $FlowFixMe
	    if (el.isConnected === false) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeTextNode = function makeTextNode(targetDocument, id) {
	  return targetDocument.createTextNode(makeTextMarker(id));
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	
	  /* indicates whether getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = makeTextNode(el.ownerDocument, id);
	    el.appendChild(markers[id]);
	    names[id] = Object.create(null);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(el.ownerDocument, id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeServerTag = function makeServerTag(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTag(namesClone, markersClone);
	  };
	
	  var tag = {
	    clone: clone,
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: null,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	
	  return tag;
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	var rehydrate = function rehydrate(tag, els, extracted) {
	  /* add all extracted components to the new tag */
	  for (var i = 0, len = extracted.length; i < len; i += 1) {
	    var _extracted$i = extracted[i],
	        componentId = _extracted$i.componentId,
	        cssFromDOM = _extracted$i.cssFromDOM;
	
	    var cssRules = splitByRules(cssFromDOM);
	    tag.insertRules(componentId, cssRules);
	  }
	
	  /* remove old HTMLStyleElements, since they have been rehydrated */
	  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
	    var el = els[_i];
	    if (el.parentNode) {
	      el.parentNode.removeChild(el);
	    }
	  }
	};
	
	// 
	
	var SPLIT_REGEX = /\s+/;
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	
	  /* a map from ids to tags */
	
	  /* deferred rules for a given id */
	
	  /* this is used for not reinjecting rules via hasNameForId() */
	
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	
	  /* a list of tags belonging to this StyleSheet */
	
	  /* a tag for import rules */
	
	  /* current capacity until a new tag must be created */
	
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    sheetRunningId += 1;
	    this.id = sheetRunningId;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	
	  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
	    if (!IS_BROWSER || this.forceServer) return this;
	
	    var els = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');
	
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (!nodesSize) return this;
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
	      var elNamesSize = elNames.length;
	      for (var j = 0, name; j < elNamesSize; j += 1) {
	        name = elNames[j];
	        /* add rehydrated name to sheet to avoid re-adding styles */
	        this.rehydratedNames[name] = true;
	      }
	
	      /* extract all components and their CSS */
	      extracted.push.apply(extracted, extractComps(el.textContent));
	
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (!extractedSize) return this;
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	
	    rehydrate(tag, els, extracted);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(tag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = tag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	
	    this.tags.forEach(function (tag) {
	      // eslint-disable-next-line no-param-reassign
	      tag.sealed = true;
	    });
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !prev.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for createGlobalStyle to check for its id */
	
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    var tag = this.getTagForId(id);
	
	    /* add deferred rules for component */
	    if (this.deferred[id] !== undefined) {
	      // Combine passed cssRules with previously deferred CSS rules
	      // NOTE: We cannot mutate the deferred array itself as all clones
	      // do the same (see clones[i].inject)
	      var rules = this.deferred[id].concat(cssRules);
	      tag.insertRules(id, rules, name);
	
	      this.deferred[id] = undefined;
	    } else {
	      tag.insertRules(id, cssRules, name);
	    }
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	
	    /* delete possible deferred rules */
	    this.deferred[id] = undefined;
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	// 
	
	var Keyframes = function () {
	  function Keyframes(name, rules) {
	    var _this = this;
	
	    classCallCheck(this, Keyframes);
	
	    this.inject = function (styleSheet) {
	      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
	        styleSheet.inject(_this.id, _this.rules, _this.name);
	      }
	    };
	
	    this.toString = function () {
	      throw new StyledComponentsError(12, String(_this.name));
	    };
	
	    this.name = name;
	    this.rules = rules;
	
	    this.id = 'sc-keyframes-' + name;
	  }
	
	  Keyframes.prototype.getName = function getName() {
	    return this.name;
	  };
	
	  return Keyframes;
	}();
	
	// 
	
	/**
	 * inlined version of
	 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
	 */
	
	var uppercasePattern = /([A-Z])/g;
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
	}
	
	// 
	
	// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
	function addUnitIfNeeded(name, value) {
	  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
	  // $FlowFixMe
	  if (value == null || typeof value === 'boolean' || value === '') {
	    return '';
	  }
	
	  if (typeof value === 'number' && value !== 0 && !(name in unitless)) {
	    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	  }
	
	  return String(value).trim();
	}
	
	// 
	
	/**
	 * It's falsish not falsy because 0 is allowed.
	 */
	var isFalsish = function isFalsish(chunk) {
	  return chunk === undefined || chunk === null || chunk === false || chunk === '';
	};
	
	var objToCssArray = function objToCssArray(obj, prevKey) {
	  var rules = [];
	  var keys = Object.keys(obj);
	
	  keys.forEach(function (key) {
	    if (!isFalsish(obj[key])) {
	      if (isPlainObject(obj[key])) {
	        rules.push.apply(rules, objToCssArray(obj[key], key));
	
	        return rules;
	      } else if (isFunction(obj[key])) {
	        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');
	
	        return rules;
	      }
	      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
	    }
	    return rules;
	  });
	
	  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
	};
	
	function flatten(chunk, executionContext, styleSheet) {
	  if (Array.isArray(chunk)) {
	    var ruleSet = [];
	
	    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
	      result = flatten(chunk[i], executionContext, styleSheet);
	
	      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
	    }
	
	    return ruleSet;
	  }
	
	  if (isFalsish(chunk)) {
	    return null;
	  }
	
	  /* Handle other components */
	  if (isStyledComponent(chunk)) {
	    return '.' + chunk.styledComponentId;
	  }
	
	  /* Either execute or defer the function */
	  if (isFunction(chunk)) {
	    if (isStatelessFunction(chunk) && executionContext) {
	      var _result = chunk(executionContext);
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
	      }
	
	      return flatten(_result, executionContext, styleSheet);
	    } else return chunk;
	  }
	
	  if (chunk instanceof Keyframes) {
	    if (styleSheet) {
	      chunk.inject(styleSheet);
	      return chunk.getName();
	    } else return chunk;
	  }
	
	  /* Handle objects */
	  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
	}
	
	// 
	
	function css(styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (isFunction(styles) || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  // $FlowFixMe
	  return flatten(interleave(styles, interpolations));
	}
	
	// 
	
	function constructWithOptions(componentConstructor, tag) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	  if (!reactIs.isValidElementType(tag)) {
	    throw new StyledComponentsError(1, String(tag));
	  }
	
	  /* This is callable directly as a template function */
	  // $FlowFixMe: Not typed to avoid destructuring arguments
	  var templateFunction = function templateFunction() {
	    return componentConstructor(tag, options, css.apply(undefined, arguments));
	  };
	
	  /* If config methods are called, wrap up a new template function and merge options */
	  templateFunction.withConfig = function (config) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	  };
	
	  /* Modify/inject new props at runtime */
	  templateFunction.attrs = function (attrs) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
	    }));
	  };
	
	  return templateFunction;
	}
	
	// 
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(c) {
	  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
	    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
	  }
	  switch (e) {
	    case 3:
	      a ^= (c.charCodeAt(d + 2) & 255) << 16;
	    case 2:
	      a ^= (c.charCodeAt(d + 1) & 255) << 8;
	    case 1:
	      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
	  }
	  a ^= a >>> 13;
	  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
	  return (a ^ a >>> 15) >>> 0;
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	}
	
	// 
	
	function hasFunctionObjectKey(obj) {
	  // eslint-disable-next-line guard-for-in, no-restricted-syntax
	  for (var key in obj) {
	    if (isFunction(obj[key])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isStaticRules(rules, attrs) {
	  for (var i = 0; i < rules.length; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
	      return false;
	    } else if (isFunction(rule) && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs.some(function (x) {
	    return isFunction(x) || hasFunctionObjectKey(x);
	  })) return false;
	
	  return true;
	}
	
	// 
	
	/* combines hashStr (murmurhash) and nameGenerator for convenience */
	var hasher = function hasher(str) {
	  return generateAlphabeticName(murmurhash(str));
	};
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	
	var ComponentStyle = function () {
	  function ComponentStyle(rules, attrs, componentId) {
	    classCallCheck(this, ComponentStyle);
	
	    this.rules = rules;
	    this.isStatic = ("production") === 'production' && isStaticRules(rules, attrs);
	    this.componentId = componentId;
	
	    if (!StyleSheet.master.hasId(componentId)) {
	      StyleSheet.master.deferredInject(componentId, []);
	    }
	  }
	
	  /*
	   * Flattens a rule set into valid CSS
	   * Hashes it, wraps the whole chunk in a .hash1234 {}
	   * Returns the hash to be injected on render()
	   * */
	
	
	  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	    var isStatic = this.isStatic,
	        componentId = this.componentId,
	        lastClassName = this.lastClassName;
	
	    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
	      return lastClassName;
	    }
	
	    var flatCSS = flatten(this.rules, executionContext, styleSheet);
	    var name = hasher(this.componentId + flatCSS.join(''));
	    if (!styleSheet.hasNameForId(componentId, name)) {
	      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
	    }
	
	    this.lastClassName = name;
	    return name;
	  };
	
	  ComponentStyle.generateName = function generateName(str) {
	    return hasher(str);
	  };
	
	  return ComponentStyle;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = (function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	
	var determineTheme = (function (props, fallbackTheme) {
	  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
	  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
	  /* eslint-enable */
	
	  return theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	function isTag(target) {
	  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
	}
	
	// 
	
	function generateDisplayName(target) {
	  // $FlowFixMe
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	var _TYPE_STATICS;
	
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDerivedStateFromProps: true,
	  propTypes: true,
	  type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[reactIs.ForwardRef] = {
	  $$typeof: true,
	  render: true
	}, _TYPE_STATICS);
	
	var defineProperty$1 = Object.defineProperty,
	    getOwnPropertyNames = Object.getOwnPropertyNames,
	    _Object$getOwnPropert = Object.getOwnPropertySymbols,
	    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
	  return [];
	} : _Object$getOwnPropert,
	    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
	    getPrototypeOf = Object.getPrototypeOf,
	    objectPrototype = Object.prototype;
	var arrayPrototype = Array.prototype;
	
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	
	    var inheritedComponent = getPrototypeOf(sourceComponent);
	
	    if (inheritedComponent && inheritedComponent !== objectPrototype) {
	      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	    }
	
	    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
	    // $FlowFixMe
	    getOwnPropertySymbols(sourceComponent));
	
	    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;
	
	    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;
	
	    var i = keys.length;
	    var descriptor = void 0;
	    var key = void 0;
	
	    // eslint-disable-next-line no-plusplus
	    while (i--) {
	      key = keys[i];
	
	      if (
	      // $FlowFixMe
	      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
	      // $FlowFixMe
	      !(targetStatics && targetStatics[key])) {
	        descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        if (descriptor) {
	          try {
	            // Avoid failures from read-only properties
	            defineProperty$1(targetComponent, key, descriptor);
	          } catch (e) {
	            /* fail silently */
	          }
	        }
	      }
	    }
	
	    return targetComponent;
	  }
	
	  return targetComponent;
	}
	
	// 
	function isDerivedReactComponent(fn) {
	  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
	}
	
	// 
	// Helper to call a given function, only once
	var once = (function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb.apply(undefined, arguments);
	    }
	  };
	});
	
	// 
	
	var ThemeContext = React.createContext();
	
	var ThemeConsumer = ThemeContext.Consumer;
	
	/**
	 * Provide a theme to an entire react component tree via context
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider(props) {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getContext = memoize(_this.getContext.bind(_this));
	    _this.renderInner = _this.renderInner.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) return null;
	
	    return React__default.createElement(
	      ThemeContext.Consumer,
	      null,
	      this.renderInner
	    );
	  };
	
	  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
	    var context = this.getContext(this.props.theme, outerTheme);
	
	    return React__default.createElement(
	      ThemeContext.Provider,
	      { value: context },
	      this.props.children
	    );
	  };
	
	  /**
	   * Get the theme from the props, supporting both (outerTheme) => {}
	   * as well as object notation
	   */
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
	    if (isFunction(theme)) {
	      var mergedTheme = theme(outerTheme);
	
	      if (false) {
	        throw new StyledComponentsError(7);
	      }
	
	      return mergedTheme;
	    }
	
	    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
	      throw new StyledComponentsError(8);
	    }
	
	    return _extends({}, outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
	    return this.getTheme(theme, outerTheme);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	// 
	
	var CLOSING_TAG_R = /^\s*<\/[a-z]/i;
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.sealed = false;
	  }
	
	  /**
	   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
	   * StyleSheet singleton.
	   */
	
	
	  ServerStyleSheet.prototype.seal = function seal() {
	    if (!this.sealed) {
	      /* Remove sealed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.sealed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.sealed) {
	      throw new StyledComponentsError(2);
	    }
	
	    return React__default.createElement(
	      StyleSheetManager,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.seal();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.seal();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new StyledComponentsError(3);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	
	    var transformer = new stream.Transform({
	      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
	        var tags = instance.tags;
	
	        var html = '';
	
	        /* retrieve html for each new style tag */
	        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	          var tag = tags[instanceTagIndex];
	          html += tag.toHTML(streamAttr);
	        }
	
	        /* force our StyleSheets to emit entirely new tags */
	        instance.sealAllTags();
	
	        var renderedHtml = chunk.toString();
	
	        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
	        if (CLOSING_TAG_R.test(renderedHtml)) {
	          var endOfClosingTag = renderedHtml.indexOf('>');
	
	          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
	        } else this.push(html + renderedHtml);
	
	        callback();
	      }
	    });
	
	    readableStream.on('end', function () {
	      return _this.seal();
	    });
	
	    readableStream.on('error', function (err) {
	      _this.seal();
	
	      // forward the error to the transform stream
	      transformer.emit('error', err);
	    });
	
	    return readableStream.pipe(transformer);
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var StyleSheetContext = React.createContext();
	var StyleSheetConsumer = StyleSheetContext.Consumer;
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager(props) {
	    classCallCheck(this, StyleSheetManager);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getContext = memoize(_this.getContext);
	    return _this;
	  }
	
	  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
	    if (sheet) {
	      return sheet;
	    } else if (target) {
	      return new StyleSheet(target);
	    } else {
	      throw new StyledComponentsError(4);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        sheet = _props.sheet,
	        target = _props.target;
	
	
	    return React__default.createElement(
	      StyleSheetContext.Provider,
	      { value: this.getContext(sheet, target) },
	       false ? React__default.Children.only(children) : children
	    );
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	
	var identifiers = {};
	
	/* We depend on components having unique IDs */
	function generateId(_ComponentStyle, _displayName, parentComponentId) {
	  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	  /**
	   * This ensures uniqueness if two components happen to share
	   * the same displayName.
	   */
	  var nr = (identifiers[displayName] || 0) + 1;
	  identifiers[displayName] = nr;
	
	  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);
	
	  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
	}
	
	// $FlowFixMe
	
	var StyledComponent = function (_Component) {
	  inherits(StyledComponent, _Component);
	
	  function StyledComponent() {
	    classCallCheck(this, StyledComponent);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.attrs = {};
	
	    _this.renderOuter = _this.renderOuter.bind(_this);
	    _this.renderInner = _this.renderInner.bind(_this);
	
	    if (false) {
	      _this.warnInnerRef = once(function (displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
	        );
	      });
	
	      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".', '\n ' + new Error().stack)
	        );
	      });
	
	      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
	        );
	      });
	    }
	    return _this;
	  }
	
	  StyledComponent.prototype.render = function render() {
	    return React__default.createElement(
	      StyleSheetConsumer,
	      null,
	      this.renderOuter
	    );
	  };
	
	  StyledComponent.prototype.renderOuter = function renderOuter() {
	    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;
	
	    this.styleSheet = styleSheet;
	
	    // No need to subscribe a static component to theme changes, it won't change anything
	    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();
	
	    return React__default.createElement(
	      ThemeConsumer,
	      null,
	      this.renderInner
	    );
	  };
	
	  StyledComponent.prototype.renderInner = function renderInner(theme) {
	    var _props$forwardedCompo = this.props.forwardedComponent,
	        componentStyle = _props$forwardedCompo.componentStyle,
	        defaultProps = _props$forwardedCompo.defaultProps,
	        displayName = _props$forwardedCompo.displayName,
	        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
	        styledComponentId = _props$forwardedCompo.styledComponentId,
	        target = _props$forwardedCompo.target;
	
	
	    var generatedClassName = void 0;
	    if (componentStyle.isStatic) {
	      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
	    } else {
	      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
	    }
	
	    var elementToBeCreated = this.props.as || this.attrs.as || target;
	    var isTargetTag = isTag(elementToBeCreated);
	
	    var propsForElement = {};
	    var computedProps = _extends({}, this.props, this.attrs);
	
	    var key = void 0;
	    // eslint-disable-next-line guard-for-in
	    for (key in computedProps) {
	      if (false) {
	        this.warnInnerRef(displayName);
	      }
	
	      if (key === 'forwardedComponent' || key === 'as') {
	        continue;
	      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || validAttr(key)) {
	        // Don't pass through non HTML tags through to HTML elements
	        propsForElement[key] = computedProps[key];
	      }
	    }
	
	    if (this.props.style && this.attrs.style) {
	      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
	    }
	
	    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');
	
	    return React.createElement(elementToBeCreated, propsForElement);
	  };
	
	  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
	    var _this2 = this;
	
	    var context = _extends({}, props, { theme: theme });
	
	    if (!attrs.length) return context;
	
	    this.attrs = {};
	
	    attrs.forEach(function (attrDef) {
	      var resolvedAttrDef = attrDef;
	      var attrDefWasFn = false;
	      var attr = void 0;
	      var key = void 0;
	
	      if (isFunction(resolvedAttrDef)) {
	        // $FlowFixMe
	        resolvedAttrDef = resolvedAttrDef(context);
	        attrDefWasFn = true;
	      }
	
	      /* eslint-disable guard-for-in */
	      // $FlowFixMe
	      for (key in resolvedAttrDef) {
	        attr = resolvedAttrDef[key];
	
	        if (!attrDefWasFn) {
	          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
	            if (false) {
	              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
	            }
	
	            attr = attr(context);
	
	            if (false) {
	              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
	            }
	          }
	        }
	
	        _this2.attrs[key] = attr;
	        context[key] = attr;
	      }
	      /* eslint-enable */
	    });
	
	    return context;
	  };
	
	  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	    var _props$forwardedCompo2 = props.forwardedComponent,
	        attrs = _props$forwardedCompo2.attrs,
	        componentStyle = _props$forwardedCompo2.componentStyle,
	        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;
	
	    // statically styled-components don't need to build an execution context object,
	    // and shouldn't be increasing the number of class names
	
	    if (componentStyle.isStatic && !attrs.length) {
	      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
	    }
	
	    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);
	
	    if (false) warnTooManyClasses(className);
	
	    return className;
	  };
	
	  return StyledComponent;
	}(React.Component);
	
	function createStyledComponent(target, options, rules) {
	  var isTargetStyledComp = isStyledComponent(target);
	  var isClass = !isTag(target);
	
	  var _options$displayName = options.displayName,
	      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	      _options$componentId = options.componentId,
	      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
	      _options$ParentCompon = options.ParentComponent,
	      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
	      _options$attrs = options.attrs,
	      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;
	
	
	  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
	
	  // fold the underlying StyledComponent attrs up (implicit extend)
	  var finalAttrs =
	  // $FlowFixMe
	  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;
	
	  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
	  // $FlowFixMe
	  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);
	
	  /**
	   * forwardRef creates a new interim component, which we'll take advantage of
	   * instead of extending ParentComponent to create _another_ interim class
	   */
	  var WrappedStyledComponent = void 0;
	  var forwardRef = function forwardRef(props, ref) {
	    return React__default.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
	  };
	  forwardRef.displayName = displayName;
	  WrappedStyledComponent = React__default.forwardRef(forwardRef);
	  WrappedStyledComponent.displayName = displayName;
	
	  // $FlowFixMe
	  WrappedStyledComponent.attrs = finalAttrs;
	  // $FlowFixMe
	  WrappedStyledComponent.componentStyle = componentStyle;
	
	  // $FlowFixMe
	  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
	  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;
	
	  // $FlowFixMe
	  WrappedStyledComponent.styledComponentId = styledComponentId;
	
	  // fold the underlying StyledComponent target up since we folded the styles
	  // $FlowFixMe
	  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;
	
	  // $FlowFixMe
	  WrappedStyledComponent.withComponent = function withComponent(tag) {
	    var previousComponentId = options.componentId,
	        optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	
	    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	    var newOptions = _extends({}, optionsToCopy, {
	      attrs: finalAttrs,
	      componentId: newComponentId,
	      ParentComponent: ParentComponent
	    });
	
	    return createStyledComponent(tag, newOptions, rules);
	  };
	
	  // $FlowFixMe
	  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
	    get: function get$$1() {
	      return this._foldedDefaultProps;
	    },
	    set: function set$$1(obj) {
	      // $FlowFixMe
	      this._foldedDefaultProps = isTargetStyledComp ? merge(target.defaultProps, obj) : obj;
	    }
	  });
	
	  if (false) {
	    // $FlowFixMe
	    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	  }
	
	  // $FlowFixMe
	  WrappedStyledComponent.toString = function () {
	    return '.' + WrappedStyledComponent.styledComponentId;
	  };
	
	  if (isClass) {
	    hoistNonReactStatics(WrappedStyledComponent, target, {
	      // all SC-specific things should not be hoisted
	      attrs: true,
	      componentStyle: true,
	      displayName: true,
	      foldedComponentIds: true,
	      styledComponentId: true,
	      target: true,
	      withComponent: true
	    });
	  }
	
	  return WrappedStyledComponent;
	}
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var styled = function styled(tag) {
	  return constructWithOptions(createStyledComponent, tag);
	};
	
	// Shorthands for all valid HTML Elements
	domElements.forEach(function (domElement) {
	  styled[domElement] = styled(domElement);
	});
	
	// 
	
	var GlobalStyle = function () {
	  function GlobalStyle(rules, componentId) {
	    classCallCheck(this, GlobalStyle);
	
	    this.rules = rules;
	    this.componentId = componentId;
	    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);
	
	    if (!StyleSheet.master.hasId(componentId)) {
	      StyleSheet.master.deferredInject(componentId, []);
	    }
	  }
	
	  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
	    var flatCSS = flatten(this.rules, executionContext, styleSheet);
	    var css = stringifyRules(flatCSS, '');
	
	    styleSheet.inject(this.componentId, css);
	  };
	
	  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
	    var componentId = this.componentId;
	
	    if (styleSheet.hasId(componentId)) {
	      styleSheet.remove(componentId);
	    }
	  };
	
	  // TODO: overwrite in-place instead of remove+create?
	
	
	  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
	    this.removeStyles(styleSheet);
	    this.createStyles(executionContext, styleSheet);
	  };
	
	  return GlobalStyle;
	}();
	
	// 
	
	// place our cache into shared context so it'll persist between HMRs
	if (IS_BROWSER) {
	  window.scCGSHMRCache = {};
	}
	
	function createGlobalStyle(strings) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(undefined, [strings].concat(interpolations));
	  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
	  var style = new GlobalStyle(rules, id);
	
	  var GlobalStyleComponent = function (_React$Component) {
	    inherits(GlobalStyleComponent, _React$Component);
	
	    function GlobalStyleComponent(props) {
	      classCallCheck(this, GlobalStyleComponent);
	
	      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      var _this$constructor = _this.constructor,
	          globalStyle = _this$constructor.globalStyle,
	          styledComponentId = _this$constructor.styledComponentId;
	
	
	      if (IS_BROWSER) {
	        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
	      }
	
	      /**
	       * This fixes HMR compatibility. Don't ask me why, but this combination of
	       * caching the closure variables via statics and then persisting the statics in
	       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
	       */
	      _this.state = {
	        globalStyle: globalStyle,
	        styledComponentId: styledComponentId
	      };
	      return _this;
	    }
	
	    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (window.scCGSHMRCache[this.state.styledComponentId]) {
	        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
	      }
	      /**
	       * Depending on the order "render" is called this can cause the styles to be lost
	       * until the next render pass of the remaining instance, which may
	       * not be immediate.
	       */
	      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
	        this.state.globalStyle.removeStyles(this.styleSheet);
	      }
	    };
	
	    GlobalStyleComponent.prototype.render = function render() {
	      var _this2 = this;
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
	      }
	
	      return React__default.createElement(
	        StyleSheetConsumer,
	        null,
	        function (styleSheet) {
	          _this2.styleSheet = styleSheet || StyleSheet.master;
	
	          var globalStyle = _this2.state.globalStyle;
	
	
	          if (globalStyle.isStatic) {
	            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);
	
	            return null;
	          } else {
	            return React__default.createElement(
	              ThemeConsumer,
	              null,
	              function (theme) {
	                // $FlowFixMe
	                var defaultProps = _this2.constructor.defaultProps;
	
	
	                var context = _extends({}, _this2.props);
	
	                if (typeof theme !== 'undefined') {
	                  context.theme = determineTheme(_this2.props, theme, defaultProps);
	                }
	
	                globalStyle.renderStyles(context, _this2.styleSheet);
	
	                return null;
	              }
	            );
	          }
	        }
	      );
	    };
	
	    return GlobalStyleComponent;
	  }(React__default.Component);
	
	  GlobalStyleComponent.globalStyle = style;
	  GlobalStyleComponent.styledComponentId = id;
	
	
	  return GlobalStyleComponent;
	}
	
	// 
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	function keyframes(strings) {
	  /* Warning if you've used keyframes on React Native */
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
	  }
	
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(undefined, [strings].concat(interpolations));
	
	  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	
	  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
	}
	
	// 
	
	var withTheme = (function (Component) {
	  var WithTheme = React__default.forwardRef(function (props, ref) {
	    return React__default.createElement(
	      ThemeConsumer,
	      null,
	      function (theme) {
	        // $FlowFixMe
	        var defaultProps = Component.defaultProps;
	
	        var themeProp = determineTheme(props, theme, defaultProps);
	
	        if (false) {
	          // eslint-disable-next-line no-console
	          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component) + '"');
	        }
	
	        return React__default.createElement(Component, _extends({}, props, { theme: themeProp, ref: ref }));
	      }
	    );
	  });
	
	  hoistNonReactStatics(WithTheme, Component);
	
	  WithTheme.displayName = 'WithTheme(' + getComponentName(Component) + ')';
	
	  return WithTheme;
	});
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	//
	
	exports.default = styled;
	exports.createGlobalStyle = createGlobalStyle;
	exports.css = css;
	exports.isStyledComponent = isStyledComponent;
	exports.keyframes = keyframes;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetConsumer = StyleSheetConsumer;
	exports.StyleSheetContext = StyleSheetContext;
	exports.StyleSheetManager = StyleSheetManager;
	exports.ThemeConsumer = ThemeConsumer;
	exports.ThemeContext = ThemeContext;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(272)))

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _inlineArrayTransformer = __webpack_require__(648);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _inlineArrayTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmxpbmVBcnJheVRyYW5zZm9ybWVyL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vaW5saW5lQXJyYXlUcmFuc2Zvcm1lcic7XG4iXX0=

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = parseToHsl;
	
	var _parseToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(71));
	
	var _rgbToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1018));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function parseToHsl(color) {
	  // Note: At a later stage we can optimize this function as right now a hsl
	  // color would be parsed converted to rgb values and converted back to hsl.
	  return (0, _rgbToHsl["default"])((0, _parseToRgb["default"])(color));
	}
	
	module.exports = exports.default;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageMargins = exports.pageMargin = exports.breakpoint = exports.typography = exports.spacing = exports.color = exports.background = undefined;
	
	var _styledComponents = __webpack_require__(34);
	
	// Global style variables
	var background = exports.background = {
	  app: '#F6F9FC',
	  appInverse: '#7A8997',
	  positive: '#E1FFD4',
	  negative: '#FEDED2',
	  warning: '#FFF5CF',
	  critical: '#FF4400'
	};
	
	var color = exports.color = {
	  // Palette
	  primary: '#FF4785', // coral
	  secondary: '#1EA7FD', // ocean
	  tertiary: '#DDDDDD',
	
	  orange: '#FC521F',
	  gold: '#FFAE00',
	  green: '#66BF3C',
	  seafoam: '#37D5D3',
	  purple: '#6F2CAC',
	  ultraviolet: '#2A0481',
	
	  // Monochrome
	  lightest: '#FFFFFF',
	  lighter: '#F8F8F8',
	  light: '#F3F3F3',
	  mediumlight: '#EEEEEE',
	  medium: '#DDDDDD',
	  mediumdark: '#999999',
	  dark: '#666666',
	  darker: '#444444',
	  darkest: '#333333',
	
	  border: 'rgba(0,0,0,.05)',
	
	  // Status
	  positive: '#66BF3C',
	  negative: '#FF4400',
	  critical: '#FFFFFF'
	};
	
	var spacing = exports.spacing = {
	  padding: {
	    small: 10,
	    medium: 20,
	    large: 30
	  },
	  borderRadius: {
	    small: 5,
	    default: 10
	  }
	};
	
	var typography = exports.typography = {
	  type: {
	    primary: '"Nunito Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
	    code: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace'
	  },
	  weight: {
	    regular: '400',
	    bold: '700',
	    black: '900'
	  },
	  size: {
	    s1: '12',
	    s2: '14',
	    s3: '16',
	    m1: '20',
	    m2: '24',
	    m3: '28',
	    l1: '32',
	    l2: '40',
	    l3: '48',
	    code: '90'
	  }
	};
	
	var breakpoint = exports.breakpoint = 600;
	var pageMargin = exports.pageMargin = '5.55555';
	
	var pageMargins = exports.pageMargins = (0, _styledComponents.css)(['padding:0 ', 'px;@media (min-width:', 'px){margin:0 ', '%;}@media (min-width:', 'px){margin:0 ', '%;}@media (min-width:', 'px){margin:0 ', '%;}@media (min-width:', 'px){margin:0 ', '%;}'], spacing.padding.medium, breakpoint * 1, pageMargin * 1, breakpoint * 2, pageMargin * 2, breakpoint * 3, pageMargin * 3, breakpoint * 4, pageMargin * 4);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _stripIndentTransformer = __webpack_require__(674);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _stripIndentTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudFRyYW5zZm9ybWVyL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcic7XG4iXX0=

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = parseToRgb;
	
	var _hslToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(271));
	
	var _nameToHex =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1017));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var hexRegex = /^#[a-fA-F0-9]{6}$/;
	var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
	var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
	var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
	var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
	var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
	var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
	var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
	/**
	 * Returns an RgbColor or RgbaColor object. This utility function is only useful
	 * if want to extract a color component. With the color util `toColorString` you
	 * can convert a RgbColor or RgbaColor object back to a string.
	 *
	 * @example
	 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
	 * const color1 = parseToRgb('rgb(255, 0, 0)');
	 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
	 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
	 */
	
	function parseToRgb(color) {
	  if (typeof color !== 'string') {
	    throw new _errors["default"](3);
	  }
	
	  var normalizedColor = (0, _nameToHex["default"])(color);
	
	  if (normalizedColor.match(hexRegex)) {
	    return {
	      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
	      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
	      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
	    };
	  }
	
	  if (normalizedColor.match(hexRgbaRegex)) {
	    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
	    return {
	      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
	      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
	      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
	      alpha: alpha
	    };
	  }
	
	  if (normalizedColor.match(reducedHexRegex)) {
	    return {
	      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
	      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
	      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
	    };
	  }
	
	  if (normalizedColor.match(reducedRgbaHexRegex)) {
	    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
	
	    return {
	      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
	      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
	      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
	      alpha: _alpha
	    };
	  }
	
	  var rgbMatched = rgbRegex.exec(normalizedColor);
	
	  if (rgbMatched) {
	    return {
	      red: parseInt("" + rgbMatched[1], 10),
	      green: parseInt("" + rgbMatched[2], 10),
	      blue: parseInt("" + rgbMatched[3], 10)
	    };
	  }
	
	  var rgbaMatched = rgbaRegex.exec(normalizedColor);
	
	  if (rgbaMatched) {
	    return {
	      red: parseInt("" + rgbaMatched[1], 10),
	      green: parseInt("" + rgbaMatched[2], 10),
	      blue: parseInt("" + rgbaMatched[3], 10),
	      alpha: parseFloat("" + rgbaMatched[4])
	    };
	  }
	
	  var hslMatched = hslRegex.exec(normalizedColor);
	
	  if (hslMatched) {
	    var hue = parseInt("" + hslMatched[1], 10);
	    var saturation = parseInt("" + hslMatched[2], 10) / 100;
	    var lightness = parseInt("" + hslMatched[3], 10) / 100;
	    var rgbColorString = "rgb(" + (0, _hslToRgb["default"])(hue, saturation, lightness) + ")";
	    var hslRgbMatched = rgbRegex.exec(rgbColorString);
	
	    if (!hslRgbMatched) {
	      throw new _errors["default"](4, normalizedColor, rgbColorString);
	    }
	
	    return {
	      red: parseInt("" + hslRgbMatched[1], 10),
	      green: parseInt("" + hslRgbMatched[2], 10),
	      blue: parseInt("" + hslRgbMatched[3], 10)
	    };
	  }
	
	  var hslaMatched = hslaRegex.exec(normalizedColor);
	
	  if (hslaMatched) {
	    var _hue = parseInt("" + hslaMatched[1], 10);
	
	    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
	
	    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
	
	    var _rgbColorString = "rgb(" + (0, _hslToRgb["default"])(_hue, _saturation, _lightness) + ")";
	
	    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
	
	    if (!_hslRgbMatched) {
	      throw new _errors["default"](4, normalizedColor, _rgbColorString);
	    }
	
	    return {
	      red: parseInt("" + _hslRgbMatched[1], 10),
	      green: parseInt("" + _hslRgbMatched[2], 10),
	      blue: parseInt("" + _hslRgbMatched[3], 10),
	      alpha: parseFloat("" + hslaMatched[4])
	    };
	  }
	
	  throw new _errors["default"](5);
	}
	
	module.exports = exports.default;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _replaceResultTransformer = __webpack_require__(664);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _replaceResultTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXInO1xuIl19

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = directionalProperty;
	
	var _capitalizeString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(270));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var positionMap = ['Top', 'Right', 'Bottom', 'Left'];
	
	function generateProperty(property, position) {
	  if (!property) return position.toLowerCase();
	  var splitProperty = property.split('-');
	
	  if (splitProperty.length > 1) {
	    splitProperty.splice(1, 0, position);
	    return splitProperty.reduce(function (acc, val) {
	      return "" + acc + (0, _capitalizeString["default"])(val);
	    });
	  }
	
	  var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
	  return property === joinedProperty ? "" + property + position : joinedProperty;
	}
	
	function generateStyles(property, valuesWithDefaults) {
	  var styles = {};
	
	  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
	    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
	      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
	    }
	  }
	
	  return styles;
	}
	/**
	 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'paddingTop': '12px',
	 *   'paddingRight': '24px',
	 *   'paddingBottom': '36px',
	 *   'paddingLeft': '48px'
	 * }
	 */
	
	
	function directionalProperty(property) {
	  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  //  prettier-ignore
	  var firstValue = values[0],
	      _values$ = values[1],
	      secondValue = _values$ === void 0 ? firstValue : _values$,
	      _values$2 = values[2],
	      thirdValue = _values$2 === void 0 ? firstValue : _values$2,
	      _values$3 = values[3],
	      fourthValue = _values$3 === void 0 ? secondValue : _values$3;
	  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
	  return generateStyles(property, valuesWithDefaults);
	}
	
	module.exports = exports.default;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = rgba;
	
	var _parseToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(71));
	
	var _rgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(184));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function rgba(firstValue, secondValue, thirdValue, fourthValue) {
	  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
	    var rgbValue = (0, _parseToRgb["default"])(firstValue);
	    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
	  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
	    return fourthValue >= 1 ? (0, _rgb["default"])(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
	  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
	    return firstValue.alpha >= 1 ? (0, _rgb["default"])(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
	  }
	
	  throw new _errors["default"](7);
	}
	
	module.exports = exports.default;

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function guard(lowerBoundary, upperBoundary, value) {
	  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
	}
	
	var _default = guard;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResetWrapper = exports.TT = exports.Code = exports.P = exports.OL = exports.UL = exports.LI = exports.Span = exports.Div = exports.Img = exports.Table = exports.Blockquote = exports.DL = exports.HR = exports.A = exports.Pre = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
	
	var _theming = __webpack_require__(5);
	
	var _withReset = __webpack_require__(143);
	
	var headerCommon = function headerCommon(_ref) {
	  var theme = _ref.theme;
	  return {
	    margin: '20px 0 8px',
	    padding: 0,
	    cursor: 'text',
	    position: 'relative',
	    color: theme.color.defaultText,
	    '&:first-of-type': {
	      marginTop: 0,
	      paddingTop: 0
	    },
	    '&:hover a.anchor': {
	      textDecoration: 'none'
	    },
	    '& tt, & code': {
	      fontSize: 'inherit'
	    }
	  };
	};
	
	var withMargin = {
	  margin: '16px 0'
	};
	
	var H1 = _theming.styled.h1(_withReset.withReset, headerCommon, function (_ref2) {
	  var theme = _ref2.theme;
	  return {
	    fontSize: "".concat(theme.typography.size.l1, "px"),
	    fontWeight: theme.typography.weight.black
	  };
	});
	
	exports.H1 = H1;
	
	var H2 = _theming.styled.h2(_withReset.withReset, headerCommon, function (_ref3) {
	  var theme = _ref3.theme;
	  return {
	    fontSize: "".concat(theme.typography.size.m2, "px"),
	    paddingBottom: '4px',
	    borderBottom: "1px solid ".concat(theme.appBorderColor)
	  };
	});
	
	exports.H2 = H2;
	
	var H3 = _theming.styled.h3(_withReset.withReset, headerCommon, function (_ref4) {
	  var theme = _ref4.theme;
	  return {
	    fontSize: "".concat(theme.typography.size.m1, "px")
	  };
	});
	
	exports.H3 = H3;
	
	var H4 = _theming.styled.h4(_withReset.withReset, headerCommon, function (_ref5) {
	  var theme = _ref5.theme;
	  return {
	    fontSize: "".concat(theme.typography.size.s3, "px")
	  };
	});
	
	exports.H4 = H4;
	
	var H5 = _theming.styled.h5(_withReset.withReset, headerCommon, function (_ref6) {
	  var theme = _ref6.theme;
	  return {
	    fontSize: "".concat(theme.typography.size.s2, "px")
	  };
	});
	
	exports.H5 = H5;
	
	var H6 = _theming.styled.h6(_withReset.withReset, headerCommon, function (_ref7) {
	  var theme = _ref7.theme;
	  return {
	    fontSize: "".concat(theme.typography.size.s2, "px"),
	    color: theme.color.dark
	  };
	});
	
	exports.H6 = H6;
	
	var Pre = _theming.styled.pre(_withReset.withReset, withMargin, function (_ref8) {
	  var theme = _ref8.theme;
	  return {
	    // reset
	    fontFamily: theme.typography.fonts.mono,
	    WebkitFontSmoothing: 'antialiased',
	    MozOsxFontSmoothing: 'grayscale',
	    lineHeight: '18px',
	    padding: '11px 1rem',
	    whiteSpace: 'pre-wrap',
	    color: 'inherit',
	    borderRadius: 3,
	    margin: '1rem 0',
	    '&:not(.hljs)': {
	      background: 'transparent',
	      border: 'none',
	      borderRadius: 0,
	      padding: 0,
	      margin: 0
	    },
	    '& pre, &.hljs': {
	      padding: 15,
	      margin: 0,
	      whiteSpace: 'pre-wrap',
	      color: 'inherit',
	      fontSize: '13px',
	      lineHeight: '19px',
	      code: {
	        color: 'inherit',
	        fontSize: 'inherit'
	      }
	    },
	    '& code': {
	      whiteSpace: 'pre'
	    },
	    '& code, & tt': {
	      border: 'none'
	    }
	  };
	});
	
	exports.Pre = Pre;
	
	var A = _theming.styled.a(_withReset.withReset, function (_ref9) {
	  var theme = _ref9.theme;
	  return {
	    fontSize: theme.typography.size.s2,
	    lineHeight: '24px',
	    color: "".concat(theme.color.secondary),
	    textDecoration: 'none',
	    '&.absent': {
	      color: '#cc0000'
	    },
	    '&.anchor': {
	      display: 'block',
	      paddingLeft: '30px',
	      marginLeft: '-30px',
	      cursor: 'pointer',
	      position: 'absolute',
	      top: '0',
	      left: '0',
	      bottom: '0'
	    }
	  };
	});
	
	exports.A = A;
	
	var HR = _theming.styled.hr(function (_ref10) {
	  var theme = _ref10.theme;
	  return {
	    border: '0 none',
	    color: theme.appBorderColor,
	    height: '4px',
	    padding: '0'
	  };
	});
	
	exports.HR = HR;
	
	var DL = _theming.styled.dl(_withReset.withReset, Object.assign({}, withMargin, {
	  padding: 0,
	  '& dt': {
	    fontSize: '14px',
	    fontWeight: 'bold',
	    fontStyle: 'italic',
	    padding: 0,
	    margin: '16px 0 4px'
	  },
	  '& dt:first-of-type': {
	    padding: 0
	  },
	  '& dt > :first-of-type': {
	    marginTop: 0
	  },
	  '& dt > :last-child': {
	    marginBottom: 0
	  },
	  '& dd': {
	    margin: '0 0 16px',
	    padding: '0 15px'
	  },
	  '& dd > :first-of-type': {
	    marginTop: 0
	  },
	  '& dd > :last-child': {
	    marginBottom: 0
	  }
	}));
	
	exports.DL = DL;
	
	var Blockquote = _theming.styled.blockquote(_withReset.withReset, withMargin, function (_ref11) {
	  var theme = _ref11.theme;
	  return {
	    borderLeft: "4px solid ".concat(theme.color.medium),
	    padding: '0 15px',
	    color: theme.color.dark,
	    '& > :first-of-type': {
	      marginTop: '0'
	    },
	    '& > :last-child': {
	      marginBottom: 0
	    }
	  };
	});
	
	exports.Blockquote = Blockquote;
	
	var Table = _theming.styled.table(_withReset.withReset, withMargin, function (_ref12) {
	  var theme = _ref12.theme;
	  return {
	    fontSize: theme.typography.size.s2,
	    lineHeight: '24px',
	    padding: 0,
	    borderCollapse: 'collapse',
	    '& tr': {
	      borderTop: "1px solid ".concat(theme.appBorderColor),
	      backgroundColor: 'white',
	      margin: '0',
	      padding: '0'
	    },
	    '& tr:nth-of-type(2n)': {
	      backgroundColor: "".concat(theme.color.lighter)
	    },
	    '& tr th': {
	      fontWeight: 'bold',
	      border: "1px solid ".concat(theme.appBorderColor),
	      textAlign: 'left',
	      margin: '0',
	      padding: '6px 13px'
	    },
	    '& tr td': {
	      border: "1px solid ".concat(theme.appBorderColor),
	      textAlign: 'left',
	      margin: '0',
	      padding: '6px 13px'
	    },
	    '& tr th :first-of-type, & tr td :first-of-type': {
	      marginTop: '0'
	    },
	    '& tr th :last-child, & tr td :last-child': {
	      marginBottom: '0'
	    }
	  };
	});
	
	exports.Table = Table;
	
	var Img = _theming.styled.img({
	  maxWidth: '100%'
	});
	
	exports.Img = Img;
	
	var Div = _theming.styled.div(_withReset.withReset);
	
	exports.Div = Div;
	
	var Span = _theming.styled.span(_withReset.withReset, function (_ref13) {
	  var theme = _ref13.theme;
	  return {
	    '&.frame': {
	      display: 'block',
	      overflow: 'hidden'
	    },
	    '&.frame > span': {
	      border: "1px solid ".concat(theme.color.medium),
	      display: 'block',
	      "float": 'left',
	      overflow: 'hidden',
	      margin: '13px 0 0',
	      padding: '7px',
	      width: 'auto'
	    },
	    '&.frame span img': {
	      display: 'block',
	      "float": 'left'
	    },
	    '&.frame span span': {
	      clear: 'both',
	      color: theme.color.darkest,
	      display: 'block',
	      padding: '5px 0 0'
	    },
	    '&.align-center': {
	      display: 'block',
	      overflow: 'hidden',
	      clear: 'both'
	    },
	    '&.align-center > span': {
	      display: 'block',
	      overflow: 'hidden',
	      margin: '13px auto 0',
	      textAlign: 'center'
	    },
	    '&.align-center span img': {
	      margin: '0 auto',
	      textAlign: 'center'
	    },
	    '&.align-right': {
	      display: 'block',
	      overflow: 'hidden',
	      clear: 'both'
	    },
	    '&.align-right > span': {
	      display: 'block',
	      overflow: 'hidden',
	      margin: '13px 0 0',
	      textAlign: 'right'
	    },
	    '&.align-right span img': {
	      margin: '0',
	      textAlign: 'right'
	    },
	    '&.float-left': {
	      display: 'block',
	      marginRight: '13px',
	      overflow: 'hidden',
	      "float": 'left'
	    },
	    '&.float-left span': {
	      margin: '13px 0 0'
	    },
	    '&.float-right': {
	      display: 'block',
	      marginLeft: '13px',
	      overflow: 'hidden',
	      "float": 'right'
	    },
	    '&.float-right > span': {
	      display: 'block',
	      overflow: 'hidden',
	      margin: '13px auto 0',
	      textAlign: 'right'
	    }
	  };
	});
	
	exports.Span = Span;
	var listCommon = {
	  paddingLeft: '30px',
	  '& :first-of-type': {
	    marginTop: 0
	  },
	  '& :last-child': {
	    marginBottom: 0
	  }
	};
	
	var LI = _theming.styled.li(_withReset.withReset, function (_ref14) {
	  var theme = _ref14.theme;
	  return {
	    fontSize: theme.typography.size.s2,
	    color: theme.color.defaultText,
	    lineHeight: '24px',
	    '& + li': {
	      marginTop: '.25em'
	    },
	    '& ul, & ol': {
	      marginTop: '.25em',
	      marginBottom: 0
	    }
	  };
	});
	
	exports.LI = LI;
	
	var UL = _theming.styled.ul(_withReset.withReset, withMargin, listCommon, {});
	
	exports.UL = UL;
	
	var OL = _theming.styled.ol(_withReset.withReset, withMargin, listCommon);
	
	exports.OL = OL;
	
	var codeCommon = function codeCommon(_ref15) {
	  var theme = _ref15.theme;
	  return {
	    margin: '0 2px',
	    padding: '0 5px',
	    whiteSpace: 'nowrap',
	    border: "1px solid ".concat(theme.color.mediumlight),
	    backgroundColor: theme.color.lighter,
	    borderRadius: '3px',
	    fontSize: theme.typography.size.s2 - 1,
	    color: theme.base === 'dark' && theme.color.darkest
	  };
	};
	
	var P = _theming.styled.p(_withReset.withReset, withMargin, function (_ref16) {
	  var theme = _ref16.theme;
	  return {
	    fontSize: theme.typography.size.s2,
	    lineHeight: '24px',
	    color: theme.color.defaultText,
	    '& code': codeCommon({
	      theme: theme
	    })
	  };
	});
	
	exports.P = P;
	
	var Code = _theming.styled.code(function (_ref17) {
	  var theme = _ref17.theme;
	  return {
	    // from reset
	    fontFamily: theme.typography.fonts.mono,
	    WebkitFontSmoothing: 'antialiased',
	    MozOsxFontSmoothing: 'grayscale',
	    display: 'inline-block',
	    paddingLeft: 2,
	    paddingRight: 2,
	    verticalAlign: 'baseline',
	    color: 'inherit'
	  };
	}, codeCommon);
	
	exports.Code = Code;
	
	var TT = _theming.styled.title(codeCommon);
	/**
	 * This is a "local" reset to style subtrees with Storybook styles
	 *
	 * We can't style individual elements (e.g. h1, h2, etc.) in here
	 * because the CSS specificity is too high, so those styles can too
	 * easily override child elements that are not expecting it.
	 */
	
	
	exports.TT = TT;
	
	var ResetWrapper = _theming.styled.div(_withReset.withReset);
	
	exports.ResetWrapper = ResetWrapper;

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.memoizerific = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	module.exports = function(forceSimilar) {
		if (typeof Map !== 'function' || forceSimilar) {
			var Similar = _dereq_('./similar');
			return new Similar();
		}
		else {
			return new Map();
		}
	}
	
	},{"./similar":2}],2:[function(_dereq_,module,exports){
	function Similar() {
		this.list = [];
		this.lastItem = undefined;
		this.size = 0;
	
		return this;
	}
	
	Similar.prototype.get = function(key) {
		var index;
	
		if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
			return this.lastItem.val;
		}
	
		index = this.indexOf(key);
		if (index >= 0) {
			this.lastItem = this.list[index];
			return this.list[index].val;
		}
	
		return undefined;
	};
	
	Similar.prototype.set = function(key, val) {
		var index;
	
		if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
			this.lastItem.val = val;
			return this;
		}
	
		index = this.indexOf(key);
		if (index >= 0) {
			this.lastItem = this.list[index];
			this.list[index].val = val;
			return this;
		}
	
		this.lastItem = { key: key, val: val };
		this.list.push(this.lastItem);
		this.size++;
	
		return this;
	};
	
	Similar.prototype.delete = function(key) {
		var index;
	
		if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
			this.lastItem = undefined;
		}
	
		index = this.indexOf(key);
		if (index >= 0) {
			this.size--;
			return this.list.splice(index, 1)[0];
		}
	
		return undefined;
	};
	
	
	// important that has() doesn't use get() in case an existing key has a falsy value, in which case has() would return false
	Similar.prototype.has = function(key) {
		var index;
	
		if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
			return true;
		}
	
		index = this.indexOf(key);
		if (index >= 0) {
			this.lastItem = this.list[index];
			return true;
		}
	
		return false;
	};
	
	Similar.prototype.forEach = function(callback, thisArg) {
		var i;
		for (i = 0; i < this.size; i++) {
			callback.call(thisArg || this, this.list[i].val, this.list[i].key, this);
		}
	};
	
	Similar.prototype.indexOf = function(key) {
		var i;
		for (i = 0; i < this.size; i++) {
			if (this.isEqual(this.list[i].key, key)) {
				return i;
			}
		}
		return -1;
	};
	
	// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
	Similar.prototype.isEqual = function(val1, val2) {
		return val1 === val2 || (val1 !== val1 && val2 !== val2);
	};
	
	module.exports = Similar;
	},{}],3:[function(_dereq_,module,exports){
	var MapOrSimilar = _dereq_('map-or-similar');
	
	module.exports = function (limit) {
		var cache = new MapOrSimilar(undefined === 'true'),
			lru = [];
	
		return function (fn) {
			var memoizerific = function () {
				var currentCache = cache,
					newMap,
					fnResult,
					argsLengthMinusOne = arguments.length - 1,
					lruPath = Array(argsLengthMinusOne + 1),
					isMemoized = true,
					i;
	
				if ((memoizerific.numArgs || memoizerific.numArgs === 0) && memoizerific.numArgs !== argsLengthMinusOne + 1) {
					throw new Error('Memoizerific functions should always be called with the same number of arguments');
				}
	
				// loop through each argument to traverse the map tree
				for (i = 0; i < argsLengthMinusOne; i++) {
					lruPath[i] = {
						cacheItem: currentCache,
						arg: arguments[i]
					};
	
					// climb through the hierarchical map tree until the second-last argument has been found, or an argument is missing.
					// if all arguments up to the second-last have been found, this will potentially be a cache hit (determined later)
					if (currentCache.has(arguments[i])) {
						currentCache = currentCache.get(arguments[i]);
						continue;
					}
	
					isMemoized = false;
	
					// make maps until last value
					newMap = new MapOrSimilar(undefined === 'true');
					currentCache.set(arguments[i], newMap);
					currentCache = newMap;
				}
	
				// we are at the last arg, check if it is really memoized
				if (isMemoized) {
					if (currentCache.has(arguments[argsLengthMinusOne])) {
						fnResult = currentCache.get(arguments[argsLengthMinusOne]);
					}
					else {
						isMemoized = false;
					}
				}
	
				if (!isMemoized) {
					fnResult = fn.apply(null, arguments);
					currentCache.set(arguments[argsLengthMinusOne], fnResult);
				}
	
				if (limit > 0) {
					lruPath[argsLengthMinusOne] = {
						cacheItem: currentCache,
						arg: arguments[argsLengthMinusOne]
					};
	
					if (isMemoized) {
						moveToMostRecentLru(lru, lruPath);
					}
					else {
						lru.push(lruPath);
					}
	
					if (lru.length > limit) {
						removeCachedResult(lru.shift());
					}
				}
	
				memoizerific.wasMemoized = isMemoized;
				memoizerific.numArgs = argsLengthMinusOne + 1;
	
				return fnResult;
			};
	
			memoizerific.limit = limit;
			memoizerific.wasMemoized = false;
			memoizerific.cache = cache;
			memoizerific.lru = lru;
	
			return memoizerific;
		};
	};
	
	// move current args to most recent position
	function moveToMostRecentLru(lru, lruPath) {
		var lruLen = lru.length,
			lruPathLen = lruPath.length,
			isMatch,
			i, ii;
	
		for (i = 0; i < lruLen; i++) {
			isMatch = true;
			for (ii = 0; ii < lruPathLen; ii++) {
				if (!isEqual(lru[i][ii].arg, lruPath[ii].arg)) {
					isMatch = false;
					break;
				}
			}
			if (isMatch) {
				break;
			}
		}
	
		lru.push(lru.splice(i, 1)[0]);
	}
	
	// remove least recently used cache item and all dead branches
	function removeCachedResult(removedLru) {
		var removedLruLen = removedLru.length,
			currentLru = removedLru[removedLruLen - 1],
			tmp,
			i;
	
		currentLru.cacheItem.delete(currentLru.arg);
	
		// walk down the tree removing dead branches (size 0) along the way
		for (i = removedLruLen - 2; i >= 0; i--) {
			currentLru = removedLru[i];
			tmp = currentLru.cacheItem.get(currentLru.arg);
	
			if (!tmp || !tmp.size) {
				currentLru.cacheItem.delete(currentLru.arg);
			} else {
				break;
			}
		}
	}
	
	// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
	function isEqual(val1, val2) {
		return val1 === val2 || (val1 !== val1 && val2 !== val2);
	}
	},{"map-or-similar":1}]},{},[3])(3)
	});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stripUnit;
	var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
	/**
	 * Returns a given CSS value minus its unit (or the original value if an invalid string is passed). Optionally returns an array containing the stripped value and the original unit of measure.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   '--dimension': stripUnit('100px'),
	 *   '--unit': stripUnit('100px')[1],
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   --dimension: ${stripUnit('100px')};
	 *   --unit: ${stripUnit('100px')[1]};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   '--dimension': 100,
	 *   '--unit': 'px',
	 * }
	 */
	
	function stripUnit(value, unitReturn) {
	  if (typeof value !== 'string') return unitReturn ? [value, undefined] : value;
	  var matchedValue = value.match(cssRegex);
	
	  if (unitReturn) {
	    if (matchedValue) return [parseFloat(value), matchedValue[2]];
	    return [value, undefined];
	  }
	
	  if (matchedValue) return parseFloat(value);
	  return value;
	}
	
	module.exports = exports.default;

/***/ }),
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(281)
	var Schema = __webpack_require__(460)
	var DefinedInfo = __webpack_require__(458)
	
	module.exports = create
	
	function create(definition) {
	  var space = definition.space
	  var mustUseProperty = definition.mustUseProperty || []
	  var attributes = definition.attributes || {}
	  var props = definition.properties
	  var transform = definition.transform
	  var property = {}
	  var normal = {}
	  var prop
	  var info
	
	  for (prop in props) {
	    info = new DefinedInfo(
	      prop,
	      transform(attributes, prop),
	      props[prop],
	      space
	    )
	
	    if (mustUseProperty.indexOf(prop) !== -1) {
	      info.mustUseProperty = true
	    }
	
	    property[prop] = info
	
	    normal[normalize(prop)] = prop
	    normal[normalize(info.attribute)] = prop
	  }
	
	  return new Schema(property, normal, space)
	}


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	/** @license React v0.18.0
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
	exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	
	  if (obj != null) {
	    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	        if (desc && (desc.get || desc.set)) {
	          Object.defineProperty(newObj, key, desc);
	        } else {
	          newObj[key] = obj[key];
	        }
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _inheritsLoose = _interopDefault(__webpack_require__(81));
	var React = __webpack_require__(1);
	var createCache = _interopDefault(__webpack_require__(461));
	var utils = __webpack_require__(292);
	var serialize = __webpack_require__(188);
	var sheet = __webpack_require__(290);
	var css = _interopDefault(__webpack_require__(462));
	
	var EmotionCacheContext = React.createContext( createCache() );
	var ThemeContext = React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function ( // $FlowFixMe we know it won't be null
	    cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var type = props[typePropName];
	  var registeredStyles = [];
	  var className = '';
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  registeredStyles.push(cssProp);
	
	  if (props.className !== undefined) {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion = exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	} // $FlowFixMe
	
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || props.css == null) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at jsx.*\n\s+at ([A-Z][A-Za-z]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/^.*\n([A-Z][A-Za-z]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = match[1];
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(489);
	
	__webpack_require__(490);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = void 0;
	var _global = global,
	    console = _global.console;
	/* tslint:disable: no-console */
	
	var logger = {
	  debug: function debug(message) {
	    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    return console.debug.apply(console, [message].concat(rest));
	  },
	  log: function log(message) {
	    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      rest[_key2 - 1] = arguments[_key2];
	    }
	
	    return console.log.apply(console, [message].concat(rest));
	  },
	  info: function info(message) {
	    for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      rest[_key3 - 1] = arguments[_key3];
	    }
	
	    return console.info.apply(console, [message].concat(rest));
	  },
	  warn: function warn(message) {
	    for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      rest[_key4 - 1] = arguments[_key4];
	    }
	
	    return console.warn.apply(console, [message].concat(rest));
	  },
	  error: function error(message) {
	    for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	      rest[_key5 - 1] = arguments[_key5];
	    }
	
	    return console.error.apply(console, [message].concat(rest));
	  }
	};
	exports.logger = logger;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBlockBackgroundStyle = void 0;
	
	var getBlockBackgroundStyle = function getBlockBackgroundStyle(theme) {
	  return {
	    borderRadius: theme.appBorderRadius,
	    background: theme.background.content,
	    boxShadow: theme.base === 'light' ? 'rgba(0, 0, 0, 0.10) 0 1px 3px 0' : 'rgba(0, 0, 0, 0.20) 0 2px 5px 0',
	    border: "1px solid ".concat(theme.appBorderColor)
	  };
	};
	
	exports.getBlockBackgroundStyle = getBlockBackgroundStyle;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withReset = void 0;
	
	var withReset = function withReset(_ref) {
	  var theme = _ref.theme;
	  return {
	    fontFamily: theme.typography.fonts.base,
	    fontSize: theme.typography.size.s3,
	    margin: 0,
	    WebkitFontSmoothing: 'antialiased',
	    MozOsxFontSmoothing: 'grayscale',
	    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	    WebkitOverflowScrolling: 'touch'
	  };
	};
	
	exports.withReset = withReset;

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(589);
	
	__webpack_require__(36);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typography = exports.background = exports.color = void 0;
	var color = {
	  // Official color palette
	  primary: '#FF4785',
	  // coral
	  secondary: '#1EA7FD',
	  // ocean
	  tertiary: '#FAFBFC',
	  ancillary: '#22a699',
	  // for code
	  // Complimentary
	  orange: '#FC521F',
	  gold: '#FFAE00',
	  green: '#66BF3C',
	  seafoam: '#37D5D3',
	  purple: '#6F2CAC',
	  ultraviolet: '#2A0481',
	  // Monochrome
	  lightest: '#FFFFFF',
	  lighter: '#F8F8F8',
	  light: '#F3F3F3',
	  mediumlight: '#EEEEEE',
	  medium: '#DDDDDD',
	  mediumdark: '#999999',
	  dark: '#666666',
	  darker: '#444444',
	  darkest: '#333333',
	  // For borders
	  border: 'rgba(0,0,0,.1)',
	  // Status
	  positive: '#66BF3C',
	  negative: '#FF4400',
	  warning: '#E69D00',
	  critical: '#FFFFFF',
	  defaultText: '#333333',
	  inverseText: '#FFFFFF'
	};
	exports.color = color;
	var background = {
	  app: '#F6F9FC',
	  bar: '#FFFFFF',
	  content: color.lightest,
	  gridCellSize: 10,
	  hoverable: 'rgba(0,0,0,.05)',
	  // hover state for items in a list
	  // Notification, error, and warning backgrounds
	  positive: '#E1FFD4',
	  negative: '#FEDED2',
	  warning: '#FFF5CF',
	  critical: '#FF4400'
	};
	exports.background = background;
	var typography = {
	  fonts: {
	    base: ['"Nunito Sans"', '-apple-system', '".SFNSText-Regular"', '"San Francisco"', 'BlinkMacSystemFont', '"Segoe UI"', '"Helvetica Neue"', 'Helvetica', 'Arial', 'sans-serif'].join(', '),
	    mono: ['"Operator Mono"', '"Fira Code Retina"', '"Fira Code"', '"FiraCode-Retina"', '"Andale Mono"', '"Lucida Console"', 'Consolas', 'Monaco', 'monospace'].join(', ')
	  },
	  weight: {
	    regular: 400,
	    bold: 700,
	    black: 900
	  },
	  size: {
	    s1: 12,
	    s2: 14,
	    s3: 16,
	    m1: 20,
	    m2: 24,
	    m3: 28,
	    l1: 32,
	    l2: 40,
	    l3: 48,
	    code: 90
	  }
	};
	exports.typography = typography;

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.index = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  };
	
	  var isDate = exports.isDate = function isDate(d) {
	    return d instanceof Date;
	  };
	  var isEmpty = exports.isEmpty = function isEmpty(o) {
	    return Object.keys(o).length === 0;
	  };
	  var isObject = exports.isObject = function isObject(o) {
	    return o != null && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
	  };
	  var properObject = exports.properObject = function properObject(o) {
	    return isObject(o) && !o.hasOwnProperty ? _extends({}, o) : o;
	  };
	});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */,
/* 182 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = rgb;
	
	var _reduceHexValue =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(439));
	
	var _numberToHex =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(437));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function rgb(value, green, blue) {
	  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
	    return (0, _reduceHexValue["default"])("#" + (0, _numberToHex["default"])(value) + (0, _numberToHex["default"])(green) + (0, _numberToHex["default"])(blue));
	  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
	    return (0, _reduceHexValue["default"])("#" + (0, _numberToHex["default"])(value.red) + (0, _numberToHex["default"])(value.green) + (0, _numberToHex["default"])(value.blue));
	  }
	
	  throw new _errors["default"](6);
	}
	
	module.exports = exports.default;

/***/ }),
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(463));
	var unitless = _interopDefault(__webpack_require__(291));
	var memoize = _interopDefault(__webpack_require__(289));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          value = value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, char) {
	        return char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles;
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	      }
	    // eslint-disable-next-line no-fallthrough
	
	    default:
	      {
	        if (registered == null) {
	          return interpolation;
	        }
	
	        var cached = registered[interpolation];
	
	        if (false) {
	          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	          shouldWarnAboutInterpolatingClassNameFromCss = false;
	        }
	
	        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	      }
	  }
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	          }
	        } else {
	          string += _key + "{" + handleInterpolation(mergedProps, registered, value, false) + "}";
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ }),
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(49);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	__webpack_require__(66);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionBar = exports.ActionButton = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Container = _theming.styled.div(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    position: 'absolute',
	    bottom: 0,
	    right: 0,
	    maxWidth: '100%',
	    display: 'flex',
	    background: theme.background.content,
	    zIndex: 1
	  };
	});
	
	var ActionButton = _theming.styled.button(function (_ref2) {
	  var theme = _ref2.theme;
	  return {
	    border: '0 none',
	    padding: '4px 10px',
	    cursor: 'pointer',
	    display: 'flex',
	    alignItems: 'center',
	    color: theme.color.defaultText,
	    background: theme.background.content,
	    fontSize: 12,
	    lineHeight: '16px',
	    fontFamily: theme.typography.fonts.base,
	    fontWeight: theme.typography.weight.bold,
	    borderTop: "1px solid ".concat(theme.appBorderColor),
	    borderLeft: "1px solid ".concat(theme.appBorderColor),
	    marginLeft: -1,
	    borderRadius: "4px 0 0 0",
	    '&:not(:last-child)': {
	      borderRight: "1px solid ".concat(theme.appBorderColor)
	    },
	    '& + *': {
	      borderLeft: "1px solid ".concat(theme.appBorderColor),
	      borderRadius: 0
	    },
	    '&:focus': {
	      boxShadow: "".concat(theme.color.secondary, " 0 -3px 0 0 inset"),
	      outline: '0 none'
	    }
	  };
	}, function (_ref3) {
	  var disabled = _ref3.disabled;
	  return disabled && {
	    cursor: 'not-allowed',
	    opacity: 0.5
	  };
	});
	
	exports.ActionButton = ActionButton;
	ActionButton.displayName = 'ActionButton';
	
	var ActionBar = function ActionBar(_ref4) {
	  var actionItems = _ref4.actionItems,
	      props = _objectWithoutProperties(_ref4, ["actionItems"]);
	
	  return _react["default"].createElement(Container, props, actionItems.map(function (_ref5, index) {
	    var title = _ref5.title,
	        onClick = _ref5.onClick,
	        disabled = _ref5.disabled;
	    return (// eslint-disable-next-line react/no-array-index-key
	      _react["default"].createElement(ActionButton, {
	        key: index,
	        onClick: onClick,
	        disabled: disabled
	      }, title)
	    );
	  }));
	};
	
	exports.ActionBar = ActionBar;
	ActionBar.displayName = "ActionBar";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(30);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollArea = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _simplebarReact = _interopRequireDefault(__webpack_require__(1111));
	
	var _ScrollAreaStyles = __webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Scroll = (0, _theming.styled)(function (_ref) {
	  var vertical = _ref.vertical,
	      horizontal = _ref.horizontal,
	      rest = _objectWithoutProperties(_ref, ["vertical", "horizontal"]);
	
	  return _react["default"].createElement(_simplebarReact["default"], rest);
	})(function (_ref2) {
	  var vertical = _ref2.vertical;
	  return !vertical ? {
	    overflowY: 'hidden'
	  } : {
	    overflowY: 'auto',
	    height: '100%'
	  };
	}, function (_ref3) {
	  var horizontal = _ref3.horizontal;
	  return !horizontal ? {
	    overflowX: 'hidden'
	  } : {
	    overflowX: 'auto',
	    width: '100%'
	  };
	});
	
	var _ref5 =
	/*#__PURE__*/
	_react["default"].createElement(_theming.Global, {
	  styles: _ScrollAreaStyles.getScrollAreaStyles
	});
	
	var ScrollArea = function ScrollArea(_ref4) {
	  var children = _ref4.children,
	      vertical = _ref4.vertical,
	      horizontal = _ref4.horizontal,
	      props = _objectWithoutProperties(_ref4, ["children", "vertical", "horizontal"]);
	
	  return _react["default"].createElement(_react.Fragment, null, _ref5, _react["default"].createElement(Scroll, _extends({
	    vertical: vertical,
	    horizontal: horizontal
	  }, props), children));
	};
	
	exports.ScrollArea = ScrollArea;
	ScrollArea.displayName = "ScrollArea";
	ScrollArea.defaultProps = {
	  horizontal: false,
	  vertical: false
	};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(51);
	
	__webpack_require__(68);
	
	__webpack_require__(11);
	
	__webpack_require__(62);
	
	__webpack_require__(48);
	
	__webpack_require__(3);
	
	__webpack_require__(30);
	
	__webpack_require__(7);
	
	__webpack_require__(50);
	
	__webpack_require__(67);
	
	__webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FlexBar = exports.Bar = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _ScrollArea = __webpack_require__(195);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Side = _theming.styled.div({
	  display: 'flex',
	  whiteSpace: 'nowrap',
	  flexBasis: 'auto',
	  flexShrink: 0
	}, function (_ref) {
	  var left = _ref.left;
	  return left ? {
	    '& > *': {
	      marginLeft: 15
	    }
	  } : {};
	}, function (_ref2) {
	  var right = _ref2.right;
	  return right ? {
	    marginLeft: 30,
	    '& > *': {
	      marginRight: 15
	    }
	  } : {};
	});
	
	Side.displayName = 'Side';
	var Bar = (0, _theming.styled)(function (_ref3) {
	  var children = _ref3.children,
	      className = _ref3.className;
	  return _react["default"].createElement(_ScrollArea.ScrollArea, {
	    horizontal: true,
	    className: className
	  }, children);
	})(function (_ref4) {
	  var theme = _ref4.theme;
	  return {
	    color: theme.barTextColor,
	    width: '100%',
	    height: 40,
	    flexShrink: 0
	  };
	}, function (_ref5) {
	  var theme = _ref5.theme,
	      border = _ref5.border;
	  return border ? {
	    boxShadow: "".concat(theme.appBorderColor, "  0 -1px 0 0 inset"),
	    background: theme.barBg
	  } : {};
	});
	exports.Bar = Bar;
	Bar.displayName = 'Bar';
	
	var BarInner = _theming.styled.div(function (_ref6) {
	  var bgColor = _ref6.bgColor;
	  return {
	    display: 'flex',
	    justifyContent: 'space-between',
	    position: 'relative',
	    flexWrap: 'nowrap',
	    flexShrink: 0,
	    height: 40,
	    backgroundColor: bgColor || ''
	  };
	});
	
	var FlexBar = function FlexBar(_ref7) {
	  var children = _ref7.children,
	      backgroundColor = _ref7.backgroundColor,
	      rest = _objectWithoutProperties(_ref7, ["children", "backgroundColor"]);
	
	  var _Children$toArray = _react.Children.toArray(children),
	      _Children$toArray2 = _slicedToArray(_Children$toArray, 2),
	      left = _Children$toArray2[0],
	      right = _Children$toArray2[1];
	
	  return _react["default"].createElement("div", null, _react["default"].createElement(Bar, rest, _react["default"].createElement(BarInner, {
	    bgColor: backgroundColor
	  }, _react["default"].createElement(Side, {
	    left: true
	  }, left), right ? _react["default"].createElement(Side, {
	    right: true
	  }, right) : null)));
	};
	
	exports.FlexBar = FlexBar;
	FlexBar.displayName = "FlexBar";
	FlexBar.displayName = 'FlexBar';

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconButton = exports.TabButton = void 0;
	
	var _theming = __webpack_require__(5);
	
	var TabButton = _theming.styled.button({
	  whiteSpace: 'normal',
	  display: 'inline-flex',
	  overflow: 'hidden',
	  verticalAlign: 'top',
	  justifyContent: 'center',
	  alignItems: 'center',
	  textAlign: 'center',
	  textDecoration: 'none',
	  '&:empty': {
	    display: 'none'
	  }
	}, function (_ref) {
	  var theme = _ref.theme;
	  return {
	    padding: '0 15px',
	    textTransform: 'capitalize',
	    transition: 'color 0.2s linear, border-bottom-color 0.2s linear',
	    height: 40,
	    lineHeight: '12px',
	    cursor: 'pointer',
	    background: 'transparent',
	    border: '0 solid transparent',
	    borderTop: '3px solid transparent',
	    borderBottom: '3px solid transparent',
	    fontWeight: 'bold',
	    fontSize: 13,
	    '&:focus': {
	      outline: '0 none',
	      borderBottomColor: theme.color.secondary
	    }
	  };
	}, function (_ref2) {
	  var active = _ref2.active,
	      textColor = _ref2.textColor,
	      theme = _ref2.theme;
	  return active ? {
	    color: textColor || theme.barSelectedColor,
	    borderBottomColor: theme.barSelectedColor
	  } : {
	    color: textColor || 'inherit',
	    borderBottomColor: 'transparent'
	  };
	});
	
	exports.TabButton = TabButton;
	TabButton.displayName = 'TabButton';
	
	var IconButton = _theming.styled.button(function (_ref3) {
	  var theme = _ref3.theme;
	  return {
	    height: 40,
	    background: 'none',
	    color: 'inherit',
	    padding: 0,
	    cursor: 'pointer',
	    border: '0 solid transparent',
	    borderTop: '3px solid transparent',
	    borderBottom: '3px solid transparent',
	    transition: 'color 0.2s linear, border-bottom-color 0.2s linear',
	    '&:hover, &:focus': {
	      outline: '0 none',
	      color: theme.color.secondary
	    },
	    '& > svg': {
	      width: 15
	    }
	  };
	}, function (_ref4) {
	  var active = _ref4.active,
	      theme = _ref4.theme;
	  return active ? {
	    outline: '0 none',
	    borderBottomColor: theme.color.secondary
	  } : {};
	});
	
	exports.IconButton = IconButton;
	IconButton.displayName = 'IconButton';

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmptyBlock = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _polished = __webpack_require__(27);
	
	var _withReset = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Wrapper = _theming.styled.div(_withReset.withReset, function (_ref) {
	  var theme = _ref.theme;
	  return {
	    backgroundColor: theme.base === 'light' ? 'rgba(0,0,0,.01)' : 'rgba(255,255,255,.01)',
	    borderRadius: theme.appBorderRadius,
	    border: "1px dashed ".concat(theme.appBorderColor),
	    display: 'flex',
	    fontSize: "".concat(theme.typography.size.s2, "px"),
	    alignItems: 'center',
	    justifyContent: 'center',
	    padding: '20px',
	    margin: '25px 0 40px',
	    color: theme.base === 'light' ? (0, _polished.transparentize)(0.4, theme.color.defaultText) : (0, _polished.transparentize)(0.6, theme.color.defaultText)
	  };
	});
	
	var EmptyBlock = function EmptyBlock(props) {
	  return _react["default"].createElement(Wrapper, _extends({}, props, {
	    className: "docblock-emptyblock"
	  }));
	};
	
	exports.EmptyBlock = EmptyBlock;
	EmptyBlock.displayName = "EmptyBlock";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Icons = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _icons = _interopRequireDefault(__webpack_require__(513));
	
	var _svg = _interopRequireDefault(__webpack_require__(514));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Path = _theming.styled.path({
	  fill: 'currentColor'
	});
	
	// TODO: if we can resize the 1024 to 20, we can remove the size attributes
	var Icons = function Icons(_ref) {
	  var icon = _ref.icon,
	      props = _objectWithoutProperties(_ref, ["icon"]);
	
	  return _react["default"].createElement(_svg["default"], _extends({
	    viewBox: "0 0 1024 1024"
	  }, props), _react["default"].createElement(Path, {
	    d: _icons["default"][icon]
	  }));
	};
	
	exports.Icons = Icons;
	Icons.displayName = "Icons";

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(36);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _base = __webpack_require__(156);
	
	var theme = {
	  base: 'light',
	  // Storybook-specific color palette
	  colorPrimary: '#FF4785',
	  // coral
	  colorSecondary: '#1EA7FD',
	  // ocean
	  // UI
	  appBg: _base.background.app,
	  appContentBg: _base.color.lightest,
	  appBorderColor: _base.color.border,
	  appBorderRadius: 4,
	  // Fonts
	  fontBase: _base.typography.fonts.base,
	  fontCode: _base.typography.fonts.mono,
	  // Text colors
	  textColor: _base.color.darkest,
	  textInverseColor: _base.color.lightest,
	  // Toolbar default and active colors
	  barTextColor: _base.color.mediumdark,
	  barSelectedColor: _base.color.secondary,
	  barBg: _base.color.lightest,
	  // Form colors
	  inputBg: _base.color.lightest,
	  inputBorder: _base.color.border,
	  inputTextColor: _base.color.darkest,
	  inputBorderRadius: 4
	};
	var _default = theme;
	exports["default"] = _default;

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slackIcon = __webpack_require__(286);
	
	var _slackIcon2 = _interopRequireDefault(_slackIcon);
	
	var _githubIcon = __webpack_require__(285);
	
	var _githubIcon2 = _interopRequireDefault(_githubIcon);
	
	__webpack_require__(259);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'div',
	    { id: 'footer', className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-md-12' },
	      _react2.default.createElement(
	        'div',
	        { className: 'logos' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12' },
	          _react2.default.createElement(
	            'center',
	            null,
	            'Maintained by the ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://storybook.js.org/community/' },
	              'Storybook Community'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'center',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://now-examples-slackin-nqnzoygycp.now.sh/',
	                target: '_blank',
	                rel: 'noreferrer noopener'
	              },
	              _react2.default.createElement('img', { src: _slackIcon2.default, alt: 'Storybook Slack', style: { padding: '7px' } })
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://github.com/storybookjs/storybook',
	                target: '_blank',
	                rel: 'noreferrer noopener'
	              },
	              _react2.default.createElement('img', { src: _githubIcon2.default, alt: 'Storybook GitHub', style: { padding: '7px' } })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _html = __webpack_require__(646);
	
	var _html2 = _interopRequireDefault(_html);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _html2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9odG1sL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vaHRtbCc7XG4iXX0=

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _splitStringTransformer = __webpack_require__(671);
	
	var _splitStringTransformer2 = _interopRequireDefault(_splitStringTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _splitStringTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zcGxpdFN0cmluZ1RyYW5zZm9ybWVyL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vc3BsaXRTdHJpbmdUcmFuc2Zvcm1lcic7XG4iXX0=

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(980);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 265 */,
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = getLuminance;
	
	var _parseToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Returns a number (float) representing the luminance of a color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
	 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
	 *                             'rgba(58, 133, 255, 1)' :
	 *                             'rgba(255, 57, 149, 1)',
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
	 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
	 *                             'rgba(58, 133, 255, 1)' :
	 *                             'rgba(255, 57, 149, 1)'};
	 *
	 * // CSS in JS Output
	 *
	 * div {
	 *   background: "#CCCD64";
	 *   background: "rgba(58, 133, 255, 1)";
	 * }
	 */
	function getLuminance(color) {
	  if (color === 'transparent') return 0;
	  var rgbColor = (0, _parseToRgb["default"])(color);
	
	  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
	    var channel = rgbColor[key] / 255;
	    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
	  }),
	      r = _Object$keys$map[0],
	      g = _Object$keys$map[1],
	      b = _Object$keys$map[2];
	
	  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
	}
	
	module.exports = exports.default;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = hsl;
	
	var _hslToHex =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(436));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function hsl(value, saturation, lightness) {
	  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
	    return (0, _hslToHex["default"])(value, saturation, lightness);
	  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
	    return (0, _hslToHex["default"])(value.hue, value.saturation, value.lightness);
	  }
	
	  throw new _errors["default"](1);
	}
	
	module.exports = exports.default;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = hsla;
	
	var _hslToHex =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(436));
	
	var _hslToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(271));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function hsla(value, saturation, lightness, alpha) {
	  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
	    return alpha >= 1 ? (0, _hslToHex["default"])(value, saturation, lightness) : "rgba(" + (0, _hslToRgb["default"])(value, saturation, lightness) + "," + alpha + ")";
	  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
	    return value.alpha >= 1 ? (0, _hslToHex["default"])(value.hue, value.saturation, value.lightness) : "rgba(" + (0, _hslToRgb["default"])(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
	  }
	
	  throw new _errors["default"](2);
	}
	
	module.exports = exports.default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _rgba =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(97));
	
	var _parseToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: mix(0.5, '#f00', '#00f')
	 *   background: mix(0.25, '#f00', '#00f')
	 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${mix(0.5, '#f00', '#00f')};
	 *   background: ${mix(0.25, '#f00', '#00f')};
	 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#7f007f";
	 *   background: "#3f00bf";
	 *   background: "rgba(63, 0, 191, 0.75)";
	 * }
	 */
	function mix(weight, color, otherColor) {
	  if (color === 'transparent') return otherColor;
	  if (otherColor === 'transparent') return color;
	  var parsedColor1 = (0, _parseToRgb["default"])(color);
	
	  var color1 = _extends({}, parsedColor1, {
	    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
	  });
	
	  var parsedColor2 = (0, _parseToRgb["default"])(otherColor);
	
	  var color2 = _extends({}, parsedColor2, {
	    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
	  }); // The formular is copied from the original Sass implementation:
	  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
	
	
	  var alphaDelta = color1.alpha - color2.alpha;
	  var x = parseFloat(weight) * 2 - 1;
	  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
	  var z = 1 + x * alphaDelta;
	  var weight1 = (y / z + 1) / 2.0;
	  var weight2 = 1 - weight1;
	  var mixedColor = {
	    red: Math.floor(color1.red * weight1 + color2.red * weight2),
	    green: Math.floor(color1.green * weight1 + color2.green * weight2),
	    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
	    alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
	  };
	  return (0, _rgba["default"])(mixedColor);
	} // prettier-ignore
	
	
	var curriedMix =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string, string> */
	)(mix);
	var _default = curriedMix;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	// @private
	function capitalizeString(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var _default = capitalizeString;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function colorToInt(color) {
	  return Math.round(color * 255);
	}
	
	function convertToInt(red, green, blue) {
	  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
	}
	
	function hslToRgb(hue, saturation, lightness, convert) {
	  if (convert === void 0) {
	    convert = convertToInt;
	  }
	
	  if (saturation === 0) {
	    // achromatic
	    return convert(lightness, lightness, lightness);
	  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
	
	
	  var huePrime = (hue % 360 + 360) % 360 / 60;
	  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
	  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
	  var red = 0;
	  var green = 0;
	  var blue = 0;
	
	  if (huePrime >= 0 && huePrime < 1) {
	    red = chroma;
	    green = secondComponent;
	  } else if (huePrime >= 1 && huePrime < 2) {
	    red = secondComponent;
	    green = chroma;
	  } else if (huePrime >= 2 && huePrime < 3) {
	    green = chroma;
	    blue = secondComponent;
	  } else if (huePrime >= 3 && huePrime < 4) {
	    green = secondComponent;
	    blue = chroma;
	  } else if (huePrime >= 4 && huePrime < 5) {
	    red = secondComponent;
	    blue = chroma;
	  } else if (huePrime >= 5 && huePrime < 6) {
	    red = chroma;
	    blue = secondComponent;
	  }
	
	  var lightnessModification = lightness - chroma / 2;
	  var finalRed = red + lightnessModification;
	  var finalGreen = green + lightnessModification;
	  var finalBlue = blue + lightnessModification;
	  return convert(finalRed, finalGreen, finalBlue);
	}
	
	var _default = hslToRgb;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 273 */
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(279);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(273);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(275);
	
	var _HelmetConstants = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(183);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(136);
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerContext = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(72));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(135));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(81));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(187));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(749));
	
	var ManagerContext = (0, _createReactContext.default)({
	  setReferenceNode: undefined,
	  referenceNode: undefined
	});
	exports.ManagerContext = ManagerContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    _this = _React$Component.call(this) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setReferenceNode", function (referenceNode) {
	      if (!referenceNode || _this.state.context.referenceNode === referenceNode) {
	        return;
	      }
	
	      _this.setState(function (_ref) {
	        var context = _ref.context;
	        return {
	          context: (0, _extends2.default)({}, context, {
	            referenceNode: referenceNode
	          })
	        };
	      });
	    });
	    _this.state = {
	      context: {
	        setReferenceNode: _this.setReferenceNode,
	        referenceNode: undefined
	      }
	    };
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.render = function render() {
	    return React.createElement(ManagerContext.Provider, {
	      value: this.state.context
	    }, this.props.children);
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(96));
	var shallowEqual = _interopDefault(__webpack_require__(80));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

	'use strict'
	
	var powers = 0
	
	exports.boolean = increment()
	exports.booleanish = increment()
	exports.overloadedBoolean = increment()
	exports.number = increment()
	exports.spaceSeparated = increment()
	exports.commaSeparated = increment()
	exports.commaOrSpaceSeparated = increment()
	
	function increment() {
	  return Math.pow(2, ++powers)
	}


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = normalize
	
	function normalize(value) {
	  return value.toLowerCase()
	}


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(133);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(289));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var index = memoize(function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	
	exports.default = index;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(63);
	
	__webpack_require__(9);
	
	__webpack_require__(64);
	
	__webpack_require__(3);
	
	__webpack_require__(65);
	
	__webpack_require__(30);
	
	__webpack_require__(7);
	
	__webpack_require__(66);
	
	__webpack_require__(554);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _polished = __webpack_require__(27);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _templateObject11() {
	  var data = _taggedTemplateLiteral(["\n          box-shadow: ", " 0 0 0 1px inset;\n          color: ", ";\n\n          &:hover {\n            box-shadow: ", " 0 0 0 1px inset;\n            background: transparent;\n          }\n\n          &:active {\n            background: ", ";\n            box-shadow: ", " 0 0 0 1px inset;\n            color: ", ";\n          }\n          &:focus {\n            box-shadow: ", " 0 0 0 1px inset,\n              ", " 0 1px 9px 2px;\n          }\n          &:focus:hover {\n            box-shadow: ", " 0 0 0 1px inset,\n              ", " 0 8px 18px 0px;\n          }\n        "]);
	
	  _templateObject11 = function _templateObject11() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject10() {
	  var data = _taggedTemplateLiteral(["\n          box-shadow: ", " 0 0 0 1px inset;\n          color: ", ";\n\n          svg path {\n            fill: ", ";\n          }\n\n          &:hover {\n            box-shadow: ", " 0 0 0 1px inset;\n            background: transparent;\n          }\n\n          &:active {\n            background: ", ";\n            box-shadow: ", " 0 0 0 1px inset;\n            color: ", ";\n          }\n          &:focus {\n            box-shadow: ", " 0 0 0 1px inset,\n              ", " 0 1px 9px 2px;\n          }\n          &:focus:hover {\n            box-shadow: ", " 0 0 0 1px inset,\n              ", " 0 8px 18px 0px;\n          }\n        "]);
	
	  _templateObject10 = function _templateObject10() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject9() {
	  var data = _taggedTemplateLiteral(["\n      box-shadow: ", " 0 0 0 1px inset;\n      color: ", ";\n      background: transparent;\n\n      &:hover {\n        box-shadow: ", " 0 0 0 1px inset;\n      }\n\n      &:active {\n        box-shadow: ", " 0 0 0 2px inset;\n        color: ", ";\n      }\n\n      ", ";\n\n      ", ";\n    "]);
	
	  _templateObject9 = function _templateObject9() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject8() {
	  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      color: ", ";\n      box-shadow: ", " 0 0 0 1px inset;\n      border-radius: ", "px;\n\n      &:hover {\n        background: ", ";\n        ", "\n      }\n      &:active {\n        background: ", ";\n      }\n      &:focus {\n        box-shadow: ", " 0 0 0 1px inset;\n      }\n    "]);
	
	  _templateObject8 = function _templateObject8() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject7() {
	  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        background: ", ";\n      }\n      &:active {\n        box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 3em inset;\n      }\n      &:focus {\n        box-shadow: ", " 0 1px 9px 2px;\n      }\n      &:focus:hover {\n        box-shadow: ", " 0 8px 18px 0px;\n      }\n    "]);
	
	  _templateObject7 = function _templateObject7() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject6() {
	  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        background: ", ";\n      }\n      &:active {\n        box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 3em inset;\n      }\n      &:focus {\n        box-shadow: ", " 0 1px 9px 2px;\n      }\n      &:focus:hover {\n        box-shadow: ", " 0 8px 18px 0px;\n      }\n    "]);
	
	  _templateObject6 = function _templateObject6() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject5() {
	  var data = _taggedTemplateLiteral(["\n          padding: 12px;\n        "]);
	
	  _templateObject5 = function _templateObject5() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject4() {
	  var data = _taggedTemplateLiteral(["\n          padding: 9px;\n        "]);
	
	  _templateObject4 = function _templateObject4() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject3() {
	  var data = _taggedTemplateLiteral(["\n      svg {\n        display: block;\n        margin: 0;\n      }\n\n      ", "\n\n      ", "\n    "]);
	
	  _templateObject3 = function _templateObject3() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject2() {
	  var data = _taggedTemplateLiteral(["\n      cursor: not-allowed !important;\n      opacity: 0.5;\n      &:hover {\n        transform: none;\n      }\n    "]);
	
	  _templateObject2 = function _templateObject2() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  border: 0;\n  border-radius: 3em;\n  cursor: pointer;\n  display: inline-block;\n  overflow: hidden;\n  padding: ", ";\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  transition: all 150ms ease-out;\n  transform: translate3d(0,0,0);\n  vertical-align: top;\n  white-space: nowrap;\n  user-select: none;\n  opacity: 1;\n  margin: 0;\n  background: transparent;\n\n\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: 1;\n\n\n  svg {\n    display: inline-block;\n    height: ", "px;\n    width: ", "px;\n    vertical-align: top;\n    margin-right: ", "px;\n    margin-top: ", "px;\n    margin-bottom: ", "px;\n\n    /* Necessary for js mouse events to not glitch out when hovering on svgs */\n    pointer-events: none;\n\n    path { fill: currentColor; }\n  }\n\n  ", "\n\n  ", "\n\n  /* Colored button for primary CTAs */\n  ", "\n\n\n  /* Colored button for secondary CTAs */\n  ", "\n\n  /* Button for tertiary CTAs and forms that responds to theme */\n  ", "\n\n  /* Button that's outlined */\n  ", "\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ButtonWrapper = _theming.styled.button(_templateObject(), function (props) {
	  return props.small ? '10px 16px' : '13px 20px';
	}, function (props) {
	  return props.small ? props.theme.typography.size.s1 : props.theme.typography.size.s2 - 1;
	}, function (props) {
	  return props.theme.typography.weight.bold;
	}, function (props) {
	  return props.small ? '14' : '16';
	}, function (props) {
	  return props.small ? '14' : '16';
	}, function (props) {
	  return props.small ? '4' : '6';
	}, function (props) {
	  return props.small ? '-1' : '-2';
	}, function (props) {
	  return props.small ? '-1' : '-2';
	}, function (props) {
	  return props.disabled && (0, _theming.css)(_templateObject2());
	}, function (props) {
	  return props.containsIcon && (0, _theming.css)(_templateObject3(), props.small && (0, _theming.css)(_templateObject4()), !props.small && (0, _theming.css)(_templateObject5()));
	}, function (props) {
	  return props.primary && (0, _theming.css)(_templateObject6(), props.theme.color.primary, props.theme.color.lightest, (0, _polished.darken)(0.05, props.theme.color.primary), (0, _polished.rgba)(props.theme.color.primary, 0.4), (0, _polished.rgba)(props.theme.color.primary, 0.2));
	}, function (props) {
	  return props.secondary && (0, _theming.css)(_templateObject7(), props.theme.color.secondary, props.theme.color.lightest, (0, _polished.darken)(0.05, props.theme.color.secondary), (0, _polished.rgba)(props.theme.color.secondary, 0.4), (0, _polished.rgba)(props.theme.color.secondary, 0.2));
	}, function (props) {
	  return props.tertiary && (0, _theming.css)(_templateObject8(), props.theme.base === 'light' ? (0, _polished.darken)(0.02, props.theme.input.background) : (0, _polished.lighten)(0.02, props.theme.input.background), props.theme.input.color, props.theme.input.border, props.theme.input.borderRadius, props.theme.base === 'light' ? (0, _polished.darken)(0.05, props.theme.input.background) : (0, _polished.lighten)(0.05, props.theme.input.background), props.inForm ? '' : 'box-shadow: rgba(0,0,0,.2) 0 2px 6px 0, rgba(0,0,0,.1) 0 0 0 1px inset', props.theme.base === 'light' ? props.theme.input.background : props.theme.input.background, (0, _polished.rgba)(props.theme.color.secondary, 0.4));
	}, function (props) {
	  return props.outline && (0, _theming.css)(_templateObject9(), (0, _polished.transparentize)(0.8, props.theme.color.defaultText), (0, _polished.transparentize)(0.3, props.theme.color.defaultText), (0, _polished.transparentize)(0.5, props.theme.color.defaultText), (0, _polished.transparentize)(0.5, props.theme.color.defaultText), (0, _polished.transparentize)(0, props.theme.color.defaultText), props.primary && (0, _theming.css)(_templateObject10(), props.theme.color.primary, props.theme.color.primary, props.theme.color.primary, props.theme.color.primary, props.theme.color.primary, props.theme.color.primary, props.theme.color.lightest, props.theme.color.primary, (0, _polished.rgba)(props.theme.color.primary, 0.4), props.theme.color.primary, (0, _polished.rgba)(props.theme.color.primary, 0.2)), props.secondary && (0, _theming.css)(_templateObject11(), props.theme.color.secondary, props.theme.color.secondary, props.theme.color.secondary, props.theme.color.secondary, props.theme.color.secondary, props.theme.color.lightest, props.theme.color.secondary, (0, _polished.rgba)(props.theme.color.secondary, 0.4), props.theme.color.secondary, (0, _polished.rgba)(props.theme.color.secondary, 0.2)));
	});
	
	var ButtonLink = ButtonWrapper.withComponent('a', {
	  target: "ex9hp6v0",
	  label: "ButtonLink"
	});
	var Button = Object.assign((0, _react.forwardRef)(function (_ref, ref) {
	  var isLink = _ref.isLink,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["isLink", "children"]);
	
	  if (isLink) {
	    return _react["default"].createElement(ButtonLink, _extends({}, props, {
	      ref: ref
	    }), children);
	  }
	
	  return _react["default"].createElement(ButtonWrapper, _extends({}, props, {
	    ref: ref
	  }), children);
	}), {
	  defaultProps: {
	    isLink: false
	  }
	});
	exports.Button = Button;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(51);
	
	__webpack_require__(68);
	
	__webpack_require__(112);
	
	__webpack_require__(11);
	
	__webpack_require__(48);
	
	__webpack_require__(9);
	
	__webpack_require__(212);
	
	__webpack_require__(3);
	
	__webpack_require__(213);
	
	__webpack_require__(7);
	
	__webpack_require__(214);
	
	__webpack_require__(50);
	
	__webpack_require__(67);
	
	__webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IFrame = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _global = _interopRequireDefault(__webpack_require__(56));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var IFrame =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(IFrame, _React$Component);
	
	  function IFrame() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, IFrame);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(IFrame)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.iframe = null;
	    return _this;
	  }
	
	  _createClass(IFrame, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var id = this.props.id;
	      this.iframe = _global["default"].document.getElementById(id);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var scale = nextProps.scale; // eslint-disable-next-line react/destructuring-assignment
	
	      if (scale !== this.props.scale) {
	        this.setIframeBodyStyle({
	          width: "".concat(scale * 100, "%"),
	          height: "".concat(scale * 100, "%"),
	          transform: "scale(".concat(1 / scale, ")"),
	          transformOrigin: 'top left'
	        });
	      }
	
	      return false;
	    }
	  }, {
	    key: "setIframeBodyStyle",
	    value: function setIframeBodyStyle(style) {
	      return Object.assign(this.iframe.contentDocument.body.style, style);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          id = _this$props.id,
	          title = _this$props.title,
	          src = _this$props.src,
	          allowFullScreen = _this$props.allowFullScreen,
	          scale = _this$props.scale,
	          rest = _objectWithoutProperties(_this$props, ["id", "title", "src", "allowFullScreen", "scale"]);
	
	      return _react["default"].createElement("iframe", _extends({
	        scrolling: "yes",
	        id: id,
	        title: title,
	        src: src,
	        allowFullScreen: allowFullScreen
	      }, rest));
	    }
	  }]);
	
	  return IFrame;
	}(_react["default"].Component);
	
	exports.IFrame = IFrame;
	IFrame.displayName = "IFrame";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Source = exports.SourceError = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _EmptyBlock = __webpack_require__(198);
	
	var _syntaxhighlighter = __webpack_require__(311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var StyledSyntaxHighlighter = (0, _theming.styled)(_syntaxhighlighter.SyntaxHighlighter)(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    // DocBlocks-specific styling and overrides
	    fontSize: "".concat(theme.typography.size.s2 - 1, "px"),
	    lineHeight: '19px',
	    margin: '25px 0 40px',
	    borderRadius: theme.appBorderRadius,
	    boxShadow: theme.base === 'light' ? 'rgba(0, 0, 0, 0.10) 0 1px 3px 0' : 'rgba(0, 0, 0, 0.20) 0 2px 5px 0',
	    'pre.hljs': {
	      padding: 20,
	      background: 'inherit'
	    }
	  };
	});
	var SourceError;
	exports.SourceError = SourceError;
	
	(function (SourceError) {
	  SourceError["NO_STORY"] = "There\u2019s no story here.";
	  SourceError["SOURCE_UNAVAILABLE"] = "Oh no! The source is not available.";
	})(SourceError || (exports.SourceError = SourceError = {}));
	
	/**
	 * Syntax-highlighted source code for a component (or anything!)
	 */
	var Source = function Source(props) {
	  var _ref2 = props,
	      error = _ref2.error;
	
	  if (error) {
	    return _react["default"].createElement(_EmptyBlock.EmptyBlock, props, error);
	  }
	
	  var _ref3 = props,
	      language = _ref3.language,
	      code = _ref3.code,
	      dark = _ref3.dark,
	      format = _ref3.format,
	      rest = _objectWithoutProperties(_ref3, ["language", "code", "dark", "format"]);
	
	  var syntaxHighlighter = _react["default"].createElement(StyledSyntaxHighlighter, _extends({
	    bordered: true,
	    copyable: true,
	    format: format,
	    language: language,
	    className: "docblock-source"
	  }, rest), code);
	
	  if (typeof dark === 'undefined') {
	    return syntaxHighlighter;
	  }
	
	  var overrideTheme = dark ? _theming.themes.dark : _theming.themes.light;
	  return _react["default"].createElement(_theming.ThemeProvider, {
	    theme: (0, _theming.convert)(overrideTheme)
	  }, syntaxHighlighter);
	};
	
	exports.Source = Source;
	Source.displayName = "Source";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ZoomContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var ZoomContext = _react["default"].createContext({
	  scale: 1
	});
	
	exports.ZoomContext = ZoomContext;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(51);
	
	__webpack_require__(68);
	
	__webpack_require__(11);
	
	__webpack_require__(62);
	
	__webpack_require__(48);
	
	__webpack_require__(63);
	
	__webpack_require__(64);
	
	__webpack_require__(3);
	
	__webpack_require__(65);
	
	__webpack_require__(30);
	
	__webpack_require__(7);
	
	__webpack_require__(50);
	
	__webpack_require__(67);
	
	__webpack_require__(66);
	
	__webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Placeholder = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _templateObject3() {
	  var data = _taggedTemplateLiteral(["\n  padding: 30px;\n  text-align: center;\n  color: ", ";\n  font-size: ", "px;\n"]);
	
	  _templateObject3 = function _templateObject3() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject2() {
	  var data = _taggedTemplateLiteral([""]);
	
	  _templateObject2 = function _templateObject2() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Title = _theming.styled.div(_templateObject(), function (props) {
	  return props.theme.typography.weight.bold;
	});
	
	var Desc = _theming.styled.div(_templateObject2());
	
	var Message = _theming.styled.div(_templateObject3(), function (props) {
	  return props.theme.color.defaultText;
	}, function (props) {
	  return props.theme.typography.size.s2 - 1;
	});
	
	var Placeholder = function Placeholder(_ref) {
	  var children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["children"]);
	
	  var _Children$toArray = _react.Children.toArray(children),
	      _Children$toArray2 = _slicedToArray(_Children$toArray, 2),
	      title = _Children$toArray2[0],
	      desc = _Children$toArray2[1];
	
	  return _react["default"].createElement(Message, props, _react["default"].createElement(Title, null, title), desc && _react["default"].createElement(Desc, null, desc));
	};
	
	exports.Placeholder = Placeholder;
	Placeholder.displayName = "Placeholder";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(51);
	
	__webpack_require__(68);
	
	__webpack_require__(112);
	
	__webpack_require__(11);
	
	__webpack_require__(62);
	
	__webpack_require__(48);
	
	__webpack_require__(154);
	
	__webpack_require__(9);
	
	__webpack_require__(212);
	
	__webpack_require__(3);
	
	__webpack_require__(342);
	
	__webpack_require__(30);
	
	__webpack_require__(213);
	
	__webpack_require__(7);
	
	__webpack_require__(214);
	
	__webpack_require__(50);
	
	__webpack_require__(67);
	
	__webpack_require__(346);
	
	__webpack_require__(69);
	
	__webpack_require__(747);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SyntaxHighlighter = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _global = __webpack_require__(56);
	
	var _memoizerific = _interopRequireDefault(__webpack_require__(128));
	
	var _jsx = _interopRequireDefault(__webpack_require__(1080));
	
	var _bash = _interopRequireDefault(__webpack_require__(1078));
	
	var _css = _interopRequireDefault(__webpack_require__(1079));
	
	var _markup = _interopRequireDefault(__webpack_require__(1081));
	
	var _prismLight = _interopRequireWildcard(__webpack_require__(1082));
	
	var _ActionBar = __webpack_require__(194);
	
	var _ScrollArea = __webpack_require__(195);
	
	var _formatter = __webpack_require__(517);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	(0, _prismLight.registerLanguage)('jsx', _jsx["default"]);
	(0, _prismLight.registerLanguage)('bash', _bash["default"]);
	(0, _prismLight.registerLanguage)('css', _css["default"]);
	(0, _prismLight.registerLanguage)('html', _markup["default"]);
	var themedSyntax = (0, _memoizerific["default"])(2)(function (theme) {
	  return Object.entries(theme.code || {}).reduce(function (acc, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        val = _ref2[1];
	
	    return Object.assign({}, acc, _defineProperty({}, "* .".concat(key), val));
	  }, {});
	});
	
	var Wrapper = _theming.styled.div(function (_ref3) {
	  var theme = _ref3.theme;
	  return {
	    position: 'relative',
	    overflow: 'hidden',
	    color: theme.color.defaultText
	  };
	}, function (_ref4) {
	  var theme = _ref4.theme,
	      bordered = _ref4.bordered;
	  return bordered ? {
	    border: "1px solid ".concat(theme.appBorderColor),
	    borderRadius: theme.borderRadius,
	    background: theme.background.content
	  } : {};
	});
	
	var Scroller = (0, _theming.styled)(function (_ref5) {
	  var children = _ref5.children,
	      className = _ref5.className;
	  return _react["default"].createElement(_ScrollArea.ScrollArea, {
	    horizontal: true,
	    vertical: true,
	    className: className
	  }, children);
	})({
	  position: 'relative'
	}, function (_ref6) {
	  var theme = _ref6.theme;
	  return {
	    '& code': {
	      paddingRight: theme.layoutMargin
	    }
	  };
	}, function (_ref7) {
	  var theme = _ref7.theme;
	  return themedSyntax(theme);
	});
	
	var Pre = _theming.styled.pre(function (_ref8) {
	  var theme = _ref8.theme,
	      padded = _ref8.padded;
	  return {
	    display: 'flex',
	    justifyContent: 'flex-start',
	    margin: 0,
	    padding: padded ? theme.layoutMargin : 0
	  };
	});
	
	var Code = _theming.styled.code({
	  flex: 1,
	  paddingRight: 0,
	  opacity: 1
	});
	
	var SyntaxHighlighter =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(SyntaxHighlighter, _Component);
	
	  function SyntaxHighlighter() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, SyntaxHighlighter);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SyntaxHighlighter)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      copied: false
	    };
	
	    _this.onClick = function (e) {
	      var children = _this.props.children;
	      e.preventDefault();
	
	      var tmp = _global.document.createElement('TEXTAREA');
	
	      var focus = _global.document.activeElement;
	      tmp.value = children;
	
	      _global.document.body.appendChild(tmp);
	
	      tmp.select();
	
	      _global.document.execCommand('copy');
	
	      _global.document.body.removeChild(tmp);
	
	      focus.focus();
	
	      _this.setState({
	        copied: true
	      }, function () {
	        _global.window.setTimeout(function () {
	          return _this.setState({
	            copied: false
	          });
	        }, 1500);
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(SyntaxHighlighter, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          _this$props$language = _this$props.language,
	          language = _this$props$language === void 0 ? 'jsx' : _this$props$language,
	          copyable = _this$props.copyable,
	          bordered = _this$props.bordered,
	          padded = _this$props.padded,
	          format = _this$props.format,
	          className = _this$props.className,
	          rest = _objectWithoutProperties(_this$props, ["children", "language", "copyable", "bordered", "padded", "format", "className"]);
	
	      var copied = this.state.copied;
	      return children ? _react["default"].createElement(Wrapper, {
	        bordered: bordered,
	        padded: padded,
	        className: className
	      }, _react["default"].createElement(Scroller, null, _react["default"].createElement(_prismLight["default"], _extends({
	        padded: padded || bordered,
	        language: language,
	        useInlineStyles: false,
	        PreTag: Pre,
	        CodeTag: Code,
	        lineNumberContainerStyle: {}
	      }, rest), format ? (0, _formatter.formatter)(children.trim()) : children.trim())), copyable ? _react["default"].createElement(_ActionBar.ActionBar, {
	        actionItems: [{
	          title: copied ? 'Copied' : 'Copy',
	          onClick: this.onClick
	        }]
	      }) : null) : null;
	    }
	  }]);
	
	  return SyntaxHighlighter;
	}(_react.Component);
	
	exports.SyntaxHighlighter = SyntaxHighlighter;
	SyntaxHighlighter.displayName = "SyntaxHighlighter";
	SyntaxHighlighter.defaultProps = {
	  language: null,
	  copyable: false,
	  bordered: false,
	  padded: false,
	  format: true,
	  className: null
	};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(63);
	
	__webpack_require__(9);
	
	__webpack_require__(64);
	
	__webpack_require__(3);
	
	__webpack_require__(65);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Link = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _polished = __webpack_require__(27);
	
	var _icon = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _templateObject10() {
	  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);
	
	  _templateObject10 = function _templateObject10() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject9() {
	  var data = _taggedTemplateLiteral(["\n      svg {\n        height: 1em;\n        width: 1em;\n        vertical-align: middle;\n        position: relative;\n        bottom: 0;\n        margin-right: 0;\n      }\n    "]);
	
	  _templateObject9 = function _templateObject9() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject8() {
	  var data = _taggedTemplateLiteral(["\n      > svg:last-of-type {\n        height: 0.7em;\n        width: 0.7em;\n        margin-right: 0;\n        margin-left: 0.25em;\n        bottom: auto;\n        vertical-align: inherit;\n      }\n    "]);
	
	  _templateObject8 = function _templateObject8() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject7() {
	  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n"]);
	
	  _templateObject7 = function _templateObject7() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject6() {
	  var data = _taggedTemplateLiteral(["\n      border: 0;\n      border-radius: 0;\n      background: none;\n      padding: 0;\n      font-size: inherit;\n    "]);
	
	  _templateObject6 = function _templateObject6() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject5() {
	  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      svg path {\n        fill: ", ";\n      }\n\n      &:hover {\n        color: ", ";\n        svg path {\n          fill: ", ";\n        }\n      }\n\n      &:active {\n        color: ", ";\n        svg path {\n          fill: ", ";\n        }\n      }\n    "]);
	
	  _templateObject5 = function _templateObject5() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject4() {
	  var data = _taggedTemplateLiteral(["\n      color: inherit;\n\n      &:hover,\n      &:active {\n        color: inherit;\n        text-decoration: underline;\n      }\n    "]);
	
	  _templateObject4 = function _templateObject4() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject3() {
	  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      svg path {\n        fill: ", ";\n      }\n\n      &:hover {\n        color: ", ";\n        svg path {\n          fill: ", ";\n        }\n      }\n\n      &:active {\n        color: ", ";\n        svg path {\n          fill: ", ";\n        }\n      }\n    "]);
	
	  _templateObject3 = function _templateObject3() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject2() {
	  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      svg path {\n        fill: ", ";\n      }\n\n      &:hover {\n        color: ", ";\n        svg path {\n          fill: ", ";\n        }\n      }\n\n      &:active {\n        color: ", ";\n        svg path {\n          fill: ", ";\n        }\n      }\n    "]);
	
	  _templateObject2 = function _templateObject2() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  transition: all 150ms ease-out;\n  text-decoration: none;\n\n  color: ", ";\n  svg path {\n    fill: ", ";\n  }\n\n  &:hover,\n  &:focus {\n    cursor: pointer;\n    color: ", ";\n    svg path {\n      fill: ", ";\n    }\n  }\n  &:active {\n    color: ", ";\n    svg path {\n      fill: ", ";\n    }\n  }\n\n  svg {\n    display: inline-block;\n    height: 1em;\n    width: 1em;\n    vertical-align: text-top;\n    position: relative;\n    bottom: -0.125em;\n    margin-right: 0.4em;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Cmd/Ctrl/Shift/Alt + Click should trigger default browser behaviour. Same applies to non-left clicks
	var LEFT_BUTTON = 0;
	
	var isPlainLeftClick = function isPlainLeftClick(e) {
	  return e.button === LEFT_BUTTON && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey;
	};
	
	var cancelled = function cancelled(e, cb) {
	  if (isPlainLeftClick(e)) {
	    e.preventDefault();
	    cb(e);
	  }
	};
	
	var linkStyles = function linkStyles(props) {
	  return (0, _theming.css)(_templateObject(), props.theme.color.secondary, props.theme.color.secondary, (0, _polished.darken)(0.07, props.theme.color.secondary), (0, _polished.darken)(0.07, props.theme.color.secondary), (0, _polished.darken)(0.1, props.theme.color.secondary), (0, _polished.darken)(0.1, props.theme.color.secondary), props.secondary && (0, _theming.css)(_templateObject2(), props.theme.color.mediumdark, props.theme.color.mediumdark, props.theme.color.dark, props.theme.color.dark, props.theme.color.darker, props.theme.color.darker), props.tertiary && (0, _theming.css)(_templateObject3(), props.theme.color.dark, props.theme.color.dark, props.theme.color.darkest, props.theme.color.darkest, props.theme.color.mediumdark, props.theme.color.mediumdark), props.nochrome && (0, _theming.css)(_templateObject4()), props.inverse && (0, _theming.css)(_templateObject5(), props.theme.color.lightest, props.theme.color.lightest, props.theme.color.lighter, props.theme.color.lighter, props.theme.color.light, props.theme.color.light), props.isButton && (0, _theming.css)(_templateObject6()));
	};
	
	var LinkInner = _theming.styled.span(_templateObject7(), function (props) {
	  return props.withArrow && (0, _theming.css)(_templateObject8());
	}, function (props) {
	  return props.containsIcon && (0, _theming.css)(_templateObject9());
	});
	
	var A = _theming.styled.a(_templateObject10(), linkStyles);
	
	var _ref2 =
	/*#__PURE__*/
	_react["default"].createElement(_icon.Icons, {
	  icon: "arrowright"
	});
	
	var Link = function Link(_ref) {
	  var cancel = _ref.cancel,
	      children = _ref.children,
	      onClick = _ref.onClick,
	      withArrow = _ref.withArrow,
	      containsIcon = _ref.containsIcon,
	      className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ["cancel", "children", "onClick", "withArrow", "containsIcon", "className"]);
	
	  return _react["default"].createElement(A, _extends({}, rest, {
	    onClick: cancel ? function (e) {
	      return cancelled(e, onClick);
	    } : onClick,
	    className: className
	  }), _react["default"].createElement(LinkInner, {
	    withArrow: withArrow,
	    containsIcon: containsIcon
	  }, children, withArrow && _ref2));
	};
	
	exports.Link = Link;
	Link.displayName = "Link";
	Link.defaultProps = {
	  cancel: true,
	  className: undefined,
	  style: undefined,
	  onClick: function onClick() {},
	  withArrow: false,
	  containsIcon: false
	};

/***/ }),
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(227);
	
	__webpack_require__(587);
	
	__webpack_require__(166);
	
	__webpack_require__(36);
	
	__webpack_require__(226);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convert = void 0;
	
	var _polished = __webpack_require__(27);
	
	var _base = __webpack_require__(156);
	
	var _animation = __webpack_require__(555);
	
	var _syntax = __webpack_require__(559);
	
	var _light = _interopRequireDefault(__webpack_require__(215));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var lightSyntaxColors = {
	  green1: '#008000',
	  red1: '#A31515',
	  red2: '#9a050f',
	  red3: '#800000',
	  red4: '#ff0000',
	  gray1: '#393A34',
	  cyan1: '#36acaa',
	  cyan2: '#2B91AF',
	  blue1: '#0000ff',
	  blue2: '#00009f'
	};
	var darkSyntaxColors = {
	  green1: '#7C7C7C',
	  red1: '#92C379',
	  red2: '#9a050f',
	  red3: '#A8FF60',
	  red4: '#96CBFE',
	  gray1: '#EDEDED',
	  cyan1: '#C6C5FE',
	  cyan2: '#FFFFB6',
	  blue1: '#B474DD',
	  blue2: '#00009f'
	};
	
	var createColors = function createColors(vars) {
	  return {
	    // Changeable colors
	    primary: vars.colorPrimary,
	    secondary: vars.colorSecondary,
	    tertiary: _base.color.tertiary,
	    ancillary: _base.color.ancillary,
	    // Complimentary
	    orange: _base.color.orange,
	    gold: _base.color.gold,
	    green: _base.color.green,
	    seafoam: _base.color.seafoam,
	    purple: _base.color.purple,
	    ultraviolet: _base.color.ultraviolet,
	    // Monochrome
	    lightest: _base.color.lightest,
	    lighter: _base.color.lighter,
	    light: _base.color.light,
	    mediumlight: _base.color.mediumlight,
	    medium: _base.color.medium,
	    mediumdark: _base.color.mediumdark,
	    dark: _base.color.dark,
	    darker: _base.color.darker,
	    darkest: _base.color.darkest,
	    // For borders
	    border: _base.color.border,
	    // Status
	    positive: _base.color.positive,
	    negative: _base.color.negative,
	    warning: _base.color.warning,
	    critical: _base.color.critical,
	    defaultText: vars.textColor || _base.color.darkest,
	    inverseText: vars.textInverseColor || _base.color.lightest
	  };
	};
	
	var convert = function convert() {
	  var inherit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _light["default"];
	
	  var base = inherit.base,
	      colorPrimary = inherit.colorPrimary,
	      colorSecondary = inherit.colorSecondary,
	      appBg = inherit.appBg,
	      appContentBg = inherit.appContentBg,
	      appBorderColor = inherit.appBorderColor,
	      appBorderRadius = inherit.appBorderRadius,
	      fontBase = inherit.fontBase,
	      fontCode = inherit.fontCode,
	      textColor = inherit.textColor,
	      textInverseColor = inherit.textInverseColor,
	      barTextColor = inherit.barTextColor,
	      barSelectedColor = inherit.barSelectedColor,
	      barBg = inherit.barBg,
	      inputBg = inherit.inputBg,
	      inputBorder = inherit.inputBorder,
	      inputTextColor = inherit.inputTextColor,
	      inputBorderRadius = inherit.inputBorderRadius,
	      brandTitle = inherit.brandTitle,
	      brandUrl = inherit.brandUrl,
	      brandImage = inherit.brandImage,
	      gridCellSize = inherit.gridCellSize,
	      rest = _objectWithoutProperties(inherit, ["base", "colorPrimary", "colorSecondary", "appBg", "appContentBg", "appBorderColor", "appBorderRadius", "fontBase", "fontCode", "textColor", "textInverseColor", "barTextColor", "barSelectedColor", "barBg", "inputBg", "inputBorder", "inputTextColor", "inputBorderRadius", "brandTitle", "brandUrl", "brandImage", "gridCellSize"]);
	
	  return Object.assign({}, rest || {}, {
	    base: base,
	    color: createColors(inherit),
	    background: {
	      app: appBg,
	      bar: barBg,
	      content: appContentBg,
	      gridCellSize: gridCellSize || _base.background.gridCellSize,
	      hoverable: base === 'light' ? 'rgba(0,0,0,.05)' : 'rgba(250,250,252,.1)' || _base.background.hoverable,
	      positive: _base.background.positive,
	      negative: _base.background.negative,
	      warning: _base.background.warning,
	      critical: _base.background.critical
	    },
	    typography: {
	      fonts: {
	        base: fontBase,
	        mono: fontCode
	      },
	      weight: _base.typography.weight,
	      size: _base.typography.size
	    },
	    animation: _animation.animation,
	    easing: _animation.easing,
	    input: {
	      border: inputBorder,
	      background: inputBg,
	      color: inputTextColor,
	      borderRadius: inputBorderRadius
	    },
	    // UI
	    layoutMargin: 10,
	    appBorderColor: appBorderColor,
	    appBorderRadius: appBorderRadius,
	    // Toolbar default/active colors
	    barTextColor: barTextColor,
	    barSelectedColor: barSelectedColor || colorSecondary,
	    barBg: barBg,
	    // Brand logo/text
	    brand: {
	      title: brandTitle,
	      url: brandUrl,
	      image: brandImage || (brandTitle ? null : undefined)
	    },
	    code: (0, _syntax.create)({
	      colors: base === 'light' ? lightSyntaxColors : darkSyntaxColors,
	      mono: fontCode
	    }),
	    // Addon actions theme
	    // API example https://github.com/xyc/react-inspector/blob/master/src/styles/themes/chromeLight.js
	    addonActionsTheme: Object.assign({}, base === 'light' ? _syntax.chromeLight : _syntax.chromeDark, {
	      BASE_FONT_FAMILY: fontCode,
	      BASE_FONT_SIZE: _base.typography.size.s2 - 1,
	      BASE_LINE_HEIGHT: '18px',
	      BASE_BACKGROUND_COLOR: 'transparent',
	      BASE_COLOR: textColor,
	      ARROW_COLOR: (0, _polished.opacify)(0.2, appBorderColor),
	      ARROW_MARGIN_RIGHT: 4,
	      ARROW_FONT_SIZE: 8,
	      TREENODE_FONT_FAMILY: fontCode,
	      TREENODE_FONT_SIZE: _base.typography.size.s2 - 1,
	      TREENODE_LINE_HEIGHT: '18px',
	      TREENODE_PADDING_LEFT: 12
	    })
	  });
	};
	
	exports.convert = convert;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(227);
	
	__webpack_require__(375);
	
	__webpack_require__(376);
	
	__webpack_require__(585);
	
	__webpack_require__(225);
	
	__webpack_require__(36);
	
	__webpack_require__(373);
	
	__webpack_require__(374);
	
	__webpack_require__(377);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.darkenColor = exports.lightenColor = exports.mkColor = void 0;
	
	var _polished = __webpack_require__(27);
	
	var _clientLogger = __webpack_require__(138);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var mkColor = function mkColor(color) {
	  return {
	    color: color
	  };
	}; // Check if it is a string. This is for the sake of warning users
	// and the successive guarding logics that use String methods.
	
	
	exports.mkColor = mkColor;
	
	var isColorString = function isColorString(color) {
	  if (typeof color !== 'string') {
	    _clientLogger.logger.warn("Color passed to theme object should be a string. Instead " + "".concat(color, "(").concat(_typeof(color), ") was passed."));
	
	    return false;
	  }
	
	  return true;
	}; // Passing arguments that can't be converted to RGB such as linear-gradient
	// to library polished's functions such as lighten or darken throws the error
	// that crashes the entire storybook. It needs to be guarded when arguments
	// of those functions are from user input.
	
	
	var isValidColorForPolished = function isValidColorForPolished(color) {
	  return !/(gradient|var|calc)/.test(color);
	};
	
	var applyPolished = function applyPolished(type, color) {
	  if (type === 'darken') {
	    return (0, _polished.rgba)("".concat((0, _polished.darken)(1, color)), 0.95);
	  }
	
	  if (type === 'lighten') {
	    return (0, _polished.rgba)("".concat((0, _polished.lighten)(1, color)), 0.95);
	  }
	
	  return color;
	};
	
	var colorFactory = function colorFactory(type) {
	  return function (color) {
	    if (!isColorString(color)) {
	      return color;
	    }
	
	    if (!isValidColorForPolished(color)) {
	      return color;
	    } // Guard anything that is not working with polished.
	
	
	    try {
	      return applyPolished(type, color);
	    } catch (error) {
	      return color;
	    }
	  };
	};
	
	var lightenColor = colorFactory('lighten');
	exports.lightenColor = lightenColor;
	var darkenColor = colorFactory('darken');
	exports.darkenColor = darkenColor;

/***/ }),
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(54);
	
	var _icons = __webpack_require__(386);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Svg = _styledComponents2.default.svg.withConfig({
	  displayName: 'Icon__Svg',
	  componentId: 'sc-5kmh5t-0'
	})(['display:inline-block;vertical-align:middle;']);
	
	var Path = _styledComponents2.default.path.withConfig({
	  displayName: 'Icon__Path',
	  componentId: 'sc-5kmh5t-1'
	})(['fill:', ';'], _styles.color.darkest);
	
	function Icon(_ref) {
	  var icon = _ref.icon,
	      props = _objectWithoutProperties(_ref, ['icon']);
	
	  return _react2.default.createElement(
	    Svg,
	    _extends({ viewBox: '0 0 1024 1024', width: '20px', height: '20px' }, props),
	    _react2.default.createElement(Path, { d: _icons2.default[icon] })
	  );
	}
	
	Icon.propTypes = {
	  icon: _propTypes2.default.string.isRequired
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Link;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(27);
	
	var _styles = __webpack_require__(54);
	
	var _Icon = __webpack_require__(381);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/prop-types */
	
	
	var linkStyles = (0, _styledComponents.css)(['display:inline-block;transition:all 150ms ease-out;text-decoration:none;color:', ';&:hover,&:focus{cursor:pointer;transform:translate3d(0,-1px,0);color:', ';}&:active{transform:translate3d(0,0,0);color:', ';}', ';', ';', ';', ';', ';'], _styles.color.secondary, (0, _polished.darken)(0.07, _styles.color.secondary), (0, _polished.darken)(0.1, _styles.color.secondary), function (props) {
	  return props.secondary && (0, _styledComponents.css)(['color:', ';&:hover{color:', ';}&:active{color:', ';}'], _styles.color.mediumdark, _styles.color.dark, _styles.color.darker);
	}, function (props) {
	  return props.tertiary && (0, _styledComponents.css)(['color:', ';&:hover{color:', ';}&:active{color:', ';}'], _styles.color.dark, _styles.color.darkest, _styles.color.mediumdark);
	}, function (props) {
	  return props.nochrome && (0, _styledComponents.css)(['color:inherit;&:hover,&:active{color:inherit;text-decoration:underline;}']);
	}, function (props) {
	  return props.inverse && (0, _styledComponents.css)(['color:', ';&:hover{color:', ';}&:active{color:', ';}'], _styles.color.lightest, _styles.color.lighter, _styles.color.light);
	}, function (props) {
	  return props.isButton && (0, _styledComponents.css)(['border:0;border-radius:0;background:none;padding:0;font-size:inherit;']);
	});
	
	var LinkInner = _styledComponents2.default.span.withConfig({
	  displayName: 'Link__LinkInner',
	  componentId: 'sc-1he77i0-0'
	})(['', ';', ';'], function (props) {
	  return props.withArrow && (0, _styledComponents.css)(['> svg:last-of-type{height:0.7em;width:0.7em;margin-right:0;margin-left:0.25em;bottom:auto;vertical-align:inherit;}']);
	}, function (props) {
	  return props.containsIcon && (0, _styledComponents.css)(['svg{height:1em;width:1em;vertical-align:middle;position:relative;bottom:0;margin-right:0;}']);
	});
	
	var LinkWrapper = _styledComponents2.default.a.withConfig({
	  displayName: 'Link__LinkWrapper',
	  componentId: 'sc-1he77i0-1'
	})(['', ';'], linkStyles);
	
	var LinkGatsby = _styledComponents2.default.a.withConfig({
	  displayName: 'Link__LinkGatsby',
	  componentId: 'sc-1he77i0-2'
	})(['', ';'], linkStyles);
	var LinkButton = _styledComponents2.default.button.withConfig({
	  displayName: 'Link__LinkButton',
	  componentId: 'sc-1he77i0-3'
	})(['', ';'], linkStyles);
	
	function Link(_ref) {
	  var isGatsby = _ref.isGatsby,
	      isButton = _ref.isButton,
	      withArrow = _ref.withArrow,
	      containsIcon = _ref.containsIcon,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['isGatsby', 'isButton', 'withArrow', 'containsIcon', 'children']);
	
	  var content = _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      LinkInner,
	      { withArrow: withArrow, containsIcon: containsIcon },
	      children,
	      withArrow && _react2.default.createElement(_Icon2.default, { icon: 'arrowright' })
	    )
	  );
	
	  if (isGatsby) {
	    return _react2.default.createElement(
	      LinkGatsby,
	      props,
	      content
	    );
	  }
	  if (isButton) {
	    return _react2.default.createElement(
	      LinkButton,
	      props,
	      content
	    );
	  }
	  return _react2.default.createElement(
	    LinkWrapper,
	    props,
	    content
	  );
	}
	
	Link.propTypes = {
	  isButton: _propTypes2.default.bool,
	  isGatsby: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  withArrow: _propTypes2.default.bool
	};
	
	Link.defaultProps = {
	  isButton: false,
	  isGatsby: false,
	  children: null,
	  withArrow: false
	};
	module.exports = exports['default'];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TooltipLinkList = exports.TooltipNote = exports.TooltipMessage = exports.WithTooltip = exports.Link = exports.Icon = exports.site = exports.icons = exports.animation = exports.global = exports.styles = undefined;
	
	var _Icon = __webpack_require__(381);
	
	Object.defineProperty(exports, 'Icon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  }
	});
	
	var _Link = __webpack_require__(382);
	
	Object.defineProperty(exports, 'Link', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Link).default;
	  }
	});
	
	var _WithTooltip = __webpack_require__(621);
	
	Object.defineProperty(exports, 'WithTooltip', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WithTooltip).default;
	  }
	});
	
	var _TooltipMessage = __webpack_require__(619);
	
	Object.defineProperty(exports, 'TooltipMessage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TooltipMessage).default;
	  }
	});
	
	var _TooltipNote = __webpack_require__(620);
	
	Object.defineProperty(exports, 'TooltipNote', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TooltipNote).default;
	  }
	});
	
	var _TooltipLinkList = __webpack_require__(618);
	
	Object.defineProperty(exports, 'TooltipLinkList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TooltipLinkList).default;
	  }
	});
	
	var _styles = __webpack_require__(54);
	
	var styles = _interopRequireWildcard(_styles);
	
	var _global = __webpack_require__(385);
	
	var global = _interopRequireWildcard(_global);
	
	var _animation = __webpack_require__(384);
	
	var animation = _interopRequireWildcard(_animation);
	
	var _icons = __webpack_require__(386);
	
	var icons = _interopRequireWildcard(_icons);
	
	var _site = __webpack_require__(616);
	
	var site = _interopRequireWildcard(_site);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.styles = styles;
	exports.global = global;
	exports.animation = animation;
	exports.icons = icons;
	exports.site = site;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.inlineGlow = exports.shake = exports.jiggle = exports.float = exports.glow = exports.rotate360 = exports.easing = undefined;
	
	var _styledComponents = __webpack_require__(34);
	
	var _styles = __webpack_require__(54);
	
	// Handy CSS animations for micro-interactions
	var easing = exports.easing = {
	  rubber: 'cubic-bezier(0.175, 0.885, 0.335, 1.05)'
	};
	
	var rotate360 = exports.rotate360 = (0, _styledComponents.keyframes)(['from{transform:rotate(0deg);}to{transform:rotate(360deg);}']);
	
	var glow = exports.glow = (0, _styledComponents.keyframes)(['0%,100%{opacity:1;}50%{opacity:.4;}']);
	
	var float = exports.float = (0, _styledComponents.keyframes)(['0%{transform:translateY(1px);}25%{transform:translateY(0px);}50%{transform:translateY(-3px);}100%{transform:translateY(1px);}']);
	
	var jiggle = exports.jiggle = (0, _styledComponents.keyframes)(['0%,100%{transform:translate3d(0,0,0);}12.5%,62.5%{transform:translate3d(-4px,0,0);}37.5%,87.5%{transform:translate3d(4px,0,0);}']);
	
	var shake = exports.shake = (0, _styledComponents.keyframes)(['0%{transform:rotate(-3deg)}1.68421%{transform:rotate(3deg)}2.10526%{transform:rotate(6deg)}3.78947%{transform:rotate(-6deg)}4.21053%{transform:rotate(-6deg)}5.89474%{transform:rotate(6deg)}6.31579%{transform:rotate(6deg)}8%{transform:rotate(-6deg)}8.42105%{transform:rotate(-6deg)}10.10526%{transform:rotate(6deg)}10.52632%{transform:rotate(6deg)}12.21053%{transform:rotate(-6deg)}12.63158%{transform:rotate(-6deg)}14.31579%{transform:rotate(6deg)}15.78947%{transform:rotate(0deg)}100%{transform:rotate(0deg)}']);
	
	var inlineGlow = exports.inlineGlow = (0, _styledComponents.css)(['animation:', ' 1.5s ease-in-out infinite;background:', ';color:transparent;cursor:progress;'], glow, _styles.color.mediumlight);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GlobalStyle = exports.bodyStyles = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    body {\n      ', '\n\n      margin: 0;\n      overflow-y: auto;\n      overflow-x: hidden;\n    }\n'], ['\n    body {\n      ', '\n\n      margin: 0;\n      overflow-y: auto;\n      overflow-x: hidden;\n    }\n']);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styles = __webpack_require__(54);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var bodyStyles = exports.bodyStyles = (0, _styledComponents.css)(['font-family:', ';font-size:', 'px;color:', ';-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;-webkit-overflow-scrolling:touch;*{box-sizing:border-box;}h1,h2,h3,h4,h5,h6{font-weight:', ';margin:0;padding:0;}button,input,textarea,select{outline:none;font-family:', ';}sub,sup{font-size:0.8em;}sub{bottom:-0.2em;}sup{top:-0.2em;}b,em{font-weight:', ';}hr{border:none;border-top:1px solid ', ';clear:both;margin-bottom:1.25rem;}code,pre{font-family:', ';font-size:', 'px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}code{display:inline-block;padding-left:2px;padding-right:2px;vertical-align:baseline;color:', ';}pre{line-height:18px;padding:11px 1rem;white-space:pre-wrap;background:rgba(0,0,0,0.05);color:', ';border-radius:3px;margin:1rem 0;}&.ReactModal__Body--open{overflow:hidden;&.hide-intercom #intercom-container{display:none;}}.ReactModalPortal > div{opacity:0;}.ReactModalPortal .ReactModal__Overlay{transition:all 200ms ease-in;&--after-open{opacity:1;}&--before-close{opacity:0;}}'], _styles.typography.type.primary, _styles.typography.size.s3, _styles.color.darkest, _styles.typography.weight.regular, _styles.typography.type.primary, _styles.typography.weight.bold, _styles.color.border, _styles.typography.type.code, _styles.typography.size.s2 - 1, _styles.color.secondary, _styles.color.darkest);
	
	var GlobalStyle = exports.GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject, bodyStyles);

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	// Icon paths
	var icons = {
	  mobile: 'M648 64h-272c-66.274 0-120 53.726-120 120v656c0 66.274 53.726 120 120 120h272c66.274 0 120-53.726 120-120v-656c0-66.274-53.726-120-120-120zM376 144h272c22.056 0 40 17.944 40 40v495.968h-352v-495.968c0-22.056 17.946-40 40-40zM648 880h-272c-22.054 0-40-17.944-40-40v-80.032h352v80.032c0 22.056-17.944 40-40 40zM544.034 819.962c0 17.676-14.33 32.002-32.004 32.002-17.67 0-32-14.326-32-32.002 0-17.672 14.33-31.998 32-31.998 17.674-0 32.004 14.326 32.004 31.998z',
	  watch: 'M736.172 108.030c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20 0 11.046 8.956 20 20 20h408.282c11.044 0 20-8.954 20-20zM736.172 50.37c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20zM736.172 973.692c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20zM736.172 916.030c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20 0 11.046 8.956 20 20 20h408.282c11.044 0 20-8.954 20-20zM717.53 228c18.904 0 34.286 15.14 34.286 33.75v500.502c0 18.61-15.38 33.75-34.286 33.75h-411.43c-18.904 0-34.286-15.14-34.286-33.75v-500.502c0-18.61 15.38-33.75 34.286-33.75h411.43zM717.53 148h-411.43c-63.118 0-114.286 50.928-114.286 113.75v500.502c0 62.822 51.166 113.75 114.286 113.75h411.43c63.118 0 114.286-50.926 114.286-113.75v-500.502c-0.002-62.822-51.168-113.75-114.286-113.75v0zM680.036 511.53c0 22.090-17.91 40-40 40h-128.004c-5.384 0-10.508-1.078-15.196-3.006-0.124-0.048-0.254-0.086-0.376-0.132-0.61-0.262-1.188-0.57-1.782-0.86-0.572-0.276-1.16-0.528-1.718-0.828-0.204-0.112-0.39-0.246-0.594-0.364-0.918-0.514-1.832-1.050-2.704-1.64-0.086-0.058-0.164-0.128-0.254-0.188-10.492-7.21-17.382-19.284-17.382-32.98v-151.5c0-22.094 17.91-40 40.004-40 22.088 0 40 17.906 40 40v111.498h88c22.094-0.002 40.002 17.91 40.006 40z',
	  tablet: 'M200.022 927.988h624.018c1.38 0 2.746-0.072 4.090-0.208 20.168-2.050 35.91-19.080 35.91-39.792v-751.916c0-22.092-17.91-40-40-40h-624.018c-22.098 0-40 17.908-40 40v751.916c0 22.094 17.906 40 40 40zM512.002 878.206c-17.674 0-32.004-14.328-32.004-31.998 0-17.678 14.33-32.002 32.004-32.002 17.67 0 32 14.324 32 32.002 0 17.67-14.33 31.998-32 31.998zM240.022 176.078h544.018v591.902h-544.018v-591.902z',
	  browser: 'M920.004 128h-816.008c-1.38 0-2.746 0.070-4.090 0.208-20.168 2.048-35.91 19.080-35.91 39.792v688c0 22.090 17.91 40 40 40h816.008c22.098 0 40-17.91 40-40v-688c-0-22.094-17.906-40-40-40zM368 177.78c17.674 0 32.004 14.328 32.004 31.998 0 17.676-14.33 32.002-32.004 32.002-17.67 0-32-14.326-32-32.002 0-17.67 14.33-31.998 32-31.998zM272 177.78c17.674 0 32.004 14.328 32.004 31.998 0 17.676-14.33 32.002-32.004 32.002-17.67 0-32-14.326-32-32.002 0-17.67 14.33-31.998 32-31.998zM176 177.78c17.674 0 32.004 14.328 32.004 31.998 0 17.676-14.33 32.002-32.004 32.002-17.67 0-32-14.326-32-32.002 0-17.67 14.33-31.998 32-31.998zM880.004 815.996h-736.008v-527.988h736.008v527.988z',
	  sidebar: 'M920.032 127.858h-816c-22.092 0-40 17.908-40 40v688c0 22.092 17.908 40 40 40h316.578c1.13 0.096 2.266 0.172 3.422 0.172s2.292-0.078 3.424-0.172h492.576c22.092 0 40-17.908 40-40v-688c0-22.092-17.908-40-40-40zM144.032 207.858h240v608h-240v-608zM880.032 815.858h-416v-608h416v608zM198.734 288.030c0-17.674 14.328-32 32.002-32h66.396c17.672 0 32 14.326 32 32 0 17.676-14.324 32-32 32h-66.398c-17.674 0-32-14.326-32-32zM198.734 416.030c0-17.674 14.328-32 32.002-32h66.396c17.672 0 32 14.326 32 32 0 17.676-14.324 32-32 32h-66.398c-17.674 0-32-14.326-32-32zM198.734 544.030c0-17.674 14.328-32 32.002-32h66.396c17.672 0 32 14.326 32 32 0 17.676-14.324 32-32 32h-66.398c-17.674 0-32-14.326-32-32z',
	  sidebaralt: 'M64 167.944v688c0 22.092 17.908 40 40 40h816c22.092 0 40-17.908 40-40v-688c0-22.092-17.908-40-40-40h-816c-22.092 0-40 17.908-40 40zM880 815.944h-240v-608h240v608zM144 207.944h416v608h-416v-608zM793.296 320.118h-66.398c-17.676 0-32-14.324-32-32 0-17.674 14.328-32 32-32h66.396c17.674 0 32.002 14.326 32.002 32 0 17.672-14.324 32-32 32zM793.296 448.118h-66.398c-17.676 0-32-14.324-32-32 0-17.674 14.328-32 32-32h66.396c17.674 0 32.002 14.326 32.002 32 0 17.672-14.324 32-32 32zM793.296 576.118h-66.398c-17.676 0-32-14.324-32-32 0-17.674 14.328-32 32-32h66.396c17.674 0 32.002 14.326 32.002 32 0 17.672-14.324 32-32 32z',
	  bottombar: 'M85 121h854c24 0 42 18 42 41v700c0 23-18 41-42 41H608a44 44 0 0 1-7 0H85c-24 0-42-18-42-41V162c0-23 18-41 42-41zm41 535v165h772V656H126zm0-82h772V202H126v372zm185 197h-69c-19 0-34-14-34-32s15-33 34-33h69c19 0 34 15 34 33s-15 32-34 32zm236 0h-70c-18 0-33-14-33-32s15-33 33-33h70c18 0 33 15 33 33s-15 32-33 32zm235 0h-70c-18 0-33-14-33-32s15-33 33-33h70c18 0 33 15 33 33s-15 32-33 32z',
	  useralt: 'M532.716 960c115.572 0 227.634-22.612 333.076-67.208 18.116-7.66 35.888-15.94 53.336-24.774v-18.726c0-116.912-241.728-223.528-306.458-233.828-20.1-3.198-20.556-58.458-20.556-58.458s59.050-58.452 71.922-137.062c34.618 0 56.004-83.57 21.378-112.972 1.448-30.95 44.5-242.972-173.474-242.972-217.976 0-174.916 212.022-173.476 242.972-34.622 29.402-13.244 112.972 21.38 112.972 12.864 78.61 71.916 137.062 71.916 137.062s-0.458 55.262-20.554 58.458c-64.042 10.19-301.326 114.674-306.334 230.124 30.474 17.61 62.084 33.376 94.776 47.204 105.436 44.596 217.498 67.208 333.068 67.208z',
	  user: 'M512.062 65.062c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM776.324 769.132c-55.386-54.52-155.436-95.864-189.492-101.282-14.918-2.376-15.258-43.39-15.258-43.39s43.832-43.39 53.384-101.738c25.698 0 41.568-62.032 15.87-83.856 1.072-22.974 33.038-180.352-128.766-180.352s-129.836 157.376-128.768 180.352c-25.706 21.824-9.83 83.856 15.87 83.856 9.552 58.348 53.382 101.738 53.382 101.738s-0.34 41.020-15.256 43.39c-34.056 5.418-134.104 46.762-189.49 101.282-66.932-69.018-103.738-159.708-103.738-256.070 0-98.296 38.278-190.708 107.786-260.212 69.51-69.506 161.918-107.788 260.214-107.788s190.708 38.278 260.214 107.788c69.506 69.506 107.786 161.916 107.786 260.212-0 96.364-36.808 187.054-103.738 256.070z',
	  useradd: 'M123.302 833.14c-26.284-11.118-51.696-23.792-76.196-37.95 4.028-92.818 194.792-176.82 246.28-185.012 16.158-2.57 16.526-46.994 16.526-46.994s-47.476-46.996-57.818-110.196c-27.836 0-45.024-67.186-17.19-90.824-1.158-24.882-35.776-195.34 139.468-195.34 175.242 0 140.628 170.458 139.464 195.34 27.838 23.638 10.644 90.824-17.188 90.824-10.346 63.2-57.822 110.196-57.822 110.196s0.37 44.424 16.528 46.994c52.042 8.282 246.38 93.996 246.38 187.988v15.054c-14.028 7.102-28.316 13.76-42.88 19.918-84.77 35.852-174.864 54.032-267.78 54.032-92.912 0.002-183.004-18.178-267.772-54.030zM910.064 335h-80.008v-80.010c0.002-22.088-17.906-39.992-39.996-39.992-22.088 0-39.998 17.906-39.998 39.996v80.006h-80.002c-22.094 0-40 17.908-39.998 40-0.002 22.090 17.904 39.996 39.996 39.996h80.004v80.002c0 22.094 17.908 40 40 40 22.090 0 39.996-17.906 39.996-39.996v-80.006l80.010-0.002c22.090 0.002 39.994-17.906 39.994-39.996 0-22.088-17.908-39.998-39.998-39.998z',
	  users: 'M123.302 822.204c-26.284-11.118-51.696-23.792-76.196-37.95 4.028-92.818 194.792-176.82 246.28-185.012 16.158-2.57 16.526-46.998 16.526-46.998s-47.476-46.994-57.818-110.192c-27.836 0-45.024-67.186-17.19-90.822-1.158-24.884-35.776-195.342 139.468-195.342 175.242 0 140.628 170.458 139.464 195.342 27.838 23.636 10.644 90.822-17.188 90.822-10.346 63.2-57.822 110.192-57.822 110.192s0.37 44.426 16.528 46.998c52.042 8.282 246.38 93.996 246.38 187.988v15.054c-14.028 7.102-28.316 13.758-42.88 19.918-84.77 35.852-174.864 54.032-267.78 54.032-92.912 0-183.004-18.18-267.772-54.030zM977.018 652.224c0-64.612-133.592-123.532-169.364-129.222-11.106-1.768-11.36-32.306-11.36-32.306s32.634-32.304 39.744-75.746c19.132 0 30.954-46.188 11.818-62.436 0.798-17.106 24.592-134.276-95.874-134.276-120.462 0-96.666 117.17-95.87 134.276-19.134 16.248-7.32 62.436 11.816 62.436 7.11 43.442 39.742 75.746 39.742 75.746s-0.25 30.54-11.358 32.306c-23.154 3.684-87.282 29.672-129.644 65.068 21.022 10.038 42.072 21.39 61.066 33.186 14.278 8.866 27.392 17.866 39.338 26.986 35.696 27.262 60.956 55.638 75.646 84.934 2.784 0.032 5.562 0.102 8.352 0.102 77.788 0 153.58-12.792 225.944-37.976v-43.078z',
	  profile: 'M396.984 530.228c-12.040-5.090-23.676-10.896-34.898-17.38 1.846-42.512 89.218-80.984 112.798-84.736 7.402-1.178 7.568-21.526 7.568-21.526s-21.742-21.524-26.48-50.47c-12.748 0-20.622-30.77-7.874-41.596-0.532-11.398-16.384-89.468 63.878-89.468s64.408 78.070 63.876 89.468c12.75 10.826 4.876 41.596-7.872 41.596-4.738 28.948-26.482 50.47-26.482 50.47s0.168 20.348 7.568 21.526c23.836 3.792 112.846 43.050 112.846 86.102v6.894c-6.426 3.252-12.968 6.3-19.64 9.122-38.826 16.422-80.090 24.746-122.646 24.746-42.552-0.002-83.816-8.326-122.642-24.748zM800 145h-592.004v736h592.004c8.708 0 15.876-7.086 15.972-15.796v-704.246c-0.018-8.8-7.176-15.958-15.972-15.958zM800 65c52.944 0 95.872 42.858 95.992 95.772l0.012 0.014v705.334h-0.036c-0.602 52.502-43.324 94.88-95.968 94.88h-632.004c-22.090 0-40-17.906-40-40v-816c0-20.338 15.192-37.090 34.836-39.628 1.696-0.218 3.41-0.372 5.164-0.372h632.004zM736.282 792.998c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20zM736.282 704.998c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20zM736.282 616.998c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20z',
	  bookmark: 'M772 1012L511 761l-260 251a49 49 0 0 1-52 10c-18-7-29-24-29-43V132c0-25 21-46 47-46h588c26 0 47 21 47 46v847c0 19-11 36-29 43a49 49 0 0 1-51-10z',
	  bookmarkhollow: 'M772 1012L511 761l-260 251a49 49 0 0 1-52 10c-18-7-29-24-29-43V132c0-25 21-46 47-46h588c26 0 47 21 47 46v847c0 19-11 36-29 43a49 49 0 0 1-51-10zM545 664l213 205V181H265v688l213-205c9-9 21-14 33-14s24 5 34 14z',
	  book: 'M896.054 159.774c-0.122-52.914-43.048-95.774-95.992-95.774h-632.004c-1.754 0-3.468 0.154-5.164 0.372-19.644 2.54-34.836 19.292-34.836 39.628v816c0 22.094 17.91 40 40 40h632.004c52.642 0 95.368-42.378 95.968-94.88h0.036v-705.332l-0.012-0.014zM368.062 144h80v271.922l-11.728-11.718c-15.62-15.606-40.924-15.606-56.542 0l-11.728 11.718v-271.922zM816.036 864.204c-0.1 8.712-7.268 15.796-15.972 15.796h-592.004v-736h80.004v368.426c0 16.176 9.742 30.758 24.684 36.954 14.944 6.192 32.146 2.778 43.586-8.656l51.728-51.68 51.728 51.68c7.652 7.644 17.876 11.708 28.28 11.708 5.156 0 10.356-1 15.306-3.050 14.944-6.196 24.684-20.778 24.684-36.954v-368.428h272c8.796 0 15.972 7.16 15.992 15.958l-0.016 704.246z',
	  repository: 'M856.020 159.804c-0.122-52.916-43.048-95.774-95.992-95.774h-591.968c-1.754 0-3.468 0.154-5.164 0.37-19.644 2.54-34.836 19.292-34.836 39.63v784.584c0 22.094 17.91 40 40 40h151.972v63.594c0 10.876 6.548 20.682 16.598 24.844 10.046 4.164 21.612 1.87 29.304-5.818l34.78-34.748 34.78 34.748c5.144 5.14 12.020 7.87 19.014 7.87 3.466 0 6.962-0.672 10.292-2.052 10.048-4.164 16.598-13.968 16.598-24.844v-63.594h278.63c52.642 0 95.368-42.38 95.968-94.882h0.036v-673.916l-0.012-0.012zM776.020 159.988l-0.014 504.628h-519.974v-520.584h503.996c8.796-0 15.972 7.158 15.992 15.956zM760.028 848.616h-278.63v-56h-161.366v56h-111.972v-104h567.944l-0.002 88.204c-0.102 8.71-7.27 15.796-15.974 15.796zM320.032 240.396c0-17.67 14.328-31.998 31.998-31.998s32.002 14.326 32.002 31.998c0 17.674-14.332 32-32.002 32-17.672-0.002-31.998-14.326-31.998-32zM320.032 349.79c0-17.67 14.328-31.998 31.998-31.998s32.002 14.328 32.002 31.998c0 17.676-14.332 32-32.002 32-17.672 0-31.998-14.324-31.998-32zM320.032 459.188c0-17.67 14.328-32 31.998-32s32.002 14.328 32.002 32c0 17.674-14.332 31.998-32.002 31.998-17.672 0-31.998-14.324-31.998-31.998zM384.032 568.582c0 17.674-14.332 31.998-32.002 31.998s-31.998-14.324-31.998-31.998c0-17.67 14.328-32 31.998-32 17.67 0.002 32.002 14.33 32.002 32z',
	  star: 'M763.972 919.5c-6.368 0-12.758-1.518-18.61-4.596l-233.358-122.688-233.37 122.688c-13.476 7.090-29.808 5.904-42.124-3.042-12.318-8.95-18.486-24.118-15.912-39.124l44.57-259.856-188.792-184.028c-10.904-10.626-14.828-26.524-10.124-41.004s17.222-25.034 32.292-27.222l260.906-37.912 116.686-236.42c6.738-13.652 20.644-22.296 35.87-22.296v0c15.226 0 29.13 8.644 35.87 22.298l116.674 236.418 260.906 37.912c15.068 2.19 27.586 12.742 32.292 27.222s0.782 30.376-10.124 41.004l-188.792 184.028 44.24 257.93c0.62 2.796 0.946 5.704 0.946 8.688 0 22.054-17.848 39.942-39.888 40-0.054 0-0.106 0-0.158 0z',
	  starhollow: 'M763.972 919.5c-6.368 0-12.758-1.518-18.61-4.596l-233.358-122.688-233.37 122.688c-13.476 7.090-29.808 5.904-42.124-3.042-12.318-8.95-18.486-24.118-15.912-39.124l44.57-259.856-188.792-184.028c-10.904-10.626-14.828-26.524-10.124-41.004s17.222-25.034 32.292-27.222l260.906-37.912 116.686-236.42c6.738-13.652 20.644-22.296 35.87-22.296v0c15.226 0 29.13 8.644 35.87 22.298l116.674 236.418 260.906 37.912c15.068 2.19 27.586 12.742 32.292 27.222s0.782 30.376-10.124 41.004l-188.792 184.028 44.24 257.93c0.62 2.796 0.946 5.704 0.946 8.688 0 22.054-17.848 39.942-39.888 40-0.054 0-0.106 0-0.158 0zM190.256 428.144l145.812 142.13c9.428 9.192 13.73 22.432 11.504 35.406l-34.424 200.7 180.244-94.758c11.654-6.13 25.576-6.126 37.226 0l180.232 94.756-34.422-200.698c-2.226-12.974 2.076-26.214 11.504-35.406l145.812-142.13-201.51-29.282c-13.030-1.892-24.292-10.076-30.118-21.882l-90.114-182.596-90.122 182.598c-5.826 11.804-17.090 19.988-30.118 21.88l-201.506 29.282z',
	  circle: 'M960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448c0-247.424 200.576-448 448-448s448 200.576 448 448z',
	  circlehollow: 'M960 513c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM251.786 773.216c-69.504-69.508-107.786-161.918-107.786-260.216 0-98.294 38.282-190.708 107.786-260.216 69.506-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214-69.506 69.508-161.922 107.786-260.214 107.786-98.296 0-190.708-38.278-260.214-107.784z',
	  heart: 'M895.032 194.328c-20.906-21.070-46.492-37.316-76.682-48.938-30.104-11.71-63.986-17.39-101.474-17.39-19.55 0-38.744 2.882-57.584 9.094-18.472 6.062-36.584 14.242-54.072 24.246-17.476 9.828-34.056 21.276-49.916 33.898-16.038 12.8-30.456 25.572-43.346 38.664-13.52-13.092-28.026-25.864-43.616-38.664-15.684-12.624-32.080-24.070-49.382-33.898-17.214-10.004-35.414-18.184-54.704-24.246-19.104-6.21-38.568-9.094-58.034-9.094-37.126 0-70.56 5.68-100.48 17.39-29.732 11.622-55.328 27.868-76.328 48.938-20.994 21.094-37.214 46.962-48.478 77.328-11.174 30.544-16.942 64.5-16.942 101.812 0 21.628 3.068 43.078 9.19 64.53 6.308 21.096 14.416 41.986 24.876 61.642 10.446 19.656 22.702 38.488 36.584 56.59 13.88 18.124 28.388 34.516 43.344 49.58l305.766 305.112c8.466 7.558 18.11 11.444 28.204 11.444 10.726 0 19.914-3.884 27.308-11.444l305.934-304.226c14.78-14.772 29.382-31.368 43.166-49.378 14.058-18.212 26.314-37.222 37.042-57.23 10.9-19.924 19.192-40.638 25.406-62 6.218-21.188 9.198-42.61 9.198-64.618 0-37.312-5.592-71.268-16.582-101.812-11.264-30.366-27.22-56.236-48.398-77.33z',
	  hearthollow: 'M716.876 208c27.708 0 52.092 4.020 72.47 11.948l0.132 0.052 0.13 0.050c19.866 7.644 35.774 17.664 48.632 30.624l0.166 0.168 0.17 0.168c12.586 12.536 22.304 28.27 29.706 48.094 7.782 21.786 11.726 46.798 11.726 74.364 0 14.658-1.95 28.426-5.958 42.086l-0.028 0.092-0.026 0.092c-4.866 16.72-11.006 31.752-18.776 45.952l-0.162 0.298-0.16 0.296c-8.81 16.434-18.58 31.532-29.864 46.148l-0.204 0.264c-11.316 14.786-23.48 28.708-36.154 41.378l-277.122 275.574-276.94-276.35c-13.32-13.43-25.248-27.074-36.488-41.75-11.386-14.848-21.284-30.136-29.444-45.49-7.206-13.54-13.494-29.17-18.7-46.472-4.030-14.264-5.988-28.044-5.988-42.116 0-27.36 4.042-52.314 12.016-74.176 7.214-19.378 17.344-35.708 30.066-48.492 12.998-13.042 28.958-23.148 48.826-30.914 20.436-8 43.764-11.886 71.32-11.886 11.536 0 22.738 1.742 33.298 5.174l0.374 0.122 0.376 0.12c13.116 4.122 26.066 9.874 38.494 17.094l0.34 0.2 0.344 0.196c12.736 7.234 25.308 15.876 38.43 26.412 14.486 11.906 27.060 23.048 38.428 34.056l56.994 55.192 55.662-56.532c10.324-10.484 22.18-21.040 36.242-32.264 13.382-10.646 26.216-19.38 39.228-26.698l0.256-0.144 0.254-0.144c13.008-7.442 26.228-13.386 39.294-17.676l0.050-0.016 0.050-0.018c10.354-3.414 20.998-5.076 32.54-5.076zM716.876 128c-19.55 0-38.744 2.882-57.584 9.094-18.472 6.062-36.584 14.242-54.072 24.246-17.476 9.828-34.056 21.276-49.916 33.898-16.038 12.8-30.456 25.572-43.346 38.664-13.52-13.092-28.026-25.864-43.616-38.664-15.684-12.624-32.080-24.070-49.382-33.898-17.214-10.004-35.414-18.184-54.704-24.246-19.104-6.21-38.568-9.094-58.034-9.094-37.126 0-70.56 5.68-100.48 17.39-29.732 11.622-55.328 27.868-76.328 48.938-20.994 21.094-37.214 46.962-48.478 77.328-11.174 30.544-16.942 64.5-16.942 101.812 0 21.628 3.068 43.078 9.19 64.53 6.308 21.096 14.416 41.986 24.876 61.642 10.446 19.656 22.702 38.488 36.584 56.59 13.88 18.124 28.388 34.516 43.344 49.58l305.766 305.112c8.466 7.558 18.11 11.444 28.204 11.444 10.726 0 19.914-3.884 27.308-11.444l305.934-304.226c14.78-14.772 29.382-31.368 43.166-49.378 14.058-18.212 26.314-37.222 37.042-57.23 10.9-19.924 19.192-40.638 25.406-62 6.218-21.188 9.198-42.61 9.198-64.618 0-37.312-5.592-71.268-16.582-101.812-11.262-30.366-27.216-56.234-48.396-77.328-20.906-21.070-46.492-37.316-76.682-48.938-30.106-11.712-63.988-17.392-101.476-17.392v0z',
	  facehappy: 'M960 513c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM251.786 773.214c-69.504-69.508-107.786-161.918-107.786-260.214 0-98.294 38.282-190.708 107.786-260.216 69.506-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214-69.506 69.506-161.922 107.786-260.214 107.786-98.296 0-190.708-38.28-260.214-107.786zM416.5 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM736 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM763.62 636.976v0.094c-49.554 87.14-143.21 145.93-250.62 145.93-107.486 0-201.2-58.868-250.726-146.108v-0.092c-3.34-5.842-5.274-12.59-5.274-19.8s1.934-13.958 5.274-19.798v-0.198h0.122c6.918-11.946 19.808-20.004 34.606-20.004s27.69 8.058 34.61 20.004h0.098c35.756 63.222 103.614 105.996 181.29 105.996s145.54-42.774 181.3-105.996h0.090c6.918-11.946 19.81-20.004 34.606-20.004s27.69 8.058 34.61 20.004h0.014v0.024c3.402 5.88 5.38 12.69 5.38 19.972 0 7.286-1.978 14.094-5.38 19.976z',
	  facesad: 'M960 513c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM251.786 773.214c-69.504-69.506-107.786-161.918-107.786-260.214 0-98.294 38.282-190.708 107.786-260.216 69.506-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214-69.506 69.506-161.922 107.786-260.214 107.786-98.296 0-190.708-38.28-260.214-107.786zM416.5 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM736 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM262.38 684.024v-0.094c49.552-87.14 143.208-145.93 250.62-145.93 107.486 0 201.2 58.868 250.726 146.108v0.092c3.34 5.842 5.274 12.59 5.274 19.8s-1.934 13.958-5.274 19.798v0.198h-0.122c-6.918 11.946-19.808 20.004-34.606 20.004s-27.69-8.058-34.61-20.004h-0.098c-35.76-63.222-103.618-105.996-181.292-105.996s-145.54 42.774-181.3 105.996h-0.090c-6.918 11.946-19.808 20.004-34.606 20.004s-27.69-8.058-34.61-20.004h-0.014v-0.024c-3.402-5.88-5.38-12.69-5.38-19.972 0.002-7.286 1.98-14.094 5.382-19.976z',
	  faceneutral: 'M968 513c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM259.786 773.214c-69.504-69.506-107.786-161.918-107.786-260.214 0-98.294 38.282-190.708 107.786-260.216 69.506-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214-69.506 69.506-161.922 107.786-260.214 107.786-98.296 0-190.708-38.28-260.214-107.786zM424.5 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM744 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM777 641c0 22.094-17.906 40-40 40h-432c-22.090 0-40-17.906-40-40 0-22.090 17.91-40 40-40h432c22.094 0 40 17.91 40 40z',
	  lock: 'M896.032 915.53v-467.498c0-19.102-13.402-35.052-31.31-39.026-0.21-0.046-0.414-0.12-0.628-0.162-0.444-0.090-0.904-0.13-1.354-0.208-2.186-0.37-4.416-0.606-6.708-0.606h-55.902l0.002-55.85h0.020c0-159.14-129.010-288.15-288.15-288.15-159.128 0-288.13 128.992-288.15 288.118v55.884h-54.852c-20.71 0-37.746 15.742-39.792 35.91-0.136 1.344-0.208 2.708-0.208 4.090v463.332c-0.618 2.792-0.968 5.688-0.968 8.668 0 22.094 17.91 40 40 40h688.27c22.092 0 40-17.91 40-40-0.002-1.524-0.104-3.024-0.27-4.502zM209 488.032h607.032v392h-607.032v-392zM303.85 352.182c0-114.776 93.376-208.15 208.15-208.15 114.59 0 207.842 93.074 208.142 207.596 0 0.084-0.012 0.164-0.012 0.248v56.156h-416.284l0.004-55.85zM552.164 691.858l-0.002 58.188c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40v-57.974c-14.704-11.726-24.134-29.782-24.134-50.048 0-35.346 28.654-64 64-64s64 28.654 64 64c0 20.142-9.318 38.104-23.868 49.836z',
	  unlock: 'M896.032 915.53v-467.498c0-1.988-0.194-3.926-0.472-5.834-0.11-0.744-0.192-1.498-0.34-2.226-1.524-7.44-5.136-14.1-10.164-19.408-0.252-0.266-0.48-0.554-0.738-0.814-0.496-0.494-1.036-0.944-1.554-1.412-0.43-0.386-0.84-0.8-1.288-1.17-0.292-0.24-0.608-0.446-0.904-0.676-2.506-1.954-5.244-3.616-8.176-4.934-0.744-0.334-1.504-0.632-2.27-0.922-4.39-1.656-9.124-2.604-14.094-2.604h-552.184l0.002-55.85c0-114.776 93.376-208.15 208.15-208.15 86.038 0 160.034 52.474 191.7 127.096 0.012 0.028 0.030 0.044 0.042 0.072 5.978 14.566 20.284 24.832 37.006 24.832 22.090 0 40-17.906 40-40 0-4.71-0.86-9.21-2.354-13.41-0.182-0.694-0.42-1.438-0.782-2.292-43.666-103.582-146.14-176.296-265.612-176.296-159.128 0-288.13 128.994-288.15 288.12v55.882h-54.85c-20.71 0-37.746 15.742-39.792 35.91-0.136 1.344-0.208 2.708-0.208 4.090v463.332c-0.618 2.794-0.968 5.688-0.968 8.668 0 22.094 17.91 40 40 40h688.27c22.092 0 40-17.91 40-40-0.002-1.528-0.104-3.028-0.27-4.506zM209 488.032h607.032v392h-607.032v-392zM552.164 691.86l-0.002 58.186c0.004 22.088-17.906 39.996-39.996 40-22.094 0-40.004-17.908-40-40v-57.976c-14.702-11.726-24.134-29.782-24.134-50.048 0-35.346 28.654-64 64-64s64 28.654 64 64c0 20.142-9.318 38.102-23.868 49.838z',
	  key: 'M768.032 320.032c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM960.032 353.092c0 159.062-128.946 288.010-288.008 288.010-35.306 0-69.124-6.368-100.38-17.996l-27.736 27.738-0.002 54.464c0 0.016 0.002 0.028 0.002 0.040 0 11.046-4.478 21.046-11.716 28.29-6.334 6.332-14.784 10.55-24.196 11.508-1.346 0.136-2.708 0.208-4.090 0.208h-71.748l-0.002 71.96c0 0.012 0.002 0.040 0.002 0.040 0 11.046-4.478 21.046-11.716 28.286-6.334 6.336-14.784 10.554-24.196 11.508-1.346 0.136-2.708 0.208-4.090 0.208h-71.996l-0.002 62.684c0 22.094-17.908 40-40 40-0.022 0-0.042 0-0.062 0-0.022 0-0.042 0-0.064 0h-175.996c-13.76 0-25.888-6.95-33.086-17.524-4.362-6.406-6.916-14.14-6.916-22.476v-112c0-0.664 0.066-1.308 0.1-1.964 0.032-0.618 0.034-1.234 0.092-1.852 0.11-1.148 0.288-2.278 0.492-3.398 0.024-0.128 0.034-0.258 0.058-0.386 1.614-8.378 5.848-15.808 11.808-21.446l325.456-325.458c-11.642-31.274-18.020-65.11-18.020-100.44 0-159.060 128.946-288.006 288.006-288.006 159.060-0.004 288.006 128.942 288.006 288.002zM880.032 353.092c0-114.696-93.312-208.006-208.008-208.006s-208.006 93.31-208.006 208.006c0 43.208 13.246 83.376 35.884 116.668l-57.36 57.362c-0.136-0.184-0.27-0.368-0.408-0.546l-298.102 298.106-0.002 55.356h96.124v-62.684c0-0.708 0.070-1.394 0.106-2.094 0.036-0.664 0.036-1.336 0.102-1.992 0.132-1.316 0.334-2.61 0.592-3.882 0.006-0.028 0.008-0.058 0.014-0.090 0.258-1.262 0.58-2.5 0.956-3.714 0.012-0.040 0.018-0.078 0.030-0.118 4.676-15.032 17.976-26.262 34.114-27.902 1.344-0.136 2.708-0.208 4.090-0.208h71.998v-67.64c-0.156-1.434-0.248-2.882-0.248-4.36 0-22.094 17.908-40 40-40h71.998v-30.692c0-0.148 0.020-0.29 0.022-0.438 0.008-10.226 3.912-20.45 11.714-28.254l55.99-55.988c1.982-1.984 4.124-3.71 6.38-5.188l18.68-18.684c33.030 22.090 72.702 34.992 115.332 34.992 114.694-0 208.008-93.314 208.008-208.010z',
	  arrowleftalt: 'M107.854 539.924l282.834 283.272c15.594 15.65 40.92 15.692 56.568 0.1 15.648-15.594 15.694-40.92 0.1-56.568l-214.838-215.040h655.412c22.092 0 40-17.908 40-40s-17.908-40-40-40h-655l214.75-214.61c15.64-15.602 15.672-40.928 0.070-56.568-7.814-7.834-18.066-11.752-28.32-11.75-10.22 0-20.442 3.892-28.25 11.68l-283.242 282.93c-15.634 15.594-15.672 40.91-0.084 56.554z',
	  arrowrightalt: 'M916.266 483.792l-282.834-283.272c-15.594-15.65-40.92-15.692-56.568-0.1-15.648 15.594-15.694 40.92-0.1 56.568l214.838 215.040h-655.412c-22.092 0-40 17.908-40 40s17.908 40 40 40h655l-214.748 214.61c-15.64 15.602-15.672 40.928-0.070 56.568 7.814 7.834 18.066 11.752 28.32 11.75 10.22 0 20.442-3.892 28.25-11.68l283.242-282.93c15.632-15.596 15.67-40.91 0.082-56.554z',
	  sync: 'M998.786 474.516l-91 90.988c-8.028 8.036-18.624 11.902-29.152 11.676-10.536 0.234-21.144-3.632-29.184-11.676l-92.3-92.296c-15.624-15.622-15.624-40.95 0-56.57 15.622-15.622 40.95-15.624 56.57 0l26.146 26.148c-13.774-61.416-44.624-117.806-90.216-163.394-63.46-63.464-147.84-98.414-237.586-98.414-89.75 0-174.128 34.95-237.59 98.414-27.012 27.012-48.836 57.824-65.024 91.214l-0.008-0.004c-6.722 12.632-20.008 21.242-35.32 21.242-22.090 0-40-17.906-40-40 0-5.464 1.102-10.668 3.086-15.414l-0.004-0.004c0.016-0.032 0.024-0.058 0.040-0.090 0.036-0.078 0.070-0.156 0.106-0.234 0.73-1.632 0.208-0.718 5.004-9.996 69.18-133.726 208.766-225.128 369.71-225.128 203.224 0 372.374 145.734 408.728 338.392l21.424-21.424c15.618-15.622 40.946-15.622 56.566 0s15.624 40.948 0.004 56.57zM889.992 682.11c0 5.464-1.106 10.672-3.090 15.414l0.008 0.004c-0.016 0.036-0.028 0.058-0.040 0.090-0.036 0.078-0.074 0.156-0.106 0.234-0.73 1.636-0.208 0.718-5.008 10-69.176 133.722-208.762 225.124-369.708 225.124-205.2 0-375.668-148.578-409.76-344.022l-19.478 19.478c-15.622 15.622-40.95 15.622-56.57 0-15.618-15.622-15.622-40.95 0-56.57l90.996-90.992c8.032-8.032 18.628-11.902 29.152-11.672 10.536-0.238 21.144 3.632 29.188 11.672l92.296 92.3c15.624 15.618 15.624 40.946 0 56.566-15.618 15.622-40.946 15.624-56.566 0.004l-29.292-29.292c12.466 65.568 44.214 125.882 92.448 174.116 63.46 63.46 147.84 98.41 237.586 98.41 89.75 0 174.124-34.95 237.59-98.41 27.012-27.012 48.836-57.824 65.020-91.218l0.008 0.004c6.726-12.632 20.012-21.242 35.324-21.242 22.092 0.002 40.002 17.912 40.002 40.002zM145.83 545.416l1.4 0.248-0.824-0.824-0.576 0.576z',
	  reply: 'M679.496 431.738c-0.414-0.062-0.834-0.102-1.266-0.102h-477.482l171.506-171.504c15.622-15.622 15.622-40.95-0.002-56.57-15.62-15.624-40.948-15.624-56.568 0l-239.734 239.732c-0.958 0.956-1.868 1.958-2.724 3.006-0.328 0.402-1.884 2.482-2.324 3.138-0.36 0.54-1.696 2.77-2.008 3.352-0.308 0.58-1.424 2.936-1.676 3.544-0.036 0.086-0.468 1.268-0.648 1.774-0.23 0.636-0.474 1.266-0.672 1.918-0.186 0.612-0.818 3.13-0.95 3.788-0.148 0.748-0.522 3.318-0.574 3.862-0.262 2.642-0.262 5.3 0 7.942 0.044 0.448 0.412 3.032 0.58 3.874 0.112 0.556 0.74 3.088 0.958 3.808 0.158 0.524 1.036 2.992 1.328 3.7 0.192 0.458 1.298 2.828 1.688 3.552 0.208 0.386 0.446 0.75 0.666 1.126 0.436 0.752 1.844 2.888 2.084 3.224 0.52 0.724 4.262 5.074 4.29 5.098l239.718 239.72c15.62 15.618 40.948 15.618 56.57 0 15.62-15.624 15.622-40.948 0-56.57l-171.516-171.514h471.296c114.52 0.084 207.688 93.124 207.988 207.594 0 0.084-0.012 0.164-0.012 0.248v95.876c-0.004 22.094 17.906 40.002 40 40 22.090-0.002 40-17.91 39.996-39.998l0.004-95.57h0.020c0-156.594-124.914-284.012-280.536-288.048z',
	  undo: 'M230 301h480a240 240 0 1 1 0 481H235c-23 0-42-20-42-43 0-24 19-43 42-43h475a155 155 0 0 0 0-310H228l3 3 65 65a45 45 0 0 1-65 64L90 376a45 45 0 0 1 0-64l142-142a45 45 0 1 1 64 65l-63 62-3 4z',
	  transfer: 'M916.25 348.726l-125 124.688c-7.808 7.79-18.032 11.68-28.25 11.68-10.254 0.002-20.506-3.918-28.32-11.75-15.602-15.64-15.57-40.966 0.070-56.568l56.508-56.368h-655.258c-22.092 0-40-17.908-40-40s17.908-40 40-40h655.672l-57.006-57.206c-15.594-15.646-15.548-40.972 0.1-56.566s40.972-15.55 56.568 0.098l125 125.438c15.588 15.644 15.548 40.958-0.084 56.554zM107.666 731.892l125 125.438c15.596 15.648 40.92 15.692 56.568 0.098s15.694-40.92 0.1-56.566l-57.006-57.206h655.672c22.092 0 40-17.908 40-40s-17.908-40-40-40h-655.258l56.508-56.368c15.64-15.602 15.672-40.928 0.070-56.568-7.814-7.832-18.066-11.752-28.32-11.75-10.218 0-20.442 3.89-28.25 11.68l-125 124.688c-15.632 15.596-15.672 40.91-0.084 56.554z',
	  redirect: 'M913.852 702.796c-15.594-15.648-40.922-15.694-56.57-0.1l-57.204 57.006v-451.424c0-0.372-0.028-0.736-0.074-1.098-0.458-99.016-80.86-179.15-179.988-179.15-99.412 0-180 80.592-180 180 0 0.084 0.004 0.166 0.004 0.248h-0.004v343.504h-0.006c0 0.082 0.006 0.164 0.006 0.248 0 55.14-44.86 100-100 100s-100-44.86-100-100c0-0.084 0.006-0.166 0.006-0.248h-0.002v-483.752c0-22.092-17.91-40-40-40s-40.004 17.908-40.004 40v483.752c0 0.018 0.002 0.036 0.002 0.054 0 0.064-0.002 0.128-0.002 0.194 0 99.408 80.59 180 180 180 99.412 0 180-80.592 180-180 0-0.084-0.004-0.166-0.004-0.248h0.004v-343.504h0.008c0-0.082-0.008-0.164-0.008-0.248 0-55.138 44.86-100 100-100s100 44.862 100 100c0 0.084-0.008 0.166-0.008 0.248h0.070v451.008l-56.368-56.506c-15.602-15.642-40.93-15.67-56.566-0.070-7.836 7.814-11.754 18.066-11.754 28.32 0 10.218 3.894 20.442 11.68 28.252l124.692 125c15.594 15.632 40.91 15.67 56.554 0.084l125.434-125c15.652-15.598 15.692-40.92 0.102-56.57z',
	  expand: 'M959.688 920.068l0.31-176c0.040-22.094-17.84-40.032-39.93-40.070-22.092-0.040-40.032 17.838-40.070 39.93l-0.142 79.672-235.734-235.732c-15.622-15.622-40.948-15.622-56.57 0s-15.622 40.948 0 56.568l235.442 235.442-78.946-0.1c-22.092-0.028-40.022 17.86-40.050 39.952-0.014 11.064 4.464 21.084 11.714 28.334 7.228 7.224 17.208 11.702 28.236 11.714l175.688 0.22c22.086 0.028 40.014-17.846 40.052-39.93zM920.178 64.228l-176-0.308c-22.094-0.040-40.032 17.84-40.070 39.93-0.040 22.092 17.838 40.032 39.93 40.070l79.672 0.14-235.732 235.734c-15.622 15.622-15.622 40.948 0 56.568s40.948 15.622 56.568 0l235.442-235.442-0.1 78.946c-0.028 22.092 17.86 40.022 39.952 40.050 11.064 0.014 21.084-4.464 28.334-11.714 7.224-7.228 11.702-17.208 11.714-28.236l0.22-175.688c0.026-22.082-17.846-40.010-39.93-40.050zM64.236 103.742l-0.308 176c-0.040 22.094 17.84 40.032 39.93 40.070 22.092 0.040 40.032-17.84 40.070-39.93l0.14-79.672 235.734 235.73c15.622 15.622 40.948 15.622 56.568 0s15.622-40.946 0-56.566l-235.442-235.442 78.946 0.098c22.092 0.028 40.022-17.86 40.050-39.95 0.014-11.066-4.464-21.086-11.714-28.336-7.228-7.222-17.208-11.7-28.236-11.714l-175.688-0.218c-22.084-0.026-40.012 17.844-40.050 39.93zM103.748 959.766l176 0.308c22.094 0.040 40.032-17.84 40.070-39.93 0.040-22.092-17.84-40.032-39.93-40.070l-79.672-0.14 235.73-235.734c15.622-15.622 15.622-40.948 0-56.568s-40.946-15.622-56.566 0l-235.442 235.442 0.098-78.946c0.028-22.092-17.86-40.022-39.95-40.050-11.066-0.014-21.086 4.464-28.336 11.714-7.222 7.228-11.7 17.208-11.714 28.236l-0.218 175.688c-0.026 22.082 17.844 40.010 39.93 40.050z',
	  expandalt: 'M512.008 959.964c-10.236 0-20.47-3.904-28.282-11.712l-239.898-239.838c-15.624-15.62-15.624-40.946-0.006-56.57 15.622-15.622 40.948-15.624 56.568-0.004l211.618 211.562 211.712-211.658c15.624-15.618 40.952-15.616 56.568 0.004 15.62 15.624 15.618 40.95-0.006 56.57l-239.994 239.934c-7.808 7.808-18.044 11.712-28.28 11.712zM483.824 75.744l-239.994 239.934c-15.624 15.62-15.624 40.948-0.006 56.57s40.944 15.622 56.568 0.004l211.712-211.658 211.618 211.562c15.622 15.62 40.948 15.616 56.568-0.006 15.62-15.624 15.618-40.95-0.006-56.57l-239.898-239.836c-7.81-7.81-18.044-11.714-28.282-11.714s-20.47 3.906-28.28 11.714z',
	  grow: 'M541.146 448.384c-1.694-0.216-3.408-0.37-5.162-0.37h-367.968c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v368.032c0 22.094 17.91 40 40 40h367.968c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-368.036c0-20.34-15.192-37.094-34.838-39.632zM208.016 816.046v-288.032h287.968v288.032h-287.968zM736.032 856.046c0 22.090-17.908 40-40 40-22.090 0-40-17.908-40-40v-487.902l-488.016 0.002c-22.090 0-40-17.91-40-40s17.908-40.002 40-40.002h528.016c1.754 0 3.468 0.152 5.162 0.37 19.646 2.538 34.838 19.292 34.838 39.63v527.902zM896.032 168.030v688.004c-0.002 22.088-17.91 39.996-40 39.996s-40.002-17.908-40.002-40c0 0 0.002-304.026 0.002-304.040v-343.96h-343.96c-0.014 0-304.040 0.002-304.040 0.002-22.090 0-40-17.91-40-40s17.908-40.002 40-40.002h688c1.754 0 3.468 0.152 5.162 0.37 19.646 2.536 34.838 19.29 34.838 39.63z',
	  arrowleft: 'M257.93 511.976c0-10.236 3.902-20.47 11.71-28.282l344.098-344.158c15.622-15.624 40.946-15.624 56.57-0.006 15.622 15.622 15.624 40.948 0.004 56.568l-315.82 315.876 315.868 315.922c15.618 15.624 15.618 40.952-0.004 56.568-15.622 15.62-40.95 15.618-56.57-0.006l-344.146-344.202c-7.808-7.81-11.71-18.044-11.71-28.28z',
	  arrowup: 'M512.024 256c10.236 0 20.47 3.904 28.282 11.712l344.154 344.098c15.624 15.62 15.624 40.946 0.006 56.57-15.622 15.622-40.948 15.624-56.568 0.004l-315.876-315.82-315.922 315.868c-15.624 15.618-40.952 15.618-56.568-0.004-15.62-15.624-15.618-40.95 0.006-56.57l344.204-344.144c7.81-7.81 18.046-11.714 28.282-11.714z',
	  arrowdown: 'M511.976 768.002c-10.236 0-20.47-3.904-28.282-11.712l-344.154-344.098c-15.624-15.62-15.624-40.946-0.006-56.57 15.622-15.622 40.948-15.624 56.568-0.004l315.876 315.82 315.922-315.868c15.624-15.618 40.952-15.616 56.568 0.004 15.62 15.624 15.618 40.95-0.006 56.57l-344.204 344.144c-7.81 7.81-18.046 11.714-28.282 11.714z',
	  arrowright: 'M768.072 514.022c0 10.236-3.904 20.47-11.712 28.282l-344.098 344.156c-15.62 15.624-40.946 15.624-56.568 0.006-15.622-15.622-15.624-40.948-0.006-56.568l315.82-315.876-315.868-315.922c-15.618-15.624-15.618-40.952 0.004-56.568 15.624-15.62 40.95-15.618 56.57 0.006l344.144 344.204c7.81 7.81 11.714 18.044 11.714 28.28z',
	  chevrondown: 'M511.976 833c-10.236 0-20.47-3.904-28.282-11.712l-471.934-471.874c-15.624-15.62-15.624-40.946-0.006-56.57 15.622-15.622 40.948-15.624 56.568-0.004l443.652 443.598 443.61-443.556c15.624-15.618 40.952-15.616 56.568 0.004 15.62 15.624 15.618 40.95-0.006 56.57l-471.89 471.832c-7.808 7.808-18.044 11.712-28.28 11.712z',
	  back: 'M512.030 880c-98.296 0-190.708-38.28-260.214-107.784-69.508-69.508-107.786-161.922-107.786-260.216 0-98.296 38.278-190.708 107.786-260.214s161.918-107.786 260.214-107.786c98.292 0 190.708 38.28 260.214 107.786 69.504 69.508 107.786 161.918 107.786 260.214 0 98.294-38.282 190.708-107.786 260.216-69.508 69.504-161.922 107.784-260.214 107.784zM512.030 960c247.422 0 448-200.576 448-448s-200.578-448-448-448c-247.426 0-448 200.576-448 448s200.574 448 448 448v0zM267.63 538.67l125 125.438c15.596 15.648 40.922 15.692 56.57 0.098s15.692-40.92 0.098-56.566l-57.004-57.206h335.672c22.090 0 40-17.908 40-40s-17.91-40-40-40h-335.26l56.508-56.368c15.64-15.602 15.672-40.928 0.070-56.568-7.814-7.832-18.064-11.752-28.318-11.75-10.22 0-20.444 3.89-28.25 11.68l-125 124.688c-15.634 15.596-15.672 40.91-0.086 56.554z',
	  download: 'M881 513.188c0 98.296-38.28 190.708-107.784 260.214-69.508 69.508-161.922 107.786-260.216 107.786-98.296 0-190.708-38.28-260.214-107.786s-107.786-161.916-107.786-260.214c0-98.294 38.28-190.708 107.786-260.216 69.508-69.504 161.918-107.784 260.214-107.784 98.294 0 190.708 38.28 260.216 107.784 69.504 69.508 107.784 161.922 107.784 260.216zM961 513.188c0-247.424-200.576-448-448-448s-448 200.576-448 448 200.576 448 448 448 448-200.576 448-448v0zM539.672 757.584l125.436-125c15.65-15.594 15.692-40.92 0.1-56.568-15.594-15.648-40.92-15.694-56.568-0.1l-57.204 57.004v-335.67c0-22.092-17.908-40-40-40s-40 17.908-40 40v335.258l-56.368-56.508c-15.602-15.64-40.928-15.672-56.568-0.070-7.834 7.814-11.752 18.066-11.75 28.32 0 10.22 3.892 20.442 11.68 28.25l124.688 125c15.594 15.634 40.91 15.672 56.554 0.084z',
	  upload: 'M143.996 511.998c0-98.296 38.28-190.708 107.784-260.214 69.508-69.508 161.922-107.786 260.216-107.786 98.296 0 190.708 38.278 260.214 107.786s107.786 161.918 107.786 260.214c0 98.292-38.28 190.708-107.786 260.214-69.508 69.504-161.918 107.786-260.214 107.786-98.294 0-190.708-38.282-260.216-107.786-69.504-69.508-107.784-161.922-107.784-260.214zM63.996 511.998c0 247.422 200.576 448 448 448s448-200.578 448-448c0-247.426-200.576-448-448-448s-448 200.574-448 448v0zM485.324 267.598l-125.438 125c-15.648 15.596-15.692 40.922-0.098 56.57s40.92 15.692 56.566 0.098l57.206-57.004v335.672c0 22.090 17.908 40 40 40s40-17.91 40-40v-335.26l56.368 56.508c15.602 15.64 40.928 15.672 56.568 0.070 7.832-7.814 11.752-18.064 11.75-28.318 0-10.22-3.89-20.444-11.68-28.25l-124.688-125c-15.594-15.634-40.91-15.672-56.554-0.086z',
	  proceed: 'M512 144c98.296 0 190.708 38.28 260.214 107.784 69.506 69.508 107.786 161.922 107.786 260.216 0 98.296-38.28 190.708-107.786 260.214-69.506 69.508-161.918 107.786-260.214 107.786-98.294 0-190.708-38.28-260.216-107.786-69.504-69.506-107.784-161.916-107.784-260.214 0-98.294 38.28-190.708 107.784-260.216 69.508-69.504 161.922-107.784 260.216-107.784zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448v0zM756.396 484.14l-125-125.436c-15.594-15.65-40.92-15.692-56.568-0.1-15.648 15.594-15.694 40.92-0.1 56.568l57.004 57.204h-335.67c-22.092 0-40 17.908-40 40s17.908 40 40 40h335.258l-56.508 56.368c-15.64 15.602-15.672 40.928-0.070 56.568 7.814 7.834 18.066 11.752 28.32 11.75 10.22 0 20.442-3.892 28.25-11.68l125-124.688c15.634-15.594 15.672-40.91 0.084-56.554z',
	  info: 'M828.782 195.216c-174.954-174.958-458.614-174.958-633.566 0-174.958 174.954-174.958 458.612 0 633.568 174.954 174.954 458.614 174.954 633.566 0 174.956-174.952 174.956-458.614 0-633.568zM772.214 772.214c-69.508 69.506-161.918 107.784-260.214 107.784-98.3 0-190.71-38.278-260.218-107.784-69.504-69.506-107.782-161.92-107.786-260.214 0.004-98.296 38.282-190.708 107.786-260.214 69.508-69.506 161.922-107.786 260.218-107.788 98.292 0.002 190.708 38.282 260.214 107.79 69.504 69.504 107.782 161.916 107.786 260.212-0.004 98.294-38.282 190.708-107.786 260.214zM512.996 361.124c-22.090 0-40-17.906-40-40v0c0-22.088 17.91-40 40-40v0c22.090 0 40.004 17.912 40.004 40v0c0 22.092-17.914 40-40.004 40v0zM512.998 743.094c-22.090 0-40-17.906-40-40v-240.002c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v240.002c0 22.094-17.914 40-40.004 40v0z',
	  question: 'M828.782 195.218c-174.954-174.958-458.614-174.958-633.566 0-174.958 174.954-174.958 458.612 0 633.566 174.954 174.956 458.614 174.956 633.566 0 174.956-174.95 174.956-458.614 0-633.566zM772.214 772.216c-69.508 69.504-161.918 107.782-260.214 107.782-98.3 0-190.71-38.278-260.218-107.782-69.504-69.506-107.782-161.92-107.786-260.216 0.004-98.298 38.282-190.708 107.786-260.216 69.508-69.504 161.922-107.784 260.218-107.784 98.292 0 190.708 38.28 260.214 107.788 69.504 69.504 107.782 161.916 107.786 260.214-0.004 98.294-38.282 190.708-107.786 260.214zM512.996 784.784c-22.090 0-40-17.906-40-40v0c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v0c0 22.094-17.914 40-40.004 40v0zM552.996 572.27v52.898c0.004 22.088-17.906 39.996-39.996 40-22.094 0-40.004-17.908-40-40v-88c-0.004-21.752 17.372-39.416 38.996-39.952v-0.146c53.118 0 96.332-43.212 96.332-96.33 0-53.116-43.214-96.328-96.332-96.328-53.098 0-96.296 43.184-96.324 96.278 0 0.014 0 0.034 0 0.050 0 22.094-17.914 40-40.004 40s-40-17.906-40-40c0-97.382 78.946-176.328 176.328-176.328 97.386 0 176.332 78.946 176.332 176.328 0 83.268-57.722 153.048-135.332 171.53z',
	  support: 'M828.814 195.216c-174.956-174.956-458.614-174.956-633.566 0-174.958 174.956-174.956 458.612 0 633.568s458.614 174.956 633.566 0c174.958-174.956 174.956-458.612 0-633.568zM813.592 723.072l-92.714-92.712c41.542-73.186 41.548-163.544 0.016-236.734l92.7-92.698c43.176 61.41 66.44 134.45 66.44 211.074-0.004 76.62-23.266 149.662-66.442 211.070zM398.916 625.116c-62.382-62.384-62.382-163.89 0-226.274 30.216-30.216 70.398-46.86 113.146-46.864h0.010c42.724 0 82.898 16.642 113.12 46.866 62.382 62.38 62.382 163.886 0 226.272-30.22 30.22-70.4 46.864-113.136 46.864-42.74-0.002-82.92-16.644-113.14-46.864zM723.104 210.44l-92.696 92.698c-36.59-20.766-77.464-31.162-118.356-31.158-40.888 0.004-81.78 10.406-118.378 31.178l-92.714-92.716c61.408-43.176 134.452-66.438 211.070-66.44 76.622-0.004 149.668 23.262 211.074 66.438zM210.472 300.928l92.724 92.726c-41.512 73.176-41.506 163.506 0.016 236.678l-92.742 92.74c-43.176-61.408-66.438-134.454-66.44-211.072 0.004-76.624 23.264-149.664 66.442-211.072zM512.032 880c-76.624-0.002-149.666-23.264-211.072-66.44l92.74-92.742c36.59 20.766 77.464 31.16 118.356 31.16 40.868 0 81.738-10.392 118.322-31.144l92.726 92.726c-61.408 43.176-134.454 66.44-211.072 66.44z',
	  alert: 'M511.998 623.846c-22.090 0-40-17.906-40-40v-208c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v208c0 22.094-17.914 40-40.004 40v0zM511.998 743.846c22.090 0 40.004-17.906 40.004-40v0c0-22.090-17.914-40-40.004-40v0c-22.090 0-40 17.91-40 40v0c0 22.094 17.91 40 40 40v0zM512.142 211.808l-340.074 589.028h680.148l-340.074-589.028zM512.142 92.51c14.5 0 29 9.526 40 28.58l398.638 690.462c22 38.106 4 69.282-40 69.282h-797.278c-44 0-62-31.176-40-69.282l398.638-690.462c11.002-19.052 25.502-28.58 40.002-28.58v0z',
	  bell: 'M901.344 760.018l-57.644-77.648c-7.906-7.906-11.77-38.284-11.71-48.646h0.042v-200.588h-0.364c-6.878-148.106-114.428-269.902-255.792-298.528 0.208-2.1 0.318-4.228 0.318-6.384 0-35.452-28.738-64.194-64.194-64.194-35.458 0-64.194 28.742-64.194 64.194 0 2.19 0.112 4.352 0.326 6.486-141.128 28.802-248.446 150.488-255.316 298.426h-0.364v200.588h0.042c0.058 10.362-3.804 40.74-11.71 48.646l-57.644 77.648c-8.802 8.802-16.35 18.978-16.35 32.208 0 22.092 17.908 40 40 40h255.876c-0.814 5.412-1.28 10.936-1.28 16.576 0 61.43 49.794 111.23 111.23 111.23 61.432 0 111.228-49.8 111.228-111.23 0-5.638-0.464-11.164-1.282-16.576h255.128c22.092 0 40-17.908 40-40 0.004-13.23-7.542-23.404-16.346-32.208zM272.732 436.848c2.862-61.602 29.032-119.104 73.69-161.91 44.786-42.93 103.628-66.62 165.692-66.706h0.26c62.062 0.086 120.906 23.776 165.692 66.706 44.658 42.806 70.828 100.308 73.69 161.91l0.278 5.962v149.384h-479.58v-149.384l0.278-5.962zM543.846 848.8c0 17.22-14.010 31.23-31.228 31.23-17.22 0-31.23-14.010-31.23-31.23 0-6.096 1.784-11.768 4.82-16.576h52.818c3.038 4.81 4.82 10.482 4.82 16.576zM512.484 752.226h-283.922l14.572-19.63c12.064-14.542 20.078-33.27 24.982-58.158 0.146-0.742 0.276-1.496 0.416-2.244h487.42c0.138 0.748 0.268 1.5 0.414 2.244 4.904 24.888 12.918 43.616 24.982 58.158l14.572 19.63h-283.436z',
	  rss: 'M256.094 865.048c0 53.020-42.972 96-96 96-53.020 0-96-42.98-96-96 0-53.016 42.98-96 96-96s96 42.984 96 96zM510.020 918.352c-0.018-0.172-0.042-0.344-0.050-0.52-0.054-0.676-0.124-1.34-0.214-2.004-10.582-105.644-57.866-200.46-128.894-271.536v0c-71.074-71.054-165.906-118.352-271.564-128.934-0.664-0.090-1.33-0.16-2.006-0.214-0.174-0.016-0.348-0.040-0.52-0.054-0.254-0.024-0.5-0.024-0.742-0.008-0.64-0.032-1.278-0.098-1.922-0.098-22.098 0-40 17.908-40 40 0 20.582 15.542 37.516 35.536 39.738 0.042 0.004 0.066 0.036 0.106 0.040 84.82 8.098 163.514 45.024 224.542 106.042v0c61.036 61.036 97.964 139.738 106.070 224.574 0.004 0.040 0.036 0.070 0.042 0.106 2.222 19.988 19.156 35.536 39.736 35.536 22.092 0 40-17.902 40-40 0-0.644-0.066-1.282-0.098-1.922 0-0.246 0-0.492-0.022-0.746zM734.688 918.45c-0.004-0.090-0.018-0.186-0.024-0.276-0.040-0.544-0.058-1.102-0.124-1.638-10.972-167.816-83.558-318.804-195.33-430.616h0.002c-111.812-111.788-262.81-184.384-430.644-195.36-0.542-0.060-1.094-0.084-1.642-0.122-0.092-0.008-0.182-0.016-0.272-0.022-0.020-0.002-0.042 0.004-0.054 0.004-0.836-0.052-1.664-0.124-2.512-0.124-22.092 0-40 17.908-40 40 0 21.036 16.246 38.24 36.874 39.842 0.046 0.008 0.078 0.038 0.128 0.042 66.876 4.086 131.786 19.292 193.406 45.358 70.472 29.81 133.78 72.494 188.166 126.874v0c54.394 54.396 97.090 117.71 126.902 188.204 26.064 61.624 41.274 126.532 45.362 193.408 0.004 0.052 0.036 0.080 0.042 0.13 1.604 20.624 18.802 36.87 39.844 36.87 22.090 0 40-17.904 40-40 0-0.85-0.074-1.678-0.126-2.514-0.002-0.024 0.006-0.040 0.002-0.060zM959.126 920.556c-0.002-0.094 0.008-0.164 0.004-0.262-10.342-231.204-108.314-439.604-261.486-592.796v-0.002c-153.2-153.19-361.61-251.174-592.828-261.518-0.096-0.004-0.168 0.006-0.262 0.004-0.176-0.004-0.348-0.030-0.524-0.030-22.098 0-40 17.91-40 40 0 20.988 16.168 38.164 36.716 39.834 0.184 0.042 0.356 0.086 0.566 0.098 97.040 4.314 191.186 25.538 280.376 63.258 97.14 41.090 184.406 99.928 259.368 174.876v0c74.96 74.964 133.81 162.24 174.908 259.398 37.718 89.19 58.946 183.336 63.26 280.376 0.010 0.208 0.052 0.38 0.096 0.562 1.67 20.552 18.848 36.72 39.834 36.72 22.092 0 40-17.906 40-40-0-0.17-0.024-0.342-0.028-0.518z',
	  edit: 'M948.56 263.376c12.704-12.708 15.072-31.836 7.11-46.936-1.84-3.524-4.232-6.832-7.192-9.792-0.286-0.286-0.594-0.528-0.886-0.8l-129.318-128.634c-0.048-0.048-0.088-0.106-0.138-0.154-7.812-7.812-18.050-11.716-28.292-11.714-10.242-0.004-20.484 3.902-28.296 11.714-0.064 0.066-0.12 0.136-0.184 0.204l-636.168 636.168c-5.868 5.134-10.21 11.958-12.298 19.748l-47.606 177.664c-3.7 13.804 0.248 28.534 10.352 38.638 7.602 7.6 17.816 11.714 28.288 11.714 3.452 0 6.93-0.446 10.352-1.364l177.664-47.606c7.296-1.956 13.732-5.904 18.74-11.216l521.486-521.484c1.126-0.904 2.222-1.87 3.268-2.914 1.042-1.044 2.006-2.138 2.91-3.264l107.75-107.748c0.836-0.71 1.668-1.432 2.458-2.224zM806.9 291.66l-73.592-73.202 56.61-56.61 73.594 73.2-56.612 56.612zM281.566 816.996l-73.4-73.4 468.572-468.568 73.594 73.202-468.766 468.766zM160.496 864.628l11.742-43.822 32.080 32.080-43.822 11.742z',
	  paintbrush: 'M946.58 293.66c12.704-12.708 15.072-31.836 7.108-46.938-1.838-3.524-4.23-6.83-7.19-9.79-0.282-0.282-0.588-0.52-0.876-0.792l-129.338-128.654c-0.046-0.046-0.084-0.098-0.13-0.144-7.814-7.812-18.056-11.718-28.296-11.714-10.24 0-20.48 3.906-28.292 11.714-0.064 0.066-0.12 0.138-0.184 0.206l-557.048 557.048c-2.194 2.192-4.042 4.59-5.622 7.11-70.624 87.486-17.922 195.43-174.738 239.554 0 0 64.758 18.11 144.33 18.11 74.374 0 161.678-15.824 221.23-77.020 0.394-0.364 0.808-0.696 1.192-1.078l1.734-1.734c0.852-0.798 1.678-1.578 2.504-2.426 0.348-0.356 0.668-0.728 1.010-1.086l168.756-168.756c1.126-0.906 2.224-1.872 3.272-2.918 1.044-1.044 2.008-2.14 2.914-3.266l375.212-375.212c0.834-0.706 1.664-1.424 2.452-2.214zM537.462 589.402l-73.594-73.206 324.068-324.064 73.594 73.2-324.068 324.070zM388.178 667.684c-13.288-13.632-28.584-23.974-44.78-31.016l63.902-63.902 73.596 73.204-64.246 64.248c-6.498-15.23-15.964-29.698-28.472-42.534zM229.848 791.928c8.294-30.346 14.852-54.332 32.416-73.862 0.83-0.864 2.664-2.702 4.26-4.286 8.030-6.792 17.534-8.246 24.198-8.246 14.386 0 29.026 6.554 40.162 17.98 19.592 20.106 21.934 49.238 5.596 66.874l-1.712 1.712c-0.798 0.752-1.612 1.524-2.462 2.354l-0.86 0.84-0.834 0.864c-30.666 31.79-75.914 45.424-118.104 50.542 7.53-18.888 12.598-37.426 17.34-54.772z',
	  close: 'M693.022 637.866c15.62 15.622 15.618 40.95 0 56.566-15.622 15.622-40.946 15.624-56.562 0.002l-124.46-124.458-124.456 124.458c-15.622 15.622-40.944 15.622-56.562 0-15.624-15.622-15.624-40.946-0.002-56.568l124.454-124.456-124.452-124.45c-15.622-15.622-15.622-40.946 0-56.564 15.62-15.624 40.944-15.624 56.568-0.002l124.45 124.45 124.454-124.452c15.622-15.62 40.95-15.62 56.566 0 15.622 15.62 15.624 40.944 0.002 56.56l-124.456 124.458 124.456 124.456zM828.784 828.784c-174.956 174.956-458.614 174.956-633.566 0-174.958-174.956-174.958-458.614 0-633.566 174.954-174.958 458.612-174.958 633.566 0 174.954 174.952 174.954 458.612 0 633.566zM880 511.998c-0.002-98.296-38.28-190.708-107.786-260.212s-161.92-107.786-260.214-107.788c-98.296 0.002-190.71 38.282-260.216 107.786-69.506 69.508-107.782 161.918-107.786 260.214 0.002 98.296 38.282 190.71 107.786 260.216 69.508 69.506 161.918 107.784 260.216 107.784 98.296 0 190.708-38.278 260.214-107.784s107.784-161.92 107.786-260.216z',
	  trash: 'M919.5 225.208h-215.5v-120.080c0-20.344-15.192-37.096-34.836-39.632-1.696-0.216-3.41-0.372-5.164-0.372h-304.004c-1.754 0-3.468 0.152-5.164 0.372-19.644 2.54-34.836 19.292-34.836 39.628v120.084h-215.996c-22.090 0-40 17.912-40 40.002 0 22.092 17.91 40 40 40h27.216l53.916 615.914h0.214c0 22.092 17.91 40 40 40h573.372c22.094 0 40-17.91 40-40h0.148l53.916-615.914h26.716c22.090 0 40-17.91 40-40s-17.908-40.002-39.998-40.002zM399.996 145.126h224.004v80.082h-224.004v-80.082zM762.062 881.124h-500.124l-50.414-575.912h600.954l-50.416 575.912zM632.004 697.124v-240c-0.004-22.092 17.906-40.002 40-40.002 22.090 0.002 40 17.908 40 40.002l-0.004 240.002c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40zM311.996 697.124v-240c-0.004-22.092 17.906-40.002 40-40.002 22.090 0.002 40 17.908 40 40.002l-0.004 240.002c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40zM472 697.124v-240c-0.004-22.092 17.906-40.002 40-40.002 22.090 0.002 40 17.908 40 40.002l-0.004 240.002c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40z',
	  cross: 'M1013.286 955.716l-443.72-443.716 443.718-443.718c15.622-15.622 15.62-40.948-0.004-56.566-15.618-15.622-40.942-15.622-56.562 0l-443.716 443.718-443.72-443.718c-15.62-15.624-40.946-15.622-56.566 0-15.622 15.62-15.622 40.944 0 56.566l443.722 443.718-443.722 443.722c-15.622 15.618-15.62 40.942 0 56.56s40.948 15.622 56.566 0l443.72-443.718 443.722 443.718c15.618 15.624 40.942 15.622 56.56 0 15.62-15.618 15.622-40.944 0.002-56.566z',
	  delete: 'M828.786 195.216c-174.958-174.956-458.612-174.958-633.568 0-174.954 174.954-174.956 458.612 0 633.566 174.954 174.956 458.614 174.956 633.568 0 174.954-174.954 174.952-458.612 0-633.566zM251.786 251.786c69.506-69.506 161.916-107.784 260.212-107.788 84.838 0 165.278 28.538 230.402 81.028l-517.372 517.374c-52.492-65.126-81.026-145.568-81.030-230.404 0.004-98.294 38.282-190.704 107.788-260.21zM772.214 772.214c-69.506 69.506-161.918 107.784-260.214 107.786-84.836-0.004-165.276-28.538-230.402-81.030l517.376-517.372c52.492 65.126 81.028 145.564 81.028 230.402-0.004 98.296-38.284 190.71-107.788 260.214z',
	  add: 'M512 144c98.296 0 190.708 38.28 260.214 107.784 69.506 69.508 107.786 161.922 107.786 260.216 0 98.296-38.28 190.708-107.786 260.214-69.508 69.506-161.918 107.786-260.214 107.786-98.294 0-190.708-38.28-260.216-107.786-69.504-69.508-107.784-161.918-107.784-260.214 0-98.294 38.28-190.708 107.784-260.216 69.508-69.504 161.922-107.784 260.216-107.784zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448v0zM729.002 473h-176.008v-176.008c0.002-22.090-17.906-39.994-39.996-39.994-22.088 0-39.998 17.908-39.998 39.998v176.004h-176c-22.094 0-40 17.908-39.998 40-0.002 22.090 17.904 39.996 39.996 39.996h176.002v176.004c0 22.094 17.908 40 40 39.998 22.090 0.002 39.996-17.904 39.996-39.996v-176.006l176.012-0.002c22.090 0.002 39.994-17.906 39.994-39.996-0.002-22.088-17.91-39.998-40-39.998z',
	  subtract: 'M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm3 83a366 366 0 0 0-368 368 366 366 0 0 0 368 368 366 366 0 0 0 369-368 366 366 0 0 0-369-368zM295 472h434a40 40 0 0 1 0 80H295a40 40 0 1 1 0-80z',
	  plus: 'M921.002 473h-368.008v-368.004c0.002-22.090-17.906-39.996-39.996-39.996-22.088 0-39.998 17.91-39.998 40v368h-368.002c-22.094 0-40 17.908-39.998 40-0.002 22.090 17.904 39.996 39.996 39.996l368.004-0.002v368.010c0 22.094 17.908 40 40 39.996 22.090 0.004 39.996-17.902 39.996-39.996v-368.010h368.010c22.090 0.002 39.994-17.906 39.994-39.996-0-22.088-17.908-39.998-39.998-39.998z',
	  document: 'M863.98 242.454c0.008-0.23-0.094-3.944-0.152-4.624-0.058-0.688-0.368-2.972-0.496-3.742-0.008-0.058-0.352-1.712-0.54-2.486-0.124-0.508-0.246-1.014-0.39-1.518-0.226-0.784-1.106-3.292-1.296-3.78-0.304-0.754-1.426-3.162-1.668-3.626-0.398-0.762-1.75-3.028-2.008-3.418-0.606-0.924-1.262-1.81-1.942-2.678-0.132-0.168-0.246-0.346-0.382-0.512-0.98-1.212-2.028-2.364-3.14-3.454l-104.020-104.9c-3.714-3.714-7.988-6.518-12.54-8.464-0.090-0.040-3.762-1.404-4.008-1.48-0.942-0.288-1.894-0.516-2.852-0.732-0.336-0.076-0.66-0.176-0.996-0.244-1-0.2-3.618-0.558-3.922-0.59-1.324-0.13-2.652-0.204-3.976-0.204h-519.652c-1.754 0-3.468 0.152-5.164 0.372-19.644 2.54-34.836 19.292-34.836 39.628v752c0 22.094 17.91 40 40 40h624c22.090 0 40-17.906 40-40l-0.020-645.548zM784 848h-544v-672l439.614 0.002v65.186c0 22.090 17.91 40 40 40h64.368l0.018 566.812zM664 336c22.090 0 40 17.908 40 40s-17.91 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304zM704 528c0 22.092-17.91 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304c22.090 0 40 17.908 40 40zM704 680c0 22.092-17.91 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304c22.090 0 40 17.908 40 40z',
	  folder: 'M571 274h327c23 0 41 18 41 41v488c0 22-18 40-41 40H126c-23 0-41-18-41-40V242c0-34 27-61 61-61h317c18 0 35 7 47 21l61 72zm-119-8H170v492h684V359H531l-79-93z',
	  component: 'M171 469h298V171H246c-42 0-75 33-75 75v223zm0 86v223c0 42 33 75 75 75h223V555H171zm682-86V246c0-42-33-75-75-75H555v298h298zm0 86H555v298h223c42 0 75-33 75-75V555zM256 85h512c94 0 171 77 171 171v512c0 94-77 171-171 171H256c-94 0-171-77-171-171V256c0-94 77-171 171-171z',
	  calendar: 'M920.036 160.030h-112.004v-72c0-22.092-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v72.004h-432v-72c0-22.092-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v72.004h-112.004c-1.38 0-2.746 0.070-4.090 0.208-20.168 2.046-35.91 19.080-35.91 39.792v688c0 22.090 17.91 40 40 40h816.008c22.098 0 40-17.91 40-40v-688c0-22.094-17.908-40-40-40zM356.032 848.026h-212.004v-142.662h212.004v142.662zM356.032 665.364h-212.004v-162.664h212.004v162.664zM356.032 462.7h-212.004v-142.662h212.004v142.662zM628.032 848.026h-232v-142.662h232v142.662zM628.032 665.364h-232v-162.664h232v162.664zM628.032 462.7h-232v-142.662h232v142.662zM880.036 848.026h-212.004v-142.662h212.004v142.662zM880.036 665.364h-212.004v-162.664h212.004v162.664zM880.036 462.7h-212.004v-142.662h212.004v142.662z',
	  graphline: 'M820.536 489.23c-15.624 15.618-40.954 15.618-56.57 0l-42.006-42.002-169.898 169.9c-7.822 7.82-18.076 11.722-28.326 11.712-10.248 0.008-20.496-3.894-28.314-11.712l-96.178-96.182-140.67 140.674c-15.624 15.622-40.954 15.618-56.57-0.004-15.624-15.618-15.624-40.946 0-56.566l168.946-168.946c7.812-7.816 18.058-11.72 28.3-11.716 10.238-0.002 20.476 3.904 28.29 11.716l96.204 96.204 168.91-168.91c0.33-0.356 0.626-0.73 0.972-1.076 7.824-7.824 18.084-11.726 28.34-11.712 10.252-0.012 20.508 3.892 28.332 11.714 0.346 0.346 0.64 0.72 0.972 1.074l69.266 69.266c15.62 15.618 15.616 40.942 0 56.566zM880 144h-736v736h736v-736zM920 64c22.092 0 40 17.908 40 40v816c0 22.092-17.908 40-40 40h-816c-22.092 0-40-17.908-40-40v-816c0-22.092 17.908-40 40-40h816z',
	  docchart: 'M919.938 128h-816.008c-1.38 0-2.746 0.070-4.090 0.208-20.168 2.046-35.91 19.080-35.91 39.792v688c0 22.090 17.91 40 40 40h816.008c22.098 0 40-17.91 40-40v-688c0-22.094-17.906-40-40-40zM395.934 470.67h232v162.664h-232v-162.664zM355.934 633.334h-212.004v-162.664h212.004v162.664zM395.934 430.67v-142.662h232v142.662h-232zM667.934 470.67h212.004v162.664h-212.004v-162.664zM667.934 430.67v-142.662h212.004v142.662h-212.004zM355.934 288.008v142.662h-212.004v-142.662h212.004zM143.93 673.334h212.004v142.662h-212.004v-142.662zM395.934 673.334h232v142.662h-232v-142.662zM667.934 673.334h212.004v142.662h-212.004v-142.662z',
	  doclist: 'M919.938 128h-816.008c-1.38 0-2.746 0.070-4.090 0.208-20.168 2.046-35.91 19.080-35.91 39.792v688c0 22.090 17.91 40 40 40h816.008c22.098 0 40-17.91 40-40v-688c-0-22.094-17.906-40-40-40zM143.93 288.008h736.008v527.988h-736.008v-527.988zM248 400.004c0-22.090 17.91-40 40-40h448c22.094 0 40 17.906 40 40 0 22.090-17.906 40-40 40h-448c-22.090 0-40-17.91-40-40zM776 552.002c0 22.094-17.906 40-40 40h-448c-22.090 0-40-17.906-40-40 0-22.090 17.91-40 40-40h448c22.094 0 40 17.91 40 40zM776 704c0 22.094-17.906 40-40 40h-448c-22.090 0-40-17.906-40-40 0-22.090 17.91-40 40-40h448c22.094 0 40 17.91 40 40z',
	  category: 'M925.224 256.37c-1.694-0.216-3.408-0.37-5.162-0.37h-816c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v624c0 22.094 17.91 40 40 40h816c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-624.004c0-20.342-15.19-37.096-34.838-39.632zM144.062 880v-544h736v544h-736zM896.11 180c0 11.044-8.954 20-20 20h-728.032c-11.046 0-20-8.956-20-20v0c0-11.046 8.954-20 20-20h728.032c11.046 0 20 8.954 20 20v0zM832.094 84c0 11.044-8.954 20-20 20h-600c-11.046 0-20-8.956-20-20v0c0-11.046 8.954-20 20-20h600c11.046 0 20 8.954 20 20v0z',
	  grid: 'M437.162 552.368c-1.694-0.216-3.408-0.37-5.162-0.37h-263.978c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v264.040c0 22.094 17.91 40 40 40h263.978c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-264.044c0-20.34-15.19-37.094-34.838-39.632zM208.022 816.038v-184.040h183.978v184.040h-183.978zM437.162 128.4c-1.694-0.216-3.408-0.37-5.162-0.37h-263.978c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v263.968c0 22.094 17.91 40 40 40h263.978c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-263.972c0-20.342-15.19-37.096-34.838-39.632zM208.022 392v-183.968h183.978v183.968h-183.978zM861.212 552.368c-1.694-0.216-3.408-0.37-5.162-0.37h-264.050c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v264.040c0 22.094 17.91 40 40 40h264.048c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-264.044c0.002-20.34-15.19-37.094-34.836-39.632zM632 816.038v-184.040h184.048v184.040h-184.048zM861.212 128.4c-1.694-0.216-3.408-0.37-5.162-0.37h-264.050c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v263.968c0 22.094 17.91 40 40 40h264.048c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-263.972c0.002-20.342-15.19-37.096-34.836-39.632zM632 392v-183.968h184.048v183.968h-184.048z',
	  copy: 'M960.132 210.186c0-0.444-0.050-0.874-0.066-1.312-0.024-0.684-0.044-1.366-0.104-2.046-0.060-0.74-0.158-1.468-0.26-2.198-0.080-0.564-0.156-1.128-0.258-1.692-0.146-0.792-0.328-1.566-0.518-2.34-0.124-0.508-0.244-1.014-0.39-1.518-0.224-0.784-0.488-1.548-0.76-2.312-0.176-0.49-0.344-0.98-0.538-1.466-0.302-0.754-0.642-1.486-0.988-2.216-0.224-0.472-0.436-0.946-0.68-1.41-0.398-0.762-0.838-1.496-1.284-2.228-0.242-0.396-0.466-0.798-0.722-1.19-0.608-0.924-1.262-1.81-1.942-2.678-0.132-0.168-0.248-0.346-0.382-0.512-0.98-1.212-2.028-2.364-3.14-3.454l-104.020-104.9c-3.714-3.714-7.988-6.518-12.542-8.464-0.088-0.040-0.174-0.084-0.262-0.122-0.994-0.418-2.006-0.774-3.024-1.108-0.242-0.080-0.474-0.176-0.72-0.252-0.942-0.288-1.894-0.516-2.854-0.732-0.334-0.076-0.658-0.176-0.996-0.244-0.998-0.2-2.004-0.336-3.010-0.458-0.306-0.038-0.606-0.1-0.912-0.13-1.322-0.13-2.65-0.204-3.976-0.204h-391.784c-1.754 0-3.468 0.152-5.162 0.372-19.646 2.538-34.838 19.29-34.838 39.628v145.516h-279.874c-1.754 0-3.468 0.152-5.162 0.372-19.646 2.538-34.838 19.29-34.838 39.628v628.28c0 22.094 17.91 40 40 40h496.118c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 2.084-3.466 2.128-3.548 2.992-5.612 4.704-12.010 4.704-18.808 0 0 0 0 0-0.004v-145.518h279.874c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 2.084-3.466 2.128-3.548 2.992-5.612 4.704-12.010 4.704-18.808 0 0 0 0 0-0.004v-521.828c0.008-0.23-0.016-0.458-0.014-0.688 0.002-0.202 0.028-0.39 0.028-0.584zM144.124 878.792v-548.278h311.752v65.186c0 22.090 17.91 40 40 40h64.366v443.092h-416.118zM640.244 693.278v-296.31c0.006-0.23-0.018-0.458-0.014-0.688 0.004-0.196 0.030-0.382 0.030-0.578 0-0.444-0.052-0.874-0.066-1.312-0.024-0.684-0.044-1.366-0.104-2.046-0.062-0.74-0.16-1.468-0.262-2.198-0.078-0.564-0.152-1.128-0.258-1.692-0.144-0.792-0.324-1.566-0.516-2.34-0.124-0.508-0.246-1.014-0.39-1.518-0.226-0.784-0.488-1.548-0.76-2.312-0.174-0.49-0.342-0.98-0.538-1.466-0.302-0.754-0.64-1.486-0.988-2.216-0.222-0.472-0.438-0.946-0.68-1.41-0.398-0.762-0.838-1.496-1.284-2.228-0.242-0.396-0.466-0.798-0.724-1.19-0.606-0.924-1.262-1.81-1.942-2.678-0.13-0.168-0.246-0.346-0.382-0.512-0.978-1.212-2.028-2.364-3.138-3.454l-104.020-104.9c-3.714-3.714-7.988-6.518-12.542-8.464-0.088-0.040-0.172-0.084-0.262-0.122-0.994-0.418-2.004-0.774-3.024-1.108-0.242-0.080-0.476-0.176-0.72-0.252-0.942-0.288-1.896-0.516-2.854-0.732-0.334-0.076-0.658-0.176-0.996-0.244-0.998-0.2-2.004-0.336-3.012-0.458-0.304-0.038-0.602-0.1-0.91-0.13-1.322-0.13-2.648-0.204-3.976-0.204h-31.916v-105.516h311.752v65.186c0 22.090 17.91 40 40 40h64.366v443.092h-239.87z',
	  certificate: 'M832.032 384.032c0-176.728-143.266-320-320-320s-320 143.272-320 320c0 104.662 50.25 197.584 127.938 255.966v311.5c0 16.174 9.74 30.756 24.682 36.952 4.954 2.052 10.152 3.050 15.31 3.050 10.402 0 20.626-4.060 28.276-11.702l123.726-123.58 123.772 123.332c11.452 11.412 28.644 14.804 43.574 8.608 14.93-6.2 24.66-20.776 24.66-36.942v-311.124c77.756-58.376 128.062-151.342 128.062-256.060zM272.032 384.032c0-64.106 24.964-124.374 70.292-169.706 45.33-45.33 105.6-70.294 169.708-70.294s124.376 24.964 169.708 70.294c45.33 45.332 70.292 105.6 70.292 169.706s-24.964 124.376-70.292 169.704c-45.33 45.33-105.6 70.294-169.708 70.294s-124.376-24.964-169.708-70.294c-45.328-45.328-70.292-105.598-70.292-169.704zM623.968 854.89l-83.804-83.508c-15.622-15.564-40.898-15.552-56.502 0.034l-83.694 83.594v-171.17c34.878 13.042 72.632 20.192 112.062 20.192 39.382 0 77.094-7.13 111.938-20.142v171z',
	  print: 'M925.922 304.496c-1.698-0.218-3.41-0.37-5.166-0.37h-88.64v-93.548c0.006-0.21-0.016-0.422-0.014-0.634 0.004-0.212 0.036-0.416 0.036-0.63 0-0.478-0.054-0.942-0.074-1.416-0.024-0.636-0.042-1.27-0.094-1.906-0.066-0.776-0.168-1.54-0.276-2.302-0.074-0.534-0.146-1.066-0.242-1.596-0.15-0.82-0.338-1.624-0.538-2.424-0.12-0.48-0.23-0.958-0.37-1.436-0.234-0.812-0.506-1.608-0.792-2.398-0.164-0.462-0.322-0.924-0.504-1.38-0.318-0.788-0.668-1.552-1.036-2.316-0.208-0.436-0.406-0.88-0.628-1.312-0.424-0.802-0.88-1.574-1.352-2.344-0.218-0.358-0.422-0.724-0.656-1.078-0.636-0.972-1.324-1.91-2.042-2.82-0.098-0.124-0.182-0.252-0.282-0.376-0.988-1.224-2.048-2.388-3.172-3.488l-104.004-104.882c-3.696-3.696-7.948-6.486-12.466-8.432-0.122-0.050-0.224-0.11-0.344-0.16-0.974-0.41-1.966-0.756-2.962-1.084-0.262-0.086-0.512-0.19-0.78-0.272-0.926-0.284-1.87-0.506-2.812-0.722-0.346-0.080-0.684-0.182-1.034-0.252-0.988-0.198-1.988-0.334-2.988-0.456-0.31-0.040-0.618-0.102-0.93-0.134-1.324-0.132-2.652-0.204-3.978-0.204h-455.67c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.29-34.838 39.63v200h-87.356c-1.754 0-3.468 0.152-5.164 0.37-19.644 2.538-34.836 19.29-34.836 39.63v320c0 22.094 17.91 40 40 40h87.368v216c0 22.094 17.91 40 40 40h560.006c13.81 0 25.982-6.996 33.17-17.636 0.102-0.146 0.184-0.306 0.282-0.458 0.612-0.922 1.2-1.86 1.722-2.836 0.046-0.082 0.080-0.17 0.124-0.254 2.994-5.612 4.704-12.008 4.704-18.808 0 0 0 0 0-0.004v-216h88.624c13.808 0 25.982-6.996 33.168-17.636 0.104-0.148 0.186-0.308 0.286-0.458 0.612-0.922 1.198-1.862 1.72-2.836 0.046-0.082 0.082-0.172 0.124-0.256 2.994-5.61 4.702-12.008 4.702-18.806 0 0 0 0 0-0.004v-320c0-20.344-15.186-37.096-34.834-39.636zM272.116 144.128h375.634v65.186c0 1.38 0.070 2.746 0.208 4.090 2.048 20.168 19.080 35.91 39.792 35.91h64.366v54.812h-480v-159.998zM272.124 880.126v-327.998h480.006v327.998zM880.756 384.128v239.998h-48.624v-111.998c0-20.34-15.19-37.092-34.836-39.63-1.694-0.218-565.17-0.372-565.17-0.372-1.754 0-3.468 0.152-5.162 0.372-19.646 2.538-34.838 19.29-34.838 39.628v112h-47.368v-239.998zM664.124 608.126c22.092 0 40 17.908 40 40s-17.908 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304zM704.124 784.126c0 22.092-17.908 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304c22.092 0 40 17.908 40 40z',
	  listunordered: 'M961 233c0 22.090-17.908 40-40 40h-607.996c-22.090 0-40-17.908-40-40v0c0-22.090 17.908-40.002 40-40.002h607.996c22.092 0 40 17.912 40 40.002v0zM961 793c0-22.090-17.908-40.002-40-40.002h-607.996c-22.092 0-40 17.912-40 40.002v0c0 22.092 17.91 40 40 40h607.996c22.092 0 40-17.91 40-40v0zM961 606.332c0-22.090-17.908-40-40-40h-607.996c-22.092 0-40 17.91-40 40v0c0 22.094 17.91 40 40 40h607.996c22.092 0 40-17.91 40-40v0zM961 419.668c0-22.090-17.908-40.004-40-40.004h-607.996c-22.092 0-40 17.914-40 40.004v0c0 22.090 17.91 40 40 40h607.996c22.092-0 40-17.91 40-40v0zM129 168.998c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zM129 728.998c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zM129 542.332c-35.346 0-64 28.652-64 64 0 35.344 28.654 64 64 64s64-28.656 64-64c0-35.348-28.654-64-64-64zM129 355.664c-35.346 0-64 28.656-64 64 0 35.348 28.654 64 64 64s64-28.652 64-64c0-35.344-28.654-64-64-64z',
	  graphbar: 'M324.832 513c22.090 0 40 17.91 40 40v304c0 22.090-17.906 40-40 40v0c-22.090 0-40-17.906-40-40v-304c0-22.090 17.91-40 40-40v0zM884.832 128.998c-22.090 0-40 17.906-40 40v688.002c0 22.094 17.91 40 40 40v0c22.094 0 40-17.91 40-40v-688.002c0-22.094-17.91-40-40-40v0zM698.164 256.998c-22.090 0-40 17.91-40 40v560.002c0 22.094 17.91 40 40 40v0c22.094 0 40-17.91 40-40v-560.002c0-22.090-17.91-40-40-40v0zM511.5 384.998c-22.090 0-40.004 17.91-40.004 40v432.002c0 22.094 17.914 40 40.004 40v0c22.090 0 40-17.91 40-40v-432.002c0-22.090-17.91-40-40-40v0zM139.168 641c-22.090 0-40 17.91-40 40v176c0 22.094 17.91 40 40 40v0c22.094 0 40-17.91 40-40v-176c0-22.090-17.91-40-40-40v0z',
	  menu: 'M960 232c0 22.092-17.908 40-40.002 40h-815.996c-22.092 0-40-17.908-40-40v0c0-22.090 17.908-40 40-40h815.998c22.092 0 40 17.91 40 40v0zM768 416c0 22.090-17.908 40-40 40h-624c-22.090 0-40-17.908-40-40v0c0-22.090 17.908-40.002 40-40.002h624c22.092 0.002 40 17.914 40 40.002v0zM832 608c0 22.092-17.906 40.002-40 40.002h-688c-22.090 0-40-17.91-40-40.002v0c0-22.090 17.908-40 40-40h688c22.094 0 40 17.912 40 40v0zM576 792c0 22.094-17.91 40-40.002 40h-431.998c-22.090 0-40-17.906-40-40v0c0-22.094 17.908-40.002 40-40.002h432c22.094 0.002 40 17.912 40 40.002v0z',
	  filter: 'M962.030 168.032c0 22.092-17.908 40-40.002 40h-815.996c-22.092 0-40-17.908-40-40v0c0-22.090 17.908-40 40-40h815.998c22.092 0 40 17.908 40 40v0zM770 544.034c0 22.090-17.908 40-40 40h-432c-22.090 0-40-17.908-40-40v0c0-22.090 17.908-40.002 40-40.002h432c22.090 0 40 17.912 40 40.002v0zM642.030 728.032c0 22.094-17.91 40-40.002 40h-175.998c-22.090 0-40-17.906-40-40v0c0-22.094 17.908-40.002 40-40.002h176c22.094 0.002 40 17.91 40 40.002v0zM866 352.030c0 22.092-17.906 40.002-40 40.002h-624c-22.090 0-40-17.91-40-40.002v0c0-22.090 17.908-40 40-40h624c22.092 0 40 17.91 40 40v0zM512.030 928.034c22.090 0 40.004-17.906 40.004-40v0c0-22.090-17.914-40-40.004-40v0c-22.090 0-40 17.91-40 40v0c0 22.092 17.91 40 40 40v0z',
	  ellipsis: 'M184 393c66.274 0 120 53.73 120 120s-53.726 120-120 120c-66.286 0-120-53.73-120-120s53.714-120 120-120zM512 393c66.272 0 120 53.73 120 120s-53.728 120-120 120c-66.286 0-120-53.73-120-120s53.714-120 120-120zM840 393c66.272 0 120 53.73 120 120s-53.728 120-120 120c-66.286 0-120-53.73-120-120s53.714-120 120-120z',
	  cog: 'M396.458 151.486l27.768 27.768c23.28 23.29 54.262 36.116 87.242 36.116 0.318 0 0.636 0 0.958-0.004 0.292 0.002 0.58 0.004 0.872 0.004 32.99 0 63.976-12.83 87.22-36.098l27.61-27.604c19.584 6.294 38.582 14.192 56.892 23.642v39.976c0 32.878 13.406 64.804 36.842 87.888 23.072 23.384 54.966 36.762 87.804 36.762l39.442 0.002c9.168 17.906 16.852 36.462 23.014 55.574l-27.676 27.676c-23.222 23.224-36.318 55.242-36.094 88.096-0.248 32.884 12.844 64.934 36.094 88.19l27.928 27.928c-6.298 19.704-14.212 38.812-23.704 57.23l-38.984 0.002c-0.008 0-0.012 0-0.022 0-32.84 0-64.74 13.38-87.814 36.776-23.43 23.080-36.83 55-36.83 87.876v39.116c-18.38 9.486-37.456 17.406-57.122 23.714l-27.348-27.346c-23.278-23.3-54.264-36.13-87.254-36.13-0.292 0-0.58 0.002-0.872 0.004-0.318-0.004-0.636-0.004-0.958-0.004-32.978 0-63.962 12.826-87.228 36.102l-27.552 27.554c-19.874-6.338-39.144-14.32-57.708-23.902l-0.002-38.13c0.012-32.854-13.368-64.764-36.772-87.846-23.082-23.43-55.004-36.834-87.878-36.834h-38.506c-9.776-18.846-17.898-38.42-24.328-58.624l27.49-27.49c23.246-23.248 36.338-55.296 36.088-88.182 0.224-32.854-12.872-64.872-36.092-88.094l-27.23-27.232c6.29-19.612 14.182-38.628 23.636-56.966h38.942c32.878 0 64.802-13.402 87.884-36.838 23.398-23.086 36.778-54.994 36.766-87.81l0.002-39.028c18.492-9.546 37.688-17.506 57.48-23.834zM421.486 60.208c-59.932 11.946-115.658 35.516-164.752 68.268l-0.004 85.866c0.004 11.676-4.886 22.194-12.706 29.68-7.486 7.83-18.012 12.728-29.702 12.728h-85.806c-32.624 48.946-56.132 104.484-68.088 164.204l60.39 60.394c8.256 8.256 12.234 19.15 11.998 29.968 0.246 10.83-3.734 21.738-11.998 30.004l-60.562 60.56c11.97 60.402 35.74 116.552 68.826 165.948h85.24c11.69 0 22.214 4.9 29.702 12.73 7.818 7.482 12.708 17.998 12.706 29.676l0.004 85.004c49.162 32.796 104.976 56.386 165.006 68.316l60.654-60.656c8.028-8.032 18.55-12.014 29.072-12.014 0.312 0 0.62 0.004 0.93 0.010 0.298-0.006 0.602-0.010 0.9-0.010 10.526 0 21.046 3.982 29.070 12.014l60.542 60.534c59.78-11.968 115.376-35.512 164.356-68.19v-85.956c0-11.69 4.9-22.214 12.73-29.702 7.486-7.818 18.002-12.708 29.678-12.706l85.876-0.004c32.668-49.032 56.182-104.674 68.104-164.504l-61.050-61.052c-8.266-8.266-12.244-19.174-12-30.004-0.236-10.818 3.742-21.712 12-29.968l60.882-60.888c-11.91-59.144-35.158-114.178-67.37-162.758l-86.444-0.004c-0.004 0-0.008 0-0.008 0-11.674 0-22.188-4.89-29.67-12.708-7.83-7.486-12.73-18.012-12.73-29.702v-86.816c-48.912-32.632-104.418-56.158-164.106-68.14l-60.792 60.784c-8.024 8.032-18.546 12.014-29.070 12.014-0.3 0-0.602-0.004-0.9-0.012-0.308 0.008-0.618 0.012-0.93 0.012-10.522 0-21.044-3.982-29.072-12.014l-60.906-60.906zM511.856 314.472c-109.014 0-197.386 88.372-197.386 197.384 0 109.010 88.374 197.382 197.386 197.382v0.134c0.746 0 1.492 0.012 2.24 0.004 14.806-0.16 29.214-1.942 43.056-5.182 1.022-0.238 1.932-0.496 2.794-0.762 17.328-4.988 29.94-21.012 29.738-39.916-0.242-22.71-18.846-40.926-41.556-40.686-2.996 0.032-5.902 0.402-8.708 1.042-0.090 0.016-0.178 0-0.266 0.022-8.18 1.99-16.708 3.096-25.472 3.224-0.586-0.074-1.19-0.124-1.826-0.124-63.486 0-115.142-51.65-115.142-115.138 0-63.49 51.656-115.142 115.142-115.142 63.488 0 115.14 51.652 115.14 115.142 0 8.924-1.028 17.616-2.964 25.958-0.020 0.090-0.008 0.178-0.020 0.268-0.61 2.812-0.948 5.724-0.948 8.72 0 22.71 18.408 41.122 41.122 41.122 18.906 0 34.792-12.778 39.596-30.158 0.262-0.866 0.508-1.78 0.736-2.804 3.092-13.876 4.722-28.3 4.722-43.106 0-109.012-88.372-197.384-197.384-197.384z',
	  wrench: 'M959.438 274.25c0-22.090-17.914-40-40.004-40-11.16 0-21.242 4.582-28.496 11.954l-60.152 60.148c-15.622 15.622-40.946 15.618-56.566-0.004l-56.57-56.566c-15.622-15.622-15.622-40.95 0-56.57l59.55-59.546c7.75-7.292 12.614-17.618 12.614-29.102 0-22.090-17.914-40-40.004-40-1.598 0-3.164 0.122-4.71 0.304-0.012 0-0.020-0.008-0.032-0.004-94.958 11.586-168.504 92.492-168.504 190.574 0 23.528 4.238 46.058 11.98 66.886l-503.078 503.074c-1.496 1.496-2.8 3.102-4.012 4.758-10.914 13.676-17.454 30.992-17.454 49.848 0 44.188 35.818 79.996 79.996 79.996 18.906 0 36.27-6.574 49.964-17.54 1.614-1.188 3.18-2.464 4.64-3.926l503.078-503.078c20.828 7.742 43.36 11.98 66.882 11.98 97.988 0 178.828-73.402 190.54-168.222v-0.012c0.2-1.628 0.338-3.272 0.338-4.952zM151.996 912c-22.090 0-40-17.906-40-40 0-22.090 17.91-40 40-40s40.004 17.91 40.004 40c0 22.094-17.914 40-40.004 40z',
	  nut: 'M512.034 144.030l318.696 184v368l-318.696 184-318.702-184v-368l318.702-184zM512.034 64.030c-13.812 0-27.624 3.574-40 10.718l-318.702 184c-24.752 14.29-40 40.7-40 69.282v368c0 28.582 15.248 54.994 40 69.28l318.702 184c12.376 7.146 26.19 10.72 40 10.72 13.814 0 27.624-3.572 40-10.72l318.696-184c24.752-14.288 40-40.698 40-69.28v-368c0-28.582-15.248-54.992-40-69.282l-318.696-184c-12.376-7.144-26.188-10.718-40-10.718v0zM511.63 314.25c-109.014 0-197.386 88.372-197.386 197.384 0 109.010 88.374 197.382 197.386 197.382v0.134c0.746 0 1.492 0.012 2.24 0.004 14.806-0.162 29.214-1.942 43.056-5.182 1.022-0.24 1.932-0.496 2.794-0.762 17.328-4.988 29.94-21.012 29.738-39.916-0.242-22.71-18.846-40.926-41.556-40.684-2.996 0.032-5.902 0.402-8.708 1.040-0.090 0.016-0.178 0-0.266 0.022-8.18 1.99-16.708 3.094-25.474 3.222-0.584-0.072-1.188-0.124-1.826-0.124-63.486 0-115.142-51.65-115.142-115.138 0-63.49 51.656-115.142 115.142-115.142 63.488 0 115.14 51.652 115.14 115.142 0 8.924-1.028 17.616-2.964 25.96-0.020 0.088-0.008 0.178-0.020 0.266-0.61 2.814-0.948 5.724-0.948 8.72 0 22.712 18.408 41.122 41.122 41.122 18.906 0 34.792-12.776 39.596-30.158 0.262-0.866 0.508-1.78 0.736-2.804 3.092-13.876 4.724-28.3 4.724-43.106 0-109.010-88.372-197.382-197.384-197.382z',
	  camera: 'M925.164 208.372c-1.694-0.218-3.408-0.372-5.162-0.372h-471.968v-39.962c0-20.344-15.192-37.096-34.836-39.63-1.696-0.218-3.41-0.374-5.164-0.374h-176.004c-1.754 0-3.468 0.152-5.164 0.374-19.644 2.538-34.836 19.29-34.836 39.626v39.966h-88.032c-1.754 0-3.468 0.152-5.162 0.372-19.646 2.536-34.838 19.29-34.838 39.628v528c0 22.094 17.91 40 40 40h816.004c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.46 0.612-0.922 1.2-1.86 1.722-2.836 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-528.004c-0-20.342-15.192-37.096-34.838-39.63zM880.002 736h-736.004v-448h736.004v448zM512 402.522c60.368 0 109.478 49.112 109.478 109.478s-49.112 109.478-109.478 109.478-109.478-49.112-109.478-109.478 49.11-109.478 109.478-109.478zM512 322.522c-104.644 0-189.478 84.832-189.478 189.478 0 104.644 84.834 189.478 189.478 189.478 104.646 0 189.478-84.834 189.478-189.478 0-104.646-84.832-189.478-189.478-189.478v0z',
	  eye: 'M1008.714 490.522c-9.002-12.594-223.276-308.808-496.684-308.808-273.444 0-487.682 296.214-496.684 308.808l-15.316 21.49 15.316 21.466c9.002 12.618 223.24 308.808 496.684 308.808 273.408 0 487.682-296.19 496.684-308.808l15.316-21.466-15.316-21.49zM807.68 631.688c-46 39.142-92.558 70.064-138.382 91.904-53.874 25.676-106.786 38.694-157.266 38.694-50.49 0-103.406-13.018-157.282-38.696-45.826-21.838-92.382-52.758-138.378-91.902-53.708-45.706-94.302-92.122-116.61-119.672 22.36-27.602 63.028-74.094 116.612-119.696 45.996-39.146 92.554-70.068 138.378-91.908 53.876-25.678 106.792-38.698 157.28-38.698 50.48 0 103.39 13.020 157.264 38.696 45.824 21.842 92.382 52.764 138.382 91.91 53.602 45.614 94.264 92.098 116.624 119.696-22.306 27.544-62.898 73.954-116.622 119.672zM692.032 512.036c0 99.41-80.588 180-180 180s-180-80.59-180-180c0-99.406 80.588-179.998 180-179.998s180 80.59 180 179.998z',
	  eyeclose: 'M75.744 948.314c-15.62-15.62-15.62-40.948 0-56.564l816-816c15.626-15.624 40.95-15.624 56.57 0 15.624 15.62 15.626 40.946 0.004 56.57l-816 815.994c-15.62 15.62-40.95 15.62-56.572 0zM332.032 512.034c0 20.104 3.296 39.434 9.376 57.484l228.104-228.106c-18.050-6.080-37.38-9.376-57.48-9.376-99.412-0.004-180 80.588-180 179.996zM692.032 512.034c0-20.1-3.3-39.432-9.38-57.484l-228.106 228.11c18.052 6.080 37.384 9.376 57.488 9.376 99.412 0 180-80.59 180-180zM1008.716 490.522c-4.98-6.968-72.86-100.8-178.81-183.22l-57.040 57.040c11.624 8.8 23.24 18.128 34.814 27.98 53.6 45.614 94.264 92.1 116.624 119.696-22.304 27.544-62.896 73.954-116.62 119.672-46 39.14-92.56 70.064-138.384 91.904-53.872 25.676-106.786 38.694-157.266 38.694-37.448 0-76.234-7.18-115.76-21.36l-61.486 61.49c54.786 24.22 114.45 39.87 177.248 39.87 273.41 0 487.684-296.19 496.686-308.808l15.316-21.468-15.316-21.49zM216.372 631.69c-53.708-45.706-94.3-92.12-116.61-119.672 22.36-27.6 63.028-74.094 116.612-119.696 46-39.146 92.554-70.068 138.38-91.908 53.874-25.68 106.79-38.7 157.28-38.7 37.46 0 76.264 7.188 115.8 21.38l61.484-61.484c-54.796-24.236-114.474-39.896-177.286-39.896-273.446 0-487.684 296.214-496.686 308.808l-15.316 21.49 15.314 21.466c4.98 6.984 72.866 100.84 178.84 183.26l57.040-57.040c-11.64-8.806-23.264-18.144-34.854-28.008z',
	  photo: 'M920 64h-816c-22.092 0-40 17.91-40 40v816c0 22.094 17.908 40 40 40h816c22.092 0 40-17.906 40-40v-816c0-22.090-17.908-40-40-40zM880 144v449.782l-235.39-235.392c-7.502-7.5-17.676-11.714-28.286-11.714s-20.784 4.214-28.286 11.716l-169.804 169.804-40.958-40.958c-15.622-15.622-40.95-15.622-56.57 0l-176.708 176.708v-519.946h736.002zM144 880v-102.914l204.992-204.994 215.972 215.974c7.81 7.81 18.048 11.714 28.286 11.714s20.474-3.904 28.286-11.714c15.62-15.622 15.62-40.95 0-56.57l-146.732-146.73 141.522-141.524 263.676 263.68v173.078h-736.002zM356.174 400.542c52.466 0 95-42.536 95-95s-42.534-95-95-95-95 42.536-95 95 42.534 95 95 95zM356.174 250.542c30.326 0 55 24.672 55 55s-24.674 55-55 55-55-24.672-55-55 24.674-55 55-55z',
	  video: 'M926.050 273.364c-9.556 0-20.574 3.8-32.278 11.812l-189.738 129.894v-151.068c0-20.342-15.192-37.094-34.838-39.63-1.694-0.218-3.408-0.372-5.162-0.372h-560.002c-1.754 0-3.468 0.152-5.162 0.372-19.646 2.538-34.838 19.29-34.838 39.628v496.002c0 22.092 17.91 40 40 40h560.004c13.808 0 25.98-6.998 33.168-17.638 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.922 1.2-1.862 1.722-2.836 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.612 4.704-12.010 4.704-18.81v-151.066l189.738 129.886c11.706 8.012 22.718 11.812 32.278 11.812 20.092 0 33.736-16.806 33.736-46.622v-384.032c0-29.816-13.644-46.62-33.738-46.62zM624.036 720h-480.004v-415.998h480.004v415.998zM879.788 632.3l-175.728-120.296 175.728-120.302v240.598zM240.688 663.534c-22.090 0-40-17.906-40-40v0c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v0c0 22.092-17.914 40-40.004 40v0z',
	  speaker: 'M692.070 580.856c18.156-18.156 28.152-42.266 28.152-67.89-0.008-25.622-10.002-49.726-28.148-67.872-8.476-8.478-18.308-15.188-29-19.922-0.222-0.098-0.408-0.22-0.566-0.364-13.294-6.5-22.476-20.116-22.476-35.914 0-22.090 17.91-40 40-40 5.774 0 11.246 1.248 16.204 3.45 0.016 0.006 0.026 0.008 0.040 0.016 19.292 8.656 37.036 20.832 52.368 36.164 33.254 33.254 51.574 77.446 51.58 124.43 0.006 46.996-18.31 91.204-51.58 124.472-15.064 15.062-32.45 27.074-51.344 35.7-0.154 0.070-0.286 0.112-0.434 0.176-5.124 2.382-10.812 3.75-16.832 3.75-22.090 0-40-17.906-40-40 0-16.196 9.644-30.112 23.488-36.402 0.156-0.11 0.32-0.216 0.516-0.304 10.314-4.712 19.81-11.268 28.032-19.49zM861.778 275.386c-47.824-47.824-107.946-79.588-173.204-92.242-0.356-0.078-0.712-0.146-1.072-0.214-0.060-0.012-0.124-0.026-0.186-0.038-0.506-0.096-0.976-0.162-1.422-0.208-1.918-0.282-3.868-0.476-5.864-0.476-22.090 0-40 17.91-40 40 0 19.024 13.292 34.91 31.084 38.968 0.352 0.128 0.728 0.244 1.162 0.326 48.7 9.268 95.226 32.748 132.934 70.452 99.972 99.972 100.054 261.984-0.002 362.040-37.684 37.684-84.152 61.14-132.788 70.426-0.084 0.016-0.144 0.046-0.224 0.066-18.338 3.644-32.166 19.816-32.166 39.222 0 22.094 17.91 40 40 40 2.776 0 5.484-0.286 8.102-0.822 0.094-0.018 0.172-0.018 0.27-0.038 65.32-12.626 125.496-44.406 173.376-92.286 131.008-131.008 131.008-344.172 0-475.176zM525.988 159.516v704.968c0 22.090-17.906 40-40 40-12.73 0-24.046-5.966-31.374-15.234l-51.056-61.722v0.216l-122.14-147.666h-177.386c-22.090 0-40-17.906-40-40v0 0-256c0-5.22 1.030-10.194 2.85-14.766 0.104-0.266 0.184-0.542 0.294-0.804 0.39-0.924 0.844-1.812 1.3-2.702 0.134-0.26 0.242-0.538 0.382-0.794 0.246-0.456 0.54-0.878 0.804-1.324 6.972-11.726 19.734-19.61 34.368-19.61h177.386l173.13-209.238c7.324-9.316 18.67-15.324 31.44-15.324 22.092-0 40.002 17.91 40.002 40zM445.988 270.826l-126.708 153.252h-175.248v176h175.248l19.832 23.998h0.17l106.708 129.112v-482.362z',
	  phone: 'M742.52 960c-76.266 0-163.184-32.364-258.338-96.194-73.798-49.504-136.41-106.904-175.938-146.34-43.282-43.222-105.612-111.376-156.842-190.682-66.576-103.062-95.348-196.038-85.518-276.344 8.952-73.326 50.674-134.292 120.664-176.304 10.95-6.63 23.76-10.134 37.054-10.134 32.752 0 71.124 23.354 120.764 73.494 36.434 36.802 70.108 79.22 89.472 106.644 46.698 66.176 60.686 107.352 48.286 142.136-12.638 35.538-35.534 55.704-52.25 70.428-5.662 5.006-9.95 8.854-13.070 12.262 4.040 7.542 11.744 19.868 26.054 37.476 42.388 52.076 90.548 89.024 111.972 100.874 3.308-2.96 7.11-7.168 12.352-13.152 14.87-16.81 35.062-39.636 70.482-52.28 7.978-2.842 16.498-4.276 25.35-4.276 44.172 0 108.804 44.078 155.246 81.056 45.834 36.494 103.292 90.498 127.104 132.612 22.602 39.596 14.982 68.64 4.596 86.006-48.138 80.296-119.862 122.718-207.44 122.718zM224.758 144.53c-47.558 29.426-73.566 67.28-79.468 115.618-7.494 61.224 17.17 136.326 73.308 223.226 49.902 77.252 112.994 144.35 146.16 177.472 30.296 30.222 91.906 88.17 163.988 136.524 81.738 54.83 153.662 82.63 213.772 82.63 58.618 0 103.506-26.526 137.138-81.076-0.47-1.536-1.532-4.062-3.854-8.132-14.584-25.794-57.006-69.202-105.642-108.156-58.776-47.074-96.708-63.894-106.756-64.982-15.348 5.826-25.020 16.758-36.178 29.372-12.542 14.318-28.31 32.316-55.476 41.528l-6.25 2.12h-6.598c-8.704 0-31.826 0-86.73-43.378-32.196-25.438-64.65-57.534-91.38-90.374-35.712-43.942-51.41-77.764-46.674-100.548l0.55-2.642 0.9-2.546c9.19-26 26.284-41.118 41.364-54.458 12.726-11.208 23.698-20.874 29.494-36.378-0.606-4.398-5.076-23.488-37.948-70.072-15.882-22.494-45.746-60.376-77.614-93.084-39.93-40.986-60.106-50.546-66.106-52.664z',
	  flag: 'M168 960.060c-22.092 0-40-17.908-40-40v-816.36c0-22.092 17.908-40 40-40h687.698c16.178 0 30.764 9.746 36.956 24.694 6.192 14.946 2.77 32.15-8.67 43.59l-188.918 188.922 189.218 189.216c11.44 11.442 14.862 28.646 8.67 43.592-6.192 14.948-20.776 24.694-36.956 24.694h-647.998v341.654c0 22.090-17.908 39.998-40 39.998zM208 498.406h551.428l-149.218-149.216c-15.622-15.622-15.622-40.95 0-56.568l148.918-148.922h-551.128v354.706z',
	  pin: 'M512 959.916c-13.36 0-25.84-6.672-33.262-17.782l-242.080-362.324c-0.12-0.176-0.236-0.356-0.354-0.536-36.394-54.5-55.63-118.042-55.63-183.804 0-182.696 148.632-331.324 331.326-331.324 182.696 0 331.328 148.628 331.328 331.324 0 60.71-16.554 119.98-47.906 171.652-0.758 1.528-1.618 3.016-2.578 4.45l-5.786 8.664c-0.054 0.082-0.112 0.164-0.168 0.246-0.042 0.070-0.104 0.16-0.148 0.23l-241.484 361.426c-7.422 11.106-19.898 17.778-33.258 17.778zM303.458 535.784l0.026 0.040c0.038 0.054 0.158 0.238 0.194 0.292l208.324 311.796 212.374-317.86c0.376-0.696 0.778-1.382 1.198-2.062 24.7-39.708 37.758-85.532 37.758-132.52 0-138.582-112.746-251.324-251.328-251.324s-251.326 112.742-251.326 251.324c0 50.054 14.674 98.39 42.432 139.782 0.114 0.176 0.232 0.356 0.348 0.532zM512 304.4c49.98 0 90.64 40.66 90.64 90.64 0 49.976-40.66 90.636-90.64 90.636s-90.64-40.66-90.64-90.636c0-49.98 40.66-90.64 90.64-90.64zM512 224.4c-94.242 0-170.64 76.398-170.64 170.64s76.398 170.636 170.64 170.636 170.64-76.394 170.64-170.636-76.398-170.64-170.64-170.64v0z',
	  compass: 'M960 512c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM251.786 772.214c-69.504-69.508-107.786-161.918-107.786-260.214 0-98.294 38.282-190.708 107.786-260.216 69.508-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214s-161.922 107.786-260.214 107.786c-98.296 0-190.708-38.28-260.214-107.786zM565.742 565.74c-0.93 0.93-1.95 1.768-3.050 2.498l-237.586 158.392c-7.934 5.29-18.496 4.242-25.238-2.498-6.738-6.742-7.786-17.304-2.496-25.236l158.39-237.588c1.464-2.2 3.348-4.082 5.546-5.546l237.586-158.392c7.934-5.29 18.496-4.242 25.238 2.498 6.742 6.742 7.79 17.304 2.5 25.238l-158.394 237.586c-0.73 1.1-1.566 2.118-2.496 3.048zM386.122 637.878l151.054-100.704-50.352-50.352-100.702 151.056z',
	  globe: 'M530.878 65.424c-6.748-1.014-13.090-1.424-18.878-1.424s-12.13 0.41-18.878 1.424c-238.662 9.9-429.122 206.48-429.122 447.576 0 247.424 200.578 448 448 448 247.426 0 448-200.576 448-448 0-241.098-190.456-437.678-429.122-447.576zM877.84 472.998h-158.508c-3.16-92.542-17.532-179.266-41.262-247.494-6.442-18.52-13.534-35.536-21.228-50.988 42.548 18.214 81.66 44.556 115.374 78.268 59.988 59.99 96.69 137.046 105.624 220.214zM512 880c-65.872 0-120.112-143.058-127.206-327h254.41c-7.092 183.942-61.332 327-127.204 327zM384.714 472.998c6.426-175.362 55.69-314.010 117.15-327.852 3.372-0.092 6.748-0.146 10.134-0.146s6.764 0.054 10.136 0.146c61.46 13.842 110.722 152.49 117.148 327.852h-254.568zM251.786 252.784c33.714-33.71 72.826-60.052 115.374-78.268-7.694 15.452-14.788 32.468-21.226 50.988-23.732 68.228-38.104 154.952-41.264 247.494h-158.508c8.934-83.168 45.636-160.224 105.624-220.214zM146.16 553h158.578c3.298 91.792 17.632 177.762 41.194 245.498 6.798 19.55 14.33 37.416 22.526 53.542-43.050-18.232-82.616-44.772-116.672-78.826-59.988-59.99-96.69-137.044-105.626-220.214zM772.214 773.214c-34.054 34.054-73.622 60.592-116.672 78.824 8.196-16.126 15.726-33.99 22.528-53.542 23.558-67.736 37.892-153.704 41.192-245.498h158.578c-8.934 83.172-45.634 160.226-105.626 220.216z',
	  location: 'M960.002 512l-0.002-0.026c-0.006-114.646-43.746-229.288-131.216-316.758-174.954-174.958-458.614-174.958-633.566 0-174.958 174.954-174.958 458.612 0 633.568 87.45 87.45 202.056 131.186 316.674 131.214 0.022 0 0.042 0.002 0.064 0.002 0.014 0 0.026-0.002 0.042-0.002 114.654 0 229.308-43.738 316.788-131.214 87.472-87.47 131.21-202.114 131.216-316.76l0-0.024zM772.216 772.214c-60 59.998-137.072 96.702-220.258 105.626v-133.84c0-22.090-17.914-40-40.004-40s-40 17.91-40 40v133.83c-83.154-8.942-160.194-45.64-220.172-105.618-59.986-59.988-96.686-137.042-105.624-220.21h133.84c22.090 0 40-17.914 40-40.004s-17.91-40-40-40h-133.84c8.936-83.17 45.636-160.226 105.624-220.214 59.978-59.976 137.020-96.676 220.172-105.622v133.836c0 22.094 17.91 40 40 40s40.004-17.906 40.004-40v-133.844c83.184 8.926 160.258 45.63 220.258 105.63 59.986 59.986 96.688 137.042 105.624 220.212h-133.838c-22.094 0-40 17.91-40 40s17.906 40.004 40 40.004h133.838c-8.938 83.172-45.636 160.226-105.624 220.214z',
	  search: 'M218 670a318 318 0 0 1 0-451 316 316 0 0 1 451 0 318 318 0 0 1 0 451 316 316 0 0 1-451 0m750 240L756 698a402 402 0 1 0-59 60l212 212c16 16 42 16 59 0 16-17 16-43 0-60',
	  zoom: 'M220 670a316 316 0 0 1 0-450 316 316 0 0 1 450 0 316 316 0 0 1 0 450 316 316 0 0 1-450 0zm749 240L757 698a402 402 0 1 0-59 59l212 212a42 42 0 0 0 59-59zM487 604a42 42 0 0 1-84 0V487H286a42 42 0 1 1 0-84h117V286a42 42 0 1 1 84 0v117h117a42 42 0 0 1 0 84H487v117z',
	  zoomout: 'M757 698a402 402 0 1 0-59 59l212 212a42 42 0 0 0 59-59L757 698zM126 445a316 316 0 0 1 319-319 316 316 0 0 1 318 319 316 316 0 0 1-318 318 316 316 0 0 1-319-318zm160 42a42 42 0 1 1 0-84h318a42 42 0 0 1 0 84H286z',
	  zoomreset: 'M148 560a318 318 0 0 0 522 110 316 316 0 0 0 0-450 316 316 0 0 0-450 0c-11 11-21 22-30 34v4h47c25 0 46 21 46 46s-21 45-46 45H90c-13 0-25-6-33-14-9-9-14-20-14-33V156c0-25 20-45 45-45s45 20 45 45v32l1 1a401 401 0 0 1 623 509l212 212a42 42 0 0 1-59 59L698 757A401 401 0 0 1 65 570a42 42 0 0 1 83-10z',
	  timer: 'M576 540.658c0 35.344-28.654 64-64 64s-64-28.656-64-64c0-20.27 9.432-38.324 24.134-50.050v-193.418c-0.004-22.092 17.906-40.002 40-40 22.090 0 40 17.906 40 40l-0.004 193.626c14.552 11.732 23.87 29.692 23.87 49.842zM928.32 543.934c0 229.79-186.28 416.066-416.068 416.066-229.786 0-416.064-186.278-416.064-416.066 0-216.26 164.998-393.958 375.97-414.134l0.188-49.794h-16.348c-22.092 0-40.002-17.91-39.998-40 0-22.090 17.906-40.004 40-40.004l112 0.002c22.090-0.002 39.998 17.91 40 40 0 22.090-17.908 40-40 39.998h-15.656l-0.19 49.782c77.246 7.352 148.33 35.812 207.422 79.564l41.854-41.856c15.622-15.622 40.95-15.618 56.57 0.002s15.622 40.948 0 56.568l-38.9 38.9c67.822 74.028 109.22 172.66 109.22 280.972zM848.32 543.934c0-89.768-34.958-174.16-98.432-237.634s-147.87-98.432-237.636-98.432c-89.766 0-174.158 34.958-237.632 98.432s-98.432 147.868-98.432 237.634c0 89.766 34.958 174.16 98.432 237.636 63.474 63.472 147.868 98.43 237.632 98.43 89.768 0 174.162-34.958 237.636-98.43 63.476-63.476 98.432-147.87 98.432-237.636z',
	  time: 'M512 64c-247.424 0-448 200.578-448 448.004 0 247.422 200.576 448 448 448s448-200.578 448-448c0-247.424-200.576-448.004-448-448.004zM772.214 772.22c-69.508 69.504-161.918 107.786-260.214 107.786s-190.708-38.282-260.214-107.786c-69.508-69.508-107.786-161.918-107.786-260.214s38.278-190.708 107.786-260.214c69.508-69.504 161.918-107.786 260.214-107.786s190.708 38.278 260.214 107.786c69.504 69.508 107.786 161.918 107.786 260.214s-38.282 190.706-107.786 260.214zM768.004 517.004c0 22.090-17.91 40-40 40h-216c-5.384 0-10.508-1.078-15.196-3.008-0.124-0.046-0.254-0.086-0.376-0.132-0.61-0.262-1.188-0.57-1.782-0.86-0.572-0.278-1.16-0.528-1.718-0.828-0.204-0.114-0.39-0.246-0.594-0.364-0.918-0.516-1.832-1.050-2.704-1.64-0.086-0.058-0.164-0.128-0.254-0.188-10.492-7.21-17.382-19.286-17.382-32.98v-285c0-22.094 17.91-40 40.004-40 22.088 0 40 17.906 40 40v244.996h175.996c22.094 0 40.002 17.916 40.006 40.004z',
	  lightning: 'M320.022 1022.644c-7.408 0-14.852-2.052-21.44-6.238-15.292-9.714-22.144-28.494-16.706-45.774l115.186-365.908-214.552-52.57c-14.714-3.606-26.128-15.214-29.486-29.988-3.356-14.772 1.92-30.174 13.632-39.786l576-472.662c14.458-11.864 35.208-12.126 49.962-0.626 14.752 11.496 19.568 31.682 11.594 48.602l-171.202 363.256 208.648 51.756c14.29 3.544 25.476 14.652 29.124 28.914s-0.834 29.376-11.668 39.344l-512 471.112c-7.586 6.984-17.308 10.568-27.092 10.568zM279.236 493.49l178.314 43.69c10.74 2.632 19.912 9.59 25.336 19.226s6.62 21.086 3.298 31.636l-83.030 263.76 347.066-319.352-183.82-45.596c-11.63-2.884-21.356-10.832-26.498-21.656-5.144-10.822-5.164-23.382-0.054-34.22l116.31-246.788-376.922 309.3z',
	  dashboard: 'M567.594 674.956c-17.674 30.61-56.816 41.098-87.426 23.426-30.61-17.676-41.1-56.816-23.426-87.426 10.134-17.554 27.33-28.472 45.928-31.278l146.974-254.57c11.042-19.132 35.506-25.688 54.64-14.64 19.13 11.046 25.688 35.508 14.64 54.64l-147.084 254.75c6.736 17.434 5.826 37.648-4.246 55.098zM512.002 209.26c-98.296 0-190.708 38.28-260.214 107.786s-107.786 161.92-107.786 260.214c0 81.428 26.252 158.786 74.768 222.452 88.404-30.49 188.406-46.448 292.732-46.448 104.662 0 204.926 16.046 293.524 46.716 48.65-63.712 74.976-141.164 74.976-222.72 0-98.294-38.28-190.708-107.786-260.214s-161.918-107.786-260.214-107.786zM512.002 129.26c247.424 0 448 200.578 448 448 0 124.132-50.494 236.468-132.054 317.602-87.096-38.574-196.984-61.598-316.446-61.598-119.146 0-228.772 22.902-315.758 61.296-81.376-81.114-131.742-193.324-131.742-317.3 0-247.422 200.576-448 448-448v0z',
	  hourglass: 'M511.926 801.946c-22.090 0-40-17.906-40-40v0c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v0c0 22.094-17.914 40-40.004 40v0zM831.682 915.242c0.192 1.582 0.318 3.186 0.318 4.82 0 22.090-17.908 40-40 40h-560c-22.092 0-40-17.914-40-40 0-2.438 0.252-4.812 0.67-7.128 2.36-53.636 18.034-105.7 45.852-151.554 0.734-1.476 1.562-2.912 2.492-4.296l5.582-8.364c0.054-0.080 0.11-0.158 0.164-0.238 0.042-0.068 0.098-0.156 0.144-0.222l157.704-236.036-158.5-237.228c-0.116-0.17-0.23-0.342-0.34-0.516-32.842-49.178-51.11-105.994-53.368-165.044-0.238-1.762-0.402-3.546-0.402-5.374 0-22.090 17.908-40 40-40h560c22.092 0 40 17.914 40 40 0 2.056-0.204 4.064-0.504 6.038-2.194 54.020-17.886 106.48-45.894 152.648-0.734 1.472-1.562 2.91-2.492 4.294l-5.582 8.366c-0.054 0.078-0.11 0.156-0.164 0.236-0.042 0.068-0.098 0.154-0.144 0.222l-157.734 236.082 158.468 237.182c0.116 0.168 0.23 0.344 0.34 0.516 32.946 49.33 51.226 106.346 53.39 165.596zM749.958 144.060h-475.99c6.138 31.304 18.384 61.124 36.354 87.916 0.118 0.17 0.23 0.344 0.342 0.514l0.024 0.038c0.036 0.054 0.15 0.23 0.186 0.284l54.286 81.25h293.596l58.196-87.1c0.366-0.67 0.75-1.334 1.154-1.99 15.492-24.916 26.228-52.324 31.852-80.912zM497.528 512.178l-0.032 0.046 14.426 21.592 93.378-139.756h-186.692l78.92 118.118zM305.96 799.156c-15.498 24.91-26.234 52.318-31.856 80.906h476.052c-6.138-31.304-18.384-61.122-36.354-87.918-0.118-0.168-0.23-0.344-0.342-0.512l-0.024-0.040c-0.036-0.050-0.15-0.23-0.186-0.282l-140.242-209.902-28.98 43.374c-7.166 10.72-19.21 17.162-32.11 17.162-12.896 0-24.942-6.442-32.11-17.166l-28.76-43.044-143.938 215.428c-0.36 0.674-0.744 1.338-1.15 1.994z',
	  play: 'M878.78 477.856l-591.884-341.722c-9.464-5.464-18.426-8.050-26.386-8.048-19.516 0.002-33.002 15.546-33.002 42.338v683.446c0 26.792 13.482 42.338 33.002 42.338 7.96 0 16.924-2.586 26.386-8.048l591.884-341.722c32.664-18.864 32.664-49.724 0-68.582z',
	  stop: 'M960 512a448 448 0 1 0-896 0 448 448 0 0 0 896 0zM252 772a366 366 0 0 1 0-520 366 366 0 0 1 520 0 366 366 0 0 1 0 520 366 366 0 0 1-520 0zm412-68H360c-22 0-40-18-40-40V360c0-22 18-40 40-40h304c22 0 40 18 40 40v304c0 22-18 40-40 40z',
	  email: 'M960.032 268.004c0.748-10.040-2.246-20.364-9.226-28.684-5.984-7.132-13.938-11.62-22.394-13.394-0.13-0.026-0.268-0.066-0.396-0.092-1.082-0.22-2.172-0.376-3.272-0.5-0.25-0.032-0.492-0.080-0.742-0.102-1.028-0.096-2.052-0.136-3.090-0.156-0.292-0.002-0.582-0.042-0.876-0.042h-816.008c-21.416 0-38.848 16.844-39.898 38-0.034 0.628-0.092 1.256-0.096 1.89 0 0.034-0.006 0.074-0.006 0.114 0 0.050 0.008 0.102 0.008 0.152v495.692c0 0.054-0.008 0.106-0.008 0.156 0 22.090 17.91 40 40 40h816.004c13.808 0 25.98-6.996 33.17-17.636 0.1-0.148 0.182-0.312 0.28-0.458 0.606-0.93 1.196-1.868 1.722-2.84 0.046-0.082 0.080-0.172 0.124-0.258 2.992-5.604 4.704-12.008 4.704-18.804v0 0-493.038zM144.032 350.156l339.946 281.188c6.568 6.434 14.918 10.168 23.564 11.122 0.16 0.024 0.32 0.050 0.48 0.066 0.838 0.082 1.676 0.114 2.518 0.14 0.496 0.020 0.994 0.058 1.492 0.058s0.996-0.042 1.492-0.058c0.842-0.028 1.68-0.058 2.518-0.14 0.16-0.016 0.32-0.042 0.48-0.066 8.646-0.958 16.996-4.688 23.564-11.122l339.946-281.206v370.894h-736v-370.876zM215.066 305.030h593.91l-296.946 245.422-296.964-245.422z',
	  comment: 'M288 378.668h448c22.094 0 40 17.906 40 40 0 22.090-17.906 40-40 40h-448c-22.090 0-40-17.91-40-40s17.91-40 40-40zM736 565.334h-448c-22.090 0-40 17.91-40 40 0 22.094 17.91 40 40 40h448c22.094 0 40-17.906 40-40 0-22.090-17.906-40-40-40zM960 232.004v560c0 6.804-1.714 13.196-4.704 18.812-0.042 0.082-0.078 0.172-0.124 0.254-0.524 0.976-1.11 1.914-1.722 2.836-0.098 0.152-0.18 0.314-0.282 0.458-7.188 10.64-19.36 17.636-33.168 17.636h-519.766l-114.292 114.286c-8.036 8.046-18.644 11.91-29.18 11.67-0.292 0.008-0.582 0.046-0.876 0.046-22.090 0-40-17.91-40-40v-86.004h-111.886c-22.090 0-40-17.906-40-40v0-560c0-20.34 15.192-37.094 34.84-39.632 1.692-0.214 3.406-0.368 5.16-0.368h816c1.754 0 3.468 0.154 5.164 0.368 19.644 2.542 34.836 19.296 34.836 39.638zM880 272h-736v480h736v-480z',
	  requestchange: 'M925.164 193.396c-1.696-0.214-3.41-0.368-5.164-0.368h-816c-1.754 0-3.468 0.152-5.16 0.368-19.648 2.54-34.84 19.292-34.84 39.632v560c0 22.094 17.91 40 40 40h111.886v86.004c0 22.090 17.91 40 40 40 0.292 0 0.582-0.040 0.876-0.046 10.536 0.238 21.144-3.624 29.18-11.67l114.292-114.286h519.766c13.808 0 25.98-6.996 33.168-17.636 0.102-0.144 0.184-0.304 0.282-0.458 0.614-0.922 1.2-1.86 1.722-2.836 0.046-0.082 0.082-0.172 0.124-0.254 2.988-5.618 4.704-12.008 4.704-18.812v0-560c-0-20.346-15.192-37.098-34.836-39.638zM880 753.028h-736v-480h736v480zM756.334 484.17l-125-125.436c-15.594-15.65-40.92-15.692-56.568-0.1-15.648 15.594-15.694 40.92-0.1 56.568l57.004 57.204h-335.67c-22.092 0-40 17.908-40 40s17.908 40 40 40h335.258l-56.508 56.368c-15.64 15.602-15.672 40.928-0.070 56.57 7.814 7.832 18.066 11.752 28.32 11.75 10.22 0 20.442-3.892 28.25-11.68l125-124.688c15.634-15.596 15.672-40.912 0.084-56.556z',
	  link: 'M743.52 529.234c5.616-5.616 83.048-83.046 88.462-88.46 30.944-32.778 47.97-75.636 47.97-120.792 0-47.048-18.304-91.26-51.542-124.484-33.228-33.22-77.43-51.516-124.458-51.516-45.024 0-87.792 16.94-120.536 47.72l-104.458 104.456c-30.792 32.738-47.734 75.512-47.734 120.548 0 41.916 14.576 81.544 41.248 113.196 3.264 3.876 6.666 7.664 10.292 11.29 4.258 4.258 8.704 8.262 13.304 12.022 0.054 0.080 0.096 0.152 0.148 0.232 9.572 7.308 15.778 18.804 15.778 31.776 0 22.094-17.914 40-40.004 40-8.542 0-16.442-2.696-22.938-7.26-2.746-1.93-20.622-17.43-30.35-28.050-0.008-0.010-0.018-0.018-0.026-0.028-4.992-5.432-13.234-15.23-18.552-22.65s-16.556-25.872-17.036-26.736c-0.7-1.262-2.974-5.526-3.422-6.39-0.69-1.334-6.118-12.67-6.114-12.67-14.342-31.96-22.332-67.4-22.332-104.728 0-60.826 21.198-116.648 56.58-160.544 0.252-0.314 4.61-5.594 6.594-7.866 0.304-0.35 5.038-5.636 7.16-7.874 0.252-0.268 105.86-105.874 106.128-106.126 45.902-43.584 107.958-70.314 176.264-70.314 141.382 0 255.998 114.5 255.998 256 0 68.516-26.882 130.688-70.652 176.61-0.144 0.148-109.854 109.546-112.090 111.528-0.958 0.848-5.072 4.352-5.072 4.352-6.448 5.434-13.132 10.592-20.1 15.378 0.412-6.836 0.644-13.702 0.644-20.6 0-26.46-3.108-52.206-8.918-76.918l-0.236-1.102zM616.144 767.82c35.382-43.896 56.58-99.718 56.58-160.544 0-37.328-7.99-72.768-22.332-104.728 0.004 0 0.006-0.002 0.010-0.004-0.258-0.576-0.538-1.14-0.8-1.714-0.686-1.498-2.894-6.112-3.296-6.93-0.668-1.344-2.952-5.732-3.386-6.604-3.48-6.982-8.708-15.126-9.49-16.366-0.498-0.792-0.996-1.58-1.502-2.364-0.834-1.29-15.364-22.066-26.656-34.466-0.008-0.010-0.018-0.018-0.026-0.028-7.056-8.448-24.932-24.198-30.35-28.050-6.47-4.602-14.396-7.26-22.938-7.26-22.090 0-40.004 17.906-40.004 40 0 12.97 6.206 24.466 15.778 31.776 0.052 0.080 0.094 0.152 0.148 0.232 4.602 3.76 20.334 19.434 23.598 23.31 26.672 31.65 41.248 71.28 41.248 113.196 0 45.038-16.944 87.81-47.734 120.548l-104.458 104.456c-32.742 30.782-75.512 47.72-120.536 47.72-47.028 0-91.228-18.294-124.458-51.516-33.236-33.224-51.542-77.436-51.542-124.484 0-45.154 17.028-88.014 47.97-120.792 5.414-5.414 40.812-40.812 68.958-68.958 7.176-7.176 13.888-13.886 19.504-19.502v-0.002c-0.356-1.562-0.246-1.096-0.246-1.096-5.81-24.712-8.918-50.458-8.918-76.918 0-6.898 0.232-13.764 0.644-20.6-6.966 4.788-20.1 15.33-20.1 15.33-0.734 0.62-9.518 8.388-11.68 10.45-0.16 0.154-105.338 105.33-105.482 105.478-43.77 45.922-70.652 108.094-70.652 176.61 0 141.5 114.616 256 255.998 256 68.306 0 130.362-26.73 176.264-70.314 0.27-0.254 105.876-105.86 106.128-106.126 0.004-0.002 13.506-15.426 13.758-15.74z',
	  paperclip: 'M824.25 369.354c68.146-70.452 67.478-182.784-2.094-252.354-70.296-70.296-184.266-70.296-254.558 0-0.014 0.012-0.028 0.026-0.042 0.042-0.004 0.002-0.006 0.004-0.010 0.008l-433.144 433.142c-0.036 0.036-0.074 0.068-0.11 0.106-0.054 0.052-0.106 0.11-0.16 0.162l-2.668 2.67c-0.286 0.286-0.528 0.596-0.8 0.888-43.028 44.88-66.664 103.616-66.664 165.986 0 64.106 24.962 124.376 70.292 169.704 45.328 45.33 105.598 70.292 169.706 70.292 50.612 0 98.822-15.57 139.186-44.428 4.932-1.952 9.556-4.906 13.544-8.894l16.802-16.802c0.056-0.056 0.116-0.112 0.172-0.168 0.038-0.038 0.074-0.076 0.112-0.116l289.010-289.014c15.622-15.618 15.62-40.942 0-56.56s-40.948-15.62-56.566 0l-289.124 289.122c-62.482 62.484-163.792 62.484-226.274 0-62.484-62.482-62.484-163.79 0-226.272h-0.002l433.134-433.12c0.058-0.060 0.112-0.122 0.172-0.18 38.99-38.99 102.43-38.99 141.42 0 38.992 38.99 38.99 102.432 0 141.422-0.058 0.060-0.122 0.114-0.18 0.17l0.006 0.006-280.536 280.534c-0.002-0.002-0.002-0.004-0.004-0.006l-79.978 79.98c-0.010 0.010-0.016 0.020-0.028 0.028-0.008 0.012-0.018 0.018-0.028 0.028l-0.064 0.062c-15.622 15.624-40.944 15.624-56.562 0-15.624-15.62-15.624-40.944-0.002-56.566l0.062-0.062c0.010-0.010 0.018-0.020 0.028-0.028 0.008-0.012 0.020-0.018 0.028-0.028l79.98-79.978c-0.002-0.002-0.004-0.002-0.006-0.004l136.508-136.512c15.622-15.62 15.62-40.944-0.002-56.562-15.618-15.62-40.946-15.62-56.564 0l-219.342 219.344c-1.284 1.284-2.42 2.652-3.494 4.052-40.4 47.148-38.316 118.184 6.322 162.824 44.64 44.638 115.674 46.722 162.82 6.324 1.402-1.072 2.772-2.21 4.054-3.494l2.83-2.832c0.002 0 0.002 0 0.002 0s0 0 0 0l360.54-360.54c0.058-0.056 0.12-0.114 0.18-0.172 0.050-0.050 0.098-0.106 0.15-0.158l0.994-0.994c0.34-0.338 0.63-0.702 0.952-1.052z',
	  box: 'M960.016 408.080c0-0.672-0.046-1.342-0.078-2.014-0.032-0.594-0.044-1.19-0.102-1.782-0.068-0.726-0.186-1.448-0.294-2.17-0.080-0.54-0.144-1.080-0.248-1.616-0.138-0.724-0.326-1.442-0.506-2.16-0.134-0.534-0.252-1.070-0.408-1.6-0.196-0.662-0.436-1.314-0.668-1.968-0.204-0.582-0.396-1.166-0.628-1.74-0.226-0.56-0.494-1.11-0.75-1.662-0.3-0.656-0.598-1.312-0.934-1.954-0.242-0.454-0.514-0.894-0.774-1.342-0.414-0.716-0.83-1.43-1.292-2.124-0.256-0.382-0.538-0.752-0.806-1.128-0.514-0.716-1.036-1.428-1.602-2.116-0.090-0.11-0.162-0.226-0.254-0.336-0.244-0.292-0.516-0.542-0.768-0.826-0.534-0.6-1.068-1.198-1.644-1.772-0.48-0.478-0.982-0.924-1.48-1.376-0.354-0.316-0.674-0.658-1.040-0.964l-405.788-335.666c-6.568-6.436-14.918-10.166-23.564-11.124-0.16-0.022-0.32-0.050-0.48-0.066-0.838-0.082-1.676-0.11-2.518-0.14-0.496-0.020-0.994-0.058-1.492-0.058s-0.996 0.040-1.492 0.058c-0.842 0.028-1.68 0.058-2.518 0.14-0.16 0.016-0.32 0.044-0.48 0.066-8.646 0.956-16.996 4.688-23.564 11.124l-405.662 335.542c-7.13 5.982-11.616 13.93-13.392 22.382-0.032 0.14-0.070 0.278-0.1 0.42-0.212 1.072-0.37 2.152-0.494 3.238-0.032 0.258-0.078 0.51-0.106 0.77-0.086 0.89-0.114 1.786-0.138 2.68-0.014 0.39-0.052 0.78-0.054 1.17 0 0.040-0.006 0.074-0.006 0.114v204.856c-0.958 12.434 3.854 25.128 14.134 33.754l405.662 335.54c6.568 6.438 14.918 10.168 23.564 11.124 0.16 0.020 0.32 0.050 0.48 0.066 0.838 0.082 1.676 0.114 2.518 0.14 0.496 0.020 0.994 0.058 1.492 0.058 0.054 0 0.11-0.008 0.162-0.008 0.042 0 0.084 0.008 0.126 0.008 0.342 0 0.672-0.042 1.012-0.050 0.062-0.004 0.126-0.008 0.192-0.008 0.134-0.004 0.27-0.020 0.402-0.024 10.602-0.422 20.136-4.938 27.054-12.046l404.526-334.624c0.084-0.066 0.166-0.136 0.248-0.204l0.12-0.098c0.17-0.144 0.314-0.304 0.48-0.45 0.814-0.704 1.614-1.43 2.37-2.2 0.296-0.3 0.562-0.624 0.85-0.934 0.602-0.652 1.2-1.308 1.756-2 0.3-0.372 0.566-0.758 0.852-1.136 0.504-0.672 1.002-1.344 1.462-2.046 0.242-0.368 0.458-0.75 0.686-1.124 0.458-0.754 0.908-1.508 1.316-2.292 0.164-0.312 0.304-0.636 0.46-0.954 0.426-0.872 0.832-1.746 1.196-2.652 0.092-0.23 0.168-0.464 0.256-0.696 0.376-0.996 0.728-2 1.026-3.032 0.042-0.148 0.074-0.296 0.114-0.442 0.306-1.102 0.578-2.218 0.79-3.356 0.016-0.082 0.024-0.164 0.038-0.246 0.212-1.184 0.382-2.378 0.49-3.598v0c0.1-1.156 0.176-2.32 0.176-3.5v-204.86c0.024-0.318 0.022-0.638 0.040-0.958 0.026-0.668 0.074-1.338 0.074-2.008zM143.89 493.202l328.14 271.42v103.902l-328.14-271.18v-104.142zM552.032 764.402l327.868-271.212v103.88l-327.868 270.972v-103.64zM511.898 122.66l345.348 285.42-345.348 285.42-345.374-285.42 345.374-285.42z',
	  structure: 'M954.324 833.3c0.208-0.558 0.388-1.128 0.586-1.692 0.3-0.868 0.608-1.734 0.882-2.61 0.234-0.746 0.444-1.5 0.66-2.25 0.212-0.734 0.432-1.464 0.624-2.204 0.204-0.766 0.378-1.54 0.562-2.308 0.18-0.766 0.366-1.528 0.528-2.292 0.146-0.692 0.272-1.386 0.402-2.082 0.168-0.89 0.332-1.778 0.476-2.668 0.090-0.566 0.164-1.136 0.244-1.704 0.148-1.058 0.29-2.118 0.404-3.18 0.042-0.422 0.080-0.852 0.12-1.274 0.118-1.23 0.212-2.46 0.282-3.696 0.018-0.304 0.030-0.606 0.042-0.906 0.062-1.36 0.098-2.718 0.104-4.082 0-0.114 0.008-0.226 0.008-0.34 0-0.128-0.010-0.258-0.010-0.39-0.006-1.368-0.042-2.734-0.104-4.102-0.014-0.296-0.030-0.594-0.044-0.89-0.070-1.246-0.166-2.492-0.284-3.738-0.042-0.434-0.084-0.864-0.128-1.292-0.116-1.050-0.25-2.098-0.4-3.144-0.088-0.628-0.18-1.258-0.282-1.882-0.13-0.8-0.276-1.598-0.428-2.394-0.162-0.868-0.332-1.73-0.518-2.594-0.116-0.524-0.24-1.046-0.364-1.57-0.264-1.128-0.542-2.25-0.846-3.36-0.070-0.254-0.144-0.504-0.214-0.754-11.38-40.382-48.464-69.996-92.488-69.996-3.066 0-6.096 0.16-9.088 0.442l-264.576-458.262c21.080-29.698 24.3-70.13 4.9-103.732-12.596-21.816-32.458-36.812-54.764-43.724-0.062-0.020-0.124-0.036-0.186-0.054-1.394-0.43-2.798-0.83-4.21-1.196-0.296-0.076-0.596-0.142-0.894-0.216-1.208-0.3-2.422-0.586-3.642-0.84-0.384-0.082-0.774-0.148-1.16-0.224-1.168-0.228-2.338-0.444-3.514-0.626-0.384-0.060-0.776-0.112-1.162-0.168-1.208-0.174-2.416-0.332-3.63-0.46-0.35-0.038-0.7-0.066-1.048-0.1-1.27-0.12-2.54-0.218-3.814-0.29-0.32-0.018-0.642-0.032-0.964-0.044-1.294-0.058-2.594-0.094-3.892-0.1-0.166 0-0.328-0.012-0.492-0.012-0.19 0-0.376 0.014-0.564 0.014-1.21 0.008-2.42 0.040-3.63 0.092-0.494 0.022-0.986 0.046-1.478 0.074-0.992 0.060-1.986 0.136-2.978 0.226-0.722 0.064-1.442 0.134-2.16 0.214-0.696 0.080-1.392 0.17-2.090 0.266-1.014 0.136-2.026 0.286-3.032 0.452-0.352 0.060-0.704 0.124-1.054 0.19-44.97 8.028-79.122 47.302-79.122 94.582 0 20.756 6.602 39.958 17.79 55.67l-264.58 458.26c-2.954-0.274-5.94-0.434-8.962-0.434-53.078 0-96.11 43.032-96.11 96.11 0 53.082 43.032 96.11 96.11 96.11 38.8 0 72.208-23.004 87.386-56.11l529.202-0.004c0.138 0.304 0.292 0.606 0.436 0.91 0.226 0.48 0.456 0.958 0.69 1.434 0.474 0.968 0.966 1.93 1.476 2.882 0.214 0.402 0.432 0.8 0.65 1.2 0.314 0.566 0.604 1.14 0.93 1.708 0.284 0.488 0.59 0.958 0.88 1.442 0.122 0.2 0.244 0.398 0.37 0.602 27.086 44.372 84.766 59.278 130.040 33.136 18.864-10.89 32.624-27.214 40.478-45.852 0.054-0.132 0.104-0.266 0.158-0.398 0.518-1.248 1.020-2.506 1.486-3.776zM238.414 744.282l264.542-458.204c0.424 0.042 0.85 0.064 1.276 0.098 0.668 0.056 1.334 0.112 2.004 0.152 0.652 0.040 1.306 0.066 1.96 0.092 1.122 0.046 2.244 0.076 3.368 0.084 0.146 0.002 0.292 0.012 0.438 0.012 0.168 0 0.334-0.012 0.502-0.014 1.436-0.004 2.874-0.040 4.31-0.108 0.088-0.006 0.176-0.010 0.262-0.014 1.376-0.070 2.75-0.168 4.124-0.296l264.596 458.298c-3.48 4.894-6.514 10.122-9.042 15.636h-529.226c-2.546-5.55-5.602-10.814-9.114-15.736z',
	  cpu: 'M392.016 672.016h240.032c22.092 0 40-17.908 40-40v-240.032c0-22.092-17.908-40-40-40h-240.032c-22.092 0-40 17.908-40 40v240.032c0 22.092 17.908 40 40 40zM432.016 431.984h160.032v160.032h-160.032v-160.032zM864.032 424h71.98c22.094 0 40.004-17.906 40.004-40 0-22.092-17.906-40-40-40h-71.984v-143.968c0-22.092-17.908-40-40-40h-144v-72.012c0-22.094-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v72.016h-176v-72.012c0-22.094-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v72.016h-144c-22.092 0-40 17.908-40 40v143.968h-71.984c-22.094 0-40 17.908-40 40s17.91 40 40 40h71.984v176h-71.984c-22.094 0-40 17.908-40 40s17.91 40 40 40h71.984v144.030c0 22.092 17.908 40 40 40h144v71.954c0 22.094 17.906 40 40 40s40-17.91 40-40v-71.954h176v71.954c0 22.094 17.906 40 40 40s40-17.91 40-40v-71.954h144c22.092 0 40-17.908 40-40v-144.030h71.98c22.094 0 40.004-17.906 40.004-40 0-22.092-17.906-40-40-40h-71.984v-176zM784.032 784.032h-143.692c-0.104 0-0.204-0.016-0.308-0.016s-0.206 0.016-0.308 0.016h-127.382c-0.104 0-0.204-0.016-0.308-0.016s-0.206 0.016-0.308 0.016h-127.382c-0.104 0-0.204-0.016-0.308-0.016s-0.206 0.016-0.308 0.016h-143.696v-544h544v544z',
	  memory: 'M320.032 416.032v-152.968c0-22.094 17.91-40 40-40 22.094 0 40 17.91 40 40.004v152.964c0 22.090-17.906 40-40 40s-40-17.908-40-40zM512 456.032c22.094 0 40-17.91 40-40v-152.964c0-22.094-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v152.968c0 22.092 17.908 40 40 40zM664.032 456.032c22.094 0 40-17.91 40-40v-82.996c0-22.094-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v83c0 22.092 17.906 40 40 40zM864.018 316.616v603.418c0 0.004 0 0.004 0 0.004 0 6.798-1.71 13.198-4.704 18.808-0.044 0.084-0.078 0.172-0.124 0.254-0.524 0.976-1.112 1.914-1.722 2.836-0.098 0.15-0.18 0.312-0.282 0.46-7.188 10.638-19.36 17.634-33.168 17.634h-623.99c-22.090 0-40-17.908-40-40v-343.574c-0.002-0.142-0.022-0.282-0.022-0.426 0-0.142 0.020-0.282 0.022-0.426v-471.574c0-20.34 15.192-37.092 34.838-39.63 1.694-0.216 3.408-0.37 5.162-0.37l411.254 0.052c10.594-0.286 21.282 3.58 29.368 11.668l211.672 212.206c7.906 7.908 11.792 18.298 11.696 28.66zM240.026 144.034v391.998h543.99v-203.27l-188.252-188.728h-355.738zM784.016 880.032v-264h-543.99v264h543.99z',
	  database: 'M895.95 221.364c-3.414-87.32-173.972-157.672-383.918-157.672s-380.504 70.352-383.918 157.672h-0.082v578.328c0 88.552 171.918 160.338 384 160.338s384-71.786 384-160.338v-578.328h-0.082zM798.412 430.578c-15.6 11.386-37.69 22.346-63.882 31.696-60.984 21.77-140.002 33.758-222.498 33.758s-161.514-11.988-222.498-33.758c-26.192-9.348-48.282-20.308-63.88-31.696-8.706-6.352-13.646-11.608-16.122-14.874v-92.9c70.29 37.478 179.654 61.566 302.5 61.566s232.21-24.088 302.5-61.566v92.9c-2.476 3.266-7.416 8.522-16.12 14.874zM814.532 514.464v93.24c-2.474 3.266-7.416 8.522-16.12 14.874-15.6 11.386-37.69 22.346-63.882 31.696-60.984 21.77-140.002 33.758-222.498 33.758s-161.514-11.988-222.498-33.758c-26.192-9.348-48.282-20.308-63.88-31.696-8.706-6.352-13.646-11.608-16.122-14.874v-93.24c70.29 37.48 179.654 61.566 302.5 61.566s232.21-24.086 302.5-61.566zM225.652 209.146c15.6-11.386 37.69-22.346 63.88-31.696 60.984-21.77 140.002-33.758 222.498-33.758s161.514 11.988 222.498 33.758c26.192 9.348 48.282 20.308 63.882 31.696 8.704 6.352 13.646 11.608 16.12 14.874v0.026c-2.474 3.266-7.416 8.522-16.12 14.874-15.6 11.386-37.69 22.346-63.882 31.696-60.984 21.77-140.002 33.758-222.498 33.758s-161.514-11.988-222.498-33.758c-26.192-9.348-48.282-20.308-63.88-31.696-8.706-6.352-13.646-11.608-16.122-14.874v-0.026c2.476-3.268 7.418-8.524 16.122-14.874zM798.412 814.578c-15.6 11.386-37.69 22.346-63.882 31.696-60.984 21.77-140.002 33.758-222.498 33.758s-161.514-11.988-222.498-33.758c-26.192-9.348-48.282-20.308-63.88-31.696-8.714-6.36-13.66-11.62-16.13-14.886h0.010v-93.228c70.29 37.48 179.654 61.566 302.5 61.566s232.21-24.086 302.5-61.566v93.228h0.010c-2.474 3.266-7.42 8.526-16.132 14.886z',
	  power: 'M472 473.188v-368c-0.004-22.092 17.906-40.002 40-40 22.090 0 40 17.906 40 40l-0.004 368.002c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40zM746.804 201.726v0.188c-13.138-9.004-26.808-17.292-40.978-24.768-1.994-1.050-3.492-1.84-4.668-2.458-1.75-0.892-3.518-1.756-5.28-2.624-0.004-0.002-0.008-0.004-0.012-0.006-0.080-0.032-0.158-0.074-0.234-0.108-0.032-0.012-0.056-0.024-0.090-0.042l-0.006 0.008c-4.724-2.022-9.924-3.168-15.386-3.212-22.090-0.178-40.14 17.588-40.32 39.678-0.122 15.112 8.166 28.298 20.47 35.208 31.9 15.71 61.418 36.616 87.492 62.292 2.796 2.754 5.52 5.562 8.208 8.394v-0.146c59.436 62.664 92.062 144.352 92.062 231.056 0 89.748-34.95 174.124-98.412 237.588s-147.84 98.412-237.588 98.412-174.124-34.95-237.588-98.412-98.412-147.84-98.412-237.588c0-81.652 28.962-158.834 81.972-219.886 5.814-6.69 11.902-13.192 18.288-19.474 26.064-25.652 55.564-46.538 87.446-62.238 12.342-6.892 20.66-20.106 20.542-35.238-0.17-22.088-18.218-39.86-40.306-39.69-5.468 0.044-10.664 1.186-15.392 3.208l-0.004-0.008c-0.036 0.016-0.058 0.028-0.088 0.042-0.042 0.018-0.084 0.038-0.126 0.056-1.862 0.918-3.728 1.828-5.574 2.774-0.458 0.238-0.948 0.496-1.512 0.792-1.096 0.566-2.18 1.148-3.27 1.722-15.704 8.294-30.804 17.572-45.232 27.736v-0.124c-106.896 75.288-176.742 199.646-176.742 340.33 0 229.75 186.25 416 416 416s416-186.25 416-416c-0.002-142.654-71.82-268.52-181.26-343.462z',
	  outbox: 'M960.062 616v304c0 1.382-0.070 2.746-0.208 4.090-2.046 20.172-19.080 35.91-39.792 35.91h-816c-22.090 0-40-17.906-40-40v-304c0-22.090 17.91-40 40-40s40 17.91 40 40v264h736v-264c0-22.090 17.91-40 40-40s40 17.912 40 40zM664.732 200.168l-124.41-124.41c-0.014-0.014-0.024-0.028-0.038-0.042-3.57-3.57-7.664-6.284-12.018-8.222-5.316-2.368-11.028-3.54-16.742-3.47-0.14-0.002-0.276-0.020-0.414-0.020-13.552 0-25.512 6.756-32.748 17.072l-119.1 119.092c-15.622 15.62-15.618 40.948 0.002 56.57 15.622 15.62 40.95 15.62 56.568 0l55.276-55.276v462.54c0 22.094 17.912 40 40.002 40 22.092 0 40-17.91 40-40v-464.314l57.052 57.052c15.622 15.624 40.948 15.62 56.568 0 15.628-15.624 15.628-40.952 0.002-56.572z',
	  share: 'M896.006 920c0 22.090-17.91 40-40 40h-688.006c-22.090 0-40-17.906-40-40v-549.922c-0.838-3.224-1.33-6.588-1.33-10.072 0-22.090 17.908-40.004 40-40.004h178.66c22.092 0.004 40 17.914 40 40.004 0 22.088-17.908 40-40 40h-137.33v479.996h607.998v-479.996h-138.658c-22.090 0-40-17.912-40-40 0-22.090 17.906-40.004 40-40.004h178.658c22.090 0 40 17.91 40 40v559.844c0 0.050 0.008 0.102 0.008 0.154zM665.622 200.168l-124.452-124.45c-8.042-8.042-18.65-11.912-29.186-11.674-1.612-0.034-3.222 0-4.828 0.16-0.558 0.054-1.098 0.16-1.648 0.238-0.742 0.104-1.484 0.192-2.218 0.338-0.656 0.13-1.29 0.31-1.934 0.472-0.622 0.154-1.244 0.292-1.86 0.476-0.64 0.196-1.258 0.436-1.886 0.66-0.602 0.216-1.208 0.414-1.802 0.66-0.598 0.248-1.17 0.54-1.754 0.814-0.598 0.282-1.202 0.546-1.788 0.86-0.578 0.312-1.13 0.664-1.694 1-0.552 0.332-1.116 0.644-1.654 1.006-0.67 0.448-1.3 0.942-1.942 1.426-0.394 0.302-0.806 0.576-1.196 0.894-1.046 0.858-2.052 1.768-3.008 2.726l-124.398 124.39c-15.622 15.62-15.618 40.948 0.002 56.57 15.622 15.62 40.95 15.62 56.568 0l56.164-56.166v439.426c0 22.094 17.912 40 40.002 40 22.092 0 40-17.91 40-40v-441.202l57.942 57.942c15.622 15.624 40.948 15.62 56.568 0 15.626-15.618 15.626-40.946 0.002-56.566z',
	  button: 'M644.634 802.32c-4.558 5.434-10.254 9.328-16.446 11.672l0.008 0.024-45.628 16.606 27.54 75.66c7.554 20.756-3.148 43.71-23.906 51.266s-43.714-3.146-51.27-23.906l-27.54-75.656-47.63 17.29c-6.020 1.956-12.586 2.518-19.254 1.342-21.75-3.836-36.282-24.582-32.45-46.34l30.57-173.328c2.55-14.476 12.61-25.714 25.458-30.508 0.292-0.118 0.586-0.23 0.878-0.34 0.238-0.084 0.476-0.168 0.718-0.246 12.942-4.624 27.91-2.492 39.196 6.98l134.824 113.13c16.932 14.2 19.144 39.432 4.932 56.354zM960.002 664v-368.082c0-22.092-17.908-40-40-40h-816c-22.092 0-40 17.908-40 40l-0.292 368.238c0 22.092 17.908 40 40 40h240.292c22.092 0 40-17.908 40-40s-17.908-40-40-40h-200.292l0.292-288.238h736v288.082h-200c-22.092 0-40 17.908-40 40s17.908 40 40 40h240c22.092 0 40-17.908 40-40z',
	  form: 'M948.362 178.828l-471.082 470.086c-0.24 0.25-0.45 0.52-0.698 0.77-7.82 7.82-18.070 11.722-28.32 11.712-10.25 0.010-20.504-3.892-28.324-11.712-0.262-0.262-0.48-0.546-0.734-0.812l-221.736-221.738c-15.624-15.622-15.624-40.95 0-56.566 15.618-15.622 40.946-15.624 56.57 0l194.224 194.222 443.53-442.528c15.622-15.618 40.95-15.618 56.57 0 15.62 15.62 15.62 40.946 0 56.566zM98.372 128.448c-18.926 0-34.266 15.342-34.266 34.268v699.032c0 18.926 15.34 34.266 34.266 34.266h699.032c18.926 0 34.266-15.34 34.266-34.266v-430.588c0 0 0.002-1.184 0.002-1.788 0-22.090-17.914-40-40.004-40s-40 17.91-40 40c0 0.288 0.002 386.64 0.002 386.64h-607.562v-607.564h600.002c22.090-0.002 40.002-17.906 40.002-40 0-22.090-17.914-40-40.004-40z',
	  check: 'M948.598 199.75c-15.622-15.618-40.95-15.618-56.57 0l-535.644 535.644-224.060-224.062c-15.624-15.624-40.954-15.62-56.57 0-15.624 15.62-15.624 40.948 0 56.568l251.574 251.574c0.252 0.266 0.472 0.55 0.734 0.812 7.82 7.82 18.072 11.724 28.322 11.714 10.25 0.010 20.502-3.894 28.322-11.714 0.248-0.248 0.456-0.518 0.698-0.77l563.196-563.202c15.618-15.618 15.618-40.94-0.002-56.564z',
	  batchaccept: 'M684 277L271 772l-1 1a40 40 0 0 1-56 5l-1-1L14 610a40 40 0 1 1 52-61l169 142 387-465a40 40 0 0 1 62 51zm340 234c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zm0-216c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zm0 432c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40z',
	  batchdeny: 'M1024 512c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zm0-216c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zm0 432c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zM625 236c16 15 16 41 0 56L406 512l220 220a40 40 0 1 1-57 57L349 568 129 788a40 40 0 1 1-57-56l220-220L73 292a40 40 0 0 1 56-57l220 220 219-219c16-16 41-16 57 0z',
	  home: 'M948.12 483.624l-407.814-407.754c-7.812-7.808-18.046-11.712-28.282-11.712-10.238 0-20.472 3.904-28.282 11.712l-407.92 407.86c-15.624 15.622-15.624 40.948-0.006 56.57s40.944 15.622 56.568 0.004l19.616-19.612v366.708c0 22.090 17.91 40 40 40h190.696c0.416 0.014 0.82 0.062 1.238 0.062 11.054 0 21.060-4.484 28.3-11.734 7.266-7.244 11.766-17.262 11.766-28.332 0-0.418-0.050-0.822-0.062-1.238v-263.204h176.060v263.934c0 22.090 17.91 40 40 40l191.876 0.124c2.292 0 4.524-0.236 6.708-0.608 0.45-0.074 0.91-0.116 1.356-0.206 0.21-0.044 0.414-0.116 0.628-0.162 17.906-3.972 31.308-19.924 31.308-39.026v-366.492l19.682 19.68c15.622 15.62 40.948 15.616 56.568-0.006s15.618-40.948-0.004-56.568zM791.876 448.272v398.71l-111.874-0.074v-263.876c0-0.020-0.002-0.042-0.002-0.062 0-0.006 0-0.014 0-0.022 0-22.090-17.91-40-40-40h-254.002c-0.556 0-1.1 0.060-1.65 0.084-0.14-0.002-0.274-0.022-0.414-0.022-22.090 0-40 17.91-40 40v264.382h-111.934v-399.392c0-2.286-0.234-4.512-0.604-6.694l280.626-280.584 280.514 280.472c-0.412 2.302-0.66 4.658-0.66 7.078z',
	  admin: 'M919.596 847.534h-88.414v-467.716l88.75-0.044c13.688-0.132 26.958-7.25 34.294-19.96 11.044-19.13 4.49-43.596-14.642-54.64l-407.904-235.676c-0.44-0.254-0.894-0.45-1.34-0.684-0.542-0.29-1.084-0.578-1.638-0.84-0.696-0.328-1.4-0.62-2.108-0.904-0.478-0.194-0.954-0.388-1.44-0.56-0.78-0.282-1.564-0.524-2.352-0.754-0.442-0.126-0.878-0.256-1.324-0.37-0.808-0.206-1.618-0.376-2.43-0.528-0.468-0.088-0.934-0.174-1.404-0.246-0.768-0.116-1.534-0.204-2.302-0.274-0.554-0.052-1.108-0.096-1.664-0.124-0.672-0.034-1.34-0.044-2.012-0.044-0.67 0-1.338 0.012-2.010 0.044-0.556 0.030-1.11 0.072-1.664 0.124-0.77 0.070-1.536 0.158-2.302 0.274-0.468 0.072-0.938 0.158-1.402 0.246-0.814 0.152-1.624 0.322-2.432 0.528-0.444 0.114-0.882 0.242-1.322 0.37-0.79 0.23-1.574 0.472-2.356 0.754-0.484 0.172-0.958 0.368-1.438 0.56-0.708 0.286-1.41 0.576-2.11 0.904-0.554 0.262-1.094 0.55-1.636 0.84-0.446 0.234-0.9 0.43-1.34 0.684l-407.906 235.672c-19.128 11.044-25.686 35.51-14.64 54.64 7.34 12.71 20.606 19.828 34.292 19.96v0.044h89.842v467.716h-89.474c-22.090 0-40 17.91-40 40s17.91 40 40 40h128.276c0.402 0.012 0.794 0.060 1.2 0.060s0.796-0.048 1.2-0.060h183.602c0.402 0.012 0.794 0.060 1.2 0.060s0.796-0.048 1.2-0.060h183.602c0.402 0.012 0.794 0.060 1.2 0.060s0.796-0.048 1.2-0.060h313.154c22.098 0 40-17.91 40-40-0.006-22.090-17.914-39.996-40.006-39.996zM751.182 847.534h-105.94v-467.716h105.94v467.716zM252.93 299.816l258.736-149.486 258.738 149.486h-517.474zM565.242 379.816v467.716h-106v-467.716h106zM273.242 379.816h106v467.716h-106v-467.716z',
	  paragraph: 'M728.032 96.032h-116.98c-0.026 0-0.050-0.004-0.076-0.004s-0.050 0.004-0.076 0.004h-199.848c-0.026 0-0.050-0.004-0.076-0.004s-0.050 0.004-0.076 0.004h-31.924c-123.712 0-224 100.292-224 224 0 121.032 95.994 219.628 216 223.842v344.158c0 22.092 17.91 40 40 40 22.086 0 40-17.908 40-40v-712h120v712c0 22.092 17.91 40 40 40 22.086 0 40-17.908 40-40v-712h77.056c22.094 0 40-17.91 40-40 0-22.092-17.91-40-40-40z',
	
	  basket: 'M632.254 695.604v-112.016c-0.004-22.092 17.906-40.002 40-40.002 22.090 0.002 40 17.908 40 40.002l-0.004 112.018c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.904-40-40zM352.246 735.604c22.090-0.002 40-17.91 39.996-39.998l0.004-112.018c0-22.094-17.91-40-40-40.002-22.094 0-40.004 17.91-40 40.002v112.016c-0.004 22.096 17.906 40.002 40 40zM512.25 735.604c22.090-0.002 40-17.91 39.996-39.998l0.004-112.018c0-22.094-17.91-40-40-40.002-22.094 0-40.004 17.91-40 40.002v112.016c-0.004 22.096 17.906 40.002 40 40zM950.3 397.424c-7.596-8.686-18.574-13.67-30.114-13.67h-313.284c0.87 5.196 1.346 10.524 1.346 15.966 0 24.608-9.27 47.044-24.494 64.034h290.684l-47.318 351.376-629.908-0.030-47.502-351.346h291.034c-15.224-16.988-24.494-39.426-24.494-64.034 0-5.444 0.476-10.772 1.346-15.966h-313.66c-11.542 0-22.524 4.986-30.12 13.678-7.596 8.694-11.066 20.242-9.52 31.682l51.614 381.742 0.050 0.042c5.832 47.424 46.222 84.158 95.222 84.172l0.054 0.034 601.816-0.034c0.042 0 0.082 0.002 0.124 0.002 49.414 0 90.090-37.34 95.396-85.336l51.258-380.64c1.54-11.44-1.934-22.984-9.53-31.672zM805.492 105.34c-15.622-15.622-40.95-15.624-56.572 0.004l-230.684 230.684c-2.052-0.2-4.132-0.306-6.236-0.306-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64c0-2.652-0.18-5.262-0.494-7.83l229.986-229.98c15.622-15.624 15.616-40.95-0-56.572z',
	  credit: 'M376.188 672.062h-112.124c-22.092 0-40-17.908-40-40s17.908-40 40-40h112.124c22.092 0 40 17.908 40 40s-17.908 40-40 40zM960 232.002v560c0 6.8-1.708 13.2-4.704 18.81-0.044 0.082-0.078 0.172-0.124 0.254-0.524 0.974-1.112 1.914-1.722 2.836-0.098 0.15-0.18 0.31-0.282 0.458-7.188 10.64-19.36 17.638-33.168 17.638h-816c-22.090 0-40-17.908-40-40v-559.998c0-20.34 15.192-37.092 34.838-39.628 1.694-0.218 3.408-0.372 5.162-0.372h816c1.754 0 3.468 0.152 5.162 0.372 19.646 2.536 34.838 19.288 34.838 39.63zM144 272.002v80.030h736v-80.030h-736zM880 751.998v-239.966h-736v239.966h736z',
	  shield: 'M875.146 148.994c-0.064-0.040-0.116-0.094-0.184-0.132-92.714-52.39-221.036-84.83-362.846-84.83-138.512 0-270.346 34.356-362.51 84.618-0.606 0.33-1.138 0.658-1.608 0.986-11.954 6.918-20.016 19.81-20.016 34.614v451.4c0 12.7 5.938 23.996 15.166 31.32l340.538 281.676c6.568 6.434 14.918 10.168 23.564 11.122 0.16 0.024 0.32 0.050 0.48 0.066 0.838 0.082 1.676 0.114 2.518 0.14 0.496 0.020 0.994 0.058 1.492 0.058s0.996-0.040 1.492-0.058c0.842-0.032 1.68-0.058 2.518-0.14 0.16-0.016 0.32-0.042 0.48-0.066 8.646-0.958 16.996-4.688 23.564-11.122l339.36-280.718c10.326-7.23 17.094-19.2 17.094-32.762v-450.918c0.002-15.254-8.54-28.506-21.102-35.254zM207.984 208.212c36.292-18.168 77.668-32.854 123.356-43.722 57.062-13.576 117.884-20.458 180.778-20.458s123.714 6.882 180.778 20.458c30.186 7.182 58.474 16.040 84.674 26.456l-490.846 490.848-78.738-65.070v-408.512zM511.742 867.75l-163.078-134.77 467.586-467.584v350.69l-304.508 251.664z',
	  beaker: 'M848.64 790.56l-208.638-361.374v-252.062h24c22.092 0 40-17.908 40-40s-17.908-40-40-40h-304.002c-22.092 0-40 17.908-40 40s17.908 40 40 40h24v252.066l-208.636 361.37c-44 76.208-8 138.564 80 138.564h513.278c87.998 0 123.998-62.354 79.998-138.564zM464 177.124h96.002l-0.070 273.376 63.872 110.628h-223.678c35.932-62.268 63.872-110.684 63.876-110.692v-273.312zM768.64 849.124h-513.278c-8.28 0-14.186-0.976-17.968-2 1.004-3.792 3.112-9.394 7.25-16.564 0 0 54.598-94.614 109.316-189.436l316.026-0.002 109.374 189.44c4.138 7.168 6.246 12.77 7.25 16.562-3.784 1.024-9.69 2-17.97 2z',
	  thumbsup: 'M256.972 768.004c0-8.67-3.156-16.158-9.484-22.534-6.332-6.34-13.836-9.484-22.504-9.458-8.682 0-16.188 3.172-22.516 9.458-6.33 6.344-9.488 13.84-9.488 22.534 0 8.692 3.158 16.186 9.488 22.532 6.328 6.286 13.834 9.458 22.516 9.458 8.668 0.028 16.172-3.118 22.504-9.458 6.328-6.376 9.484-13.868 9.484-22.532zM832.948 480.010c0-17.004-6.478-31.908-19.468-44.734-13.014-12.82-27.834-19.25-44.512-19.276h-175.97c0-19.328 7.98-45.904 24.004-79.724 15.968-33.826 23.978-60.568 23.978-80.256 0-32.646-5.332-56.808-15.994-72.48-10.664-15.664-31.988-23.484-63.98-23.484-8.696 8.64-15.012 22.828-19.032 42.486-4.020 19.69-9.102 40.606-15.254 62.752-6.168 22.172-16.080 40.382-29.762 54.738-7.344 7.68-20.168 22.832-38.5 45.496-1.326 1.67-5.164 6.65-11.512 15.010-6.342 8.342-11.594 15.178-15.762 20.508-4.156 5.308-9.91 12.386-17.252 21.218-7.328 8.862-14 16.186-19.988 22.038-5.986 5.794-12.412 11.73-19.26 17.744-6.852 5.984-13.508 10.5-19.99 13.48-6.478 3.010-12.4 4.484-17.756 4.512h-15.982v320.010h15.982c4.332 0 9.596 0.492 15.774 1.504 6.168 1.012 11.676 2.080 16.488 3.258 4.812 1.144 11.154 2.98 19.002 5.466 7.862 2.512 13.702 4.424 17.502 5.74 3.812 1.31 9.732 3.422 17.756 6.238 8.026 2.842 12.866 4.586 14.506 5.272 70.324 24.334 127.304 36.504 170.996 36.504h60.482c64.006 0 96.024-27.836 96.024-83.478 0-8.664-0.848-18.016-2.514-27.996 10.004-5.334 17.936-14.084 23.758-26.276 5.824-12.172 8.724-24.416 8.778-36.746 0-12.366-3.008-23.844-9.024-34.51 17.664-16.682 26.524-36.496 26.524-59.496 0-8.308-1.696-17.554-5.032-27.72-3.336-10.202-7.492-18.104-12.468-23.762 10.636-0.328 19.55-8.15 26.714-23.486 7.192-15.34 10.744-28.82 10.744-40.496v-0.054zM896.984 479.516c0 29.638-8.204 56.816-24.5 81.506 2.98 10.994 4.484 22.476 4.484 34.482 0 25.674-6.344 49.68-19.004 71.99 1.012 7 1.506 14.164 1.506 21.488 0 33.688-10.008 63.354-29.968 89.026 0.326 46.32-13.834 82.904-42.518 109.756-28.682 26.848-66.522 40.246-113.496 40.246h-64.528c-31.99 0-63.542-3.746-94.742-11.268-31.168-7.492-67.246-18.402-108.23-32.758-38.662-13.312-61.656-19.956-68.984-19.956h-143.996c-17.664 0-32.742-6.292-45.252-18.784-12.508-12.5-18.756-27.588-18.756-45.254v-319.982c0-17.666 6.248-32.728 18.756-45.226 12.51-12.52 27.588-18.784 45.252-18.784h136.998c12.002-8.010 34.818-33.822 68.478-77.484 19.33-24.99 37.168-46.344 53.508-64.008 7.996-8.314 13.918-22.586 17.744-42.766 3.828-20.178 8.912-41.232 15.256-63.24 6.36-21.984 16.68-40.002 30.994-53.998 13.002-12.362 28.012-18.514 45.018-18.514 27.998 0 53.152 5.414 75.464 16.242 22.31 10.828 39.316 27.748 50.964 50.77 11.704 23.002 17.5 53.978 17.5 92.962 0 31.008-7.984 63-23.98 96.028h88.014c34.67 0 64.634 12.628 89.956 37.98 25.346 25.346 38.008 55.144 38.008 89.49l0.054 0.056z',
	  mirror: 'M857 127.778h-688c-22.092 0-40 17.91-40 40v688c0 22.090 17.908 40 40 40h688c22.094 0 40-17.91 40-40v-688c0-22.092-17.906-40-40-40zM817 815.778h-608v-1.086l606.914-606.914h1.086v608z',
	  switchalt: 'M923.946 63.418h-631.232c-20.268 0-36.7 16.432-36.7 36.7v155.286h-155.284c-20.268 0-36.7 16.432-36.7 36.7v631.23c0 20.268 16.43 36.7 36.7 36.7h631.23c20.272 0 36.7-16.432 36.7-36.7v-155.286h155.286c20.272 0 36.7-16.432 36.7-36.7v-631.23c-0.002-20.268-16.43-36.7-36.7-36.7zM688.66 880.032h-544.628v-544.628h111.984v395.946c0 20.268 16.43 36.7 36.7 36.7h395.944v111.982zM688.66 688.046h-352.644v-352.644h352.644v352.644zM880.644 688.046h-111.984v-395.946c0-20.268-16.428-36.7-36.7-36.7h-395.944v-111.984h544.628v544.63z',
	  commit: 'M984.032 472h-186.808c-19.474-140.12-139.74-248-285.222-248s-265.748 107.88-285.222 248h-186.746c-22.092 0-40 17.912-40 40.002 0 22.092 17.91 40 40 40h186.746c19.476 140.122 139.74 247.998 285.222 247.998s265.746-107.876 285.222-247.998h186.808c22.092 0 40-17.91 40-40s-17.908-40.002-40-40.002zM512 720c-114.692 0-208-93.308-208-208s93.308-208 208-208 208 93.308 208 208-93.308 208-208 208z',
	  branch: 'M861.968 312.032c0-66.168-53.832-120-120-120s-120 53.832-120 120c0 50.55 31.436 93.87 75.77 111.516-5.384 20.352-15.71 39.68-29.844 54.92-28.828 31.092-72.202 46.858-128.91 46.858-77.162 0-129.12 26.162-162.984 55.12V297.15c46.556-16.512 80-60.974 80-113.12 0-66.168-53.832-120-120-120s-120 53.832-120 120c0 52.146 33.444 96.608 80 113.12v429.762c-46.556 16.512-80 60.974-80 113.12 0 66.168 53.832 120 120 120s120-53.832 120-120c0-50.926-31.902-94.514-76.758-111.908 5.222-26.17 16.578-51.154 32.558-70.432 28.8-34.746 71.592-52.364 127.184-52.364 99.498 0 156.922-39.408 187.574-72.466 27.402-29.554 45.708-67.194 52.48-106.716 48.078-15.66 82.93-60.882 82.93-114.114zM336 144.032c22.056 0 40 17.944 40 40s-17.944 40-40 40-40-17.944-40-40 17.944-40 40-40zm0 736c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40zm405.968-528c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.942 40-40 40z',
	  merge: 'M776.306 456.032c-51.602 0-95.696 32.744-112.612 78.542-69.674-6.072-141.482-31.012-197.386-69.306-46.266-31.69-100.392-85.728-111.792-168.92 45.4-17.12 77.79-60.998 77.79-112.314 0-66.168-53.832-120-120-120s-120 53.832-120 120c0 52.146 33.444 96.608 80 113.12v429.762c-46.556 16.512-80 60.974-80 113.12 0 66.168 53.832 120 120 120s120-53.832 120-120c0-52.146-33.444-96.608-80-113.12V471.444c19.622 21.888 42.618 41.898 68.792 59.828 68.422 46.868 156.64 77.042 241.646 83.462 16.14 47.23 60.932 81.3 113.56 81.3 66.168 0 120-53.832 120-120s-53.83-120.002-119.998-120.002zm-464-312c22.056 0 40 17.944 40 40s-17.944 40-40 40-40-17.944-40-40 17.942-40 40-40zm0 736c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40zm464-264c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z',
	  pullrequest: 'M631 157c104 1 171 52 171 166v397a123 123 0 1 1-82 0V323c0-63-27-83-90-84h-24l22 23a41 41 0 1 1-58 58l-93-93a41 41 0 0 1 1-58l93-93a41 41 0 1 1 58 58l-23 23h25zM222 314a123 123 0 1 1 82 0v406a123 123 0 1 1-82 0V314zm41 564a41 41 0 1 0 0-82 41 41 0 0 0 0 82zm0-639a41 41 0 1 0 0-83 41 41 0 0 0 0 83zm498 639a41 41 0 1 0 0-82 41 41 0 0 0 0 82z',
	  chroma: 'M511.714 956.324c-92.92 0-168.518-75.594-168.518-168.514v-334.082l131.54 75.954v215.936c0 13.172 7.082 25.446 18.48 32.030l139.33 80.43c8.33 4.814 17.014 9.168 25.872 12.966-29.646 52.72-85.44 85.28-146.704 85.28zM753.584 816.61c-29.36 0-58.43-7.812-84.064-22.59l-83.828-48.404 289.354-167.028c8.3-4.802 16.402-10.152 24.132-15.936 30.858 52.030 31.182 116.622 0.568 169.664-30.034 51.994-86.040 84.294-146.162 84.294zM270.334 816.576c-60.084 0-116.064-32.278-146.102-84.238-22.494-39.012-28.466-84.426-16.814-127.866 11.68-43.512 39.564-79.858 78.522-102.334l83.806-48.398 0.018 334.018c0 9.624 0.57 19.294 1.69 28.814-0.374 0.002-0.748 0.004-1.12 0.004zM548.73 529.73l186.996-107.966c11.416-6.588 18.506-18.864 18.506-32.040v-160.856c0.012-9.456-0.56-19.116-1.706-28.778 0.364-0.002 0.732-0.004 1.096-0.004 60.114 0 116.104 32.296 146.124 84.29 46.436 80.486 18.75 183.742-61.714 230.176l-289.302 167.040v-151.862zM325.248 357.624c-5.632-3.242-12.030-4.954-18.504-4.954-6.428 0-12.804 1.708-18.44 4.936l-139.344 80.452c-8.348 4.802-16.462 10.142-24.172 15.912-30.824-52-31.14-116.59-0.546-169.664 30.048-52 86.050-84.306 146.148-84.306 29.326 0 58.394 7.822 84.064 22.624l289.3 167.054-131.482 75.91-187.024-107.964zM390.964 158.644c-8.334-4.826-17.036-9.192-25.92-13.004 29.634-52.742 85.418-85.316 146.67-85.316 92.92 0 168.514 75.6 168.514 168.522v96.81l-289.264-167.012z',
	  twitter: 'M960 233.114c-32.946 14.616-68.41 24.5-105.598 28.942 37.954-22.762 67.098-58.774 80.856-101.688-35.52 21.054-74.894 36.368-116.726 44.598-33.542-35.724-81.316-58.038-134.204-58.038-101.496 0-183.796 82.292-183.796 183.814 0 14.424 1.628 28.45 4.758 41.89-152.75-7.668-288.22-80.872-378.876-192.072-15.822 27.15-24.898 58.706-24.898 92.42 0 63.776 32.458 120.034 81.782 153.010-30.116-0.944-58.458-9.212-83.262-22.982-0.028 0.75-0.028 1.546-0.028 2.324 0 89.070 63.356 163.334 147.438 180.256-15.426 4.186-31.664 6.426-48.442 6.426-11.836 0-23.35-1.146-34.574-3.28 23.406 73.006 91.286 126.16 171.726 127.632-62.914 49.324-142.18 78.696-228.314 78.696-14.828 0-29.448-0.876-43.842-2.568 81.33 52.138 177.96 82.574 281.786 82.574 338.11 0 523-280.104 523-523.014 0-7.986-0.164-15.914-0.542-23.778 35.952-25.96 67.124-58.318 91.756-95.162z',
	  google: 'M799.094 79.996c0 0-200.938 0-267.936 0-120.126 0-233.188 91.004-233.188 196.434 0 107.692 81.904 194.624 204.124 194.624 8.496 0 16.75-0.148 24.812-0.74-7.942 15.186-13.594 32.286-13.594 50.022 0 29.974 16.094 54.226 36.466 74.042-15.376 0-30.248 0.438-46.438 0.438-148.782 0.036-263.312 94.784-263.312 193.056 0 96.758 125.534 157.312 274.312 157.312 169.656 0 263.312-96.25 263.312-193.024 0-77.6-22.908-124.062-93.686-174.156-24.216-17.128-70.534-58.812-70.534-83.32 0-28.69 8.19-42.868 51.406-76.624 44.346-34.63 75.688-83.302 75.688-139.944 0-67.372-30-133.058-86.374-154.746h85l59.942-43.374zM701.504 735.438c2.092 8.992 3.276 18.226 3.276 27.624 0 78.226-50.374 139.304-194.934 139.304-102.874 0-177.124-65.078-177.124-143.304 0-76.622 92.122-140.434 194.934-139.32 24.004 0.254 46.376 4.136 66.69 10.702 55.812 38.834 95.874 60.808 107.158 104.994zM536.844 443.782c-69-2.094-134.624-77.212-146.564-167.876-11.874-90.664 34.378-160.030 103.442-157.97 68.996 2.060 134.594 74.818 146.53 165.432 11.906 90.696-34.408 162.508-103.408 160.414z',
	  gdrive: 'M465.926 641.356l-149.328 258.708h494.074l149.328-258.708h-494.074zM917.704 567.988l-256.33-444.048h-298.686l256.356 444.048h298.66zM320.236 197.442l-256.236 443.914 149.36 258.708 256.23-443.914-149.354-258.708z',
	  youtube: 'M704.010 511.988c0-12.332-5.038-21.358-15.042-26.992l-255.982-159.99c-10.344-6.666-21.178-6.998-32.51-1.008-10.988 5.984-16.492 15.312-16.492 28.002v320c0 12.69 5.504 22.018 16.492 28.002 5.332 2.678 10.516 3.996 15.506 3.996 6.668 0 12.334-1.644 17.004-4.98l255.982-160.014c10.004-5.69 15.042-14.684 15.042-26.992v-0.024zM960 511.988c0 31.99-0.164 56.98-0.488 75.032-0.334 17.99-1.754 40.738-4.27 68.25-2.516 27.504-6.262 52.058-11.27 73.742-5.332 24.338-16.84 44.85-34.504 61.496-17.64 16.63-38.306 26.308-61.96 28.988-73.992 8.342-185.824 12.526-335.508 12.526-149.668 0-261.5-4.184-335.5-12.526-23.662-2.656-44.414-12.302-62.242-28.988-17.834-16.678-29.412-37.182-34.744-61.496-4.672-21.684-8.258-46.238-10.756-73.742-2.508-27.512-3.928-50.26-4.254-68.25-0.342-18.050-0.504-43.042-0.504-75.032 0-31.998 0.162-57.010 0.504-75.008 0.326-18.022 1.746-40.768 4.254-68.28 2.498-27.474 6.262-52.082 11.252-73.744 5.34-24.336 16.842-44.842 34.504-61.496 17.648-16.654 38.324-26.332 61.986-29.010 74-8.312 185.832-12.472 335.5-12.472 149.684 0 261.516 4.16 335.508 12.472 23.654 2.678 44.406 12.356 62.232 29.010 17.826 16.678 29.422 37.16 34.73 61.496 4.702 21.662 8.256 46.27 10.772 73.744 2.516 27.512 3.936 50.258 4.27 68.28 0.324 17.998 0.488 43.010 0.488 75.008z',
	  facebook: 'M582.52 960h-167.88v-448h-112v-154.396l112-0.052-0.166-90.948c-0.036-125.974 34.12-202.604 182.484-202.604h123.542v154.424h-77.19c-57.782 0-60.566 21.56-60.566 61.85l-0.218 77.278h138.854l-16.376 154.394-122.36 0.052-0.124 448.002z',
	  medium: 'M0 0v1024h1024v-1024h-1024zM850.708 242.614l-54.918 52.655c-3.858 2.965-6.321 7.581-6.321 12.772 0 0.933 0.080 1.847 0.232 2.736l-0.014-0.095v386.883c-0.139 0.794-0.219 1.708-0.219 2.641 0 5.191 2.462 9.807 6.283 12.744l0.038 0.028 53.637 52.655v11.558h-269.774v-11.558l55.559-53.936c5.461-5.456 5.461-7.068 5.461-15.413v-312.719l-154.477 392.344h-20.874l-179.851-392.344v262.947c-0.209 1.465-0.329 3.156-0.329 4.875 0 9.848 3.924 18.78 10.293 25.317l-0.008-0.008 72.258 87.649v11.558h-204.895v-11.558l72.263-87.649c6.070-6.284 9.81-14.852 9.81-24.293 0-2.081-0.182-4.12-0.53-6.101l0.031 0.21v-304.044c0.086-0.804 0.135-1.737 0.135-2.682 0-7.844-3.389-14.896-8.782-19.773l-0.023-0.021-64.234-77.378v-11.558h199.438l154.157 338.083 135.53-338.083h190.123v11.558z',
	  graphql: 'M896.38 635.332c-7.286-4.206-14.934-7.196-22.714-9.074v-228.148c7.788-1.882 15.44-4.874 22.732-9.082 40.902-23.614 54.92-75.934 31.3-116.846-23.62-40.914-75.942-54.932-116.846-31.318-7.286 4.21-13.704 9.34-19.22 15.14l-197.586-114.076c2.266-7.68 3.502-15.802 3.502-24.212 0-47.232-38.3-85.53-85.544-85.53-47.242 0-85.544 38.298-85.544 85.53 0 8.42 1.238 16.552 3.508 24.24l-197.598 114.046c-5.518-5.802-11.936-10.93-19.218-15.138-40.902-23.614-93.22-9.596-116.846 31.318-23.62 40.91-9.6 93.228 31.3 116.846 7.29 4.208 14.94 7.202 22.728 9.082v228.15c-7.782 1.878-15.434 4.866-22.718 9.074-40.91 23.62-54.93 75.938-31.31 116.848 23.624 40.914 75.944 54.932 116.856 31.312 7.28-4.206 13.692-9.334 19.206-15.13l197.588 114.080c-2.262 7.68-3.498 15.792-3.498 24.2 0 47.244 38.302 85.544 85.546 85.544 47.242 0 85.542-38.302 85.542-85.544 0-9.362-1.524-18.36-4.308-26.79l196.558-113.484c5.914 6.624 12.946 12.446 21.046 17.126 40.912 23.618 93.23 9.602 116.856-31.314 23.618-40.914 9.598-93.232-31.318-116.85zM253.492 689.212c-1.88-7.73-4.856-15.33-9.038-22.568-4.142-7.18-9.194-13.516-14.892-18.98l258.558-447.814c7.58 2.198 15.586 3.402 23.878 3.402 8.262 0 16.242-1.196 23.802-3.38l258.574 447.85c-5.676 5.456-10.704 11.77-14.834 18.928-4.182 7.238-7.162 14.838-9.042 22.566l-517.006-0.004zM771.404 291.408c-6.156 21.512-3.936 45.396 8.138 66.306 12.066 20.91 31.638 34.772 53.348 40.2v228.538c-1.074 0.266-2.144 0.56-3.208 0.868l-258.56-447.826c0.804-0.768 1.596-1.556 2.372-2.354l197.91 114.268zM450.526 177.162c0.75 0.772 1.516 1.536 2.296 2.282l-258.578 447.856c-1.038-0.3-2.084-0.586-3.134-0.85v-228.536c21.708-5.428 41.276-19.29 53.348-40.202 12.074-20.91 14.294-44.794 8.134-66.306l197.934-114.244zM575.392 849.216c-15.65-17.262-38.256-28.108-63.39-28.108-24.152 0-45.946 10.026-61.5 26.112l-197.908-114.266c0.28-0.986 0.544-1.98 0.794-2.972h517.226c0.464 1.888 0.976 3.756 1.57 5.61l-196.792 113.624z',
	  redux: 'M359.016 943.608c-23.82 5.948-47.642 8.322-71.512 8.322-88.208 0-168.084-36.982-207.444-96.534-52.432-79.882-70.296-249.182 102.538-374.356 3.586 19.078 10.746 45.292 15.492 60.834-22.656 16.652-58.39 50.064-81.046 95.324-32.19 63.184-28.61 126.404 9.54 184.798 26.194 39.304 67.926 63.176 121.564 70.34 65.598 8.332 131.154-3.582 194.332-36.94 92.998-48.898 155.014-107.282 195.49-187.162-10.702-10.75-17.818-26.248-19.074-44.15-1.168-36.942 27.45-67.922 64.388-69.132h2.418c35.73 0 65.55 28.61 66.714 64.384 1.206 35.73-24.986 65.546-59.548 69.132-65.6 134.686-181.254 225.312-333.852 255.14zM902.646 540.622c-90.59-106.072-224.11-164.488-376.708-164.488h-19.072c-10.744-21.444-33.402-35.752-58.388-35.752h-2.418c-36.944 1.186-65.548 32.192-64.392 69.13 1.216 35.774 30.99 64.394 66.81 64.394h2.328c26.242-1.208 48.894-17.892 58.434-40.542h21.45c90.624 0 176.46 26.234 253.968 77.482 59.55 39.36 102.49 90.576 126.356 152.596 20.24 50.052 19.074 98.952-2.42 140.64-33.356 63.228-89.37 97.794-163.292 97.794-47.69 0-92.998-14.33-116.822-25.082-13.118 11.958-36.984 31.028-53.64 42.944 51.226 23.87 103.7 36.94 153.762 36.94 114.446 0 199.070-63.132 231.268-126.362 34.562-69.13 32.188-188.326-57.224-289.694zM297.046 708.706c1.21 35.828 30.984 64.394 66.764 64.394h2.368c36.992-1.168 65.556-32.15 64.39-69.132-1.162-35.732-30.984-64.394-66.758-64.394h-2.376c-2.418 0-5.958 0-8.332 1.208-48.89-81.090-69.132-169.27-62.014-264.648 4.792-71.528 28.616-133.516 70.346-184.766 34.568-44.106 101.326-65.57 146.598-66.758 126.402-2.396 180.044 154.968 183.576 218.144 15.542 3.584 41.734 11.936 59.644 17.892-14.328-193.118-133.526-293.266-247.97-293.266-107.28 0-206.236 77.484-245.552 191.932-54.848 152.596-19.070 299.212 47.644 414.826-5.912 8.374-9.494 21.498-8.328 34.568z',
	  github: 'M512.062 64.032c-247.426 0-448 200.576-448 448s200.574 448 448 448c247.422 0 448-200.576 448-448s-200.578-448-448-448zM251.846 772.246c-69.506-69.508-107.784-161.918-107.784-260.214 0-98.294 38.278-190.708 107.784-260.216 69.508-69.504 161.92-107.784 260.216-107.784s190.708 38.28 260.214 107.784c69.504 69.508 107.786 161.922 107.786 260.216 0 98.296-38.282 190.708-107.786 260.214-42.852 42.848-94.41 73.806-150.684 91.27v-65.104c0-34.584-11.86-60.022-35.578-76.31 14.864-1.43 28.512-3.43 40.942-6.002 12.434-2.572 25.578-6.292 39.442-11.146s26.292-10.644 37.3-17.364c11-6.712 21.574-15.434 31.718-26.15s18.648-22.866 25.508-36.444c6.864-13.57 12.292-29.866 16.292-48.874 4.004-19.006 6-39.944 6-62.802 0-44.3-14.434-82.032-43.296-113.182 13.14-34.294 11.714-71.594-4.29-111.894l-10.718-1.286c-7.43-0.858-20.79 2.286-40.082 9.434-19.29 7.144-40.942 18.864-64.95 35.152-34.016-9.432-69.308-14.148-105.894-14.148-36.87 0-72.024 4.716-105.46 14.148-15.144-10.29-29.51-18.79-43.086-25.508s-24.436-11.29-32.582-13.718c-8.144-2.43-15.718-3.93-22.722-4.5-7-0.574-11.5-0.714-13.504-0.43-2 0.286-3.43 0.572-4.288 0.86-16.004 40.582-17.436 77.88-4.288 111.894-28.868 31.152-43.3 68.878-43.3 113.178 0 22.866 2 43.798 6.002 62.804 4 19.010 9.432 35.296 16.292 48.876s15.364 25.722 25.508 36.442c10.146 10.718 20.72 19.438 31.724 26.152s23.436 12.504 37.298 17.362c13.862 4.858 27.008 8.574 39.442 11.146 12.434 2.57 26.080 4.574 40.942 6.002-23.438 16.004-35.152 41.444-35.152 76.31v66.404c-57.936-17.198-111.030-48.638-154.966-92.572z',
	  bitbucket: 'M512.157 32c-219.6 0-400.001 61.279-400.001 138.881 0 20.4 47.040 310.481 66.641 424.8 7.841 53.28 137.359 126.72 333.36 126.72 196.080 0 321.6-73.601 333.36-126.641 19.601-114.4 66.641-404.479 66.641-424.8-3.919-77.76-180.401-138.96-400.001-138.96v0zM512.157 628.4c-70.56 0-125.52-57.2-125.52-130.722s54.96-130.72 125.52-130.72c70.56 0 125.52 57.199 125.52 130.721 0 69.439-54.96 130.721-125.52 130.721zM512.157 211.76c-141.199 0-254.88-24.559-254.88-57.199 0-32.719 113.681-57.199 254.88-57.199s254.88 24.48 254.88 57.199c0 32.64-113.681 57.199-254.88 57.199zM801.597 706.081c7.84 0 11.76 8.16 7.84 16.32v4.002c-15.679 85.84-27.439 147.199-27.439 155.28-11.76 61.279-129.439 110.321-270.641 110.321-141.12 0-258.8-49.039-270.56-110.321 0-8.16-11.76-69.439-27.439-155.201v-4.081c0-12.24 7.841-16.319 15.679-16.319 4.409 0.751 8.359 2.145 11.962 4.1l-0.202-0.101c0 0 98.081 81.761 274.481 81.761 176.479 0 274.56-81.679 274.56-81.679s3.919-4.080 11.76-4.080l0.001-0.002zM512.157 558.961c-34.639 0-62.719-29.279-62.719-65.359s28.001-65.359 62.719-65.359c34.639 0 62.719 29.279 62.719 65.359s-28.001 65.359-62.719 65.359z',
	  gitlab: 'M511.989 937.076l-175.718-538.045h351.434l-175.717 538.045zM90.107 399.031l421.88 538.045-462.033-334.102c-9.156-6.631-15.047-17.289-15.047-29.321 0-3.985 0.645-7.821 1.839-11.406l-0.072 0.255 53.431-163.471zM90.107 399.031l105.75-324.083c2.508-7.304 9.319-12.457 17.334-12.457s14.825 5.153 17.294 12.329l0.042 0.128 105.749 324.082-246.165 0.001zM933.869 399.031l53.431 163.474c1.133 3.347 1.788 7.203 1.788 11.215 0 12.038-5.895 22.705-14.961 29.262l-0.104 0.072-462.034 334.022 421.88-538.046zM933.869 399.031h-246.162l105.75-324.083c2.543-7.242 9.325-12.341 17.292-12.341s14.748 5.096 17.256 12.212l0.042 0.127 105.825 324.083z',
	  discord: 'M371 147c-14 0-126 3-245 91 0 0-126 227-126 507 0 0 74 126 268 132l58-71c-111-34-153-103-153-103l24 15 4 2 8 4a668 668 0 0 0 420 68 629 629 0 0 0 228-89s-44 71-159 103l58 71c194-7 268-133 268-132 0-280-126-507-126-507-126-94-246-91-246-91l-12 14a576 576 0 0 1 218 110 729 729 0 0 0-441-81l-15 1c-31 4-105 14-199 56-33 14-52 24-52 24s72-69 230-114l-9-10h-1zm-23 323c50 0 91 43 90 97 0 53-40 96-90 96-49 0-89-43-89-96 0-54 39-97 89-97zm321 0c49 0 89 43 89 97 0 53-39 96-89 96s-90-43-90-96c0-54 40-97 90-97z'
	};
	
	exports.default = icons;
	module.exports = exports['default'];

/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _removeNonPrintingValuesTransformer = __webpack_require__(663);
	
	var _removeNonPrintingValuesTransformer2 = _interopRequireDefault(_removeNonPrintingValuesTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _removeNonPrintingValuesTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vcmVtb3ZlTm9uUHJpbnRpbmdWYWx1ZXNUcmFuc2Zvcm1lcic7XG4iXX0=

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _replaceSubstitutionTransformer = __webpack_require__(667);
	
	var _replaceSubstitutionTransformer2 = _interopRequireDefault(_replaceSubstitutionTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _replaceSubstitutionTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9yZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXInO1xuIl19

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(179)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(module, exports, require('../utils'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod, mod.exports, global.utils);
	    global.index = mod.exports;
	  }
	})(this, function (module, exports, _utils) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  var addedDiff = function addedDiff(lhs, rhs) {
	
	    if (lhs === rhs || !(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return {};
	
	    var l = (0, _utils.properObject)(lhs);
	    var r = (0, _utils.properObject)(rhs);
	
	    return Object.keys(r).reduce(function (acc, key) {
	      if (l.hasOwnProperty(key)) {
	        var difference = addedDiff(l[key], r[key]);
	
	        if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference)) return acc;
	
	        return _extends({}, acc, _defineProperty({}, key, difference));
	      }
	
	      return _extends({}, acc, _defineProperty({}, key, r[key]));
	    }, {});
	  };
	
	  exports.default = addedDiff;
	  module.exports = exports['default'];
	});

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(179)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(module, exports, require('../utils'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod, mod.exports, global.utils);
	    global.index = mod.exports;
	  }
	})(this, function (module, exports, _utils) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  var deletedDiff = function deletedDiff(lhs, rhs) {
	    if (lhs === rhs || !(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return {};
	
	    var l = (0, _utils.properObject)(lhs);
	    var r = (0, _utils.properObject)(rhs);
	
	    return Object.keys(l).reduce(function (acc, key) {
	      if (r.hasOwnProperty(key)) {
	        var difference = deletedDiff(l[key], r[key]);
	
	        if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference)) return acc;
	
	        return _extends({}, acc, _defineProperty({}, key, difference));
	      }
	
	      return _extends({}, acc, _defineProperty({}, key, undefined));
	    }, {});
	  };
	
	  exports.default = deletedDiff;
	  module.exports = exports['default'];
	});

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(179)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(module, exports, require('../utils'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod, mod.exports, global.utils);
	    global.index = mod.exports;
	  }
	})(this, function (module, exports, _utils) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  var updatedDiff = function updatedDiff(lhs, rhs) {
	
	    if (lhs === rhs) return {};
	
	    if (!(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return rhs;
	
	    var l = (0, _utils.properObject)(lhs);
	    var r = (0, _utils.properObject)(rhs);
	
	    if ((0, _utils.isDate)(l) || (0, _utils.isDate)(r)) {
	      if (l.valueOf() == r.valueOf()) return {};
	      return r;
	    }
	
	    return Object.keys(r).reduce(function (acc, key) {
	
	      if (l.hasOwnProperty(key)) {
	        var difference = updatedDiff(l[key], r[key]);
	
	        if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference) && !(0, _utils.isDate)(difference)) return acc;
	
	        return _extends({}, acc, _defineProperty({}, key, difference));
	      }
	
	      return acc;
	    }, {});
	  };
	
	  exports.default = updatedDiff;
	  module.exports = exports['default'];
	});

/***/ }),
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var CASE_SENSITIVE_TAG_NAMES = __webpack_require__(867).CASE_SENSITIVE_TAG_NAMES;
	
	var caseSensitiveTagNamesMap = {};
	var tagName;
	for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
	  tagName = CASE_SENSITIVE_TAG_NAMES[i];
	  caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
	}
	
	/**
	 * Gets case-sensitive tag name.
	 *
	 * @param  {String}           tagName - The lowercase tag name.
	 * @return {String|undefined}
	 */
	function getCaseSensitiveTagName(tagName) {
	  return caseSensitiveTagNamesMap[tagName];
	}
	
	/**
	 * Formats DOM attributes to a hash map.
	 *
	 * @param  {NamedNodeMap} attributes - The list of attributes.
	 * @return {Object}                  - A map of attribute name to value.
	 */
	function formatAttributes(attributes) {
	  var result = {};
	  var attribute;
	  // `NamedNodeMap` is array-like
	  for (var i = 0, len = attributes.length; i < len; i++) {
	    attribute = attributes[i];
	    result[attribute.name] = attribute.value;
	  }
	  return result;
	}
	
	/**
	 * Corrects the tag name if it is case-sensitive (SVG).
	 * Otherwise, returns the lowercase tag name (HTML).
	 *
	 * @param  {String} tagName - The lowercase tag name.
	 * @return {String}         - The formatted tag name.
	 */
	function formatTagName(tagName) {
	  tagName = tagName.toLowerCase();
	  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
	  if (caseSensitiveTagName) {
	    return caseSensitiveTagName;
	  }
	  return tagName;
	}
	
	/**
	 * Formats the browser DOM nodes to mimic the output of `htmlparser2.parseDOM()`.
	 *
	 * @param  {NodeList} nodes        - The DOM nodes.
	 * @param  {Object}   [parentObj]  - The formatted parent node.
	 * @param  {String}   [directive]  - The directive.
	 * @return {Object[]}              - The formatted DOM object.
	 */
	function formatDOM(nodes, parentObj, directive) {
	  parentObj = parentObj || null;
	
	  var result = [];
	  var node;
	  var prevNode;
	  var nodeObj;
	
	  // `NodeList` is array-like
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    node = nodes[i];
	    // reset
	    nodeObj = {
	      next: null,
	      prev: result[i - 1] || null,
	      parent: parentObj
	    };
	
	    // set the next node for the previous node (if applicable)
	    prevNode = result[i - 1];
	    if (prevNode) {
	      prevNode.next = nodeObj;
	    }
	
	    // set the node name if it's not "#text" or "#comment"
	    // e.g., "div"
	    if (node.nodeName[0] !== '#') {
	      nodeObj.name = formatTagName(node.nodeName);
	      // also, nodes of type "tag" have "attribs"
	      nodeObj.attribs = {}; // default
	      if (node.attributes && node.attributes.length) {
	        nodeObj.attribs = formatAttributes(node.attributes);
	      }
	    }
	
	    // set the node type
	    // e.g., "tag"
	    switch (node.nodeType) {
	      // 1 = element
	      case 1:
	        if (nodeObj.name === 'script' || nodeObj.name === 'style') {
	          nodeObj.type = nodeObj.name;
	        } else {
	          nodeObj.type = 'tag';
	        }
	        // recursively format the children
	        nodeObj.children = formatDOM(node.childNodes, nodeObj);
	        break;
	      // 2 = attribute
	      // 3 = text
	      case 3:
	        nodeObj.type = 'text';
	        nodeObj.data = node.nodeValue;
	        break;
	      // 8 = comment
	      case 8:
	        nodeObj.type = 'comment';
	        nodeObj.data = node.nodeValue;
	        break;
	    }
	
	    result.push(nodeObj);
	  }
	
	  if (directive) {
	    result.unshift({
	      name: directive.substring(0, directive.indexOf(' ')).toLowerCase(),
	      data: directive,
	      type: 'directive',
	      next: result[0] ? result[0] : null,
	      prev: null,
	      parent: parentObj
	    });
	
	    if (result[1]) {
	      result[1].prev = result[0];
	    }
	  }
	
	  return result;
	}
	
	/**
	 * Detects IE with or without version.
	 *
	 * @param  {Number}  [version] - The IE version to detect.
	 * @return {Boolean}           - Whether IE or the version has been detected.
	 */
	function isIE(version) {
	  if (version) {
	    return document.documentMode === version;
	  }
	  return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
	}
	
	module.exports = {
	  formatAttributes: formatAttributes,
	  formatDOM: formatDOM,
	  isIE: isIE
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var hyphenPatternRegex = /-([a-z])/g;
	var CUSTOM_PROPERTY_OR_NO_HYPHEN_REGEX = /^--[a-zA-Z0-9-]+$|^[^-]+$/;
	
	/**
	 * Converts a string to camelCase.
	 *
	 * @param  {String} string - The string.
	 * @return {String}
	 */
	function camelCase(string) {
	  if (typeof string !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  // custom property or no hyphen found
	  if (CUSTOM_PROPERTY_OR_NO_HYPHEN_REGEX.test(string)) {
	    return string;
	  }
	
	  // convert to camelCase
	  return string
	    .toLowerCase()
	    .replace(hyphenPatternRegex, function(_, character) {
	      return character.toUpperCase();
	    });
	}
	
	/**
	 * Swap key with value in an object.
	 *
	 * @param  {Object}   obj        - The object.
	 * @param  {Function} [override] - The override method.
	 * @return {Object}              - The inverted object.
	 */
	function invertObject(obj, override) {
	  if (!obj || typeof obj !== 'object') {
	    throw new TypeError('First argument must be an object');
	  }
	
	  var key;
	  var value;
	  var isOverridePresent = typeof override === 'function';
	  var overrides = {};
	  var result = {};
	
	  for (key in obj) {
	    value = obj[key];
	
	    if (isOverridePresent) {
	      overrides = override(key, value);
	      if (overrides && overrides.length === 2) {
	        result[overrides[0]] = overrides[1];
	        continue;
	      }
	    }
	
	    if (typeof value === 'string') {
	      result[value] = key;
	    }
	  }
	
	  return result;
	}
	
	/**
	 * Check if a given tag is a custom component.
	 *
	 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
	 *
	 * @param {string} tagName - The name of the html tag.
	 * @param {Object} props   - The props being passed to the element.
	 * @return {boolean}
	 */
	function isCustomComponent(tagName, props) {
	  if (tagName.indexOf('-') === -1) {
	    return props && typeof props.is === 'string';
	  }
	
	  switch (tagName) {
	    // These are reserved SVG and MathML elements.
	    // We don't mind this whitelist too much because we expect it to never grow.
	    // The alternative is to track the namespace in a few places which is convoluted.
	    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
	    case 'annotation-xml':
	    case 'color-profile':
	    case 'font-face':
	    case 'font-face-src':
	    case 'font-face-uri':
	    case 'font-face-format':
	    case 'font-face-name':
	    case 'missing-glyph':
	      return false;
	    default:
	      return true;
	  }
	}
	
	/**
	 * @constant {Boolean}
	 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
	 */
	var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;
	
	module.exports = {
	  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
	  camelCase: camelCase,
	  invertObject: invertObject,
	  isCustomComponent: isCustomComponent
	};


/***/ }),
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = decimal
	
	/* Check if the given character code, or the character
	 * code at the first character, is decimal. */
	function decimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return code >= 48 && code <= 57 /* 0-9 */
	}


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(974);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 433 */,
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = getContrast;
	
	var _getLuminance =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(266));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Returns the contrast ratio between two colors based on
	 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
	 *
	 * @example
	 * const contrastRatio = getContrast('#444', '#fff');
	 */
	function getContrast(color1, color2) {
	  var luminance1 = (0, _getLuminance["default"])(color1);
	  var luminance2 = (0, _getLuminance["default"])(color2);
	  return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
	}
	
	module.exports = exports.default;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function constructGradientValue(literals) {
	  var template = '';
	
	  for (var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    substitutions[_key - 1] = arguments[_key];
	  }
	
	  for (var i = 0; i < literals.length; i += 1) {
	    template += literals[i];
	
	    if (i === substitutions.length - 1 && substitutions[i]) {
	      var definedValues = substitutions.filter(function (substitute) {
	        return !!substitute;
	      }); // Adds leading coma if properties preceed color-stops
	
	      if (definedValues.length > 1) {
	        template = template.slice(0, -1);
	        template += ", " + substitutions[i]; // No trailing space if color-stops is the only param provided
	      } else if (definedValues.length === 1) {
	        template += "" + substitutions[i];
	      }
	    } else if (substitutions[i]) {
	      template += substitutions[i] + " ";
	    }
	  }
	
	  return template.trim();
	}
	
	var _default = constructGradientValue;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _hslToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(271));
	
	var _reduceHexValue =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(439));
	
	var _numberToHex =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(437));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function colorToHex(color) {
	  return (0, _numberToHex["default"])(Math.round(color * 255));
	}
	
	function convertToHex(red, green, blue) {
	  return (0, _reduceHexValue["default"])("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
	}
	
	function hslToHex(hue, saturation, lightness) {
	  return (0, _hslToRgb["default"])(hue, saturation, lightness, convertToHex);
	}
	
	var _default = hslToHex;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function numberToHex(value) {
	  var hex = value.toString(16);
	  return hex.length === 1 ? "0" + hex : hex;
	}
	
	var _default = numberToHex;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _endsWith =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1016));
	
	var _stripUnit =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(129));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Factory function that creates pixel-to-x converters
	 * @private
	 */
	var pxtoFactory = function pxtoFactory(to) {
	  return function (pxval, base) {
	    if (base === void 0) {
	      base = '16px';
	    }
	
	    var newPxval = pxval;
	    var newBase = base;
	
	    if (typeof pxval === 'string') {
	      if (!(0, _endsWith["default"])(pxval, 'px')) {
	        throw new _errors["default"](69, to, pxval);
	      }
	
	      newPxval = (0, _stripUnit["default"])(pxval);
	    }
	
	    if (typeof base === 'string') {
	      if (!(0, _endsWith["default"])(base, 'px')) {
	        throw new _errors["default"](70, to, base);
	      }
	
	      newBase = (0, _stripUnit["default"])(base);
	    }
	
	    if (typeof newPxval === 'string') {
	      throw new _errors["default"](71, pxval, to);
	    }
	
	    if (typeof newBase === 'string') {
	      throw new _errors["default"](72, base, to);
	    }
	
	    return "" + newPxval / newBase + to;
	  };
	};
	
	var _default = pxtoFactory;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	/**
	 * Reduces hex values if possible e.g. #ff8866 to #f86
	 * @private
	 */
	var reduceHexValue = function reduceHexValue(value) {
	  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
	    return "#" + value[1] + value[3] + value[5];
	  }
	
	  return value;
	};
	
	var _default = reduceHexValue;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function generateSelectors(template, state) {
	  var stateSuffix = state ? ":" + state : '';
	  return template(stateSuffix);
	}
	/**
	 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
	 * @private
	 */
	
	
	function statefulSelectors(states, template, stateMap) {
	  if (!template) throw new _errors["default"](67);
	  if (states.length === 0) return generateSelectors(template, null);
	  var selectors = [];
	
	  for (var i = 0; i < states.length; i += 1) {
	    if (stateMap && stateMap.indexOf(states[i]) < 0) {
	      throw new _errors["default"](68);
	    }
	
	    selectors.push(generateSelectors(template, states[i]));
	  }
	
	  selectors = selectors.join(',');
	  return selectors;
	}
	
	var _default = statefulSelectors;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = between;
	
	var _stripUnit5 =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(129));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   fontSize: between('20px', '100px', '400px', '1000px'),
	 *   fontSize: between('20px', '100px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
	 *   fontSize: ${between('20px', '100px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * h1: {
	 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
	 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
	 * }
	 */
	function between(fromSize, toSize, minScreen, maxScreen) {
	  if (minScreen === void 0) {
	    minScreen = '320px';
	  }
	
	  if (maxScreen === void 0) {
	    maxScreen = '1200px';
	  }
	
	  var _stripUnit = (0, _stripUnit5["default"])(fromSize, true),
	      unitlessFromSize = _stripUnit[0],
	      fromSizeUnit = _stripUnit[1];
	
	  var _stripUnit2 = (0, _stripUnit5["default"])(toSize, true),
	      unitlessToSize = _stripUnit2[0],
	      toSizeUnit = _stripUnit2[1];
	
	  var _stripUnit3 = (0, _stripUnit5["default"])(minScreen, true),
	      unitlessMinScreen = _stripUnit3[0],
	      minScreenUnit = _stripUnit3[1];
	
	  var _stripUnit4 = (0, _stripUnit5["default"])(maxScreen, true),
	      unitlessMaxScreen = _stripUnit4[0],
	      maxScreenUnit = _stripUnit4[1];
	
	  if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) {
	    throw new _errors["default"](47);
	  }
	
	  if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) {
	    throw new _errors["default"](48);
	  }
	
	  var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
	  var base = unitlessToSize - slope * unitlessMaxScreen;
	  return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
	}
	
	module.exports = exports.default;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = hiDPI;
	
	/**
	 * Generates a media query to target HiDPI devices.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *  [hiDPI(1.5)]: {
	 *    width: 200px;
	 *  }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${hiDPI(1.5)} {
	 *     width: 200px;
	 *   }
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
	 *  only screen and (min--moz-device-pixel-ratio: 1.5),
	 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
	 *  only screen and (min-resolution: 144dpi),
	 *  only screen and (min-resolution: 1.5dppx)': {
	 *   'width': '200px',
	 * }
	 */
	function hiDPI(ratio) {
	  if (ratio === void 0) {
	    ratio = 1.3;
	  }
	
	  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
	}
	
	module.exports = exports.default;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(72);
	var _inheritsLoose = __webpack_require__(81);
	var React = __webpack_require__(1);
	var reactDom = __webpack_require__(130);
	var reactPopper = __webpack_require__(1059);
	
	var TooltipContext = React.createContext({}); // eslint-disable-next-line @typescript-eslint/no-explicit-any
	
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	var callAll = function callAll() {
	  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return fns.forEach(function (fn) {
	      return fn && fn.apply(void 0, args);
	    });
	  };
	};
	var noop = function noop() {};
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	};
	
	var MUTATION_OBSERVER_CONFIG = {
	  childList: true,
	  subtree: true
	};
	
	var Tooltip =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(Tooltip, _Component);
	
	  function Tooltip() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.observer = void 0;
	    _this.tooltipRef = void 0;
	
	    _this.handleOutsideClick = function (event) {
	      if (_this.tooltipRef && !_this.tooltipRef.contains(event.target)) {
	        var parentOutsideClickHandler = _this.context.parentOutsideClickHandler;
	        var _this$props = _this.props,
	            hideTooltip = _this$props.hideTooltip,
	            clearScheduled = _this$props.clearScheduled;
	        clearScheduled();
	        hideTooltip();
	
	        if (parentOutsideClickHandler) {
	          parentOutsideClickHandler(event);
	        }
	      }
	    };
	
	    _this.handleOutsideRightClick = function (event) {
	      if (_this.tooltipRef && !_this.tooltipRef.contains(event.target)) {
	        var parentOutsideRightClickHandler = _this.context.parentOutsideRightClickHandler;
	        var _this$props2 = _this.props,
	            hideTooltip = _this$props2.hideTooltip,
	            clearScheduled = _this$props2.clearScheduled;
	        clearScheduled();
	        hideTooltip();
	
	        if (parentOutsideRightClickHandler) {
	          parentOutsideRightClickHandler(event);
	        }
	      }
	    };
	
	    _this.addOutsideClickHandler = function () {
	      document.body.addEventListener('touchend', _this.handleOutsideClick);
	      document.body.addEventListener('click', _this.handleOutsideClick);
	    };
	
	    _this.removeOutsideClickHandler = function () {
	      document.body.removeEventListener('touchend', _this.handleOutsideClick);
	      document.body.removeEventListener('click', _this.handleOutsideClick);
	    };
	
	    _this.addOutsideRightClickHandler = function () {
	      return document.body.addEventListener('contextmenu', _this.handleOutsideRightClick);
	    };
	
	    _this.removeOutsideRightClickHandler = function () {
	      return document.body.removeEventListener('contextmenu', _this.handleOutsideRightClick);
	    };
	
	    _this.getTooltipRef = function (ref) {
	      _this.tooltipRef = ref;
	
	      _this.props.innerRef(ref);
	    };
	
	    _this.getArrowProps = function (props) {
	      if (props === void 0) {
	        props = {};
	      }
	
	      return _extends({}, props, {
	        style: _extends({}, props.style, {}, _this.props.arrowProps.style)
	      });
	    };
	
	    _this.getTooltipProps = function (props) {
	      if (props === void 0) {
	        props = {};
	      }
	
	      var isHoverTriggered = _this.props.trigger === 'hover';
	      return _extends({}, props, {}, isHoverTriggered && {
	        onMouseEnter: callAll(_this.props.clearScheduled, props.onMouseEnter),
	        onMouseLeave: callAll(_this.props.hideTooltip, props.onMouseLeave)
	      }, {
	        style: _extends({}, props.style, {}, _this.props.style)
	      });
	    };
	
	    _this.contextValue = {
	      isParentNoneTriggered: _this.props.trigger === 'none',
	      addParentOutsideClickHandler: _this.addOutsideClickHandler,
	      addParentOutsideRightClickHandler: _this.addOutsideRightClickHandler,
	      parentOutsideClickHandler: _this.handleOutsideClick,
	      parentOutsideRightClickHandler: _this.handleOutsideRightClick,
	      removeParentOutsideClickHandler: _this.removeOutsideClickHandler,
	      removeParentOutsideRightClickHandler: _this.removeOutsideRightClickHandler
	    };
	    return _this;
	  }
	
	  var _proto = Tooltip.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var trigger = this.props.trigger;
	    var observer = this.observer = new MutationObserver(function () {
	      _this2.props.scheduleUpdate();
	    });
	    observer.observe(this.tooltipRef, MUTATION_OBSERVER_CONFIG);
	
	    if (trigger !== 'none' && trigger !== 'focus') {
	      var _this$context = this.context,
	          removeParentOutsideClickHandler = _this$context.removeParentOutsideClickHandler,
	          removeParentOutsideRightClickHandler = _this$context.removeParentOutsideRightClickHandler;
	      this.addOutsideClickHandler();
	      this.addOutsideRightClickHandler();
	
	      if (removeParentOutsideClickHandler) {
	        removeParentOutsideClickHandler();
	      }
	
	      if (removeParentOutsideRightClickHandler) {
	        removeParentOutsideRightClickHandler();
	      }
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    if (this.props.closeOnOutOfBoundaries && this.props.outOfBoundaries) {
	      this.props.hideTooltip();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    var trigger = this.props.trigger;
	
	    if (this.observer) {
	      this.observer.disconnect();
	    }
	
	    if (trigger !== 'none' && trigger !== 'focus') {
	      var _this$context2 = this.context,
	          isParentNoneTriggered = _this$context2.isParentNoneTriggered,
	          addParentOutsideClickHandler = _this$context2.addParentOutsideClickHandler,
	          addParentOutsideRightClickHandler = _this$context2.addParentOutsideRightClickHandler;
	      this.removeOutsideClickHandler();
	      this.removeOutsideRightClickHandler();
	      this.handleOutsideClick = undefined;
	      this.handleOutsideRightClick = undefined;
	
	      if (!isParentNoneTriggered && addParentOutsideClickHandler) {
	        addParentOutsideClickHandler();
	      }
	
	      if (!isParentNoneTriggered && addParentOutsideRightClickHandler) {
	        addParentOutsideRightClickHandler();
	      }
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props3 = this.props,
	        arrowProps = _this$props3.arrowProps,
	        placement = _this$props3.placement,
	        tooltip = _this$props3.tooltip;
	    return React.createElement(TooltipContext.Provider, {
	      value: this.contextValue
	    }, tooltip({
	      arrowRef: arrowProps.ref,
	      getArrowProps: this.getArrowProps,
	      getTooltipProps: this.getTooltipProps,
	      placement: placement,
	      tooltipRef: this.getTooltipRef
	    }));
	  };
	
	  return Tooltip;
	}(React.Component);
	
	Tooltip.contextType = TooltipContext;
	
	var DEFAULT_MODIFIERS = {
	  preventOverflow: {
	    boundariesElement: 'viewport'
	  }
	};
	
	var TooltipTrigger =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(TooltipTrigger, _Component);
	
	  function TooltipTrigger() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.state = {
	      tooltipShown: _this.props.defaultTooltipShown
	    };
	    _this.hideTimeout = void 0;
	    _this.showTimeout = void 0;
	    _this.popperOffset = void 0;
	
	    _this.setTooltipState = function (state) {
	      var cb = function cb() {
	        return _this.props.onVisibilityChange(state.tooltipShown);
	      };
	
	      _this.isControlled() ? cb() : _this.setState(state, cb);
	    };
	
	    _this.clearScheduled = function () {
	      clearTimeout(_this.hideTimeout);
	      clearTimeout(_this.showTimeout);
	    };
	
	    _this.showTooltip = function (_ref) {
	      var pageX = _ref.pageX,
	          pageY = _ref.pageY;
	
	      _this.clearScheduled();
	
	      var state = {
	        tooltipShown: true
	      };
	
	      if (_this.props.followCursor) {
	        state = _extends({}, state, {
	          pageX: pageX,
	          pageY: pageY
	        });
	      }
	
	      _this.showTimeout = window.setTimeout(function () {
	        return _this.setTooltipState(state);
	      }, _this.props.delayShow);
	    };
	
	    _this.hideTooltip = function () {
	      _this.clearScheduled();
	
	      _this.hideTimeout = window.setTimeout(function () {
	        return _this.setTooltipState({
	          tooltipShown: false
	        });
	      }, _this.props.delayHide);
	    };
	
	    _this.toggleTooltip = function (_ref2) {
	      var pageX = _ref2.pageX,
	          pageY = _ref2.pageY;
	      var action = _this.getState() ? 'hideTooltip' : 'showTooltip';
	
	      _this[action]({
	        pageX: pageX,
	        pageY: pageY
	      });
	    };
	
	    _this.clickToggle = function (event) {
	      event.preventDefault();
	      var pageX = event.pageX,
	          pageY = event.pageY;
	      var action = _this.props.followCursor ? 'showTooltip' : 'toggleTooltip';
	
	      _this[action]({
	        pageX: pageX,
	        pageY: pageY
	      });
	    };
	
	    _this.contextMenuToggle = function (event) {
	      event.preventDefault();
	      var pageX = event.pageX,
	          pageY = event.pageY;
	      var action = _this.props.followCursor ? 'showTooltip' : 'toggleTooltip';
	
	      _this[action]({
	        pageX: pageX,
	        pageY: pageY
	      });
	    };
	
	    _this.getTriggerProps = function (props) {
	      if (props === void 0) {
	        props = {};
	      }
	
	      return _extends({}, props, {}, _this.isTriggeredBy('click') && {
	        onClick: callAll(_this.clickToggle, props.onClick),
	        onTouchEnd: callAll(_this.clickToggle, props.onTouchEnd)
	      }, {}, _this.isTriggeredBy('right-click') && {
	        onContextMenu: callAll(_this.contextMenuToggle, props.onContextMenu)
	      }, {}, _this.isTriggeredBy('hover') && _extends({
	        onMouseEnter: callAll(_this.showTooltip, props.onMouseEnter),
	        onMouseLeave: callAll(_this.hideTooltip, props.onMouseLeave)
	      }, _this.props.followCursor && {
	        onMouseMove: callAll(_this.showTooltip, props.onMouseMove)
	      }), {}, _this.isTriggeredBy('focus') && {
	        onFocus: callAll(_this.showTooltip, props.onFocus),
	        onBlur: callAll(_this.hideTooltip, props.onBlur)
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = TooltipTrigger.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.clearScheduled();
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        tooltip = _this$props.tooltip,
	        placement = _this$props.placement,
	        trigger = _this$props.trigger,
	        getTriggerRef = _this$props.getTriggerRef,
	        modifiers = _this$props.modifiers,
	        closeOnOutOfBoundaries = _this$props.closeOnOutOfBoundaries,
	        usePortal = _this$props.usePortal,
	        portalContainer = _this$props.portalContainer,
	        followCursor = _this$props.followCursor,
	        getTooltipRef = _this$props.getTooltipRef;
	    var popper = React.createElement(reactPopper.Popper, {
	      innerRef: getTooltipRef,
	      placement: placement,
	      modifiers: _extends({}, DEFAULT_MODIFIERS, {}, followCursor && {
	        followCursorModifier: {
	          enabled: true,
	          fn: function fn(data) {
	            _this2.popperOffset = data.offsets.popper;
	            return data;
	          },
	          order: 1000
	        }
	      }, {}, modifiers)
	    }, function (_ref3) {
	      var ref = _ref3.ref,
	          style = _ref3.style,
	          placement = _ref3.placement,
	          arrowProps = _ref3.arrowProps,
	          outOfBoundaries = _ref3.outOfBoundaries,
	          scheduleUpdate = _ref3.scheduleUpdate;
	
	      if (followCursor && _this2.popperOffset) {
	        var _this2$state = _this2.state,
	            pageX = _this2$state.pageX,
	            pageY = _this2$state.pageY;
	        var _this2$popperOffset = _this2.popperOffset,
	            width = _this2$popperOffset.width,
	            height = _this2$popperOffset.height;
	        var x = pageX + width > window.scrollX + document.body.offsetWidth ? pageX - width : pageX;
	        var y = pageY + height > window.scrollY + document.body.offsetHeight ? pageY - height : pageY;
	        style.transform = "translate3d(" + x + "px, " + y + "px, 0";
	      }
	
	      return React.createElement(Tooltip, _extends({
	        arrowProps: arrowProps,
	        closeOnOutOfBoundaries: closeOnOutOfBoundaries,
	        outOfBoundaries: outOfBoundaries,
	        placement: placement,
	        scheduleUpdate: scheduleUpdate,
	        style: style,
	        tooltip: tooltip,
	        trigger: trigger
	      }, {
	        clearScheduled: _this2.clearScheduled,
	        hideTooltip: _this2.hideTooltip,
	        innerRef: ref
	      }));
	    });
	    return React.createElement(reactPopper.Manager, null, React.createElement(reactPopper.Reference, {
	      innerRef: getTriggerRef
	    }, function (_ref4) {
	      var ref = _ref4.ref;
	      return children({
	        getTriggerProps: _this2.getTriggerProps,
	        triggerRef: ref
	      });
	    }), this.getState() && (usePortal ? reactDom.createPortal(popper, portalContainer) : popper));
	  };
	
	  _proto.isControlled = function isControlled() {
	    return this.props.tooltipShown !== undefined;
	  };
	
	  _proto.getState = function getState() {
	    return this.isControlled() ? this.props.tooltipShown : this.state.tooltipShown;
	  };
	
	  _proto.isTriggeredBy = function isTriggeredBy(event) {
	    var trigger = this.props.trigger;
	    return trigger === event || Array.isArray(trigger) && trigger.includes(event);
	  };
	
	  return TooltipTrigger;
	}(React.Component);
	
	TooltipTrigger.defaultProps = {
	  closeOnOutOfBoundaries: true,
	  defaultTooltipShown: false,
	  delayHide: 0,
	  delayShow: 0,
	  followCursor: false,
	  onVisibilityChange: noop,
	  placement: 'right',
	  portalContainer: canUseDOM() ? document.body : null,
	  trigger: 'hover',
	  usePortal: canUseDOM()
	};
	
	module.exports = TooltipTrigger;
	//# sourceMappingURL=react-popper-tooltip.js.map


/***/ }),
/* 444 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	
	exports.safeInvoke = safeInvoke;

/***/ }),
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = css
	css.displayName = 'css'
	css.aliases = []
	function css(Prism) {
	  ;(function(Prism) {
	    var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/
	    Prism.languages.css = {
	      comment: /\/\*[\s\S]*?\*\//,
	      atrule: {
	        pattern: /@[\w-]+?[\s\S]*?(?:;|(?=\s*\{))/i,
	        inside: {
	          rule: /@[\w-]+/
	          // See rest below
	        }
	      },
	      url: RegExp('url\\((?:' + string.source + '|.*?)\\)', 'i'),
	      selector: RegExp(
	        '[^{}\\s](?:[^{};"\']|' + string.source + ')*?(?=\\s*\\{)'
	      ),
	      string: {
	        pattern: string,
	        greedy: true
	      },
	      property: /[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,
	      important: /!important\b/i,
	      function: /[-a-z0-9]+(?=\()/i,
	      punctuation: /[(){};:,]/
	    }
	    Prism.languages.css['atrule'].inside.rest = Prism.languages.css
	    var markup = Prism.languages.markup
	    if (markup) {
	      markup.tag.addInlined('style', 'css')
	      Prism.languages.insertBefore(
	        'inside',
	        'attr-value',
	        {
	          'style-attr': {
	            pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
	            inside: {
	              'attr-name': {
	                pattern: /^\s*style/i,
	                inside: markup.tag.inside
	              },
	              punctuation: /^\s*=\s*['"]|['"]\s*$/,
	              'attr-value': {
	                pattern: /.+/i,
	                inside: Prism.languages.css
	              }
	            },
	            alias: 'language-css'
	          }
	        },
	        markup.tag
	      )
	    }
	  })(Prism)
	}


/***/ }),
/* 456 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = markup
	markup.displayName = 'markup'
	markup.aliases = ['xml', 'html', 'mathml', 'svg']
	function markup(Prism) {
	  Prism.languages.markup = {
	    comment: /<!--[\s\S]*?-->/,
	    prolog: /<\?[\s\S]+?\?>/,
	    doctype: /<!DOCTYPE[\s\S]+?>/i,
	    cdata: /<!\[CDATA\[[\s\S]*?]]>/i,
	    tag: {
	      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/i,
	      greedy: true,
	      inside: {
	        tag: {
	          pattern: /^<\/?[^\s>\/]+/i,
	          inside: {
	            punctuation: /^<\/?/,
	            namespace: /^[^\s>\/:]+:/
	          }
	        },
	        'attr-value': {
	          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/i,
	          inside: {
	            punctuation: [
	              /^=/,
	              {
	                pattern: /^(\s*)["']|["']$/,
	                lookbehind: true
	              }
	            ]
	          }
	        },
	        punctuation: /\/?>/,
	        'attr-name': {
	          pattern: /[^\s>\/]+/,
	          inside: {
	            namespace: /^[^\s>\/:]+:/
	          }
	        }
	      }
	    },
	    entity: /&#?[\da-z]{1,8};/i
	  }
	  Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	    Prism.languages.markup['entity']
	  // Plugin to make entity title show the real entity, idea by Roman Komarov
	  Prism.hooks.add('wrap', function(env) {
	    if (env.type === 'entity') {
	      env.attributes['title'] = env.content.value.replace(/&amp;/, '&')
	    }
	  })
	  Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	    /**
	     * Adds an inlined language to markup.
	     *
	     * An example of an inlined language is CSS with `<style>` tags.
	     *
	     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	     * case insensitive.
	     * @param {string} lang The language key.
	     * @example
	     * addInlined('style', 'css');
	     */
	    value: function addInlined(tagName, lang) {
	      var includedCdataInside = {}
	      includedCdataInside['language-' + lang] = {
	        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
	        lookbehind: true,
	        inside: Prism.languages[lang]
	      }
	      includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i
	      var inside = {
	        'included-cdata': {
	          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
	          inside: includedCdataInside
	        }
	      }
	      inside['language-' + lang] = {
	        pattern: /[\s\S]+/,
	        inside: Prism.languages[lang]
	      }
	      var def = {}
	      def[tagName] = {
	        pattern: RegExp(
	          /(<__[\s\S]*?>)(?:<!\[CDATA\[[\s\S]*?\]\]>\s*|[\s\S])*?(?=<\/__>)/.source.replace(
	            /__/g,
	            tagName
	          ),
	          'i'
	        ),
	        lookbehind: true,
	        greedy: true,
	        inside: inside
	      }
	      Prism.languages.insertBefore('markup', 'cdata', def)
	    }
	  })
	  Prism.languages.xml = Prism.languages.extend('markup', {})
	  Prism.languages.html = Prism.languages.markup
	  Prism.languages.mathml = Prism.languages.markup
	  Prism.languages.svg = Prism.languages.markup
	}


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var caseSensitiveTransform = __webpack_require__(1102)
	
	module.exports = caseInsensitiveTransform
	
	function caseInsensitiveTransform(attributes, property) {
	  return caseSensitiveTransform(attributes, property.toLowerCase())
	}


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var Info = __webpack_require__(459)
	var types = __webpack_require__(280)
	
	module.exports = DefinedInfo
	
	DefinedInfo.prototype = new Info()
	DefinedInfo.prototype.defined = true
	
	function DefinedInfo(property, attribute, mask, space) {
	  mark(this, 'space', space)
	  Info.call(this, property, attribute)
	  mark(this, 'boolean', check(mask, types.boolean))
	  mark(this, 'booleanish', check(mask, types.booleanish))
	  mark(this, 'overloadedBoolean', check(mask, types.overloadedBoolean))
	  mark(this, 'number', check(mask, types.number))
	  mark(this, 'commaSeparated', check(mask, types.commaSeparated))
	  mark(this, 'spaceSeparated', check(mask, types.spaceSeparated))
	  mark(this, 'commaOrSpaceSeparated', check(mask, types.commaOrSpaceSeparated))
	}
	
	function mark(values, key, value) {
	  if (value) {
	    values[key] = value
	  }
	}
	
	function check(value, mask) {
	  return (value & mask) === mask
	}


/***/ }),
/* 459 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = Info
	
	var proto = Info.prototype
	
	proto.space = null
	proto.attribute = null
	proto.property = null
	proto.boolean = false
	proto.booleanish = false
	proto.overloadedBoolean = false
	proto.number = false
	proto.commaSeparated = false
	proto.spaceSeparated = false
	proto.commaOrSpaceSeparated = false
	proto.mustUseProperty = false
	proto.defined = false
	
	function Info(property, attribute) {
	  this.property = property
	  this.attribute = attribute
	}


/***/ }),
/* 460 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = Schema
	
	var proto = Schema.prototype
	
	proto.space = null
	proto.normal = {}
	proto.property = {}
	
	function Schema(property, normal, space) {
	  this.property = property
	  this.normal = normal
	
	  if (space) {
	    this.space = space
	  }
	}


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(290);
	var Stylis = _interopDefault(__webpack_require__(466));
	__webpack_require__(293);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(188);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	exports.default = murmurhash2_32_gc;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(72));
	var React = __webpack_require__(1);
	var isPropValid = _interopDefault(__webpack_require__(288));
	var core = __webpack_require__(137);
	var utils = __webpack_require__(292);
	var serialize = __webpack_require__(188);
	
	var testOmitPropsOnStringTag = isPropValid;
	
	var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	
	var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
	  return typeof tag === 'string' && // 96 is one less than the char code
	  // for "a" so this is checking that
	  // it's a lowercase character
	  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
	};
	
	var createStyled = function createStyled(tag, options) {
	  if (false) {
	    if (tag === undefined) {
	      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	    }
	  }
	
	  var identifierName;
	  var shouldForwardProp;
	  var targetClassName;
	
	  if (options !== undefined) {
	    identifierName = options.label;
	    targetClassName = options.target;
	    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
	      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
	      options.shouldForwardProp(propName);
	    } : options.shouldForwardProp;
	  }
	
	  var isReal = tag.__emotion_real === tag;
	  var baseTag = isReal && tag.__emotion_base || tag;
	
	  if (typeof shouldForwardProp !== 'function' && isReal) {
	    shouldForwardProp = tag.__emotion_forwardProp;
	  }
	
	  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
	  var shouldUseAs = !defaultShouldForwardProp('as');
	  return function () {
	    var args = arguments;
	    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
	
	    if (identifierName !== undefined) {
	      styles.push("label:" + identifierName + ";");
	    }
	
	    if (args[0] == null || args[0].raw === undefined) {
	      styles.push.apply(styles, args);
	    } else {
	      styles.push(args[0][0]);
	      var len = args.length;
	      var i = 1;
	
	      for (; i < len; i++) {
	        styles.push(args[i], args[0][i]);
	      }
	    }
	
	    var Styled = core.withEmotionCache(function (props, context, ref) {
	      return React.createElement(core.ThemeContext.Consumer, null, function (theme) {
	        var finalTag = shouldUseAs && props.as || baseTag;
	        var className = '';
	        var classInterpolations = [];
	        var mergedProps = props;
	
	        if (props.theme == null) {
	          mergedProps = {};
	
	          for (var key in props) {
	            mergedProps[key] = props[key];
	          }
	
	          mergedProps.theme = theme;
	        }
	
	        if (typeof props.className === 'string') {
	          className += utils.getRegisteredStyles(context.registered, classInterpolations, props.className);
	        }
	
	        var serialized = serialize.serializeStyles(styles.concat(classInterpolations), context.registered, mergedProps);
	        var rules = utils.insertStyles(context, serialized, typeof finalTag === 'string');
	        className += context.key + "-" + serialized.name;
	
	        if (targetClassName !== undefined) {
	          className += " " + targetClassName;
	        }
	
	        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
	        var newProps = {};
	
	        for (var _key in props) {
	          if (shouldUseAs && _key === 'as') continue;
	
	          if ( // $FlowFixMe
	          finalShouldForwardProp(_key)) {
	            newProps[_key] = props[_key];
	          }
	        }
	
	        newProps.className = className;
	        newProps.ref = ref || props.innerRef;
	
	        if (false) {
	          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
	        }
	
	        var ele = React.createElement(finalTag, newProps);
	
	        return ele;
	      });
	    });
	    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	    Styled.defaultProps = tag.defaultProps;
	    Styled.__emotion_real = Styled;
	    Styled.__emotion_base = baseTag;
	    Styled.__emotion_styles = styles;
	    Styled.__emotion_forwardProp = shouldForwardProp;
	    Object.defineProperty(Styled, 'toString', {
	      value: function value() {
	        if (targetClassName === undefined && ("production") !== 'production') {
	          return 'NO_COMPONENT_SELECTOR';
	        } // $FlowFixMe
	
	
	        return "." + targetClassName;
	      }
	    });
	
	    Styled.withComponent = function (nextTag, nextOptions) {
	      return createStyled(nextTag, nextOptions !== undefined ? _extends({}, options || {}, nextOptions) : options).apply(void 0, styles);
	    };
	
	    return Styled;
	  };
	};
	
	exports.default = createStyled;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var styled = _interopDefault(__webpack_require__(464));
	
	var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	var newStyled = styled.bind();
	tags.forEach(function (tagName) {
	  newStyled[tagName] = newStyled(tagName);
	});
	
	exports.default = newStyled;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ }),
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(63);
	
	__webpack_require__(9);
	
	__webpack_require__(64);
	
	__webpack_require__(3);
	
	__webpack_require__(65);
	
	__webpack_require__(66);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Badge = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _templateObject6() {
	  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: ", ";\n    "]);
	
	  _templateObject6 = function _templateObject6() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject5() {
	  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: ", ";\n    "]);
	
	  _templateObject5 = function _templateObject5() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject4() {
	  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: ", ";\n    "]);
	
	  _templateObject4 = function _templateObject4() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject3() {
	  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: ", ";\n    "]);
	
	  _templateObject3 = function _templateObject3() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject2() {
	  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: ", ";\n    "]);
	
	  _templateObject2 = function _templateObject2() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: 11px;\n  line-height: 12px;\n  align-self: center;\n  padding: 4px 12px;\n  border-radius: 3em;\n  font-weight: ", ";\n\n  svg {\n    height: 12px;\n    width: 12px;\n    margin-right: 4px;\n    margin-top: -2px;\n\n    path {\n      fill: currentColor;\n    }\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var BadgeWrapper = _theming.styled.div(_templateObject(), function (props) {
	  return props.theme.typography.weight.bold;
	}, function (props) {
	  return props.status === 'critical' && (0, _theming.css)(_templateObject2(), props.theme.color.critical, props.theme.background.critical);
	}, function (props) {
	  return props.status === 'negative' && (0, _theming.css)(_templateObject3(), props.theme.color.negative, props.theme.background.negative);
	}, function (props) {
	  return props.status === 'warning' && (0, _theming.css)(_templateObject4(), props.theme.color.warning, props.theme.background.warning);
	}, function (props) {
	  return props.status === 'neutral' && (0, _theming.css)(_templateObject5(), props.theme.color.dark, props.theme.color.mediumlight);
	}, function (props) {
	  return props.status === 'positive' && (0, _theming.css)(_templateObject6(), props.theme.color.positive, props.theme.background.positive);
	});
	
	var Badge = function Badge(_ref) {
	  var props = Object.assign({}, _ref);
	  return _react["default"].createElement(BadgeWrapper, props);
	};
	
	exports.Badge = Badge;
	Badge.displayName = "Badge";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getScrollAreaStyles = void 0;
	
	var getScrollAreaStyles = function getScrollAreaStyles(theme) {
	  return {
	    '[data-simplebar]': {
	      position: 'relative',
	      flexDirection: 'column',
	      flexWrap: 'wrap',
	      justifyContent: 'flex-start',
	      alignContent: 'flex-start',
	      alignItems: 'flex-start'
	    },
	    '.simplebar-wrapper': {
	      overflow: 'hidden',
	      width: 'inherit',
	      height: 'inherit',
	      maxWidth: 'inherit',
	      maxHeight: 'inherit'
	    },
	    '.simplebar-mask': {
	      direction: 'inherit',
	      position: 'absolute',
	      overflow: 'hidden',
	      padding: 0,
	      margin: 0,
	      left: 0,
	      top: 0,
	      bottom: 0,
	      right: 0,
	      width: 'auto !important',
	      height: 'auto !important',
	      zIndex: 0
	    },
	    '.simplebar-offset': {
	      direction: 'inherit !important',
	      resize: 'none !important',
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      bottom: 0,
	      right: 0,
	      padding: 0,
	      margin: 0,
	      WebkitOverflowScrolling: 'touch'
	    },
	    '.simplebar-content-wrapper': {
	      direction: 'inherit',
	      position: 'relative',
	      display: 'block',
	      visibility: 'visible'
	    },
	    '.simplebar-placeholder': {
	      maxHeight: '100%',
	      maxWidth: '100%',
	      width: '100%',
	      pointerEvents: 'none'
	    },
	    '.simplebar-height-auto-observer-wrapper': {
	      height: '100%',
	      width: 'inherit',
	      maxWidth: 1,
	      position: 'relative',
	      "float": 'left',
	      maxHeight: 1,
	      overflow: 'hidden',
	      zIndex: -1,
	      padding: 0,
	      margin: 0,
	      pointerEvents: 'none',
	      flexGrow: 'inherit',
	      flexShrink: 0,
	      flexBasis: 0
	    },
	    '.simplebar-height-auto-observer': {
	      display: 'block',
	      opacity: 0,
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      height: '1000%',
	      width: '1000%',
	      minHeight: 1,
	      minWidth: 1,
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      zIndex: -1
	    },
	    '.simplebar-track': {
	      zIndex: 1,
	      position: 'absolute',
	      right: 0,
	      bottom: 0,
	      pointerEvents: 'none',
	      overflow: 'hidden'
	    },
	    '[data-simplebar].simplebar-dragging .simplebar-track': {
	      pointerEvents: 'all'
	    },
	    '.simplebar-scrollbar': {
	      position: 'absolute',
	      right: 2,
	      width: 7,
	      minHeight: 10
	    },
	    '.simplebar-scrollbar:before': {
	      position: 'absolute',
	      content: '""',
	      borderRadius: 7,
	      left: 0,
	      right: 0,
	      opacity: 0,
	      transition: 'opacity 0.2s linear',
	      background: theme.base === 'light' ? theme.color.darkest : theme.color.lightest
	    },
	    '.simplebar-track .simplebar-scrollbar.simplebar-visible:before': {
	      opacity: 0.5,
	      transition: 'opacity 0s linear'
	    },
	    '.simplebar-track.simplebar-vertical': {
	      top: 0,
	      width: 11
	    },
	    '.simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
	      top: 2,
	      bottom: 2
	    },
	    '.simplebar-track.simplebar-horizontal': {
	      left: 0,
	      height: 11
	    },
	    '.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before': {
	      height: '100%',
	      left: 2,
	      right: 2
	    },
	    '.simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
	      right: 'auto',
	      left: 0,
	      top: 2,
	      height: 7,
	      minHeight: 0,
	      minWidth: 10,
	      width: 'auto'
	    },
	    '[data-simplebar-direction="rtl"] .simplebar-track.simplebar-vertical': {
	      right: 'auto',
	      left: 0
	    }
	  };
	};
	
	exports.getScrollAreaStyles = getScrollAreaStyles;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	__webpack_require__(30);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddonPanel = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	var usePrevious = function usePrevious(value) {
	  var ref = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    // happens after return
	    ref.current = value;
	  }, [value]);
	  return ref.current;
	};
	
	var useUpdate = function useUpdate(update, value) {
	  var previousValue = usePrevious(value);
	  return update ? value : previousValue;
	};
	
	var AddonPanel = function AddonPanel(_ref) {
	  var active = _ref.active,
	      children = _ref.children;
	  return (// the transform is to prevent a bug where the content would be invisible
	    // the hidden attribute is an valid html element that's both accessible and works to visually hide content
	    _react["default"].createElement("div", {
	      hidden: !active,
	      style: {
	        transform: 'translateX(0px)'
	      }
	    }, useUpdate(active, children))
	  );
	};
	
	exports.AddonPanel = AddonPanel;
	AddonPanel.displayName = "AddonPanel";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(154);
	
	__webpack_require__(3);
	
	__webpack_require__(30);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.interleaveSeparators = exports.Separator = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	var Separator = _theming.styled.span(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    width: 1,
	    height: 24,
	    background: theme.appBorderColor,
	    marginTop: 8
	  };
	}, function (_ref2) {
	  var force = _ref2.force;
	  return force ? {} : {
	    '& + &': {
	      display: 'none'
	    }
	  };
	});
	
	exports.Separator = Separator;
	Separator.displayName = 'Separator';
	
	var interleaveSeparators = function interleaveSeparators(list) {
	  return list.reduce(function (acc, item, index) {
	    return item ? _react["default"].createElement(_react.Fragment, {
	      key: item.id || item.key || "f-".concat(index)
	    }, acc, index > 0 ? _react["default"].createElement(Separator, {
	      key: "s-".concat(index)
	    }) : null, item.render() || item) : acc;
	  }, null);
	};
	
	exports.interleaveSeparators = interleaveSeparators;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(49);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	__webpack_require__(66);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorPalette = exports.ColorItem = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _polished = __webpack_require__(27);
	
	var _BlockBackgroundStyles = __webpack_require__(142);
	
	var _DocumentFormatting = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var ItemTitle = _theming.styled.div(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    fontWeight: theme.typography.weight.bold,
	    color: theme.color.defaultText
	  };
	});
	
	var ItemSubtitle = _theming.styled.div(function (_ref2) {
	  var theme = _ref2.theme;
	  return {
	    color: theme.base === 'light' ? (0, _polished.transparentize)(0.2, theme.color.defaultText) : (0, _polished.transparentize)(0.6, theme.color.defaultText)
	  };
	});
	
	var ItemDescription = _theming.styled.div({
	  flex: '0 0 30%',
	  lineHeight: '20px',
	  marginTop: 5
	});
	
	var SwatchLabel = _theming.styled.div(function (_ref3) {
	  var theme = _ref3.theme;
	  return {
	    flex: 1,
	    textAlign: 'center',
	    fontFamily: theme.typography.fonts.mono,
	    fontSize: theme.typography.size.s1,
	    lineHeight: 1,
	    overflow: 'hidden',
	    color: theme.base === 'light' ? (0, _polished.transparentize)(0.4, theme.color.defaultText) : (0, _polished.transparentize)(0.6, theme.color.defaultText),
	    '> div': {
	      display: 'inline-block',
	      overflow: 'hidden',
	      maxWidth: '100%'
	    }
	  };
	});
	
	var SwatchLabels = _theming.styled.div({
	  display: 'flex',
	  flexDirection: 'row'
	});
	
	var Swatch = _theming.styled.div({
	  flex: 1
	});
	
	var SwatchColors = _theming.styled.div(function (_ref4) {
	  var theme = _ref4.theme;
	  return Object.assign({}, (0, _BlockBackgroundStyles.getBlockBackgroundStyle)(theme), {
	    display: 'flex',
	    flexDirection: 'row',
	    height: 50,
	    marginBottom: 5,
	    overflow: 'hidden'
	  });
	});
	
	var SwatchSpecimen = _theming.styled.div({
	  display: 'flex',
	  flexDirection: 'column',
	  flex: 1,
	  position: 'relative',
	  marginBottom: 30
	});
	
	var Swatches = _theming.styled.div({
	  flex: 1,
	  display: 'flex',
	  flexDirection: 'row'
	});
	
	var Item = _theming.styled.div({
	  display: 'flex',
	  alignItems: 'flex-start'
	});
	
	var ListName = _theming.styled.div({
	  flex: '0 0 30%'
	});
	
	var ListSwatches = _theming.styled.div({
	  flex: 1
	});
	
	var ListHeading = _theming.styled.div(function (_ref5) {
	  var theme = _ref5.theme;
	  return {
	    display: 'flex',
	    flexDirection: 'row',
	    alignItems: 'center',
	    paddingBottom: 20,
	    fontWeight: theme.typography.weight.bold,
	    color: theme.base === 'light' ? (0, _polished.transparentize)(0.4, theme.color.defaultText) : (0, _polished.transparentize)(0.6, theme.color.defaultText)
	  };
	});
	
	var List = _theming.styled.div(function (_ref6) {
	  var theme = _ref6.theme;
	  return {
	    fontSize: theme.typography.size.s2,
	    lineHeight: "20px",
	    display: 'flex',
	    flexDirection: 'column'
	  };
	});
	
	/**
	 * A single color row your styleguide showing title, subtitle and one or more colors, used
	 * as a child of `ColorPalette`.
	 */
	var ColorItem = function ColorItem(_ref7) {
	  var title = _ref7.title,
	      subtitle = _ref7.subtitle,
	      colors = _ref7.colors;
	  return _react["default"].createElement(Item, null, _react["default"].createElement(ItemDescription, null, _react["default"].createElement(ItemTitle, null, title), _react["default"].createElement(ItemSubtitle, null, subtitle)), _react["default"].createElement(Swatches, null, _react["default"].createElement(SwatchSpecimen, null, _react["default"].createElement(SwatchColors, null, colors.map(function (color) {
	    return _react["default"].createElement(Swatch, {
	      key: color,
	      title: color,
	      style: {
	        backgroundColor: color
	      }
	    });
	  })), _react["default"].createElement(SwatchLabels, null, colors.map(function (color) {
	    return _react["default"].createElement(SwatchLabel, {
	      key: color,
	      title: color
	    }, _react["default"].createElement("div", null, color));
	  })))));
	};
	
	exports.ColorItem = ColorItem;
	ColorItem.displayName = "ColorItem";
	
	var _ref9 =
	/*#__PURE__*/
	_react["default"].createElement(ListHeading, null, _react["default"].createElement(ListName, null, "Name"), _react["default"].createElement(ListSwatches, null, "Swatches"));
	
	/**
	 * Styleguide documentation for colors, including names, captions, and color swatches,
	 * all specified as `ColorItem` children of this wrapper component.
	 */
	var ColorPalette = function ColorPalette(_ref8) {
	  var children = _ref8.children,
	      props = _objectWithoutProperties(_ref8, ["children"]);
	
	  return _react["default"].createElement(_DocumentFormatting.ResetWrapper, null, _react["default"].createElement(List, _extends({}, props, {
	    className: "docblock-colorpalette"
	  }), _ref9, children));
	};
	
	exports.ColorPalette = ColorPalette;
	ColorPalette.displayName = "ColorPalette";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Description = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _markdownToJsx = _interopRequireDefault(__webpack_require__(988));
	
	var _DocumentFormatting = __webpack_require__(101);
	
	var _html = __webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * A markdown description for a component, typically used to show the
	 * components docgen docs.
	 */
	var Description = function Description(_ref) {
	  var markdown = _ref.markdown;
	  return _react["default"].createElement(_DocumentFormatting.ResetWrapper, null, _react["default"].createElement(_markdownToJsx["default"], {
	    options: {
	      forceBlock: true,
	      overrides: _html.components
	    }
	  }, markdown));
	};
	
	exports.Description = Description;
	Description.displayName = "Description";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DocsPage = exports.DocsPageWrapper = exports.DocsWrapper = exports.DocsContent = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _polished = __webpack_require__(27);
	
	var _withReset = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var breakpoint = 600;
	var pageMargin = '5.55555';
	
	var Title = _theming.styled.h1(_withReset.withReset, function (_ref) {
	  var theme = _ref.theme;
	  return _defineProperty({
	    color: theme.color.defaultText,
	    fontSize: theme.typography.size.m3,
	    fontWeight: theme.typography.weight.black,
	    lineHeight: '32px'
	  }, "@media (min-width: ".concat(breakpoint * 1, "px)"), {
	    fontSize: theme.typography.size.l1,
	    lineHeight: '36px',
	    marginBottom: '.5rem' // 8px
	
	  });
	});
	
	var Subtitle = _theming.styled.h2(_withReset.withReset, function (_ref3) {
	  var _ref4;
	
	  var theme = _ref3.theme;
	  return _ref4 = {
	    fontWeight: theme.typography.weight.regular,
	    fontSize: theme.typography.size.s3,
	    lineHeight: '20px',
	    borderBottom: 'none',
	    marginBottom: '15px'
	  }, _defineProperty(_ref4, "@media (min-width: ".concat(breakpoint * 1, "px)"), {
	    fontSize: theme.typography.size.m1,
	    lineHeight: '28px',
	    marginBottom: '24px'
	  }), _defineProperty(_ref4, "color", theme.base === 'light' ? (0, _polished.transparentize)(0.25, theme.color.defaultText) : (0, _polished.transparentize)(0.25, theme.color.defaultText)), _ref4;
	});
	
	var DocsContent = _theming.styled.div({
	  maxWidth: 800,
	  width: '100%'
	});
	
	exports.DocsContent = DocsContent;
	
	var DocsWrapper = _theming.styled.div(function (_ref5) {
	  var theme = _ref5.theme;
	  return _defineProperty({
	    background: theme.background.content,
	    display: 'flex',
	    justifyContent: 'center',
	    minHeight: '100vh',
	    padding: '4rem 20px'
	  }, "@media (min-width: ".concat(breakpoint * 1, "px)"), {});
	});
	
	exports.DocsWrapper = DocsWrapper;
	
	var DocsPageWrapper = function DocsPageWrapper(_ref7) {
	  var children = _ref7.children;
	  return _react["default"].createElement(DocsWrapper, null, _react["default"].createElement(DocsContent, null, children));
	};
	
	exports.DocsPageWrapper = DocsPageWrapper;
	DocsPageWrapper.displayName = "DocsPageWrapper";
	
	/**
	 * An out-of-the box documentation page for components that shows the
	 * title & subtitle and a collection of blocks including `Description`,
	 * and `Preview`s for each of the component's stories.
	 */
	var DocsPage = function DocsPage(_ref8) {
	  var title = _ref8.title,
	      subtitle = _ref8.subtitle,
	      children = _ref8.children;
	  return _react["default"].createElement(_react["default"].Fragment, null, title && _react["default"].createElement(Title, {
	    className: "sbdocs-title"
	  }, title), subtitle && _react["default"].createElement(Subtitle, {
	    className: "sbdocs-subtitle"
	  }, subtitle), children);
	};
	
	exports.DocsPage = DocsPage;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(211);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconGallery = exports.IconItem = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _DocumentFormatting = __webpack_require__(101);
	
	var _BlockBackgroundStyles = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var ItemLabel = _theming.styled.div(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    fontFamily: theme.typography.fonts.base,
	    fontSize: theme.typography.size.s2,
	    marginLeft: 10,
	    lineHeight: 1.2
	  };
	});
	
	var ItemSpecimen = _theming.styled.div(function (_ref2) {
	  var theme = _ref2.theme;
	  return Object.assign({}, (0, _BlockBackgroundStyles.getBlockBackgroundStyle)(theme), {
	    overflow: 'hidden',
	    height: 40,
	    width: 40,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    flex: 'none',
	    '> img, > svg': {
	      width: 20,
	      height: 20
	    }
	  });
	});
	
	var Item = _theming.styled.div({
	  display: 'inline-flex',
	  flexDirection: 'row',
	  alignItems: 'center',
	  flex: '0 1 calc(20% - 10px)',
	  minWidth: 120,
	  margin: '0px 10px 30px 0'
	});
	
	var List = _theming.styled.div({
	  display: 'flex',
	  flexFlow: 'row wrap'
	});
	
	/**
	 * An individual icon with a caption and an example (passed as `children`).
	 */
	var IconItem = function IconItem(_ref3) {
	  var name = _ref3.name,
	      children = _ref3.children;
	  return _react["default"].createElement(Item, null, _react["default"].createElement(ItemSpecimen, null, children), _react["default"].createElement(ItemLabel, null, name));
	};
	
	exports.IconItem = IconItem;
	IconItem.displayName = "IconItem";
	
	/**
	 * Show a grid of icons, as specified by `IconItem`.
	 */
	var IconGallery = function IconGallery(_ref4) {
	  var children = _ref4.children,
	      props = _objectWithoutProperties(_ref4, ["children"]);
	
	  return _react["default"].createElement(_DocumentFormatting.ResetWrapper, null, _react["default"].createElement(List, _extends({}, props, {
	    className: "docblock-icongallery"
	  }), children));
	};
	
	exports.IconGallery = IconGallery;
	IconGallery.displayName = "IconGallery";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(51);
	
	__webpack_require__(68);
	
	__webpack_require__(11);
	
	__webpack_require__(62);
	
	__webpack_require__(48);
	
	__webpack_require__(49);
	
	__webpack_require__(341);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	__webpack_require__(50);
	
	__webpack_require__(344);
	
	__webpack_require__(67);
	
	__webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Preview = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _polished = __webpack_require__(27);
	
	var _clientLogger = __webpack_require__(138);
	
	var _BlockBackgroundStyles = __webpack_require__(142);
	
	var _Source = __webpack_require__(308);
	
	var _ActionBar = __webpack_require__(194);
	
	var _Toolbar = __webpack_require__(504);
	
	var _ZoomContext = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ChildrenContainer = _theming.styled.div(function (_ref) {
	  var isColumn = _ref.isColumn,
	      columns = _ref.columns;
	  return {
	    display: 'flex',
	    flexWrap: 'wrap',
	    flexDirection: isColumn ? 'column' : 'row',
	    marginTop: -20,
	    '> *': {
	      flex: columns ? "1 1 calc(100%/".concat(columns, " - 20px)") : "1 1 0%",
	      marginRight: 20,
	      marginTop: 20
	    }
	  };
	});
	
	var StyledSource = (0, _theming.styled)(_Source.Source)(function (_ref2) {
	  var theme = _ref2.theme;
	  return {
	    margin: 0,
	    borderTopLeftRadius: 0,
	    borderTopRightRadius: 0,
	    borderBottomLeftRadius: theme.appBorderRadius,
	    borderBottomRightRadius: theme.appBorderRadius,
	    border: 'none',
	    background: theme.base === 'light' ? 'rgba(0, 0, 0, 0.85)' : (0, _polished.darken)(0.05, theme.background.content),
	    color: theme.color.lightest,
	    button: {
	      background: theme.base === 'light' ? 'rgba(0, 0, 0, 0.85)' : (0, _polished.darken)(0.05, theme.background.content)
	    }
	  };
	});
	
	var PreviewWrapper = _theming.styled.div(function (_ref3) {
	  var theme = _ref3.theme,
	      withSource = _ref3.withSource,
	      isExpanded = _ref3.isExpanded;
	  return Object.assign({}, (0, _BlockBackgroundStyles.getBlockBackgroundStyle)(theme), {
	    padding: '30px 20px',
	    position: 'relative',
	    overflow: 'hidden',
	    borderBottomLeftRadius: withSource && isExpanded && 0,
	    borderBottomRightRadius: withSource && isExpanded && 0,
	    borderBottomWidth: isExpanded && 0
	  });
	}, function (_ref4) {
	  var withToolbar = _ref4.withToolbar;
	  return withToolbar && {
	    paddingTop: 64
	  };
	});
	
	var PreviewContainer = _theming.styled.div({
	  margin: '25px 0 40px'
	});
	
	var getSource = function getSource(withSource, expanded, setExpanded) {
	  switch (true) {
	    case !!(withSource && withSource.error):
	      {
	        return {
	          source: null,
	          actionItem: {
	            title: 'No code available',
	            disabled: true,
	            onClick: function onClick() {
	              return setExpanded(false);
	            }
	          }
	        };
	      }
	
	    case expanded:
	      {
	        return {
	          source: _react["default"].createElement(StyledSource, _extends({}, withSource, {
	            dark: true
	          })),
	          actionItem: {
	            title: 'Hide code',
	            onClick: function onClick() {
	              return setExpanded(false);
	            }
	          }
	        };
	      }
	
	    default:
	      {
	        return {
	          source: null,
	          actionItem: {
	            title: 'Show code',
	            onClick: function onClick() {
	              return setExpanded(true);
	            }
	          }
	        };
	      }
	  }
	};
	
	function getStoryId(children) {
	  if (_react["default"].Children.count(children) === 1) {
	    var elt = children;
	
	    if (elt.props) {
	      return elt.props.id;
	    }
	  }
	
	  return null;
	}
	/**
	 * A preview component for showing one or more component `Story`
	 * items. The preview also shows the source for the component
	 * as a drop-down.
	 */
	
	
	var Preview = function Preview(_ref5) {
	  var isColumn = _ref5.isColumn,
	      columns = _ref5.columns,
	      children = _ref5.children,
	      withSource = _ref5.withSource,
	      _ref5$withToolbar = _ref5.withToolbar,
	      withToolbar = _ref5$withToolbar === void 0 ? false : _ref5$withToolbar,
	      _ref5$isExpanded = _ref5.isExpanded,
	      isExpanded = _ref5$isExpanded === void 0 ? false : _ref5$isExpanded,
	      props = _objectWithoutProperties(_ref5, ["isColumn", "columns", "children", "withSource", "withToolbar", "isExpanded"]);
	
	  var _React$useState = _react["default"].useState(isExpanded),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      expanded = _React$useState2[0],
	      setExpanded = _React$useState2[1];
	
	  var _getSource = getSource(withSource, expanded, setExpanded),
	      source = _getSource.source,
	      actionItem = _getSource.actionItem;
	
	  var _React$useState3 = _react["default"].useState(1),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      scale = _React$useState4[0],
	      setScale = _React$useState4[1];
	
	  if (withToolbar && Array.isArray(children)) {
	    _clientLogger.logger.warn('Cannot use toolbar with multiple preview children, disabling');
	  }
	
	  var showToolbar = withToolbar && !Array.isArray(children);
	  return _react["default"].createElement(PreviewContainer, props, _react["default"].createElement(PreviewWrapper, {
	    withSource: withSource,
	    withToolbar: showToolbar
	  }, showToolbar && _react["default"].createElement(_Toolbar.Toolbar, {
	    border: true,
	    zoom: function zoom(z) {
	      return setScale(scale * z);
	    },
	    resetZoom: function resetZoom() {
	      return setScale(1);
	    },
	    storyId: getStoryId(children),
	    baseUrl: "./iframe.html"
	  }), _react["default"].createElement(_ZoomContext.ZoomContext.Provider, {
	    value: {
	      scale: scale
	    }
	  }, _react["default"].createElement(ChildrenContainer, {
	    isColumn: isColumn,
	    columns: columns
	  }, Array.isArray(children) ? children.map(function (child, i) {
	    return _react["default"].createElement("div", {
	      key: i.toString()
	    }, child);
	  }) : _react["default"].createElement("div", null, children))), withSource && _react["default"].createElement(_ActionBar.ActionBar, {
	    actionItems: [actionItem]
	  })), withSource && source);
	};
	
	exports.Preview = Preview;
	Preview.displayName = "Preview";

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(51);
	
	__webpack_require__(112);
	
	__webpack_require__(62);
	
	__webpack_require__(550);
	
	__webpack_require__(49);
	
	__webpack_require__(341);
	
	__webpack_require__(211);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	__webpack_require__(50);
	
	__webpack_require__(344);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PropRow = exports.PrettyPropVal = exports.PrettyPropType = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _polished = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var PropType;
	
	(function (PropType) {
	  PropType["SHAPE"] = "shape";
	  PropType["UNION"] = "union";
	  PropType["ARRAYOF"] = "arrayOf";
	  PropType["OBJECTOF"] = "objectOf";
	  PropType["ENUM"] = "enum";
	  PropType["INSTANCEOF"] = "instanceOf";
	})(PropType || (PropType = {}));
	
	var Name = _theming.styled.span({
	  fontWeight: 'bold'
	});
	
	var Required = _theming.styled.span(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    color: theme.color.negative,
	    fontFamily: theme.typography.fonts.mono,
	    cursor: 'help'
	  };
	});
	
	var StyledPropDef = _theming.styled.div(function (_ref2) {
	  var theme = _ref2.theme;
	  return {
	    color: theme.base === 'light' ? (0, _polished.transparentize)(0.4, theme.color.defaultText) : (0, _polished.transparentize)(0.6, theme.color.defaultText),
	    fontFamily: theme.typography.fonts.mono,
	    fontSize: "".concat(theme.typography.size.code, "%")
	  };
	});
	
	var prettyPrint = function prettyPrint(type) {
	  if (!type || !type.name) {
	    return '';
	  }
	
	  var fields = '';
	
	  switch (type.name) {
	    case PropType.SHAPE:
	      fields = Object.keys(type.value).map(function (key) {
	        return "".concat(key, ": ").concat(prettyPrint(type.value[key]));
	      }).join(', ');
	      return "{ ".concat(fields, " }");
	
	    case PropType.UNION:
	      return Array.isArray(type.value) ? "Union<".concat(type.value.map(prettyPrint).join(' | '), ">") : JSON.stringify(type.value);
	
	    case PropType.ARRAYOF:
	      return "[ ".concat(prettyPrint(type.value), " ]");
	
	    case PropType.OBJECTOF:
	      return "objectOf(".concat(prettyPrint(type.value), ")");
	
	    case PropType.ENUM:
	      if (type.computed) {
	        return JSON.stringify(type);
	      }
	
	      return Array.isArray(type.value) ? type.value.map(function (v) {
	        return v && v.value && v.value.toString();
	      }).join(' | ') : JSON.stringify(type);
	
	    case PropType.INSTANCEOF:
	      return "instanceOf(".concat(JSON.stringify(type.value), ")");
	
	    default:
	      return type.name;
	  }
	};
	
	var PrettyPropType = function PrettyPropType(_ref3) {
	  var type = _ref3.type;
	  return _react["default"].createElement("span", null, prettyPrint(type));
	};
	
	exports.PrettyPropType = PrettyPropType;
	PrettyPropType.displayName = "PrettyPropType";
	
	var PrettyPropVal = function PrettyPropVal(_ref4) {
	  var value = _ref4.value;
	  return _react["default"].createElement("span", null, JSON.stringify(value));
	};
	
	exports.PrettyPropVal = PrettyPropVal;
	PrettyPropVal.displayName = "PrettyPropVal";
	
	var _ref6 =
	/*#__PURE__*/
	_react["default"].createElement(Required, {
	  title: "Required"
	}, "*");
	
	var PropRow = function PropRow(_ref5) {
	  var _ref5$row = _ref5.row,
	      name = _ref5$row.name,
	      type = _ref5$row.type,
	      required = _ref5$row.required,
	      description = _ref5$row.description,
	      defaultValue = _ref5$row.defaultValue;
	  return _react["default"].createElement("tr", null, _react["default"].createElement("td", null, _react["default"].createElement(Name, null, name), required ? _ref6 : null), _react["default"].createElement("td", null, _react["default"].createElement("div", null, description), _react["default"].createElement(StyledPropDef, null, _react["default"].createElement(PrettyPropType, {
	    type: type
	  }))), _react["default"].createElement("td", null, defaultValue === undefined ? '-' : _react["default"].createElement(PrettyPropVal, {
	    value: defaultValue
	  })));
	};
	
	exports.PropRow = PropRow;
	PropRow.displayName = "PropRow";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(49);
	
	__webpack_require__(211);
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "PropDef", {
	  enumerable: true,
	  get: function get() {
	    return _PropDef.PropDef;
	  }
	});
	exports.PropsTable = exports.PropsTableError = exports.Table = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _polished = __webpack_require__(27);
	
	var _PropRow = __webpack_require__(501);
	
	var _PropDef = __webpack_require__(500);
	
	var _EmptyBlock = __webpack_require__(198);
	
	var _DocumentFormatting = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Table = _theming.styled.table(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    '&&': {
	      // Resets for cascading/system styles
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      color: theme.color.defaultText,
	      tr: {
	        border: 'none',
	        background: 'none'
	      },
	      'td, th': {
	        padding: 0,
	        border: 'none'
	      },
	      // End Resets
	      fontSize: theme.typography.size.s2,
	      lineHeight: '20px',
	      textAlign: 'left',
	      width: '100%',
	      // Margin collapse
	      marginTop: '25px',
	      marginBottom: '40px',
	      'th:first-of-type, td:first-of-type': {
	        paddingLeft: 20
	      },
	      'th:last-of-type, td:last-of-type': {
	        paddingRight: '20px',
	        width: '20%'
	      },
	      th: {
	        color: theme.base === 'light' ? (0, _polished.transparentize)(0.4, theme.color.defaultText) : (0, _polished.transparentize)(0.6, theme.color.defaultText),
	        paddingTop: 10,
	        paddingBottom: 10,
	        '&:not(:first-of-type)': {
	          paddingLeft: 15,
	          paddingRight: 15
	        }
	      },
	      td: {
	        paddingTop: '16px',
	        paddingBottom: '16px',
	        '&:not(:first-of-type)': {
	          paddingLeft: 15,
	          paddingRight: 15
	        },
	        '&:last-of-type': {
	          paddingRight: '20px'
	        }
	      },
	      // Table "block" styling
	      // Emphasize tbody's background and set borderRadius
	      // Calling out because styling tables is finicky
	      // Makes border alignment consistent w/other DocBlocks
	      marginLeft: 1,
	      marginRight: 1,
	      'tr:first-child td:first-child': {
	        borderTopLeftRadius: theme.appBorderRadius
	      },
	      'tr:first-child td:last-child': {
	        borderTopRightRadius: theme.appBorderRadius
	      },
	      'tr:last-child td:first-child': {
	        borderBottomLeftRadius: theme.appBorderRadius
	      },
	      'tr:last-child td:last-child': {
	        borderBottomRightRadius: theme.appBorderRadius
	      },
	      tbody: {
	        // slightly different than the other DocBlock shadows to account for table styling gymnastics
	        boxShadow: theme.base === 'light' ? "rgba(0, 0, 0, 0.10) 0 1px 3px 1px,\n          ".concat((0, _polished.transparentize)(0.035, theme.appBorderColor), " 0 0 0 1px") : "rgba(0, 0, 0, 0.20) 0 2px 5px 1px,\n          ".concat((0, _polished.opacify)(0.05, theme.appBorderColor), " 0 0 0 1px"),
	        borderRadius: theme.appBorderRadius,
	        tr: {
	          background: 'transparent',
	          '&:not(:first-child)': {
	            borderTop: "1px solid ".concat(theme.appBorderColor)
	          }
	        },
	        td: {
	          background: theme.background.content
	        }
	      } // End finicky table styling
	
	    }
	  };
	});
	
	exports.Table = Table;
	var PropsTableError;
	exports.PropsTableError = PropsTableError;
	
	(function (PropsTableError) {
	  PropsTableError["NO_COMPONENT"] = "No component found";
	  PropsTableError["PROPS_UNSUPPORTED"] = "Props unsupported. See Props documentation for your framework.";
	})(PropsTableError || (exports.PropsTableError = PropsTableError = {}));
	
	var _ref4 =
	/*#__PURE__*/
	_react["default"].createElement(_EmptyBlock.EmptyBlock, null, "No props found for this component");
	
	var _ref5 =
	/*#__PURE__*/
	_react["default"].createElement("thead", null, _react["default"].createElement("tr", null, _react["default"].createElement("th", null, "Name"), _react["default"].createElement("th", null, "Description"), _react["default"].createElement("th", null, "Default")));
	
	/**
	 * Display the props for a component as a props table. Each row is a collection of
	 * PropDefs, usually derived from docgen info for the component.
	 */
	var PropsTable = function PropsTable(props) {
	  var _ref2 = props,
	      error = _ref2.error;
	
	  if (error) {
	    return _react["default"].createElement(_EmptyBlock.EmptyBlock, null, error);
	  }
	
	  var _ref3 = props,
	      rows = _ref3.rows;
	
	  if (rows.length === 0) {
	    return _ref4;
	  }
	
	  return _react["default"].createElement(_DocumentFormatting.ResetWrapper, null, _react["default"].createElement(Table, {
	    className: "docblock-propstable"
	  }, _ref5, _react["default"].createElement("tbody", null, rows.map(function (row) {
	    return _react["default"].createElement(_PropRow.PropRow, {
	      key: row.name,
	      row: row
	    });
	  }))));
	};
	
	exports.PropsTable = PropsTable;
	PropsTable.displayName = "PropsTable";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Story = exports.StoryError = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _IFrame = __webpack_require__(307);
	
	var _EmptyBlock = __webpack_require__(198);
	
	var _ZoomContext = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var BASE_URL = 'iframe.html';
	var StoryError;
	/** error message for Story with null storyFn
	 * if the story id exists, it must be pointing to a non-existing story
	 *  if there is assigned story id, the story must be empty
	 */
	
	exports.StoryError = StoryError;
	
	(function (StoryError) {
	  StoryError["NO_STORY"] = "No component or story to display";
	})(StoryError || (exports.StoryError = StoryError = {}));
	
	var MISSING_STORY = function MISSING_STORY(id) {
	  return id ? "Story \"".concat(id, "\" doesn't exist.") : StoryError.NO_STORY;
	};
	
	var InlineZoomWrapper = function InlineZoomWrapper(_ref) {
	  var scale = _ref.scale,
	      children = _ref.children;
	  return scale === 1 ? _react["default"].createElement(_react["default"].Fragment, null, children) : _react["default"].createElement("div", {
	    style: {
	      overflow: 'hidden'
	    }
	  }, _react["default"].createElement("div", {
	    style: {
	      transform: "scale(".concat(1 / scale, ")"),
	      transformOrigin: 'top left'
	    }
	  }, children));
	};
	
	var InlineStory = function InlineStory(_ref2) {
	  var storyFn = _ref2.storyFn,
	      height = _ref2.height,
	      id = _ref2.id;
	  return _react["default"].createElement("div", {
	    style: {
	      height: height
	    }
	  }, _react["default"].createElement(_ZoomContext.ZoomContext.Consumer, null, function (_ref3) {
	    var scale = _ref3.scale;
	    return _react["default"].createElement(InlineZoomWrapper, {
	      scale: scale
	    }, storyFn ? _react["default"].createElement(storyFn) : _react["default"].createElement(_EmptyBlock.EmptyBlock, null, MISSING_STORY(id)));
	  }));
	};
	
	InlineStory.displayName = "InlineStory";
	
	var IFrameStory = function IFrameStory(_ref4) {
	  var id = _ref4.id,
	      title = _ref4.title,
	      _ref4$height = _ref4.height,
	      height = _ref4$height === void 0 ? '500px' : _ref4$height;
	  return _react["default"].createElement("div", {
	    style: {
	      width: '100%',
	      height: height
	    }
	  }, _react["default"].createElement(_ZoomContext.ZoomContext.Consumer, null, function (_ref5) {
	    var scale = _ref5.scale;
	    return _react["default"].createElement(_IFrame.IFrame, {
	      key: "iframe",
	      id: "iframe--".concat(id),
	      title: title,
	      src: "".concat(BASE_URL, "?id=").concat(id, "&viewMode=story"),
	      allowFullScreen: true,
	      scale: scale,
	      style: {
	        width: '100%',
	        height: '100%',
	        border: '0 none'
	      }
	    });
	  }));
	};
	
	IFrameStory.displayName = "IFrameStory";
	
	/**
	 * A story element, either renderend inline or in an iframe,
	 * with configurable height.
	 */
	var Story = function Story(props) {
	  var _ref6 = props,
	      error = _ref6.error;
	  var _ref7 = props,
	      storyFn = _ref7.storyFn;
	  var id = props.id,
	      inline = props.inline,
	      title = props.title,
	      height = props.height;
	
	  if (error) {
	    return _react["default"].createElement(_EmptyBlock.EmptyBlock, null, error);
	  }
	
	  return inline ? _react["default"].createElement(InlineStory, {
	    id: id,
	    storyFn: storyFn,
	    title: title,
	    height: height
	  }) : _react["default"].createElement(IFrameStory, {
	    id: id,
	    title: title,
	    height: height
	  });
	};
	
	exports.Story = Story;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(112);
	
	__webpack_require__(11);
	
	__webpack_require__(3);
	
	__webpack_require__(30);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Toolbar = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _global = __webpack_require__(56);
	
	var _bar = __webpack_require__(196);
	
	var _icon = __webpack_require__(199);
	
	var _button = __webpack_require__(197);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var _ref2 =
	/*#__PURE__*/
	_react["default"].createElement(_icon.Icons, {
	  icon: "zoom"
	});
	
	var _ref3 =
	/*#__PURE__*/
	_react["default"].createElement(_icon.Icons, {
	  icon: "zoomout"
	});
	
	var _ref4 =
	/*#__PURE__*/
	_react["default"].createElement(_icon.Icons, {
	  icon: "zoomreset"
	});
	
	var Zoom = function Zoom(_ref) {
	  var zoom = _ref.zoom,
	      resetZoom = _ref.resetZoom;
	  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_button.IconButton, {
	    key: "zoomin",
	    onClick: function onClick(e) {
	      e.preventDefault();
	      zoom(0.8);
	    },
	    title: "Zoom in"
	  }, _ref2), _react["default"].createElement(_button.IconButton, {
	    key: "zoomout",
	    onClick: function onClick(e) {
	      e.preventDefault();
	      zoom(1.25);
	    },
	    title: "Zoom out"
	  }, _ref3), _react["default"].createElement(_button.IconButton, {
	    key: "zoomreset",
	    onClick: function onClick(e) {
	      e.preventDefault();
	      resetZoom();
	    },
	    title: "Reset zoom"
	  }, _ref4));
	};
	
	var _ref6 =
	/*#__PURE__*/
	_react["default"].createElement(_icon.Icons, {
	  icon: "share"
	});
	
	var Eject = function Eject(_ref5) {
	  var baseUrl = _ref5.baseUrl,
	      storyId = _ref5.storyId;
	  return _react["default"].createElement(_button.IconButton, {
	    key: "opener",
	    onClick: function onClick() {
	      return _global.window.open("".concat(baseUrl, "?id=").concat(storyId));
	    },
	    title: "Open canvas in new tab"
	  }, _ref6);
	};
	
	Eject.displayName = "Eject";
	var Bar = (0, _theming.styled)(function (props) {
	  return _react["default"].createElement(_bar.FlexBar, props);
	})({
	  position: 'absolute',
	  left: 0,
	  right: 0,
	  top: 0,
	  transition: 'transform .2s linear'
	});
	
	var Toolbar = function Toolbar(_ref7) {
	  var storyId = _ref7.storyId,
	      baseUrl = _ref7.baseUrl,
	      zoom = _ref7.zoom,
	      resetZoom = _ref7.resetZoom,
	      rest = _objectWithoutProperties(_ref7, ["storyId", "baseUrl", "zoom", "resetZoom"]);
	
	  return _react["default"].createElement(Bar, rest, _react["default"].createElement(_react.Fragment, {
	    key: "left"
	  }, _react["default"].createElement(Zoom, {
	    zoom: zoom,
	    resetZoom: resetZoom
	  })), _react["default"].createElement(_react.Fragment, {
	    key: "right"
	  }, storyId && _react["default"].createElement(Eject, {
	    storyId: storyId,
	    baseUrl: baseUrl
	  })));
	};
	
	exports.Toolbar = Toolbar;
	Toolbar.displayName = "Toolbar";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(49);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Typeset = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _polished = __webpack_require__(27);
	
	var _withReset = __webpack_require__(143);
	
	var _BlockBackgroundStyles = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Label = _theming.styled.div(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    marginRight: 30,
	    fontSize: "".concat(theme.typography.size.s1, "px"),
	    color: theme.base === 'light' ? (0, _polished.transparentize)(0.4, theme.color.defaultText) : (0, _polished.transparentize)(0.6, theme.color.defaultText)
	  };
	});
	
	var Sample = _theming.styled.div({
	  lineHeight: 1,
	  overflow: 'hidden',
	  whiteSpace: 'nowrap',
	  textOverflow: 'ellipsis'
	});
	
	var TypeSpecimen = _theming.styled.div({
	  display: 'flex',
	  flexDirection: 'row',
	  alignItems: 'baseline',
	  '&:not(:last-child)': {
	    marginBottom: '1rem'
	  }
	});
	
	var Wrapper = _theming.styled.div(_withReset.withReset, function (_ref2) {
	  var theme = _ref2.theme;
	  return Object.assign({}, (0, _BlockBackgroundStyles.getBlockBackgroundStyle)(theme), {
	    margin: '25px 0 40px',
	    padding: '30px 20px'
	  });
	});
	
	/**
	 * Convenient tyleguide documentation showing examples of type
	 * with different sizes and weights and configurable sample text.
	 */
	var Typeset = function Typeset(_ref3) {
	  var fontSizes = _ref3.fontSizes,
	      fontWeight = _ref3.fontWeight,
	      sampleText = _ref3.sampleText,
	      props = _objectWithoutProperties(_ref3, ["fontSizes", "fontWeight", "sampleText"]);
	
	  return _react["default"].createElement(Wrapper, _extends({}, props, {
	    className: "docblock-typeset"
	  }), fontSizes.map(function (num) {
	    return _react["default"].createElement(TypeSpecimen, {
	      key: num
	    }, _react["default"].createElement(Label, null, num, "px"), _react["default"].createElement(Sample, {
	      style: {
	        fontSize: num,
	        fontWeight: fontWeight
	      }
	    }, sampleText || 'Was he a beast if music could move him so?'));
	  }));
	};
	
	exports.Typeset = Typeset;
	Typeset.displayName = "Typeset";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(153);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	__webpack_require__(155);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Description = __webpack_require__(496);
	
	Object.keys(_Description).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Description[key];
	    }
	  });
	});
	
	var _DocsPage = __webpack_require__(497);
	
	Object.keys(_DocsPage).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DocsPage[key];
	    }
	  });
	});
	
	var _Preview = __webpack_require__(499);
	
	Object.keys(_Preview).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Preview[key];
	    }
	  });
	});
	
	var _PropsTable = __webpack_require__(502);
	
	Object.keys(_PropsTable).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _PropsTable[key];
	    }
	  });
	});
	
	var _Source = __webpack_require__(308);
	
	Object.keys(_Source).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Source[key];
	    }
	  });
	});
	
	var _Story = __webpack_require__(503);
	
	Object.keys(_Story).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Story[key];
	    }
	  });
	});
	
	var _IFrame = __webpack_require__(307);
	
	Object.keys(_IFrame).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IFrame[key];
	    }
	  });
	});
	
	var _Typeset = __webpack_require__(505);
	
	Object.keys(_Typeset).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Typeset[key];
	    }
	  });
	});
	
	var _ColorPalette = __webpack_require__(495);
	
	Object.keys(_ColorPalette).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ColorPalette[key];
	    }
	  });
	});
	
	var _IconGallery = __webpack_require__(498);
	
	Object.keys(_IconGallery).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconGallery[key];
	    }
	  });
	});

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StorybookIcon = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var _ref2 =
	/*#__PURE__*/
	_react["default"].createElement("title", null, "Storybook icon");
	
	var _ref3 =
	/*#__PURE__*/
	_react["default"].createElement("g", {
	  id: "Artboard",
	  stroke: "none",
	  strokeWidth: "1",
	  fill: "none",
	  fillRule: "evenodd"
	}, _react["default"].createElement("path", {
	  d: "M8.04798541,58.7875918 L6.07908839,6.32540407 C6.01406344,4.5927838 7.34257463,3.12440831 9.07303814,3.01625434 L53.6958037,0.227331489 C55.457209,0.117243658 56.974354,1.45590096 57.0844418,3.21730626 C57.0885895,3.28366922 57.0906648,3.35014546 57.0906648,3.41663791 L57.0906648,60.5834697 C57.0906648,62.3483119 55.6599776,63.7789992 53.8951354,63.7789992 C53.847325,63.7789992 53.7995207,63.7779262 53.7517585,63.775781 L11.0978899,61.8600599 C9.43669044,61.7854501 8.11034889,60.4492961 8.04798541,58.7875918 Z",
	  id: "path-1",
	  fill: "#FF4785",
	  fillRule: "nonzero"
	}), _react["default"].createElement("path", {
	  d: "M35.9095005,24.1768792 C35.9095005,25.420127 44.2838488,24.8242707 45.4080313,23.9509748 C45.4080313,15.4847538 40.8652557,11.0358878 32.5466666,11.0358878 C24.2280775,11.0358878 19.5673077,15.553972 19.5673077,22.3311017 C19.5673077,34.1346028 35.4965208,34.3605071 35.4965208,40.7987804 C35.4965208,42.606015 34.6115646,43.6790606 32.6646607,43.6790606 C30.127786,43.6790606 29.1248356,42.3834613 29.2428298,37.9783269 C29.2428298,37.0226907 19.5673077,36.7247626 19.2723223,37.9783269 C18.5211693,48.6535354 25.1720308,51.7326752 32.7826549,51.7326752 C40.1572906,51.7326752 45.939005,47.8018145 45.939005,40.6858282 C45.939005,28.035186 29.7738035,28.3740425 29.7738035,22.1051974 C29.7738035,19.5637737 31.6617103,19.2249173 32.7826549,19.2249173 C33.9625966,19.2249173 36.0864917,19.4328883 35.9095005,24.1768792 Z",
	  id: "path9_fill-path",
	  fill: "#FFFFFF",
	  fillRule: "nonzero"
	}), _react["default"].createElement("path", {
	  d: "M44.0461638,0.830433986 L50.1874092,0.446606143 L50.443532,7.7810017 C50.4527198,8.04410717 50.2468789,8.26484453 49.9837734,8.27403237 C49.871115,8.27796649 49.7607078,8.24184808 49.6721567,8.17209069 L47.3089847,6.3104681 L44.5110468,8.43287463 C44.3012992,8.591981 44.0022839,8.55092814 43.8431776,8.34118051 C43.7762017,8.25288717 43.742082,8.14401677 43.7466857,8.03329059 L44.0461638,0.830433986 Z",
	  id: "Path",
	  fill: "#FFFFFF"
	}));
	
	var StorybookIcon = function StorybookIcon(_ref) {
	  var props = Object.assign({}, _ref);
	  return _react["default"].createElement("svg", _extends({
	    viewBox: "0 0 64 64"
	  }, props), _ref2, _ref3);
	};
	
	exports.StorybookIcon = StorybookIcon;
	StorybookIcon.displayName = "StorybookIcon";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StorybookLogo = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var _ref2 =
	/*#__PURE__*/
	_react["default"].createElement("defs", null, _react["default"].createElement("path", {
	  d: "M1.2 36.9L0 3.9c0-1.1.8-2 1.9-2.1l28-1.8a2 2 0 0 1 2.2 1.9 2 2 0 0 1 0 .1v36a2 2 0 0 1-2 2 2 2 0 0 1-.1 0L3.2 38.8a2 2 0 0 1-2-2z",
	  id: "a"
	}));
	
	var _ref3 =
	/*#__PURE__*/
	_react["default"].createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react["default"].createElement("path", {
	  d: "M53.3 31.7c-1.7 0-3.4-.3-5-.7-1.5-.5-2.8-1.1-3.9-2l1.6-3.5c2.2 1.5 4.6 2.3 7.3 2.3 1.5 0 2.5-.2 3.3-.7.7-.5 1.1-1 1.1-1.9 0-.7-.3-1.3-1-1.7s-2-.8-3.7-1.2c-2-.4-3.6-.9-4.8-1.5-1.1-.5-2-1.2-2.6-2-.5-1-.8-2-.8-3.2 0-1.4.4-2.6 1.2-3.6.7-1.1 1.8-2 3.2-2.6 1.3-.6 2.9-.9 4.7-.9 1.6 0 3.1.3 4.6.7 1.5.5 2.7 1.1 3.5 2l-1.6 3.5c-2-1.5-4.2-2.3-6.5-2.3-1.3 0-2.3.2-3 .8-.8.5-1.2 1.1-1.2 2 0 .5.2 1 .5 1.3.2.3.7.6 1.4.9l2.9.8c2.9.6 5 1.4 6.2 2.4a5 5 0 0 1 2 4.2 6 6 0 0 1-2.5 5c-1.7 1.2-4 1.9-7 1.9zm21-3.6l1.4-.1-.2 3.5-1.9.1c-2.4 0-4.1-.5-5.2-1.5-1.1-1-1.6-2.7-1.6-4.8v-6h-3v-3.6h3V11h4.8v4.6h4v3.6h-4v6c0 1.8.9 2.8 2.6 2.8zm11.1 3.5c-1.6 0-3-.3-4.3-1a7 7 0 0 1-3-2.8c-.6-1.3-1-2.7-1-4.4 0-1.6.4-3 1-4.3a7 7 0 0 1 3-2.8c1.2-.7 2.7-1 4.3-1 1.7 0 3.2.3 4.4 1a7 7 0 0 1 3 2.8c.6 1.2 1 2.7 1 4.3 0 1.7-.4 3.1-1 4.4a7 7 0 0 1-3 2.8c-1.2.7-2.7 1-4.4 1zm0-3.6c2.4 0 3.6-1.6 3.6-4.6 0-1.5-.3-2.6-1-3.4a3.2 3.2 0 0 0-2.6-1c-2.3 0-3.5 1.4-3.5 4.4 0 3 1.2 4.6 3.5 4.6zm21.7-8.8l-2.7.3c-1.3.2-2.3.5-2.8 1.2-.6.6-.9 1.4-.9 2.5v8.2H96V15.7h4.6v2.6c.8-1.8 2.5-2.8 5-3h1.3l.3 4zm14-3.5h4.8L116.4 37h-4.9l3-6.6-6.4-14.8h5l4 10 4-10zm16-.4c1.4 0 2.6.3 3.6 1 1 .6 1.9 1.6 2.5 2.8.6 1.2.9 2.7.9 4.3 0 1.6-.3 3-1 4.3a6.9 6.9 0 0 1-2.4 2.9c-1 .7-2.2 1-3.6 1-1 0-2-.2-3-.7-.8-.4-1.5-1-2-1.9v2.4h-4.7V8.8h4.8v9c.5-.8 1.2-1.4 2-1.9.9-.4 1.8-.6 3-.6zM135.7 28c1.1 0 2-.4 2.6-1.2.6-.8 1-2 1-3.4 0-1.5-.4-2.5-1-3.3s-1.5-1.1-2.6-1.1-2 .3-2.6 1.1c-.6.8-1 2-1 3.3 0 1.5.4 2.6 1 3.4.6.8 1.5 1.2 2.6 1.2zm18.9 3.6c-1.7 0-3.2-.3-4.4-1a7 7 0 0 1-3-2.8c-.6-1.3-1-2.7-1-4.4 0-1.6.4-3 1-4.3a7 7 0 0 1 3-2.8c1.2-.7 2.7-1 4.4-1 1.6 0 3 .3 4.3 1a7 7 0 0 1 3 2.8c.6 1.2 1 2.7 1 4.3 0 1.7-.4 3.1-1 4.4a7 7 0 0 1-3 2.8c-1.2.7-2.7 1-4.3 1zm0-3.6c2.3 0 3.5-1.6 3.5-4.6 0-1.5-.3-2.6-1-3.4a3.2 3.2 0 0 0-2.5-1c-2.4 0-3.6 1.4-3.6 4.4 0 3 1.2 4.6 3.6 4.6zm18 3.6c-1.7 0-3.2-.3-4.4-1a7 7 0 0 1-3-2.8c-.6-1.3-1-2.7-1-4.4 0-1.6.4-3 1-4.3a7 7 0 0 1 3-2.8c1.2-.7 2.7-1 4.4-1 1.6 0 3 .3 4.4 1a7 7 0 0 1 2.9 2.8c.6 1.2 1 2.7 1 4.3 0 1.7-.4 3.1-1 4.4a7 7 0 0 1-3 2.8c-1.2.7-2.7 1-4.3 1zm0-3.6c2.3 0 3.5-1.6 3.5-4.6 0-1.5-.3-2.6-1-3.4a3.2 3.2 0 0 0-2.5-1c-2.4 0-3.6 1.4-3.6 4.4 0 3 1.2 4.6 3.6 4.6zm27.4 3.4h-6l-6-7v7h-4.8V8.8h4.9v13.6l5.8-6.7h5.7l-6.6 7.5 7 8.2z",
	  fill: "currentColor"
	}), _react["default"].createElement("mask", {
	  id: "b",
	  fill: "#fff"
	}, _react["default"].createElement("use", {
	  xlinkHref: "#a"
	})), _react["default"].createElement("use", {
	  fill: "#FF4785",
	  fillRule: "nonzero",
	  xlinkHref: "#a"
	}), _react["default"].createElement("path", {
	  d: "M23.7 5L24 .2l3.9-.3.1 4.8a.3.3 0 0 1-.5.2L26 3.8l-1.7 1.4a.3.3 0 0 1-.5-.3zm-5 10c0 .9 5.3.5 6 0 0-5.4-2.8-8.2-8-8.2-5.3 0-8.2 2.8-8.2 7.1 0 7.4 10 7.6 10 11.6 0 1.2-.5 1.9-1.8 1.9-1.6 0-2.2-.9-2.1-3.6 0-.6-6.1-.8-6.3 0-.5 6.7 3.7 8.6 8.5 8.6 4.6 0 8.3-2.5 8.3-7 0-7.9-10.2-7.7-10.2-11.6 0-1.6 1.2-1.8 2-1.8.6 0 2 0 1.9 3z",
	  fill: "#FFF",
	  fillRule: "nonzero",
	  mask: "url(#b)"
	}));
	
	var StorybookLogo = function StorybookLogo(_ref) {
	  var alt = _ref.alt,
	      props = _objectWithoutProperties(_ref, ["alt"]);
	
	  return _react["default"].createElement("svg", _extends({
	    width: "200px",
	    height: "40px",
	    viewBox: "0 0 200 40"
	  }, props, {
	    role: "img"
	  }), alt ? _react["default"].createElement("title", null, alt) : null, _ref2, _ref3);
	};
	
	exports.StorybookLogo = StorybookLogo;
	StorybookLogo.displayName = "StorybookLogo";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	__webpack_require__(66);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Field = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Wrapper = _theming.styled.label(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    display: 'flex',
	    borderBottom: "1px solid ".concat(theme.appBorderColor),
	    margin: '0 15px',
	    padding: '8px 0',
	    '&:last-child': {
	      marginBottom: '3rem'
	    }
	  };
	});
	
	var Label = _theming.styled.span(function (_ref2) {
	  var theme = _ref2.theme;
	  return {
	    minWidth: 100,
	    fontWeight: theme.typography.weight.bold,
	    marginRight: 15,
	    display: 'flex',
	    justifyContent: 'flex-start',
	    alignItems: 'center',
	    lineHeight: '16px'
	  };
	});
	
	var Field = function Field(_ref3) {
	  var label = _ref3.label,
	      children = _ref3.children;
	  return _react["default"].createElement(Wrapper, null, label ? _react["default"].createElement(Label, null, _react["default"].createElement("span", null, label)) : null, children);
	};
	
	exports.Field = Field;
	Field.displayName = "Field";
	Field.defaultProps = {
	  label: undefined
	};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Form = void 0;
	
	var _theming = __webpack_require__(5);
	
	var _field = __webpack_require__(509);
	
	var _input = __webpack_require__(511);
	
	// InputStyleProps import is for TS
	var Form = Object.assign(_theming.styled.form({
	  boxSizing: 'border-box',
	  width: '100%'
	}), {
	  Field: _field.Field,
	  Input: _input.Input,
	  Select: _input.Select,
	  Textarea: _input.Textarea,
	  Button: _input.Button
	});
	exports.Form = Form;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(30);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = exports.Textarea = exports.Select = exports.Input = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _reactTextareaAutosize = _interopRequireDefault(__webpack_require__(1083));
	
	var _Button = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var styleResets = {
	  // resets
	  appearance: 'none',
	  border: '0',
	  boxSizing: 'inherit',
	  display: ' block',
	  margin: ' 0',
	  background: 'transparent',
	  padding: 0,
	  fontSize: 'inherit',
	  position: 'relative'
	};
	
	var styles = function styles(_ref) {
	  var theme = _ref.theme;
	  return Object.assign({}, styleResets, {
	    transition: 'all 200ms ease-out',
	    color: theme.input.color || 'inherit',
	    background: theme.input.background,
	    boxShadow: "".concat(theme.input.border, " 0 0 0 1px inset"),
	    borderRadius: theme.input.borderRadius,
	    fontSize: theme.typography.size.s2 - 1,
	    lineHeight: '20px',
	    padding: '.42em 1em',
	    // 32
	    '&:focus': {
	      boxShadow: "".concat(theme.color.secondary, " 0 0 0 1px inset")
	    },
	    '&[disabled]': {
	      cursor: 'not-allowed',
	      opacity: 0.5
	    },
	    '&:-webkit-autofill': {
	      WebkitBoxShadow: "0 0 0 3em ".concat(theme.color.lightest, " inset")
	    },
	    '::placeholder': {
	      color: theme.color.mediumdark
	    }
	  });
	};
	
	var sizes = function sizes(_ref2) {
	  var size = _ref2.size;
	
	  switch (size) {
	    case '100%':
	      {
	        return {
	          width: '100%'
	        };
	      }
	
	    case 'flex':
	      {
	        return {
	          flex: 1
	        };
	      }
	
	    case 'auto':
	    default:
	      {
	        return {
	          display: 'inline'
	        };
	      }
	  }
	};
	
	var alignment = function alignment(_ref3) {
	  var align = _ref3.align;
	
	  switch (align) {
	    case 'end':
	      {
	        return {
	          textAlign: 'right'
	        };
	      }
	
	    case 'center':
	      {
	        return {
	          textAlign: 'center'
	        };
	      }
	
	    case 'start':
	    default:
	      {
	        return {
	          textAlign: 'left'
	        };
	      }
	  }
	};
	
	var validation = function validation(_ref4) {
	  var valid = _ref4.valid,
	      theme = _ref4.theme;
	
	  switch (valid) {
	    case 'valid':
	      {
	        return {
	          boxShadow: "".concat(theme.color.positive, " 0 0 0 1px inset !important")
	        };
	      }
	
	    case 'error':
	      {
	        return {
	          boxShadow: "".concat(theme.color.negative, " 0 0 0 1px inset !important")
	        };
	      }
	
	    case 'warn':
	      {
	        return {
	          boxShadow: "".concat(theme.color.warning, " 0 0 0 1px inset")
	        };
	      }
	
	    case undefined:
	    case null:
	    default:
	      {
	        return {};
	      }
	  }
	};
	
	var Input = Object.assign((0, _theming.styled)((0, _react.forwardRef)(function (_ref5, ref) {
	  var size = _ref5.size,
	      valid = _ref5.valid,
	      align = _ref5.align,
	      props = _objectWithoutProperties(_ref5, ["size", "valid", "align"]);
	
	  return _react["default"].createElement("input", _extends({}, props, {
	    ref: ref
	  }));
	}))(styles, sizes, alignment, validation, {
	  minHeight: 32
	}), {
	  displayName: 'Input'
	}); // (Input).styles = { ...styleResets, ...styles };
	// (Input).sizes = sizes;
	// (Input).alignment = alignment;
	
	exports.Input = Input;
	var Select = Object.assign((0, _theming.styled)((0, _react.forwardRef)(function (_ref6, ref) {
	  var size = _ref6.size,
	      valid = _ref6.valid,
	      align = _ref6.align,
	      props = _objectWithoutProperties(_ref6, ["size", "valid", "align"]);
	
	  return _react["default"].createElement("select", _extends({}, props, {
	    ref: ref
	  }));
	}))(styles, sizes, validation, {
	  height: 32,
	  userSelect: 'none',
	  paddingRight: 20,
	  appearance: 'menulist'
	}), {
	  displayName: 'Select'
	});
	exports.Select = Select;
	var Textarea = Object.assign((0, _theming.styled)((0, _react.forwardRef)(function (_ref7, ref) {
	  var size = _ref7.size,
	      valid = _ref7.valid,
	      align = _ref7.align,
	      props = _objectWithoutProperties(_ref7, ["size", "valid", "align"]);
	
	  return _react["default"].createElement(_reactTextareaAutosize["default"], _extends({}, props, {
	    ref: ref
	  }));
	}))(styles, sizes, alignment, validation, {
	  overflow: 'visible'
	}), {
	  displayName: 'Textarea'
	});
	exports.Textarea = Textarea;
	var ButtonStyled = (0, _theming.styled)((0, _react.forwardRef)(function (_ref8, ref) {
	  var size = _ref8.size,
	      valid = _ref8.valid,
	      align = _ref8.align,
	      props = _objectWithoutProperties(_ref8, ["size", "valid", "align"]);
	
	  return _react["default"].createElement(_Button.Button, _extends({}, props, {
	    ref: ref
	  }));
	}))(sizes, validation, {
	  // Custom styling for color widget nested in buttons
	  userSelect: 'none',
	  overflow: 'visible',
	  zIndex: 2,
	  // overrides the default hover from Button
	  '&:hover': {
	    transform: 'none'
	  }
	});
	var Button = Object.assign((0, _react.forwardRef)(function (props, ref) {
	  return _react["default"].createElement(ButtonStyled, _extends({}, props, {
	    tertiary: true,
	    small: true,
	    inForm: true
	  }, {
	    ref: ref
	  }));
	}), {
	  displayName: 'Button'
	});
	exports.Button = Button;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(51);
	
	__webpack_require__(68);
	
	__webpack_require__(153);
	
	__webpack_require__(62);
	
	__webpack_require__(48);
	
	__webpack_require__(154);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(342);
	
	__webpack_require__(30);
	
	__webpack_require__(7);
	
	__webpack_require__(50);
	
	__webpack_require__(67);
	
	__webpack_require__(155);
	
	__webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  components: true
	};
	exports.components = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var rawComponents = _interopRequireWildcard(__webpack_require__(101));
	
	Object.keys(rawComponents).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return rawComponents[key];
	    }
	  });
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var components = Object.entries(rawComponents).reduce(function (acc, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      k = _ref2[0],
	      V = _ref2[1];
	
	  return Object.assign({}, acc, _defineProperty({}, k.toLowerCase(), function (props) {
	    return _react["default"].createElement(V, _extends({}, props, {
	      className: "sbdocs sbdocs-".concat(k.toLowerCase())
	    }));
	  }));
	}, {});
	exports.components = components;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.icons = void 0;
	// Icon paths
	var icons = {
	  mobile: 'M648 64h-272c-66.274 0-120 53.726-120 120v656c0 66.274 53.726 120 120 120h272c66.274 0 120-53.726 120-120v-656c0-66.274-53.726-120-120-120zM376 144h272c22.056 0 40 17.944 40 40v495.968h-352v-495.968c0-22.056 17.946-40 40-40zM648 880h-272c-22.054 0-40-17.944-40-40v-80.032h352v80.032c0 22.056-17.944 40-40 40zM544.034 819.962c0 17.676-14.33 32.002-32.004 32.002-17.67 0-32-14.326-32-32.002 0-17.672 14.33-31.998 32-31.998 17.674-0 32.004 14.326 32.004 31.998z',
	  watch: 'M736.172 108.030c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20 0 11.046 8.956 20 20 20h408.282c11.044 0 20-8.954 20-20zM736.172 50.37c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20zM736.172 973.692c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20zM736.172 916.030c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20 0 11.046 8.956 20 20 20h408.282c11.044 0 20-8.954 20-20zM717.53 228c18.904 0 34.286 15.14 34.286 33.75v500.502c0 18.61-15.38 33.75-34.286 33.75h-411.43c-18.904 0-34.286-15.14-34.286-33.75v-500.502c0-18.61 15.38-33.75 34.286-33.75h411.43zM717.53 148h-411.43c-63.118 0-114.286 50.928-114.286 113.75v500.502c0 62.822 51.166 113.75 114.286 113.75h411.43c63.118 0 114.286-50.926 114.286-113.75v-500.502c-0.002-62.822-51.168-113.75-114.286-113.75v0zM680.036 511.53c0 22.090-17.91 40-40 40h-128.004c-5.384 0-10.508-1.078-15.196-3.006-0.124-0.048-0.254-0.086-0.376-0.132-0.61-0.262-1.188-0.57-1.782-0.86-0.572-0.276-1.16-0.528-1.718-0.828-0.204-0.112-0.39-0.246-0.594-0.364-0.918-0.514-1.832-1.050-2.704-1.64-0.086-0.058-0.164-0.128-0.254-0.188-10.492-7.21-17.382-19.284-17.382-32.98v-151.5c0-22.094 17.91-40 40.004-40 22.088 0 40 17.906 40 40v111.498h88c22.094-0.002 40.002 17.91 40.006 40z',
	  tablet: 'M200.022 927.988h624.018c1.38 0 2.746-0.072 4.090-0.208 20.168-2.050 35.91-19.080 35.91-39.792v-751.916c0-22.092-17.91-40-40-40h-624.018c-22.098 0-40 17.908-40 40v751.916c0 22.094 17.906 40 40 40zM512.002 878.206c-17.674 0-32.004-14.328-32.004-31.998 0-17.678 14.33-32.002 32.004-32.002 17.67 0 32 14.324 32 32.002 0 17.67-14.33 31.998-32 31.998zM240.022 176.078h544.018v591.902h-544.018v-591.902z',
	  browser: 'M920.004 128h-816.008c-1.38 0-2.746 0.070-4.090 0.208-20.168 2.048-35.91 19.080-35.91 39.792v688c0 22.090 17.91 40 40 40h816.008c22.098 0 40-17.91 40-40v-688c-0-22.094-17.906-40-40-40zM368 177.78c17.674 0 32.004 14.328 32.004 31.998 0 17.676-14.33 32.002-32.004 32.002-17.67 0-32-14.326-32-32.002 0-17.67 14.33-31.998 32-31.998zM272 177.78c17.674 0 32.004 14.328 32.004 31.998 0 17.676-14.33 32.002-32.004 32.002-17.67 0-32-14.326-32-32.002 0-17.67 14.33-31.998 32-31.998zM176 177.78c17.674 0 32.004 14.328 32.004 31.998 0 17.676-14.33 32.002-32.004 32.002-17.67 0-32-14.326-32-32.002 0-17.67 14.33-31.998 32-31.998zM880.004 815.996h-736.008v-527.988h736.008v527.988z',
	  sidebar: 'M920.032 127.858h-816c-22.092 0-40 17.908-40 40v688c0 22.092 17.908 40 40 40h316.578c1.13 0.096 2.266 0.172 3.422 0.172s2.292-0.078 3.424-0.172h492.576c22.092 0 40-17.908 40-40v-688c0-22.092-17.908-40-40-40zM144.032 207.858h240v608h-240v-608zM880.032 815.858h-416v-608h416v608zM198.734 288.030c0-17.674 14.328-32 32.002-32h66.396c17.672 0 32 14.326 32 32 0 17.676-14.324 32-32 32h-66.398c-17.674 0-32-14.326-32-32zM198.734 416.030c0-17.674 14.328-32 32.002-32h66.396c17.672 0 32 14.326 32 32 0 17.676-14.324 32-32 32h-66.398c-17.674 0-32-14.326-32-32zM198.734 544.030c0-17.674 14.328-32 32.002-32h66.396c17.672 0 32 14.326 32 32 0 17.676-14.324 32-32 32h-66.398c-17.674 0-32-14.326-32-32z',
	  sidebaralt: 'M64 167.944v688c0 22.092 17.908 40 40 40h816c22.092 0 40-17.908 40-40v-688c0-22.092-17.908-40-40-40h-816c-22.092 0-40 17.908-40 40zM880 815.944h-240v-608h240v608zM144 207.944h416v608h-416v-608zM793.296 320.118h-66.398c-17.676 0-32-14.324-32-32 0-17.674 14.328-32 32-32h66.396c17.674 0 32.002 14.326 32.002 32 0 17.672-14.324 32-32 32zM793.296 448.118h-66.398c-17.676 0-32-14.324-32-32 0-17.674 14.328-32 32-32h66.396c17.674 0 32.002 14.326 32.002 32 0 17.672-14.324 32-32 32zM793.296 576.118h-66.398c-17.676 0-32-14.324-32-32 0-17.674 14.328-32 32-32h66.396c17.674 0 32.002 14.326 32.002 32 0 17.672-14.324 32-32 32z',
	  bottombar: 'M85 121h854c24 0 42 18 42 41v700c0 23-18 41-42 41H608a44 44 0 0 1-7 0H85c-24 0-42-18-42-41V162c0-23 18-41 42-41zm41 535v165h772V656H126zm0-82h772V202H126v372zm185 197h-69c-19 0-34-14-34-32s15-33 34-33h69c19 0 34 15 34 33s-15 32-34 32zm236 0h-70c-18 0-33-14-33-32s15-33 33-33h70c18 0 33 15 33 33s-15 32-33 32zm235 0h-70c-18 0-33-14-33-32s15-33 33-33h70c18 0 33 15 33 33s-15 32-33 32z',
	  useralt: 'M532.716 960c115.572 0 227.634-22.612 333.076-67.208 18.116-7.66 35.888-15.94 53.336-24.774v-18.726c0-116.912-241.728-223.528-306.458-233.828-20.1-3.198-20.556-58.458-20.556-58.458s59.050-58.452 71.922-137.062c34.618 0 56.004-83.57 21.378-112.972 1.448-30.95 44.5-242.972-173.474-242.972-217.976 0-174.916 212.022-173.476 242.972-34.622 29.402-13.244 112.972 21.38 112.972 12.864 78.61 71.916 137.062 71.916 137.062s-0.458 55.262-20.554 58.458c-64.042 10.19-301.326 114.674-306.334 230.124 30.474 17.61 62.084 33.376 94.776 47.204 105.436 44.596 217.498 67.208 333.068 67.208z',
	  user: 'M512.062 65.062c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM776.324 769.132c-55.386-54.52-155.436-95.864-189.492-101.282-14.918-2.376-15.258-43.39-15.258-43.39s43.832-43.39 53.384-101.738c25.698 0 41.568-62.032 15.87-83.856 1.072-22.974 33.038-180.352-128.766-180.352s-129.836 157.376-128.768 180.352c-25.706 21.824-9.83 83.856 15.87 83.856 9.552 58.348 53.382 101.738 53.382 101.738s-0.34 41.020-15.256 43.39c-34.056 5.418-134.104 46.762-189.49 101.282-66.932-69.018-103.738-159.708-103.738-256.070 0-98.296 38.278-190.708 107.786-260.212 69.51-69.506 161.918-107.788 260.214-107.788s190.708 38.278 260.214 107.788c69.506 69.506 107.786 161.916 107.786 260.212-0 96.364-36.808 187.054-103.738 256.070z',
	  useradd: 'M123.302 833.14c-26.284-11.118-51.696-23.792-76.196-37.95 4.028-92.818 194.792-176.82 246.28-185.012 16.158-2.57 16.526-46.994 16.526-46.994s-47.476-46.996-57.818-110.196c-27.836 0-45.024-67.186-17.19-90.824-1.158-24.882-35.776-195.34 139.468-195.34 175.242 0 140.628 170.458 139.464 195.34 27.838 23.638 10.644 90.824-17.188 90.824-10.346 63.2-57.822 110.196-57.822 110.196s0.37 44.424 16.528 46.994c52.042 8.282 246.38 93.996 246.38 187.988v15.054c-14.028 7.102-28.316 13.76-42.88 19.918-84.77 35.852-174.864 54.032-267.78 54.032-92.912 0.002-183.004-18.178-267.772-54.030zM910.064 335h-80.008v-80.010c0.002-22.088-17.906-39.992-39.996-39.992-22.088 0-39.998 17.906-39.998 39.996v80.006h-80.002c-22.094 0-40 17.908-39.998 40-0.002 22.090 17.904 39.996 39.996 39.996h80.004v80.002c0 22.094 17.908 40 40 40 22.090 0 39.996-17.906 39.996-39.996v-80.006l80.010-0.002c22.090 0.002 39.994-17.906 39.994-39.996 0-22.088-17.908-39.998-39.998-39.998z',
	  users: 'M123.302 822.204c-26.284-11.118-51.696-23.792-76.196-37.95 4.028-92.818 194.792-176.82 246.28-185.012 16.158-2.57 16.526-46.998 16.526-46.998s-47.476-46.994-57.818-110.192c-27.836 0-45.024-67.186-17.19-90.822-1.158-24.884-35.776-195.342 139.468-195.342 175.242 0 140.628 170.458 139.464 195.342 27.838 23.636 10.644 90.822-17.188 90.822-10.346 63.2-57.822 110.192-57.822 110.192s0.37 44.426 16.528 46.998c52.042 8.282 246.38 93.996 246.38 187.988v15.054c-14.028 7.102-28.316 13.758-42.88 19.918-84.77 35.852-174.864 54.032-267.78 54.032-92.912 0-183.004-18.18-267.772-54.030zM977.018 652.224c0-64.612-133.592-123.532-169.364-129.222-11.106-1.768-11.36-32.306-11.36-32.306s32.634-32.304 39.744-75.746c19.132 0 30.954-46.188 11.818-62.436 0.798-17.106 24.592-134.276-95.874-134.276-120.462 0-96.666 117.17-95.87 134.276-19.134 16.248-7.32 62.436 11.816 62.436 7.11 43.442 39.742 75.746 39.742 75.746s-0.25 30.54-11.358 32.306c-23.154 3.684-87.282 29.672-129.644 65.068 21.022 10.038 42.072 21.39 61.066 33.186 14.278 8.866 27.392 17.866 39.338 26.986 35.696 27.262 60.956 55.638 75.646 84.934 2.784 0.032 5.562 0.102 8.352 0.102 77.788 0 153.58-12.792 225.944-37.976v-43.078z',
	  profile: 'M396.984 530.228c-12.040-5.090-23.676-10.896-34.898-17.38 1.846-42.512 89.218-80.984 112.798-84.736 7.402-1.178 7.568-21.526 7.568-21.526s-21.742-21.524-26.48-50.47c-12.748 0-20.622-30.77-7.874-41.596-0.532-11.398-16.384-89.468 63.878-89.468s64.408 78.070 63.876 89.468c12.75 10.826 4.876 41.596-7.872 41.596-4.738 28.948-26.482 50.47-26.482 50.47s0.168 20.348 7.568 21.526c23.836 3.792 112.846 43.050 112.846 86.102v6.894c-6.426 3.252-12.968 6.3-19.64 9.122-38.826 16.422-80.090 24.746-122.646 24.746-42.552-0.002-83.816-8.326-122.642-24.748zM800 145h-592.004v736h592.004c8.708 0 15.876-7.086 15.972-15.796v-704.246c-0.018-8.8-7.176-15.958-15.972-15.958zM800 65c52.944 0 95.872 42.858 95.992 95.772l0.012 0.014v705.334h-0.036c-0.602 52.502-43.324 94.88-95.968 94.88h-632.004c-22.090 0-40-17.906-40-40v-816c0-20.338 15.192-37.090 34.836-39.628 1.696-0.218 3.41-0.372 5.164-0.372h632.004zM736.282 792.998c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20zM736.282 704.998c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20zM736.282 616.998c0-11.044-8.956-20-20-20h-408.282c-11.044 0-20 8.956-20 20s8.956 20 20 20h408.282c11.044 0 20-8.956 20-20z',
	  bookmark: 'M772 1012L511 761l-260 251a49 49 0 0 1-52 10c-18-7-29-24-29-43V132c0-25 21-46 47-46h588c26 0 47 21 47 46v847c0 19-11 36-29 43a49 49 0 0 1-51-10z',
	  bookmarkhollow: 'M772 1012L511 761l-260 251a49 49 0 0 1-52 10c-18-7-29-24-29-43V132c0-25 21-46 47-46h588c26 0 47 21 47 46v847c0 19-11 36-29 43a49 49 0 0 1-51-10zM545 664l213 205V181H265v688l213-205c9-9 21-14 33-14s24 5 34 14z',
	  book: 'M896.054 159.774c-0.122-52.914-43.048-95.774-95.992-95.774h-632.004c-1.754 0-3.468 0.154-5.164 0.372-19.644 2.54-34.836 19.292-34.836 39.628v816c0 22.094 17.91 40 40 40h632.004c52.642 0 95.368-42.378 95.968-94.88h0.036v-705.332l-0.012-0.014zM368.062 144h80v271.922l-11.728-11.718c-15.62-15.606-40.924-15.606-56.542 0l-11.728 11.718v-271.922zM816.036 864.204c-0.1 8.712-7.268 15.796-15.972 15.796h-592.004v-736h80.004v368.426c0 16.176 9.742 30.758 24.684 36.954 14.944 6.192 32.146 2.778 43.586-8.656l51.728-51.68 51.728 51.68c7.652 7.644 17.876 11.708 28.28 11.708 5.156 0 10.356-1 15.306-3.050 14.944-6.196 24.684-20.778 24.684-36.954v-368.428h272c8.796 0 15.972 7.16 15.992 15.958l-0.016 704.246z',
	  repository: 'M856.020 159.804c-0.122-52.916-43.048-95.774-95.992-95.774h-591.968c-1.754 0-3.468 0.154-5.164 0.37-19.644 2.54-34.836 19.292-34.836 39.63v784.584c0 22.094 17.91 40 40 40h151.972v63.594c0 10.876 6.548 20.682 16.598 24.844 10.046 4.164 21.612 1.87 29.304-5.818l34.78-34.748 34.78 34.748c5.144 5.14 12.020 7.87 19.014 7.87 3.466 0 6.962-0.672 10.292-2.052 10.048-4.164 16.598-13.968 16.598-24.844v-63.594h278.63c52.642 0 95.368-42.38 95.968-94.882h0.036v-673.916l-0.012-0.012zM776.020 159.988l-0.014 504.628h-519.974v-520.584h503.996c8.796-0 15.972 7.158 15.992 15.956zM760.028 848.616h-278.63v-56h-161.366v56h-111.972v-104h567.944l-0.002 88.204c-0.102 8.71-7.27 15.796-15.974 15.796zM320.032 240.396c0-17.67 14.328-31.998 31.998-31.998s32.002 14.326 32.002 31.998c0 17.674-14.332 32-32.002 32-17.672-0.002-31.998-14.326-31.998-32zM320.032 349.79c0-17.67 14.328-31.998 31.998-31.998s32.002 14.328 32.002 31.998c0 17.676-14.332 32-32.002 32-17.672 0-31.998-14.324-31.998-32zM320.032 459.188c0-17.67 14.328-32 31.998-32s32.002 14.328 32.002 32c0 17.674-14.332 31.998-32.002 31.998-17.672 0-31.998-14.324-31.998-31.998zM384.032 568.582c0 17.674-14.332 31.998-32.002 31.998s-31.998-14.324-31.998-31.998c0-17.67 14.328-32 31.998-32 17.67 0.002 32.002 14.33 32.002 32z',
	  star: 'M763.972 919.5c-6.368 0-12.758-1.518-18.61-4.596l-233.358-122.688-233.37 122.688c-13.476 7.090-29.808 5.904-42.124-3.042-12.318-8.95-18.486-24.118-15.912-39.124l44.57-259.856-188.792-184.028c-10.904-10.626-14.828-26.524-10.124-41.004s17.222-25.034 32.292-27.222l260.906-37.912 116.686-236.42c6.738-13.652 20.644-22.296 35.87-22.296v0c15.226 0 29.13 8.644 35.87 22.298l116.674 236.418 260.906 37.912c15.068 2.19 27.586 12.742 32.292 27.222s0.782 30.376-10.124 41.004l-188.792 184.028 44.24 257.93c0.62 2.796 0.946 5.704 0.946 8.688 0 22.054-17.848 39.942-39.888 40-0.054 0-0.106 0-0.158 0z',
	  starhollow: 'M763.972 919.5c-6.368 0-12.758-1.518-18.61-4.596l-233.358-122.688-233.37 122.688c-13.476 7.090-29.808 5.904-42.124-3.042-12.318-8.95-18.486-24.118-15.912-39.124l44.57-259.856-188.792-184.028c-10.904-10.626-14.828-26.524-10.124-41.004s17.222-25.034 32.292-27.222l260.906-37.912 116.686-236.42c6.738-13.652 20.644-22.296 35.87-22.296v0c15.226 0 29.13 8.644 35.87 22.298l116.674 236.418 260.906 37.912c15.068 2.19 27.586 12.742 32.292 27.222s0.782 30.376-10.124 41.004l-188.792 184.028 44.24 257.93c0.62 2.796 0.946 5.704 0.946 8.688 0 22.054-17.848 39.942-39.888 40-0.054 0-0.106 0-0.158 0zM190.256 428.144l145.812 142.13c9.428 9.192 13.73 22.432 11.504 35.406l-34.424 200.7 180.244-94.758c11.654-6.13 25.576-6.126 37.226 0l180.232 94.756-34.422-200.698c-2.226-12.974 2.076-26.214 11.504-35.406l145.812-142.13-201.51-29.282c-13.030-1.892-24.292-10.076-30.118-21.882l-90.114-182.596-90.122 182.598c-5.826 11.804-17.090 19.988-30.118 21.88l-201.506 29.282z',
	  circle: 'M960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448c0-247.424 200.576-448 448-448s448 200.576 448 448z',
	  circlehollow: 'M960 513c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM251.786 773.216c-69.504-69.508-107.786-161.918-107.786-260.216 0-98.294 38.282-190.708 107.786-260.216 69.506-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214-69.506 69.508-161.922 107.786-260.214 107.786-98.296 0-190.708-38.278-260.214-107.784z',
	  heart: 'M895.032 194.328c-20.906-21.070-46.492-37.316-76.682-48.938-30.104-11.71-63.986-17.39-101.474-17.39-19.55 0-38.744 2.882-57.584 9.094-18.472 6.062-36.584 14.242-54.072 24.246-17.476 9.828-34.056 21.276-49.916 33.898-16.038 12.8-30.456 25.572-43.346 38.664-13.52-13.092-28.026-25.864-43.616-38.664-15.684-12.624-32.080-24.070-49.382-33.898-17.214-10.004-35.414-18.184-54.704-24.246-19.104-6.21-38.568-9.094-58.034-9.094-37.126 0-70.56 5.68-100.48 17.39-29.732 11.622-55.328 27.868-76.328 48.938-20.994 21.094-37.214 46.962-48.478 77.328-11.174 30.544-16.942 64.5-16.942 101.812 0 21.628 3.068 43.078 9.19 64.53 6.308 21.096 14.416 41.986 24.876 61.642 10.446 19.656 22.702 38.488 36.584 56.59 13.88 18.124 28.388 34.516 43.344 49.58l305.766 305.112c8.466 7.558 18.11 11.444 28.204 11.444 10.726 0 19.914-3.884 27.308-11.444l305.934-304.226c14.78-14.772 29.382-31.368 43.166-49.378 14.058-18.212 26.314-37.222 37.042-57.23 10.9-19.924 19.192-40.638 25.406-62 6.218-21.188 9.198-42.61 9.198-64.618 0-37.312-5.592-71.268-16.582-101.812-11.264-30.366-27.22-56.236-48.398-77.33z',
	  hearthollow: 'M716.876 208c27.708 0 52.092 4.020 72.47 11.948l0.132 0.052 0.13 0.050c19.866 7.644 35.774 17.664 48.632 30.624l0.166 0.168 0.17 0.168c12.586 12.536 22.304 28.27 29.706 48.094 7.782 21.786 11.726 46.798 11.726 74.364 0 14.658-1.95 28.426-5.958 42.086l-0.028 0.092-0.026 0.092c-4.866 16.72-11.006 31.752-18.776 45.952l-0.162 0.298-0.16 0.296c-8.81 16.434-18.58 31.532-29.864 46.148l-0.204 0.264c-11.316 14.786-23.48 28.708-36.154 41.378l-277.122 275.574-276.94-276.35c-13.32-13.43-25.248-27.074-36.488-41.75-11.386-14.848-21.284-30.136-29.444-45.49-7.206-13.54-13.494-29.17-18.7-46.472-4.030-14.264-5.988-28.044-5.988-42.116 0-27.36 4.042-52.314 12.016-74.176 7.214-19.378 17.344-35.708 30.066-48.492 12.998-13.042 28.958-23.148 48.826-30.914 20.436-8 43.764-11.886 71.32-11.886 11.536 0 22.738 1.742 33.298 5.174l0.374 0.122 0.376 0.12c13.116 4.122 26.066 9.874 38.494 17.094l0.34 0.2 0.344 0.196c12.736 7.234 25.308 15.876 38.43 26.412 14.486 11.906 27.060 23.048 38.428 34.056l56.994 55.192 55.662-56.532c10.324-10.484 22.18-21.040 36.242-32.264 13.382-10.646 26.216-19.38 39.228-26.698l0.256-0.144 0.254-0.144c13.008-7.442 26.228-13.386 39.294-17.676l0.050-0.016 0.050-0.018c10.354-3.414 20.998-5.076 32.54-5.076zM716.876 128c-19.55 0-38.744 2.882-57.584 9.094-18.472 6.062-36.584 14.242-54.072 24.246-17.476 9.828-34.056 21.276-49.916 33.898-16.038 12.8-30.456 25.572-43.346 38.664-13.52-13.092-28.026-25.864-43.616-38.664-15.684-12.624-32.080-24.070-49.382-33.898-17.214-10.004-35.414-18.184-54.704-24.246-19.104-6.21-38.568-9.094-58.034-9.094-37.126 0-70.56 5.68-100.48 17.39-29.732 11.622-55.328 27.868-76.328 48.938-20.994 21.094-37.214 46.962-48.478 77.328-11.174 30.544-16.942 64.5-16.942 101.812 0 21.628 3.068 43.078 9.19 64.53 6.308 21.096 14.416 41.986 24.876 61.642 10.446 19.656 22.702 38.488 36.584 56.59 13.88 18.124 28.388 34.516 43.344 49.58l305.766 305.112c8.466 7.558 18.11 11.444 28.204 11.444 10.726 0 19.914-3.884 27.308-11.444l305.934-304.226c14.78-14.772 29.382-31.368 43.166-49.378 14.058-18.212 26.314-37.222 37.042-57.23 10.9-19.924 19.192-40.638 25.406-62 6.218-21.188 9.198-42.61 9.198-64.618 0-37.312-5.592-71.268-16.582-101.812-11.262-30.366-27.216-56.234-48.396-77.328-20.906-21.070-46.492-37.316-76.682-48.938-30.106-11.712-63.988-17.392-101.476-17.392v0z',
	  facehappy: 'M960 513c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM251.786 773.214c-69.504-69.508-107.786-161.918-107.786-260.214 0-98.294 38.282-190.708 107.786-260.216 69.506-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214-69.506 69.506-161.922 107.786-260.214 107.786-98.296 0-190.708-38.28-260.214-107.786zM416.5 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM736 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM763.62 636.976v0.094c-49.554 87.14-143.21 145.93-250.62 145.93-107.486 0-201.2-58.868-250.726-146.108v-0.092c-3.34-5.842-5.274-12.59-5.274-19.8s1.934-13.958 5.274-19.798v-0.198h0.122c6.918-11.946 19.808-20.004 34.606-20.004s27.69 8.058 34.61 20.004h0.098c35.756 63.222 103.614 105.996 181.29 105.996s145.54-42.774 181.3-105.996h0.090c6.918-11.946 19.81-20.004 34.606-20.004s27.69 8.058 34.61 20.004h0.014v0.024c3.402 5.88 5.38 12.69 5.38 19.972 0 7.286-1.978 14.094-5.38 19.976z',
	  facesad: 'M960 513c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM251.786 773.214c-69.504-69.506-107.786-161.918-107.786-260.214 0-98.294 38.282-190.708 107.786-260.216 69.506-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214-69.506 69.506-161.922 107.786-260.214 107.786-98.296 0-190.708-38.28-260.214-107.786zM416.5 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM736 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM262.38 684.024v-0.094c49.552-87.14 143.208-145.93 250.62-145.93 107.486 0 201.2 58.868 250.726 146.108v0.092c3.34 5.842 5.274 12.59 5.274 19.8s-1.934 13.958-5.274 19.798v0.198h-0.122c-6.918 11.946-19.808 20.004-34.606 20.004s-27.69-8.058-34.61-20.004h-0.098c-35.76-63.222-103.618-105.996-181.292-105.996s-145.54 42.774-181.3 105.996h-0.090c-6.918 11.946-19.808 20.004-34.606 20.004s-27.69-8.058-34.61-20.004h-0.014v-0.024c-3.402-5.88-5.38-12.69-5.38-19.972 0.002-7.286 1.98-14.094 5.382-19.976z',
	  faceneutral: 'M968 513c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM259.786 773.214c-69.504-69.506-107.786-161.918-107.786-260.214 0-98.294 38.282-190.708 107.786-260.216 69.506-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214-69.506 69.506-161.922 107.786-260.214 107.786-98.296 0-190.708-38.28-260.214-107.786zM424.5 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM744 384.998c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM777 641c0 22.094-17.906 40-40 40h-432c-22.090 0-40-17.906-40-40 0-22.090 17.91-40 40-40h432c22.094 0 40 17.91 40 40z',
	  lock: 'M896.032 915.53v-467.498c0-19.102-13.402-35.052-31.31-39.026-0.21-0.046-0.414-0.12-0.628-0.162-0.444-0.090-0.904-0.13-1.354-0.208-2.186-0.37-4.416-0.606-6.708-0.606h-55.902l0.002-55.85h0.020c0-159.14-129.010-288.15-288.15-288.15-159.128 0-288.13 128.992-288.15 288.118v55.884h-54.852c-20.71 0-37.746 15.742-39.792 35.91-0.136 1.344-0.208 2.708-0.208 4.090v463.332c-0.618 2.792-0.968 5.688-0.968 8.668 0 22.094 17.91 40 40 40h688.27c22.092 0 40-17.91 40-40-0.002-1.524-0.104-3.024-0.27-4.502zM209 488.032h607.032v392h-607.032v-392zM303.85 352.182c0-114.776 93.376-208.15 208.15-208.15 114.59 0 207.842 93.074 208.142 207.596 0 0.084-0.012 0.164-0.012 0.248v56.156h-416.284l0.004-55.85zM552.164 691.858l-0.002 58.188c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40v-57.974c-14.704-11.726-24.134-29.782-24.134-50.048 0-35.346 28.654-64 64-64s64 28.654 64 64c0 20.142-9.318 38.104-23.868 49.836z',
	  unlock: 'M896.032 915.53v-467.498c0-1.988-0.194-3.926-0.472-5.834-0.11-0.744-0.192-1.498-0.34-2.226-1.524-7.44-5.136-14.1-10.164-19.408-0.252-0.266-0.48-0.554-0.738-0.814-0.496-0.494-1.036-0.944-1.554-1.412-0.43-0.386-0.84-0.8-1.288-1.17-0.292-0.24-0.608-0.446-0.904-0.676-2.506-1.954-5.244-3.616-8.176-4.934-0.744-0.334-1.504-0.632-2.27-0.922-4.39-1.656-9.124-2.604-14.094-2.604h-552.184l0.002-55.85c0-114.776 93.376-208.15 208.15-208.15 86.038 0 160.034 52.474 191.7 127.096 0.012 0.028 0.030 0.044 0.042 0.072 5.978 14.566 20.284 24.832 37.006 24.832 22.090 0 40-17.906 40-40 0-4.71-0.86-9.21-2.354-13.41-0.182-0.694-0.42-1.438-0.782-2.292-43.666-103.582-146.14-176.296-265.612-176.296-159.128 0-288.13 128.994-288.15 288.12v55.882h-54.85c-20.71 0-37.746 15.742-39.792 35.91-0.136 1.344-0.208 2.708-0.208 4.090v463.332c-0.618 2.794-0.968 5.688-0.968 8.668 0 22.094 17.91 40 40 40h688.27c22.092 0 40-17.91 40-40-0.002-1.528-0.104-3.028-0.27-4.506zM209 488.032h607.032v392h-607.032v-392zM552.164 691.86l-0.002 58.186c0.004 22.088-17.906 39.996-39.996 40-22.094 0-40.004-17.908-40-40v-57.976c-14.702-11.726-24.134-29.782-24.134-50.048 0-35.346 28.654-64 64-64s64 28.654 64 64c0 20.142-9.318 38.102-23.868 49.838z',
	  key: 'M768.032 320.032c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM960.032 353.092c0 159.062-128.946 288.010-288.008 288.010-35.306 0-69.124-6.368-100.38-17.996l-27.736 27.738-0.002 54.464c0 0.016 0.002 0.028 0.002 0.040 0 11.046-4.478 21.046-11.716 28.29-6.334 6.332-14.784 10.55-24.196 11.508-1.346 0.136-2.708 0.208-4.090 0.208h-71.748l-0.002 71.96c0 0.012 0.002 0.040 0.002 0.040 0 11.046-4.478 21.046-11.716 28.286-6.334 6.336-14.784 10.554-24.196 11.508-1.346 0.136-2.708 0.208-4.090 0.208h-71.996l-0.002 62.684c0 22.094-17.908 40-40 40-0.022 0-0.042 0-0.062 0-0.022 0-0.042 0-0.064 0h-175.996c-13.76 0-25.888-6.95-33.086-17.524-4.362-6.406-6.916-14.14-6.916-22.476v-112c0-0.664 0.066-1.308 0.1-1.964 0.032-0.618 0.034-1.234 0.092-1.852 0.11-1.148 0.288-2.278 0.492-3.398 0.024-0.128 0.034-0.258 0.058-0.386 1.614-8.378 5.848-15.808 11.808-21.446l325.456-325.458c-11.642-31.274-18.020-65.11-18.020-100.44 0-159.060 128.946-288.006 288.006-288.006 159.060-0.004 288.006 128.942 288.006 288.002zM880.032 353.092c0-114.696-93.312-208.006-208.008-208.006s-208.006 93.31-208.006 208.006c0 43.208 13.246 83.376 35.884 116.668l-57.36 57.362c-0.136-0.184-0.27-0.368-0.408-0.546l-298.102 298.106-0.002 55.356h96.124v-62.684c0-0.708 0.070-1.394 0.106-2.094 0.036-0.664 0.036-1.336 0.102-1.992 0.132-1.316 0.334-2.61 0.592-3.882 0.006-0.028 0.008-0.058 0.014-0.090 0.258-1.262 0.58-2.5 0.956-3.714 0.012-0.040 0.018-0.078 0.030-0.118 4.676-15.032 17.976-26.262 34.114-27.902 1.344-0.136 2.708-0.208 4.090-0.208h71.998v-67.64c-0.156-1.434-0.248-2.882-0.248-4.36 0-22.094 17.908-40 40-40h71.998v-30.692c0-0.148 0.020-0.29 0.022-0.438 0.008-10.226 3.912-20.45 11.714-28.254l55.99-55.988c1.982-1.984 4.124-3.71 6.38-5.188l18.68-18.684c33.030 22.090 72.702 34.992 115.332 34.992 114.694-0 208.008-93.314 208.008-208.010z',
	  arrowleftalt: 'M107.854 539.924l282.834 283.272c15.594 15.65 40.92 15.692 56.568 0.1 15.648-15.594 15.694-40.92 0.1-56.568l-214.838-215.040h655.412c22.092 0 40-17.908 40-40s-17.908-40-40-40h-655l214.75-214.61c15.64-15.602 15.672-40.928 0.070-56.568-7.814-7.834-18.066-11.752-28.32-11.75-10.22 0-20.442 3.892-28.25 11.68l-283.242 282.93c-15.634 15.594-15.672 40.91-0.084 56.554z',
	  arrowrightalt: 'M916.266 483.792l-282.834-283.272c-15.594-15.65-40.92-15.692-56.568-0.1-15.648 15.594-15.694 40.92-0.1 56.568l214.838 215.040h-655.412c-22.092 0-40 17.908-40 40s17.908 40 40 40h655l-214.748 214.61c-15.64 15.602-15.672 40.928-0.070 56.568 7.814 7.834 18.066 11.752 28.32 11.75 10.22 0 20.442-3.892 28.25-11.68l283.242-282.93c15.632-15.596 15.67-40.91 0.082-56.554z',
	  sync: 'M998.786 474.516l-91 90.988c-8.028 8.036-18.624 11.902-29.152 11.676-10.536 0.234-21.144-3.632-29.184-11.676l-92.3-92.296c-15.624-15.622-15.624-40.95 0-56.57 15.622-15.622 40.95-15.624 56.57 0l26.146 26.148c-13.774-61.416-44.624-117.806-90.216-163.394-63.46-63.464-147.84-98.414-237.586-98.414-89.75 0-174.128 34.95-237.59 98.414-27.012 27.012-48.836 57.824-65.024 91.214l-0.008-0.004c-6.722 12.632-20.008 21.242-35.32 21.242-22.090 0-40-17.906-40-40 0-5.464 1.102-10.668 3.086-15.414l-0.004-0.004c0.016-0.032 0.024-0.058 0.040-0.090 0.036-0.078 0.070-0.156 0.106-0.234 0.73-1.632 0.208-0.718 5.004-9.996 69.18-133.726 208.766-225.128 369.71-225.128 203.224 0 372.374 145.734 408.728 338.392l21.424-21.424c15.618-15.622 40.946-15.622 56.566 0s15.624 40.948 0.004 56.57zM889.992 682.11c0 5.464-1.106 10.672-3.090 15.414l0.008 0.004c-0.016 0.036-0.028 0.058-0.040 0.090-0.036 0.078-0.074 0.156-0.106 0.234-0.73 1.636-0.208 0.718-5.008 10-69.176 133.722-208.762 225.124-369.708 225.124-205.2 0-375.668-148.578-409.76-344.022l-19.478 19.478c-15.622 15.622-40.95 15.622-56.57 0-15.618-15.622-15.622-40.95 0-56.57l90.996-90.992c8.032-8.032 18.628-11.902 29.152-11.672 10.536-0.238 21.144 3.632 29.188 11.672l92.296 92.3c15.624 15.618 15.624 40.946 0 56.566-15.618 15.622-40.946 15.624-56.566 0.004l-29.292-29.292c12.466 65.568 44.214 125.882 92.448 174.116 63.46 63.46 147.84 98.41 237.586 98.41 89.75 0 174.124-34.95 237.59-98.41 27.012-27.012 48.836-57.824 65.020-91.218l0.008 0.004c6.726-12.632 20.012-21.242 35.324-21.242 22.092 0.002 40.002 17.912 40.002 40.002zM145.83 545.416l1.4 0.248-0.824-0.824-0.576 0.576z',
	  reply: 'M679.496 431.738c-0.414-0.062-0.834-0.102-1.266-0.102h-477.482l171.506-171.504c15.622-15.622 15.622-40.95-0.002-56.57-15.62-15.624-40.948-15.624-56.568 0l-239.734 239.732c-0.958 0.956-1.868 1.958-2.724 3.006-0.328 0.402-1.884 2.482-2.324 3.138-0.36 0.54-1.696 2.77-2.008 3.352-0.308 0.58-1.424 2.936-1.676 3.544-0.036 0.086-0.468 1.268-0.648 1.774-0.23 0.636-0.474 1.266-0.672 1.918-0.186 0.612-0.818 3.13-0.95 3.788-0.148 0.748-0.522 3.318-0.574 3.862-0.262 2.642-0.262 5.3 0 7.942 0.044 0.448 0.412 3.032 0.58 3.874 0.112 0.556 0.74 3.088 0.958 3.808 0.158 0.524 1.036 2.992 1.328 3.7 0.192 0.458 1.298 2.828 1.688 3.552 0.208 0.386 0.446 0.75 0.666 1.126 0.436 0.752 1.844 2.888 2.084 3.224 0.52 0.724 4.262 5.074 4.29 5.098l239.718 239.72c15.62 15.618 40.948 15.618 56.57 0 15.62-15.624 15.622-40.948 0-56.57l-171.516-171.514h471.296c114.52 0.084 207.688 93.124 207.988 207.594 0 0.084-0.012 0.164-0.012 0.248v95.876c-0.004 22.094 17.906 40.002 40 40 22.090-0.002 40-17.91 39.996-39.998l0.004-95.57h0.020c0-156.594-124.914-284.012-280.536-288.048z',
	  undo: 'M230 301h480a240 240 0 1 1 0 481H235c-23 0-42-20-42-43 0-24 19-43 42-43h475a155 155 0 0 0 0-310H228l3 3 65 65a45 45 0 0 1-65 64L90 376a45 45 0 0 1 0-64l142-142a45 45 0 1 1 64 65l-63 62-3 4z',
	  transfer: 'M916.25 348.726l-125 124.688c-7.808 7.79-18.032 11.68-28.25 11.68-10.254 0.002-20.506-3.918-28.32-11.75-15.602-15.64-15.57-40.966 0.070-56.568l56.508-56.368h-655.258c-22.092 0-40-17.908-40-40s17.908-40 40-40h655.672l-57.006-57.206c-15.594-15.646-15.548-40.972 0.1-56.566s40.972-15.55 56.568 0.098l125 125.438c15.588 15.644 15.548 40.958-0.084 56.554zM107.666 731.892l125 125.438c15.596 15.648 40.92 15.692 56.568 0.098s15.694-40.92 0.1-56.566l-57.006-57.206h655.672c22.092 0 40-17.908 40-40s-17.908-40-40-40h-655.258l56.508-56.368c15.64-15.602 15.672-40.928 0.070-56.568-7.814-7.832-18.066-11.752-28.32-11.75-10.218 0-20.442 3.89-28.25 11.68l-125 124.688c-15.632 15.596-15.672 40.91-0.084 56.554z',
	  redirect: 'M913.852 702.796c-15.594-15.648-40.922-15.694-56.57-0.1l-57.204 57.006v-451.424c0-0.372-0.028-0.736-0.074-1.098-0.458-99.016-80.86-179.15-179.988-179.15-99.412 0-180 80.592-180 180 0 0.084 0.004 0.166 0.004 0.248h-0.004v343.504h-0.006c0 0.082 0.006 0.164 0.006 0.248 0 55.14-44.86 100-100 100s-100-44.86-100-100c0-0.084 0.006-0.166 0.006-0.248h-0.002v-483.752c0-22.092-17.91-40-40-40s-40.004 17.908-40.004 40v483.752c0 0.018 0.002 0.036 0.002 0.054 0 0.064-0.002 0.128-0.002 0.194 0 99.408 80.59 180 180 180 99.412 0 180-80.592 180-180 0-0.084-0.004-0.166-0.004-0.248h0.004v-343.504h0.008c0-0.082-0.008-0.164-0.008-0.248 0-55.138 44.86-100 100-100s100 44.862 100 100c0 0.084-0.008 0.166-0.008 0.248h0.070v451.008l-56.368-56.506c-15.602-15.642-40.93-15.67-56.566-0.070-7.836 7.814-11.754 18.066-11.754 28.32 0 10.218 3.894 20.442 11.68 28.252l124.692 125c15.594 15.632 40.91 15.67 56.554 0.084l125.434-125c15.652-15.598 15.692-40.92 0.102-56.57z',
	  expand: 'M959.688 920.068l0.31-176c0.040-22.094-17.84-40.032-39.93-40.070-22.092-0.040-40.032 17.838-40.070 39.93l-0.142 79.672-235.734-235.732c-15.622-15.622-40.948-15.622-56.57 0s-15.622 40.948 0 56.568l235.442 235.442-78.946-0.1c-22.092-0.028-40.022 17.86-40.050 39.952-0.014 11.064 4.464 21.084 11.714 28.334 7.228 7.224 17.208 11.702 28.236 11.714l175.688 0.22c22.086 0.028 40.014-17.846 40.052-39.93zM920.178 64.228l-176-0.308c-22.094-0.040-40.032 17.84-40.070 39.93-0.040 22.092 17.838 40.032 39.93 40.070l79.672 0.14-235.732 235.734c-15.622 15.622-15.622 40.948 0 56.568s40.948 15.622 56.568 0l235.442-235.442-0.1 78.946c-0.028 22.092 17.86 40.022 39.952 40.050 11.064 0.014 21.084-4.464 28.334-11.714 7.224-7.228 11.702-17.208 11.714-28.236l0.22-175.688c0.026-22.082-17.846-40.010-39.93-40.050zM64.236 103.742l-0.308 176c-0.040 22.094 17.84 40.032 39.93 40.070 22.092 0.040 40.032-17.84 40.070-39.93l0.14-79.672 235.734 235.73c15.622 15.622 40.948 15.622 56.568 0s15.622-40.946 0-56.566l-235.442-235.442 78.946 0.098c22.092 0.028 40.022-17.86 40.050-39.95 0.014-11.066-4.464-21.086-11.714-28.336-7.228-7.222-17.208-11.7-28.236-11.714l-175.688-0.218c-22.084-0.026-40.012 17.844-40.050 39.93zM103.748 959.766l176 0.308c22.094 0.040 40.032-17.84 40.070-39.93 0.040-22.092-17.84-40.032-39.93-40.070l-79.672-0.14 235.73-235.734c15.622-15.622 15.622-40.948 0-56.568s-40.946-15.622-56.566 0l-235.442 235.442 0.098-78.946c0.028-22.092-17.86-40.022-39.95-40.050-11.066-0.014-21.086 4.464-28.336 11.714-7.222 7.228-11.7 17.208-11.714 28.236l-0.218 175.688c-0.026 22.082 17.844 40.010 39.93 40.050z',
	  expandalt: 'M512.008 959.964c-10.236 0-20.47-3.904-28.282-11.712l-239.898-239.838c-15.624-15.62-15.624-40.946-0.006-56.57 15.622-15.622 40.948-15.624 56.568-0.004l211.618 211.562 211.712-211.658c15.624-15.618 40.952-15.616 56.568 0.004 15.62 15.624 15.618 40.95-0.006 56.57l-239.994 239.934c-7.808 7.808-18.044 11.712-28.28 11.712zM483.824 75.744l-239.994 239.934c-15.624 15.62-15.624 40.948-0.006 56.57s40.944 15.622 56.568 0.004l211.712-211.658 211.618 211.562c15.622 15.62 40.948 15.616 56.568-0.006 15.62-15.624 15.618-40.95-0.006-56.57l-239.898-239.836c-7.81-7.81-18.044-11.714-28.282-11.714s-20.47 3.906-28.28 11.714z',
	  grow: 'M541.146 448.384c-1.694-0.216-3.408-0.37-5.162-0.37h-367.968c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v368.032c0 22.094 17.91 40 40 40h367.968c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-368.036c0-20.34-15.192-37.094-34.838-39.632zM208.016 816.046v-288.032h287.968v288.032h-287.968zM736.032 856.046c0 22.090-17.908 40-40 40-22.090 0-40-17.908-40-40v-487.902l-488.016 0.002c-22.090 0-40-17.91-40-40s17.908-40.002 40-40.002h528.016c1.754 0 3.468 0.152 5.162 0.37 19.646 2.538 34.838 19.292 34.838 39.63v527.902zM896.032 168.030v688.004c-0.002 22.088-17.91 39.996-40 39.996s-40.002-17.908-40.002-40c0 0 0.002-304.026 0.002-304.040v-343.96h-343.96c-0.014 0-304.040 0.002-304.040 0.002-22.090 0-40-17.91-40-40s17.908-40.002 40-40.002h688c1.754 0 3.468 0.152 5.162 0.37 19.646 2.536 34.838 19.29 34.838 39.63z',
	  arrowleft: 'M257.93 511.976c0-10.236 3.902-20.47 11.71-28.282l344.098-344.158c15.622-15.624 40.946-15.624 56.57-0.006 15.622 15.622 15.624 40.948 0.004 56.568l-315.82 315.876 315.868 315.922c15.618 15.624 15.618 40.952-0.004 56.568-15.622 15.62-40.95 15.618-56.57-0.006l-344.146-344.202c-7.808-7.81-11.71-18.044-11.71-28.28z',
	  arrowup: 'M512.024 256c10.236 0 20.47 3.904 28.282 11.712l344.154 344.098c15.624 15.62 15.624 40.946 0.006 56.57-15.622 15.622-40.948 15.624-56.568 0.004l-315.876-315.82-315.922 315.868c-15.624 15.618-40.952 15.618-56.568-0.004-15.62-15.624-15.618-40.95 0.006-56.57l344.204-344.144c7.81-7.81 18.046-11.714 28.282-11.714z',
	  arrowdown: 'M511.976 768.002c-10.236 0-20.47-3.904-28.282-11.712l-344.154-344.098c-15.624-15.62-15.624-40.946-0.006-56.57 15.622-15.622 40.948-15.624 56.568-0.004l315.876 315.82 315.922-315.868c15.624-15.618 40.952-15.616 56.568 0.004 15.62 15.624 15.618 40.95-0.006 56.57l-344.204 344.144c-7.81 7.81-18.046 11.714-28.282 11.714z',
	  arrowright: 'M768.072 514.022c0 10.236-3.904 20.47-11.712 28.282l-344.098 344.156c-15.62 15.624-40.946 15.624-56.568 0.006-15.622-15.622-15.624-40.948-0.006-56.568l315.82-315.876-315.868-315.922c-15.618-15.624-15.618-40.952 0.004-56.568 15.624-15.62 40.95-15.618 56.57 0.006l344.144 344.204c7.81 7.81 11.714 18.044 11.714 28.28z',
	  chevrondown: 'M511.976 833c-10.236 0-20.47-3.904-28.282-11.712l-471.934-471.874c-15.624-15.62-15.624-40.946-0.006-56.57 15.622-15.622 40.948-15.624 56.568-0.004l443.652 443.598 443.61-443.556c15.624-15.618 40.952-15.616 56.568 0.004 15.62 15.624 15.618 40.95-0.006 56.57l-471.89 471.832c-7.808 7.808-18.044 11.712-28.28 11.712z',
	  back: 'M512.030 880c-98.296 0-190.708-38.28-260.214-107.784-69.508-69.508-107.786-161.922-107.786-260.216 0-98.296 38.278-190.708 107.786-260.214s161.918-107.786 260.214-107.786c98.292 0 190.708 38.28 260.214 107.786 69.504 69.508 107.786 161.918 107.786 260.214 0 98.294-38.282 190.708-107.786 260.216-69.508 69.504-161.922 107.784-260.214 107.784zM512.030 960c247.422 0 448-200.576 448-448s-200.578-448-448-448c-247.426 0-448 200.576-448 448s200.574 448 448 448v0zM267.63 538.67l125 125.438c15.596 15.648 40.922 15.692 56.57 0.098s15.692-40.92 0.098-56.566l-57.004-57.206h335.672c22.090 0 40-17.908 40-40s-17.91-40-40-40h-335.26l56.508-56.368c15.64-15.602 15.672-40.928 0.070-56.568-7.814-7.832-18.064-11.752-28.318-11.75-10.22 0-20.444 3.89-28.25 11.68l-125 124.688c-15.634 15.596-15.672 40.91-0.086 56.554z',
	  download: 'M881 513.188c0 98.296-38.28 190.708-107.784 260.214-69.508 69.508-161.922 107.786-260.216 107.786-98.296 0-190.708-38.28-260.214-107.786s-107.786-161.916-107.786-260.214c0-98.294 38.28-190.708 107.786-260.216 69.508-69.504 161.918-107.784 260.214-107.784 98.294 0 190.708 38.28 260.216 107.784 69.504 69.508 107.784 161.922 107.784 260.216zM961 513.188c0-247.424-200.576-448-448-448s-448 200.576-448 448 200.576 448 448 448 448-200.576 448-448v0zM539.672 757.584l125.436-125c15.65-15.594 15.692-40.92 0.1-56.568-15.594-15.648-40.92-15.694-56.568-0.1l-57.204 57.004v-335.67c0-22.092-17.908-40-40-40s-40 17.908-40 40v335.258l-56.368-56.508c-15.602-15.64-40.928-15.672-56.568-0.070-7.834 7.814-11.752 18.066-11.75 28.32 0 10.22 3.892 20.442 11.68 28.25l124.688 125c15.594 15.634 40.91 15.672 56.554 0.084z',
	  upload: 'M143.996 511.998c0-98.296 38.28-190.708 107.784-260.214 69.508-69.508 161.922-107.786 260.216-107.786 98.296 0 190.708 38.278 260.214 107.786s107.786 161.918 107.786 260.214c0 98.292-38.28 190.708-107.786 260.214-69.508 69.504-161.918 107.786-260.214 107.786-98.294 0-190.708-38.282-260.216-107.786-69.504-69.508-107.784-161.922-107.784-260.214zM63.996 511.998c0 247.422 200.576 448 448 448s448-200.578 448-448c0-247.426-200.576-448-448-448s-448 200.574-448 448v0zM485.324 267.598l-125.438 125c-15.648 15.596-15.692 40.922-0.098 56.57s40.92 15.692 56.566 0.098l57.206-57.004v335.672c0 22.090 17.908 40 40 40s40-17.91 40-40v-335.26l56.368 56.508c15.602 15.64 40.928 15.672 56.568 0.070 7.832-7.814 11.752-18.064 11.75-28.318 0-10.22-3.89-20.444-11.68-28.25l-124.688-125c-15.594-15.634-40.91-15.672-56.554-0.086z',
	  proceed: 'M512 144c98.296 0 190.708 38.28 260.214 107.784 69.506 69.508 107.786 161.922 107.786 260.216 0 98.296-38.28 190.708-107.786 260.214-69.506 69.508-161.918 107.786-260.214 107.786-98.294 0-190.708-38.28-260.216-107.786-69.504-69.506-107.784-161.916-107.784-260.214 0-98.294 38.28-190.708 107.784-260.216 69.508-69.504 161.922-107.784 260.216-107.784zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448v0zM756.396 484.14l-125-125.436c-15.594-15.65-40.92-15.692-56.568-0.1-15.648 15.594-15.694 40.92-0.1 56.568l57.004 57.204h-335.67c-22.092 0-40 17.908-40 40s17.908 40 40 40h335.258l-56.508 56.368c-15.64 15.602-15.672 40.928-0.070 56.568 7.814 7.834 18.066 11.752 28.32 11.75 10.22 0 20.442-3.892 28.25-11.68l125-124.688c15.634-15.594 15.672-40.91 0.084-56.554z',
	  info: 'M828.782 195.216c-174.954-174.958-458.614-174.958-633.566 0-174.958 174.954-174.958 458.612 0 633.568 174.954 174.954 458.614 174.954 633.566 0 174.956-174.952 174.956-458.614 0-633.568zM772.214 772.214c-69.508 69.506-161.918 107.784-260.214 107.784-98.3 0-190.71-38.278-260.218-107.784-69.504-69.506-107.782-161.92-107.786-260.214 0.004-98.296 38.282-190.708 107.786-260.214 69.508-69.506 161.922-107.786 260.218-107.788 98.292 0.002 190.708 38.282 260.214 107.79 69.504 69.504 107.782 161.916 107.786 260.212-0.004 98.294-38.282 190.708-107.786 260.214zM512.996 361.124c-22.090 0-40-17.906-40-40v0c0-22.088 17.91-40 40-40v0c22.090 0 40.004 17.912 40.004 40v0c0 22.092-17.914 40-40.004 40v0zM512.998 743.094c-22.090 0-40-17.906-40-40v-240.002c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v240.002c0 22.094-17.914 40-40.004 40v0z',
	  question: 'M828.782 195.218c-174.954-174.958-458.614-174.958-633.566 0-174.958 174.954-174.958 458.612 0 633.566 174.954 174.956 458.614 174.956 633.566 0 174.956-174.95 174.956-458.614 0-633.566zM772.214 772.216c-69.508 69.504-161.918 107.782-260.214 107.782-98.3 0-190.71-38.278-260.218-107.782-69.504-69.506-107.782-161.92-107.786-260.216 0.004-98.298 38.282-190.708 107.786-260.216 69.508-69.504 161.922-107.784 260.218-107.784 98.292 0 190.708 38.28 260.214 107.788 69.504 69.504 107.782 161.916 107.786 260.214-0.004 98.294-38.282 190.708-107.786 260.214zM512.996 784.784c-22.090 0-40-17.906-40-40v0c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v0c0 22.094-17.914 40-40.004 40v0zM552.996 572.27v52.898c0.004 22.088-17.906 39.996-39.996 40-22.094 0-40.004-17.908-40-40v-88c-0.004-21.752 17.372-39.416 38.996-39.952v-0.146c53.118 0 96.332-43.212 96.332-96.33 0-53.116-43.214-96.328-96.332-96.328-53.098 0-96.296 43.184-96.324 96.278 0 0.014 0 0.034 0 0.050 0 22.094-17.914 40-40.004 40s-40-17.906-40-40c0-97.382 78.946-176.328 176.328-176.328 97.386 0 176.332 78.946 176.332 176.328 0 83.268-57.722 153.048-135.332 171.53z',
	  support: 'M828.814 195.216c-174.956-174.956-458.614-174.956-633.566 0-174.958 174.956-174.956 458.612 0 633.568s458.614 174.956 633.566 0c174.958-174.956 174.956-458.612 0-633.568zM813.592 723.072l-92.714-92.712c41.542-73.186 41.548-163.544 0.016-236.734l92.7-92.698c43.176 61.41 66.44 134.45 66.44 211.074-0.004 76.62-23.266 149.662-66.442 211.070zM398.916 625.116c-62.382-62.384-62.382-163.89 0-226.274 30.216-30.216 70.398-46.86 113.146-46.864h0.010c42.724 0 82.898 16.642 113.12 46.866 62.382 62.38 62.382 163.886 0 226.272-30.22 30.22-70.4 46.864-113.136 46.864-42.74-0.002-82.92-16.644-113.14-46.864zM723.104 210.44l-92.696 92.698c-36.59-20.766-77.464-31.162-118.356-31.158-40.888 0.004-81.78 10.406-118.378 31.178l-92.714-92.716c61.408-43.176 134.452-66.438 211.070-66.44 76.622-0.004 149.668 23.262 211.074 66.438zM210.472 300.928l92.724 92.726c-41.512 73.176-41.506 163.506 0.016 236.678l-92.742 92.74c-43.176-61.408-66.438-134.454-66.44-211.072 0.004-76.624 23.264-149.664 66.442-211.072zM512.032 880c-76.624-0.002-149.666-23.264-211.072-66.44l92.74-92.742c36.59 20.766 77.464 31.16 118.356 31.16 40.868 0 81.738-10.392 118.322-31.144l92.726 92.726c-61.408 43.176-134.454 66.44-211.072 66.44z',
	  alert: 'M511.998 623.846c-22.090 0-40-17.906-40-40v-208c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v208c0 22.094-17.914 40-40.004 40v0zM511.998 743.846c22.090 0 40.004-17.906 40.004-40v0c0-22.090-17.914-40-40.004-40v0c-22.090 0-40 17.91-40 40v0c0 22.094 17.91 40 40 40v0zM512.142 211.808l-340.074 589.028h680.148l-340.074-589.028zM512.142 92.51c14.5 0 29 9.526 40 28.58l398.638 690.462c22 38.106 4 69.282-40 69.282h-797.278c-44 0-62-31.176-40-69.282l398.638-690.462c11.002-19.052 25.502-28.58 40.002-28.58v0z',
	  bell: 'M901.344 760.018l-57.644-77.648c-7.906-7.906-11.77-38.284-11.71-48.646h0.042v-200.588h-0.364c-6.878-148.106-114.428-269.902-255.792-298.528 0.208-2.1 0.318-4.228 0.318-6.384 0-35.452-28.738-64.194-64.194-64.194-35.458 0-64.194 28.742-64.194 64.194 0 2.19 0.112 4.352 0.326 6.486-141.128 28.802-248.446 150.488-255.316 298.426h-0.364v200.588h0.042c0.058 10.362-3.804 40.74-11.71 48.646l-57.644 77.648c-8.802 8.802-16.35 18.978-16.35 32.208 0 22.092 17.908 40 40 40h255.876c-0.814 5.412-1.28 10.936-1.28 16.576 0 61.43 49.794 111.23 111.23 111.23 61.432 0 111.228-49.8 111.228-111.23 0-5.638-0.464-11.164-1.282-16.576h255.128c22.092 0 40-17.908 40-40 0.004-13.23-7.542-23.404-16.346-32.208zM272.732 436.848c2.862-61.602 29.032-119.104 73.69-161.91 44.786-42.93 103.628-66.62 165.692-66.706h0.26c62.062 0.086 120.906 23.776 165.692 66.706 44.658 42.806 70.828 100.308 73.69 161.91l0.278 5.962v149.384h-479.58v-149.384l0.278-5.962zM543.846 848.8c0 17.22-14.010 31.23-31.228 31.23-17.22 0-31.23-14.010-31.23-31.23 0-6.096 1.784-11.768 4.82-16.576h52.818c3.038 4.81 4.82 10.482 4.82 16.576zM512.484 752.226h-283.922l14.572-19.63c12.064-14.542 20.078-33.27 24.982-58.158 0.146-0.742 0.276-1.496 0.416-2.244h487.42c0.138 0.748 0.268 1.5 0.414 2.244 4.904 24.888 12.918 43.616 24.982 58.158l14.572 19.63h-283.436z',
	  rss: 'M256.094 865.048c0 53.020-42.972 96-96 96-53.020 0-96-42.98-96-96 0-53.016 42.98-96 96-96s96 42.984 96 96zM510.020 918.352c-0.018-0.172-0.042-0.344-0.050-0.52-0.054-0.676-0.124-1.34-0.214-2.004-10.582-105.644-57.866-200.46-128.894-271.536v0c-71.074-71.054-165.906-118.352-271.564-128.934-0.664-0.090-1.33-0.16-2.006-0.214-0.174-0.016-0.348-0.040-0.52-0.054-0.254-0.024-0.5-0.024-0.742-0.008-0.64-0.032-1.278-0.098-1.922-0.098-22.098 0-40 17.908-40 40 0 20.582 15.542 37.516 35.536 39.738 0.042 0.004 0.066 0.036 0.106 0.040 84.82 8.098 163.514 45.024 224.542 106.042v0c61.036 61.036 97.964 139.738 106.070 224.574 0.004 0.040 0.036 0.070 0.042 0.106 2.222 19.988 19.156 35.536 39.736 35.536 22.092 0 40-17.902 40-40 0-0.644-0.066-1.282-0.098-1.922 0-0.246 0-0.492-0.022-0.746zM734.688 918.45c-0.004-0.090-0.018-0.186-0.024-0.276-0.040-0.544-0.058-1.102-0.124-1.638-10.972-167.816-83.558-318.804-195.33-430.616h0.002c-111.812-111.788-262.81-184.384-430.644-195.36-0.542-0.060-1.094-0.084-1.642-0.122-0.092-0.008-0.182-0.016-0.272-0.022-0.020-0.002-0.042 0.004-0.054 0.004-0.836-0.052-1.664-0.124-2.512-0.124-22.092 0-40 17.908-40 40 0 21.036 16.246 38.24 36.874 39.842 0.046 0.008 0.078 0.038 0.128 0.042 66.876 4.086 131.786 19.292 193.406 45.358 70.472 29.81 133.78 72.494 188.166 126.874v0c54.394 54.396 97.090 117.71 126.902 188.204 26.064 61.624 41.274 126.532 45.362 193.408 0.004 0.052 0.036 0.080 0.042 0.13 1.604 20.624 18.802 36.87 39.844 36.87 22.090 0 40-17.904 40-40 0-0.85-0.074-1.678-0.126-2.514-0.002-0.024 0.006-0.040 0.002-0.060zM959.126 920.556c-0.002-0.094 0.008-0.164 0.004-0.262-10.342-231.204-108.314-439.604-261.486-592.796v-0.002c-153.2-153.19-361.61-251.174-592.828-261.518-0.096-0.004-0.168 0.006-0.262 0.004-0.176-0.004-0.348-0.030-0.524-0.030-22.098 0-40 17.91-40 40 0 20.988 16.168 38.164 36.716 39.834 0.184 0.042 0.356 0.086 0.566 0.098 97.040 4.314 191.186 25.538 280.376 63.258 97.14 41.090 184.406 99.928 259.368 174.876v0c74.96 74.964 133.81 162.24 174.908 259.398 37.718 89.19 58.946 183.336 63.26 280.376 0.010 0.208 0.052 0.38 0.096 0.562 1.67 20.552 18.848 36.72 39.834 36.72 22.092 0 40-17.906 40-40-0-0.17-0.024-0.342-0.028-0.518z',
	  edit: 'M948.56 263.376c12.704-12.708 15.072-31.836 7.11-46.936-1.84-3.524-4.232-6.832-7.192-9.792-0.286-0.286-0.594-0.528-0.886-0.8l-129.318-128.634c-0.048-0.048-0.088-0.106-0.138-0.154-7.812-7.812-18.050-11.716-28.292-11.714-10.242-0.004-20.484 3.902-28.296 11.714-0.064 0.066-0.12 0.136-0.184 0.204l-636.168 636.168c-5.868 5.134-10.21 11.958-12.298 19.748l-47.606 177.664c-3.7 13.804 0.248 28.534 10.352 38.638 7.602 7.6 17.816 11.714 28.288 11.714 3.452 0 6.93-0.446 10.352-1.364l177.664-47.606c7.296-1.956 13.732-5.904 18.74-11.216l521.486-521.484c1.126-0.904 2.222-1.87 3.268-2.914 1.042-1.044 2.006-2.138 2.91-3.264l107.75-107.748c0.836-0.71 1.668-1.432 2.458-2.224zM806.9 291.66l-73.592-73.202 56.61-56.61 73.594 73.2-56.612 56.612zM281.566 816.996l-73.4-73.4 468.572-468.568 73.594 73.202-468.766 468.766zM160.496 864.628l11.742-43.822 32.080 32.080-43.822 11.742z',
	  paintbrush: 'M946.58 293.66c12.704-12.708 15.072-31.836 7.108-46.938-1.838-3.524-4.23-6.83-7.19-9.79-0.282-0.282-0.588-0.52-0.876-0.792l-129.338-128.654c-0.046-0.046-0.084-0.098-0.13-0.144-7.814-7.812-18.056-11.718-28.296-11.714-10.24 0-20.48 3.906-28.292 11.714-0.064 0.066-0.12 0.138-0.184 0.206l-557.048 557.048c-2.194 2.192-4.042 4.59-5.622 7.11-70.624 87.486-17.922 195.43-174.738 239.554 0 0 64.758 18.11 144.33 18.11 74.374 0 161.678-15.824 221.23-77.020 0.394-0.364 0.808-0.696 1.192-1.078l1.734-1.734c0.852-0.798 1.678-1.578 2.504-2.426 0.348-0.356 0.668-0.728 1.010-1.086l168.756-168.756c1.126-0.906 2.224-1.872 3.272-2.918 1.044-1.044 2.008-2.14 2.914-3.266l375.212-375.212c0.834-0.706 1.664-1.424 2.452-2.214zM537.462 589.402l-73.594-73.206 324.068-324.064 73.594 73.2-324.068 324.070zM388.178 667.684c-13.288-13.632-28.584-23.974-44.78-31.016l63.902-63.902 73.596 73.204-64.246 64.248c-6.498-15.23-15.964-29.698-28.472-42.534zM229.848 791.928c8.294-30.346 14.852-54.332 32.416-73.862 0.83-0.864 2.664-2.702 4.26-4.286 8.030-6.792 17.534-8.246 24.198-8.246 14.386 0 29.026 6.554 40.162 17.98 19.592 20.106 21.934 49.238 5.596 66.874l-1.712 1.712c-0.798 0.752-1.612 1.524-2.462 2.354l-0.86 0.84-0.834 0.864c-30.666 31.79-75.914 45.424-118.104 50.542 7.53-18.888 12.598-37.426 17.34-54.772z',
	  close: 'M693.022 637.866c15.62 15.622 15.618 40.95 0 56.566-15.622 15.622-40.946 15.624-56.562 0.002l-124.46-124.458-124.456 124.458c-15.622 15.622-40.944 15.622-56.562 0-15.624-15.622-15.624-40.946-0.002-56.568l124.454-124.456-124.452-124.45c-15.622-15.622-15.622-40.946 0-56.564 15.62-15.624 40.944-15.624 56.568-0.002l124.45 124.45 124.454-124.452c15.622-15.62 40.95-15.62 56.566 0 15.622 15.62 15.624 40.944 0.002 56.56l-124.456 124.458 124.456 124.456zM828.784 828.784c-174.956 174.956-458.614 174.956-633.566 0-174.958-174.956-174.958-458.614 0-633.566 174.954-174.958 458.612-174.958 633.566 0 174.954 174.952 174.954 458.612 0 633.566zM880 511.998c-0.002-98.296-38.28-190.708-107.786-260.212s-161.92-107.786-260.214-107.788c-98.296 0.002-190.71 38.282-260.216 107.786-69.506 69.508-107.782 161.918-107.786 260.214 0.002 98.296 38.282 190.71 107.786 260.216 69.508 69.506 161.918 107.784 260.216 107.784 98.296 0 190.708-38.278 260.214-107.784s107.784-161.92 107.786-260.216z',
	  closeAlt: 'M586.7 512L936 861.4a52.8 52.8 0 0 1-74.6 74.7L512 586.7 162.6 936A52.8 52.8 0 0 1 88 861.4L437.3 512 88 162.6A52.8 52.8 0 1 1 162.6 88L512 437.3 861.4 88a52.8 52.8 0 1 1 74.7 74.7L586.7 512z',
	  trash: 'M919.5 225.208h-215.5v-120.080c0-20.344-15.192-37.096-34.836-39.632-1.696-0.216-3.41-0.372-5.164-0.372h-304.004c-1.754 0-3.468 0.152-5.164 0.372-19.644 2.54-34.836 19.292-34.836 39.628v120.084h-215.996c-22.090 0-40 17.912-40 40.002 0 22.092 17.91 40 40 40h27.216l53.916 615.914h0.214c0 22.092 17.91 40 40 40h573.372c22.094 0 40-17.91 40-40h0.148l53.916-615.914h26.716c22.090 0 40-17.91 40-40s-17.908-40.002-39.998-40.002zM399.996 145.126h224.004v80.082h-224.004v-80.082zM762.062 881.124h-500.124l-50.414-575.912h600.954l-50.416 575.912zM632.004 697.124v-240c-0.004-22.092 17.906-40.002 40-40.002 22.090 0.002 40 17.908 40 40.002l-0.004 240.002c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40zM311.996 697.124v-240c-0.004-22.092 17.906-40.002 40-40.002 22.090 0.002 40 17.908 40 40.002l-0.004 240.002c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40zM472 697.124v-240c-0.004-22.092 17.906-40.002 40-40.002 22.090 0.002 40 17.908 40 40.002l-0.004 240.002c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40z',
	  cross: 'M1013.286 955.716l-443.72-443.716 443.718-443.718c15.622-15.622 15.62-40.948-0.004-56.566-15.618-15.622-40.942-15.622-56.562 0l-443.716 443.718-443.72-443.718c-15.62-15.624-40.946-15.622-56.566 0-15.622 15.62-15.622 40.944 0 56.566l443.722 443.718-443.722 443.722c-15.622 15.618-15.62 40.942 0 56.56s40.948 15.622 56.566 0l443.72-443.718 443.722 443.718c15.618 15.624 40.942 15.622 56.56 0 15.62-15.618 15.622-40.944 0.002-56.566z',
	  "delete": 'M828.786 195.216c-174.958-174.956-458.612-174.958-633.568 0-174.954 174.954-174.956 458.612 0 633.566 174.954 174.956 458.614 174.956 633.568 0 174.954-174.954 174.952-458.612 0-633.566zM251.786 251.786c69.506-69.506 161.916-107.784 260.212-107.788 84.838 0 165.278 28.538 230.402 81.028l-517.372 517.374c-52.492-65.126-81.026-145.568-81.030-230.404 0.004-98.294 38.282-190.704 107.788-260.21zM772.214 772.214c-69.506 69.506-161.918 107.784-260.214 107.786-84.836-0.004-165.276-28.538-230.402-81.030l517.376-517.372c52.492 65.126 81.028 145.564 81.028 230.402-0.004 98.296-38.284 190.71-107.788 260.214z',
	  add: 'M512 144c98.296 0 190.708 38.28 260.214 107.784 69.506 69.508 107.786 161.922 107.786 260.216 0 98.296-38.28 190.708-107.786 260.214-69.508 69.506-161.918 107.786-260.214 107.786-98.294 0-190.708-38.28-260.216-107.786-69.504-69.508-107.784-161.918-107.784-260.214 0-98.294 38.28-190.708 107.784-260.216 69.508-69.504 161.922-107.784 260.216-107.784zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448v0zM729.002 473h-176.008v-176.008c0.002-22.090-17.906-39.994-39.996-39.994-22.088 0-39.998 17.908-39.998 39.998v176.004h-176c-22.094 0-40 17.908-39.998 40-0.002 22.090 17.904 39.996 39.996 39.996h176.002v176.004c0 22.094 17.908 40 40 39.998 22.090 0.002 39.996-17.904 39.996-39.996v-176.006l176.012-0.002c22.090 0.002 39.994-17.906 39.994-39.996-0.002-22.088-17.91-39.998-40-39.998z',
	  subtract: 'M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm3 83a366 366 0 0 0-368 368 366 366 0 0 0 368 368 366 366 0 0 0 369-368 366 366 0 0 0-369-368zM295 472h434a40 40 0 0 1 0 80H295a40 40 0 1 1 0-80z',
	  plus: 'M921.002 473h-368.008v-368.004c0.002-22.090-17.906-39.996-39.996-39.996-22.088 0-39.998 17.91-39.998 40v368h-368.002c-22.094 0-40 17.908-39.998 40-0.002 22.090 17.904 39.996 39.996 39.996l368.004-0.002v368.010c0 22.094 17.908 40 40 39.996 22.090 0.004 39.996-17.902 39.996-39.996v-368.010h368.010c22.090 0.002 39.994-17.906 39.994-39.996-0-22.088-17.908-39.998-39.998-39.998z',
	  document: 'M863.98 242.454c0.008-0.23-0.094-3.944-0.152-4.624-0.058-0.688-0.368-2.972-0.496-3.742-0.008-0.058-0.352-1.712-0.54-2.486-0.124-0.508-0.246-1.014-0.39-1.518-0.226-0.784-1.106-3.292-1.296-3.78-0.304-0.754-1.426-3.162-1.668-3.626-0.398-0.762-1.75-3.028-2.008-3.418-0.606-0.924-1.262-1.81-1.942-2.678-0.132-0.168-0.246-0.346-0.382-0.512-0.98-1.212-2.028-2.364-3.14-3.454l-104.020-104.9c-3.714-3.714-7.988-6.518-12.54-8.464-0.090-0.040-3.762-1.404-4.008-1.48-0.942-0.288-1.894-0.516-2.852-0.732-0.336-0.076-0.66-0.176-0.996-0.244-1-0.2-3.618-0.558-3.922-0.59-1.324-0.13-2.652-0.204-3.976-0.204h-519.652c-1.754 0-3.468 0.152-5.164 0.372-19.644 2.54-34.836 19.292-34.836 39.628v752c0 22.094 17.91 40 40 40h624c22.090 0 40-17.906 40-40l-0.020-645.548zM784 848h-544v-672l439.614 0.002v65.186c0 22.090 17.91 40 40 40h64.368l0.018 566.812zM664 336c22.090 0 40 17.908 40 40s-17.91 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304zM704 528c0 22.092-17.91 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304c22.090 0 40 17.908 40 40zM704 680c0 22.092-17.91 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304c22.090 0 40 17.908 40 40z',
	  folder: 'M571 274h327c23 0 41 18 41 41v488c0 22-18 40-41 40H126c-23 0-41-18-41-40V242c0-34 27-61 61-61h317c18 0 35 7 47 21l61 72zm-119-8H170v492h684V359H531l-79-93z',
	  component: 'M171 469h298V171H246c-42 0-75 33-75 75v223zm0 86v223c0 42 33 75 75 75h223V555H171zm682-86V246c0-42-33-75-75-75H555v298h298zm0 86H555v298h223c42 0 75-33 75-75V555zM256 85h512c94 0 171 77 171 171v512c0 94-77 171-171 171H256c-94 0-171-77-171-171V256c0-94 77-171 171-171z',
	  calendar: 'M920.036 160.030h-112.004v-72c0-22.092-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v72.004h-432v-72c0-22.092-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v72.004h-112.004c-1.38 0-2.746 0.070-4.090 0.208-20.168 2.046-35.91 19.080-35.91 39.792v688c0 22.090 17.91 40 40 40h816.008c22.098 0 40-17.91 40-40v-688c0-22.094-17.908-40-40-40zM356.032 848.026h-212.004v-142.662h212.004v142.662zM356.032 665.364h-212.004v-162.664h212.004v162.664zM356.032 462.7h-212.004v-142.662h212.004v142.662zM628.032 848.026h-232v-142.662h232v142.662zM628.032 665.364h-232v-162.664h232v162.664zM628.032 462.7h-232v-142.662h232v142.662zM880.036 848.026h-212.004v-142.662h212.004v142.662zM880.036 665.364h-212.004v-162.664h212.004v162.664zM880.036 462.7h-212.004v-142.662h212.004v142.662z',
	  graphline: 'M820.536 489.23c-15.624 15.618-40.954 15.618-56.57 0l-42.006-42.002-169.898 169.9c-7.822 7.82-18.076 11.722-28.326 11.712-10.248 0.008-20.496-3.894-28.314-11.712l-96.178-96.182-140.67 140.674c-15.624 15.622-40.954 15.618-56.57-0.004-15.624-15.618-15.624-40.946 0-56.566l168.946-168.946c7.812-7.816 18.058-11.72 28.3-11.716 10.238-0.002 20.476 3.904 28.29 11.716l96.204 96.204 168.91-168.91c0.33-0.356 0.626-0.73 0.972-1.076 7.824-7.824 18.084-11.726 28.34-11.712 10.252-0.012 20.508 3.892 28.332 11.714 0.346 0.346 0.64 0.72 0.972 1.074l69.266 69.266c15.62 15.618 15.616 40.942 0 56.566zM880 144h-736v736h736v-736zM920 64c22.092 0 40 17.908 40 40v816c0 22.092-17.908 40-40 40h-816c-22.092 0-40-17.908-40-40v-816c0-22.092 17.908-40 40-40h816z',
	  docchart: 'M919.938 128h-816.008c-1.38 0-2.746 0.070-4.090 0.208-20.168 2.046-35.91 19.080-35.91 39.792v688c0 22.090 17.91 40 40 40h816.008c22.098 0 40-17.91 40-40v-688c0-22.094-17.906-40-40-40zM395.934 470.67h232v162.664h-232v-162.664zM355.934 633.334h-212.004v-162.664h212.004v162.664zM395.934 430.67v-142.662h232v142.662h-232zM667.934 470.67h212.004v162.664h-212.004v-162.664zM667.934 430.67v-142.662h212.004v142.662h-212.004zM355.934 288.008v142.662h-212.004v-142.662h212.004zM143.93 673.334h212.004v142.662h-212.004v-142.662zM395.934 673.334h232v142.662h-232v-142.662zM667.934 673.334h212.004v142.662h-212.004v-142.662z',
	  doclist: 'M919.938 128h-816.008c-1.38 0-2.746 0.070-4.090 0.208-20.168 2.046-35.91 19.080-35.91 39.792v688c0 22.090 17.91 40 40 40h816.008c22.098 0 40-17.91 40-40v-688c-0-22.094-17.906-40-40-40zM143.93 288.008h736.008v527.988h-736.008v-527.988zM248 400.004c0-22.090 17.91-40 40-40h448c22.094 0 40 17.906 40 40 0 22.090-17.906 40-40 40h-448c-22.090 0-40-17.91-40-40zM776 552.002c0 22.094-17.906 40-40 40h-448c-22.090 0-40-17.906-40-40 0-22.090 17.91-40 40-40h448c22.094 0 40 17.91 40 40zM776 704c0 22.094-17.906 40-40 40h-448c-22.090 0-40-17.906-40-40 0-22.090 17.91-40 40-40h448c22.094 0 40 17.91 40 40z',
	  category: 'M925.224 256.37c-1.694-0.216-3.408-0.37-5.162-0.37h-816c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v624c0 22.094 17.91 40 40 40h816c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-624.004c0-20.342-15.19-37.096-34.838-39.632zM144.062 880v-544h736v544h-736zM896.11 180c0 11.044-8.954 20-20 20h-728.032c-11.046 0-20-8.956-20-20v0c0-11.046 8.954-20 20-20h728.032c11.046 0 20 8.954 20 20v0zM832.094 84c0 11.044-8.954 20-20 20h-600c-11.046 0-20-8.956-20-20v0c0-11.046 8.954-20 20-20h600c11.046 0 20 8.954 20 20v0z',
	  grid: 'M437.162 552.368c-1.694-0.216-3.408-0.37-5.162-0.37h-263.978c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v264.040c0 22.094 17.91 40 40 40h263.978c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-264.044c0-20.34-15.19-37.094-34.838-39.632zM208.022 816.038v-184.040h183.978v184.040h-183.978zM437.162 128.4c-1.694-0.216-3.408-0.37-5.162-0.37h-263.978c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v263.968c0 22.094 17.91 40 40 40h263.978c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-263.972c0-20.342-15.19-37.096-34.838-39.632zM208.022 392v-183.968h183.978v183.968h-183.978zM861.212 552.368c-1.694-0.216-3.408-0.37-5.162-0.37h-264.050c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v264.040c0 22.094 17.91 40 40 40h264.048c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-264.044c0.002-20.34-15.19-37.094-34.836-39.632zM632 816.038v-184.040h184.048v184.040h-184.048zM861.212 128.4c-1.694-0.216-3.408-0.37-5.162-0.37h-264.050c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.292-34.838 39.63v263.968c0 22.094 17.91 40 40 40h264.048c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.924 1.2-1.862 1.722-2.838 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-263.972c0.002-20.342-15.19-37.096-34.836-39.632zM632 392v-183.968h184.048v183.968h-184.048z',
	  copy: 'M960.132 210.186c0-0.444-0.050-0.874-0.066-1.312-0.024-0.684-0.044-1.366-0.104-2.046-0.060-0.74-0.158-1.468-0.26-2.198-0.080-0.564-0.156-1.128-0.258-1.692-0.146-0.792-0.328-1.566-0.518-2.34-0.124-0.508-0.244-1.014-0.39-1.518-0.224-0.784-0.488-1.548-0.76-2.312-0.176-0.49-0.344-0.98-0.538-1.466-0.302-0.754-0.642-1.486-0.988-2.216-0.224-0.472-0.436-0.946-0.68-1.41-0.398-0.762-0.838-1.496-1.284-2.228-0.242-0.396-0.466-0.798-0.722-1.19-0.608-0.924-1.262-1.81-1.942-2.678-0.132-0.168-0.248-0.346-0.382-0.512-0.98-1.212-2.028-2.364-3.14-3.454l-104.020-104.9c-3.714-3.714-7.988-6.518-12.542-8.464-0.088-0.040-0.174-0.084-0.262-0.122-0.994-0.418-2.006-0.774-3.024-1.108-0.242-0.080-0.474-0.176-0.72-0.252-0.942-0.288-1.894-0.516-2.854-0.732-0.334-0.076-0.658-0.176-0.996-0.244-0.998-0.2-2.004-0.336-3.010-0.458-0.306-0.038-0.606-0.1-0.912-0.13-1.322-0.13-2.65-0.204-3.976-0.204h-391.784c-1.754 0-3.468 0.152-5.162 0.372-19.646 2.538-34.838 19.29-34.838 39.628v145.516h-279.874c-1.754 0-3.468 0.152-5.162 0.372-19.646 2.538-34.838 19.29-34.838 39.628v628.28c0 22.094 17.91 40 40 40h496.118c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 2.084-3.466 2.128-3.548 2.992-5.612 4.704-12.010 4.704-18.808 0 0 0 0 0-0.004v-145.518h279.874c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 2.084-3.466 2.128-3.548 2.992-5.612 4.704-12.010 4.704-18.808 0 0 0 0 0-0.004v-521.828c0.008-0.23-0.016-0.458-0.014-0.688 0.002-0.202 0.028-0.39 0.028-0.584zM144.124 878.792v-548.278h311.752v65.186c0 22.090 17.91 40 40 40h64.366v443.092h-416.118zM640.244 693.278v-296.31c0.006-0.23-0.018-0.458-0.014-0.688 0.004-0.196 0.030-0.382 0.030-0.578 0-0.444-0.052-0.874-0.066-1.312-0.024-0.684-0.044-1.366-0.104-2.046-0.062-0.74-0.16-1.468-0.262-2.198-0.078-0.564-0.152-1.128-0.258-1.692-0.144-0.792-0.324-1.566-0.516-2.34-0.124-0.508-0.246-1.014-0.39-1.518-0.226-0.784-0.488-1.548-0.76-2.312-0.174-0.49-0.342-0.98-0.538-1.466-0.302-0.754-0.64-1.486-0.988-2.216-0.222-0.472-0.438-0.946-0.68-1.41-0.398-0.762-0.838-1.496-1.284-2.228-0.242-0.396-0.466-0.798-0.724-1.19-0.606-0.924-1.262-1.81-1.942-2.678-0.13-0.168-0.246-0.346-0.382-0.512-0.978-1.212-2.028-2.364-3.138-3.454l-104.020-104.9c-3.714-3.714-7.988-6.518-12.542-8.464-0.088-0.040-0.172-0.084-0.262-0.122-0.994-0.418-2.004-0.774-3.024-1.108-0.242-0.080-0.476-0.176-0.72-0.252-0.942-0.288-1.896-0.516-2.854-0.732-0.334-0.076-0.658-0.176-0.996-0.244-0.998-0.2-2.004-0.336-3.012-0.458-0.304-0.038-0.602-0.1-0.91-0.13-1.322-0.13-2.648-0.204-3.976-0.204h-31.916v-105.516h311.752v65.186c0 22.090 17.91 40 40 40h64.366v443.092h-239.87z',
	  certificate: 'M832.032 384.032c0-176.728-143.266-320-320-320s-320 143.272-320 320c0 104.662 50.25 197.584 127.938 255.966v311.5c0 16.174 9.74 30.756 24.682 36.952 4.954 2.052 10.152 3.050 15.31 3.050 10.402 0 20.626-4.060 28.276-11.702l123.726-123.58 123.772 123.332c11.452 11.412 28.644 14.804 43.574 8.608 14.93-6.2 24.66-20.776 24.66-36.942v-311.124c77.756-58.376 128.062-151.342 128.062-256.060zM272.032 384.032c0-64.106 24.964-124.374 70.292-169.706 45.33-45.33 105.6-70.294 169.708-70.294s124.376 24.964 169.708 70.294c45.33 45.332 70.292 105.6 70.292 169.706s-24.964 124.376-70.292 169.704c-45.33 45.33-105.6 70.294-169.708 70.294s-124.376-24.964-169.708-70.294c-45.328-45.328-70.292-105.598-70.292-169.704zM623.968 854.89l-83.804-83.508c-15.622-15.564-40.898-15.552-56.502 0.034l-83.694 83.594v-171.17c34.878 13.042 72.632 20.192 112.062 20.192 39.382 0 77.094-7.13 111.938-20.142v171z',
	  print: 'M925.922 304.496c-1.698-0.218-3.41-0.37-5.166-0.37h-88.64v-93.548c0.006-0.21-0.016-0.422-0.014-0.634 0.004-0.212 0.036-0.416 0.036-0.63 0-0.478-0.054-0.942-0.074-1.416-0.024-0.636-0.042-1.27-0.094-1.906-0.066-0.776-0.168-1.54-0.276-2.302-0.074-0.534-0.146-1.066-0.242-1.596-0.15-0.82-0.338-1.624-0.538-2.424-0.12-0.48-0.23-0.958-0.37-1.436-0.234-0.812-0.506-1.608-0.792-2.398-0.164-0.462-0.322-0.924-0.504-1.38-0.318-0.788-0.668-1.552-1.036-2.316-0.208-0.436-0.406-0.88-0.628-1.312-0.424-0.802-0.88-1.574-1.352-2.344-0.218-0.358-0.422-0.724-0.656-1.078-0.636-0.972-1.324-1.91-2.042-2.82-0.098-0.124-0.182-0.252-0.282-0.376-0.988-1.224-2.048-2.388-3.172-3.488l-104.004-104.882c-3.696-3.696-7.948-6.486-12.466-8.432-0.122-0.050-0.224-0.11-0.344-0.16-0.974-0.41-1.966-0.756-2.962-1.084-0.262-0.086-0.512-0.19-0.78-0.272-0.926-0.284-1.87-0.506-2.812-0.722-0.346-0.080-0.684-0.182-1.034-0.252-0.988-0.198-1.988-0.334-2.988-0.456-0.31-0.040-0.618-0.102-0.93-0.134-1.324-0.132-2.652-0.204-3.978-0.204h-455.67c-1.754 0-3.468 0.152-5.162 0.37-19.646 2.538-34.838 19.29-34.838 39.63v200h-87.356c-1.754 0-3.468 0.152-5.164 0.37-19.644 2.538-34.836 19.29-34.836 39.63v320c0 22.094 17.91 40 40 40h87.368v216c0 22.094 17.91 40 40 40h560.006c13.81 0 25.982-6.996 33.17-17.636 0.102-0.146 0.184-0.306 0.282-0.458 0.612-0.922 1.2-1.86 1.722-2.836 0.046-0.082 0.080-0.17 0.124-0.254 2.994-5.612 4.704-12.008 4.704-18.808 0 0 0 0 0-0.004v-216h88.624c13.808 0 25.982-6.996 33.168-17.636 0.104-0.148 0.186-0.308 0.286-0.458 0.612-0.922 1.198-1.862 1.72-2.836 0.046-0.082 0.082-0.172 0.124-0.256 2.994-5.61 4.702-12.008 4.702-18.806 0 0 0 0 0-0.004v-320c0-20.344-15.186-37.096-34.834-39.636zM272.116 144.128h375.634v65.186c0 1.38 0.070 2.746 0.208 4.090 2.048 20.168 19.080 35.91 39.792 35.91h64.366v54.812h-480v-159.998zM272.124 880.126v-327.998h480.006v327.998zM880.756 384.128v239.998h-48.624v-111.998c0-20.34-15.19-37.092-34.836-39.63-1.694-0.218-565.17-0.372-565.17-0.372-1.754 0-3.468 0.152-5.162 0.372-19.646 2.538-34.838 19.29-34.838 39.628v112h-47.368v-239.998zM664.124 608.126c22.092 0 40 17.908 40 40s-17.908 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304zM704.124 784.126c0 22.092-17.908 40-40 40h-304c-22.092 0-40-17.908-40-40s17.908-40 40-40h304c22.092 0 40 17.908 40 40z',
	  listunordered: 'M961 233c0 22.090-17.908 40-40 40h-607.996c-22.090 0-40-17.908-40-40v0c0-22.090 17.908-40.002 40-40.002h607.996c22.092 0 40 17.912 40 40.002v0zM961 793c0-22.090-17.908-40.002-40-40.002h-607.996c-22.092 0-40 17.912-40 40.002v0c0 22.092 17.91 40 40 40h607.996c22.092 0 40-17.91 40-40v0zM961 606.332c0-22.090-17.908-40-40-40h-607.996c-22.092 0-40 17.91-40 40v0c0 22.094 17.91 40 40 40h607.996c22.092 0 40-17.91 40-40v0zM961 419.668c0-22.090-17.908-40.004-40-40.004h-607.996c-22.092 0-40 17.914-40 40.004v0c0 22.090 17.91 40 40 40h607.996c22.092-0 40-17.91 40-40v0zM129 168.998c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zM129 728.998c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zM129 542.332c-35.346 0-64 28.652-64 64 0 35.344 28.654 64 64 64s64-28.656 64-64c0-35.348-28.654-64-64-64zM129 355.664c-35.346 0-64 28.656-64 64 0 35.348 28.654 64 64 64s64-28.652 64-64c0-35.344-28.654-64-64-64z',
	  graphbar: 'M324.832 513c22.090 0 40 17.91 40 40v304c0 22.090-17.906 40-40 40v0c-22.090 0-40-17.906-40-40v-304c0-22.090 17.91-40 40-40v0zM884.832 128.998c-22.090 0-40 17.906-40 40v688.002c0 22.094 17.91 40 40 40v0c22.094 0 40-17.91 40-40v-688.002c0-22.094-17.91-40-40-40v0zM698.164 256.998c-22.090 0-40 17.91-40 40v560.002c0 22.094 17.91 40 40 40v0c22.094 0 40-17.91 40-40v-560.002c0-22.090-17.91-40-40-40v0zM511.5 384.998c-22.090 0-40.004 17.91-40.004 40v432.002c0 22.094 17.914 40 40.004 40v0c22.090 0 40-17.91 40-40v-432.002c0-22.090-17.91-40-40-40v0zM139.168 641c-22.090 0-40 17.91-40 40v176c0 22.094 17.91 40 40 40v0c22.094 0 40-17.91 40-40v-176c0-22.090-17.91-40-40-40v0z',
	  menu: 'M960 232c0 22.092-17.908 40-40.002 40h-815.996c-22.092 0-40-17.908-40-40v0c0-22.090 17.908-40 40-40h815.998c22.092 0 40 17.91 40 40v0zM768 416c0 22.090-17.908 40-40 40h-624c-22.090 0-40-17.908-40-40v0c0-22.090 17.908-40.002 40-40.002h624c22.092 0.002 40 17.914 40 40.002v0zM832 608c0 22.092-17.906 40.002-40 40.002h-688c-22.090 0-40-17.91-40-40.002v0c0-22.090 17.908-40 40-40h688c22.094 0 40 17.912 40 40v0zM576 792c0 22.094-17.91 40-40.002 40h-431.998c-22.090 0-40-17.906-40-40v0c0-22.094 17.908-40.002 40-40.002h432c22.094 0.002 40 17.912 40 40.002v0z',
	  filter: 'M962.030 168.032c0 22.092-17.908 40-40.002 40h-815.996c-22.092 0-40-17.908-40-40v0c0-22.090 17.908-40 40-40h815.998c22.092 0 40 17.908 40 40v0zM770 544.034c0 22.090-17.908 40-40 40h-432c-22.090 0-40-17.908-40-40v0c0-22.090 17.908-40.002 40-40.002h432c22.090 0 40 17.912 40 40.002v0zM642.030 728.032c0 22.094-17.91 40-40.002 40h-175.998c-22.090 0-40-17.906-40-40v0c0-22.094 17.908-40.002 40-40.002h176c22.094 0.002 40 17.91 40 40.002v0zM866 352.030c0 22.092-17.906 40.002-40 40.002h-624c-22.090 0-40-17.91-40-40.002v0c0-22.090 17.908-40 40-40h624c22.092 0 40 17.91 40 40v0zM512.030 928.034c22.090 0 40.004-17.906 40.004-40v0c0-22.090-17.914-40-40.004-40v0c-22.090 0-40 17.91-40 40v0c0 22.092 17.91 40 40 40v0z',
	  ellipsis: 'M184 393c66.274 0 120 53.73 120 120s-53.726 120-120 120c-66.286 0-120-53.73-120-120s53.714-120 120-120zM512 393c66.272 0 120 53.73 120 120s-53.728 120-120 120c-66.286 0-120-53.73-120-120s53.714-120 120-120zM840 393c66.272 0 120 53.73 120 120s-53.728 120-120 120c-66.286 0-120-53.73-120-120s53.714-120 120-120z',
	  cog: 'M396.458 151.486l27.768 27.768c23.28 23.29 54.262 36.116 87.242 36.116 0.318 0 0.636 0 0.958-0.004 0.292 0.002 0.58 0.004 0.872 0.004 32.99 0 63.976-12.83 87.22-36.098l27.61-27.604c19.584 6.294 38.582 14.192 56.892 23.642v39.976c0 32.878 13.406 64.804 36.842 87.888 23.072 23.384 54.966 36.762 87.804 36.762l39.442 0.002c9.168 17.906 16.852 36.462 23.014 55.574l-27.676 27.676c-23.222 23.224-36.318 55.242-36.094 88.096-0.248 32.884 12.844 64.934 36.094 88.19l27.928 27.928c-6.298 19.704-14.212 38.812-23.704 57.23l-38.984 0.002c-0.008 0-0.012 0-0.022 0-32.84 0-64.74 13.38-87.814 36.776-23.43 23.080-36.83 55-36.83 87.876v39.116c-18.38 9.486-37.456 17.406-57.122 23.714l-27.348-27.346c-23.278-23.3-54.264-36.13-87.254-36.13-0.292 0-0.58 0.002-0.872 0.004-0.318-0.004-0.636-0.004-0.958-0.004-32.978 0-63.962 12.826-87.228 36.102l-27.552 27.554c-19.874-6.338-39.144-14.32-57.708-23.902l-0.002-38.13c0.012-32.854-13.368-64.764-36.772-87.846-23.082-23.43-55.004-36.834-87.878-36.834h-38.506c-9.776-18.846-17.898-38.42-24.328-58.624l27.49-27.49c23.246-23.248 36.338-55.296 36.088-88.182 0.224-32.854-12.872-64.872-36.092-88.094l-27.23-27.232c6.29-19.612 14.182-38.628 23.636-56.966h38.942c32.878 0 64.802-13.402 87.884-36.838 23.398-23.086 36.778-54.994 36.766-87.81l0.002-39.028c18.492-9.546 37.688-17.506 57.48-23.834zM421.486 60.208c-59.932 11.946-115.658 35.516-164.752 68.268l-0.004 85.866c0.004 11.676-4.886 22.194-12.706 29.68-7.486 7.83-18.012 12.728-29.702 12.728h-85.806c-32.624 48.946-56.132 104.484-68.088 164.204l60.39 60.394c8.256 8.256 12.234 19.15 11.998 29.968 0.246 10.83-3.734 21.738-11.998 30.004l-60.562 60.56c11.97 60.402 35.74 116.552 68.826 165.948h85.24c11.69 0 22.214 4.9 29.702 12.73 7.818 7.482 12.708 17.998 12.706 29.676l0.004 85.004c49.162 32.796 104.976 56.386 165.006 68.316l60.654-60.656c8.028-8.032 18.55-12.014 29.072-12.014 0.312 0 0.62 0.004 0.93 0.010 0.298-0.006 0.602-0.010 0.9-0.010 10.526 0 21.046 3.982 29.070 12.014l60.542 60.534c59.78-11.968 115.376-35.512 164.356-68.19v-85.956c0-11.69 4.9-22.214 12.73-29.702 7.486-7.818 18.002-12.708 29.678-12.706l85.876-0.004c32.668-49.032 56.182-104.674 68.104-164.504l-61.050-61.052c-8.266-8.266-12.244-19.174-12-30.004-0.236-10.818 3.742-21.712 12-29.968l60.882-60.888c-11.91-59.144-35.158-114.178-67.37-162.758l-86.444-0.004c-0.004 0-0.008 0-0.008 0-11.674 0-22.188-4.89-29.67-12.708-7.83-7.486-12.73-18.012-12.73-29.702v-86.816c-48.912-32.632-104.418-56.158-164.106-68.14l-60.792 60.784c-8.024 8.032-18.546 12.014-29.070 12.014-0.3 0-0.602-0.004-0.9-0.012-0.308 0.008-0.618 0.012-0.93 0.012-10.522 0-21.044-3.982-29.072-12.014l-60.906-60.906zM511.856 314.472c-109.014 0-197.386 88.372-197.386 197.384 0 109.010 88.374 197.382 197.386 197.382v0.134c0.746 0 1.492 0.012 2.24 0.004 14.806-0.16 29.214-1.942 43.056-5.182 1.022-0.238 1.932-0.496 2.794-0.762 17.328-4.988 29.94-21.012 29.738-39.916-0.242-22.71-18.846-40.926-41.556-40.686-2.996 0.032-5.902 0.402-8.708 1.042-0.090 0.016-0.178 0-0.266 0.022-8.18 1.99-16.708 3.096-25.472 3.224-0.586-0.074-1.19-0.124-1.826-0.124-63.486 0-115.142-51.65-115.142-115.138 0-63.49 51.656-115.142 115.142-115.142 63.488 0 115.14 51.652 115.14 115.142 0 8.924-1.028 17.616-2.964 25.958-0.020 0.090-0.008 0.178-0.020 0.268-0.61 2.812-0.948 5.724-0.948 8.72 0 22.71 18.408 41.122 41.122 41.122 18.906 0 34.792-12.778 39.596-30.158 0.262-0.866 0.508-1.78 0.736-2.804 3.092-13.876 4.722-28.3 4.722-43.106 0-109.012-88.372-197.384-197.384-197.384z',
	  wrench: 'M959.438 274.25c0-22.090-17.914-40-40.004-40-11.16 0-21.242 4.582-28.496 11.954l-60.152 60.148c-15.622 15.622-40.946 15.618-56.566-0.004l-56.57-56.566c-15.622-15.622-15.622-40.95 0-56.57l59.55-59.546c7.75-7.292 12.614-17.618 12.614-29.102 0-22.090-17.914-40-40.004-40-1.598 0-3.164 0.122-4.71 0.304-0.012 0-0.020-0.008-0.032-0.004-94.958 11.586-168.504 92.492-168.504 190.574 0 23.528 4.238 46.058 11.98 66.886l-503.078 503.074c-1.496 1.496-2.8 3.102-4.012 4.758-10.914 13.676-17.454 30.992-17.454 49.848 0 44.188 35.818 79.996 79.996 79.996 18.906 0 36.27-6.574 49.964-17.54 1.614-1.188 3.18-2.464 4.64-3.926l503.078-503.078c20.828 7.742 43.36 11.98 66.882 11.98 97.988 0 178.828-73.402 190.54-168.222v-0.012c0.2-1.628 0.338-3.272 0.338-4.952zM151.996 912c-22.090 0-40-17.906-40-40 0-22.090 17.91-40 40-40s40.004 17.91 40.004 40c0 22.094-17.914 40-40.004 40z',
	  nut: 'M512.034 144.030l318.696 184v368l-318.696 184-318.702-184v-368l318.702-184zM512.034 64.030c-13.812 0-27.624 3.574-40 10.718l-318.702 184c-24.752 14.29-40 40.7-40 69.282v368c0 28.582 15.248 54.994 40 69.28l318.702 184c12.376 7.146 26.19 10.72 40 10.72 13.814 0 27.624-3.572 40-10.72l318.696-184c24.752-14.288 40-40.698 40-69.28v-368c0-28.582-15.248-54.992-40-69.282l-318.696-184c-12.376-7.144-26.188-10.718-40-10.718v0zM511.63 314.25c-109.014 0-197.386 88.372-197.386 197.384 0 109.010 88.374 197.382 197.386 197.382v0.134c0.746 0 1.492 0.012 2.24 0.004 14.806-0.162 29.214-1.942 43.056-5.182 1.022-0.24 1.932-0.496 2.794-0.762 17.328-4.988 29.94-21.012 29.738-39.916-0.242-22.71-18.846-40.926-41.556-40.684-2.996 0.032-5.902 0.402-8.708 1.040-0.090 0.016-0.178 0-0.266 0.022-8.18 1.99-16.708 3.094-25.474 3.222-0.584-0.072-1.188-0.124-1.826-0.124-63.486 0-115.142-51.65-115.142-115.138 0-63.49 51.656-115.142 115.142-115.142 63.488 0 115.14 51.652 115.14 115.142 0 8.924-1.028 17.616-2.964 25.96-0.020 0.088-0.008 0.178-0.020 0.266-0.61 2.814-0.948 5.724-0.948 8.72 0 22.712 18.408 41.122 41.122 41.122 18.906 0 34.792-12.776 39.596-30.158 0.262-0.866 0.508-1.78 0.736-2.804 3.092-13.876 4.724-28.3 4.724-43.106 0-109.010-88.372-197.382-197.384-197.382z',
	  camera: 'M925.164 208.372c-1.694-0.218-3.408-0.372-5.162-0.372h-471.968v-39.962c0-20.344-15.192-37.096-34.836-39.63-1.696-0.218-3.41-0.374-5.164-0.374h-176.004c-1.754 0-3.468 0.152-5.164 0.374-19.644 2.538-34.836 19.29-34.836 39.626v39.966h-88.032c-1.754 0-3.468 0.152-5.162 0.372-19.646 2.536-34.838 19.29-34.838 39.628v528c0 22.094 17.91 40 40 40h816.004c13.808 0 25.98-6.996 33.168-17.636 0.102-0.148 0.184-0.308 0.282-0.46 0.612-0.922 1.2-1.86 1.722-2.836 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.61 4.704-12.008 4.704-18.808v-528.004c-0-20.342-15.192-37.096-34.838-39.63zM880.002 736h-736.004v-448h736.004v448zM512 402.522c60.368 0 109.478 49.112 109.478 109.478s-49.112 109.478-109.478 109.478-109.478-49.112-109.478-109.478 49.11-109.478 109.478-109.478zM512 322.522c-104.644 0-189.478 84.832-189.478 189.478 0 104.644 84.834 189.478 189.478 189.478 104.646 0 189.478-84.834 189.478-189.478 0-104.646-84.832-189.478-189.478-189.478v0z',
	  eye: 'M1008.714 490.522c-9.002-12.594-223.276-308.808-496.684-308.808-273.444 0-487.682 296.214-496.684 308.808l-15.316 21.49 15.316 21.466c9.002 12.618 223.24 308.808 496.684 308.808 273.408 0 487.682-296.19 496.684-308.808l15.316-21.466-15.316-21.49zM807.68 631.688c-46 39.142-92.558 70.064-138.382 91.904-53.874 25.676-106.786 38.694-157.266 38.694-50.49 0-103.406-13.018-157.282-38.696-45.826-21.838-92.382-52.758-138.378-91.902-53.708-45.706-94.302-92.122-116.61-119.672 22.36-27.602 63.028-74.094 116.612-119.696 45.996-39.146 92.554-70.068 138.378-91.908 53.876-25.678 106.792-38.698 157.28-38.698 50.48 0 103.39 13.020 157.264 38.696 45.824 21.842 92.382 52.764 138.382 91.91 53.602 45.614 94.264 92.098 116.624 119.696-22.306 27.544-62.898 73.954-116.622 119.672zM692.032 512.036c0 99.41-80.588 180-180 180s-180-80.59-180-180c0-99.406 80.588-179.998 180-179.998s180 80.59 180 179.998z',
	  eyeclose: 'M75.744 948.314c-15.62-15.62-15.62-40.948 0-56.564l816-816c15.626-15.624 40.95-15.624 56.57 0 15.624 15.62 15.626 40.946 0.004 56.57l-816 815.994c-15.62 15.62-40.95 15.62-56.572 0zM332.032 512.034c0 20.104 3.296 39.434 9.376 57.484l228.104-228.106c-18.050-6.080-37.38-9.376-57.48-9.376-99.412-0.004-180 80.588-180 179.996zM692.032 512.034c0-20.1-3.3-39.432-9.38-57.484l-228.106 228.11c18.052 6.080 37.384 9.376 57.488 9.376 99.412 0 180-80.59 180-180zM1008.716 490.522c-4.98-6.968-72.86-100.8-178.81-183.22l-57.040 57.040c11.624 8.8 23.24 18.128 34.814 27.98 53.6 45.614 94.264 92.1 116.624 119.696-22.304 27.544-62.896 73.954-116.62 119.672-46 39.14-92.56 70.064-138.384 91.904-53.872 25.676-106.786 38.694-157.266 38.694-37.448 0-76.234-7.18-115.76-21.36l-61.486 61.49c54.786 24.22 114.45 39.87 177.248 39.87 273.41 0 487.684-296.19 496.686-308.808l15.316-21.468-15.316-21.49zM216.372 631.69c-53.708-45.706-94.3-92.12-116.61-119.672 22.36-27.6 63.028-74.094 116.612-119.696 46-39.146 92.554-70.068 138.38-91.908 53.874-25.68 106.79-38.7 157.28-38.7 37.46 0 76.264 7.188 115.8 21.38l61.484-61.484c-54.796-24.236-114.474-39.896-177.286-39.896-273.446 0-487.684 296.214-496.686 308.808l-15.316 21.49 15.314 21.466c4.98 6.984 72.866 100.84 178.84 183.26l57.040-57.040c-11.64-8.806-23.264-18.144-34.854-28.008z',
	  photo: 'M920 64h-816c-22.092 0-40 17.91-40 40v816c0 22.094 17.908 40 40 40h816c22.092 0 40-17.906 40-40v-816c0-22.090-17.908-40-40-40zM880 144v449.782l-235.39-235.392c-7.502-7.5-17.676-11.714-28.286-11.714s-20.784 4.214-28.286 11.716l-169.804 169.804-40.958-40.958c-15.622-15.622-40.95-15.622-56.57 0l-176.708 176.708v-519.946h736.002zM144 880v-102.914l204.992-204.994 215.972 215.974c7.81 7.81 18.048 11.714 28.286 11.714s20.474-3.904 28.286-11.714c15.62-15.622 15.62-40.95 0-56.57l-146.732-146.73 141.522-141.524 263.676 263.68v173.078h-736.002zM356.174 400.542c52.466 0 95-42.536 95-95s-42.534-95-95-95-95 42.536-95 95 42.534 95 95 95zM356.174 250.542c30.326 0 55 24.672 55 55s-24.674 55-55 55-55-24.672-55-55 24.674-55 55-55z',
	  video: 'M926.050 273.364c-9.556 0-20.574 3.8-32.278 11.812l-189.738 129.894v-151.068c0-20.342-15.192-37.094-34.838-39.63-1.694-0.218-3.408-0.372-5.162-0.372h-560.002c-1.754 0-3.468 0.152-5.162 0.372-19.646 2.538-34.838 19.29-34.838 39.628v496.002c0 22.092 17.91 40 40 40h560.004c13.808 0 25.98-6.998 33.168-17.638 0.102-0.148 0.184-0.308 0.282-0.458 0.612-0.922 1.2-1.862 1.722-2.836 0.046-0.082 0.080-0.172 0.124-0.254 2.994-5.612 4.704-12.010 4.704-18.81v-151.066l189.738 129.886c11.706 8.012 22.718 11.812 32.278 11.812 20.092 0 33.736-16.806 33.736-46.622v-384.032c0-29.816-13.644-46.62-33.738-46.62zM624.036 720h-480.004v-415.998h480.004v415.998zM879.788 632.3l-175.728-120.296 175.728-120.302v240.598zM240.688 663.534c-22.090 0-40-17.906-40-40v0c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v0c0 22.092-17.914 40-40.004 40v0z',
	  speaker: 'M692.070 580.856c18.156-18.156 28.152-42.266 28.152-67.89-0.008-25.622-10.002-49.726-28.148-67.872-8.476-8.478-18.308-15.188-29-19.922-0.222-0.098-0.408-0.22-0.566-0.364-13.294-6.5-22.476-20.116-22.476-35.914 0-22.090 17.91-40 40-40 5.774 0 11.246 1.248 16.204 3.45 0.016 0.006 0.026 0.008 0.040 0.016 19.292 8.656 37.036 20.832 52.368 36.164 33.254 33.254 51.574 77.446 51.58 124.43 0.006 46.996-18.31 91.204-51.58 124.472-15.064 15.062-32.45 27.074-51.344 35.7-0.154 0.070-0.286 0.112-0.434 0.176-5.124 2.382-10.812 3.75-16.832 3.75-22.090 0-40-17.906-40-40 0-16.196 9.644-30.112 23.488-36.402 0.156-0.11 0.32-0.216 0.516-0.304 10.314-4.712 19.81-11.268 28.032-19.49zM861.778 275.386c-47.824-47.824-107.946-79.588-173.204-92.242-0.356-0.078-0.712-0.146-1.072-0.214-0.060-0.012-0.124-0.026-0.186-0.038-0.506-0.096-0.976-0.162-1.422-0.208-1.918-0.282-3.868-0.476-5.864-0.476-22.090 0-40 17.91-40 40 0 19.024 13.292 34.91 31.084 38.968 0.352 0.128 0.728 0.244 1.162 0.326 48.7 9.268 95.226 32.748 132.934 70.452 99.972 99.972 100.054 261.984-0.002 362.040-37.684 37.684-84.152 61.14-132.788 70.426-0.084 0.016-0.144 0.046-0.224 0.066-18.338 3.644-32.166 19.816-32.166 39.222 0 22.094 17.91 40 40 40 2.776 0 5.484-0.286 8.102-0.822 0.094-0.018 0.172-0.018 0.27-0.038 65.32-12.626 125.496-44.406 173.376-92.286 131.008-131.008 131.008-344.172 0-475.176zM525.988 159.516v704.968c0 22.090-17.906 40-40 40-12.73 0-24.046-5.966-31.374-15.234l-51.056-61.722v0.216l-122.14-147.666h-177.386c-22.090 0-40-17.906-40-40v0 0-256c0-5.22 1.030-10.194 2.85-14.766 0.104-0.266 0.184-0.542 0.294-0.804 0.39-0.924 0.844-1.812 1.3-2.702 0.134-0.26 0.242-0.538 0.382-0.794 0.246-0.456 0.54-0.878 0.804-1.324 6.972-11.726 19.734-19.61 34.368-19.61h177.386l173.13-209.238c7.324-9.316 18.67-15.324 31.44-15.324 22.092-0 40.002 17.91 40.002 40zM445.988 270.826l-126.708 153.252h-175.248v176h175.248l19.832 23.998h0.17l106.708 129.112v-482.362z',
	  phone: 'M742.52 960c-76.266 0-163.184-32.364-258.338-96.194-73.798-49.504-136.41-106.904-175.938-146.34-43.282-43.222-105.612-111.376-156.842-190.682-66.576-103.062-95.348-196.038-85.518-276.344 8.952-73.326 50.674-134.292 120.664-176.304 10.95-6.63 23.76-10.134 37.054-10.134 32.752 0 71.124 23.354 120.764 73.494 36.434 36.802 70.108 79.22 89.472 106.644 46.698 66.176 60.686 107.352 48.286 142.136-12.638 35.538-35.534 55.704-52.25 70.428-5.662 5.006-9.95 8.854-13.070 12.262 4.040 7.542 11.744 19.868 26.054 37.476 42.388 52.076 90.548 89.024 111.972 100.874 3.308-2.96 7.11-7.168 12.352-13.152 14.87-16.81 35.062-39.636 70.482-52.28 7.978-2.842 16.498-4.276 25.35-4.276 44.172 0 108.804 44.078 155.246 81.056 45.834 36.494 103.292 90.498 127.104 132.612 22.602 39.596 14.982 68.64 4.596 86.006-48.138 80.296-119.862 122.718-207.44 122.718zM224.758 144.53c-47.558 29.426-73.566 67.28-79.468 115.618-7.494 61.224 17.17 136.326 73.308 223.226 49.902 77.252 112.994 144.35 146.16 177.472 30.296 30.222 91.906 88.17 163.988 136.524 81.738 54.83 153.662 82.63 213.772 82.63 58.618 0 103.506-26.526 137.138-81.076-0.47-1.536-1.532-4.062-3.854-8.132-14.584-25.794-57.006-69.202-105.642-108.156-58.776-47.074-96.708-63.894-106.756-64.982-15.348 5.826-25.020 16.758-36.178 29.372-12.542 14.318-28.31 32.316-55.476 41.528l-6.25 2.12h-6.598c-8.704 0-31.826 0-86.73-43.378-32.196-25.438-64.65-57.534-91.38-90.374-35.712-43.942-51.41-77.764-46.674-100.548l0.55-2.642 0.9-2.546c9.19-26 26.284-41.118 41.364-54.458 12.726-11.208 23.698-20.874 29.494-36.378-0.606-4.398-5.076-23.488-37.948-70.072-15.882-22.494-45.746-60.376-77.614-93.084-39.93-40.986-60.106-50.546-66.106-52.664z',
	  flag: 'M168 960.060c-22.092 0-40-17.908-40-40v-816.36c0-22.092 17.908-40 40-40h687.698c16.178 0 30.764 9.746 36.956 24.694 6.192 14.946 2.77 32.15-8.67 43.59l-188.918 188.922 189.218 189.216c11.44 11.442 14.862 28.646 8.67 43.592-6.192 14.948-20.776 24.694-36.956 24.694h-647.998v341.654c0 22.090-17.908 39.998-40 39.998zM208 498.406h551.428l-149.218-149.216c-15.622-15.622-15.622-40.95 0-56.568l148.918-148.922h-551.128v354.706z',
	  pin: 'M512 959.916c-13.36 0-25.84-6.672-33.262-17.782l-242.080-362.324c-0.12-0.176-0.236-0.356-0.354-0.536-36.394-54.5-55.63-118.042-55.63-183.804 0-182.696 148.632-331.324 331.326-331.324 182.696 0 331.328 148.628 331.328 331.324 0 60.71-16.554 119.98-47.906 171.652-0.758 1.528-1.618 3.016-2.578 4.45l-5.786 8.664c-0.054 0.082-0.112 0.164-0.168 0.246-0.042 0.070-0.104 0.16-0.148 0.23l-241.484 361.426c-7.422 11.106-19.898 17.778-33.258 17.778zM303.458 535.784l0.026 0.040c0.038 0.054 0.158 0.238 0.194 0.292l208.324 311.796 212.374-317.86c0.376-0.696 0.778-1.382 1.198-2.062 24.7-39.708 37.758-85.532 37.758-132.52 0-138.582-112.746-251.324-251.328-251.324s-251.326 112.742-251.326 251.324c0 50.054 14.674 98.39 42.432 139.782 0.114 0.176 0.232 0.356 0.348 0.532zM512 304.4c49.98 0 90.64 40.66 90.64 90.64 0 49.976-40.66 90.636-90.64 90.636s-90.64-40.66-90.64-90.636c0-49.98 40.66-90.64 90.64-90.64zM512 224.4c-94.242 0-170.64 76.398-170.64 170.64s76.398 170.636 170.64 170.636 170.64-76.394 170.64-170.636-76.398-170.64-170.64-170.64v0z',
	  compass: 'M960 512c0-247.424-200.574-448-448-448-247.422 0-448 200.576-448 448s200.578 448 448 448c247.426 0 448-200.576 448-448zM251.786 772.214c-69.504-69.508-107.786-161.918-107.786-260.214 0-98.294 38.282-190.708 107.786-260.216 69.508-69.504 161.918-107.784 260.214-107.784s190.708 38.28 260.214 107.784c69.508 69.508 107.786 161.922 107.786 260.216 0 98.296-38.278 190.708-107.786 260.214s-161.922 107.786-260.214 107.786c-98.296 0-190.708-38.28-260.214-107.786zM565.742 565.74c-0.93 0.93-1.95 1.768-3.050 2.498l-237.586 158.392c-7.934 5.29-18.496 4.242-25.238-2.498-6.738-6.742-7.786-17.304-2.496-25.236l158.39-237.588c1.464-2.2 3.348-4.082 5.546-5.546l237.586-158.392c7.934-5.29 18.496-4.242 25.238 2.498 6.742 6.742 7.79 17.304 2.5 25.238l-158.394 237.586c-0.73 1.1-1.566 2.118-2.496 3.048zM386.122 637.878l151.054-100.704-50.352-50.352-100.702 151.056z',
	  globe: 'M530.878 65.424c-6.748-1.014-13.090-1.424-18.878-1.424s-12.13 0.41-18.878 1.424c-238.662 9.9-429.122 206.48-429.122 447.576 0 247.424 200.578 448 448 448 247.426 0 448-200.576 448-448 0-241.098-190.456-437.678-429.122-447.576zM877.84 472.998h-158.508c-3.16-92.542-17.532-179.266-41.262-247.494-6.442-18.52-13.534-35.536-21.228-50.988 42.548 18.214 81.66 44.556 115.374 78.268 59.988 59.99 96.69 137.046 105.624 220.214zM512 880c-65.872 0-120.112-143.058-127.206-327h254.41c-7.092 183.942-61.332 327-127.204 327zM384.714 472.998c6.426-175.362 55.69-314.010 117.15-327.852 3.372-0.092 6.748-0.146 10.134-0.146s6.764 0.054 10.136 0.146c61.46 13.842 110.722 152.49 117.148 327.852h-254.568zM251.786 252.784c33.714-33.71 72.826-60.052 115.374-78.268-7.694 15.452-14.788 32.468-21.226 50.988-23.732 68.228-38.104 154.952-41.264 247.494h-158.508c8.934-83.168 45.636-160.224 105.624-220.214zM146.16 553h158.578c3.298 91.792 17.632 177.762 41.194 245.498 6.798 19.55 14.33 37.416 22.526 53.542-43.050-18.232-82.616-44.772-116.672-78.826-59.988-59.99-96.69-137.044-105.626-220.214zM772.214 773.214c-34.054 34.054-73.622 60.592-116.672 78.824 8.196-16.126 15.726-33.99 22.528-53.542 23.558-67.736 37.892-153.704 41.192-245.498h158.578c-8.934 83.172-45.634 160.226-105.626 220.216z',
	  location: 'M960.002 512l-0.002-0.026c-0.006-114.646-43.746-229.288-131.216-316.758-174.954-174.958-458.614-174.958-633.566 0-174.958 174.954-174.958 458.612 0 633.568 87.45 87.45 202.056 131.186 316.674 131.214 0.022 0 0.042 0.002 0.064 0.002 0.014 0 0.026-0.002 0.042-0.002 114.654 0 229.308-43.738 316.788-131.214 87.472-87.47 131.21-202.114 131.216-316.76l0-0.024zM772.216 772.214c-60 59.998-137.072 96.702-220.258 105.626v-133.84c0-22.090-17.914-40-40.004-40s-40 17.91-40 40v133.83c-83.154-8.942-160.194-45.64-220.172-105.618-59.986-59.988-96.686-137.042-105.624-220.21h133.84c22.090 0 40-17.914 40-40.004s-17.91-40-40-40h-133.84c8.936-83.17 45.636-160.226 105.624-220.214 59.978-59.976 137.020-96.676 220.172-105.622v133.836c0 22.094 17.91 40 40 40s40.004-17.906 40.004-40v-133.844c83.184 8.926 160.258 45.63 220.258 105.63 59.986 59.986 96.688 137.042 105.624 220.212h-133.838c-22.094 0-40 17.91-40 40s17.906 40.004 40 40.004h133.838c-8.938 83.172-45.636 160.226-105.624 220.214z',
	  search: 'M218 670a318 318 0 0 1 0-451 316 316 0 0 1 451 0 318 318 0 0 1 0 451 316 316 0 0 1-451 0m750 240L756 698a402 402 0 1 0-59 60l212 212c16 16 42 16 59 0 16-17 16-43 0-60',
	  zoom: 'M220 670a316 316 0 0 1 0-450 316 316 0 0 1 450 0 316 316 0 0 1 0 450 316 316 0 0 1-450 0zm749 240L757 698a402 402 0 1 0-59 59l212 212a42 42 0 0 0 59-59zM487 604a42 42 0 0 1-84 0V487H286a42 42 0 1 1 0-84h117V286a42 42 0 1 1 84 0v117h117a42 42 0 0 1 0 84H487v117z',
	  zoomout: 'M757 698a402 402 0 1 0-59 59l212 212a42 42 0 0 0 59-59L757 698zM126 445a316 316 0 0 1 319-319 316 316 0 0 1 318 319 316 316 0 0 1-318 318 316 316 0 0 1-319-318zm160 42a42 42 0 1 1 0-84h318a42 42 0 0 1 0 84H286z',
	  zoomreset: 'M148 560a318 318 0 0 0 522 110 316 316 0 0 0 0-450 316 316 0 0 0-450 0c-11 11-21 22-30 34v4h47c25 0 46 21 46 46s-21 45-46 45H90c-13 0-25-6-33-14-9-9-14-20-14-33V156c0-25 20-45 45-45s45 20 45 45v32l1 1a401 401 0 0 1 623 509l212 212a42 42 0 0 1-59 59L698 757A401 401 0 0 1 65 570a42 42 0 0 1 83-10z',
	  timer: 'M576 540.658c0 35.344-28.654 64-64 64s-64-28.656-64-64c0-20.27 9.432-38.324 24.134-50.050v-193.418c-0.004-22.092 17.906-40.002 40-40 22.090 0 40 17.906 40 40l-0.004 193.626c14.552 11.732 23.87 29.692 23.87 49.842zM928.32 543.934c0 229.79-186.28 416.066-416.068 416.066-229.786 0-416.064-186.278-416.064-416.066 0-216.26 164.998-393.958 375.97-414.134l0.188-49.794h-16.348c-22.092 0-40.002-17.91-39.998-40 0-22.090 17.906-40.004 40-40.004l112 0.002c22.090-0.002 39.998 17.91 40 40 0 22.090-17.908 40-40 39.998h-15.656l-0.19 49.782c77.246 7.352 148.33 35.812 207.422 79.564l41.854-41.856c15.622-15.622 40.95-15.618 56.57 0.002s15.622 40.948 0 56.568l-38.9 38.9c67.822 74.028 109.22 172.66 109.22 280.972zM848.32 543.934c0-89.768-34.958-174.16-98.432-237.634s-147.87-98.432-237.636-98.432c-89.766 0-174.158 34.958-237.632 98.432s-98.432 147.868-98.432 237.634c0 89.766 34.958 174.16 98.432 237.636 63.474 63.472 147.868 98.43 237.632 98.43 89.768 0 174.162-34.958 237.636-98.43 63.476-63.476 98.432-147.87 98.432-237.636z',
	  time: 'M512 64c-247.424 0-448 200.578-448 448.004 0 247.422 200.576 448 448 448s448-200.578 448-448c0-247.424-200.576-448.004-448-448.004zM772.214 772.22c-69.508 69.504-161.918 107.786-260.214 107.786s-190.708-38.282-260.214-107.786c-69.508-69.508-107.786-161.918-107.786-260.214s38.278-190.708 107.786-260.214c69.508-69.504 161.918-107.786 260.214-107.786s190.708 38.278 260.214 107.786c69.504 69.508 107.786 161.918 107.786 260.214s-38.282 190.706-107.786 260.214zM768.004 517.004c0 22.090-17.91 40-40 40h-216c-5.384 0-10.508-1.078-15.196-3.008-0.124-0.046-0.254-0.086-0.376-0.132-0.61-0.262-1.188-0.57-1.782-0.86-0.572-0.278-1.16-0.528-1.718-0.828-0.204-0.114-0.39-0.246-0.594-0.364-0.918-0.516-1.832-1.050-2.704-1.64-0.086-0.058-0.164-0.128-0.254-0.188-10.492-7.21-17.382-19.286-17.382-32.98v-285c0-22.094 17.91-40 40.004-40 22.088 0 40 17.906 40 40v244.996h175.996c22.094 0 40.002 17.916 40.006 40.004z',
	  lightning: 'M320.022 1022.644c-7.408 0-14.852-2.052-21.44-6.238-15.292-9.714-22.144-28.494-16.706-45.774l115.186-365.908-214.552-52.57c-14.714-3.606-26.128-15.214-29.486-29.988-3.356-14.772 1.92-30.174 13.632-39.786l576-472.662c14.458-11.864 35.208-12.126 49.962-0.626 14.752 11.496 19.568 31.682 11.594 48.602l-171.202 363.256 208.648 51.756c14.29 3.544 25.476 14.652 29.124 28.914s-0.834 29.376-11.668 39.344l-512 471.112c-7.586 6.984-17.308 10.568-27.092 10.568zM279.236 493.49l178.314 43.69c10.74 2.632 19.912 9.59 25.336 19.226s6.62 21.086 3.298 31.636l-83.030 263.76 347.066-319.352-183.82-45.596c-11.63-2.884-21.356-10.832-26.498-21.656-5.144-10.822-5.164-23.382-0.054-34.22l116.31-246.788-376.922 309.3z',
	  dashboard: 'M567.594 674.956c-17.674 30.61-56.816 41.098-87.426 23.426-30.61-17.676-41.1-56.816-23.426-87.426 10.134-17.554 27.33-28.472 45.928-31.278l146.974-254.57c11.042-19.132 35.506-25.688 54.64-14.64 19.13 11.046 25.688 35.508 14.64 54.64l-147.084 254.75c6.736 17.434 5.826 37.648-4.246 55.098zM512.002 209.26c-98.296 0-190.708 38.28-260.214 107.786s-107.786 161.92-107.786 260.214c0 81.428 26.252 158.786 74.768 222.452 88.404-30.49 188.406-46.448 292.732-46.448 104.662 0 204.926 16.046 293.524 46.716 48.65-63.712 74.976-141.164 74.976-222.72 0-98.294-38.28-190.708-107.786-260.214s-161.918-107.786-260.214-107.786zM512.002 129.26c247.424 0 448 200.578 448 448 0 124.132-50.494 236.468-132.054 317.602-87.096-38.574-196.984-61.598-316.446-61.598-119.146 0-228.772 22.902-315.758 61.296-81.376-81.114-131.742-193.324-131.742-317.3 0-247.422 200.576-448 448-448v0z',
	  hourglass: 'M511.926 801.946c-22.090 0-40-17.906-40-40v0c0-22.090 17.91-40 40-40v0c22.090 0 40.004 17.91 40.004 40v0c0 22.094-17.914 40-40.004 40v0zM831.682 915.242c0.192 1.582 0.318 3.186 0.318 4.82 0 22.090-17.908 40-40 40h-560c-22.092 0-40-17.914-40-40 0-2.438 0.252-4.812 0.67-7.128 2.36-53.636 18.034-105.7 45.852-151.554 0.734-1.476 1.562-2.912 2.492-4.296l5.582-8.364c0.054-0.080 0.11-0.158 0.164-0.238 0.042-0.068 0.098-0.156 0.144-0.222l157.704-236.036-158.5-237.228c-0.116-0.17-0.23-0.342-0.34-0.516-32.842-49.178-51.11-105.994-53.368-165.044-0.238-1.762-0.402-3.546-0.402-5.374 0-22.090 17.908-40 40-40h560c22.092 0 40 17.914 40 40 0 2.056-0.204 4.064-0.504 6.038-2.194 54.020-17.886 106.48-45.894 152.648-0.734 1.472-1.562 2.91-2.492 4.294l-5.582 8.366c-0.054 0.078-0.11 0.156-0.164 0.236-0.042 0.068-0.098 0.154-0.144 0.222l-157.734 236.082 158.468 237.182c0.116 0.168 0.23 0.344 0.34 0.516 32.946 49.33 51.226 106.346 53.39 165.596zM749.958 144.060h-475.99c6.138 31.304 18.384 61.124 36.354 87.916 0.118 0.17 0.23 0.344 0.342 0.514l0.024 0.038c0.036 0.054 0.15 0.23 0.186 0.284l54.286 81.25h293.596l58.196-87.1c0.366-0.67 0.75-1.334 1.154-1.99 15.492-24.916 26.228-52.324 31.852-80.912zM497.528 512.178l-0.032 0.046 14.426 21.592 93.378-139.756h-186.692l78.92 118.118zM305.96 799.156c-15.498 24.91-26.234 52.318-31.856 80.906h476.052c-6.138-31.304-18.384-61.122-36.354-87.918-0.118-0.168-0.23-0.344-0.342-0.512l-0.024-0.040c-0.036-0.050-0.15-0.23-0.186-0.282l-140.242-209.902-28.98 43.374c-7.166 10.72-19.21 17.162-32.11 17.162-12.896 0-24.942-6.442-32.11-17.166l-28.76-43.044-143.938 215.428c-0.36 0.674-0.744 1.338-1.15 1.994z',
	  play: 'M878.78 477.856l-591.884-341.722c-9.464-5.464-18.426-8.050-26.386-8.048-19.516 0.002-33.002 15.546-33.002 42.338v683.446c0 26.792 13.482 42.338 33.002 42.338 7.96 0 16.924-2.586 26.386-8.048l591.884-341.722c32.664-18.864 32.664-49.724 0-68.582z',
	  stop: 'M960 512a448 448 0 1 0-896 0 448 448 0 0 0 896 0zM252 772a366 366 0 0 1 0-520 366 366 0 0 1 520 0 366 366 0 0 1 0 520 366 366 0 0 1-520 0zm412-68H360c-22 0-40-18-40-40V360c0-22 18-40 40-40h304c22 0 40 18 40 40v304c0 22-18 40-40 40z',
	  email: 'M960.032 268.004c0.748-10.040-2.246-20.364-9.226-28.684-5.984-7.132-13.938-11.62-22.394-13.394-0.13-0.026-0.268-0.066-0.396-0.092-1.082-0.22-2.172-0.376-3.272-0.5-0.25-0.032-0.492-0.080-0.742-0.102-1.028-0.096-2.052-0.136-3.090-0.156-0.292-0.002-0.582-0.042-0.876-0.042h-816.008c-21.416 0-38.848 16.844-39.898 38-0.034 0.628-0.092 1.256-0.096 1.89 0 0.034-0.006 0.074-0.006 0.114 0 0.050 0.008 0.102 0.008 0.152v495.692c0 0.054-0.008 0.106-0.008 0.156 0 22.090 17.91 40 40 40h816.004c13.808 0 25.98-6.996 33.17-17.636 0.1-0.148 0.182-0.312 0.28-0.458 0.606-0.93 1.196-1.868 1.722-2.84 0.046-0.082 0.080-0.172 0.124-0.258 2.992-5.604 4.704-12.008 4.704-18.804v0 0-493.038zM144.032 350.156l339.946 281.188c6.568 6.434 14.918 10.168 23.564 11.122 0.16 0.024 0.32 0.050 0.48 0.066 0.838 0.082 1.676 0.114 2.518 0.14 0.496 0.020 0.994 0.058 1.492 0.058s0.996-0.042 1.492-0.058c0.842-0.028 1.68-0.058 2.518-0.14 0.16-0.016 0.32-0.042 0.48-0.066 8.646-0.958 16.996-4.688 23.564-11.122l339.946-281.206v370.894h-736v-370.876zM215.066 305.030h593.91l-296.946 245.422-296.964-245.422z',
	  comment: 'M288 378.668h448c22.094 0 40 17.906 40 40 0 22.090-17.906 40-40 40h-448c-22.090 0-40-17.91-40-40s17.91-40 40-40zM736 565.334h-448c-22.090 0-40 17.91-40 40 0 22.094 17.91 40 40 40h448c22.094 0 40-17.906 40-40 0-22.090-17.906-40-40-40zM960 232.004v560c0 6.804-1.714 13.196-4.704 18.812-0.042 0.082-0.078 0.172-0.124 0.254-0.524 0.976-1.11 1.914-1.722 2.836-0.098 0.152-0.18 0.314-0.282 0.458-7.188 10.64-19.36 17.636-33.168 17.636h-519.766l-114.292 114.286c-8.036 8.046-18.644 11.91-29.18 11.67-0.292 0.008-0.582 0.046-0.876 0.046-22.090 0-40-17.91-40-40v-86.004h-111.886c-22.090 0-40-17.906-40-40v0-560c0-20.34 15.192-37.094 34.84-39.632 1.692-0.214 3.406-0.368 5.16-0.368h816c1.754 0 3.468 0.154 5.164 0.368 19.644 2.542 34.836 19.296 34.836 39.638zM880 272h-736v480h736v-480z',
	  requestchange: 'M925.164 193.396c-1.696-0.214-3.41-0.368-5.164-0.368h-816c-1.754 0-3.468 0.152-5.16 0.368-19.648 2.54-34.84 19.292-34.84 39.632v560c0 22.094 17.91 40 40 40h111.886v86.004c0 22.090 17.91 40 40 40 0.292 0 0.582-0.040 0.876-0.046 10.536 0.238 21.144-3.624 29.18-11.67l114.292-114.286h519.766c13.808 0 25.98-6.996 33.168-17.636 0.102-0.144 0.184-0.304 0.282-0.458 0.614-0.922 1.2-1.86 1.722-2.836 0.046-0.082 0.082-0.172 0.124-0.254 2.988-5.618 4.704-12.008 4.704-18.812v0-560c-0-20.346-15.192-37.098-34.836-39.638zM880 753.028h-736v-480h736v480zM756.334 484.17l-125-125.436c-15.594-15.65-40.92-15.692-56.568-0.1-15.648 15.594-15.694 40.92-0.1 56.568l57.004 57.204h-335.67c-22.092 0-40 17.908-40 40s17.908 40 40 40h335.258l-56.508 56.368c-15.64 15.602-15.672 40.928-0.070 56.57 7.814 7.832 18.066 11.752 28.32 11.75 10.22 0 20.442-3.892 28.25-11.68l125-124.688c15.634-15.596 15.672-40.912 0.084-56.556z',
	  link: 'M743.52 529.234c5.616-5.616 83.048-83.046 88.462-88.46 30.944-32.778 47.97-75.636 47.97-120.792 0-47.048-18.304-91.26-51.542-124.484-33.228-33.22-77.43-51.516-124.458-51.516-45.024 0-87.792 16.94-120.536 47.72l-104.458 104.456c-30.792 32.738-47.734 75.512-47.734 120.548 0 41.916 14.576 81.544 41.248 113.196 3.264 3.876 6.666 7.664 10.292 11.29 4.258 4.258 8.704 8.262 13.304 12.022 0.054 0.080 0.096 0.152 0.148 0.232 9.572 7.308 15.778 18.804 15.778 31.776 0 22.094-17.914 40-40.004 40-8.542 0-16.442-2.696-22.938-7.26-2.746-1.93-20.622-17.43-30.35-28.050-0.008-0.010-0.018-0.018-0.026-0.028-4.992-5.432-13.234-15.23-18.552-22.65s-16.556-25.872-17.036-26.736c-0.7-1.262-2.974-5.526-3.422-6.39-0.69-1.334-6.118-12.67-6.114-12.67-14.342-31.96-22.332-67.4-22.332-104.728 0-60.826 21.198-116.648 56.58-160.544 0.252-0.314 4.61-5.594 6.594-7.866 0.304-0.35 5.038-5.636 7.16-7.874 0.252-0.268 105.86-105.874 106.128-106.126 45.902-43.584 107.958-70.314 176.264-70.314 141.382 0 255.998 114.5 255.998 256 0 68.516-26.882 130.688-70.652 176.61-0.144 0.148-109.854 109.546-112.090 111.528-0.958 0.848-5.072 4.352-5.072 4.352-6.448 5.434-13.132 10.592-20.1 15.378 0.412-6.836 0.644-13.702 0.644-20.6 0-26.46-3.108-52.206-8.918-76.918l-0.236-1.102zM616.144 767.82c35.382-43.896 56.58-99.718 56.58-160.544 0-37.328-7.99-72.768-22.332-104.728 0.004 0 0.006-0.002 0.010-0.004-0.258-0.576-0.538-1.14-0.8-1.714-0.686-1.498-2.894-6.112-3.296-6.93-0.668-1.344-2.952-5.732-3.386-6.604-3.48-6.982-8.708-15.126-9.49-16.366-0.498-0.792-0.996-1.58-1.502-2.364-0.834-1.29-15.364-22.066-26.656-34.466-0.008-0.010-0.018-0.018-0.026-0.028-7.056-8.448-24.932-24.198-30.35-28.050-6.47-4.602-14.396-7.26-22.938-7.26-22.090 0-40.004 17.906-40.004 40 0 12.97 6.206 24.466 15.778 31.776 0.052 0.080 0.094 0.152 0.148 0.232 4.602 3.76 20.334 19.434 23.598 23.31 26.672 31.65 41.248 71.28 41.248 113.196 0 45.038-16.944 87.81-47.734 120.548l-104.458 104.456c-32.742 30.782-75.512 47.72-120.536 47.72-47.028 0-91.228-18.294-124.458-51.516-33.236-33.224-51.542-77.436-51.542-124.484 0-45.154 17.028-88.014 47.97-120.792 5.414-5.414 40.812-40.812 68.958-68.958 7.176-7.176 13.888-13.886 19.504-19.502v-0.002c-0.356-1.562-0.246-1.096-0.246-1.096-5.81-24.712-8.918-50.458-8.918-76.918 0-6.898 0.232-13.764 0.644-20.6-6.966 4.788-20.1 15.33-20.1 15.33-0.734 0.62-9.518 8.388-11.68 10.45-0.16 0.154-105.338 105.33-105.482 105.478-43.77 45.922-70.652 108.094-70.652 176.61 0 141.5 114.616 256 255.998 256 68.306 0 130.362-26.73 176.264-70.314 0.27-0.254 105.876-105.86 106.128-106.126 0.004-0.002 13.506-15.426 13.758-15.74z',
	  paperclip: 'M824.25 369.354c68.146-70.452 67.478-182.784-2.094-252.354-70.296-70.296-184.266-70.296-254.558 0-0.014 0.012-0.028 0.026-0.042 0.042-0.004 0.002-0.006 0.004-0.010 0.008l-433.144 433.142c-0.036 0.036-0.074 0.068-0.11 0.106-0.054 0.052-0.106 0.11-0.16 0.162l-2.668 2.67c-0.286 0.286-0.528 0.596-0.8 0.888-43.028 44.88-66.664 103.616-66.664 165.986 0 64.106 24.962 124.376 70.292 169.704 45.328 45.33 105.598 70.292 169.706 70.292 50.612 0 98.822-15.57 139.186-44.428 4.932-1.952 9.556-4.906 13.544-8.894l16.802-16.802c0.056-0.056 0.116-0.112 0.172-0.168 0.038-0.038 0.074-0.076 0.112-0.116l289.010-289.014c15.622-15.618 15.62-40.942 0-56.56s-40.948-15.62-56.566 0l-289.124 289.122c-62.482 62.484-163.792 62.484-226.274 0-62.484-62.482-62.484-163.79 0-226.272h-0.002l433.134-433.12c0.058-0.060 0.112-0.122 0.172-0.18 38.99-38.99 102.43-38.99 141.42 0 38.992 38.99 38.99 102.432 0 141.422-0.058 0.060-0.122 0.114-0.18 0.17l0.006 0.006-280.536 280.534c-0.002-0.002-0.002-0.004-0.004-0.006l-79.978 79.98c-0.010 0.010-0.016 0.020-0.028 0.028-0.008 0.012-0.018 0.018-0.028 0.028l-0.064 0.062c-15.622 15.624-40.944 15.624-56.562 0-15.624-15.62-15.624-40.944-0.002-56.566l0.062-0.062c0.010-0.010 0.018-0.020 0.028-0.028 0.008-0.012 0.020-0.018 0.028-0.028l79.98-79.978c-0.002-0.002-0.004-0.002-0.006-0.004l136.508-136.512c15.622-15.62 15.62-40.944-0.002-56.562-15.618-15.62-40.946-15.62-56.564 0l-219.342 219.344c-1.284 1.284-2.42 2.652-3.494 4.052-40.4 47.148-38.316 118.184 6.322 162.824 44.64 44.638 115.674 46.722 162.82 6.324 1.402-1.072 2.772-2.21 4.054-3.494l2.83-2.832c0.002 0 0.002 0 0.002 0s0 0 0 0l360.54-360.54c0.058-0.056 0.12-0.114 0.18-0.172 0.050-0.050 0.098-0.106 0.15-0.158l0.994-0.994c0.34-0.338 0.63-0.702 0.952-1.052z',
	  box: 'M960.016 408.080c0-0.672-0.046-1.342-0.078-2.014-0.032-0.594-0.044-1.19-0.102-1.782-0.068-0.726-0.186-1.448-0.294-2.17-0.080-0.54-0.144-1.080-0.248-1.616-0.138-0.724-0.326-1.442-0.506-2.16-0.134-0.534-0.252-1.070-0.408-1.6-0.196-0.662-0.436-1.314-0.668-1.968-0.204-0.582-0.396-1.166-0.628-1.74-0.226-0.56-0.494-1.11-0.75-1.662-0.3-0.656-0.598-1.312-0.934-1.954-0.242-0.454-0.514-0.894-0.774-1.342-0.414-0.716-0.83-1.43-1.292-2.124-0.256-0.382-0.538-0.752-0.806-1.128-0.514-0.716-1.036-1.428-1.602-2.116-0.090-0.11-0.162-0.226-0.254-0.336-0.244-0.292-0.516-0.542-0.768-0.826-0.534-0.6-1.068-1.198-1.644-1.772-0.48-0.478-0.982-0.924-1.48-1.376-0.354-0.316-0.674-0.658-1.040-0.964l-405.788-335.666c-6.568-6.436-14.918-10.166-23.564-11.124-0.16-0.022-0.32-0.050-0.48-0.066-0.838-0.082-1.676-0.11-2.518-0.14-0.496-0.020-0.994-0.058-1.492-0.058s-0.996 0.040-1.492 0.058c-0.842 0.028-1.68 0.058-2.518 0.14-0.16 0.016-0.32 0.044-0.48 0.066-8.646 0.956-16.996 4.688-23.564 11.124l-405.662 335.542c-7.13 5.982-11.616 13.93-13.392 22.382-0.032 0.14-0.070 0.278-0.1 0.42-0.212 1.072-0.37 2.152-0.494 3.238-0.032 0.258-0.078 0.51-0.106 0.77-0.086 0.89-0.114 1.786-0.138 2.68-0.014 0.39-0.052 0.78-0.054 1.17 0 0.040-0.006 0.074-0.006 0.114v204.856c-0.958 12.434 3.854 25.128 14.134 33.754l405.662 335.54c6.568 6.438 14.918 10.168 23.564 11.124 0.16 0.020 0.32 0.050 0.48 0.066 0.838 0.082 1.676 0.114 2.518 0.14 0.496 0.020 0.994 0.058 1.492 0.058 0.054 0 0.11-0.008 0.162-0.008 0.042 0 0.084 0.008 0.126 0.008 0.342 0 0.672-0.042 1.012-0.050 0.062-0.004 0.126-0.008 0.192-0.008 0.134-0.004 0.27-0.020 0.402-0.024 10.602-0.422 20.136-4.938 27.054-12.046l404.526-334.624c0.084-0.066 0.166-0.136 0.248-0.204l0.12-0.098c0.17-0.144 0.314-0.304 0.48-0.45 0.814-0.704 1.614-1.43 2.37-2.2 0.296-0.3 0.562-0.624 0.85-0.934 0.602-0.652 1.2-1.308 1.756-2 0.3-0.372 0.566-0.758 0.852-1.136 0.504-0.672 1.002-1.344 1.462-2.046 0.242-0.368 0.458-0.75 0.686-1.124 0.458-0.754 0.908-1.508 1.316-2.292 0.164-0.312 0.304-0.636 0.46-0.954 0.426-0.872 0.832-1.746 1.196-2.652 0.092-0.23 0.168-0.464 0.256-0.696 0.376-0.996 0.728-2 1.026-3.032 0.042-0.148 0.074-0.296 0.114-0.442 0.306-1.102 0.578-2.218 0.79-3.356 0.016-0.082 0.024-0.164 0.038-0.246 0.212-1.184 0.382-2.378 0.49-3.598v0c0.1-1.156 0.176-2.32 0.176-3.5v-204.86c0.024-0.318 0.022-0.638 0.040-0.958 0.026-0.668 0.074-1.338 0.074-2.008zM143.89 493.202l328.14 271.42v103.902l-328.14-271.18v-104.142zM552.032 764.402l327.868-271.212v103.88l-327.868 270.972v-103.64zM511.898 122.66l345.348 285.42-345.348 285.42-345.374-285.42 345.374-285.42z',
	  structure: 'M954.324 833.3c0.208-0.558 0.388-1.128 0.586-1.692 0.3-0.868 0.608-1.734 0.882-2.61 0.234-0.746 0.444-1.5 0.66-2.25 0.212-0.734 0.432-1.464 0.624-2.204 0.204-0.766 0.378-1.54 0.562-2.308 0.18-0.766 0.366-1.528 0.528-2.292 0.146-0.692 0.272-1.386 0.402-2.082 0.168-0.89 0.332-1.778 0.476-2.668 0.090-0.566 0.164-1.136 0.244-1.704 0.148-1.058 0.29-2.118 0.404-3.18 0.042-0.422 0.080-0.852 0.12-1.274 0.118-1.23 0.212-2.46 0.282-3.696 0.018-0.304 0.030-0.606 0.042-0.906 0.062-1.36 0.098-2.718 0.104-4.082 0-0.114 0.008-0.226 0.008-0.34 0-0.128-0.010-0.258-0.010-0.39-0.006-1.368-0.042-2.734-0.104-4.102-0.014-0.296-0.030-0.594-0.044-0.89-0.070-1.246-0.166-2.492-0.284-3.738-0.042-0.434-0.084-0.864-0.128-1.292-0.116-1.050-0.25-2.098-0.4-3.144-0.088-0.628-0.18-1.258-0.282-1.882-0.13-0.8-0.276-1.598-0.428-2.394-0.162-0.868-0.332-1.73-0.518-2.594-0.116-0.524-0.24-1.046-0.364-1.57-0.264-1.128-0.542-2.25-0.846-3.36-0.070-0.254-0.144-0.504-0.214-0.754-11.38-40.382-48.464-69.996-92.488-69.996-3.066 0-6.096 0.16-9.088 0.442l-264.576-458.262c21.080-29.698 24.3-70.13 4.9-103.732-12.596-21.816-32.458-36.812-54.764-43.724-0.062-0.020-0.124-0.036-0.186-0.054-1.394-0.43-2.798-0.83-4.21-1.196-0.296-0.076-0.596-0.142-0.894-0.216-1.208-0.3-2.422-0.586-3.642-0.84-0.384-0.082-0.774-0.148-1.16-0.224-1.168-0.228-2.338-0.444-3.514-0.626-0.384-0.060-0.776-0.112-1.162-0.168-1.208-0.174-2.416-0.332-3.63-0.46-0.35-0.038-0.7-0.066-1.048-0.1-1.27-0.12-2.54-0.218-3.814-0.29-0.32-0.018-0.642-0.032-0.964-0.044-1.294-0.058-2.594-0.094-3.892-0.1-0.166 0-0.328-0.012-0.492-0.012-0.19 0-0.376 0.014-0.564 0.014-1.21 0.008-2.42 0.040-3.63 0.092-0.494 0.022-0.986 0.046-1.478 0.074-0.992 0.060-1.986 0.136-2.978 0.226-0.722 0.064-1.442 0.134-2.16 0.214-0.696 0.080-1.392 0.17-2.090 0.266-1.014 0.136-2.026 0.286-3.032 0.452-0.352 0.060-0.704 0.124-1.054 0.19-44.97 8.028-79.122 47.302-79.122 94.582 0 20.756 6.602 39.958 17.79 55.67l-264.58 458.26c-2.954-0.274-5.94-0.434-8.962-0.434-53.078 0-96.11 43.032-96.11 96.11 0 53.082 43.032 96.11 96.11 96.11 38.8 0 72.208-23.004 87.386-56.11l529.202-0.004c0.138 0.304 0.292 0.606 0.436 0.91 0.226 0.48 0.456 0.958 0.69 1.434 0.474 0.968 0.966 1.93 1.476 2.882 0.214 0.402 0.432 0.8 0.65 1.2 0.314 0.566 0.604 1.14 0.93 1.708 0.284 0.488 0.59 0.958 0.88 1.442 0.122 0.2 0.244 0.398 0.37 0.602 27.086 44.372 84.766 59.278 130.040 33.136 18.864-10.89 32.624-27.214 40.478-45.852 0.054-0.132 0.104-0.266 0.158-0.398 0.518-1.248 1.020-2.506 1.486-3.776zM238.414 744.282l264.542-458.204c0.424 0.042 0.85 0.064 1.276 0.098 0.668 0.056 1.334 0.112 2.004 0.152 0.652 0.040 1.306 0.066 1.96 0.092 1.122 0.046 2.244 0.076 3.368 0.084 0.146 0.002 0.292 0.012 0.438 0.012 0.168 0 0.334-0.012 0.502-0.014 1.436-0.004 2.874-0.040 4.31-0.108 0.088-0.006 0.176-0.010 0.262-0.014 1.376-0.070 2.75-0.168 4.124-0.296l264.596 458.298c-3.48 4.894-6.514 10.122-9.042 15.636h-529.226c-2.546-5.55-5.602-10.814-9.114-15.736z',
	  cpu: 'M392.016 672.016h240.032c22.092 0 40-17.908 40-40v-240.032c0-22.092-17.908-40-40-40h-240.032c-22.092 0-40 17.908-40 40v240.032c0 22.092 17.908 40 40 40zM432.016 431.984h160.032v160.032h-160.032v-160.032zM864.032 424h71.98c22.094 0 40.004-17.906 40.004-40 0-22.092-17.906-40-40-40h-71.984v-143.968c0-22.092-17.908-40-40-40h-144v-72.012c0-22.094-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v72.016h-176v-72.012c0-22.094-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v72.016h-144c-22.092 0-40 17.908-40 40v143.968h-71.984c-22.094 0-40 17.908-40 40s17.91 40 40 40h71.984v176h-71.984c-22.094 0-40 17.908-40 40s17.91 40 40 40h71.984v144.030c0 22.092 17.908 40 40 40h144v71.954c0 22.094 17.906 40 40 40s40-17.91 40-40v-71.954h176v71.954c0 22.094 17.906 40 40 40s40-17.91 40-40v-71.954h144c22.092 0 40-17.908 40-40v-144.030h71.98c22.094 0 40.004-17.906 40.004-40 0-22.092-17.906-40-40-40h-71.984v-176zM784.032 784.032h-143.692c-0.104 0-0.204-0.016-0.308-0.016s-0.206 0.016-0.308 0.016h-127.382c-0.104 0-0.204-0.016-0.308-0.016s-0.206 0.016-0.308 0.016h-127.382c-0.104 0-0.204-0.016-0.308-0.016s-0.206 0.016-0.308 0.016h-143.696v-544h544v544z',
	  memory: 'M320.032 416.032v-152.968c0-22.094 17.91-40 40-40 22.094 0 40 17.91 40 40.004v152.964c0 22.090-17.906 40-40 40s-40-17.908-40-40zM512 456.032c22.094 0 40-17.91 40-40v-152.964c0-22.094-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v152.968c0 22.092 17.908 40 40 40zM664.032 456.032c22.094 0 40-17.91 40-40v-82.996c0-22.094-17.906-40.004-40-40.004-22.090 0-40 17.906-40 40v83c0 22.092 17.906 40 40 40zM864.018 316.616v603.418c0 0.004 0 0.004 0 0.004 0 6.798-1.71 13.198-4.704 18.808-0.044 0.084-0.078 0.172-0.124 0.254-0.524 0.976-1.112 1.914-1.722 2.836-0.098 0.15-0.18 0.312-0.282 0.46-7.188 10.638-19.36 17.634-33.168 17.634h-623.99c-22.090 0-40-17.908-40-40v-343.574c-0.002-0.142-0.022-0.282-0.022-0.426 0-0.142 0.020-0.282 0.022-0.426v-471.574c0-20.34 15.192-37.092 34.838-39.63 1.694-0.216 3.408-0.37 5.162-0.37l411.254 0.052c10.594-0.286 21.282 3.58 29.368 11.668l211.672 212.206c7.906 7.908 11.792 18.298 11.696 28.66zM240.026 144.034v391.998h543.99v-203.27l-188.252-188.728h-355.738zM784.016 880.032v-264h-543.99v264h543.99z',
	  database: 'M895.95 221.364c-3.414-87.32-173.972-157.672-383.918-157.672s-380.504 70.352-383.918 157.672h-0.082v578.328c0 88.552 171.918 160.338 384 160.338s384-71.786 384-160.338v-578.328h-0.082zM798.412 430.578c-15.6 11.386-37.69 22.346-63.882 31.696-60.984 21.77-140.002 33.758-222.498 33.758s-161.514-11.988-222.498-33.758c-26.192-9.348-48.282-20.308-63.88-31.696-8.706-6.352-13.646-11.608-16.122-14.874v-92.9c70.29 37.478 179.654 61.566 302.5 61.566s232.21-24.088 302.5-61.566v92.9c-2.476 3.266-7.416 8.522-16.12 14.874zM814.532 514.464v93.24c-2.474 3.266-7.416 8.522-16.12 14.874-15.6 11.386-37.69 22.346-63.882 31.696-60.984 21.77-140.002 33.758-222.498 33.758s-161.514-11.988-222.498-33.758c-26.192-9.348-48.282-20.308-63.88-31.696-8.706-6.352-13.646-11.608-16.122-14.874v-93.24c70.29 37.48 179.654 61.566 302.5 61.566s232.21-24.086 302.5-61.566zM225.652 209.146c15.6-11.386 37.69-22.346 63.88-31.696 60.984-21.77 140.002-33.758 222.498-33.758s161.514 11.988 222.498 33.758c26.192 9.348 48.282 20.308 63.882 31.696 8.704 6.352 13.646 11.608 16.12 14.874v0.026c-2.474 3.266-7.416 8.522-16.12 14.874-15.6 11.386-37.69 22.346-63.882 31.696-60.984 21.77-140.002 33.758-222.498 33.758s-161.514-11.988-222.498-33.758c-26.192-9.348-48.282-20.308-63.88-31.696-8.706-6.352-13.646-11.608-16.122-14.874v-0.026c2.476-3.268 7.418-8.524 16.122-14.874zM798.412 814.578c-15.6 11.386-37.69 22.346-63.882 31.696-60.984 21.77-140.002 33.758-222.498 33.758s-161.514-11.988-222.498-33.758c-26.192-9.348-48.282-20.308-63.88-31.696-8.714-6.36-13.66-11.62-16.13-14.886h0.010v-93.228c70.29 37.48 179.654 61.566 302.5 61.566s232.21-24.086 302.5-61.566v93.228h0.010c-2.474 3.266-7.42 8.526-16.132 14.886z',
	  power: 'M472 473.188v-368c-0.004-22.092 17.906-40.002 40-40 22.090 0 40 17.906 40 40l-0.004 368.002c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.906-40-40zM746.804 201.726v0.188c-13.138-9.004-26.808-17.292-40.978-24.768-1.994-1.050-3.492-1.84-4.668-2.458-1.75-0.892-3.518-1.756-5.28-2.624-0.004-0.002-0.008-0.004-0.012-0.006-0.080-0.032-0.158-0.074-0.234-0.108-0.032-0.012-0.056-0.024-0.090-0.042l-0.006 0.008c-4.724-2.022-9.924-3.168-15.386-3.212-22.090-0.178-40.14 17.588-40.32 39.678-0.122 15.112 8.166 28.298 20.47 35.208 31.9 15.71 61.418 36.616 87.492 62.292 2.796 2.754 5.52 5.562 8.208 8.394v-0.146c59.436 62.664 92.062 144.352 92.062 231.056 0 89.748-34.95 174.124-98.412 237.588s-147.84 98.412-237.588 98.412-174.124-34.95-237.588-98.412-98.412-147.84-98.412-237.588c0-81.652 28.962-158.834 81.972-219.886 5.814-6.69 11.902-13.192 18.288-19.474 26.064-25.652 55.564-46.538 87.446-62.238 12.342-6.892 20.66-20.106 20.542-35.238-0.17-22.088-18.218-39.86-40.306-39.69-5.468 0.044-10.664 1.186-15.392 3.208l-0.004-0.008c-0.036 0.016-0.058 0.028-0.088 0.042-0.042 0.018-0.084 0.038-0.126 0.056-1.862 0.918-3.728 1.828-5.574 2.774-0.458 0.238-0.948 0.496-1.512 0.792-1.096 0.566-2.18 1.148-3.27 1.722-15.704 8.294-30.804 17.572-45.232 27.736v-0.124c-106.896 75.288-176.742 199.646-176.742 340.33 0 229.75 186.25 416 416 416s416-186.25 416-416c-0.002-142.654-71.82-268.52-181.26-343.462z',
	  outbox: 'M960.062 616v304c0 1.382-0.070 2.746-0.208 4.090-2.046 20.172-19.080 35.91-39.792 35.91h-816c-22.090 0-40-17.906-40-40v-304c0-22.090 17.91-40 40-40s40 17.91 40 40v264h736v-264c0-22.090 17.91-40 40-40s40 17.912 40 40zM664.732 200.168l-124.41-124.41c-0.014-0.014-0.024-0.028-0.038-0.042-3.57-3.57-7.664-6.284-12.018-8.222-5.316-2.368-11.028-3.54-16.742-3.47-0.14-0.002-0.276-0.020-0.414-0.020-13.552 0-25.512 6.756-32.748 17.072l-119.1 119.092c-15.622 15.62-15.618 40.948 0.002 56.57 15.622 15.62 40.95 15.62 56.568 0l55.276-55.276v462.54c0 22.094 17.912 40 40.002 40 22.092 0 40-17.91 40-40v-464.314l57.052 57.052c15.622 15.624 40.948 15.62 56.568 0 15.628-15.624 15.628-40.952 0.002-56.572z',
	  share: 'M896.006 920c0 22.090-17.91 40-40 40h-688.006c-22.090 0-40-17.906-40-40v-549.922c-0.838-3.224-1.33-6.588-1.33-10.072 0-22.090 17.908-40.004 40-40.004h178.66c22.092 0.004 40 17.914 40 40.004 0 22.088-17.908 40-40 40h-137.33v479.996h607.998v-479.996h-138.658c-22.090 0-40-17.912-40-40 0-22.090 17.906-40.004 40-40.004h178.658c22.090 0 40 17.91 40 40v559.844c0 0.050 0.008 0.102 0.008 0.154zM665.622 200.168l-124.452-124.45c-8.042-8.042-18.65-11.912-29.186-11.674-1.612-0.034-3.222 0-4.828 0.16-0.558 0.054-1.098 0.16-1.648 0.238-0.742 0.104-1.484 0.192-2.218 0.338-0.656 0.13-1.29 0.31-1.934 0.472-0.622 0.154-1.244 0.292-1.86 0.476-0.64 0.196-1.258 0.436-1.886 0.66-0.602 0.216-1.208 0.414-1.802 0.66-0.598 0.248-1.17 0.54-1.754 0.814-0.598 0.282-1.202 0.546-1.788 0.86-0.578 0.312-1.13 0.664-1.694 1-0.552 0.332-1.116 0.644-1.654 1.006-0.67 0.448-1.3 0.942-1.942 1.426-0.394 0.302-0.806 0.576-1.196 0.894-1.046 0.858-2.052 1.768-3.008 2.726l-124.398 124.39c-15.622 15.62-15.618 40.948 0.002 56.57 15.622 15.62 40.95 15.62 56.568 0l56.164-56.166v439.426c0 22.094 17.912 40 40.002 40 22.092 0 40-17.91 40-40v-441.202l57.942 57.942c15.622 15.624 40.948 15.62 56.568 0 15.626-15.618 15.626-40.946 0.002-56.566z',
	  button: 'M644.634 802.32c-4.558 5.434-10.254 9.328-16.446 11.672l0.008 0.024-45.628 16.606 27.54 75.66c7.554 20.756-3.148 43.71-23.906 51.266s-43.714-3.146-51.27-23.906l-27.54-75.656-47.63 17.29c-6.020 1.956-12.586 2.518-19.254 1.342-21.75-3.836-36.282-24.582-32.45-46.34l30.57-173.328c2.55-14.476 12.61-25.714 25.458-30.508 0.292-0.118 0.586-0.23 0.878-0.34 0.238-0.084 0.476-0.168 0.718-0.246 12.942-4.624 27.91-2.492 39.196 6.98l134.824 113.13c16.932 14.2 19.144 39.432 4.932 56.354zM960.002 664v-368.082c0-22.092-17.908-40-40-40h-816c-22.092 0-40 17.908-40 40l-0.292 368.238c0 22.092 17.908 40 40 40h240.292c22.092 0 40-17.908 40-40s-17.908-40-40-40h-200.292l0.292-288.238h736v288.082h-200c-22.092 0-40 17.908-40 40s17.908 40 40 40h240c22.092 0 40-17.908 40-40z',
	  form: 'M948.362 178.828l-471.082 470.086c-0.24 0.25-0.45 0.52-0.698 0.77-7.82 7.82-18.070 11.722-28.32 11.712-10.25 0.010-20.504-3.892-28.324-11.712-0.262-0.262-0.48-0.546-0.734-0.812l-221.736-221.738c-15.624-15.622-15.624-40.95 0-56.566 15.618-15.622 40.946-15.624 56.57 0l194.224 194.222 443.53-442.528c15.622-15.618 40.95-15.618 56.57 0 15.62 15.62 15.62 40.946 0 56.566zM98.372 128.448c-18.926 0-34.266 15.342-34.266 34.268v699.032c0 18.926 15.34 34.266 34.266 34.266h699.032c18.926 0 34.266-15.34 34.266-34.266v-430.588c0 0 0.002-1.184 0.002-1.788 0-22.090-17.914-40-40.004-40s-40 17.91-40 40c0 0.288 0.002 386.64 0.002 386.64h-607.562v-607.564h600.002c22.090-0.002 40.002-17.906 40.002-40 0-22.090-17.914-40-40.004-40z',
	  check: 'M948.598 199.75c-15.622-15.618-40.95-15.618-56.57 0l-535.644 535.644-224.060-224.062c-15.624-15.624-40.954-15.62-56.57 0-15.624 15.62-15.624 40.948 0 56.568l251.574 251.574c0.252 0.266 0.472 0.55 0.734 0.812 7.82 7.82 18.072 11.724 28.322 11.714 10.25 0.010 20.502-3.894 28.322-11.714 0.248-0.248 0.456-0.518 0.698-0.77l563.196-563.202c15.618-15.618 15.618-40.94-0.002-56.564z',
	  batchaccept: 'M684 277L271 772l-1 1a40 40 0 0 1-56 5l-1-1L14 610a40 40 0 1 1 52-61l169 142 387-465a40 40 0 0 1 62 51zm340 234c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zm0-216c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zm0 432c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40z',
	  batchdeny: 'M1024 512c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zm0-216c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zm0 432c0-22-18-40-40-40H808a40 40 0 0 0 0 80h176c22 0 40-18 40-40zM625 236c16 15 16 41 0 56L406 512l220 220a40 40 0 1 1-57 57L349 568 129 788a40 40 0 1 1-57-56l220-220L73 292a40 40 0 0 1 56-57l220 220 219-219c16-16 41-16 57 0z',
	  home: 'M948.12 483.624l-407.814-407.754c-7.812-7.808-18.046-11.712-28.282-11.712-10.238 0-20.472 3.904-28.282 11.712l-407.92 407.86c-15.624 15.622-15.624 40.948-0.006 56.57s40.944 15.622 56.568 0.004l19.616-19.612v366.708c0 22.090 17.91 40 40 40h190.696c0.416 0.014 0.82 0.062 1.238 0.062 11.054 0 21.060-4.484 28.3-11.734 7.266-7.244 11.766-17.262 11.766-28.332 0-0.418-0.050-0.822-0.062-1.238v-263.204h176.060v263.934c0 22.090 17.91 40 40 40l191.876 0.124c2.292 0 4.524-0.236 6.708-0.608 0.45-0.074 0.91-0.116 1.356-0.206 0.21-0.044 0.414-0.116 0.628-0.162 17.906-3.972 31.308-19.924 31.308-39.026v-366.492l19.682 19.68c15.622 15.62 40.948 15.616 56.568-0.006s15.618-40.948-0.004-56.568zM791.876 448.272v398.71l-111.874-0.074v-263.876c0-0.020-0.002-0.042-0.002-0.062 0-0.006 0-0.014 0-0.022 0-22.090-17.91-40-40-40h-254.002c-0.556 0-1.1 0.060-1.65 0.084-0.14-0.002-0.274-0.022-0.414-0.022-22.090 0-40 17.91-40 40v264.382h-111.934v-399.392c0-2.286-0.234-4.512-0.604-6.694l280.626-280.584 280.514 280.472c-0.412 2.302-0.66 4.658-0.66 7.078z',
	  admin: 'M919.596 847.534h-88.414v-467.716l88.75-0.044c13.688-0.132 26.958-7.25 34.294-19.96 11.044-19.13 4.49-43.596-14.642-54.64l-407.904-235.676c-0.44-0.254-0.894-0.45-1.34-0.684-0.542-0.29-1.084-0.578-1.638-0.84-0.696-0.328-1.4-0.62-2.108-0.904-0.478-0.194-0.954-0.388-1.44-0.56-0.78-0.282-1.564-0.524-2.352-0.754-0.442-0.126-0.878-0.256-1.324-0.37-0.808-0.206-1.618-0.376-2.43-0.528-0.468-0.088-0.934-0.174-1.404-0.246-0.768-0.116-1.534-0.204-2.302-0.274-0.554-0.052-1.108-0.096-1.664-0.124-0.672-0.034-1.34-0.044-2.012-0.044-0.67 0-1.338 0.012-2.010 0.044-0.556 0.030-1.11 0.072-1.664 0.124-0.77 0.070-1.536 0.158-2.302 0.274-0.468 0.072-0.938 0.158-1.402 0.246-0.814 0.152-1.624 0.322-2.432 0.528-0.444 0.114-0.882 0.242-1.322 0.37-0.79 0.23-1.574 0.472-2.356 0.754-0.484 0.172-0.958 0.368-1.438 0.56-0.708 0.286-1.41 0.576-2.11 0.904-0.554 0.262-1.094 0.55-1.636 0.84-0.446 0.234-0.9 0.43-1.34 0.684l-407.906 235.672c-19.128 11.044-25.686 35.51-14.64 54.64 7.34 12.71 20.606 19.828 34.292 19.96v0.044h89.842v467.716h-89.474c-22.090 0-40 17.91-40 40s17.91 40 40 40h128.276c0.402 0.012 0.794 0.060 1.2 0.060s0.796-0.048 1.2-0.060h183.602c0.402 0.012 0.794 0.060 1.2 0.060s0.796-0.048 1.2-0.060h183.602c0.402 0.012 0.794 0.060 1.2 0.060s0.796-0.048 1.2-0.060h313.154c22.098 0 40-17.91 40-40-0.006-22.090-17.914-39.996-40.006-39.996zM751.182 847.534h-105.94v-467.716h105.94v467.716zM252.93 299.816l258.736-149.486 258.738 149.486h-517.474zM565.242 379.816v467.716h-106v-467.716h106zM273.242 379.816h106v467.716h-106v-467.716z',
	  paragraph: 'M728.032 96.032h-116.98c-0.026 0-0.050-0.004-0.076-0.004s-0.050 0.004-0.076 0.004h-199.848c-0.026 0-0.050-0.004-0.076-0.004s-0.050 0.004-0.076 0.004h-31.924c-123.712 0-224 100.292-224 224 0 121.032 95.994 219.628 216 223.842v344.158c0 22.092 17.91 40 40 40 22.086 0 40-17.908 40-40v-712h120v712c0 22.092 17.91 40 40 40 22.086 0 40-17.908 40-40v-712h77.056c22.094 0 40-17.91 40-40 0-22.092-17.91-40-40-40z',
	  basket: 'M632.254 695.604v-112.016c-0.004-22.092 17.906-40.002 40-40.002 22.090 0.002 40 17.908 40 40.002l-0.004 112.018c0.004 22.088-17.906 39.996-39.996 39.998-22.094 0.002-40.004-17.904-40-40zM352.246 735.604c22.090-0.002 40-17.91 39.996-39.998l0.004-112.018c0-22.094-17.91-40-40-40.002-22.094 0-40.004 17.91-40 40.002v112.016c-0.004 22.096 17.906 40.002 40 40zM512.25 735.604c22.090-0.002 40-17.91 39.996-39.998l0.004-112.018c0-22.094-17.91-40-40-40.002-22.094 0-40.004 17.91-40 40.002v112.016c-0.004 22.096 17.906 40.002 40 40zM950.3 397.424c-7.596-8.686-18.574-13.67-30.114-13.67h-313.284c0.87 5.196 1.346 10.524 1.346 15.966 0 24.608-9.27 47.044-24.494 64.034h290.684l-47.318 351.376-629.908-0.030-47.502-351.346h291.034c-15.224-16.988-24.494-39.426-24.494-64.034 0-5.444 0.476-10.772 1.346-15.966h-313.66c-11.542 0-22.524 4.986-30.12 13.678-7.596 8.694-11.066 20.242-9.52 31.682l51.614 381.742 0.050 0.042c5.832 47.424 46.222 84.158 95.222 84.172l0.054 0.034 601.816-0.034c0.042 0 0.082 0.002 0.124 0.002 49.414 0 90.090-37.34 95.396-85.336l51.258-380.64c1.54-11.44-1.934-22.984-9.53-31.672zM805.492 105.34c-15.622-15.622-40.95-15.624-56.572 0.004l-230.684 230.684c-2.052-0.2-4.132-0.306-6.236-0.306-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64c0-2.652-0.18-5.262-0.494-7.83l229.986-229.98c15.622-15.624 15.616-40.95-0-56.572z',
	  credit: 'M376.188 672.062h-112.124c-22.092 0-40-17.908-40-40s17.908-40 40-40h112.124c22.092 0 40 17.908 40 40s-17.908 40-40 40zM960 232.002v560c0 6.8-1.708 13.2-4.704 18.81-0.044 0.082-0.078 0.172-0.124 0.254-0.524 0.974-1.112 1.914-1.722 2.836-0.098 0.15-0.18 0.31-0.282 0.458-7.188 10.64-19.36 17.638-33.168 17.638h-816c-22.090 0-40-17.908-40-40v-559.998c0-20.34 15.192-37.092 34.838-39.628 1.694-0.218 3.408-0.372 5.162-0.372h816c1.754 0 3.468 0.152 5.162 0.372 19.646 2.536 34.838 19.288 34.838 39.63zM144 272.002v80.030h736v-80.030h-736zM880 751.998v-239.966h-736v239.966h736z',
	  shield: 'M875.146 148.994c-0.064-0.040-0.116-0.094-0.184-0.132-92.714-52.39-221.036-84.83-362.846-84.83-138.512 0-270.346 34.356-362.51 84.618-0.606 0.33-1.138 0.658-1.608 0.986-11.954 6.918-20.016 19.81-20.016 34.614v451.4c0 12.7 5.938 23.996 15.166 31.32l340.538 281.676c6.568 6.434 14.918 10.168 23.564 11.122 0.16 0.024 0.32 0.050 0.48 0.066 0.838 0.082 1.676 0.114 2.518 0.14 0.496 0.020 0.994 0.058 1.492 0.058s0.996-0.040 1.492-0.058c0.842-0.032 1.68-0.058 2.518-0.14 0.16-0.016 0.32-0.042 0.48-0.066 8.646-0.958 16.996-4.688 23.564-11.122l339.36-280.718c10.326-7.23 17.094-19.2 17.094-32.762v-450.918c0.002-15.254-8.54-28.506-21.102-35.254zM207.984 208.212c36.292-18.168 77.668-32.854 123.356-43.722 57.062-13.576 117.884-20.458 180.778-20.458s123.714 6.882 180.778 20.458c30.186 7.182 58.474 16.040 84.674 26.456l-490.846 490.848-78.738-65.070v-408.512zM511.742 867.75l-163.078-134.77 467.586-467.584v350.69l-304.508 251.664z',
	  beaker: 'M848.64 790.56l-208.638-361.374v-252.062h24c22.092 0 40-17.908 40-40s-17.908-40-40-40h-304.002c-22.092 0-40 17.908-40 40s17.908 40 40 40h24v252.066l-208.636 361.37c-44 76.208-8 138.564 80 138.564h513.278c87.998 0 123.998-62.354 79.998-138.564zM464 177.124h96.002l-0.070 273.376 63.872 110.628h-223.678c35.932-62.268 63.872-110.684 63.876-110.692v-273.312zM768.64 849.124h-513.278c-8.28 0-14.186-0.976-17.968-2 1.004-3.792 3.112-9.394 7.25-16.564 0 0 54.598-94.614 109.316-189.436l316.026-0.002 109.374 189.44c4.138 7.168 6.246 12.77 7.25 16.562-3.784 1.024-9.69 2-17.97 2z',
	  thumbsup: 'M256.972 768.004c0-8.67-3.156-16.158-9.484-22.534-6.332-6.34-13.836-9.484-22.504-9.458-8.682 0-16.188 3.172-22.516 9.458-6.33 6.344-9.488 13.84-9.488 22.534 0 8.692 3.158 16.186 9.488 22.532 6.328 6.286 13.834 9.458 22.516 9.458 8.668 0.028 16.172-3.118 22.504-9.458 6.328-6.376 9.484-13.868 9.484-22.532zM832.948 480.010c0-17.004-6.478-31.908-19.468-44.734-13.014-12.82-27.834-19.25-44.512-19.276h-175.97c0-19.328 7.98-45.904 24.004-79.724 15.968-33.826 23.978-60.568 23.978-80.256 0-32.646-5.332-56.808-15.994-72.48-10.664-15.664-31.988-23.484-63.98-23.484-8.696 8.64-15.012 22.828-19.032 42.486-4.020 19.69-9.102 40.606-15.254 62.752-6.168 22.172-16.080 40.382-29.762 54.738-7.344 7.68-20.168 22.832-38.5 45.496-1.326 1.67-5.164 6.65-11.512 15.010-6.342 8.342-11.594 15.178-15.762 20.508-4.156 5.308-9.91 12.386-17.252 21.218-7.328 8.862-14 16.186-19.988 22.038-5.986 5.794-12.412 11.73-19.26 17.744-6.852 5.984-13.508 10.5-19.99 13.48-6.478 3.010-12.4 4.484-17.756 4.512h-15.982v320.010h15.982c4.332 0 9.596 0.492 15.774 1.504 6.168 1.012 11.676 2.080 16.488 3.258 4.812 1.144 11.154 2.98 19.002 5.466 7.862 2.512 13.702 4.424 17.502 5.74 3.812 1.31 9.732 3.422 17.756 6.238 8.026 2.842 12.866 4.586 14.506 5.272 70.324 24.334 127.304 36.504 170.996 36.504h60.482c64.006 0 96.024-27.836 96.024-83.478 0-8.664-0.848-18.016-2.514-27.996 10.004-5.334 17.936-14.084 23.758-26.276 5.824-12.172 8.724-24.416 8.778-36.746 0-12.366-3.008-23.844-9.024-34.51 17.664-16.682 26.524-36.496 26.524-59.496 0-8.308-1.696-17.554-5.032-27.72-3.336-10.202-7.492-18.104-12.468-23.762 10.636-0.328 19.55-8.15 26.714-23.486 7.192-15.34 10.744-28.82 10.744-40.496v-0.054zM896.984 479.516c0 29.638-8.204 56.816-24.5 81.506 2.98 10.994 4.484 22.476 4.484 34.482 0 25.674-6.344 49.68-19.004 71.99 1.012 7 1.506 14.164 1.506 21.488 0 33.688-10.008 63.354-29.968 89.026 0.326 46.32-13.834 82.904-42.518 109.756-28.682 26.848-66.522 40.246-113.496 40.246h-64.528c-31.99 0-63.542-3.746-94.742-11.268-31.168-7.492-67.246-18.402-108.23-32.758-38.662-13.312-61.656-19.956-68.984-19.956h-143.996c-17.664 0-32.742-6.292-45.252-18.784-12.508-12.5-18.756-27.588-18.756-45.254v-319.982c0-17.666 6.248-32.728 18.756-45.226 12.51-12.52 27.588-18.784 45.252-18.784h136.998c12.002-8.010 34.818-33.822 68.478-77.484 19.33-24.99 37.168-46.344 53.508-64.008 7.996-8.314 13.918-22.586 17.744-42.766 3.828-20.178 8.912-41.232 15.256-63.24 6.36-21.984 16.68-40.002 30.994-53.998 13.002-12.362 28.012-18.514 45.018-18.514 27.998 0 53.152 5.414 75.464 16.242 22.31 10.828 39.316 27.748 50.964 50.77 11.704 23.002 17.5 53.978 17.5 92.962 0 31.008-7.984 63-23.98 96.028h88.014c34.67 0 64.634 12.628 89.956 37.98 25.346 25.346 38.008 55.144 38.008 89.49l0.054 0.056z',
	  mirror: 'M857 127.778h-688c-22.092 0-40 17.91-40 40v688c0 22.090 17.908 40 40 40h688c22.094 0 40-17.91 40-40v-688c0-22.092-17.906-40-40-40zM817 815.778h-608v-1.086l606.914-606.914h1.086v608z',
	  switchalt: 'M923.946 63.418h-631.232c-20.268 0-36.7 16.432-36.7 36.7v155.286h-155.284c-20.268 0-36.7 16.432-36.7 36.7v631.23c0 20.268 16.43 36.7 36.7 36.7h631.23c20.272 0 36.7-16.432 36.7-36.7v-155.286h155.286c20.272 0 36.7-16.432 36.7-36.7v-631.23c-0.002-20.268-16.43-36.7-36.7-36.7zM688.66 880.032h-544.628v-544.628h111.984v395.946c0 20.268 16.43 36.7 36.7 36.7h395.944v111.982zM688.66 688.046h-352.644v-352.644h352.644v352.644zM880.644 688.046h-111.984v-395.946c0-20.268-16.428-36.7-36.7-36.7h-395.944v-111.984h544.628v544.63z',
	  commit: 'M984.032 472h-186.808c-19.474-140.12-139.74-248-285.222-248s-265.748 107.88-285.222 248h-186.746c-22.092 0-40 17.912-40 40.002 0 22.092 17.91 40 40 40h186.746c19.476 140.122 139.74 247.998 285.222 247.998s265.746-107.876 285.222-247.998h186.808c22.092 0 40-17.91 40-40s-17.908-40.002-40-40.002zM512 720c-114.692 0-208-93.308-208-208s93.308-208 208-208 208 93.308 208 208-93.308 208-208 208z',
	  branch: 'M861.968 312.032c0-66.168-53.832-120-120-120s-120 53.832-120 120c0 50.55 31.436 93.87 75.77 111.516-5.384 20.352-15.71 39.68-29.844 54.92-28.828 31.092-72.202 46.858-128.91 46.858-77.162 0-129.12 26.162-162.984 55.12V297.15c46.556-16.512 80-60.974 80-113.12 0-66.168-53.832-120-120-120s-120 53.832-120 120c0 52.146 33.444 96.608 80 113.12v429.762c-46.556 16.512-80 60.974-80 113.12 0 66.168 53.832 120 120 120s120-53.832 120-120c0-50.926-31.902-94.514-76.758-111.908 5.222-26.17 16.578-51.154 32.558-70.432 28.8-34.746 71.592-52.364 127.184-52.364 99.498 0 156.922-39.408 187.574-72.466 27.402-29.554 45.708-67.194 52.48-106.716 48.078-15.66 82.93-60.882 82.93-114.114zM336 144.032c22.056 0 40 17.944 40 40s-17.944 40-40 40-40-17.944-40-40 17.944-40 40-40zm0 736c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40zm405.968-528c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.942 40-40 40z',
	  merge: 'M776.306 456.032c-51.602 0-95.696 32.744-112.612 78.542-69.674-6.072-141.482-31.012-197.386-69.306-46.266-31.69-100.392-85.728-111.792-168.92 45.4-17.12 77.79-60.998 77.79-112.314 0-66.168-53.832-120-120-120s-120 53.832-120 120c0 52.146 33.444 96.608 80 113.12v429.762c-46.556 16.512-80 60.974-80 113.12 0 66.168 53.832 120 120 120s120-53.832 120-120c0-52.146-33.444-96.608-80-113.12V471.444c19.622 21.888 42.618 41.898 68.792 59.828 68.422 46.868 156.64 77.042 241.646 83.462 16.14 47.23 60.932 81.3 113.56 81.3 66.168 0 120-53.832 120-120s-53.83-120.002-119.998-120.002zm-464-312c22.056 0 40 17.944 40 40s-17.944 40-40 40-40-17.944-40-40 17.942-40 40-40zm0 736c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40zm464-264c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z',
	  pullrequest: 'M631 157c104 1 171 52 171 166v397a123 123 0 1 1-82 0V323c0-63-27-83-90-84h-24l22 23a41 41 0 1 1-58 58l-93-93a41 41 0 0 1 1-58l93-93a41 41 0 1 1 58 58l-23 23h25zM222 314a123 123 0 1 1 82 0v406a123 123 0 1 1-82 0V314zm41 564a41 41 0 1 0 0-82 41 41 0 0 0 0 82zm0-639a41 41 0 1 0 0-83 41 41 0 0 0 0 83zm498 639a41 41 0 1 0 0-82 41 41 0 0 0 0 82z',
	  chroma: 'M511.714 956.324c-92.92 0-168.518-75.594-168.518-168.514v-334.082l131.54 75.954v215.936c0 13.172 7.082 25.446 18.48 32.030l139.33 80.43c8.33 4.814 17.014 9.168 25.872 12.966-29.646 52.72-85.44 85.28-146.704 85.28zM753.584 816.61c-29.36 0-58.43-7.812-84.064-22.59l-83.828-48.404 289.354-167.028c8.3-4.802 16.402-10.152 24.132-15.936 30.858 52.030 31.182 116.622 0.568 169.664-30.034 51.994-86.040 84.294-146.162 84.294zM270.334 816.576c-60.084 0-116.064-32.278-146.102-84.238-22.494-39.012-28.466-84.426-16.814-127.866 11.68-43.512 39.564-79.858 78.522-102.334l83.806-48.398 0.018 334.018c0 9.624 0.57 19.294 1.69 28.814-0.374 0.002-0.748 0.004-1.12 0.004zM548.73 529.73l186.996-107.966c11.416-6.588 18.506-18.864 18.506-32.040v-160.856c0.012-9.456-0.56-19.116-1.706-28.778 0.364-0.002 0.732-0.004 1.096-0.004 60.114 0 116.104 32.296 146.124 84.29 46.436 80.486 18.75 183.742-61.714 230.176l-289.302 167.040v-151.862zM325.248 357.624c-5.632-3.242-12.030-4.954-18.504-4.954-6.428 0-12.804 1.708-18.44 4.936l-139.344 80.452c-8.348 4.802-16.462 10.142-24.172 15.912-30.824-52-31.14-116.59-0.546-169.664 30.048-52 86.050-84.306 146.148-84.306 29.326 0 58.394 7.822 84.064 22.624l289.3 167.054-131.482 75.91-187.024-107.964zM390.964 158.644c-8.334-4.826-17.036-9.192-25.92-13.004 29.634-52.742 85.418-85.316 146.67-85.316 92.92 0 168.514 75.6 168.514 168.522v96.81l-289.264-167.012z',
	  twitter: 'M960 233.114c-32.946 14.616-68.41 24.5-105.598 28.942 37.954-22.762 67.098-58.774 80.856-101.688-35.52 21.054-74.894 36.368-116.726 44.598-33.542-35.724-81.316-58.038-134.204-58.038-101.496 0-183.796 82.292-183.796 183.814 0 14.424 1.628 28.45 4.758 41.89-152.75-7.668-288.22-80.872-378.876-192.072-15.822 27.15-24.898 58.706-24.898 92.42 0 63.776 32.458 120.034 81.782 153.010-30.116-0.944-58.458-9.212-83.262-22.982-0.028 0.75-0.028 1.546-0.028 2.324 0 89.070 63.356 163.334 147.438 180.256-15.426 4.186-31.664 6.426-48.442 6.426-11.836 0-23.35-1.146-34.574-3.28 23.406 73.006 91.286 126.16 171.726 127.632-62.914 49.324-142.18 78.696-228.314 78.696-14.828 0-29.448-0.876-43.842-2.568 81.33 52.138 177.96 82.574 281.786 82.574 338.11 0 523-280.104 523-523.014 0-7.986-0.164-15.914-0.542-23.778 35.952-25.96 67.124-58.318 91.756-95.162z',
	  google: 'M799.094 79.996c0 0-200.938 0-267.936 0-120.126 0-233.188 91.004-233.188 196.434 0 107.692 81.904 194.624 204.124 194.624 8.496 0 16.75-0.148 24.812-0.74-7.942 15.186-13.594 32.286-13.594 50.022 0 29.974 16.094 54.226 36.466 74.042-15.376 0-30.248 0.438-46.438 0.438-148.782 0.036-263.312 94.784-263.312 193.056 0 96.758 125.534 157.312 274.312 157.312 169.656 0 263.312-96.25 263.312-193.024 0-77.6-22.908-124.062-93.686-174.156-24.216-17.128-70.534-58.812-70.534-83.32 0-28.69 8.19-42.868 51.406-76.624 44.346-34.63 75.688-83.302 75.688-139.944 0-67.372-30-133.058-86.374-154.746h85l59.942-43.374zM701.504 735.438c2.092 8.992 3.276 18.226 3.276 27.624 0 78.226-50.374 139.304-194.934 139.304-102.874 0-177.124-65.078-177.124-143.304 0-76.622 92.122-140.434 194.934-139.32 24.004 0.254 46.376 4.136 66.69 10.702 55.812 38.834 95.874 60.808 107.158 104.994zM536.844 443.782c-69-2.094-134.624-77.212-146.564-167.876-11.874-90.664 34.378-160.030 103.442-157.97 68.996 2.060 134.594 74.818 146.53 165.432 11.906 90.696-34.408 162.508-103.408 160.414z',
	  gdrive: 'M465.926 641.356l-149.328 258.708h494.074l149.328-258.708h-494.074zM917.704 567.988l-256.33-444.048h-298.686l256.356 444.048h298.66zM320.236 197.442l-256.236 443.914 149.36 258.708 256.23-443.914-149.354-258.708z',
	  youtube: 'M704.010 511.988c0-12.332-5.038-21.358-15.042-26.992l-255.982-159.99c-10.344-6.666-21.178-6.998-32.51-1.008-10.988 5.984-16.492 15.312-16.492 28.002v320c0 12.69 5.504 22.018 16.492 28.002 5.332 2.678 10.516 3.996 15.506 3.996 6.668 0 12.334-1.644 17.004-4.98l255.982-160.014c10.004-5.69 15.042-14.684 15.042-26.992v-0.024zM960 511.988c0 31.99-0.164 56.98-0.488 75.032-0.334 17.99-1.754 40.738-4.27 68.25-2.516 27.504-6.262 52.058-11.27 73.742-5.332 24.338-16.84 44.85-34.504 61.496-17.64 16.63-38.306 26.308-61.96 28.988-73.992 8.342-185.824 12.526-335.508 12.526-149.668 0-261.5-4.184-335.5-12.526-23.662-2.656-44.414-12.302-62.242-28.988-17.834-16.678-29.412-37.182-34.744-61.496-4.672-21.684-8.258-46.238-10.756-73.742-2.508-27.512-3.928-50.26-4.254-68.25-0.342-18.050-0.504-43.042-0.504-75.032 0-31.998 0.162-57.010 0.504-75.008 0.326-18.022 1.746-40.768 4.254-68.28 2.498-27.474 6.262-52.082 11.252-73.744 5.34-24.336 16.842-44.842 34.504-61.496 17.648-16.654 38.324-26.332 61.986-29.010 74-8.312 185.832-12.472 335.5-12.472 149.684 0 261.516 4.16 335.508 12.472 23.654 2.678 44.406 12.356 62.232 29.010 17.826 16.678 29.422 37.16 34.73 61.496 4.702 21.662 8.256 46.27 10.772 73.744 2.516 27.512 3.936 50.258 4.27 68.28 0.324 17.998 0.488 43.010 0.488 75.008z',
	  facebook: 'M582.52 960h-167.88v-448h-112v-154.396l112-0.052-0.166-90.948c-0.036-125.974 34.12-202.604 182.484-202.604h123.542v154.424h-77.19c-57.782 0-60.566 21.56-60.566 61.85l-0.218 77.278h138.854l-16.376 154.394-122.36 0.052-0.124 448.002z',
	  medium: 'M0 0v1024h1024v-1024h-1024zM850.708 242.614l-54.918 52.655c-3.858 2.965-6.321 7.581-6.321 12.772 0 0.933 0.080 1.847 0.232 2.736l-0.014-0.095v386.883c-0.139 0.794-0.219 1.708-0.219 2.641 0 5.191 2.462 9.807 6.283 12.744l0.038 0.028 53.637 52.655v11.558h-269.774v-11.558l55.559-53.936c5.461-5.456 5.461-7.068 5.461-15.413v-312.719l-154.477 392.344h-20.874l-179.851-392.344v262.947c-0.209 1.465-0.329 3.156-0.329 4.875 0 9.848 3.924 18.78 10.293 25.317l-0.008-0.008 72.258 87.649v11.558h-204.895v-11.558l72.263-87.649c6.070-6.284 9.81-14.852 9.81-24.293 0-2.081-0.182-4.12-0.53-6.101l0.031 0.21v-304.044c0.086-0.804 0.135-1.737 0.135-2.682 0-7.844-3.389-14.896-8.782-19.773l-0.023-0.021-64.234-77.378v-11.558h199.438l154.157 338.083 135.53-338.083h190.123v11.558z',
	  graphql: 'M896.38 635.332c-7.286-4.206-14.934-7.196-22.714-9.074v-228.148c7.788-1.882 15.44-4.874 22.732-9.082 40.902-23.614 54.92-75.934 31.3-116.846-23.62-40.914-75.942-54.932-116.846-31.318-7.286 4.21-13.704 9.34-19.22 15.14l-197.586-114.076c2.266-7.68 3.502-15.802 3.502-24.212 0-47.232-38.3-85.53-85.544-85.53-47.242 0-85.544 38.298-85.544 85.53 0 8.42 1.238 16.552 3.508 24.24l-197.598 114.046c-5.518-5.802-11.936-10.93-19.218-15.138-40.902-23.614-93.22-9.596-116.846 31.318-23.62 40.91-9.6 93.228 31.3 116.846 7.29 4.208 14.94 7.202 22.728 9.082v228.15c-7.782 1.878-15.434 4.866-22.718 9.074-40.91 23.62-54.93 75.938-31.31 116.848 23.624 40.914 75.944 54.932 116.856 31.312 7.28-4.206 13.692-9.334 19.206-15.13l197.588 114.080c-2.262 7.68-3.498 15.792-3.498 24.2 0 47.244 38.302 85.544 85.546 85.544 47.242 0 85.542-38.302 85.542-85.544 0-9.362-1.524-18.36-4.308-26.79l196.558-113.484c5.914 6.624 12.946 12.446 21.046 17.126 40.912 23.618 93.23 9.602 116.856-31.314 23.618-40.914 9.598-93.232-31.318-116.85zM253.492 689.212c-1.88-7.73-4.856-15.33-9.038-22.568-4.142-7.18-9.194-13.516-14.892-18.98l258.558-447.814c7.58 2.198 15.586 3.402 23.878 3.402 8.262 0 16.242-1.196 23.802-3.38l258.574 447.85c-5.676 5.456-10.704 11.77-14.834 18.928-4.182 7.238-7.162 14.838-9.042 22.566l-517.006-0.004zM771.404 291.408c-6.156 21.512-3.936 45.396 8.138 66.306 12.066 20.91 31.638 34.772 53.348 40.2v228.538c-1.074 0.266-2.144 0.56-3.208 0.868l-258.56-447.826c0.804-0.768 1.596-1.556 2.372-2.354l197.91 114.268zM450.526 177.162c0.75 0.772 1.516 1.536 2.296 2.282l-258.578 447.856c-1.038-0.3-2.084-0.586-3.134-0.85v-228.536c21.708-5.428 41.276-19.29 53.348-40.202 12.074-20.91 14.294-44.794 8.134-66.306l197.934-114.244zM575.392 849.216c-15.65-17.262-38.256-28.108-63.39-28.108-24.152 0-45.946 10.026-61.5 26.112l-197.908-114.266c0.28-0.986 0.544-1.98 0.794-2.972h517.226c0.464 1.888 0.976 3.756 1.57 5.61l-196.792 113.624z',
	  redux: 'M359.016 943.608c-23.82 5.948-47.642 8.322-71.512 8.322-88.208 0-168.084-36.982-207.444-96.534-52.432-79.882-70.296-249.182 102.538-374.356 3.586 19.078 10.746 45.292 15.492 60.834-22.656 16.652-58.39 50.064-81.046 95.324-32.19 63.184-28.61 126.404 9.54 184.798 26.194 39.304 67.926 63.176 121.564 70.34 65.598 8.332 131.154-3.582 194.332-36.94 92.998-48.898 155.014-107.282 195.49-187.162-10.702-10.75-17.818-26.248-19.074-44.15-1.168-36.942 27.45-67.922 64.388-69.132h2.418c35.73 0 65.55 28.61 66.714 64.384 1.206 35.73-24.986 65.546-59.548 69.132-65.6 134.686-181.254 225.312-333.852 255.14zM902.646 540.622c-90.59-106.072-224.11-164.488-376.708-164.488h-19.072c-10.744-21.444-33.402-35.752-58.388-35.752h-2.418c-36.944 1.186-65.548 32.192-64.392 69.13 1.216 35.774 30.99 64.394 66.81 64.394h2.328c26.242-1.208 48.894-17.892 58.434-40.542h21.45c90.624 0 176.46 26.234 253.968 77.482 59.55 39.36 102.49 90.576 126.356 152.596 20.24 50.052 19.074 98.952-2.42 140.64-33.356 63.228-89.37 97.794-163.292 97.794-47.69 0-92.998-14.33-116.822-25.082-13.118 11.958-36.984 31.028-53.64 42.944 51.226 23.87 103.7 36.94 153.762 36.94 114.446 0 199.070-63.132 231.268-126.362 34.562-69.13 32.188-188.326-57.224-289.694zM297.046 708.706c1.21 35.828 30.984 64.394 66.764 64.394h2.368c36.992-1.168 65.556-32.15 64.39-69.132-1.162-35.732-30.984-64.394-66.758-64.394h-2.376c-2.418 0-5.958 0-8.332 1.208-48.89-81.090-69.132-169.27-62.014-264.648 4.792-71.528 28.616-133.516 70.346-184.766 34.568-44.106 101.326-65.57 146.598-66.758 126.402-2.396 180.044 154.968 183.576 218.144 15.542 3.584 41.734 11.936 59.644 17.892-14.328-193.118-133.526-293.266-247.97-293.266-107.28 0-206.236 77.484-245.552 191.932-54.848 152.596-19.070 299.212 47.644 414.826-5.912 8.374-9.494 21.498-8.328 34.568z',
	  github: 'M512.062 64.032c-247.426 0-448 200.576-448 448s200.574 448 448 448c247.422 0 448-200.576 448-448s-200.578-448-448-448zM251.846 772.246c-69.506-69.508-107.784-161.918-107.784-260.214 0-98.294 38.278-190.708 107.784-260.216 69.508-69.504 161.92-107.784 260.216-107.784s190.708 38.28 260.214 107.784c69.504 69.508 107.786 161.922 107.786 260.216 0 98.296-38.282 190.708-107.786 260.214-42.852 42.848-94.41 73.806-150.684 91.27v-65.104c0-34.584-11.86-60.022-35.578-76.31 14.864-1.43 28.512-3.43 40.942-6.002 12.434-2.572 25.578-6.292 39.442-11.146s26.292-10.644 37.3-17.364c11-6.712 21.574-15.434 31.718-26.15s18.648-22.866 25.508-36.444c6.864-13.57 12.292-29.866 16.292-48.874 4.004-19.006 6-39.944 6-62.802 0-44.3-14.434-82.032-43.296-113.182 13.14-34.294 11.714-71.594-4.29-111.894l-10.718-1.286c-7.43-0.858-20.79 2.286-40.082 9.434-19.29 7.144-40.942 18.864-64.95 35.152-34.016-9.432-69.308-14.148-105.894-14.148-36.87 0-72.024 4.716-105.46 14.148-15.144-10.29-29.51-18.79-43.086-25.508s-24.436-11.29-32.582-13.718c-8.144-2.43-15.718-3.93-22.722-4.5-7-0.574-11.5-0.714-13.504-0.43-2 0.286-3.43 0.572-4.288 0.86-16.004 40.582-17.436 77.88-4.288 111.894-28.868 31.152-43.3 68.878-43.3 113.178 0 22.866 2 43.798 6.002 62.804 4 19.010 9.432 35.296 16.292 48.876s15.364 25.722 25.508 36.442c10.146 10.718 20.72 19.438 31.724 26.152s23.436 12.504 37.298 17.362c13.862 4.858 27.008 8.574 39.442 11.146 12.434 2.57 26.080 4.574 40.942 6.002-23.438 16.004-35.152 41.444-35.152 76.31v66.404c-57.936-17.198-111.030-48.638-154.966-92.572z',
	  bitbucket: 'M512.157 32c-219.6 0-400.001 61.279-400.001 138.881 0 20.4 47.040 310.481 66.641 424.8 7.841 53.28 137.359 126.72 333.36 126.72 196.080 0 321.6-73.601 333.36-126.641 19.601-114.4 66.641-404.479 66.641-424.8-3.919-77.76-180.401-138.96-400.001-138.96v0zM512.157 628.4c-70.56 0-125.52-57.2-125.52-130.722s54.96-130.72 125.52-130.72c70.56 0 125.52 57.199 125.52 130.721 0 69.439-54.96 130.721-125.52 130.721zM512.157 211.76c-141.199 0-254.88-24.559-254.88-57.199 0-32.719 113.681-57.199 254.88-57.199s254.88 24.48 254.88 57.199c0 32.64-113.681 57.199-254.88 57.199zM801.597 706.081c7.84 0 11.76 8.16 7.84 16.32v4.002c-15.679 85.84-27.439 147.199-27.439 155.28-11.76 61.279-129.439 110.321-270.641 110.321-141.12 0-258.8-49.039-270.56-110.321 0-8.16-11.76-69.439-27.439-155.201v-4.081c0-12.24 7.841-16.319 15.679-16.319 4.409 0.751 8.359 2.145 11.962 4.1l-0.202-0.101c0 0 98.081 81.761 274.481 81.761 176.479 0 274.56-81.679 274.56-81.679s3.919-4.080 11.76-4.080l0.001-0.002zM512.157 558.961c-34.639 0-62.719-29.279-62.719-65.359s28.001-65.359 62.719-65.359c34.639 0 62.719 29.279 62.719 65.359s-28.001 65.359-62.719 65.359z',
	  gitlab: 'M511.989 937.076l-175.718-538.045h351.434l-175.717 538.045zM90.107 399.031l421.88 538.045-462.033-334.102c-9.156-6.631-15.047-17.289-15.047-29.321 0-3.985 0.645-7.821 1.839-11.406l-0.072 0.255 53.431-163.471zM90.107 399.031l105.75-324.083c2.508-7.304 9.319-12.457 17.334-12.457s14.825 5.153 17.294 12.329l0.042 0.128 105.749 324.082-246.165 0.001zM933.869 399.031l53.431 163.474c1.133 3.347 1.788 7.203 1.788 11.215 0 12.038-5.895 22.705-14.961 29.262l-0.104 0.072-462.034 334.022 421.88-538.046zM933.869 399.031h-246.162l105.75-324.083c2.543-7.242 9.325-12.341 17.292-12.341s14.748 5.096 17.256 12.212l0.042 0.127 105.825 324.083z',
	  discord: 'M371 147c-14 0-126 3-245 91 0 0-126 227-126 507 0 0 74 126 268 132l58-71c-111-34-153-103-153-103l24 15 4 2 8 4a668 668 0 0 0 420 68 629 629 0 0 0 228-89s-44 71-159 103l58 71c194-7 268-133 268-132 0-280-126-507-126-507-126-94-246-91-246-91l-12 14a576 576 0 0 1 218 110 729 729 0 0 0-441-81l-15 1c-31 4-105 14-199 56-33 14-52 24-52 24s72-69 230-114l-9-10h-1zm-23 323c50 0 91 43 90 97 0 53-40 96-90 96-49 0-89-43-89-96 0-54 39-97 89-97zm321 0c49 0 89 43 89 97 0 53-39 96-89 96s-90-43-90-96c0-54 40-97 90-97z'
	};
	exports.icons = icons;
	var _default = icons;
	exports["default"] = _default;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _theming = __webpack_require__(5);
	
	var Svg = _theming.styled.svg({
	  // Fix rendering bugs in Chrome for hdpi
	  shapeRendering: 'inherit',
	  transform: 'translate3d(0,0,0)'
	}, function (_ref) {
	  var inline = _ref.inline;
	  return inline ? {
	    display: 'inline-block'
	  } : {
	    display: 'block'
	  };
	});
	
	exports["default"] = Svg;
	Svg.displayName = 'Svg';

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(153);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	__webpack_require__(155);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  Badge: true,
	  Link: true,
	  DocumentWrapper: true,
	  SyntaxHighlighter: true,
	  ActionBar: true,
	  Spaced: true,
	  Placeholder: true,
	  ScrollArea: true,
	  Button: true,
	  Form: true,
	  WithTooltip: true,
	  WithTooltipPure: true,
	  TooltipMessage: true,
	  TooltipNote: true,
	  TooltipLinkList: true,
	  Tabs: true,
	  TabsState: true,
	  TabBar: true,
	  TabWrapper: true,
	  IconButton: true,
	  TabButton: true,
	  Separator: true,
	  interleaveSeparators: true,
	  Bar: true,
	  FlexBar: true,
	  AddonPanel: true,
	  Icons: true,
	  StorybookLogo: true,
	  StorybookIcon: true
	};
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.Badge;
	  }
	});
	Object.defineProperty(exports, "Link", {
	  enumerable: true,
	  get: function get() {
	    return _link.Link;
	  }
	});
	Object.defineProperty(exports, "DocumentWrapper", {
	  enumerable: true,
	  get: function get() {
	    return _DocumentWrapper.DocumentWrapper;
	  }
	});
	Object.defineProperty(exports, "SyntaxHighlighter", {
	  enumerable: true,
	  get: function get() {
	    return _syntaxhighlighter.SyntaxHighlighter;
	  }
	});
	Object.defineProperty(exports, "ActionBar", {
	  enumerable: true,
	  get: function get() {
	    return _ActionBar.ActionBar;
	  }
	});
	Object.defineProperty(exports, "Spaced", {
	  enumerable: true,
	  get: function get() {
	    return _Spaced.Spaced;
	  }
	});
	Object.defineProperty(exports, "Placeholder", {
	  enumerable: true,
	  get: function get() {
	    return _placeholder.Placeholder;
	  }
	});
	Object.defineProperty(exports, "ScrollArea", {
	  enumerable: true,
	  get: function get() {
	    return _ScrollArea.ScrollArea;
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button.Button;
	  }
	});
	Object.defineProperty(exports, "Form", {
	  enumerable: true,
	  get: function get() {
	    return _index.Form;
	  }
	});
	Object.defineProperty(exports, "WithTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _WithTooltip.WithTooltip;
	  }
	});
	Object.defineProperty(exports, "WithTooltipPure", {
	  enumerable: true,
	  get: function get() {
	    return _WithTooltip.WithTooltipPure;
	  }
	});
	Object.defineProperty(exports, "TooltipMessage", {
	  enumerable: true,
	  get: function get() {
	    return _TooltipMessage.TooltipMessage;
	  }
	});
	Object.defineProperty(exports, "TooltipNote", {
	  enumerable: true,
	  get: function get() {
	    return _TooltipNote.TooltipNote;
	  }
	});
	Object.defineProperty(exports, "TooltipLinkList", {
	  enumerable: true,
	  get: function get() {
	    return _TooltipLinkList.TooltipLinkList;
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _tabs.Tabs;
	  }
	});
	Object.defineProperty(exports, "TabsState", {
	  enumerable: true,
	  get: function get() {
	    return _tabs.TabsState;
	  }
	});
	Object.defineProperty(exports, "TabBar", {
	  enumerable: true,
	  get: function get() {
	    return _tabs.TabBar;
	  }
	});
	Object.defineProperty(exports, "TabWrapper", {
	  enumerable: true,
	  get: function get() {
	    return _tabs.TabWrapper;
	  }
	});
	Object.defineProperty(exports, "IconButton", {
	  enumerable: true,
	  get: function get() {
	    return _button.IconButton;
	  }
	});
	Object.defineProperty(exports, "TabButton", {
	  enumerable: true,
	  get: function get() {
	    return _button.TabButton;
	  }
	});
	Object.defineProperty(exports, "Separator", {
	  enumerable: true,
	  get: function get() {
	    return _separator.Separator;
	  }
	});
	Object.defineProperty(exports, "interleaveSeparators", {
	  enumerable: true,
	  get: function get() {
	    return _separator.interleaveSeparators;
	  }
	});
	Object.defineProperty(exports, "Bar", {
	  enumerable: true,
	  get: function get() {
	    return _bar.Bar;
	  }
	});
	Object.defineProperty(exports, "FlexBar", {
	  enumerable: true,
	  get: function get() {
	    return _bar.FlexBar;
	  }
	});
	Object.defineProperty(exports, "AddonPanel", {
	  enumerable: true,
	  get: function get() {
	    return _addonPanel.AddonPanel;
	  }
	});
	Object.defineProperty(exports, "Icons", {
	  enumerable: true,
	  get: function get() {
	    return _icon.Icons;
	  }
	});
	Object.defineProperty(exports, "StorybookLogo", {
	  enumerable: true,
	  get: function get() {
	    return _StorybookLogo.StorybookLogo;
	  }
	});
	Object.defineProperty(exports, "StorybookIcon", {
	  enumerable: true,
	  get: function get() {
	    return _StorybookIcon.StorybookIcon;
	  }
	});
	
	var _Badge = __webpack_require__(491);
	
	var _link = __webpack_require__(312);
	
	var _DocumentWrapper = __webpack_require__(525);
	
	var _syntaxhighlighter = __webpack_require__(311);
	
	var _ActionBar = __webpack_require__(194);
	
	var _Spaced = __webpack_require__(516);
	
	var _placeholder = __webpack_require__(310);
	
	var _ScrollArea = __webpack_require__(195);
	
	var _Button = __webpack_require__(306);
	
	var _index = __webpack_require__(510);
	
	var _WithTooltip = __webpack_require__(524);
	
	var _TooltipMessage = __webpack_require__(522);
	
	var _TooltipNote = __webpack_require__(523);
	
	var _TooltipLinkList = __webpack_require__(521);
	
	var _tabs = __webpack_require__(518);
	
	var _button = __webpack_require__(197);
	
	var _separator = __webpack_require__(494);
	
	var _bar = __webpack_require__(196);
	
	var _addonPanel = __webpack_require__(493);
	
	var _icon = __webpack_require__(199);
	
	var _StorybookLogo = __webpack_require__(508);
	
	var _StorybookIcon = __webpack_require__(507);
	
	var _blocks = __webpack_require__(506);
	
	Object.keys(_blocks).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _blocks[key];
	    }
	  });
	});

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(551);
	
	__webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Spaced = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var toNumber = function toNumber(input) {
	  return typeof input === 'number' ? input : Number(input);
	};
	
	var Container = _theming.styled.div(function (_ref) {
	  var theme = _ref.theme,
	      col = _ref.col,
	      _ref$row = _ref.row,
	      row = _ref$row === void 0 ? 1 : _ref$row;
	  return col ? {
	    display: 'inline-block',
	    verticalAlign: 'inherit',
	    '& > *': {
	      marginLeft: col * theme.layoutMargin,
	      verticalAlign: 'inherit'
	    },
	    '& > *:first-of-type': {
	      marginLeft: 0
	    }
	  } : {
	    '& > *': {
	      marginTop: row * theme.layoutMargin
	    },
	    '& > *:first-of-type': {
	      marginTop: 0
	    }
	  };
	}, function (_ref2) {
	  var theme = _ref2.theme,
	      outer = _ref2.outer,
	      col = _ref2.col,
	      row = _ref2.row;
	
	  switch (true) {
	    case !!(outer && col):
	      {
	        return {
	          marginLeft: outer * theme.layoutMargin,
	          marginRight: outer * theme.layoutMargin
	        };
	      }
	
	    case !!(outer && row):
	      {
	        return {
	          marginTop: outer * theme.layoutMargin,
	          marginBottom: outer * theme.layoutMargin
	        };
	      }
	
	    default:
	      {
	        return {};
	      }
	  }
	});
	
	var Spaced = function Spaced(_ref3) {
	  var col = _ref3.col,
	      row = _ref3.row,
	      outer = _ref3.outer,
	      children = _ref3.children;
	  var outerAmount = toNumber(typeof outer === 'number' || !outer ? outer : col || row);
	  return _react["default"].createElement(Container, {
	    col: col,
	    row: row,
	    outer: outerAmount
	  }, children);
	};
	
	exports.Spaced = Spaced;
	Spaced.displayName = "Spaced";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(112);
	
	__webpack_require__(154);
	
	__webpack_require__(3);
	
	__webpack_require__(343);
	
	__webpack_require__(552);
	
	__webpack_require__(553);
	
	__webpack_require__(345);
	
	__webpack_require__(346);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatter = void 0;
	
	var _memoizerific = _interopRequireDefault(__webpack_require__(128));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var formatter = (0, _memoizerific["default"])(2)(function (code) {
	  // code provided to the component is often coming from template literals, which preserve whitespace.
	  // sometimes the first line doesn't have padding, but the second does.
	  // we split the code-string into lines, then if we find padding on line 0 or 1,
	  // we assume that padding is bad, and remove that much padding on all following lines
	  return code.split(/\n/).reduce(function (acc, i, index) {
	    var match = i.match(/^((:?\s|\t)+)/);
	    var padding = match ? match[1] : '';
	
	    if (acc.firstIndent === '' && padding && index < 3) {
	      return {
	        result: "".concat(acc.result, "\n").concat(i.replace(padding, '')),
	        firstIndent: padding
	      };
	    }
	
	    return {
	      result: "".concat(acc.result, "\n").concat(i.replace(acc.firstIndent, '').replace(/\s*$/, '')),
	      firstIndent: acc.firstIndent
	    };
	  }, {
	    firstIndent: '',
	    result: ''
	  }).result.trim();
	});
	exports.formatter = formatter;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(51);
	
	__webpack_require__(68);
	
	__webpack_require__(62);
	
	__webpack_require__(48);
	
	__webpack_require__(49);
	
	__webpack_require__(212);
	
	__webpack_require__(3);
	
	__webpack_require__(30);
	
	__webpack_require__(213);
	
	__webpack_require__(214);
	
	__webpack_require__(50);
	
	__webpack_require__(67);
	
	__webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabsState = exports.Tabs = exports.panelProps = exports.TabWrapper = exports.TabBar = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _theming = __webpack_require__(5);
	
	var _placeholder = __webpack_require__(310);
	
	var _bar = __webpack_require__(196);
	
	var _button = __webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ignoreSsrWarning = '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */';
	
	var Wrapper = _theming.styled.div(function (_ref) {
	  var theme = _ref.theme,
	      bordered = _ref.bordered;
	  return bordered ? {
	    backgroundClip: 'padding-box',
	    border: "1px solid ".concat(theme.appBorderColor),
	    borderRadius: theme.appBorderRadius,
	    overflow: 'hidden'
	  } : {};
	}, function (_ref2) {
	  var absolute = _ref2.absolute;
	  return absolute ? {
	    width: '100%',
	    height: '100%',
	    boxSizing: 'border-box',
	    display: 'flex',
	    flexDirection: 'column'
	  } : {
	    display: 'block'
	  };
	});
	
	var TabBar = _theming.styled.div({
	  overflow: 'hidden',
	  '&:first-of-type': {
	    marginLeft: 0
	  }
	});
	
	exports.TabBar = TabBar;
	
	var Content = _theming.styled.div({
	  display: 'block',
	  position: 'relative'
	}, function (_ref3) {
	  var theme = _ref3.theme;
	  return {
	    fontSize: theme.typography.size.s2 - 1
	  };
	}, function (_ref4) {
	  var absolute = _ref4.absolute;
	  return absolute ? _defineProperty({
	    height: 'calc(100% - 40px)',
	    position: 'absolute',
	    left: 0,
	    right: 0,
	    bottom: 0,
	    top: 40,
	    overflow: 'auto'
	  }, "& > *:first-child".concat(ignoreSsrWarning), {
	    position: 'absolute',
	    left: 0,
	    right: 0,
	    bottom: 0,
	    top: 0,
	    height: '100%',
	    overflow: 'auto'
	  }) : {};
	});
	
	var VisuallyHidden = _theming.styled.div(function (_ref6) {
	  var active = _ref6.active;
	  return active ? {
	    display: 'block'
	  } : {
	    display: 'none'
	  };
	});
	
	var TabWrapper = function TabWrapper(_ref7) {
	  var active = _ref7.active,
	      render = _ref7.render,
	      children = _ref7.children;
	  return _react["default"].createElement(VisuallyHidden, {
	    active: active
	  }, render ? render() : children);
	};
	
	exports.TabWrapper = TabWrapper;
	TabWrapper.displayName = "TabWrapper";
	var panelProps = {
	  active: _propTypes["default"].bool
	};
	exports.panelProps = panelProps;
	
	var childrenToList = function childrenToList(children, selected) {
	  return _react.Children.toArray(children).map(function (_ref8, index) {
	    var _ref8$props = _ref8.props,
	        title = _ref8$props.title,
	        id = _ref8$props.id,
	        color = _ref8$props.color,
	        childrenOfChild = _ref8$props.children;
	    var content = Array.isArray(childrenOfChild) ? childrenOfChild[0] : childrenOfChild;
	    return {
	      active: selected ? id === selected : index === 0,
	      title: title,
	      id: id,
	      color: color,
	      render: typeof content === 'function' ? content : function (_ref9) {
	        var active = _ref9.active,
	            key = _ref9.key;
	        return _react["default"].createElement(VisuallyHidden, {
	          key: key,
	          active: active,
	          role: "tabpanel"
	        }, content);
	      }
	    };
	  });
	};
	
	var _ref13 =
	/*#__PURE__*/
	_react["default"].createElement(_placeholder.Placeholder, null, _react["default"].createElement(_react.Fragment, {
	  key: "title"
	}, "Nothing found"));
	
	var Tabs = _react["default"].memo(function (_ref10) {
	  var children = _ref10.children,
	      selected = _ref10.selected,
	      actions = _ref10.actions,
	      absolute = _ref10.absolute,
	      bordered = _ref10.bordered,
	      tools = _ref10.tools,
	      backgroundColor = _ref10.backgroundColor,
	      htmlId = _ref10.id;
	  var list = childrenToList(children, selected);
	  return list.length ? _react["default"].createElement(Wrapper, {
	    absolute: absolute,
	    bordered: bordered,
	    id: htmlId
	  }, _react["default"].createElement(_bar.FlexBar, {
	    border: true,
	    backgroundColor: backgroundColor
	  }, _react["default"].createElement(TabBar, {
	    role: "tablist"
	  }, list.map(function (_ref11) {
	    var title = _ref11.title,
	        id = _ref11.id,
	        active = _ref11.active,
	        color = _ref11.color;
	    return _react["default"].createElement(_button.TabButton, {
	      type: "button",
	      key: id,
	      active: active,
	      textColor: color,
	      onClick: function onClick(e) {
	        e.preventDefault();
	        actions.onSelect(id);
	      },
	      role: "tab"
	    }, typeof title === 'function' ? title() : title);
	  })), tools ? _react["default"].createElement(_react.Fragment, null, tools) : null), _react["default"].createElement(Content, {
	    absolute: absolute
	  }, list.map(function (_ref12) {
	    var id = _ref12.id,
	        active = _ref12.active,
	        render = _ref12.render;
	    return render({
	      key: id,
	      active: active
	    });
	  }))) : _ref13;
	});
	
	exports.Tabs = Tabs;
	Tabs.displayName = 'Tabs';
	Tabs.defaultProps = {
	  id: null,
	  children: null,
	  tools: null,
	  selected: null,
	  absolute: false,
	  bordered: false
	};
	
	var TabsState =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(TabsState, _Component);
	
	  function TabsState(props) {
	    var _this;
	
	    _classCallCheck(this, TabsState);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabsState).call(this, props));
	    _this.state = {
	      selected: props.initial
	    };
	    return _this;
	  }
	
	  _createClass(TabsState, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          _this$props$bordered = _this$props.bordered,
	          bordered = _this$props$bordered === void 0 ? false : _this$props$bordered,
	          _this$props$absolute = _this$props.absolute,
	          absolute = _this$props$absolute === void 0 ? false : _this$props$absolute,
	          children = _this$props.children,
	          backgroundColor = _this$props.backgroundColor;
	      var selected = this.state.selected;
	      return _react["default"].createElement(Tabs, {
	        bordered: bordered,
	        absolute: absolute,
	        selected: selected,
	        backgroundColor: backgroundColor,
	        actions: {
	          onSelect: function onSelect(id) {
	            return _this2.setState({
	              selected: id
	            });
	          }
	        }
	      }, children);
	    }
	  }]);
	
	  return TabsState;
	}(_react.Component);
	
	exports.TabsState = TabsState;
	TabsState.displayName = "TabsState";
	TabsState.defaultProps = {
	  children: [],
	  initial: null,
	  absolute: false,
	  bordered: false,
	  backgroundColor: ''
	};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	__webpack_require__(66);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _memoizerific = _interopRequireDefault(__webpack_require__(128));
	
	var _polished = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Title = (0, _theming.styled)(function (_ref) {
	  var active = _ref.active,
	      loading = _ref.loading,
	      disabled = _ref.disabled,
	      rest = _objectWithoutProperties(_ref, ["active", "loading", "disabled"]);
	
	  return _react["default"].createElement("span", rest);
	})(function (_ref2) {
	  var theme = _ref2.theme;
	  return {
	    color: theme.color.defaultText,
	    // Previously was theme.typography.weight.normal but this weight does not exists in Theme
	    fontWeight: theme.typography.weight.regular
	  };
	}, function (_ref3) {
	  var active = _ref3.active,
	      theme = _ref3.theme;
	  return active ? {
	    color: theme.color.primary,
	    fontWeight: theme.typography.weight.bold
	  } : {};
	}, function (_ref4) {
	  var loading = _ref4.loading,
	      theme = _ref4.theme;
	  return loading ? Object.assign({
	    display: 'inline-block',
	    flex: 'none'
	  }, theme.animation.inlineGlow) : {};
	}, function (_ref5) {
	  var disabled = _ref5.disabled,
	      theme = _ref5.theme;
	  return disabled ? {
	    color: (0, _polished.transparentize)(0.7, theme.color.defaultText)
	  } : {};
	});
	
	var Right = _theming.styled.span({
	  '& svg': {
	    transition: 'all 200ms ease-out',
	    opacity: '0',
	    height: '12px',
	    width: '12px',
	    margin: '3px 0',
	    verticalAlign: 'top'
	  },
	  '& path': {
	    fill: 'inherit'
	  }
	}, function (_ref6) {
	  var active = _ref6.active,
	      theme = _ref6.theme;
	  return active ? {
	    '& svg': {
	      opacity: 1
	    },
	    '& path': {
	      fill: theme.color.primary
	    }
	  } : {};
	});
	
	var Center = _theming.styled.span({
	  flex: 1,
	  textAlign: 'left',
	  display: 'inline-flex',
	  '& > * + *': {
	    paddingLeft: 10
	  }
	});
	
	var CenterText = _theming.styled.span({
	  flex: 1,
	  textAlign: 'center'
	}, function (_ref7) {
	  var active = _ref7.active,
	      theme = _ref7.theme;
	  return active ? {
	    color: theme.color.primary
	  } : {};
	}, function (_ref8) {
	  var theme = _ref8.theme,
	      disabled = _ref8.disabled;
	  return disabled ? {
	    color: theme.color.mediumdark
	  } : {};
	});
	
	var Left = _theming.styled.span(function (_ref9) {
	  var active = _ref9.active,
	      theme = _ref9.theme;
	  return active ? {
	    '& svg': {
	      opacity: 1
	    },
	    '& path': {
	      fill: theme.color.primary
	    }
	  } : {};
	});
	
	var Item = _theming.styled.a(function (_ref10) {
	  var theme = _ref10.theme;
	  return {
	    fontSize: theme.typography.size.s1,
	    transition: 'all 150ms ease-out',
	    color: (0, _polished.transparentize)(0.5, theme.color.defaultText),
	    textDecoration: 'none',
	    cursor: 'pointer',
	    justifyContent: 'space-between',
	    lineHeight: '18px',
	    padding: '7px 15px',
	    display: 'flex',
	    alignItems: 'center',
	    '& > * + *': {
	      paddingLeft: 10
	    },
	    '&:hover': {
	      background: theme.background.hoverable
	    },
	    '&:hover svg': {
	      opacity: 1
	    }
	  };
	}, function (_ref11) {
	  var disabled = _ref11.disabled;
	  return disabled ? {
	    cursor: 'not-allowed'
	  } : {};
	});
	
	var getItemProps = (0, _memoizerific["default"])(100)(function (onClick, href, LinkWrapper) {
	  var result = {};
	
	  if (onClick) {
	    Object.assign(result, {
	      onClick: onClick
	    });
	  }
	
	  if (href) {
	    Object.assign(result, {
	      href: href
	    });
	  }
	
	  if (LinkWrapper && href) {
	    Object.assign(result, {
	      to: href,
	      as: LinkWrapper
	    });
	  }
	
	  return result;
	});
	
	var ListItem = function ListItem(_ref12) {
	  var loading = _ref12.loading,
	      left = _ref12.left,
	      title = _ref12.title,
	      center = _ref12.center,
	      right = _ref12.right,
	      active = _ref12.active,
	      disabled = _ref12.disabled,
	      href = _ref12.href,
	      onClick = _ref12.onClick,
	      LinkWrapper = _ref12.LinkWrapper,
	      rest = _objectWithoutProperties(_ref12, ["loading", "left", "title", "center", "right", "active", "disabled", "href", "onClick", "LinkWrapper"]);
	
	  var itemProps = getItemProps(onClick, href, LinkWrapper);
	  var commonProps = {
	    active: active,
	    disabled: disabled
	  };
	  return _react["default"].createElement(Item, _extends({}, commonProps, rest, itemProps), left && _react["default"].createElement(Left, commonProps, left), title || center ? _react["default"].createElement(Center, null, title && _react["default"].createElement(Title, _extends({}, commonProps, {
	    loading: loading
	  }), title), center && _react["default"].createElement(CenterText, commonProps, center)) : null, right && _react["default"].createElement(Right, commonProps, right));
	};
	
	ListItem.displayName = "ListItem";
	ListItem.defaultProps = {
	  loading: false,
	  left: null,
	  title: _react["default"].createElement("span", null, "Loading state"),
	  center: null,
	  right: null,
	  active: false,
	  disabled: false,
	  href: null,
	  LinkWrapper: null,
	  onClick: null
	};
	var _default = ListItem;
	exports["default"] = _default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	__webpack_require__(343);
	
	__webpack_require__(345);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tooltip = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _memoizerific = _interopRequireDefault(__webpack_require__(128));
	
	var _theming = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var match = (0, _memoizerific["default"])(1000)(function (requestes, actual, value) {
	  var fallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	  return actual.split('-')[0] === requestes ? value : fallback;
	});
	var ArrowSpacing = 8;
	
	var Arrow = _theming.styled.div({
	  position: 'absolute',
	  borderStyle: 'solid'
	}, function (_ref) {
	  var theme = _ref.theme,
	      color = _ref.color,
	      placement = _ref.placement;
	  return {
	    marginBottom: "".concat(match('top', placement, '0', ArrowSpacing), "px"),
	    marginTop: "".concat(match('bottom', placement, '0', ArrowSpacing), "px"),
	    marginRight: "".concat(match('left', placement, '0', ArrowSpacing), "px"),
	    marginLeft: "".concat(match('right', placement, '0', ArrowSpacing), "px"),
	    bottom: "".concat(match('top', placement, ArrowSpacing * -1, 'auto'), "px"),
	    top: "".concat(match('bottom', placement, ArrowSpacing * -1, 'auto'), "px"),
	    right: "".concat(match('left', placement, ArrowSpacing * -1, 'auto'), "px"),
	    left: "".concat(match('right', placement, ArrowSpacing * -1, 'auto'), "px"),
	    borderBottomWidth: "".concat(match('top', placement, '0', ArrowSpacing), "px"),
	    borderTopWidth: "".concat(match('bottom', placement, '0', ArrowSpacing), "px"),
	    borderRightWidth: "".concat(match('left', placement, '0', ArrowSpacing), "px"),
	    borderLeftWidth: "".concat(match('right', placement, '0', ArrowSpacing), "px"),
	    borderTopColor: match('top', placement, theme.color[color] || color || theme.base === 'light' ? (0, _theming.lighten)(theme.background.app) : (0, _theming.darken)(theme.background.app), 'transparent'),
	    borderBottomColor: match('bottom', placement, theme.color[color] || color || theme.base === 'light' ? (0, _theming.lighten)(theme.background.app) : (0, _theming.darken)(theme.background.app), 'transparent'),
	    borderLeftColor: match('left', placement, theme.color[color] || color || theme.base === 'light' ? (0, _theming.lighten)(theme.background.app) : (0, _theming.darken)(theme.background.app), 'transparent'),
	    borderRightColor: match('right', placement, theme.color[color] || color || theme.base === 'light' ? (0, _theming.lighten)(theme.background.app) : (0, _theming.darken)(theme.background.app), 'transparent')
	  };
	});
	
	var Wrapper = _theming.styled.div(function (_ref2) {
	  var hidden = _ref2.hidden;
	  return {
	    display: hidden ? 'none' : 'inline-block',
	    zIndex: 2147483647
	  };
	}, function (_ref3) {
	  var theme = _ref3.theme,
	      color = _ref3.color,
	      hasChrome = _ref3.hasChrome,
	      placement = _ref3.placement;
	  return hasChrome ? {
	    marginBottom: "".concat(match('top', placement, ArrowSpacing + 2, 0), "px"),
	    marginTop: "".concat(match('bottom', placement, ArrowSpacing + 2, 0), "px"),
	    marginLeft: "".concat(match('right', placement, ArrowSpacing + 2, 0), "px"),
	    marginRight: "".concat(match('left', placement, ArrowSpacing + 2, 0), "px"),
	    background: theme.color[color] || color || theme.base === 'light' ? (0, _theming.lighten)(theme.background.app) : (0, _theming.darken)(theme.background.app),
	    filter: "\n            drop-shadow(0px 5px 5px rgba(0,0,0,0.05))\n            drop-shadow(0 1px 3px rgba(0,0,0,0.1))\n          ",
	    borderRadius: theme.appBorderRadius * 2,
	    fontSize: theme.typography.size.s1
	  } : {
	    marginBottom: "".concat(match('top', placement, 8, 0), "px"),
	    marginTop: "".concat(match('bottom', placement, 8, 0), "px"),
	    marginLeft: "".concat(match('right', placement, 8, 0), "px"),
	    marginRight: "".concat(match('left', placement, 8, 0), "px")
	  };
	});
	
	var Tooltip = function Tooltip(_ref4) {
	  var placement = _ref4.placement,
	      hasChrome = _ref4.hasChrome,
	      children = _ref4.children,
	      arrowProps = _ref4.arrowProps,
	      tooltipRef = _ref4.tooltipRef,
	      arrowRef = _ref4.arrowRef,
	      color = _ref4.color,
	      props = _objectWithoutProperties(_ref4, ["placement", "hasChrome", "children", "arrowProps", "tooltipRef", "arrowRef", "color"]);
	
	  return _react["default"].createElement(Wrapper, _extends({
	    hasChrome: hasChrome,
	    placement: placement,
	    ref: tooltipRef
	  }, props, {
	    color: color
	  }), hasChrome && _react["default"].createElement(Arrow, _extends({
	    placement: placement,
	    ref: arrowRef
	  }, arrowProps, {
	    color: color
	  })), children);
	};
	
	exports.Tooltip = Tooltip;
	Tooltip.displayName = "Tooltip";
	Tooltip.defaultProps = {
	  color: undefined,
	  arrowRef: undefined,
	  tooltipRef: undefined,
	  hasChrome: true,
	  placement: 'top',
	  arrowProps: {}
	};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(49);
	
	__webpack_require__(9);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TooltipLinkList = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _ListItem = _interopRequireDefault(__webpack_require__(519));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var List = _theming.styled.div({
	  minWidth: 180,
	  overflow: 'hidden',
	  overflowY: 'auto',
	  maxHeight: 10.5 * 32 // 10.5 items
	
	}, function (_ref) {
	  var theme = _ref.theme;
	  return {
	    borderRadius: theme.appBorderRadius * 2
	  };
	});
	
	var TooltipLinkList = function TooltipLinkList(_ref2) {
	  var links = _ref2.links,
	      LinkWrapper = _ref2.LinkWrapper;
	  return _react["default"].createElement(List, null, links.map(function (_ref3) {
	    var id = _ref3.id,
	        title = _ref3.title,
	        href = _ref3.href,
	        onClick = _ref3.onClick,
	        active = _ref3.active,
	        isGatsby = _ref3.isGatsby,
	        props = _objectWithoutProperties(_ref3, ["id", "title", "href", "onClick", "active", "isGatsby"]);
	
	    return _react["default"].createElement(_ListItem["default"], _extends({
	      key: id || title,
	      title: title,
	      onClick: onClick,
	      active: active,
	      href: href,
	      LinkWrapper: isGatsby ? LinkWrapper : null
	    }, props));
	  }));
	};
	
	exports.TooltipLinkList = TooltipLinkList;
	TooltipLinkList.displayName = "TooltipLinkList";
	TooltipLinkList.defaultProps = {
	  LinkWrapper: _ListItem["default"].defaultProps.LinkWrapper
	};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(49);
	
	__webpack_require__(63);
	
	__webpack_require__(9);
	
	__webpack_require__(64);
	
	__webpack_require__(3);
	
	__webpack_require__(65);
	
	__webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TooltipMessage = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _link = __webpack_require__(312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _templateObject5() {
	  var data = _taggedTemplateLiteral(["\n  padding: 15px;\n  width: 280px;\n  box-sizing: border-box;\n"]);
	
	  _templateObject5 = function _templateObject5() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject4() {
	  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  line-height: 18px;\n"]);
	
	  _templateObject4 = function _templateObject4() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject3() {
	  var data = _taggedTemplateLiteral(["\n  margin-top: 8px;\n  text-align: center;\n\n  > * {\n    margin: 0 8px;\n    font-weight: ", ";\n  }\n"]);
	
	  _templateObject3 = function _templateObject3() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject2() {
	  var data = _taggedTemplateLiteral([""]);
	
	  _templateObject2 = function _templateObject2() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Title = _theming.styled.div(_templateObject(), function (props) {
	  return props.theme.typography.weight.black;
	});
	
	var Desc = _theming.styled.span(_templateObject2());
	
	var Links = _theming.styled.div(_templateObject3(), function (props) {
	  return props.theme.typography.weight.black;
	});
	
	var Message = _theming.styled.div(_templateObject4(), function (props) {
	  return props.theme.color.darker;
	});
	
	var MessageWrapper = _theming.styled.div(_templateObject5());
	
	var TooltipMessage = function TooltipMessage(_ref) {
	  var title = _ref.title,
	      desc = _ref.desc,
	      links = _ref.links;
	  return _react["default"].createElement(MessageWrapper, null, _react["default"].createElement(Message, null, title && _react["default"].createElement(Title, null, title), desc && _react["default"].createElement(Desc, null, desc)), links && _react["default"].createElement(Links, null, links.map(function (_ref2) {
	    var linkTitle = _ref2.title,
	        other = _objectWithoutProperties(_ref2, ["title"]);
	
	    return _react["default"].createElement(_link.Link, _extends({}, other, {
	      key: linkTitle
	    }), linkTitle);
	  })));
	};
	
	exports.TooltipMessage = TooltipMessage;
	TooltipMessage.displayName = "TooltipMessage";
	TooltipMessage.defaultProps = {
	  title: null,
	  desc: null,
	  links: null
	};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(63);
	
	__webpack_require__(64);
	
	__webpack_require__(3);
	
	__webpack_require__(65);
	
	__webpack_require__(66);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TooltipNote = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  padding: 2px 6px;\n  line-height: 16px;\n  font-size: 10px;\n  font-weight: ", ";\n  color: ", ";\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: -1;\n  background: rgba(0, 0, 0, 0.4);\n  margin: 6px;\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Note = _theming.styled.div(_templateObject(), function (props) {
	  return props.theme.typography.weight.bold;
	}, function (props) {
	  return props.theme.color.lightest;
	});
	
	var TooltipNote = function TooltipNote(_ref) {
	  var note = _ref.note;
	  return _react["default"].createElement(Note, null, note);
	};
	
	exports.TooltipNote = TooltipNote;
	TooltipNote.displayName = "TooltipNote";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(8);
	
	__webpack_require__(51);
	
	__webpack_require__(68);
	
	__webpack_require__(153);
	
	__webpack_require__(549);
	
	__webpack_require__(11);
	
	__webpack_require__(62);
	
	__webpack_require__(48);
	
	__webpack_require__(63);
	
	__webpack_require__(9);
	
	__webpack_require__(64);
	
	__webpack_require__(3);
	
	__webpack_require__(65);
	
	__webpack_require__(30);
	
	__webpack_require__(7);
	
	__webpack_require__(50);
	
	__webpack_require__(67);
	
	__webpack_require__(155);
	
	__webpack_require__(69);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WithTooltip = exports.WithToolTipState = exports.WithTooltipPure = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _theming = __webpack_require__(5);
	
	var _clientLogger = __webpack_require__(138);
	
	var _global = __webpack_require__(56);
	
	var _reactPopperTooltip = _interopRequireDefault(__webpack_require__(443));
	
	var _Tooltip = __webpack_require__(520);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _templateObject2() {
	  var data = _taggedTemplateLiteral(["\n  cursor: ", ";\n"]);
	
	  _templateObject2 = function _templateObject2() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  cursor: ", ";\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// A target that doesn't speak popper
	var TargetContainer = _theming.styled.div(_templateObject(), function (props) {
	  return props.mode === 'hover' ? 'default' : 'pointer';
	});
	
	var TargetSvgContainer = _theming.styled.g(_templateObject2(), function (props) {
	  return props.mode === 'hover' ? 'default' : 'pointer';
	});
	
	// Pure, does not bind to the body
	var WithTooltipPure = function WithTooltipPure(_ref) {
	  var svg = _ref.svg,
	      trigger = _ref.trigger,
	      closeOnClick = _ref.closeOnClick,
	      placement = _ref.placement,
	      modifiers = _ref.modifiers,
	      hasChrome = _ref.hasChrome,
	      _tooltip = _ref.tooltip,
	      children = _ref.children,
	      tooltipShown = _ref.tooltipShown,
	      onVisibilityChange = _ref.onVisibilityChange,
	      props = _objectWithoutProperties(_ref, ["svg", "trigger", "closeOnClick", "placement", "modifiers", "hasChrome", "tooltip", "children", "tooltipShown", "onVisibilityChange"]);
	
	  var Container = svg ? TargetSvgContainer : TargetContainer;
	  return _react["default"].createElement(_reactPopperTooltip["default"], {
	    placement: placement,
	    trigger: trigger,
	    modifiers: modifiers,
	    tooltipShown: tooltipShown,
	    onVisibilityChange: onVisibilityChange,
	    tooltip: function tooltip(_ref2) {
	      var getTooltipProps = _ref2.getTooltipProps,
	          getArrowProps = _ref2.getArrowProps,
	          tooltipRef = _ref2.tooltipRef,
	          arrowRef = _ref2.arrowRef,
	          tooltipPlacement = _ref2.placement;
	      return _react["default"].createElement(_Tooltip.Tooltip, _extends({
	        hasChrome: hasChrome,
	        placement: tooltipPlacement,
	        tooltipRef: tooltipRef,
	        arrowRef: arrowRef,
	        arrowProps: getArrowProps()
	      }, getTooltipProps()), typeof _tooltip === 'function' ? _tooltip({
	        onHide: function onHide() {
	          return onVisibilityChange(false);
	        }
	      }) : _tooltip);
	    }
	  }, function (_ref3) {
	    var getTriggerProps = _ref3.getTriggerProps,
	        triggerRef = _ref3.triggerRef;
	    return (// @ts-ignore
	      _react["default"].createElement(Container, _extends({
	        ref: triggerRef
	      }, getTriggerProps(), props), children)
	    );
	  });
	};
	
	exports.WithTooltipPure = WithTooltipPure;
	WithTooltipPure.displayName = "WithTooltipPure";
	WithTooltipPure.defaultProps = {
	  svg: false,
	  trigger: 'hover',
	  closeOnClick: false,
	  placement: 'top',
	  modifiers: {},
	  hasChrome: true,
	  tooltipShown: false
	};
	
	var WithToolTipState = function WithToolTipState(_ref4) {
	  var startOpen = _ref4.startOpen,
	      rest = _objectWithoutProperties(_ref4, ["startOpen"]);
	
	  var _useState = (0, _react.useState)(startOpen || false),
	      _useState2 = _slicedToArray(_useState, 2),
	      tooltipShown = _useState2[0],
	      onVisibilityChange = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var hide = function hide() {
	      return onVisibilityChange(false);
	    };
	
	    _global.document.addEventListener('keydown', hide, false); // Find all iframes on the screen and bind to clicks inside them (waiting until the iframe is ready)
	
	
	    var iframes = Array.from(_global.document.getElementsByTagName('iframe'));
	    var unbinders = [];
	    iframes.forEach(function (iframe) {
	      var bind = function bind() {
	        try {
	          if (iframe.contentWindow.document) {
	            iframe.contentWindow.document.addEventListener('click', hide);
	            unbinders.push(function () {
	              try {
	                iframe.contentWindow.document.removeEventListener('click', hide);
	              } catch (e) {
	                _clientLogger.logger.warn('Removing a click listener from iframe failed: ', e);
	              }
	            });
	          }
	        } catch (e) {
	          _clientLogger.logger.warn('Adding a click listener to iframe failed: ', e);
	        }
	      };
	
	      bind(); // I don't know how to find out if it's already loaded so I potentially will bind twice
	
	      iframe.addEventListener('load', bind);
	      unbinders.push(function () {
	        iframe.removeEventListener('load', bind);
	      });
	    });
	    return function () {
	      _global.document.removeEventListener('keydown', hide);
	
	      unbinders.forEach(function (unbind) {
	        unbind();
	      });
	    };
	  });
	  return _react["default"].createElement(WithTooltipPure, _extends({}, rest, {
	    tooltipShown: tooltipShown,
	    onVisibilityChange: onVisibilityChange
	  }));
	};
	
	exports.WithTooltip = exports.WithToolTipState = WithToolTipState;
	WithToolTipState.displayName = "WithToolTipState";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(63);
	
	__webpack_require__(64);
	
	__webpack_require__(3);
	
	__webpack_require__(65);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DocumentWrapper = void 0;
	
	var _theming = __webpack_require__(5);
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n    /* Custom styles atop GitHub base theme (see below) */\n    font-size: ", "px;\n    line-height: 1.6;\n\n    h1 {\n      font-size: ", "px;\n      font-weight: ", ";\n    }\n\n    h2 {\n      font-size: ", "px;\n      border-bottom: 1px solid ", ";\n    }\n\n    h3 {\n      font-size: ", "px;\n    }\n\n    h4 {\n      font-size: ", "px;\n    }\n\n    h5 {\n      font-size: ", "px;\n    }\n\n    h6 {\n      font-size: ", "px;\n      color: ", ";\n    }\n\n    /* Custom for SB SyntaxHighlighter */\n\n    pre:not(.hljs) {\n      background: transparent;\n      border: none;\n      border-radius: 0;\n      padding: 0;\n      margin: 0;\n    }\n\n    pre pre,\n    pre.hljs {\n      padding: 15px;\n      margin: 0;\n\n      white-space: pre-wrap;\n      color: inherit;\n\n      font-size: 13px;\n      line-height: 19px;\n\n      code {\n        color: inherit;\n        font-size: inherit;\n      }\n    }\n\n    pre code {\n      margin: 0;\n      padding: 0;\n      white-space: pre;\n      border: none;\n      background: transparent;\n    }\n\n    pre code,\n    pre tt {\n      background-color: transparent;\n      border: none;\n    }\n\n    /* GitHub inspired Markdown styles loosely from https://gist.github.com/tuzz/3331384 */\n\n    body > *:first-of-type {\n      margin-top: 0 !important;\n    }\n\n    body > *:last-child {\n      margin-bottom: 0 !important;\n    }\n\n    a {\n      color: ", ";\n      text-decoration: none;\n    }\n\n    a.absent {\n      color: #cc0000;\n    }\n\n    a.anchor {\n      display: block;\n      padding-left: 30px;\n      margin-left: -30px;\n      cursor: pointer;\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      margin: 20px 0 10px;\n      padding: 0;\n      cursor: text;\n      position: relative;\n    }\n\n    h2:first-of-type,\n    h1:first-of-type,\n    h1:first-of-type + h2,\n    h3:first-of-type,\n    h4:first-of-type,\n    h5:first-of-type,\n    h6:first-of-type {\n      margin-top: 0;\n      padding-top: 0;\n    }\n\n    h1:hover a.anchor,\n    h2:hover a.anchor,\n    h3:hover a.anchor,\n    h4:hover a.anchor,\n    h5:hover a.anchor,\n    h6:hover a.anchor {\n      text-decoration: none;\n    }\n\n    h1 tt,\n    h1 code {\n      font-size: inherit;\n    }\n\n    h2 tt,\n    h2 code {\n      font-size: inherit;\n    }\n\n    h3 tt,\n    h3 code {\n      font-size: inherit;\n    }\n\n    h4 tt,\n    h4 code {\n      font-size: inherit;\n    }\n\n    h5 tt,\n    h5 code {\n      font-size: inherit;\n    }\n\n    h6 tt,\n    h6 code {\n      font-size: inherit;\n    }\n\n    p,\n    blockquote,\n    ul,\n    ol,\n    dl,\n    li,\n    table,\n    pre {\n      margin: 15px 0;\n    }\n\n    hr {\n      border: 0 none;\n      color: ", ";\n      height: 4px;\n      padding: 0;\n    }\n\n    body > h2:first-of-type {\n      margin-top: 0;\n      padding-top: 0;\n    }\n\n    body > h1:first-of-type {\n      margin-top: 0;\n      padding-top: 0;\n    }\n\n    body > h1:first-of-type + h2 {\n      margin-top: 0;\n      padding-top: 0;\n    }\n\n    body > h3:first-of-type,\n    body > h4:first-of-type,\n    body > h5:first-of-type,\n    body > h6:first-of-type {\n      margin-top: 0;\n      padding-top: 0;\n    }\n\n    a:first-of-type h1,\n    a:first-of-type h2,\n    a:first-of-type h3,\n    a:first-of-type h4,\n    a:first-of-type h5,\n    a:first-of-type h6 {\n      margin-top: 0;\n      padding-top: 0;\n    }\n\n    h1 p,\n    h2 p,\n    h3 p,\n    h4 p,\n    h5 p,\n    h6 p {\n      margin-top: 0;\n    }\n\n    li p.first {\n      display: inline-block;\n    }\n\n    ul,\n    ol {\n      padding-left: 30px;\n    }\n\n    ul :first-of-type,\n    ol :first-of-type {\n      margin-top: 0;\n    }\n\n    ul :last-child,\n    ol :last-child {\n      margin-bottom: 0;\n    }\n\n    dl {\n      padding: 0;\n    }\n\n    dl dt {\n      font-size: 14px;\n      font-weight: bold;\n      font-style: italic;\n      padding: 0;\n      margin: 15px 0 5px;\n    }\n\n    dl dt:first-of-type {\n      padding: 0;\n    }\n\n    dl dt > :first-of-type {\n      margin-top: 0;\n    }\n\n    dl dt > :last-child {\n      margin-bottom: 0;\n    }\n\n    dl dd {\n      margin: 0 0 15px;\n      padding: 0 15px;\n    }\n\n    dl dd > :first-of-type {\n      margin-top: 0;\n    }\n\n    dl dd > :last-child {\n      margin-bottom: 0;\n    }\n\n    blockquote {\n      border-left: 4px solid ", ";\n      padding: 0 15px;\n      color: ", ";\n    }\n\n    blockquote > :first-of-type {\n      margin-top: 0;\n    }\n\n    blockquote > :last-child {\n      margin-bottom: 0;\n    }\n\n    table {\n      padding: 0;\n      border-collapse: collapse;\n    }\n    table tr {\n      border-top: 1px solid ", ";\n      background-color: white;\n      margin: 0;\n      padding: 0;\n    }\n\n    table tr:nth-of-type(2n) {\n      background-color: ", ";\n    }\n\n    table tr th {\n      font-weight: bold;\n      border: 1px solid ", ";\n      text-align: left;\n      margin: 0;\n      padding: 6px 13px;\n    }\n\n    table tr td {\n      border: 1px solid ", ";\n      text-align: left;\n      margin: 0;\n      padding: 6px 13px;\n    }\n\n    table tr th :first-of-type,\n    table tr td :first-of-type {\n      margin-top: 0;\n    }\n\n    table tr th :last-child,\n    table tr td :last-child {\n      margin-bottom: 0;\n    }\n\n    img {\n      max-width: 100%;\n    }\n\n    span.frame {\n      display: block;\n      overflow: hidden;\n    }\n\n    span.frame > span {\n      border: 1px solid ", ";\n      display: block;\n      float: left;\n      overflow: hidden;\n      margin: 13px 0 0;\n      padding: 7px;\n      width: auto;\n    }\n\n    span.frame span img {\n      display: block;\n      float: left;\n    }\n\n    span.frame span span {\n      clear: both;\n      color: ", ";\n      display: block;\n      padding: 5px 0 0;\n    }\n\n    span.align-center {\n      display: block;\n      overflow: hidden;\n      clear: both;\n    }\n\n    span.align-center > span {\n      display: block;\n      overflow: hidden;\n      margin: 13px auto 0;\n      text-align: center;\n    }\n\n    span.align-center span img {\n      margin: 0 auto;\n      text-align: center;\n    }\n\n    span.align-right {\n      display: block;\n      overflow: hidden;\n      clear: both;\n    }\n\n    span.align-right > span {\n      display: block;\n      overflow: hidden;\n      margin: 13px 0 0;\n      text-align: right;\n    }\n\n    span.align-right span img {\n      margin: 0;\n      text-align: right;\n    }\n\n    span.float-left {\n      display: block;\n      margin-right: 13px;\n      overflow: hidden;\n      float: left;\n    }\n\n    span.float-left span {\n      margin: 13px 0 0;\n    }\n\n    span.float-right {\n      display: block;\n      margin-left: 13px;\n      overflow: hidden;\n      float: right;\n    }\n\n    span.float-right > span {\n      display: block;\n      overflow: hidden;\n      margin: 13px auto 0;\n      text-align: right;\n    }\n\n    code,\n    tt {\n      margin: 0 2px;\n      padding: 0 5px;\n      white-space: nowrap;\n      border: 1px solid ", ";\n      background-color: ", ";\n      border-radius: 3px;\n      color: ", ";\n    }\n  "]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DocumentWrapper = _theming.styled.div(function (_ref) {
	  var theme = _ref.theme;
	  return (0, _theming.css)(_templateObject(), theme.typography.size.s2, theme.typography.size.l1, theme.typography.weight.black, theme.typography.size.m2, theme.appBorderColor, theme.typography.size.m1, theme.typography.size.s3, theme.typography.size.s2, theme.typography.size.s2, theme.color.dark, theme.color.secondary, theme.appBorderColor, theme.color.medium, theme.color.dark, theme.appBorderColor, theme.color.lighter, theme.appBorderColor, theme.appBorderColor, theme.color.medium, theme.color.darkest, theme.color.mediumlight, theme.color.lighter, theme.base === 'dark' && theme.color.darkest);
	});
	
	exports.DocumentWrapper = DocumentWrapper;

/***/ }),
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(370);
	
	__webpack_require__(371);
	
	__webpack_require__(36);
	
	__webpack_require__(372);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animation = exports.easing = void 0;
	
	var _core = __webpack_require__(137);
	
	function _templateObject4() {
	  var data = _taggedTemplateLiteral(["\n  0%, 100% { transform:translate3d(0,0,0); }\n  12.5%, 62.5% { transform:translate3d(-4px,0,0); }\n  37.5%, 87.5% {  transform: translate3d(4px,0,0);  }\n"]);
	
	  _templateObject4 = function _templateObject4() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject3() {
	  var data = _taggedTemplateLiteral(["\n  0% { transform: translateY(1px); }\n  25% { transform: translateY(0px); }\n  50% { transform: translateY(-3px); }\n  100% { transform: translateY(1px); }\n"]);
	
	  _templateObject3 = function _templateObject3() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject2() {
	  var data = _taggedTemplateLiteral(["\n  0%, 100% { opacity: 1; }\n  50% { opacity: .4; }\n"]);
	
	  _templateObject2 = function _templateObject2() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var easing = {
	  rubber: 'cubic-bezier(0.175, 0.885, 0.335, 1.05)'
	};
	exports.easing = easing;
	var rotate360 = (0, _core.keyframes)(_templateObject());
	var glow = (0, _core.keyframes)(_templateObject2());
	
	var _float = (0, _core.keyframes)(_templateObject3());
	
	var jiggle = (0, _core.keyframes)(_templateObject4());
	var inlineGlow =
	/*#__PURE__*/
	(0, _core.css)("animation:", glow, " 1.5s ease-in-out infinite;color:transparent;cursor:progress;label:inlineGlow;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9hbmltYXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUNzQiIsImZpbGUiOiIuLi9zcmMvYW5pbWF0aW9uLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGNvbnN0IGVhc2luZyA9IHtcbiAgcnViYmVyOiAnY3ViaWMtYmV6aWVyKDAuMTc1LCAwLjg4NSwgMC4zMzUsIDEuMDUpJyxcbn07XG5cbmNvbnN0IHJvdGF0ZTM2MCA9IGtleWZyYW1lc2Bcblx0ZnJvbSB7XG5cdFx0dHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7XG5cdH1cblx0dG8ge1xuXHRcdHRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7XG5cdH1cbmA7XG5cbmNvbnN0IGdsb3cgPSBrZXlmcmFtZXNgXG4gIDAlLCAxMDAlIHsgb3BhY2l0eTogMTsgfVxuICA1MCUgeyBvcGFjaXR5OiAuNDsgfVxuYDtcblxuY29uc3QgZmxvYXQgPSBrZXlmcmFtZXNgXG4gIDAlIHsgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDFweCk7IH1cbiAgMjUlIHsgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDBweCk7IH1cbiAgNTAlIHsgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0zcHgpOyB9XG4gIDEwMCUgeyB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMXB4KTsgfVxuYDtcblxuY29uc3QgamlnZ2xlID0ga2V5ZnJhbWVzYFxuICAwJSwgMTAwJSB7IHRyYW5zZm9ybTp0cmFuc2xhdGUzZCgwLDAsMCk7IH1cbiAgMTIuNSUsIDYyLjUlIHsgdHJhbnNmb3JtOnRyYW5zbGF0ZTNkKC00cHgsMCwwKTsgfVxuICAzNy41JSwgODcuNSUgeyAgdHJhbnNmb3JtOiB0cmFuc2xhdGUzZCg0cHgsMCwwKTsgIH1cbmA7XG5cbmNvbnN0IGlubGluZUdsb3cgPSBjc3NgXG4gIGFuaW1hdGlvbjogJHtnbG93fSAxLjVzIGVhc2UtaW4tb3V0IGluZmluaXRlO1xuICBjb2xvcjogdHJhbnNwYXJlbnQ7XG4gIGN1cnNvcjogcHJvZ3Jlc3M7XG5gO1xuXG4vLyBob3ZlciAmIGFjdGl2ZSBzdGF0ZSBmb3IgbGlua3MgYW5kIGJ1dHRvbnNcbmNvbnN0IGhvdmVyYWJsZSA9IGNzc2BcbiAgdHJhbnNpdGlvbjogYWxsIDE1MG1zIGVhc2Utb3V0O1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZTNkKDAsIDAsIDApO1xuXG4gICY6aG92ZXIge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlM2QoMCwgLTJweCwgMCk7XG4gIH1cblxuICAmOmFjdGl2ZSB7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUzZCgwLCAwLCAwKTtcbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IGFuaW1hdGlvbiA9IHtcbiAgcm90YXRlMzYwLFxuICBnbG93LFxuICBmbG9hdCxcbiAgamlnZ2xlLFxuICBpbmxpbmVHbG93LFxuICBob3ZlcmFibGUsXG59O1xuIl19 */")); // hover & active state for links and buttons
	
	var hoverable =  true ? {
	  name: "1023qba-hoverable",
	  styles: "transition:all 150ms ease-out;transform:translate3d(0,0,0);&:hover{transform:translate3d(0,-2px,0);}&:active{transform:translate3d(0,0,0);}label:hoverable;"
	} : {
	  name: "1023qba-hoverable",
	  styles: "transition:all 150ms ease-out;transform:translate3d(0,0,0);&:hover{transform:translate3d(0,-2px,0);}&:active{transform:translate3d(0,0,0);}label:hoverable;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9hbmltYXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0NxQiIsImZpbGUiOiIuLi9zcmMvYW5pbWF0aW9uLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGNvbnN0IGVhc2luZyA9IHtcbiAgcnViYmVyOiAnY3ViaWMtYmV6aWVyKDAuMTc1LCAwLjg4NSwgMC4zMzUsIDEuMDUpJyxcbn07XG5cbmNvbnN0IHJvdGF0ZTM2MCA9IGtleWZyYW1lc2Bcblx0ZnJvbSB7XG5cdFx0dHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7XG5cdH1cblx0dG8ge1xuXHRcdHRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7XG5cdH1cbmA7XG5cbmNvbnN0IGdsb3cgPSBrZXlmcmFtZXNgXG4gIDAlLCAxMDAlIHsgb3BhY2l0eTogMTsgfVxuICA1MCUgeyBvcGFjaXR5OiAuNDsgfVxuYDtcblxuY29uc3QgZmxvYXQgPSBrZXlmcmFtZXNgXG4gIDAlIHsgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDFweCk7IH1cbiAgMjUlIHsgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDBweCk7IH1cbiAgNTAlIHsgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC0zcHgpOyB9XG4gIDEwMCUgeyB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMXB4KTsgfVxuYDtcblxuY29uc3QgamlnZ2xlID0ga2V5ZnJhbWVzYFxuICAwJSwgMTAwJSB7IHRyYW5zZm9ybTp0cmFuc2xhdGUzZCgwLDAsMCk7IH1cbiAgMTIuNSUsIDYyLjUlIHsgdHJhbnNmb3JtOnRyYW5zbGF0ZTNkKC00cHgsMCwwKTsgfVxuICAzNy41JSwgODcuNSUgeyAgdHJhbnNmb3JtOiB0cmFuc2xhdGUzZCg0cHgsMCwwKTsgIH1cbmA7XG5cbmNvbnN0IGlubGluZUdsb3cgPSBjc3NgXG4gIGFuaW1hdGlvbjogJHtnbG93fSAxLjVzIGVhc2UtaW4tb3V0IGluZmluaXRlO1xuICBjb2xvcjogdHJhbnNwYXJlbnQ7XG4gIGN1cnNvcjogcHJvZ3Jlc3M7XG5gO1xuXG4vLyBob3ZlciAmIGFjdGl2ZSBzdGF0ZSBmb3IgbGlua3MgYW5kIGJ1dHRvbnNcbmNvbnN0IGhvdmVyYWJsZSA9IGNzc2BcbiAgdHJhbnNpdGlvbjogYWxsIDE1MG1zIGVhc2Utb3V0O1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZTNkKDAsIDAsIDApO1xuXG4gICY6aG92ZXIge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlM2QoMCwgLTJweCwgMCk7XG4gIH1cblxuICAmOmFjdGl2ZSB7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUzZCgwLCAwLCAwKTtcbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IGFuaW1hdGlvbiA9IHtcbiAgcm90YXRlMzYwLFxuICBnbG93LFxuICBmbG9hdCxcbiAgamlnZ2xlLFxuICBpbmxpbmVHbG93LFxuICBob3ZlcmFibGUsXG59O1xuIl19 */"
	};
	var animation = {
	  rotate360: rotate360,
	  glow: glow,
	  "float": _float,
	  jiggle: jiggle,
	  inlineGlow: inlineGlow,
	  hoverable: hoverable
	};
	exports.animation = animation;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(166);
	
	__webpack_require__(36);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = exports.themes = void 0;
	
	var _light = _interopRequireDefault(__webpack_require__(215));
	
	var _dark = _interopRequireDefault(__webpack_require__(560));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// This generates theme variables in the correct shape for the UI
	var themes = {
	  light: _light["default"],
	  dark: _dark["default"],
	  normal: _light["default"]
	};
	exports.themes = themes;
	
	var create = function create() {
	  var vars = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    base: 'light'
	  };
	  var rest = arguments.length > 1 ? arguments[1] : undefined;
	  var inherit = Object.assign({}, themes.light, {}, themes[vars.base] || {}, {}, vars, {}, {
	    base: themes[vars.base] ? vars.base : 'light'
	  });
	  return Object.assign({}, rest, {}, inherit, {}, {
	    barSelectedColor: vars.barSelectedColor || inherit.colorSecondary
	  });
	};
	
	exports.create = create;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(370);
	
	__webpack_require__(371);
	
	__webpack_require__(36);
	
	__webpack_require__(372);
	
	__webpack_require__(226);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ensure = void 0;
	
	var _clientLogger = __webpack_require__(138);
	
	var _deepObjectDiff = __webpack_require__(752);
	
	var _commonTags = __webpack_require__(647);
	
	var _light = _interopRequireDefault(__webpack_require__(215));
	
	var _convert = __webpack_require__(347);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n          Your theme is missing properties, you should update your theme!\n\n          theme-data missing:\n        "]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ensure = function ensure(input) {
	  if (!input) {
	    return (0, _convert.convert)(_light["default"]);
	  }
	
	  var missing = (0, _deepObjectDiff.deletedDiff)(_light["default"], input);
	
	  if (Object.keys(missing).length) {
	    _clientLogger.logger.warn((0, _commonTags.stripIndent)(_templateObject()), missing);
	  }
	
	  return (0, _convert.convert)(input);
	};
	
	exports.ensure = ensure;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(166);
	
	__webpack_require__(36);
	
	__webpack_require__(592);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createGlobal = exports.createReset = void 0;
	
	var _memoizerific = _interopRequireDefault(__webpack_require__(128));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var createReset = (0, _memoizerific["default"])(1)(function (_ref) {
	  var typography = _ref.typography;
	  return {
	    body: {
	      fontFamily: typography.fonts.base,
	      fontSize: typography.size.s3,
	      margin: 0,
	      WebkitFontSmoothing: 'antialiased',
	      MozOsxFontSmoothing: 'grayscale',
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	      WebkitOverflowScrolling: 'touch'
	    },
	    '*': {
	      boxSizing: 'border-box'
	    },
	    'h1, h2, h3, h4, h5, h6': {
	      fontWeight: typography.weight.regular,
	      margin: 0,
	      padding: 0
	    },
	    'button, input, textarea, select': {
	      outline: 'none',
	      fontFamily: 'inherit',
	      fontSize: 'inherit',
	      boxSizing: 'border-box'
	    },
	    sub: {
	      fontSize: '0.8em',
	      bottom: '-0.2em'
	    },
	    sup: {
	      fontSize: '0.8em',
	      top: '-0.2em'
	    },
	    'b, em': {
	      fontWeight: typography.weight.bold
	    },
	    hr: {
	      border: 'none',
	      borderTop: '1px solid silver',
	      clear: 'both',
	      marginBottom: '1.25rem'
	    },
	    code: {
	      fontFamily: typography.fonts.mono,
	      WebkitFontSmoothing: 'antialiased',
	      MozOsxFontSmoothing: 'grayscale',
	      display: 'inline-block',
	      paddingLeft: 2,
	      paddingRight: 2,
	      verticalAlign: 'baseline',
	      color: 'inherit'
	    },
	    pre: {
	      fontFamily: typography.fonts.mono,
	      WebkitFontSmoothing: 'antialiased',
	      MozOsxFontSmoothing: 'grayscale',
	      lineHeight: '18px',
	      padding: '11px 1rem',
	      whiteSpace: 'pre-wrap',
	      color: 'inherit',
	      borderRadius: 3,
	      margin: '1rem 0'
	    }
	  };
	});
	exports.createReset = createReset;
	var createGlobal = (0, _memoizerific["default"])(1)(function (_ref2) {
	  var color = _ref2.color,
	      background = _ref2.background,
	      typography = _ref2.typography;
	  var resetStyles = createReset({
	    typography: typography
	  });
	  return Object.assign({}, resetStyles, {
	    body: Object.assign({}, resetStyles.body, {
	      color: color.defaultText,
	      background: background.app,
	      overflow: 'hidden'
	    }),
	    hr: Object.assign({}, resetStyles.hr, {
	      borderTop: "1px solid ".concat(color.border)
	    })
	  });
	});
	exports.createGlobal = createGlobal;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(227);
	
	__webpack_require__(375);
	
	__webpack_require__(376);
	
	__webpack_require__(588);
	
	__webpack_require__(225);
	
	__webpack_require__(590);
	
	__webpack_require__(166);
	
	__webpack_require__(36);
	
	__webpack_require__(591);
	
	__webpack_require__(373);
	
	__webpack_require__(374);
	
	__webpack_require__(377);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = exports.chromeLight = exports.chromeDark = void 0;
	
	var _utils = __webpack_require__(348);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var chromeDark = {
	  BASE_FONT_FAMILY: 'Menlo, monospace',
	  BASE_FONT_SIZE: '11px',
	  BASE_LINE_HEIGHT: 1.2,
	  BASE_BACKGROUND_COLOR: 'rgb(36, 36, 36)',
	  BASE_COLOR: 'rgb(213, 213, 213)',
	  OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10,
	  OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5,
	  OBJECT_NAME_COLOR: 'rgb(227, 110, 236)',
	  OBJECT_VALUE_NULL_COLOR: 'rgb(127, 127, 127)',
	  OBJECT_VALUE_UNDEFINED_COLOR: 'rgb(127, 127, 127)',
	  OBJECT_VALUE_REGEXP_COLOR: 'rgb(233, 63, 59)',
	  OBJECT_VALUE_STRING_COLOR: 'rgb(233, 63, 59)',
	  OBJECT_VALUE_SYMBOL_COLOR: 'rgb(233, 63, 59)',
	  OBJECT_VALUE_NUMBER_COLOR: 'hsl(252, 100%, 75%)',
	  OBJECT_VALUE_BOOLEAN_COLOR: 'hsl(252, 100%, 75%)',
	  OBJECT_VALUE_FUNCTION_PREFIX_COLOR: 'rgb(85, 106, 242)',
	  HTML_TAG_COLOR: 'rgb(93, 176, 215)',
	  HTML_TAGNAME_COLOR: 'rgb(93, 176, 215)',
	  HTML_TAGNAME_TEXT_TRANSFORM: 'lowercase',
	  HTML_ATTRIBUTE_NAME_COLOR: 'rgb(155, 187, 220)',
	  HTML_ATTRIBUTE_VALUE_COLOR: 'rgb(242, 151, 102)',
	  HTML_COMMENT_COLOR: 'rgb(137, 137, 137)',
	  HTML_DOCTYPE_COLOR: 'rgb(192, 192, 192)',
	  ARROW_COLOR: 'rgb(145, 145, 145)',
	  ARROW_MARGIN_RIGHT: 3,
	  ARROW_FONT_SIZE: 12,
	  ARROW_ANIMATION_DURATION: '0',
	  TREENODE_FONT_FAMILY: 'Menlo, monospace',
	  TREENODE_FONT_SIZE: '11px',
	  TREENODE_LINE_HEIGHT: 1.2,
	  TREENODE_PADDING_LEFT: 12,
	  TABLE_BORDER_COLOR: 'rgb(85, 85, 85)',
	  TABLE_TH_BACKGROUND_COLOR: 'rgb(44, 44, 44)',
	  TABLE_TH_HOVER_COLOR: 'rgb(48, 48, 48)',
	  TABLE_SORT_ICON_COLOR: 'black',
	  // 'rgb(48, 57, 66)',
	  TABLE_DATA_BACKGROUND_IMAGE: 'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 50%, rgba(51, 139, 255, 0.0980392) 50%, rgba(51, 139, 255, 0.0980392))',
	  TABLE_DATA_BACKGROUND_SIZE: '128px 32px'
	};
	exports.chromeDark = chromeDark;
	var chromeLight = {
	  BASE_FONT_FAMILY: 'Menlo, monospace',
	  BASE_FONT_SIZE: '11px',
	  BASE_LINE_HEIGHT: 1.2,
	  BASE_BACKGROUND_COLOR: 'white',
	  BASE_COLOR: 'black',
	  OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10,
	  OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5,
	  OBJECT_NAME_COLOR: 'rgb(136, 19, 145)',
	  OBJECT_VALUE_NULL_COLOR: 'rgb(128, 128, 128)',
	  OBJECT_VALUE_UNDEFINED_COLOR: 'rgb(128, 128, 128)',
	  OBJECT_VALUE_REGEXP_COLOR: 'rgb(196, 26, 22)',
	  OBJECT_VALUE_STRING_COLOR: 'rgb(196, 26, 22)',
	  OBJECT_VALUE_SYMBOL_COLOR: 'rgb(196, 26, 22)',
	  OBJECT_VALUE_NUMBER_COLOR: 'rgb(28, 0, 207)',
	  OBJECT_VALUE_BOOLEAN_COLOR: 'rgb(28, 0, 207)',
	  OBJECT_VALUE_FUNCTION_PREFIX_COLOR: 'rgb(13, 34, 170)',
	  HTML_TAG_COLOR: 'rgb(168, 148, 166)',
	  HTML_TAGNAME_COLOR: 'rgb(136, 18, 128)',
	  HTML_TAGNAME_TEXT_TRANSFORM: 'lowercase',
	  HTML_ATTRIBUTE_NAME_COLOR: 'rgb(153, 69, 0)',
	  HTML_ATTRIBUTE_VALUE_COLOR: 'rgb(26, 26, 166)',
	  HTML_COMMENT_COLOR: 'rgb(35, 110, 37)',
	  HTML_DOCTYPE_COLOR: 'rgb(192, 192, 192)',
	  ARROW_COLOR: '#6e6e6e',
	  ARROW_MARGIN_RIGHT: 3,
	  ARROW_FONT_SIZE: 12,
	  ARROW_ANIMATION_DURATION: '0',
	  TREENODE_FONT_FAMILY: 'Menlo, monospace',
	  TREENODE_FONT_SIZE: '11px',
	  TREENODE_LINE_HEIGHT: 1.2,
	  TREENODE_PADDING_LEFT: 12,
	  TABLE_BORDER_COLOR: '#aaa',
	  TABLE_TH_BACKGROUND_COLOR: '#eee',
	  TABLE_TH_HOVER_COLOR: 'hsla(0, 0%, 90%, 1)',
	  TABLE_SORT_ICON_COLOR: '#6e6e6e',
	  TABLE_DATA_BACKGROUND_IMAGE: 'linear-gradient(to bottom, white, white 50%, rgb(234, 243, 255) 50%, rgb(234, 243, 255))',
	  TABLE_DATA_BACKGROUND_SIZE: '128px 32px'
	};
	exports.chromeLight = chromeLight;
	
	var convertColors = function convertColors(colors) {
	  return Object.entries(colors).reduce(function (acc, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        k = _ref2[0],
	        v = _ref2[1];
	
	    return Object.assign({}, acc, _defineProperty({}, k, (0, _utils.mkColor)(v)));
	  }, {});
	};
	
	var create = function create(_ref3) {
	  var colors = _ref3.colors,
	      mono = _ref3.mono;
	  var colorsObjs = convertColors(colors);
	  return {
	    token: {
	      fontFamily: mono,
	      WebkitFontSmoothing: 'antialiased',
	      '&.comment': Object.assign({}, colorsObjs.green1, {
	        fontStyle: 'italic'
	      }),
	      '&.prolog': Object.assign({}, colorsObjs.green1, {
	        fontStyle: 'italic'
	      }),
	      '&.doctype': Object.assign({}, colorsObjs.green1, {
	        fontStyle: 'italic'
	      }),
	      '&.cdata': Object.assign({}, colorsObjs.green1, {
	        fontStyle: 'italic'
	      }),
	      '&.string': colorsObjs.red1,
	      '&.punctuation': colorsObjs.gray1,
	      '&.operator': colorsObjs.gray1,
	      '&.url': colorsObjs.cyan1,
	      '&.symbol': colorsObjs.cyan1,
	      '&.number': colorsObjs.cyan1,
	      '&.boolean': colorsObjs.cyan1,
	      '&.variable': colorsObjs.cyan1,
	      '&.constant': colorsObjs.cyan1,
	      '&.inserted': colorsObjs.cyan1,
	      '&.atrule': colorsObjs.blue1,
	      '&.keyword': colorsObjs.blue1,
	      '&.attr-value': colorsObjs.blue1,
	      '&.function': colorsObjs.gray1,
	      '&.deleted': colorsObjs.red2,
	      '&.important': {
	        fontWeight: 'bold'
	      },
	      '&.bold': {
	        fontWeight: 'bold'
	      },
	      '&.italic': {
	        fontStyle: 'italic'
	      },
	      '&.class-name': colorsObjs.cyan2,
	      '&.tag': colorsObjs.red3,
	      '&.selector': colorsObjs.red3,
	      '&.attr-name': colorsObjs.red4,
	      '&.property': colorsObjs.red4,
	      '&.regex': colorsObjs.red4,
	      '&.entity': colorsObjs.red4,
	      '&.directive.tag .tag': Object.assign({
	        background: '#ffff00'
	      }, colorsObjs.gray1)
	    },
	    'language-json .token.boolean': colorsObjs.blue1,
	    'language-json .token.number': colorsObjs.blue1,
	    'language-json .token.property': colorsObjs.cyan2,
	    namespace: {
	      opacity: 0.7
	    }
	  };
	};
	
	exports.create = create;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(36);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _base = __webpack_require__(156);
	
	var theme = {
	  base: 'dark',
	  // Storybook-specific color palette
	  colorPrimary: '#FF4785',
	  // coral
	  colorSecondary: '#1EA7FD',
	  // ocean
	  // UI
	  appBg: '#2f2f2f',
	  appContentBg: '#333',
	  appBorderColor: 'rgba(255,255,255,.1)',
	  appBorderRadius: 4,
	  // Fonts
	  fontBase: _base.typography.fonts.base,
	  fontCode: _base.typography.fonts.mono,
	  // Text colors
	  textColor: _base.color.lightest,
	  textInverseColor: _base.color.darkest,
	  // Toolbar default and active colors
	  barTextColor: '#999999',
	  barSelectedColor: _base.color.secondary,
	  barBg: _base.color.darkest,
	  // Form colors
	  inputBg: '#3f3f3f',
	  inputBorder: 'rgba(0,0,0,.3)',
	  inputTextColor: _base.color.lightest,
	  inputBorderRadius: 4
	};
	var _default = theme;
	exports["default"] = _default;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _global = __webpack_require__(56);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Nav = __webpack_require__(605);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _dropdown = __webpack_require__(604);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _Content = __webpack_require__(603);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	__webpack_require__(773);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getEditUrl = function getEditUrl(selectedSectionId, selectedItemId) {
	  var gitHubRepoUrl = 'https://github.com/storybookjs/storybook';
	  var docPath = selectedSectionId + '/' + selectedItemId;
	
	  return gitHubRepoUrl + '/blob/master/docs/src/pages/' + docPath + '/index.md';
	};
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search() {
	    _classCallCheck(this, Search);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Search.prototype.componentDidMount = function componentDidMount() {
	    _global.window.docsearch({
	      apiKey: 'a4f7f972f1d8f99a66e237e7fd2e489f',
	      indexName: 'storybook-js',
	      inputSelector: '#search',
	      debug: false
	    });
	  };
	
	  Search.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'search' },
	      _react2.default.createElement('input', {
	        className: 'form-control form-control-sm',
	        type: 'search',
	        id: 'search',
	        placeholder: 'type to search'
	      })
	    );
	  };
	
	  return Search;
	}(_react.Component);
	
	var Container = function Container(_ref) {
	  var sections = _ref.sections,
	      selectedItem = _ref.selectedItem,
	      selectedSectionId = _ref.selectedSectionId,
	      selectedItemId = _ref.selectedItemId;
	  return _react2.default.createElement(
	    'div',
	    { id: 'docs-container', className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'nav col-lg-3 col-md-3 d-none d-md-block' },
	      _react2.default.createElement(_Nav2.default, {
	        sections: sections,
	        selectedSection: selectedItem.section,
	        selectedItem: selectedItem.id,
	        selectedSectionId: selectedSectionId,
	        selectedItemId: selectedItemId
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content col-xs-12 col-sm-12 col-md-9 col-lg-9' },
	      _react2.default.createElement(
	        'div',
	        { className: 'nav-dropdown' },
	        _react2.default.createElement(_dropdown2.default, {
	          sections: sections,
	          selectedSection: selectedItem.section,
	          selectedItem: selectedItem.id
	        })
	      ),
	      _react2.default.createElement(Search, null),
	      _react2.default.createElement(_Content2.default, {
	        title: selectedItem.title,
	        content: selectedItem.content,
	        editUrl: getEditUrl(selectedSectionId, selectedItemId)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'nav-dropdown' },
	        _react2.default.createElement(_dropdown2.default, {
	          sections: sections,
	          selectedSection: selectedItem.section,
	          selectedItem: selectedItem.id
	        })
	      )
	    )
	  );
	};
	Container.propTypes = {
	  sections: _propTypes2.default.array, // eslint-disable-line
	  selectedItem: _propTypes2.default.object, // eslint-disable-line
	  selectedSectionId: _propTypes2.default.string.isRequired,
	  selectedItemId: _propTypes2.default.string.isRequired
	};
	
	exports.default = Container;
	module.exports = exports['default'];

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _components = __webpack_require__(515);
	
	var _theming = __webpack_require__(5);
	
	__webpack_require__(774);
	
	var _htmlReactParser = __webpack_require__(870);
	
	var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable consistent-return */
	
	
	var DocsContent = function DocsContent(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      editUrl = _ref.editUrl,
	      rest = _objectWithoutProperties(_ref, ['title', 'content', 'editUrl']);
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'docs-content' },
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'title' },
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          { className: 'edit-link', href: editUrl, target: '_blank', rel: 'noopener noreferrer' },
	          'Edit this page'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'markdown' },
	        _react2.default.createElement(
	          _theming.ThemeProvider,
	          { theme: (0, _theming.convert)((0, _theming.create)({ base: 'light' })) },
	          (0, _htmlReactParser2.default)(content, {
	            replace: function replace(domNode) {
	              if (domNode.name === 'pre' && domNode.children.find(function (n) {
	                return n.name === 'code' && n.attribs.class && n.attribs.class.match(/^language-/);
	              })) {
	                var language = domNode.children[0].attribs.class.replace('language-', '');
	                var code = domNode.children[0].children[0].data;
	                return _react2.default.createElement(
	                  _components.SyntaxHighlighter,
	                  { copyable: true, language: language },
	                  code
	                );
	              }
	            }
	          })
	        )
	      )
	    )
	  );
	};
	
	DocsContent.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  content: _propTypes2.default.string.isRequired,
	  editUrl: _propTypes2.default.string.isRequired
	};
	
	exports.default = DocsContent;
	module.exports = exports['default'];

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1064);
	
	__webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_React$Component) {
	  _inherits(Nav, _React$Component);
	
	  function Nav() {
	    _classCallCheck(this, Nav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args)));
	
	    _this.state = {};
	    return _this;
	  }
	
	  Nav.prototype.handleHeadingChange = function handleHeadingChange(event) {
	    var sections = this.props.sections;
	
	    var selectedSectionId = event.target.value;
	    var section = sections.find(function (s) {
	      return s.id === selectedSectionId;
	    });
	    var itemId = section.items[0].id;
	    this.changeRoute(selectedSectionId, itemId);
	  };
	
	  Nav.prototype.handleNavChange = function handleNavChange(event) {
	    var _props = this.props,
	        sections = _props.sections,
	        selectedSection = _props.selectedSection;
	
	    var selectedSectionId = selectedSection || sections[0].id;
	    this.changeRoute(selectedSectionId, event.target.value);
	  };
	
	  Nav.prototype.changeRoute = function changeRoute(selectedSectionId, selectedItemId) {
	    var url = '/' + selectedSectionId + '/' + selectedItemId + '/';
	    this.setState({ redirect: url });
	  };
	
	  Nav.prototype.renderNavOpts = function renderNavOpts(nav) {
	    return _react2.default.createElement(
	      'option',
	      { value: nav.id, key: nav.id },
	      nav.title
	    );
	  };
	
	  Nav.prototype.renderHeadingOpts = function renderHeadingOpts(section) {
	    return _react2.default.createElement(
	      'option',
	      { value: section.id, key: section.id },
	      section.heading
	    );
	  };
	
	  Nav.prototype.render = function render() {
	    var _this2 = this;
	
	    var redirect = this.state.redirect;
	    var _props2 = this.props,
	        sections = _props2.sections,
	        selectedSection = _props2.selectedSection,
	        selectedItem = _props2.selectedItem;
	
	    var selectedSectionId = selectedSection || sections[0].id;
	    var selectedItemId = selectedItem || sections[0].items[0].id;
	
	    var selectedSectionData = sections.find(function (section) {
	      return section.id === selectedSectionId;
	    });
	    var navs = selectedSectionData.items;
	
	    return redirect ? _react2.default.createElement(_reactRouter.Redirect, { to: redirect }) : _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'select',
	          {
	            className: 'custom-select custom-select-sm',
	            value: selectedSectionId,
	            onChange: function onChange(event) {
	              return _this2.handleHeadingChange(event);
	            }
	          },
	          sections.map(function (section) {
	            return _this2.renderHeadingOpts(section);
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'select',
	          {
	            className: 'custom-select custom-select-sm',
	            value: selectedItemId,
	            onChange: function onChange(event) {
	              return _this2.handleNavChange(event);
	            }
	          },
	          navs.map(function (nav) {
	            return _this2.renderNavOpts(nav);
	          })
	        )
	      )
	    );
	  };
	
	  return Nav;
	}(_react2.default.Component);
	
	Nav.propTypes = {
	  sections: _propTypes2.default.array, // eslint-disable-line
	  selectedSection: _propTypes2.default.string.isRequired,
	  selectedItem: _propTypes2.default.string.isRequired
	};
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(260);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nav = function Nav(_ref) {
	  var sections = _ref.sections,
	      selectedSectionId = _ref.selectedSectionId,
	      selectedItemId = _ref.selectedItemId;
	  return _react2.default.createElement(
	    'div',
	    { id: 'nav' },
	    sections.map(function (section) {
	      return _react2.default.createElement(
	        'div',
	        { key: section.id },
	        _react2.default.createElement(
	          'h3',
	          null,
	          section.heading
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          section.items.map(function (item) {
	            var cssClass = section.id === selectedSectionId && item.id === selectedItemId ? 'selected' : '';
	
	            var url = '/' + section.id + '/' + item.id + '/';
	
	            return _react2.default.createElement(
	              'li',
	              { key: item.id },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: cssClass, to: url },
	                item.title
	              )
	            );
	          })
	        )
	      );
	    })
	  );
	};
	Nav.propTypes = {
	  sections: _propTypes2.default.array, // eslint-disable-line
	  selectedSectionId: _propTypes2.default.string.isRequired,
	  selectedItemId: _propTypes2.default.string.isRequired
	};
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(274);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(622);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Container = __webpack_require__(602);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Footer = __webpack_require__(229);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(775);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Header from '../Header';
	var Docs = function Docs(_ref) {
	  var sections = _ref.sections,
	      selectedItem = _ref.selectedItem,
	      selectedSectionId = _ref.selectedSectionId,
	      selectedItemId = _ref.selectedItemId;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(_reactHelmet2.default, { title: '' + selectedItem.title }),
	    _react2.default.createElement(_Header2.default, { currentSection: 'docs' }),
	    _react2.default.createElement(_Container2.default, {
	      sections: sections,
	      selectedItem: selectedItem,
	      selectedSectionId: selectedSectionId,
	      selectedItemId: selectedItemId
	    }),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	Docs.propTypes = {
	  sections: _propTypes2.default.array, // eslint-disable-line
	  selectedItem: _propTypes2.default.object, // eslint-disable-line
	  selectedSectionId: _propTypes2.default.string.isRequired,
	  selectedItemId: _propTypes2.default.string.isRequired
	};
	
	exports.default = Docs;
	module.exports = exports['default'];

/***/ }),
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ListItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(54);
	
	var _animation = __webpack_require__(384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Left = _styledComponents2.default.span.withConfig({
	  displayName: 'ListItem__Left',
	  componentId: 'sc-1j89z7k-0'
	})(['']);
	var Title = _styledComponents2.default.span.withConfig({
	  displayName: 'ListItem__Title',
	  componentId: 'sc-1j89z7k-1'
	})(['font-weight:', ';'], _styles.typography.weight.bold);
	var Center = _styledComponents2.default.span.withConfig({
	  displayName: 'ListItem__Center',
	  componentId: 'sc-1j89z7k-2'
	})(['']);
	var Right = _styledComponents2.default.span.withConfig({
	  displayName: 'ListItem__Right',
	  componentId: 'sc-1j89z7k-3'
	})(['']);
	
	var ItemInner = _styledComponents2.default.span.withConfig({
	  displayName: 'ListItem__ItemInner',
	  componentId: 'sc-1j89z7k-4'
	})(['line-height:18px;padding:7px 15px;display:flex;align-items:center;', ',', ',', ',', '{display:inline-flex;}', ',', '{flex:1;}', ',', '{flex:0 1 auto;}', '{text-align:right;margin-left:20px;}'], Left, Title, Center, Right, Title, Center, Left, Right, Right);
	
	var Item = _styledComponents2.default.a.withConfig({
	  displayName: 'ListItem__Item',
	  componentId: 'sc-1j89z7k-5'
	})(['font-size:', 'px;transition:all 150ms ease-out;color:', ';text-decoration:none;display:block;&:not(:first-child){border-top:1px solid ', ';}', '{color:', ';}', ' svg{transition:all 200ms ease-out;opacity:0;height:12px;width:12px;margin:3px 0;vertical-align:top;path{fill:', ';}}&:hover{background:#e3f3ff;cursor:pointer;', ' svg{opacity:1;}}', ';', ';', ';'], _styles.typography.size.s1, _styles.color.mediumdark, _styles.color.mediumlight, Title, _styles.color.darker, Right, _styles.color.mediumdark, Right, function (props) {
	  return props.active && (0, _styledComponents.css)(['', '{font-weight:', ';}', ',', '{color:', ';}', ' svg{opacity:1;path{fill:', ';}}'], Title, _styles.typography.weight.extrabold, Title, Center, _styles.color.primary, Right, _styles.color.primary);
	}, function (props) {
	  return props.loading && (0, _styledComponents.css)(['', '{', ';flex:0;display:inline-block;}'], Title, _animation.inlineGlow);
	}, function (props) {
	  return props.disabled && (0, _styledComponents.css)(['cursor:not-allowed !important;', ',', '{color:', ';}'], Title, Center, _styles.color.mediumdark);
	});
	
	function ListItem(_ref) {
	  var loading = _ref.loading,
	      left = _ref.left,
	      title = _ref.title,
	      center = _ref.center,
	      right = _ref.right,
	      active = _ref.active,
	      disabled = _ref.disabled,
	      href = _ref.href,
	      onClick = _ref.onClick,
	      LinkWrapper = _ref.LinkWrapper,
	      props = _objectWithoutProperties(_ref, ['loading', 'left', 'title', 'center', 'right', 'active', 'disabled', 'href', 'onClick', 'LinkWrapper']);
	
	  var linkInner = _react2.default.createElement(
	    ItemInner,
	    { onClick: onClick, role: 'presentation' },
	    left && _react2.default.createElement(
	      Left,
	      null,
	      left
	    ),
	    title && _react2.default.createElement(
	      Title,
	      null,
	      title
	    ),
	    center && _react2.default.createElement(
	      Center,
	      null,
	      center
	    ),
	    right && _react2.default.createElement(
	      Right,
	      null,
	      right
	    )
	  );
	
	  return _react2.default.createElement(
	    Item,
	    _extends({
	      as: LinkWrapper && href ? LinkWrapper : null,
	      href: !LinkWrapper ? href : undefined,
	      to: LinkWrapper ? href : undefined,
	      active: active,
	      loading: loading,
	      disabled: disabled
	    }, props),
	    linkInner
	  );
	}
	
	ListItem.propTypes = {
	  loading: _propTypes2.default.bool,
	  left: _propTypes2.default.node,
	  title: _propTypes2.default.node,
	  center: _propTypes2.default.node,
	  right: _propTypes2.default.node,
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  href: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({})]),
	  LinkWrapper: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	};
	
	ListItem.defaultProps = {
	  loading: false,
	  left: null,
	  title: _react2.default.createElement(
	    'span',
	    null,
	    'Loading'
	  ),
	  center: null,
	  right: null,
	  active: false,
	  disabled: false,
	  href: null,
	  LinkWrapper: null,
	  onClick: null
	};
	module.exports = exports['default'];

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	// eslint-disable import/prefer-default-export
	
	var gitHubOrg = 'https://github.com/storybooks';
	var homepageUrl = 'https://storybook.js.org';
	var docsUrl = homepageUrl + '/docs';
	var npmApiBase = 'https://api.npmjs.org/downloads/point/last-month';
	
	var metadata = exports.metadata = {
	  title: 'Storybook',
	  description: 'Storybook is an open source tool for developing UI components in isolation for React, Vue, and Angular',
	  ogImage: '/images/social/open-graph.png',
	  googleSiteVerification: '',
	  latestVersion: 'v5.3'
	};
	
	var url = exports.url = {
	  gitHub: {
	    repo: gitHubOrg + '/storybook',
	    frontpage: gitHubOrg + '/frontpage',
	    issues: gitHubOrg + '/storybook/issues',
	    releases: gitHubOrg + '/storybook/releases',
	    contributors: gitHubOrg + '/storybook/graphs/contributors',
	    brand: gitHubOrg + '/press'
	  },
	
	  npm: 'https://www.npmjs.com/package/@storybook/react',
	  openCollective: 'https://opencollective.com/storybook',
	
	  npmApi: {
	    react: npmApiBase + '/@storybook/react',
	    reactNative: npmApiBase + '/@storybook/react-native',
	    vue: npmApiBase + '/@storybook/vue',
	    angular: npmApiBase + '/@storybook/angular',
	    ember: npmApiBase + '/@storybook/ember',
	    html: npmApiBase + '/@storybook/html',
	    svelte: npmApiBase + '/@storybook/svelte',
	    mithril: npmApiBase + '/@storybook/mithril',
	    marko: npmApiBase + '/@storybook/marko',
	    riot: npmApiBase + '/@storybook/riot',
	    polymer: npmApiBase + '/@storybook/polymer',
	    preact: npmApiBase + '/@storybook/preact'
	  },
	
	  // Navigation
	  home: '' + homepageUrl,
	  docs: {
	    home: docsUrl + '/basics/introduction/',
	    addonInstruction: docsUrl + '/addons/writing-addons/'
	  },
	  tutorials: 'https://www.learnstorybook.com/',
	  addons: homepageUrl + '/addons/',
	  community: homepageUrl + '/community/',
	  useCases: homepageUrl + '/use-cases/',
	  support: homepageUrl + '/support/',
	  team: homepageUrl + '/team/',
	
	  // Social
	  blog: 'https://medium.com/storybookjs',
	  twitter: 'https://twitter.com/storybookjs',
	  chat: 'https://discord.gg/UUt2PJb',
	  youtube: 'https://www.youtube.com/channel/UCr7Quur3eIyA_oe8FNYexfg',
	
	  // Brand
	  brand: gitHubOrg + '/brand',
	  designSystem: 'https://storybooks-official.netlify.com',
	  badge: gitHubOrg + '/brand/tree/master/badge',
	  presentation: gitHubOrg + '/brand/tree/master/presentation',
	  video: gitHubOrg + '/brand/tree/master/video',
	
	  // Framework docs
	  framework: {
	    react: docsUrl + '/guides/guide-react/',
	    reactNative: docsUrl + '/guides/guide-react-native/',
	    vue: docsUrl + '/guides/guide-vue/',
	    angular: docsUrl + '/guides/guide-angular/',
	    ember: docsUrl + '/guides/guide-ember/',
	    html: docsUrl + '/guides/guide-html/',
	    svelte: docsUrl + '/guides/guide-svelte/',
	    mithril: docsUrl + '/guides/guide-mithril/',
	    marko: docsUrl + '/guides/guide-marko/',
	    riot: docsUrl + '/guides/guide-riot/'
	  },
	
	  // Official addons
	  officialAddons: {
	    knobs: gitHubOrg + '/storybook/tree/master/addons/knobs',
	    actions: gitHubOrg + '/storybook/tree/master/addons/actions',
	    source: gitHubOrg + '/storybook/tree/master/addons/storysource',
	    info: gitHubOrg + '/storybook/tree/master/addons/info',
	    viewport: gitHubOrg + '/storybook/tree/master/addons/viewport',
	    storyshots: gitHubOrg + '/storybook/tree/master/addons/storyshots',
	    backgrounds: gitHubOrg + '/storybook/tree/master/addons/backgrounds',
	    accessibility: gitHubOrg + '/storybook/tree/master/addons/a11y',
	    console: gitHubOrg + '/storybook-addon-console',
	    links: gitHubOrg + '/storybook/tree/master/addons/links'
	  }
	};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Tooltip;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/prop-types */
	// Our wrapper around react-popper that does common stuff.
	
	var ifPlacementEquals = function ifPlacementEquals(placement, value) {
	  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  return function (props) {
	    return props['data-placement'].split('-')[0] === placement ? value : fallback;
	  };
	};
	
	var ArrowSpacing = 8;
	
	var Arrow = _styledComponents2.default.div.withConfig({
	  displayName: 'Tooltip__Arrow',
	  componentId: 'p4vqqa-0'
	})(['position:absolute;border-style:solid;margin-bottom:', 'px;margin-top:', 'px;margin-right:', 'px;margin-left:', 'px;bottom:', 'px;top:', 'px;right:', 'px;left:', 'px;border-bottom-width:', 'px;border-top-width:', 'px;border-right-width:', 'px;border-left-width:', 'px;border-top-color:', ';border-bottom-color:', ';border-left-color:', ';border-right-color:', ';'], ifPlacementEquals('top', '0', ArrowSpacing), ifPlacementEquals('bottom', '0', ArrowSpacing), ifPlacementEquals('left', '0', ArrowSpacing), ifPlacementEquals('right', '0', ArrowSpacing), ifPlacementEquals('top', ArrowSpacing * -1, 'auto'), ifPlacementEquals('bottom', ArrowSpacing * -1, 'auto'), ifPlacementEquals('left', ArrowSpacing * -1, 'auto'), ifPlacementEquals('right', ArrowSpacing * -1, 'auto'), ifPlacementEquals('top', '0', ArrowSpacing), ifPlacementEquals('bottom', '0', ArrowSpacing), ifPlacementEquals('left', '0', ArrowSpacing), ifPlacementEquals('right', '0', ArrowSpacing), ifPlacementEquals('top', 'white', 'transparent'), ifPlacementEquals('bottom', 'white', 'transparent'), ifPlacementEquals('left', 'white', 'transparent'), ifPlacementEquals('right', 'white', 'transparent'));
	
	var TooltipWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'Tooltip__TooltipWrapper',
	  componentId: 'p4vqqa-1'
	})(['display:', ';z-index:2147483647;', ';', ';'], function (props) {
	  return props.hidden ? 'none' : 'inline-block';
	}, function (props) {
	  return !props.hasChrome && (0, _styledComponents.css)(['margin-bottom:', 'px;margin-bottom:', 'px;margin-top:', 'px;margin-top:', 'px;margin-left:', 'px;margin-right:', 'px;'], ifPlacementEquals('top', 8), ifPlacementEquals('top-start', 8), ifPlacementEquals('bottom', 8), ifPlacementEquals('bottom-start', 8), ifPlacementEquals('right', 8), ifPlacementEquals('left', 8));
	}, function (props) {
	  return props.hasChrome && (0, _styledComponents.css)(['margin-bottom:', 'px;margin-top:', 'px;margin-left:', 'px;margin-right:', 'px;background-image:linear-gradient( -1deg,rgba(248,248,248,0.97) 0%,rgba(255,255,255,0.97) 100% );box-shadow:0 2px 5px 0 rgba(0,0,0,0.05),0 5px 15px 0 rgba(0,0,0,0.1);border-radius:4px;font-size:', 'px;'], ifPlacementEquals('top', ArrowSpacing + 2), ifPlacementEquals('bottom', ArrowSpacing + 2), ifPlacementEquals('right', ArrowSpacing + 2), ifPlacementEquals('left', ArrowSpacing + 2), _styles.typography.size.s1);
	});
	
	function Tooltip(_ref) {
	  var placement = _ref.placement,
	      hasChrome = _ref.hasChrome,
	      children = _ref.children,
	      arrowProps = _ref.arrowProps,
	      tooltipRef = _ref.tooltipRef,
	      arrowRef = _ref.arrowRef,
	      props = _objectWithoutProperties(_ref, ['placement', 'hasChrome', 'children', 'arrowProps', 'tooltipRef', 'arrowRef']);
	
	  return _react2.default.createElement(
	    TooltipWrapper,
	    _extends({ hasChrome: hasChrome, 'data-placement': placement, ref: tooltipRef }, props),
	    hasChrome && _react2.default.createElement(Arrow, _extends({ 'data-placement': placement, ref: arrowRef }, arrowProps)),
	    children
	  );
	}
	
	Tooltip.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  hasChrome: _propTypes2.default.bool,
	  /* eslint-disable-next-line */
	  arrowProps: _propTypes2.default.any,
	  placement: _propTypes2.default.string
	};
	Tooltip.defaultProps = {
	  hasChrome: true,
	  placement: 'top',
	  arrowProps: null
	};
	module.exports = exports['default'];

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ListItem = __webpack_require__(615);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var List = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipLinkList__List',
	  componentId: 'sc-60b2nd-0'
	})(['min-width:180px;overflow:hidden;overflow-y:auto;max-height:', ';'], 11.5 * 32 /* 11.5 items */);
	
	function TooltipLinkList(_ref) {
	  var links = _ref.links,
	      LinkWrapper = _ref.LinkWrapper;
	
	  return _react2.default.createElement(
	    List,
	    null,
	    links.map(function (_ref2, index) {
	      var title = _ref2.title,
	          href = _ref2.href,
	          onClick = _ref2.onClick,
	          active = _ref2.active,
	          isGatsby = _ref2.isGatsby,
	          props = _objectWithoutProperties(_ref2, ['title', 'href', 'onClick', 'active', 'isGatsby']);
	
	      return _react2.default.createElement(_ListItem2.default
	      /* eslint-disable react/no-array-index-key */
	      , _extends({ key: index,
	        title: title,
	        onClick: onClick,
	        active: active,
	        href: href,
	        LinkWrapper: isGatsby ? LinkWrapper : null
	      }, props));
	    })
	  );
	}
	
	TooltipLinkList.propTypes = {
	  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    title: _propTypes2.default.node.isRequired,
	    href: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({})]),
	    onClick: _propTypes2.default.func,
	    active: _propTypes2.default.bool
	  }).isRequired).isRequired,
	  LinkWrapper: _propTypes2.default.shape()
	};
	
	TooltipLinkList.defaultProps = {
	  LinkWrapper: _ListItem2.default.defaultProps.LinkWrapper
	};
	
	exports.default = TooltipLinkList;
	module.exports = exports['default'];

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(54);
	
	var _Link = __webpack_require__(382);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Title = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipMessage__Title',
	  componentId: 'sc-1502qvj-0'
	})(['font-weight:', ';'], _styles.typography.weight.black);
	
	var Desc = _styledComponents2.default.span.withConfig({
	  displayName: 'TooltipMessage__Desc',
	  componentId: 'sc-1502qvj-1'
	})(['']);
	
	var Links = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipMessage__Links',
	  componentId: 'sc-1502qvj-2'
	})(['margin-top:8px;text-align:center;> *{margin:0 8px;font-weight:', ';}'], _styles.typography.weight.black);
	
	var Message = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipMessage__Message',
	  componentId: 'sc-1502qvj-3'
	})(['color:', ';line-height:18px;'], _styles.color.darker);
	
	var MessageWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipMessage__MessageWrapper',
	  componentId: 'sc-1502qvj-4'
	})(['padding:15px;width:280px;box-sizing:border-box;']);
	
	function TooltipMessage(_ref) {
	  var title = _ref.title,
	      desc = _ref.desc,
	      links = _ref.links;
	
	  return _react2.default.createElement(
	    MessageWrapper,
	    null,
	    _react2.default.createElement(
	      Message,
	      null,
	      title && _react2.default.createElement(
	        Title,
	        null,
	        title
	      ),
	      desc && _react2.default.createElement(
	        Desc,
	        null,
	        desc
	      )
	    ),
	    links && _react2.default.createElement(
	      Links,
	      null,
	      links.map(function (_ref2) {
	        var linkTitle = _ref2.title,
	            other = _objectWithoutProperties(_ref2, ['title']);
	
	        return _react2.default.createElement(
	          _Link2.default,
	          _extends({}, other, { key: linkTitle }),
	          linkTitle
	        );
	      })
	    )
	  );
	}
	
	TooltipMessage.propTypes = {
	  title: _propTypes2.default.node,
	  desc: _propTypes2.default.node,
	  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    title: _propTypes2.default.string.isRequired
	  }))
	};
	
	TooltipMessage.defaultProps = {
	  title: null,
	  desc: null,
	  links: null
	};
	
	exports.default = TooltipMessage;
	module.exports = exports['default'];

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = TooltipNote;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Note = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipNote__Note',
	  componentId: 'sc-1to16c6-0'
	})(['padding:2px 6px;line-height:16px;font-size:10px;font-weight:', ';color:', ';box-shadow:0 0 5px 0 rgba(0,0,0,0.3);border-radius:4px;white-space:nowrap;pointer-events:none;z-index:-1;background:rgba(0,0,0,0.4);margin:6px;'], _styles.typography.weight.bold, _styles.color.lightest);
	
	function TooltipNote(_ref) {
	  var note = _ref.note;
	
	  return _react2.default.createElement(
	    Note,
	    null,
	    note
	  );
	}
	
	TooltipNote.propTypes = {
	  note: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactPopperTooltip = __webpack_require__(443);
	
	var _reactPopperTooltip2 = _interopRequireDefault(_reactPopperTooltip);
	
	var _Tooltip = __webpack_require__(617);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/prop-types */
	
	
	// A target that doesn't speak popper
	// prettier-ignore
	var TargetContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'WithTooltip__TargetContainer',
	  componentId: 'sc-1cbux8z-0'
	})(['display:inline-block;cursor:', ';'], function (props) {
	  return props.mode === 'hover' ? 'default' : 'pointer';
	});
	
	var TargetSvgContainer = _styledComponents2.default.g.withConfig({
	  displayName: 'WithTooltip__TargetSvgContainer',
	  componentId: 'sc-1cbux8z-1'
	})(['cursor:', ';'], function (props) {
	  return props.mode === 'hover' ? 'default' : 'pointer';
	});
	
	function WithTooltip(_ref) {
	  var svg = _ref.svg,
	      trigger = _ref.trigger,
	      closeOnClick = _ref.closeOnClick,
	      placement = _ref.placement,
	      modifiers = _ref.modifiers,
	      hasChrome = _ref.hasChrome,
	      _tooltip = _ref.tooltip,
	      children = _ref.children,
	      startOpen = _ref.startOpen,
	      props = _objectWithoutProperties(_ref, ['svg', 'trigger', 'closeOnClick', 'placement', 'modifiers', 'hasChrome', 'tooltip', 'children', 'startOpen']);
	
	  var _useState = (0, _react.useState)(startOpen),
	      tooltipShown = _useState[0],
	      onVisibilityChange = _useState[1];
	
	  var Container = svg ? TargetSvgContainer : TargetContainer;
	  return _react2.default.createElement(
	    _reactPopperTooltip2.default,
	    {
	      placement: placement,
	      trigger: trigger,
	      tooltipShown: tooltipShown,
	      onVisibilityChange: onVisibilityChange,
	      modifiers: modifiers,
	      tooltip: function tooltip(_ref2) {
	        var getTooltipProps = _ref2.getTooltipProps,
	            getArrowProps = _ref2.getArrowProps,
	            tooltipRef = _ref2.tooltipRef,
	            arrowRef = _ref2.arrowRef,
	            tooltipPlacement = _ref2.placement;
	        return _react2.default.createElement(
	          _Tooltip2.default,
	          _extends({
	            hasChrome: hasChrome,
	            placement: tooltipPlacement,
	            tooltipRef: tooltipRef,
	            arrowRef: arrowRef,
	            arrowProps: getArrowProps()
	          }, getTooltipProps()),
	          typeof _tooltip === 'function' ? _tooltip({ onHide: function onHide() {
	              return onVisibilityChange(false);
	            } }) : _tooltip
	        );
	      }
	    },
	    function (_ref3) {
	      var getTriggerProps = _ref3.getTriggerProps,
	          triggerRef = _ref3.triggerRef;
	      return _react2.default.createElement(
	        Container,
	        _extends({ ref: triggerRef }, getTriggerProps(), props),
	        children
	      );
	    }
	  );
	}
	
	WithTooltip.propTypes = {
	  svg: _propTypes2.default.bool,
	  trigger: _propTypes2.default.string,
	  closeOnClick: _propTypes2.default.bool,
	  placement: _propTypes2.default.string,
	  modifiers: _propTypes2.default.shape({}),
	  hasChrome: _propTypes2.default.bool,
	  tooltip: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]).isRequired,
	  children: _propTypes2.default.node.isRequired,
	  onVisibilityChange: _propTypes2.default.func.isRequired
	};
	
	WithTooltip.defaultProps = {
	  svg: false,
	  trigger: 'hover',
	  closeOnClick: false,
	  placement: 'top',
	  modifiers: {},
	  hasChrome: true
	};
	
	exports.default = WithTooltip;
	module.exports = exports['default'];

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Header;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(34);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _global = __webpack_require__(385);
	
	var _basics = __webpack_require__(383);
	
	var _PageLayout = __webpack_require__(623);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var color = _basics.styles.color,
	    typography = _basics.styles.typography,
	    spacing = _basics.styles.spacing,
	    breakpoint = _basics.styles.breakpoint;
	var metadata = _basics.site.metadata,
	    url = _basics.site.url;
	
	
	var LogotypeWrapper = _styledComponents2.default.a.withConfig({
	  displayName: 'Header__LogotypeWrapper',
	  componentId: 'sc-1ozrtv-0'
	})(['display:inline-block;img{height:22px;width:auto;margin-top:14px;@media (min-width:', 'px){height:26px;margin-top:10px;}display:block;}'], breakpoint);
	
	var Version = (0, _styledComponents2.default)(_basics.Link).withConfig({
	  displayName: 'Header__Version',
	  componentId: 'sc-1ozrtv-1'
	})(['display:inline-block;vertical-align:top;margin-left:10px;position:relative;top:2px;font-size:', 'px;color:', ';'], typography.size.s1, color.mediumdark);
	
	var TooltipLinkListWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__TooltipLinkListWrapper',
	  componentId: 'sc-1ozrtv-2'
	})(['padding:8px 5px;color:', ';'], color.darkest);
	
	var NavLink = (0, _styledComponents2.default)(_basics.Link).withConfig({
	  displayName: 'Header__NavLink',
	  componentId: 'sc-1ozrtv-3'
	})(['font-size:', 'px;font-weight:', ';'], typography.size.s2, typography.weight.bold);
	
	var Menu = (0, _styledComponents2.default)(_basics.Link).withConfig({
	  displayName: 'Header__Menu',
	  componentId: 'sc-1ozrtv-4'
	})(['width:3rem;height:3rem;border:none !important;text-decoration:none !important;background:none !important;text-align:right;display:flex;align-items:center;justify-content:flex-end;svg{vertical-align:top;height:1rem;width:1rem;margin:0;}']);
	
	var MobileMenu = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__MobileMenu',
	  componentId: 'sc-1ozrtv-5'
	})(['font-size:', 'px;', '{padding:5px 0;}'], typography.size.s1, TooltipLinkListWrapper);
	
	var NavItem = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__NavItem',
	  componentId: 'sc-1ozrtv-6'
	})(['display:inline-block;line-height:3rem;height:3rem;vertical-align:top;', ';', ';'], function (props) {
	  return props.showDesktop && (0, _styledComponents.css)(['display:none;@media (min-width:', 'px){display:inline-block;}'], breakpoint * 1.333);
	}, function (props) {
	  return props.showMobile && (0, _styledComponents.css)(['@media (min-width:', 'px){display:none;}'], breakpoint * 1.333);
	});
	
	var NavGroup = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__NavGroup',
	  componentId: 'sc-1ozrtv-7'
	})(['position:absolute;top:0;left:0;z-index:1;', ' ', ' + ', '{margin-left:', 'px;}'], function (props) {
	  return props.right && (0, _styledComponents.css)(['left:auto;right:0;']);
	}, NavItem, NavItem, spacing.padding.large);
	
	var Nav = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__Nav',
	  componentId: 'sc-1ozrtv-8'
	})(['height:3rem;position:relative;text-align:center;z-index:3;display:flex;']);
	
	var NavWrapper = _styledComponents2.default.nav.withConfig({
	  displayName: 'Header__NavWrapper',
	  componentId: 'sc-1ozrtv-9'
	})(['padding-top:12px;@media (min-width:', 'px){padding-top:36px;}'], breakpoint);
	
	function Header(_ref) {
	  var props = _objectWithoutProperties(_ref, []);
	
	  var mobileMenu = _react2.default.createElement(
	    MobileMenu,
	    null,
	    _react2.default.createElement(_basics.TooltipLinkList, { links: _PageLayout.navLinks })
	  );
	
	  return _react2.default.createElement(
	    NavWrapper,
	    props,
	    _react2.default.createElement(_global.GlobalStyle, null),
	    _react2.default.createElement(
	      Nav,
	      null,
	      _react2.default.createElement(
	        NavGroup,
	        null,
	        _react2.default.createElement(
	          NavItem,
	          null,
	          _react2.default.createElement(
	            LogotypeWrapper,
	            { href: '/' },
	            _react2.default.createElement('img', { src: 'https://storybook.js.org/images/logos/logo-storybook.svg', alt: 'Storybook' })
	          ),
	          _react2.default.createElement(
	            Version,
	            { href: url.gitHub.releases },
	            metadata.latestVersion
	          )
	        )
	      ),
	      _react2.default.createElement(
	        NavGroup,
	        { right: true },
	        _PageLayout.navLinks.map(function (_ref2) {
	          var title = _ref2.title,
	              href = _ref2.href,
	              isGatsby = _ref2.isGatsby;
	          return _react2.default.createElement(
	            NavItem,
	            { showDesktop: true, key: title },
	            _react2.default.createElement(
	              NavLink,
	              {
	                tertiary: 1,
	                href: !isGatsby ? href : undefined,
	                to: isGatsby ? href : undefined,
	                isGatsby: isGatsby
	              },
	              title
	            )
	          );
	        }),
	        _react2.default.createElement(
	          NavItem,
	          { showMobile: true },
	          _react2.default.createElement(
	            _basics.WithTooltip,
	            { placement: 'top', trigger: 'click', tooltip: mobileMenu },
	            _react2.default.createElement(
	              Menu,
	              { secondary: true, icon: 1, isButton: true },
	              _react2.default.createElement(_basics.Icon, { icon: 'menu' })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.navLinks = undefined;
	
	var _basics = __webpack_require__(383);
	
	var url = _basics.site.url;
	var navLinks = exports.navLinks = [{ title: 'Docs', href: url.docs.home, isGatsby: false }, { title: 'Tutorials', href: url.tutorials, isGatsby: false }, { title: 'Addons', href: url.addons, isGatsby: false }, { title: 'Community', href: url.community, isGatsby: false }, { title: 'Use cases', href: url.useCases, isGatsby: false }, { title: 'Support', href: url.support, isGatsby: false }, { title: 'Team', href: url.team, isGatsby: false }];

/***/ }),
/* 624 */,
/* 625 */,
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _capitalize = __webpack_require__(983);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _Docs = __webpack_require__(606);
	
	var _Docs2 = _interopRequireDefault(_Docs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var categories = [{
	  id: 'storybook',
	  title: 'Storybook'
	}];
	
	var getSections = function getSections(sections, edges) {
	  return Object.keys(sections).map(function (key) {
	    return {
	      id: key,
	      heading: (0, _capitalize2.default)(key),
	      items: sections[key].map(function (path) {
	        var page = edges.find(function (_ref) {
	          var node = _ref.node;
	          return node.fields.slug === path;
	        });
	        return page.node.frontmatter;
	      })
	    };
	  });
	};
	
	var getSelectedSection = function getSelectedSection(sections, path) {
	  return Object.keys(sections).find(function (key) {
	    return sections[key].indexOf(path) >= 0;
	  });
	};
	
	var DocsContainer = function DocsContainer(_ref2) {
	  var data = _ref2.data;
	  var site = data.site,
	      markdownRemark = data.markdownRemark,
	      allMarkdownRemark = data.allMarkdownRemark;
	  var frontmatter = markdownRemark.frontmatter,
	      fields = markdownRemark.fields,
	      html = markdownRemark.html;
	  var id = frontmatter.id,
	      title = frontmatter.title;
	  var slug = fields.slug;
	  var docSections = site.siteMetadata.docSections;
	
	
	  var section = getSelectedSection(docSections, slug);
	
	  var docProps = {
	    categories: categories,
	    sections: getSections(docSections, allMarkdownRemark.edges),
	    selectedItem: { id: id, title: title, section: section, content: html },
	    selectedSectionId: section,
	    selectedItemId: id
	  };
	
	  return _react2.default.createElement(_Docs2.default, docProps);
	};
	
	var nodeTypeShape = {
	  fields: _propTypes2.default.shape({
	    section: _propTypes2.default.string
	  }),
	  frontmatter: _propTypes2.default.shape({
	    title: _propTypes2.default.string,
	    id: _propTypes2.default.string
	  })
	};
	
	DocsContainer.propTypes = {
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        docsSections: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.string))
	      })
	    }),
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        node: _propTypes2.default.shape(nodeTypeShape)
	      }))
	    }),
	    markdownRemark: _propTypes2.default.shape(_extends({
	      html: _propTypes2.default.string
	    }, nodeTypeShape))
	  }).isRequired
	};
	DocsContainer.contextTypes = {
	  router: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = DocsContainer;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var comma = ','
	var space = ' '
	var empty = ''
	
	/* Parse comma-separated tokens to an array. */
	function parse(value) {
	  var values = []
	  var input = String(value || empty)
	  var index = input.indexOf(comma)
	  var lastIndex = 0
	  var end = false
	  var val
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length
	      end = true
	    }
	
	    val = input.slice(lastIndex, index).trim()
	
	    if (val || !end) {
	      values.push(val)
	    }
	
	    lastIndex = index + 1
	    index = input.indexOf(comma, lastIndex)
	  }
	
	  return values
	}
	
	/* Compile an array to comma-separated tokens.
	 * `options.padLeft` (default: `true`) pads a space left of each
	 * token, and `options.padRight` (default: `false`) pads a space
	 * to the right of each token. */
	function stringify(values, options) {
	  var settings = options || {}
	  var left = settings.padLeft === false ? empty : space
	  var right = settings.padRight ? space : empty
	
	  /* Ensure the last empty entry is seen. */
	  if (values[values.length - 1] === empty) {
	    values = values.concat(empty)
	  }
	
	  return values.join(right + comma + left).trim()
	}


/***/ }),
/* 638 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['', ''], ['', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class TemplateTag
	 * @classdesc Consumes a pipeline of composable transformer plugins and produces a template tag.
	 */
	var TemplateTag = function () {
	  /**
	   * constructs a template tag
	   * @constructs TemplateTag
	   * @param  {...Object} [...transformers] - an array or arguments list of transformers
	   * @return {Function}                    - a template tag
	   */
	  function TemplateTag() {
	    var _this = this;
	
	    for (var _len = arguments.length, transformers = Array(_len), _key = 0; _key < _len; _key++) {
	      transformers[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, TemplateTag);
	
	    this.tag = function (strings) {
	      for (var _len2 = arguments.length, expressions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        expressions[_key2 - 1] = arguments[_key2];
	      }
	
	      if (typeof strings === 'function') {
	        // if the first argument passed is a function, assume it is a template tag and return
	        // an intermediary tag that processes the template using the aforementioned tag, passing the
	        // result to our tag
	        return _this.interimTag.bind(_this, strings);
	      }
	
	      if (typeof strings === 'string') {
	        // if the first argument passed is a string, just transform it
	        return _this.transformEndResult(strings);
	      }
	
	      // else, return a transformed end result of processing the template with our tag
	      strings = strings.map(_this.transformString.bind(_this));
	      return _this.transformEndResult(strings.reduce(_this.processSubstitutions.bind(_this, expressions)));
	    };
	
	    // if first argument is an array, extrude it as a list of transformers
	    if (transformers.length > 0 && Array.isArray(transformers[0])) {
	      transformers = transformers[0];
	    }
	
	    // if any transformers are functions, this means they are not initiated - automatically initiate them
	    this.transformers = transformers.map(function (transformer) {
	      return typeof transformer === 'function' ? transformer() : transformer;
	    });
	
	    // return an ES2015 template tag
	    return this.tag;
	  }
	
	  /**
	   * Applies all transformers to a template literal tagged with this method.
	   * If a function is passed as the first argument, assumes the function is a template tag
	   * and applies it to the template, returning a template tag.
	   * @param  {(Function|String|Array<String>)} strings        - Either a template tag or an array containing template strings separated by identifier
	   * @param  {...*}                            ...expressions - Optional list of substitution values.
	   * @return {(String|Function)}                              - Either an intermediary tag function or the results of processing the template.
	   */
	
	
	  _createClass(TemplateTag, [{
	    key: 'interimTag',
	
	
	    /**
	     * An intermediary template tag that receives a template tag and passes the result of calling the template with the received
	     * template tag to our own template tag.
	     * @param  {Function}        nextTag          - the received template tag
	     * @param  {Array<String>}   template         - the template to process
	     * @param  {...*}            ...substitutions - `substitutions` is an array of all substitutions in the template
	     * @return {*}                                - the final processed value
	     */
	    value: function interimTag(previousTag, template) {
	      for (var _len3 = arguments.length, substitutions = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	        substitutions[_key3 - 2] = arguments[_key3];
	      }
	
	      return this.tag(_templateObject, previousTag.apply(undefined, [template].concat(substitutions)));
	    }
	
	    /**
	     * Performs bulk processing on the tagged template, transforming each substitution and then
	     * concatenating the resulting values into a string.
	     * @param  {Array<*>} substitutions - an array of all remaining substitutions present in this template
	     * @param  {String}   resultSoFar   - this iteration's result string so far
	     * @param  {String}   remainingPart - the template chunk after the current substitution
	     * @return {String}                 - the result of joining this iteration's processed substitution with the result
	     */
	
	  }, {
	    key: 'processSubstitutions',
	    value: function processSubstitutions(substitutions, resultSoFar, remainingPart) {
	      var substitution = this.transformSubstitution(substitutions.shift(), resultSoFar);
	      return ''.concat(resultSoFar, substitution, remainingPart);
	    }
	
	    /**
	     * Iterate through each transformer, applying the transformer's `onString` method to the template
	     * strings before all substitutions are processed.
	     * @param {String}  str - The input string
	     * @return {String}     - The final results of processing each transformer
	     */
	
	  }, {
	    key: 'transformString',
	    value: function transformString(str) {
	      var cb = function cb(res, transform) {
	        return transform.onString ? transform.onString(res) : res;
	      };
	      return this.transformers.reduce(cb, str);
	    }
	
	    /**
	     * When a substitution is encountered, iterates through each transformer and applies the transformer's
	     * `onSubstitution` method to the substitution.
	     * @param  {*}      substitution - The current substitution
	     * @param  {String} resultSoFar  - The result up to and excluding this substitution.
	     * @return {*}                   - The final result of applying all substitution transformations.
	     */
	
	  }, {
	    key: 'transformSubstitution',
	    value: function transformSubstitution(substitution, resultSoFar) {
	      var cb = function cb(res, transform) {
	        return transform.onSubstitution ? transform.onSubstitution(res, resultSoFar) : res;
	      };
	      return this.transformers.reduce(cb, substitution);
	    }
	
	    /**
	     * Iterates through each transformer, applying the transformer's `onEndResult` method to the
	     * template literal after all substitutions have finished processing.
	     * @param  {String} endResult - The processed template, just before it is returned from the tag
	     * @return {String}           - The final results of processing each transformer
	     */
	
	  }, {
	    key: 'transformEndResult',
	    value: function transformEndResult(endResult) {
	      var cb = function cb(res, transform) {
	        return transform.onEndResult ? transform.onEndResult(res) : res;
	      };
	      return this.transformers.reduce(cb, endResult);
	    }
	  }]);
	
	  return TemplateTag;
	}();
	
	exports.default = TemplateTag;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _html = __webpack_require__(233);
	
	var _html2 = _interopRequireDefault(_html);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _html2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb2RlQmxvY2svaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi4vaHRtbCc7XG4iXX0=

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(55);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commaLists = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',' }), _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = commaLists;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzL2NvbW1hTGlzdHMuanMiXSwibmFtZXMiOlsiY29tbWFMaXN0cyIsInNlcGFyYXRvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLGFBQWEsMEJBQ2pCLHNDQUF1QixFQUFFQyxXQUFXLEdBQWIsRUFBdkIsQ0FEaUIsb0VBQW5COztrQkFNZUQsVSIsImZpbGUiOiJjb21tYUxpc3RzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFRlbXBsYXRlVGFnIGZyb20gJy4uL1RlbXBsYXRlVGFnJztcbmltcG9ydCBzdHJpcEluZGVudFRyYW5zZm9ybWVyIGZyb20gJy4uL3N0cmlwSW5kZW50VHJhbnNmb3JtZXInO1xuaW1wb3J0IGlubGluZUFycmF5VHJhbnNmb3JtZXIgZnJvbSAnLi4vaW5saW5lQXJyYXlUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IGNvbW1hTGlzdHMgPSBuZXcgVGVtcGxhdGVUYWcoXG4gIGlubGluZUFycmF5VHJhbnNmb3JtZXIoeyBzZXBhcmF0b3I6ICcsJyB9KSxcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcixcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgY29tbWFMaXN0cztcbiJdfQ==

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _commaLists = __webpack_require__(640);
	
	var _commaLists2 = _interopRequireDefault(_commaLists);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _commaLists2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vY29tbWFMaXN0cyc7XG4iXX0=

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(55);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commaListsAnd = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',', conjunction: 'and' }), _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = commaListsAnd;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzQW5kL2NvbW1hTGlzdHNBbmQuanMiXSwibmFtZXMiOlsiY29tbWFMaXN0c0FuZCIsInNlcGFyYXRvciIsImNvbmp1bmN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBTUEsZ0JBQWdCLDBCQUNwQixzQ0FBdUIsRUFBRUMsV0FBVyxHQUFiLEVBQWtCQyxhQUFhLEtBQS9CLEVBQXZCLENBRG9CLG9FQUF0Qjs7a0JBTWVGLGEiLCJmaWxlIjoiY29tbWFMaXN0c0FuZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lciBmcm9tICcuLi9zdHJpcEluZGVudFRyYW5zZm9ybWVyJztcbmltcG9ydCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyIGZyb20gJy4uL2lubGluZUFycmF5VHJhbnNmb3JtZXInO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBjb21tYUxpc3RzQW5kID0gbmV3IFRlbXBsYXRlVGFnKFxuICBpbmxpbmVBcnJheVRyYW5zZm9ybWVyKHsgc2VwYXJhdG9yOiAnLCcsIGNvbmp1bmN0aW9uOiAnYW5kJyB9KSxcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcixcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgY29tbWFMaXN0c0FuZDtcbiJdfQ==

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _commaListsAnd = __webpack_require__(642);
	
	var _commaListsAnd2 = _interopRequireDefault(_commaListsAnd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _commaListsAnd2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzQW5kL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vY29tbWFMaXN0c0FuZCc7XG4iXX0=

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(55);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commaListsOr = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',', conjunction: 'or' }), _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = commaListsOr;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzT3IvY29tbWFMaXN0c09yLmpzIl0sIm5hbWVzIjpbImNvbW1hTGlzdHNPciIsInNlcGFyYXRvciIsImNvbmp1bmN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBTUEsZUFBZSwwQkFDbkIsc0NBQXVCLEVBQUVDLFdBQVcsR0FBYixFQUFrQkMsYUFBYSxJQUEvQixFQUF2QixDQURtQixvRUFBckI7O2tCQU1lRixZIiwiZmlsZSI6ImNvbW1hTGlzdHNPci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lciBmcm9tICcuLi9zdHJpcEluZGVudFRyYW5zZm9ybWVyJztcbmltcG9ydCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyIGZyb20gJy4uL2lubGluZUFycmF5VHJhbnNmb3JtZXInO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBjb21tYUxpc3RzT3IgPSBuZXcgVGVtcGxhdGVUYWcoXG4gIGlubGluZUFycmF5VHJhbnNmb3JtZXIoeyBzZXBhcmF0b3I6ICcsJywgY29uanVuY3Rpb246ICdvcicgfSksXG4gIHN0cmlwSW5kZW50VHJhbnNmb3JtZXIsXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbW1hTGlzdHNPcjtcbiJdfQ==

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _commaListsOr = __webpack_require__(644);
	
	var _commaListsOr2 = _interopRequireDefault(_commaListsOr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _commaListsOr2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYUxpc3RzT3IvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9jb21tYUxpc3RzT3InO1xuIl19

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(55);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _splitStringTransformer = __webpack_require__(234);
	
	var _splitStringTransformer2 = _interopRequireDefault(_splitStringTransformer);
	
	var _removeNonPrintingValuesTransformer = __webpack_require__(390);
	
	var _removeNonPrintingValuesTransformer2 = _interopRequireDefault(_removeNonPrintingValuesTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = new _TemplateTag2.default((0, _splitStringTransformer2.default)('\n'), _removeNonPrintingValuesTransformer2.default, _inlineArrayTransformer2.default, _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = html;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9odG1sL2h0bWwuanMiXSwibmFtZXMiOlsiaHRtbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxPQUFPLDBCQUNYLHNDQUF1QixJQUF2QixDQURXLG9KQUFiOztrQkFRZUEsSSIsImZpbGUiOiJodG1sLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFRlbXBsYXRlVGFnIGZyb20gJy4uL1RlbXBsYXRlVGFnJztcbmltcG9ydCBzdHJpcEluZGVudFRyYW5zZm9ybWVyIGZyb20gJy4uL3N0cmlwSW5kZW50VHJhbnNmb3JtZXInO1xuaW1wb3J0IGlubGluZUFycmF5VHJhbnNmb3JtZXIgZnJvbSAnLi4vaW5saW5lQXJyYXlUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgc3BsaXRTdHJpbmdUcmFuc2Zvcm1lciBmcm9tICcuLi9zcGxpdFN0cmluZ1RyYW5zZm9ybWVyJztcbmltcG9ydCByZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyIGZyb20gJy4uL3JlbW92ZU5vblByaW50aW5nVmFsdWVzVHJhbnNmb3JtZXInO1xuXG5jb25zdCBodG1sID0gbmV3IFRlbXBsYXRlVGFnKFxuICBzcGxpdFN0cmluZ1RyYW5zZm9ybWVyKCdcXG4nKSxcbiAgcmVtb3ZlTm9uUHJpbnRpbmdWYWx1ZXNUcmFuc2Zvcm1lcixcbiAgaW5saW5lQXJyYXlUcmFuc2Zvcm1lcixcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcixcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgaHRtbDtcbiJdfQ==

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripIndents = exports.stripIndent = exports.oneLineInlineLists = exports.inlineLists = exports.oneLineCommaListsAnd = exports.oneLineCommaListsOr = exports.oneLineCommaLists = exports.oneLineTrim = exports.oneLine = exports.safeHtml = exports.source = exports.codeBlock = exports.html = exports.commaListsOr = exports.commaListsAnd = exports.commaLists = exports.removeNonPrintingValuesTransformer = exports.splitStringTransformer = exports.inlineArrayTransformer = exports.replaceStringTransformer = exports.replaceSubstitutionTransformer = exports.replaceResultTransformer = exports.stripIndentTransformer = exports.trimResultTransformer = exports.TemplateTag = undefined;
	
	var _TemplateTag2 = __webpack_require__(18);
	
	var _TemplateTag3 = _interopRequireDefault(_TemplateTag2);
	
	var _trimResultTransformer2 = __webpack_require__(19);
	
	var _trimResultTransformer3 = _interopRequireDefault(_trimResultTransformer2);
	
	var _stripIndentTransformer2 = __webpack_require__(55);
	
	var _stripIndentTransformer3 = _interopRequireDefault(_stripIndentTransformer2);
	
	var _replaceResultTransformer2 = __webpack_require__(74);
	
	var _replaceResultTransformer3 = _interopRequireDefault(_replaceResultTransformer2);
	
	var _replaceSubstitutionTransformer2 = __webpack_require__(391);
	
	var _replaceSubstitutionTransformer3 = _interopRequireDefault(_replaceSubstitutionTransformer2);
	
	var _replaceStringTransformer2 = __webpack_require__(665);
	
	var _replaceStringTransformer3 = _interopRequireDefault(_replaceStringTransformer2);
	
	var _inlineArrayTransformer2 = __webpack_require__(37);
	
	var _inlineArrayTransformer3 = _interopRequireDefault(_inlineArrayTransformer2);
	
	var _splitStringTransformer2 = __webpack_require__(234);
	
	var _splitStringTransformer3 = _interopRequireDefault(_splitStringTransformer2);
	
	var _removeNonPrintingValuesTransformer2 = __webpack_require__(390);
	
	var _removeNonPrintingValuesTransformer3 = _interopRequireDefault(_removeNonPrintingValuesTransformer2);
	
	var _commaLists2 = __webpack_require__(641);
	
	var _commaLists3 = _interopRequireDefault(_commaLists2);
	
	var _commaListsAnd2 = __webpack_require__(643);
	
	var _commaListsAnd3 = _interopRequireDefault(_commaListsAnd2);
	
	var _commaListsOr2 = __webpack_require__(645);
	
	var _commaListsOr3 = _interopRequireDefault(_commaListsOr2);
	
	var _html2 = __webpack_require__(233);
	
	var _html3 = _interopRequireDefault(_html2);
	
	var _codeBlock2 = __webpack_require__(639);
	
	var _codeBlock3 = _interopRequireDefault(_codeBlock2);
	
	var _source2 = __webpack_require__(670);
	
	var _source3 = _interopRequireDefault(_source2);
	
	var _safeHtml2 = __webpack_require__(668);
	
	var _safeHtml3 = _interopRequireDefault(_safeHtml2);
	
	var _oneLine2 = __webpack_require__(651);
	
	var _oneLine3 = _interopRequireDefault(_oneLine2);
	
	var _oneLineTrim2 = __webpack_require__(661);
	
	var _oneLineTrim3 = _interopRequireDefault(_oneLineTrim2);
	
	var _oneLineCommaLists2 = __webpack_require__(653);
	
	var _oneLineCommaLists3 = _interopRequireDefault(_oneLineCommaLists2);
	
	var _oneLineCommaListsOr2 = __webpack_require__(657);
	
	var _oneLineCommaListsOr3 = _interopRequireDefault(_oneLineCommaListsOr2);
	
	var _oneLineCommaListsAnd2 = __webpack_require__(655);
	
	var _oneLineCommaListsAnd3 = _interopRequireDefault(_oneLineCommaListsAnd2);
	
	var _inlineLists2 = __webpack_require__(649);
	
	var _inlineLists3 = _interopRequireDefault(_inlineLists2);
	
	var _oneLineInlineLists2 = __webpack_require__(659);
	
	var _oneLineInlineLists3 = _interopRequireDefault(_oneLineInlineLists2);
	
	var _stripIndent2 = __webpack_require__(672);
	
	var _stripIndent3 = _interopRequireDefault(_stripIndent2);
	
	var _stripIndents2 = __webpack_require__(675);
	
	var _stripIndents3 = _interopRequireDefault(_stripIndents2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.TemplateTag = _TemplateTag3.default;
	
	// transformers
	// core
	
	exports.trimResultTransformer = _trimResultTransformer3.default;
	exports.stripIndentTransformer = _stripIndentTransformer3.default;
	exports.replaceResultTransformer = _replaceResultTransformer3.default;
	exports.replaceSubstitutionTransformer = _replaceSubstitutionTransformer3.default;
	exports.replaceStringTransformer = _replaceStringTransformer3.default;
	exports.inlineArrayTransformer = _inlineArrayTransformer3.default;
	exports.splitStringTransformer = _splitStringTransformer3.default;
	exports.removeNonPrintingValuesTransformer = _removeNonPrintingValuesTransformer3.default;
	
	// tags
	
	exports.commaLists = _commaLists3.default;
	exports.commaListsAnd = _commaListsAnd3.default;
	exports.commaListsOr = _commaListsOr3.default;
	exports.html = _html3.default;
	exports.codeBlock = _codeBlock3.default;
	exports.source = _source3.default;
	exports.safeHtml = _safeHtml3.default;
	exports.oneLine = _oneLine3.default;
	exports.oneLineTrim = _oneLineTrim3.default;
	exports.oneLineCommaLists = _oneLineCommaLists3.default;
	exports.oneLineCommaListsOr = _oneLineCommaListsOr3.default;
	exports.oneLineCommaListsAnd = _oneLineCommaListsAnd3.default;
	exports.inlineLists = _inlineLists3.default;
	exports.oneLineInlineLists = _oneLineInlineLists3.default;
	exports.stripIndent = _stripIndent3.default;
	exports.stripIndents = _stripIndents3.default;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaults = {
	  separator: '',
	  conjunction: '',
	  serial: false
	};
	
	/**
	 * Converts an array substitution to a string containing a list
	 * @param  {String} [opts.separator = ''] - the character that separates each item
	 * @param  {String} [opts.conjunction = '']  - replace the last separator with this
	 * @param  {Boolean} [opts.serial = false] - include the separator before the conjunction? (Oxford comma use-case)
	 *
	 * @return {Object}                     - a TemplateTag transformer
	 */
	var inlineArrayTransformer = function inlineArrayTransformer() {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults;
	  return {
	    onSubstitution: function onSubstitution(substitution, resultSoFar) {
	      // only operate on arrays
	      if (Array.isArray(substitution)) {
	        var arrayLength = substitution.length;
	        var separator = opts.separator;
	        var conjunction = opts.conjunction;
	        var serial = opts.serial;
	        // join each item in the array into a string where each item is separated by separator
	        // be sure to maintain indentation
	        var indent = resultSoFar.match(/(\n?[^\S\n]+)$/);
	        if (indent) {
	          substitution = substitution.join(separator + indent[1]);
	        } else {
	          substitution = substitution.join(separator + ' ');
	        }
	        // if conjunction is set, replace the last separator with conjunction, but only if there is more than one substitution
	        if (conjunction && arrayLength > 1) {
	          var separatorIndex = substitution.lastIndexOf(separator);
	          substitution = substitution.slice(0, separatorIndex) + (serial ? separator : '') + ' ' + conjunction + substitution.slice(separatorIndex + 1);
	        }
	      }
	      return substitution;
	    }
	  };
	};
	
	exports.default = inlineArrayTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmxpbmVBcnJheVRyYW5zZm9ybWVyL2lubGluZUFycmF5VHJhbnNmb3JtZXIuanMiXSwibmFtZXMiOlsiZGVmYXVsdHMiLCJzZXBhcmF0b3IiLCJjb25qdW5jdGlvbiIsInNlcmlhbCIsImlubGluZUFycmF5VHJhbnNmb3JtZXIiLCJvcHRzIiwib25TdWJzdGl0dXRpb24iLCJzdWJzdGl0dXRpb24iLCJyZXN1bHRTb0ZhciIsIkFycmF5IiwiaXNBcnJheSIsImFycmF5TGVuZ3RoIiwibGVuZ3RoIiwiaW5kZW50IiwibWF0Y2giLCJqb2luIiwic2VwYXJhdG9ySW5kZXgiLCJsYXN0SW5kZXhPZiIsInNsaWNlIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBLElBQU1BLFdBQVc7QUFDZkMsYUFBVyxFQURJO0FBRWZDLGVBQWEsRUFGRTtBQUdmQyxVQUFRO0FBSE8sQ0FBakI7O0FBTUE7Ozs7Ozs7O0FBUUEsSUFBTUMseUJBQXlCLFNBQXpCQSxzQkFBeUI7QUFBQSxNQUFDQyxJQUFELHVFQUFRTCxRQUFSO0FBQUEsU0FBc0I7QUFDbkRNLGtCQURtRCwwQkFDcENDLFlBRG9DLEVBQ3RCQyxXQURzQixFQUNUO0FBQ3hDO0FBQ0EsVUFBSUMsTUFBTUMsT0FBTixDQUFjSCxZQUFkLENBQUosRUFBaUM7QUFDL0IsWUFBTUksY0FBY0osYUFBYUssTUFBakM7QUFDQSxZQUFNWCxZQUFZSSxLQUFLSixTQUF2QjtBQUNBLFlBQU1DLGNBQWNHLEtBQUtILFdBQXpCO0FBQ0EsWUFBTUMsU0FBU0UsS0FBS0YsTUFBcEI7QUFDQTtBQUNBO0FBQ0EsWUFBTVUsU0FBU0wsWUFBWU0sS0FBWixDQUFrQixnQkFBbEIsQ0FBZjtBQUNBLFlBQUlELE1BQUosRUFBWTtBQUNWTix5QkFBZUEsYUFBYVEsSUFBYixDQUFrQmQsWUFBWVksT0FBTyxDQUFQLENBQTlCLENBQWY7QUFDRCxTQUZELE1BRU87QUFDTE4seUJBQWVBLGFBQWFRLElBQWIsQ0FBa0JkLFlBQVksR0FBOUIsQ0FBZjtBQUNEO0FBQ0Q7QUFDQSxZQUFJQyxlQUFlUyxjQUFjLENBQWpDLEVBQW9DO0FBQ2xDLGNBQU1LLGlCQUFpQlQsYUFBYVUsV0FBYixDQUF5QmhCLFNBQXpCLENBQXZCO0FBQ0FNLHlCQUNFQSxhQUFhVyxLQUFiLENBQW1CLENBQW5CLEVBQXNCRixjQUF0QixLQUNDYixTQUFTRixTQUFULEdBQXFCLEVBRHRCLElBRUEsR0FGQSxHQUdBQyxXQUhBLEdBSUFLLGFBQWFXLEtBQWIsQ0FBbUJGLGlCQUFpQixDQUFwQyxDQUxGO0FBTUQ7QUFDRjtBQUNELGFBQU9ULFlBQVA7QUFDRDtBQTVCa0QsR0FBdEI7QUFBQSxDQUEvQjs7a0JBK0JlSCxzQiIsImZpbGUiOiJpbmxpbmVBcnJheVRyYW5zZm9ybWVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgZGVmYXVsdHMgPSB7XG4gIHNlcGFyYXRvcjogJycsXG4gIGNvbmp1bmN0aW9uOiAnJyxcbiAgc2VyaWFsOiBmYWxzZSxcbn07XG5cbi8qKlxuICogQ29udmVydHMgYW4gYXJyYXkgc3Vic3RpdHV0aW9uIHRvIGEgc3RyaW5nIGNvbnRhaW5pbmcgYSBsaXN0XG4gKiBAcGFyYW0gIHtTdHJpbmd9IFtvcHRzLnNlcGFyYXRvciA9ICcnXSAtIHRoZSBjaGFyYWN0ZXIgdGhhdCBzZXBhcmF0ZXMgZWFjaCBpdGVtXG4gKiBAcGFyYW0gIHtTdHJpbmd9IFtvcHRzLmNvbmp1bmN0aW9uID0gJyddICAtIHJlcGxhY2UgdGhlIGxhc3Qgc2VwYXJhdG9yIHdpdGggdGhpc1xuICogQHBhcmFtICB7Qm9vbGVhbn0gW29wdHMuc2VyaWFsID0gZmFsc2VdIC0gaW5jbHVkZSB0aGUgc2VwYXJhdG9yIGJlZm9yZSB0aGUgY29uanVuY3Rpb24/IChPeGZvcmQgY29tbWEgdXNlLWNhc2UpXG4gKlxuICogQHJldHVybiB7T2JqZWN0fSAgICAgICAgICAgICAgICAgICAgIC0gYSBUZW1wbGF0ZVRhZyB0cmFuc2Zvcm1lclxuICovXG5jb25zdCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyID0gKG9wdHMgPSBkZWZhdWx0cykgPT4gKHtcbiAgb25TdWJzdGl0dXRpb24oc3Vic3RpdHV0aW9uLCByZXN1bHRTb0Zhcikge1xuICAgIC8vIG9ubHkgb3BlcmF0ZSBvbiBhcnJheXNcbiAgICBpZiAoQXJyYXkuaXNBcnJheShzdWJzdGl0dXRpb24pKSB7XG4gICAgICBjb25zdCBhcnJheUxlbmd0aCA9IHN1YnN0aXR1dGlvbi5sZW5ndGg7XG4gICAgICBjb25zdCBzZXBhcmF0b3IgPSBvcHRzLnNlcGFyYXRvcjtcbiAgICAgIGNvbnN0IGNvbmp1bmN0aW9uID0gb3B0cy5jb25qdW5jdGlvbjtcbiAgICAgIGNvbnN0IHNlcmlhbCA9IG9wdHMuc2VyaWFsO1xuICAgICAgLy8gam9pbiBlYWNoIGl0ZW0gaW4gdGhlIGFycmF5IGludG8gYSBzdHJpbmcgd2hlcmUgZWFjaCBpdGVtIGlzIHNlcGFyYXRlZCBieSBzZXBhcmF0b3JcbiAgICAgIC8vIGJlIHN1cmUgdG8gbWFpbnRhaW4gaW5kZW50YXRpb25cbiAgICAgIGNvbnN0IGluZGVudCA9IHJlc3VsdFNvRmFyLm1hdGNoKC8oXFxuP1teXFxTXFxuXSspJC8pO1xuICAgICAgaWYgKGluZGVudCkge1xuICAgICAgICBzdWJzdGl0dXRpb24gPSBzdWJzdGl0dXRpb24uam9pbihzZXBhcmF0b3IgKyBpbmRlbnRbMV0pO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgc3Vic3RpdHV0aW9uID0gc3Vic3RpdHV0aW9uLmpvaW4oc2VwYXJhdG9yICsgJyAnKTtcbiAgICAgIH1cbiAgICAgIC8vIGlmIGNvbmp1bmN0aW9uIGlzIHNldCwgcmVwbGFjZSB0aGUgbGFzdCBzZXBhcmF0b3Igd2l0aCBjb25qdW5jdGlvbiwgYnV0IG9ubHkgaWYgdGhlcmUgaXMgbW9yZSB0aGFuIG9uZSBzdWJzdGl0dXRpb25cbiAgICAgIGlmIChjb25qdW5jdGlvbiAmJiBhcnJheUxlbmd0aCA+IDEpIHtcbiAgICAgICAgY29uc3Qgc2VwYXJhdG9ySW5kZXggPSBzdWJzdGl0dXRpb24ubGFzdEluZGV4T2Yoc2VwYXJhdG9yKTtcbiAgICAgICAgc3Vic3RpdHV0aW9uID1cbiAgICAgICAgICBzdWJzdGl0dXRpb24uc2xpY2UoMCwgc2VwYXJhdG9ySW5kZXgpICtcbiAgICAgICAgICAoc2VyaWFsID8gc2VwYXJhdG9yIDogJycpICtcbiAgICAgICAgICAnICcgK1xuICAgICAgICAgIGNvbmp1bmN0aW9uICtcbiAgICAgICAgICBzdWJzdGl0dXRpb24uc2xpY2Uoc2VwYXJhdG9ySW5kZXggKyAxKTtcbiAgICAgIH1cbiAgICB9XG4gICAgcmV0dXJuIHN1YnN0aXR1dGlvbjtcbiAgfSxcbn0pO1xuXG5leHBvcnQgZGVmYXVsdCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyO1xuIl19

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _inlineLists = __webpack_require__(650);
	
	var _inlineLists2 = _interopRequireDefault(_inlineLists);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _inlineLists2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmxpbmVMaXN0cy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL2lubGluZUxpc3RzJztcbiJdfQ==

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(55);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inlineLists = new _TemplateTag2.default(_inlineArrayTransformer2.default, _stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = inlineLists;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmxpbmVMaXN0cy9pbmxpbmVMaXN0cy5qcyJdLCJuYW1lcyI6WyJpbmxpbmVMaXN0cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLGNBQWMsOEhBQXBCOztrQkFNZUEsVyIsImZpbGUiOiJpbmxpbmVMaXN0cy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lciBmcm9tICcuLi9zdHJpcEluZGVudFRyYW5zZm9ybWVyJztcbmltcG9ydCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyIGZyb20gJy4uL2lubGluZUFycmF5VHJhbnNmb3JtZXInO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBpbmxpbmVMaXN0cyA9IG5ldyBUZW1wbGF0ZVRhZyhcbiAgaW5saW5lQXJyYXlUcmFuc2Zvcm1lcixcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcixcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgaW5saW5lTGlzdHM7XG4iXX0=

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLine = __webpack_require__(652);
	
	var _oneLine2 = _interopRequireDefault(_oneLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLine2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vb25lTGluZSc7XG4iXX0=

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(74);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLine = new _TemplateTag2.default((0, _replaceResultTransformer2.default)(/(?:\n(?:\s*))+/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLine;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lL29uZUxpbmUuanMiXSwibmFtZXMiOlsib25lTGluZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxVQUFVLDBCQUNkLHdDQUF5QixpQkFBekIsRUFBNEMsR0FBNUMsQ0FEYyxrQ0FBaEI7O2tCQUtlQSxPIiwiZmlsZSI6Im9uZUxpbmUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuaW1wb3J0IHJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBvbmVMaW5lID0gbmV3IFRlbXBsYXRlVGFnKFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/Olxcbig/OlxccyopKSsvZywgJyAnKSxcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgb25lTGluZTtcbiJdfQ==

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineCommaLists = __webpack_require__(654);
	
	var _oneLineCommaLists2 = _interopRequireDefault(_oneLineCommaLists);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineCommaLists2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0cy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL29uZUxpbmVDb21tYUxpc3RzJztcbiJdfQ==

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(74);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineCommaLists = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',' }), (0, _replaceResultTransformer2.default)(/(?:\s+)/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLineCommaLists;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0cy9vbmVMaW5lQ29tbWFMaXN0cy5qcyJdLCJuYW1lcyI6WyJvbmVMaW5lQ29tbWFMaXN0cyIsInNlcGFyYXRvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLG9CQUFvQiwwQkFDeEIsc0NBQXVCLEVBQUVDLFdBQVcsR0FBYixFQUF2QixDQUR3QixFQUV4Qix3Q0FBeUIsVUFBekIsRUFBcUMsR0FBckMsQ0FGd0Isa0NBQTFCOztrQkFNZUQsaUIiLCJmaWxlIjoib25lTGluZUNvbW1hTGlzdHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IGlubGluZUFycmF5VHJhbnNmb3JtZXIgZnJvbSAnLi4vaW5saW5lQXJyYXlUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3JlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IG9uZUxpbmVDb21tYUxpc3RzID0gbmV3IFRlbXBsYXRlVGFnKFxuICBpbmxpbmVBcnJheVRyYW5zZm9ybWVyKHsgc2VwYXJhdG9yOiAnLCcgfSksXG4gIHJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lcigvKD86XFxzKykvZywgJyAnKSxcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgb25lTGluZUNvbW1hTGlzdHM7XG4iXX0=

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineCommaListsAnd = __webpack_require__(656);
	
	var _oneLineCommaListsAnd2 = _interopRequireDefault(_oneLineCommaListsAnd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineCommaListsAnd2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0c0FuZC9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL29uZUxpbmVDb21tYUxpc3RzQW5kJztcbiJdfQ==

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(74);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineCommaListsAnd = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',', conjunction: 'and' }), (0, _replaceResultTransformer2.default)(/(?:\s+)/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLineCommaListsAnd;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0c0FuZC9vbmVMaW5lQ29tbWFMaXN0c0FuZC5qcyJdLCJuYW1lcyI6WyJvbmVMaW5lQ29tbWFMaXN0c0FuZCIsInNlcGFyYXRvciIsImNvbmp1bmN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBTUEsdUJBQXVCLDBCQUMzQixzQ0FBdUIsRUFBRUMsV0FBVyxHQUFiLEVBQWtCQyxhQUFhLEtBQS9CLEVBQXZCLENBRDJCLEVBRTNCLHdDQUF5QixVQUF6QixFQUFxQyxHQUFyQyxDQUYyQixrQ0FBN0I7O2tCQU1lRixvQiIsImZpbGUiOiJvbmVMaW5lQ29tbWFMaXN0c0FuZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgaW5saW5lQXJyYXlUcmFuc2Zvcm1lciBmcm9tICcuLi9pbmxpbmVBcnJheVRyYW5zZm9ybWVyJztcbmltcG9ydCB0cmltUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vdHJpbVJlc3VsdFRyYW5zZm9ybWVyJztcbmltcG9ydCByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyJztcblxuY29uc3Qgb25lTGluZUNvbW1hTGlzdHNBbmQgPSBuZXcgVGVtcGxhdGVUYWcoXG4gIGlubGluZUFycmF5VHJhbnNmb3JtZXIoeyBzZXBhcmF0b3I6ICcsJywgY29uanVuY3Rpb246ICdhbmQnIH0pLFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/OlxccyspL2csICcgJyksXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IG9uZUxpbmVDb21tYUxpc3RzQW5kO1xuIl19

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineCommaListsOr = __webpack_require__(658);
	
	var _oneLineCommaListsOr2 = _interopRequireDefault(_oneLineCommaListsOr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineCommaListsOr2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0c09yL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUFBT0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZyb20gJy4vb25lTGluZUNvbW1hTGlzdHNPcic7XG4iXX0=

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(74);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineCommaListsOr = new _TemplateTag2.default((0, _inlineArrayTransformer2.default)({ separator: ',', conjunction: 'or' }), (0, _replaceResultTransformer2.default)(/(?:\s+)/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLineCommaListsOr;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lQ29tbWFMaXN0c09yL29uZUxpbmVDb21tYUxpc3RzT3IuanMiXSwibmFtZXMiOlsib25lTGluZUNvbW1hTGlzdHNPciIsInNlcGFyYXRvciIsImNvbmp1bmN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBTUEsc0JBQXNCLDBCQUMxQixzQ0FBdUIsRUFBRUMsV0FBVyxHQUFiLEVBQWtCQyxhQUFhLElBQS9CLEVBQXZCLENBRDBCLEVBRTFCLHdDQUF5QixVQUF6QixFQUFxQyxHQUFyQyxDQUYwQixrQ0FBNUI7O2tCQU1lRixtQiIsImZpbGUiOiJvbmVMaW5lQ29tbWFMaXN0c09yLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFRlbXBsYXRlVGFnIGZyb20gJy4uL1RlbXBsYXRlVGFnJztcbmltcG9ydCBpbmxpbmVBcnJheVRyYW5zZm9ybWVyIGZyb20gJy4uL2lubGluZUFycmF5VHJhbnNmb3JtZXInO1xuaW1wb3J0IHRyaW1SZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi90cmltUmVzdWx0VHJhbnNmb3JtZXInO1xuaW1wb3J0IHJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lciBmcm9tICcuLi9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXInO1xuXG5jb25zdCBvbmVMaW5lQ29tbWFMaXN0c09yID0gbmV3IFRlbXBsYXRlVGFnKFxuICBpbmxpbmVBcnJheVRyYW5zZm9ybWVyKHsgc2VwYXJhdG9yOiAnLCcsIGNvbmp1bmN0aW9uOiAnb3InIH0pLFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/OlxccyspL2csICcgJyksXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IG9uZUxpbmVDb21tYUxpc3RzT3I7XG4iXX0=

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineInlineLists = __webpack_require__(660);
	
	var _oneLineInlineLists2 = _interopRequireDefault(_oneLineInlineLists);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineInlineLists2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lSW5saW5lTGlzdHMvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9vbmVMaW5lSW5saW5lTGlzdHMnO1xuIl19

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(74);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineInlineLists = new _TemplateTag2.default(_inlineArrayTransformer2.default, (0, _replaceResultTransformer2.default)(/(?:\s+)/g, ' '), _trimResultTransformer2.default);
	
	exports.default = oneLineInlineLists;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lSW5saW5lTGlzdHMvb25lTGluZUlubGluZUxpc3RzLmpzIl0sIm5hbWVzIjpbIm9uZUxpbmVJbmxpbmVMaXN0cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLHFCQUFxQiw0REFFekIsd0NBQXlCLFVBQXpCLEVBQXFDLEdBQXJDLENBRnlCLGtDQUEzQjs7a0JBTWVBLGtCIiwiZmlsZSI6Im9uZUxpbmVJbmxpbmVMaXN0cy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgaW5saW5lQXJyYXlUcmFuc2Zvcm1lciBmcm9tICcuLi9pbmxpbmVBcnJheVRyYW5zZm9ybWVyJztcbmltcG9ydCB0cmltUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vdHJpbVJlc3VsdFRyYW5zZm9ybWVyJztcbmltcG9ydCByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyJztcblxuY29uc3Qgb25lTGluZUlubGluZUxpc3RzID0gbmV3IFRlbXBsYXRlVGFnKFxuICBpbmxpbmVBcnJheVRyYW5zZm9ybWVyLFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/OlxccyspL2csICcgJyksXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IG9uZUxpbmVJbmxpbmVMaXN0cztcbiJdfQ==

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _oneLineTrim = __webpack_require__(662);
	
	var _oneLineTrim2 = _interopRequireDefault(_oneLineTrim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _oneLineTrim2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lVHJpbS9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL29uZUxpbmVUcmltJztcbiJdfQ==

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _replaceResultTransformer = __webpack_require__(74);
	
	var _replaceResultTransformer2 = _interopRequireDefault(_replaceResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneLineTrim = new _TemplateTag2.default((0, _replaceResultTransformer2.default)(/(?:\n\s*)/g, ''), _trimResultTransformer2.default);
	
	exports.default = oneLineTrim;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vbmVMaW5lVHJpbS9vbmVMaW5lVHJpbS5qcyJdLCJuYW1lcyI6WyJvbmVMaW5lVHJpbSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxjQUFjLDBCQUNsQix3Q0FBeUIsWUFBekIsRUFBdUMsRUFBdkMsQ0FEa0Isa0NBQXBCOztrQkFLZUEsVyIsImZpbGUiOiJvbmVMaW5lVHJpbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZW1wbGF0ZVRhZyBmcm9tICcuLi9UZW1wbGF0ZVRhZyc7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3JlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IG9uZUxpbmVUcmltID0gbmV3IFRlbXBsYXRlVGFnKFxuICByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIoLyg/OlxcblxccyopL2csICcnKSxcbiAgdHJpbVJlc3VsdFRyYW5zZm9ybWVyLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgb25lTGluZVRyaW07XG4iXX0=

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isValidValue = function isValidValue(x) {
	  return x != null && !Number.isNaN(x) && typeof x !== 'boolean';
	};
	
	var removeNonPrintingValuesTransformer = function removeNonPrintingValuesTransformer() {
	  return {
	    onSubstitution: function onSubstitution(substitution) {
	      if (Array.isArray(substitution)) {
	        return substitution.filter(isValidValue);
	      }
	      if (isValidValue(substitution)) {
	        return substitution;
	      }
	      return '';
	    }
	  };
	};
	
	exports.default = removeNonPrintingValuesTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyL3JlbW92ZU5vblByaW50aW5nVmFsdWVzVHJhbnNmb3JtZXIuanMiXSwibmFtZXMiOlsiaXNWYWxpZFZhbHVlIiwieCIsIk51bWJlciIsImlzTmFOIiwicmVtb3ZlTm9uUHJpbnRpbmdWYWx1ZXNUcmFuc2Zvcm1lciIsIm9uU3Vic3RpdHV0aW9uIiwic3Vic3RpdHV0aW9uIiwiQXJyYXkiLCJpc0FycmF5IiwiZmlsdGVyIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBLElBQU1BLGVBQWUsU0FBZkEsWUFBZTtBQUFBLFNBQ25CQyxLQUFLLElBQUwsSUFBYSxDQUFDQyxPQUFPQyxLQUFQLENBQWFGLENBQWIsQ0FBZCxJQUFpQyxPQUFPQSxDQUFQLEtBQWEsU0FEM0I7QUFBQSxDQUFyQjs7QUFHQSxJQUFNRyxxQ0FBcUMsU0FBckNBLGtDQUFxQztBQUFBLFNBQU87QUFDaERDLGtCQURnRCwwQkFDakNDLFlBRGlDLEVBQ25CO0FBQzNCLFVBQUlDLE1BQU1DLE9BQU4sQ0FBY0YsWUFBZCxDQUFKLEVBQWlDO0FBQy9CLGVBQU9BLGFBQWFHLE1BQWIsQ0FBb0JULFlBQXBCLENBQVA7QUFDRDtBQUNELFVBQUlBLGFBQWFNLFlBQWIsQ0FBSixFQUFnQztBQUM5QixlQUFPQSxZQUFQO0FBQ0Q7QUFDRCxhQUFPLEVBQVA7QUFDRDtBQVQrQyxHQUFQO0FBQUEsQ0FBM0M7O2tCQVllRixrQyIsImZpbGUiOiJyZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgaXNWYWxpZFZhbHVlID0geCA9PlxuICB4ICE9IG51bGwgJiYgIU51bWJlci5pc05hTih4KSAmJiB0eXBlb2YgeCAhPT0gJ2Jvb2xlYW4nO1xuXG5jb25zdCByZW1vdmVOb25QcmludGluZ1ZhbHVlc1RyYW5zZm9ybWVyID0gKCkgPT4gKHtcbiAgb25TdWJzdGl0dXRpb24oc3Vic3RpdHV0aW9uKSB7XG4gICAgaWYgKEFycmF5LmlzQXJyYXkoc3Vic3RpdHV0aW9uKSkge1xuICAgICAgcmV0dXJuIHN1YnN0aXR1dGlvbi5maWx0ZXIoaXNWYWxpZFZhbHVlKTtcbiAgICB9XG4gICAgaWYgKGlzVmFsaWRWYWx1ZShzdWJzdGl0dXRpb24pKSB7XG4gICAgICByZXR1cm4gc3Vic3RpdHV0aW9uO1xuICAgIH1cbiAgICByZXR1cm4gJyc7XG4gIH0sXG59KTtcblxuZXhwb3J0IGRlZmF1bHQgcmVtb3ZlTm9uUHJpbnRpbmdWYWx1ZXNUcmFuc2Zvcm1lcjtcbiJdfQ==

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Replaces tabs, newlines and spaces with the chosen value when they occur in sequences
	 * @param  {(String|RegExp)} replaceWhat - the value or pattern that should be replaced
	 * @param  {*}               replaceWith - the replacement value
	 * @return {Object}                      - a TemplateTag transformer
	 */
	var replaceResultTransformer = function replaceResultTransformer(replaceWhat, replaceWith) {
	  return {
	    onEndResult: function onEndResult(endResult) {
	      if (replaceWhat == null || replaceWith == null) {
	        throw new Error('replaceResultTransformer requires at least 2 arguments.');
	      }
	      return endResult.replace(replaceWhat, replaceWith);
	    }
	  };
	};
	
	exports.default = replaceResultTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIvcmVwbGFjZVJlc3VsdFRyYW5zZm9ybWVyLmpzIl0sIm5hbWVzIjpbInJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lciIsInJlcGxhY2VXaGF0IiwicmVwbGFjZVdpdGgiLCJvbkVuZFJlc3VsdCIsImVuZFJlc3VsdCIsIkVycm9yIiwicmVwbGFjZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7Ozs7O0FBTUEsSUFBTUEsMkJBQTJCLFNBQTNCQSx3QkFBMkIsQ0FBQ0MsV0FBRCxFQUFjQyxXQUFkO0FBQUEsU0FBK0I7QUFDOURDLGVBRDhELHVCQUNsREMsU0FEa0QsRUFDdkM7QUFDckIsVUFBSUgsZUFBZSxJQUFmLElBQXVCQyxlQUFlLElBQTFDLEVBQWdEO0FBQzlDLGNBQU0sSUFBSUcsS0FBSixDQUNKLHlEQURJLENBQU47QUFHRDtBQUNELGFBQU9ELFVBQVVFLE9BQVYsQ0FBa0JMLFdBQWxCLEVBQStCQyxXQUEvQixDQUFQO0FBQ0Q7QUFSNkQsR0FBL0I7QUFBQSxDQUFqQzs7a0JBV2VGLHdCIiwiZmlsZSI6InJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogUmVwbGFjZXMgdGFicywgbmV3bGluZXMgYW5kIHNwYWNlcyB3aXRoIHRoZSBjaG9zZW4gdmFsdWUgd2hlbiB0aGV5IG9jY3VyIGluIHNlcXVlbmNlc1xuICogQHBhcmFtICB7KFN0cmluZ3xSZWdFeHApfSByZXBsYWNlV2hhdCAtIHRoZSB2YWx1ZSBvciBwYXR0ZXJuIHRoYXQgc2hvdWxkIGJlIHJlcGxhY2VkXG4gKiBAcGFyYW0gIHsqfSAgICAgICAgICAgICAgIHJlcGxhY2VXaXRoIC0gdGhlIHJlcGxhY2VtZW50IHZhbHVlXG4gKiBAcmV0dXJuIHtPYmplY3R9ICAgICAgICAgICAgICAgICAgICAgIC0gYSBUZW1wbGF0ZVRhZyB0cmFuc2Zvcm1lclxuICovXG5jb25zdCByZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIgPSAocmVwbGFjZVdoYXQsIHJlcGxhY2VXaXRoKSA9PiAoe1xuICBvbkVuZFJlc3VsdChlbmRSZXN1bHQpIHtcbiAgICBpZiAocmVwbGFjZVdoYXQgPT0gbnVsbCB8fCByZXBsYWNlV2l0aCA9PSBudWxsKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoXG4gICAgICAgICdyZXBsYWNlUmVzdWx0VHJhbnNmb3JtZXIgcmVxdWlyZXMgYXQgbGVhc3QgMiBhcmd1bWVudHMuJyxcbiAgICAgICk7XG4gICAgfVxuICAgIHJldHVybiBlbmRSZXN1bHQucmVwbGFjZShyZXBsYWNlV2hhdCwgcmVwbGFjZVdpdGgpO1xuICB9LFxufSk7XG5cbmV4cG9ydCBkZWZhdWx0IHJlcGxhY2VSZXN1bHRUcmFuc2Zvcm1lcjtcbiJdfQ==

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _replaceStringTransformer = __webpack_require__(666);
	
	var _replaceStringTransformer2 = _interopRequireDefault(_replaceStringTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _replaceStringTransformer2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlU3RyaW5nVHJhbnNmb3JtZXIvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9yZXBsYWNlU3RyaW5nVHJhbnNmb3JtZXInO1xuIl19

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var replaceStringTransformer = function replaceStringTransformer(replaceWhat, replaceWith) {
	  return {
	    onString: function onString(str) {
	      if (replaceWhat == null || replaceWith == null) {
	        throw new Error('replaceStringTransformer requires at least 2 arguments.');
	      }
	
	      return str.replace(replaceWhat, replaceWith);
	    }
	  };
	};
	
	exports.default = replaceStringTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlU3RyaW5nVHJhbnNmb3JtZXIvcmVwbGFjZVN0cmluZ1RyYW5zZm9ybWVyLmpzIl0sIm5hbWVzIjpbInJlcGxhY2VTdHJpbmdUcmFuc2Zvcm1lciIsInJlcGxhY2VXaGF0IiwicmVwbGFjZVdpdGgiLCJvblN0cmluZyIsInN0ciIsIkVycm9yIiwicmVwbGFjZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxJQUFNQSwyQkFBMkIsU0FBM0JBLHdCQUEyQixDQUFDQyxXQUFELEVBQWNDLFdBQWQ7QUFBQSxTQUErQjtBQUM5REMsWUFEOEQsb0JBQ3JEQyxHQURxRCxFQUNoRDtBQUNaLFVBQUlILGVBQWUsSUFBZixJQUF1QkMsZUFBZSxJQUExQyxFQUFnRDtBQUM5QyxjQUFNLElBQUlHLEtBQUosQ0FDSix5REFESSxDQUFOO0FBR0Q7O0FBRUQsYUFBT0QsSUFBSUUsT0FBSixDQUFZTCxXQUFaLEVBQXlCQyxXQUF6QixDQUFQO0FBQ0Q7QUFUNkQsR0FBL0I7QUFBQSxDQUFqQzs7a0JBWWVGLHdCIiwiZmlsZSI6InJlcGxhY2VTdHJpbmdUcmFuc2Zvcm1lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHJlcGxhY2VTdHJpbmdUcmFuc2Zvcm1lciA9IChyZXBsYWNlV2hhdCwgcmVwbGFjZVdpdGgpID0+ICh7XG4gIG9uU3RyaW5nKHN0cikge1xuICAgIGlmIChyZXBsYWNlV2hhdCA9PSBudWxsIHx8IHJlcGxhY2VXaXRoID09IG51bGwpIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcihcbiAgICAgICAgJ3JlcGxhY2VTdHJpbmdUcmFuc2Zvcm1lciByZXF1aXJlcyBhdCBsZWFzdCAyIGFyZ3VtZW50cy4nLFxuICAgICAgKTtcbiAgICB9XG5cbiAgICByZXR1cm4gc3RyLnJlcGxhY2UocmVwbGFjZVdoYXQsIHJlcGxhY2VXaXRoKTtcbiAgfSxcbn0pO1xuXG5leHBvcnQgZGVmYXVsdCByZXBsYWNlU3RyaW5nVHJhbnNmb3JtZXI7XG4iXX0=

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var replaceSubstitutionTransformer = function replaceSubstitutionTransformer(replaceWhat, replaceWith) {
	  return {
	    onSubstitution: function onSubstitution(substitution, resultSoFar) {
	      if (replaceWhat == null || replaceWith == null) {
	        throw new Error('replaceSubstitutionTransformer requires at least 2 arguments.');
	      }
	
	      // Do not touch if null or undefined
	      if (substitution == null) {
	        return substitution;
	      } else {
	        return substitution.toString().replace(replaceWhat, replaceWith);
	      }
	    }
	  };
	};
	
	exports.default = replaceSubstitutionTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIvcmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyLmpzIl0sIm5hbWVzIjpbInJlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lciIsInJlcGxhY2VXaGF0IiwicmVwbGFjZVdpdGgiLCJvblN1YnN0aXR1dGlvbiIsInN1YnN0aXR1dGlvbiIsInJlc3VsdFNvRmFyIiwiRXJyb3IiLCJ0b1N0cmluZyIsInJlcGxhY2UiXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsSUFBTUEsaUNBQWlDLFNBQWpDQSw4QkFBaUMsQ0FBQ0MsV0FBRCxFQUFjQyxXQUFkO0FBQUEsU0FBK0I7QUFDcEVDLGtCQURvRSwwQkFDckRDLFlBRHFELEVBQ3ZDQyxXQUR1QyxFQUMxQjtBQUN4QyxVQUFJSixlQUFlLElBQWYsSUFBdUJDLGVBQWUsSUFBMUMsRUFBZ0Q7QUFDOUMsY0FBTSxJQUFJSSxLQUFKLENBQ0osK0RBREksQ0FBTjtBQUdEOztBQUVEO0FBQ0EsVUFBSUYsZ0JBQWdCLElBQXBCLEVBQTBCO0FBQ3hCLGVBQU9BLFlBQVA7QUFDRCxPQUZELE1BRU87QUFDTCxlQUFPQSxhQUFhRyxRQUFiLEdBQXdCQyxPQUF4QixDQUFnQ1AsV0FBaEMsRUFBNkNDLFdBQTdDLENBQVA7QUFDRDtBQUNGO0FBZG1FLEdBQS9CO0FBQUEsQ0FBdkM7O2tCQWlCZUYsOEIiLCJmaWxlIjoicmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgcmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyID0gKHJlcGxhY2VXaGF0LCByZXBsYWNlV2l0aCkgPT4gKHtcbiAgb25TdWJzdGl0dXRpb24oc3Vic3RpdHV0aW9uLCByZXN1bHRTb0Zhcikge1xuICAgIGlmIChyZXBsYWNlV2hhdCA9PSBudWxsIHx8IHJlcGxhY2VXaXRoID09IG51bGwpIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcihcbiAgICAgICAgJ3JlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lciByZXF1aXJlcyBhdCBsZWFzdCAyIGFyZ3VtZW50cy4nLFxuICAgICAgKTtcbiAgICB9XG5cbiAgICAvLyBEbyBub3QgdG91Y2ggaWYgbnVsbCBvciB1bmRlZmluZWRcbiAgICBpZiAoc3Vic3RpdHV0aW9uID09IG51bGwpIHtcbiAgICAgIHJldHVybiBzdWJzdGl0dXRpb247XG4gICAgfSBlbHNlIHtcbiAgICAgIHJldHVybiBzdWJzdGl0dXRpb24udG9TdHJpbmcoKS5yZXBsYWNlKHJlcGxhY2VXaGF0LCByZXBsYWNlV2l0aCk7XG4gICAgfVxuICB9LFxufSk7XG5cbmV4cG9ydCBkZWZhdWx0IHJlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lcjtcbiJdfQ==

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _safeHtml = __webpack_require__(669);
	
	var _safeHtml2 = _interopRequireDefault(_safeHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _safeHtml2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zYWZlSHRtbC9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL3NhZmVIdG1sJztcbiJdfQ==

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(55);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _inlineArrayTransformer = __webpack_require__(37);
	
	var _inlineArrayTransformer2 = _interopRequireDefault(_inlineArrayTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	var _splitStringTransformer = __webpack_require__(234);
	
	var _splitStringTransformer2 = _interopRequireDefault(_splitStringTransformer);
	
	var _replaceSubstitutionTransformer = __webpack_require__(391);
	
	var _replaceSubstitutionTransformer2 = _interopRequireDefault(_replaceSubstitutionTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var safeHtml = new _TemplateTag2.default((0, _splitStringTransformer2.default)('\n'), _inlineArrayTransformer2.default, _stripIndentTransformer2.default, _trimResultTransformer2.default, (0, _replaceSubstitutionTransformer2.default)(/&/g, '&amp;'), (0, _replaceSubstitutionTransformer2.default)(/</g, '&lt;'), (0, _replaceSubstitutionTransformer2.default)(/>/g, '&gt;'), (0, _replaceSubstitutionTransformer2.default)(/"/g, '&quot;'), (0, _replaceSubstitutionTransformer2.default)(/'/g, '&#x27;'), (0, _replaceSubstitutionTransformer2.default)(/`/g, '&#x60;'));
	
	exports.default = safeHtml;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zYWZlSHRtbC9zYWZlSHRtbC5qcyJdLCJuYW1lcyI6WyJzYWZlSHRtbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxXQUFXLDBCQUNmLHNDQUF1QixJQUF2QixDQURlLHVHQUtmLDhDQUErQixJQUEvQixFQUFxQyxPQUFyQyxDQUxlLEVBTWYsOENBQStCLElBQS9CLEVBQXFDLE1BQXJDLENBTmUsRUFPZiw4Q0FBK0IsSUFBL0IsRUFBcUMsTUFBckMsQ0FQZSxFQVFmLDhDQUErQixJQUEvQixFQUFxQyxRQUFyQyxDQVJlLEVBU2YsOENBQStCLElBQS9CLEVBQXFDLFFBQXJDLENBVGUsRUFVZiw4Q0FBK0IsSUFBL0IsRUFBcUMsUUFBckMsQ0FWZSxDQUFqQjs7a0JBYWVBLFEiLCJmaWxlIjoic2FmZUh0bWwuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IHN0cmlwSW5kZW50VHJhbnNmb3JtZXIgZnJvbSAnLi4vc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgaW5saW5lQXJyYXlUcmFuc2Zvcm1lciBmcm9tICcuLi9pbmxpbmVBcnJheVRyYW5zZm9ybWVyJztcbmltcG9ydCB0cmltUmVzdWx0VHJhbnNmb3JtZXIgZnJvbSAnLi4vdHJpbVJlc3VsdFRyYW5zZm9ybWVyJztcbmltcG9ydCBzcGxpdFN0cmluZ1RyYW5zZm9ybWVyIGZyb20gJy4uL3NwbGl0U3RyaW5nVHJhbnNmb3JtZXInO1xuaW1wb3J0IHJlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lciBmcm9tICcuLi9yZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXInO1xuXG5jb25zdCBzYWZlSHRtbCA9IG5ldyBUZW1wbGF0ZVRhZyhcbiAgc3BsaXRTdHJpbmdUcmFuc2Zvcm1lcignXFxuJyksXG4gIGlubGluZUFycmF5VHJhbnNmb3JtZXIsXG4gIHN0cmlwSW5kZW50VHJhbnNmb3JtZXIsXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbiAgcmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyKC8mL2csICcmYW1wOycpLFxuICByZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIoLzwvZywgJyZsdDsnKSxcbiAgcmVwbGFjZVN1YnN0aXR1dGlvblRyYW5zZm9ybWVyKC8+L2csICcmZ3Q7JyksXG4gIHJlcGxhY2VTdWJzdGl0dXRpb25UcmFuc2Zvcm1lcigvXCIvZywgJyZxdW90OycpLFxuICByZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIoLycvZywgJyYjeDI3OycpLFxuICByZXBsYWNlU3Vic3RpdHV0aW9uVHJhbnNmb3JtZXIoL2AvZywgJyYjeDYwOycpLFxuKTtcblxuZXhwb3J0IGRlZmF1bHQgc2FmZUh0bWw7XG4iXX0=

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _html = __webpack_require__(233);
	
	var _html2 = _interopRequireDefault(_html);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _html2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zb3VyY2UvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi4vaHRtbCc7XG4iXX0=

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var splitStringTransformer = function splitStringTransformer(splitBy) {
	  return {
	    onSubstitution: function onSubstitution(substitution, resultSoFar) {
	      if (splitBy != null && typeof splitBy === 'string') {
	        if (typeof substitution === 'string' && substitution.includes(splitBy)) {
	          substitution = substitution.split(splitBy);
	        }
	      } else {
	        throw new Error('You need to specify a string character to split by.');
	      }
	      return substitution;
	    }
	  };
	};
	
	exports.default = splitStringTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zcGxpdFN0cmluZ1RyYW5zZm9ybWVyL3NwbGl0U3RyaW5nVHJhbnNmb3JtZXIuanMiXSwibmFtZXMiOlsic3BsaXRTdHJpbmdUcmFuc2Zvcm1lciIsIm9uU3Vic3RpdHV0aW9uIiwic3Vic3RpdHV0aW9uIiwicmVzdWx0U29GYXIiLCJzcGxpdEJ5IiwiaW5jbHVkZXMiLCJzcGxpdCIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBLElBQU1BLHlCQUF5QixTQUF6QkEsc0JBQXlCO0FBQUEsU0FBWTtBQUN6Q0Msa0JBRHlDLDBCQUMxQkMsWUFEMEIsRUFDWkMsV0FEWSxFQUNDO0FBQ3hDLFVBQUlDLFdBQVcsSUFBWCxJQUFtQixPQUFPQSxPQUFQLEtBQW1CLFFBQTFDLEVBQW9EO0FBQ2xELFlBQUksT0FBT0YsWUFBUCxLQUF3QixRQUF4QixJQUFvQ0EsYUFBYUcsUUFBYixDQUFzQkQsT0FBdEIsQ0FBeEMsRUFBd0U7QUFDdEVGLHlCQUFlQSxhQUFhSSxLQUFiLENBQW1CRixPQUFuQixDQUFmO0FBQ0Q7QUFDRixPQUpELE1BSU87QUFDTCxjQUFNLElBQUlHLEtBQUosQ0FBVSxxREFBVixDQUFOO0FBQ0Q7QUFDRCxhQUFPTCxZQUFQO0FBQ0Q7QUFWd0MsR0FBWjtBQUFBLENBQS9COztrQkFhZUYsc0IiLCJmaWxlIjoic3BsaXRTdHJpbmdUcmFuc2Zvcm1lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHNwbGl0U3RyaW5nVHJhbnNmb3JtZXIgPSBzcGxpdEJ5ID0+ICh7XG4gIG9uU3Vic3RpdHV0aW9uKHN1YnN0aXR1dGlvbiwgcmVzdWx0U29GYXIpIHtcbiAgICBpZiAoc3BsaXRCeSAhPSBudWxsICYmIHR5cGVvZiBzcGxpdEJ5ID09PSAnc3RyaW5nJykge1xuICAgICAgaWYgKHR5cGVvZiBzdWJzdGl0dXRpb24gPT09ICdzdHJpbmcnICYmIHN1YnN0aXR1dGlvbi5pbmNsdWRlcyhzcGxpdEJ5KSkge1xuICAgICAgICBzdWJzdGl0dXRpb24gPSBzdWJzdGl0dXRpb24uc3BsaXQoc3BsaXRCeSk7XG4gICAgICB9XG4gICAgfSBlbHNlIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcignWW91IG5lZWQgdG8gc3BlY2lmeSBhIHN0cmluZyBjaGFyYWN0ZXIgdG8gc3BsaXQgYnkuJyk7XG4gICAgfVxuICAgIHJldHVybiBzdWJzdGl0dXRpb247XG4gIH0sXG59KTtcblxuZXhwb3J0IGRlZmF1bHQgc3BsaXRTdHJpbmdUcmFuc2Zvcm1lcjtcbiJdfQ==

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _stripIndent = __webpack_require__(673);
	
	var _stripIndent2 = _interopRequireDefault(_stripIndent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _stripIndent2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudC9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmcm9tICcuL3N0cmlwSW5kZW50JztcbiJdfQ==

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(55);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stripIndent = new _TemplateTag2.default(_stripIndentTransformer2.default, _trimResultTransformer2.default);
	
	exports.default = stripIndent;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudC9zdHJpcEluZGVudC5qcyJdLCJuYW1lcyI6WyJzdHJpcEluZGVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxjQUFjLDRGQUFwQjs7a0JBS2VBLFciLCJmaWxlIjoic3RyaXBJbmRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IHN0cmlwSW5kZW50VHJhbnNmb3JtZXIgZnJvbSAnLi4vc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IHN0cmlwSW5kZW50ID0gbmV3IFRlbXBsYXRlVGFnKFxuICBzdHJpcEluZGVudFRyYW5zZm9ybWVyLFxuICB0cmltUmVzdWx0VHJhbnNmb3JtZXIsXG4pO1xuXG5leHBvcnQgZGVmYXVsdCBzdHJpcEluZGVudDtcbiJdfQ==

/***/ }),
/* 674 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * strips indentation from a template literal
	 * @param  {String} type = 'initial' - whether to remove all indentation or just leading indentation. can be 'all' or 'initial'
	 * @return {Object}                  - a TemplateTag transformer
	 */
	var stripIndentTransformer = function stripIndentTransformer() {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'initial';
	  return {
	    onEndResult: function onEndResult(endResult) {
	      if (type === 'initial') {
	        // remove the shortest leading indentation from each line
	        var match = endResult.match(/^[^\S\n]*(?=\S)/gm);
	        var indent = match && Math.min.apply(Math, _toConsumableArray(match.map(function (el) {
	          return el.length;
	        })));
	        if (indent) {
	          var regexp = new RegExp('^.{' + indent + '}', 'gm');
	          return endResult.replace(regexp, '');
	        }
	        return endResult;
	      }
	      if (type === 'all') {
	        // remove all indentation from each line
	        return endResult.replace(/^[^\S\n]+/gm, '');
	      }
	      throw new Error('Unknown type: ' + type);
	    }
	  };
	};
	
	exports.default = stripIndentTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudFRyYW5zZm9ybWVyL3N0cmlwSW5kZW50VHJhbnNmb3JtZXIuanMiXSwibmFtZXMiOlsic3RyaXBJbmRlbnRUcmFuc2Zvcm1lciIsInR5cGUiLCJvbkVuZFJlc3VsdCIsImVuZFJlc3VsdCIsIm1hdGNoIiwiaW5kZW50IiwiTWF0aCIsIm1pbiIsIm1hcCIsImVsIiwibGVuZ3RoIiwicmVnZXhwIiwiUmVnRXhwIiwicmVwbGFjZSIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBOzs7OztBQUtBLElBQU1BLHlCQUF5QixTQUF6QkEsc0JBQXlCO0FBQUEsTUFBQ0MsSUFBRCx1RUFBUSxTQUFSO0FBQUEsU0FBdUI7QUFDcERDLGVBRG9ELHVCQUN4Q0MsU0FEd0MsRUFDN0I7QUFDckIsVUFBSUYsU0FBUyxTQUFiLEVBQXdCO0FBQ3RCO0FBQ0EsWUFBTUcsUUFBUUQsVUFBVUMsS0FBVixDQUFnQixtQkFBaEIsQ0FBZDtBQUNBLFlBQU1DLFNBQVNELFNBQVNFLEtBQUtDLEdBQUwsZ0NBQVlILE1BQU1JLEdBQU4sQ0FBVTtBQUFBLGlCQUFNQyxHQUFHQyxNQUFUO0FBQUEsU0FBVixDQUFaLEVBQXhCO0FBQ0EsWUFBSUwsTUFBSixFQUFZO0FBQ1YsY0FBTU0sU0FBUyxJQUFJQyxNQUFKLFNBQWlCUCxNQUFqQixRQUE0QixJQUE1QixDQUFmO0FBQ0EsaUJBQU9GLFVBQVVVLE9BQVYsQ0FBa0JGLE1BQWxCLEVBQTBCLEVBQTFCLENBQVA7QUFDRDtBQUNELGVBQU9SLFNBQVA7QUFDRDtBQUNELFVBQUlGLFNBQVMsS0FBYixFQUFvQjtBQUNsQjtBQUNBLGVBQU9FLFVBQVVVLE9BQVYsQ0FBa0IsYUFBbEIsRUFBaUMsRUFBakMsQ0FBUDtBQUNEO0FBQ0QsWUFBTSxJQUFJQyxLQUFKLG9CQUEyQmIsSUFBM0IsQ0FBTjtBQUNEO0FBakJtRCxHQUF2QjtBQUFBLENBQS9COztrQkFvQmVELHNCIiwiZmlsZSI6InN0cmlwSW5kZW50VHJhbnNmb3JtZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIHN0cmlwcyBpbmRlbnRhdGlvbiBmcm9tIGEgdGVtcGxhdGUgbGl0ZXJhbFxuICogQHBhcmFtICB7U3RyaW5nfSB0eXBlID0gJ2luaXRpYWwnIC0gd2hldGhlciB0byByZW1vdmUgYWxsIGluZGVudGF0aW9uIG9yIGp1c3QgbGVhZGluZyBpbmRlbnRhdGlvbi4gY2FuIGJlICdhbGwnIG9yICdpbml0aWFsJ1xuICogQHJldHVybiB7T2JqZWN0fSAgICAgICAgICAgICAgICAgIC0gYSBUZW1wbGF0ZVRhZyB0cmFuc2Zvcm1lclxuICovXG5jb25zdCBzdHJpcEluZGVudFRyYW5zZm9ybWVyID0gKHR5cGUgPSAnaW5pdGlhbCcpID0+ICh7XG4gIG9uRW5kUmVzdWx0KGVuZFJlc3VsdCkge1xuICAgIGlmICh0eXBlID09PSAnaW5pdGlhbCcpIHtcbiAgICAgIC8vIHJlbW92ZSB0aGUgc2hvcnRlc3QgbGVhZGluZyBpbmRlbnRhdGlvbiBmcm9tIGVhY2ggbGluZVxuICAgICAgY29uc3QgbWF0Y2ggPSBlbmRSZXN1bHQubWF0Y2goL15bXlxcU1xcbl0qKD89XFxTKS9nbSk7XG4gICAgICBjb25zdCBpbmRlbnQgPSBtYXRjaCAmJiBNYXRoLm1pbiguLi5tYXRjaC5tYXAoZWwgPT4gZWwubGVuZ3RoKSk7XG4gICAgICBpZiAoaW5kZW50KSB7XG4gICAgICAgIGNvbnN0IHJlZ2V4cCA9IG5ldyBSZWdFeHAoYF4ueyR7aW5kZW50fX1gLCAnZ20nKTtcbiAgICAgICAgcmV0dXJuIGVuZFJlc3VsdC5yZXBsYWNlKHJlZ2V4cCwgJycpO1xuICAgICAgfVxuICAgICAgcmV0dXJuIGVuZFJlc3VsdDtcbiAgICB9XG4gICAgaWYgKHR5cGUgPT09ICdhbGwnKSB7XG4gICAgICAvLyByZW1vdmUgYWxsIGluZGVudGF0aW9uIGZyb20gZWFjaCBsaW5lXG4gICAgICByZXR1cm4gZW5kUmVzdWx0LnJlcGxhY2UoL15bXlxcU1xcbl0rL2dtLCAnJyk7XG4gICAgfVxuICAgIHRocm93IG5ldyBFcnJvcihgVW5rbm93biB0eXBlOiAke3R5cGV9YCk7XG4gIH0sXG59KTtcblxuZXhwb3J0IGRlZmF1bHQgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcjtcbiJdfQ==

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _stripIndents = __webpack_require__(676);
	
	var _stripIndents2 = _interopRequireDefault(_stripIndents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _stripIndents2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudHMvaW5kZXguanMiXSwibmFtZXMiOlsiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQUFPQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnJvbSAnLi9zdHJpcEluZGVudHMnO1xuIl19

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TemplateTag = __webpack_require__(18);
	
	var _TemplateTag2 = _interopRequireDefault(_TemplateTag);
	
	var _stripIndentTransformer = __webpack_require__(55);
	
	var _stripIndentTransformer2 = _interopRequireDefault(_stripIndentTransformer);
	
	var _trimResultTransformer = __webpack_require__(19);
	
	var _trimResultTransformer2 = _interopRequireDefault(_trimResultTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stripIndents = new _TemplateTag2.default((0, _stripIndentTransformer2.default)('all'), _trimResultTransformer2.default);
	
	exports.default = stripIndents;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHJpcEluZGVudHMvc3RyaXBJbmRlbnRzLmpzIl0sIm5hbWVzIjpbInN0cmlwSW5kZW50cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQSxJQUFNQSxlQUFlLDBCQUNuQixzQ0FBdUIsS0FBdkIsQ0FEbUIsa0NBQXJCOztrQkFLZUEsWSIsImZpbGUiOiJzdHJpcEluZGVudHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVGVtcGxhdGVUYWcgZnJvbSAnLi4vVGVtcGxhdGVUYWcnO1xuaW1wb3J0IHN0cmlwSW5kZW50VHJhbnNmb3JtZXIgZnJvbSAnLi4vc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcic7XG5pbXBvcnQgdHJpbVJlc3VsdFRyYW5zZm9ybWVyIGZyb20gJy4uL3RyaW1SZXN1bHRUcmFuc2Zvcm1lcic7XG5cbmNvbnN0IHN0cmlwSW5kZW50cyA9IG5ldyBUZW1wbGF0ZVRhZyhcbiAgc3RyaXBJbmRlbnRUcmFuc2Zvcm1lcignYWxsJyksXG4gIHRyaW1SZXN1bHRUcmFuc2Zvcm1lcixcbik7XG5cbmV4cG9ydCBkZWZhdWx0IHN0cmlwSW5kZW50cztcbiJdfQ==

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * TemplateTag transformer that trims whitespace on the end result of a tagged template
	 * @param  {String} side = '' - The side of the string to trim. Can be 'start' or 'end' (alternatively 'left' or 'right')
	 * @return {Object}           - a TemplateTag transformer
	 */
	var trimResultTransformer = function trimResultTransformer() {
	  var side = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return {
	    onEndResult: function onEndResult(endResult) {
	      if (side === '') {
	        return endResult.trim();
	      }
	
	      side = side.toLowerCase();
	
	      if (side === 'start' || side === 'left') {
	        return endResult.replace(/^\s*/, '');
	      }
	
	      if (side === 'end' || side === 'right') {
	        return endResult.replace(/\s*$/, '');
	      }
	
	      throw new Error('Side not supported: ' + side);
	    }
	  };
	};
	
	exports.default = trimResultTransformer;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90cmltUmVzdWx0VHJhbnNmb3JtZXIvdHJpbVJlc3VsdFRyYW5zZm9ybWVyLmpzIl0sIm5hbWVzIjpbInRyaW1SZXN1bHRUcmFuc2Zvcm1lciIsInNpZGUiLCJvbkVuZFJlc3VsdCIsImVuZFJlc3VsdCIsInRyaW0iLCJ0b0xvd2VyQ2FzZSIsInJlcGxhY2UiLCJFcnJvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7Ozs7QUFLQSxJQUFNQSx3QkFBd0IsU0FBeEJBLHFCQUF3QjtBQUFBLE1BQUNDLElBQUQsdUVBQVEsRUFBUjtBQUFBLFNBQWdCO0FBQzVDQyxlQUQ0Qyx1QkFDaENDLFNBRGdDLEVBQ3JCO0FBQ3JCLFVBQUlGLFNBQVMsRUFBYixFQUFpQjtBQUNmLGVBQU9FLFVBQVVDLElBQVYsRUFBUDtBQUNEOztBQUVESCxhQUFPQSxLQUFLSSxXQUFMLEVBQVA7O0FBRUEsVUFBSUosU0FBUyxPQUFULElBQW9CQSxTQUFTLE1BQWpDLEVBQXlDO0FBQ3ZDLGVBQU9FLFVBQVVHLE9BQVYsQ0FBa0IsTUFBbEIsRUFBMEIsRUFBMUIsQ0FBUDtBQUNEOztBQUVELFVBQUlMLFNBQVMsS0FBVCxJQUFrQkEsU0FBUyxPQUEvQixFQUF3QztBQUN0QyxlQUFPRSxVQUFVRyxPQUFWLENBQWtCLE1BQWxCLEVBQTBCLEVBQTFCLENBQVA7QUFDRDs7QUFFRCxZQUFNLElBQUlDLEtBQUosMEJBQWlDTixJQUFqQyxDQUFOO0FBQ0Q7QUFqQjJDLEdBQWhCO0FBQUEsQ0FBOUI7O2tCQW9CZUQscUIiLCJmaWxlIjoidHJpbVJlc3VsdFRyYW5zZm9ybWVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBUZW1wbGF0ZVRhZyB0cmFuc2Zvcm1lciB0aGF0IHRyaW1zIHdoaXRlc3BhY2Ugb24gdGhlIGVuZCByZXN1bHQgb2YgYSB0YWdnZWQgdGVtcGxhdGVcbiAqIEBwYXJhbSAge1N0cmluZ30gc2lkZSA9ICcnIC0gVGhlIHNpZGUgb2YgdGhlIHN0cmluZyB0byB0cmltLiBDYW4gYmUgJ3N0YXJ0JyBvciAnZW5kJyAoYWx0ZXJuYXRpdmVseSAnbGVmdCcgb3IgJ3JpZ2h0JylcbiAqIEByZXR1cm4ge09iamVjdH0gICAgICAgICAgIC0gYSBUZW1wbGF0ZVRhZyB0cmFuc2Zvcm1lclxuICovXG5jb25zdCB0cmltUmVzdWx0VHJhbnNmb3JtZXIgPSAoc2lkZSA9ICcnKSA9PiAoe1xuICBvbkVuZFJlc3VsdChlbmRSZXN1bHQpIHtcbiAgICBpZiAoc2lkZSA9PT0gJycpIHtcbiAgICAgIHJldHVybiBlbmRSZXN1bHQudHJpbSgpO1xuICAgIH1cblxuICAgIHNpZGUgPSBzaWRlLnRvTG93ZXJDYXNlKCk7XG5cbiAgICBpZiAoc2lkZSA9PT0gJ3N0YXJ0JyB8fCBzaWRlID09PSAnbGVmdCcpIHtcbiAgICAgIHJldHVybiBlbmRSZXN1bHQucmVwbGFjZSgvXlxccyovLCAnJyk7XG4gICAgfVxuXG4gICAgaWYgKHNpZGUgPT09ICdlbmQnIHx8IHNpZGUgPT09ICdyaWdodCcpIHtcbiAgICAgIHJldHVybiBlbmRSZXN1bHQucmVwbGFjZSgvXFxzKiQvLCAnJyk7XG4gICAgfVxuXG4gICAgdGhyb3cgbmV3IEVycm9yKGBTaWRlIG5vdCBzdXBwb3J0ZWQ6ICR7c2lkZX1gKTtcbiAgfSxcbn0pO1xuXG5leHBvcnQgZGVmYXVsdCB0cmltUmVzdWx0VHJhbnNmb3JtZXI7XG4iXX0=

/***/ }),
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(862);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(748);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(415), __webpack_require__(416), __webpack_require__(417)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(module, exports, require('../added'), require('../deleted'), require('../updated'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod, mod.exports, global.added, global.deleted, global.updated);
	    global.index = mod.exports;
	  }
	})(this, function (module, exports, _added, _deleted, _updated) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _added2 = _interopRequireDefault(_added);
	
	  var _deleted2 = _interopRequireDefault(_deleted);
	
	  var _updated2 = _interopRequireDefault(_updated);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var detailedDiff = function detailedDiff(lhs, rhs) {
	    return {
	      added: (0, _added2.default)(lhs, rhs),
	      deleted: (0, _deleted2.default)(lhs, rhs),
	      updated: (0, _updated2.default)(lhs, rhs)
	    };
	  };
	
	  exports.default = detailedDiff;
	  module.exports = exports['default'];
	});

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(179)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(module, exports, require('../utils'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod, mod.exports, global.utils);
	    global.index = mod.exports;
	  }
	})(this, function (module, exports, _utils) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  var diff = function diff(lhs, rhs) {
	    if (lhs === rhs) return {}; // equal return no diff
	
	    if (!(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return rhs; // return updated rhs
	
	    var l = (0, _utils.properObject)(lhs);
	    var r = (0, _utils.properObject)(rhs);
	
	    var deletedValues = Object.keys(l).reduce(function (acc, key) {
	      return r.hasOwnProperty(key) ? acc : _extends({}, acc, _defineProperty({}, key, undefined));
	    }, {});
	
	    if ((0, _utils.isDate)(l) || (0, _utils.isDate)(r)) {
	      if (l.valueOf() == r.valueOf()) return {};
	      return r;
	    }
	
	    return Object.keys(r).reduce(function (acc, key) {
	      if (!l.hasOwnProperty(key)) return _extends({}, acc, _defineProperty({}, key, r[key])); // return added r key
	
	      var difference = diff(l[key], r[key]);
	
	      if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference) && !(0, _utils.isDate)(difference)) return acc; // return no diff
	
	      return _extends({}, acc, _defineProperty({}, key, difference)); // return updated key
	    }, deletedValues);
	  };
	
	  exports.default = diff;
	  module.exports = exports['default'];
	});

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(751), __webpack_require__(415), __webpack_require__(416), __webpack_require__(417), __webpack_require__(750)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./diff'), require('./added'), require('./deleted'), require('./updated'), require('./detailed'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.diff, global.added, global.deleted, global.updated, global.detailed);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _diff, _added, _deleted, _updated, _detailed) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.detailedDiff = exports.updatedDiff = exports.deletedDiff = exports.diff = exports.addedDiff = undefined;
	
	  var _diff2 = _interopRequireDefault(_diff);
	
	  var _added2 = _interopRequireDefault(_added);
	
	  var _deleted2 = _interopRequireDefault(_deleted);
	
	  var _updated2 = _interopRequireDefault(_updated);
	
	  var _detailed2 = _interopRequireDefault(_detailed);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.addedDiff = _added2.default;
	  exports.diff = _diff2.default;
	  exports.deletedDiff = _deleted2.default;
	  exports.updatedDiff = _updated2.default;
	  exports.detailedDiff = _detailed2.default;
	});

/***/ }),
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(72));
	var React = __webpack_require__(1);
	var core = __webpack_require__(137);
	var weakMemoize = _interopDefault(__webpack_require__(293));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(182));
	
	var getTheme = function getTheme(outerTheme, theme) {
	  if (typeof theme === 'function') {
	    var mergedTheme = theme(outerTheme);
	
	    if (false) {
	      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	    }
	
	    return mergedTheme;
	  }
	
	  if (false) {
	    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	  }
	
	  return _extends({}, outerTheme, theme);
	};
	
	var createCacheWithTheme = weakMemoize(function (outerTheme) {
	  return weakMemoize(function (theme) {
	    return getTheme(outerTheme, theme);
	  });
	});
	
	var ThemeProvider = function ThemeProvider(props) {
	  return React.createElement(core.ThemeContext.Consumer, null, function (theme) {
	    if (props.theme !== theme) {
	      theme = createCacheWithTheme(theme)(props.theme);
	    }
	
	    return React.createElement(core.ThemeContext.Provider, {
	      value: theme
	    }, props.children);
	  });
	};
	
	// should we change this to be forwardRef/withCSSContext style so it doesn't merge with props?
	function withTheme(Component) {
	  var componentName = Component.displayName || Component.name || 'Component';
	
	  var render = function render(props, ref) {
	    return React.createElement(core.ThemeContext.Consumer, null, function (theme) {
	      return React.createElement(Component, _extends({
	        theme: theme,
	        ref: ref
	      }, props));
	    });
	  }; // $FlowFixMe
	
	
	  var WithTheme = React.forwardRef(render);
	  WithTheme.displayName = "WithTheme(" + componentName + ")";
	  return hoistNonReactStatics(WithTheme, Component);
	}
	
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;


/***/ }),
/* 771 */,
/* 772 */,
/* 773 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = parse
	
	var dot = '.'.charCodeAt(0)
	var hash = '#'.charCodeAt(0)
	
	/* Parse a simple CSS selector into a HAST node. */
	function parse(selector, defaultTagName) {
	  var value = selector || ''
	  var name = defaultTagName || 'div'
	  var props = {}
	  var index = -1
	  var length = value.length
	  var className
	  var type
	  var code
	  var subvalue
	  var lastIndex
	
	  while (++index <= length) {
	    code = value.charCodeAt(index)
	
	    if (!code || code === dot || code === hash) {
	      subvalue = value.slice(lastIndex, index)
	
	      if (subvalue) {
	        if (type === dot) {
	          if (className) {
	            className.push(subvalue)
	          } else {
	            className = [subvalue]
	            props.className = className
	          }
	        } else if (type === hash) {
	          props.id = subvalue
	        } else {
	          name = subvalue
	        }
	      }
	
	      lastIndex = index + 1
	      type = code
	    }
	  }
	
	  return {
	    type: 'element',
	    tagName: name,
	    properties: props,
	    children: []
	  }
	}


/***/ }),
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */
/***/ (function(module, exports) {

	/**
	 * SVG elements are case-sensitive.
	 *
	 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#SVG_elements_A_to_Z}
	 */
	var CASE_SENSITIVE_TAG_NAMES = [
	  'animateMotion',
	  'animateTransform',
	  'clipPath',
	  'feBlend',
	  'feColorMatrix',
	  'feComponentTransfer',
	  'feComposite',
	  'feConvolveMatrix',
	  'feDiffuseLighting',
	  'feDisplacementMap',
	  'feDropShadow',
	  'feFlood',
	  'feFuncA',
	  'feFuncB',
	  'feFuncG',
	  'feFuncR',
	  'feGaussainBlur',
	  'feImage',
	  'feMerge',
	  'feMergeNode',
	  'feMorphology',
	  'feOffset',
	  'fePointLight',
	  'feSpecularLighting',
	  'feSpotLight',
	  'feTile',
	  'feTurbulence',
	  'foreignObject',
	  'linearGradient',
	  'radialGradient',
	  'textPath'
	];
	
	module.exports = {
	  CASE_SENSITIVE_TAG_NAMES: CASE_SENSITIVE_TAG_NAMES
	};


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	var utilities = __webpack_require__(425);
	
	// constants
	var HTML = 'html';
	var HEAD = 'head';
	var BODY = 'body';
	var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
	var HEAD_TAG_REGEX = /<head.*>/i;
	var BODY_TAG_REGEX = /<body.*>/i;
	// http://www.w3.org/TR/html/syntax.html#void-elements
	var VOID_ELEMENTS_REGEX = /<(area|base|br|col|embed|hr|img|input|keygen|link|menuitem|meta|param|source|track|wbr)(.*?)\/?>/gi;
	
	// detect IE browser
	var isIE9 = utilities.isIE(9);
	var isIE = isIE9 || utilities.isIE();
	
	/**
	 * DOMParser (performance: slow).
	 *
	 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
	 */
	var parseFromString;
	
	if (typeof window.DOMParser === 'function') {
	  var domParser = new window.DOMParser();
	
	  // IE9 does not support 'text/html' MIME type
	  // https://msdn.microsoft.com/en-us/library/ff975278(v=vs.85).aspx
	  var mimeType = isIE9 ? 'text/xml' : 'text/html';
	
	  /**
	   * Creates an HTML document using `DOMParser.parseFromString`.
	   *
	   * @param  {string} html      - The HTML string.
	   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
	   * @return {HTMLDocument}
	   */
	  parseFromString = function domStringParser(html, tagName) {
	    if (tagName) {
	      html = '<' + tagName + '>' + html + '</' + tagName + '>';
	    }
	
	    // because IE9 only supports MIME type 'text/xml', void elements need to be self-closed
	    if (isIE9) {
	      html = html.replace(VOID_ELEMENTS_REGEX, '<$1$2$3/>');
	    }
	
	    return domParser.parseFromString(html, mimeType);
	  };
	}
	
	/**
	 * DOMImplementation (performance: fair).
	 *
	 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
	 */
	var parseFromDocument;
	
	if (typeof document.implementation === 'object') {
	  // title parameter is required in IE
	  // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
	  var doc = document.implementation.createHTMLDocument(
	    isIE ? 'HTML_DOM_PARSER_TITLE' : undefined
	  );
	
	  /**
	   * Use HTML document created by `document.implementation.createHTMLDocument`.
	   *
	   * @param  {string} html      - The HTML string.
	   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
	   * @return {HTMLDocument}
	   */
	  parseFromDocument = function createHTMLDocument(html, tagName) {
	    if (tagName) {
	      doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
	      return doc;
	    }
	
	    try {
	      doc.documentElement.innerHTML = html;
	      return doc;
	      // fallback when certain elements in `documentElement` are read-only (IE9)
	    } catch (err) {
	      if (parseFromString) {
	        return parseFromString(html);
	      }
	    }
	  };
	}
	
	/**
	 * Template (performance: fast).
	 *
	 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
	 */
	var parseFromTemplate;
	var template = document.createElement('template');
	
	if (template.content) {
	  /**
	   * Uses a template element (content fragment) to parse HTML.
	   *
	   * @param  {string} html - The HTML string.
	   * @return {NodeList}
	   */
	  parseFromTemplate = function templateParser(html) {
	    template.innerHTML = html;
	    return template.content.childNodes;
	  };
	}
	
	// fallback document parser
	var parseWithFallback = parseFromDocument || parseFromString;
	
	/**
	 * Parses HTML string to DOM nodes.
	 *
	 * @param  {string} html - The HTML string.
	 * @return {NodeList|Array}
	 */
	function domparser(html) {
	  var firstTagName;
	  var match = html.match(FIRST_TAG_REGEX);
	
	  if (match && match[1]) {
	    firstTagName = match[1].toLowerCase();
	  }
	
	  var doc;
	  var element;
	  var elements;
	
	  switch (firstTagName) {
	    case HTML:
	      if (parseFromString) {
	        doc = parseFromString(html);
	
	        // the created document may come with filler head/body elements,
	        // so make sure to remove them if they don't actually exist
	        if (!HEAD_TAG_REGEX.test(html)) {
	          element = doc.getElementsByTagName(HEAD)[0];
	          if (element) {
	            element.parentNode.removeChild(element);
	          }
	        }
	
	        if (!BODY_TAG_REGEX.test(html)) {
	          element = doc.getElementsByTagName(BODY)[0];
	          if (element) {
	            element.parentNode.removeChild(element);
	          }
	        }
	
	        return doc.getElementsByTagName(HTML);
	      }
	      break;
	
	    case HEAD:
	    case BODY:
	      if (parseWithFallback) {
	        elements = parseWithFallback(html).getElementsByTagName(firstTagName);
	
	        // account for possibility of sibling
	        if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
	          return elements[0].parentNode.childNodes;
	        }
	
	        return elements;
	      }
	      break;
	
	    // low-level tag or text
	    default:
	      if (parseFromTemplate) {
	        return parseFromTemplate(html);
	      }
	
	      if (parseWithFallback) {
	        return parseWithFallback(html, BODY).getElementsByTagName(BODY)[0]
	          .childNodes;
	      }
	
	      break;
	  }
	
	  return [];
	}
	
	module.exports = domparser;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	var domparser = __webpack_require__(868);
	var utilities = __webpack_require__(425);
	
	var formatDOM = utilities.formatDOM;
	var isIE9 = utilities.isIE(9);
	
	var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
	
	/**
	 * Parses HTML and reformats DOM nodes output.
	 *
	 * @param  {String} html - The HTML string.
	 * @return {Array}       - The formatted DOM nodes.
	 */
	function parseDOM(html) {
	  if (typeof html !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (!html) {
	    return [];
	  }
	
	  // match directive
	  var match = html.match(DIRECTIVE_REGEX);
	  var directive;
	
	  if (match && match[1]) {
	    directive = match[1];
	
	    // remove directive in IE9 because DOMParser uses
	    // MIME type 'text/xml' instead of 'text/html'
	    if (isIE9) {
	      html = html.replace(match[0], '');
	    }
	  }
	
	  return formatDOM(domparser(html), null, directive);
	}
	
	module.exports = parseDOM;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	var domToReact = __webpack_require__(872);
	var htmlToDOM = __webpack_require__(869);
	
	// decode HTML entities by default for `htmlparser2`
	var domParserOptions = { decodeEntities: true, lowerCaseAttributeNames: false };
	
	/**
	 * Converts HTML string to React elements.
	 *
	 * @param  {String}   html              - The HTML string to parse to React.
	 * @param  {Object}   [options]         - The parser options.
	 * @param  {Function} [options.replace] - The replace method.
	 * @return {ReactElement|Array|String}  - When parsed with HTML string, returns React elements; otherwise, returns string or empty array.
	 */
	function HTMLReactParser(html, options) {
	  if (typeof html !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	  return domToReact(htmlToDOM(html, domParserOptions), options);
	}
	
	HTMLReactParser.domToReact = domToReact;
	HTMLReactParser.htmlToDOM = htmlToDOM;
	
	module.exports = HTMLReactParser;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	var reactProperty = __webpack_require__(1060);
	var styleToObject = __webpack_require__(1114);
	var utilities = __webpack_require__(426);
	
	var camelCase = utilities.camelCase;
	
	var htmlProperties = reactProperty.html;
	var svgProperties = reactProperty.svg;
	var isCustomAttribute = reactProperty.isCustomAttribute;
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Converts HTML/SVG DOM attributes to React props.
	 *
	 * @param  {Object} [attributes={}] - The HTML/SVG DOM attributes.
	 * @return {Object}                 - The React props.
	 */
	function attributesToProps(attributes) {
	  attributes = attributes || {};
	
	  var attributeName;
	  var attributeNameLowerCased;
	  var attributeValue;
	  var property;
	  var props = {};
	
	  for (attributeName in attributes) {
	    attributeValue = attributes[attributeName];
	
	    // ARIA (aria-*) or custom data (data-*) attribute
	    if (isCustomAttribute(attributeName)) {
	      props[attributeName] = attributeValue;
	      continue;
	    }
	
	    // convert HTML attribute to React prop
	    attributeNameLowerCased = attributeName.toLowerCase();
	    if (hasOwnProperty.call(htmlProperties, attributeNameLowerCased)) {
	      property = htmlProperties[attributeNameLowerCased];
	      props[property.propertyName] =
	        property.hasBooleanValue ||
	        (property.hasOverloadedBooleanValue && !attributeValue)
	          ? true
	          : attributeValue;
	      continue;
	    }
	
	    // convert SVG attribute to React prop
	    if (hasOwnProperty.call(svgProperties, attributeName)) {
	      property = svgProperties[attributeName];
	      props[property.propertyName] = attributeValue;
	      continue;
	    }
	
	    // preserve custom attribute if React >=16
	    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
	      props[attributeName] = attributeValue;
	    }
	  }
	
	  // convert inline style to object
	  if (attributes.style != null) {
	    props.style = cssToJs(attributes.style);
	  }
	
	  return props;
	}
	
	/**
	 * Converts CSS style string to JS style object.
	 *
	 * @param  {String} style - The CSS style.
	 * @return {Object}       - The JS style object.
	 */
	function cssToJs(style) {
	  if (typeof style !== 'string') {
	    throw new TypeError('First argument must be a string.');
	  }
	
	  var styleObj = {};
	
	  styleToObject(style, function(property, value) {
	    // skip if it's a comment node
	    if (property && value) {
	      styleObj[camelCase(property)] = value;
	    }
	  });
	
	  return styleObj;
	}
	
	module.exports = attributesToProps;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	var attributesToProps = __webpack_require__(871);
	var utilities = __webpack_require__(426);
	
	/**
	 * Converts DOM nodes to React elements.
	 *
	 * @param  {Array}    nodes             - The DOM nodes.
	 * @param  {Object}   [options]         - The additional options.
	 * @param  {Function} [options.replace] - The replace method.
	 * @return {ReactElement|Array}
	 */
	function domToReact(nodes, options) {
	  options = options || {};
	
	  var React = options.library || __webpack_require__(1);
	  var cloneElement = React.cloneElement;
	  var createElement = React.createElement;
	  var isValidElement = React.isValidElement;
	
	  var result = [];
	  var node;
	  var hasReplace = typeof options.replace === 'function';
	  var replaceElement;
	  var props;
	  var children;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    node = nodes[i];
	
	    // replace with custom React element (if present)
	    if (hasReplace) {
	      replaceElement = options.replace(node);
	
	      if (isValidElement(replaceElement)) {
	        // specify a "key" prop if element has siblings
	        // https://fb.me/react-warning-keys
	        if (len > 1) {
	          replaceElement = cloneElement(replaceElement, {
	            key: replaceElement.key || i
	          });
	        }
	        result.push(replaceElement);
	        continue;
	      }
	    }
	
	    if (node.type === 'text') {
	      result.push(node.data);
	      continue;
	    }
	
	    props = node.attribs;
	    if (!shouldPassAttributesUnaltered(node)) {
	      // update values
	      props = attributesToProps(node.attribs);
	    }
	
	    children = null;
	
	    // node type for <script> is "script"
	    // node type for <style> is "style"
	    if (node.type === 'script' || node.type === 'style') {
	      // prevent text in <script> or <style> from being escaped
	      // https://facebook.github.io/react/tips/dangerously-set-inner-html.html
	      if (node.children[0]) {
	        props.dangerouslySetInnerHTML = {
	          __html: node.children[0].data
	        };
	      }
	    } else if (node.type === 'tag') {
	      // setting textarea value in children is an antipattern in React
	      // https://reactjs.org/docs/forms.html#the-textarea-tag
	      if (node.name === 'textarea' && node.children[0]) {
	        props.defaultValue = node.children[0].data;
	
	        // continue recursion of creating React elements (if applicable)
	      } else if (node.children && node.children.length) {
	        children = domToReact(node.children, options);
	      }
	
	      // skip all other cases (e.g., comment)
	    } else {
	      continue;
	    }
	
	    // specify a "key" prop if element has siblings
	    // https://fb.me/react-warning-keys
	    if (len > 1) {
	      props.key = i;
	    }
	
	    result.push(createElement(node.name, props, children));
	  }
	
	  return result.length === 1 ? result[0] : result;
	}
	
	function shouldPassAttributesUnaltered(node) {
	  return (
	    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
	    node.type === 'tag' &&
	    utilities.isCustomComponent(node.name, node.attribs)
	  );
	}
	
	module.exports = domToReact;


/***/ }),
/* 873 */,
/* 874 */,
/* 875 */
/***/ (function(module, exports) {

	// http://www.w3.org/TR/CSS21/grammar.html
	// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
	var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
	
	var NEWLINE_REGEX = /\n/g;
	var WHITESPACE_REGEX = /^\s*/;
	
	// declaration
	var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
	var COLON_REGEX = /^:\s*/;
	var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
	var SEMICOLON_REGEX = /^[;\s]*/;
	
	// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
	var TRIM_REGEX = /^\s+|\s+$/g;
	
	// strings
	var NEWLINE = '\n';
	var FORWARD_SLASH = '/';
	var ASTERISK = '*';
	var EMPTY_STRING = '';
	
	// types
	var TYPE_COMMENT = 'comment';
	var TYPE_DECLARATION = 'declaration';
	
	/**
	 * @param {String} style
	 * @param {Object} [options]
	 * @return {Object[]}
	 * @throws {TypeError}
	 * @throws {Error}
	 */
	module.exports = function(style, options) {
	  if (typeof style !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (!style) return [];
	
	  options = options || {};
	
	  /**
	   * Positional.
	   */
	  var lineno = 1;
	  var column = 1;
	
	  /**
	   * Update lineno and column based on `str`.
	   *
	   * @param {String} str
	   */
	  function updatePosition(str) {
	    var lines = str.match(NEWLINE_REGEX);
	    if (lines) lineno += lines.length;
	    var i = str.lastIndexOf(NEWLINE);
	    column = ~i ? str.length - i : column + str.length;
	  }
	
	  /**
	   * Mark position and patch `node.position`.
	   *
	   * @return {Function}
	   */
	  function position() {
	    var start = { line: lineno, column: column };
	    return function(node) {
	      node.position = new Position(start);
	      whitespace();
	      return node;
	    };
	  }
	
	  /**
	   * Store position information for a node.
	   *
	   * @constructor
	   * @property {Object} start
	   * @property {Object} end
	   * @property {undefined|String} source
	   */
	  function Position(start) {
	    this.start = start;
	    this.end = { line: lineno, column: column };
	    this.source = options.source;
	  }
	
	  /**
	   * Non-enumerable source string.
	   */
	  Position.prototype.content = style;
	
	  var errorsList = [];
	
	  /**
	   * Error `msg`.
	   *
	   * @param {String} msg
	   * @throws {Error}
	   */
	  function error(msg) {
	    var err = new Error(
	      options.source + ':' + lineno + ':' + column + ': ' + msg
	    );
	    err.reason = msg;
	    err.filename = options.source;
	    err.line = lineno;
	    err.column = column;
	    err.source = style;
	
	    if (options.silent) {
	      errorsList.push(err);
	    } else {
	      throw err;
	    }
	  }
	
	  /**
	   * Match `re` and return captures.
	   *
	   * @param {RegExp} re
	   * @return {undefined|Array}
	   */
	  function match(re) {
	    var m = re.exec(style);
	    if (!m) return;
	    var str = m[0];
	    updatePosition(str);
	    style = style.slice(str.length);
	    return m;
	  }
	
	  /**
	   * Parse whitespace.
	   */
	  function whitespace() {
	    match(WHITESPACE_REGEX);
	  }
	
	  /**
	   * Parse comments.
	   *
	   * @param {Object[]} [rules]
	   * @return {Object[]}
	   */
	  function comments(rules) {
	    var c;
	    rules = rules || [];
	    while ((c = comment())) {
	      if (c !== false) {
	        rules.push(c);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Parse comment.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function comment() {
	    var pos = position();
	    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
	
	    var i = 2;
	    while (
	      EMPTY_STRING != style.charAt(i) &&
	      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
	    ) {
	      ++i;
	    }
	    i += 2;
	
	    if (EMPTY_STRING === style.charAt(i - 1)) {
	      return error('End of comment missing');
	    }
	
	    var str = style.slice(2, i - 2);
	    column += 2;
	    updatePosition(str);
	    style = style.slice(i);
	    column += 2;
	
	    return pos({
	      type: TYPE_COMMENT,
	      comment: str
	    });
	  }
	
	  /**
	   * Parse declaration.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function declaration() {
	    var pos = position();
	
	    // prop
	    var prop = match(PROPERTY_REGEX);
	    if (!prop) return;
	    comment();
	
	    // :
	    if (!match(COLON_REGEX)) return error("property missing ':'");
	
	    // val
	    var val = match(VALUE_REGEX);
	
	    var ret = pos({
	      type: TYPE_DECLARATION,
	      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
	      value: val
	        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
	        : EMPTY_STRING
	    });
	
	    // ;
	    match(SEMICOLON_REGEX);
	
	    return ret;
	  }
	
	  /**
	   * Parse declarations.
	   *
	   * @return {Object[]}
	   */
	  function declarations() {
	    var decls = [];
	
	    comments(decls);
	
	    // declarations
	    var decl;
	    while ((decl = declaration())) {
	      if (decl !== false) {
	        decls.push(decl);
	        comments(decls);
	      }
	    }
	
	    return decls;
	  }
	
	  whitespace();
	  return declarations();
	};
	
	/**
	 * Trim `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function trim(str) {
	  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
	}


/***/ }),
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = alphabetical
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphabetical. */
	function alphabetical(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 && code <= 122) /* a-z */ ||
	    (code >= 65 && code <= 90) /* A-Z */
	  )
	}


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var alphabetical = __webpack_require__(905)
	var decimal = __webpack_require__(430)
	
	module.exports = alphanumerical
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphanumerical. */
	function alphanumerical(character) {
	  return alphabetical(character) || decimal(character)
	}


/***/ }),
/* 907 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = hexadecimal
	
	/* Check if the given character code, or the character
	 * code at the first character, is hexadecimal. */
	function hexadecimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 /* a */ && code <= 102) /* z */ ||
	    (code >= 65 /* A */ && code <= 70) /* Z */ ||
	    (code >= 48 /* A */ && code <= 57) /* Z */
	  )
	}


/***/ }),
/* 908 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Returns the object type of the given payload
	 *
	 * @param {*} payload
	 * @returns {string}
	 */
	function getType(payload) {
	    return Object.prototype.toString.call(payload).slice(8, -1);
	}
	/**
	 * Returns whether the payload is undefined
	 *
	 * @param {*} payload
	 * @returns {payload is undefined}
	 */
	function isUndefined(payload) {
	    return getType(payload) === 'Undefined';
	}
	/**
	 * Returns whether the payload is null
	 *
	 * @param {*} payload
	 * @returns {payload is null}
	 */
	function isNull(payload) {
	    return getType(payload) === 'Null';
	}
	/**
	 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is {[key: string]: any}}
	 */
	function isPlainObject(payload) {
	    if (getType(payload) !== 'Object')
	        return false;
	    return (payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype);
	}
	/**
	 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is {[key: string]: any}}
	 */
	function isObject(payload) {
	    return isPlainObject(payload);
	}
	/**
	 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is {[key: string]: any}}
	 */
	function isAnyObject(payload) {
	    return getType(payload) === 'Object';
	}
	/**
	 * Returns whether the payload is an object like a type passed in < >
	 *
	 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
	 *
	 * @template T this must be passed in < >
	 * @param {*} payload
	 * @returns {payload is T}
	 */
	function isObjectLike(payload) {
	    return isAnyObject(payload);
	}
	/**
	 * Returns whether the payload is a function
	 *
	 * @param {*} payload
	 * @returns {payload is Function}
	 */
	function isFunction(payload) {
	    return getType(payload) === 'Function';
	}
	/**
	 * Returns whether the payload is an array
	 *
	 * @param {*} payload
	 * @returns {payload is undefined}
	 */
	function isArray(payload) {
	    return getType(payload) === 'Array';
	}
	/**
	 * Returns whether the payload is a string
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isString(payload) {
	    return getType(payload) === 'String';
	}
	/**
	 * Returns whether the payload is a string, BUT returns false for ''
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isFullString(payload) {
	    return isString(payload) && payload !== '';
	}
	/**
	 * Returns whether the payload is ''
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isEmptyString(payload) {
	    return payload === '';
	}
	/**
	 * Returns whether the payload is a number
	 *
	 * This will return false for NaN
	 *
	 * @param {*} payload
	 * @returns {payload is number}
	 */
	function isNumber(payload) {
	    return (getType(payload) === 'Number' && !isNaN(payload));
	}
	/**
	 * Returns whether the payload is a boolean
	 *
	 * @param {*} payload
	 * @returns {payload is boolean}
	 */
	function isBoolean(payload) {
	    return getType(payload) === 'Boolean';
	}
	/**
	 * Returns whether the payload is a regular expression
	 *
	 * @param {*} payload
	 * @returns {payload is RegExp}
	 */
	function isRegExp(payload) {
	    return getType(payload) === 'RegExp';
	}
	/**
	 * Returns whether the payload is a date, and that the date is Valid
	 *
	 * @param {*} payload
	 * @returns {payload is Date}
	 */
	function isDate(payload) {
	    return (getType(payload) === 'Date' && !isNaN(payload));
	}
	/**
	 * Returns whether the payload is a Symbol
	 *
	 * @param {*} payload
	 * @returns {payload is Symbol}
	 */
	function isSymbol(payload) {
	    return (getType(payload) === 'Symbol');
	}
	/**
	 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
	 *
	 * @param {*} payload
	 * @returns {*}
	 */
	function isPrimitive(payload) {
	    return (isBoolean(payload) ||
	        isNull(payload) ||
	        isUndefined(payload) ||
	        isNumber(payload) ||
	        isString(payload) ||
	        isSymbol(payload));
	}
	/**
	 * Does a generic check to check that the given payload is of a given type.
	 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
	 * It will, however, differentiate between object and null
	 *
	 * @template T
	 * @param {*} payload
	 * @param {T} type
	 * @throws {TypeError} Will throw type error if type is an invalid type
	 * @returns {payload is T}
	 */
	function isType(payload, type) {
	    if (!(type instanceof Function)) {
	        throw new TypeError('Type must be a function');
	    }
	    if (!type.hasOwnProperty('prototype')) {
	        throw new TypeError('Type is not a class');
	    }
	    // Classes usually have names (as functions usually have names)
	    var name = type.name;
	    return (getType(payload) === name) || Boolean(payload && (payload.constructor === type));
	}
	
	exports.getType = getType;
	exports.isUndefined = isUndefined;
	exports.isNull = isNull;
	exports.isPlainObject = isPlainObject;
	exports.isObject = isObject;
	exports.isAnyObject = isAnyObject;
	exports.isObjectLike = isObjectLike;
	exports.isFunction = isFunction;
	exports.isArray = isArray;
	exports.isString = isString;
	exports.isFullString = isFullString;
	exports.isEmptyString = isEmptyString;
	exports.isNumber = isNumber;
	exports.isBoolean = isBoolean;
	exports.isRegExp = isRegExp;
	exports.isDate = isDate;
	exports.isSymbol = isSymbol;
	exports.isPrimitive = isPrimitive;
	exports.isType = isType;


/***/ }),
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */
/***/ (function(module, exports) {

	module.exports = {"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	module.exports = {"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}

/***/ }),
/* 968 */,
/* 969 */,
/* 970 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 971 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(264),
	    getRawTag = __webpack_require__(978),
	    objectToString = __webpack_require__(979);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 973 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(264),
	    arrayMap = __webpack_require__(970),
	    isArray = __webpack_require__(984),
	    isSymbol = __webpack_require__(986);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(973);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(975),
	    hasUnicode = __webpack_require__(431),
	    stringToArray = __webpack_require__(981),
	    toString = __webpack_require__(432);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ }),
/* 977 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(264);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 979 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(977);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(971),
	    hasUnicode = __webpack_require__(431),
	    unicodeToArray = __webpack_require__(982);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 982 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(432),
	    upperFirst = __webpack_require__(987);
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	module.exports = capitalize;


/***/ }),
/* 984 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 985 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(972),
	    isObjectLike = __webpack_require__(985);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(976);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';exports.__esModule=!0;var _extends=Object.assign||function(a){for(var b,c=1;c<arguments.length;c++)for(var d in b=arguments[c],b)Object.prototype.hasOwnProperty.call(b,d)&&(a[d]=b[d]);return a},_typeof=typeof Symbol=='function'&&typeof Symbol.iterator=='symbol'?function(a){return typeof a}:function(a){return a&&typeof Symbol=='function'&&a.constructor===Symbol&&a!==Symbol.prototype?'symbol':typeof a};exports.compiler=compiler,exports.default=Markdown;var _react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_unquote=__webpack_require__(1118),_unquote2=_interopRequireDefault(_unquote);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function _objectWithoutProperties(a,b){var c={};for(var d in a)b.indexOf(d)>=0||Object.prototype.hasOwnProperty.call(a,d)&&(c[d]=a[d]);return c}var ATTRIBUTE_TO_JSX_PROP_MAP={accesskey:'accessKey',allowfullscreen:'allowFullScreen',allowtransparency:'allowTransparency',autocomplete:'autoComplete',autofocus:'autoFocus',autoplay:'autoPlay',cellpadding:'cellPadding',cellspacing:'cellSpacing',charset:'charSet',class:'className',classid:'classId',colspan:'colSpan',contenteditable:'contentEditable',contextmenu:'contextMenu',crossorigin:'crossOrigin',enctype:'encType',for:'htmlFor',formaction:'formAction',formenctype:'formEncType',formmethod:'formMethod',formnovalidate:'formNoValidate',formtarget:'formTarget',frameborder:'frameBorder',hreflang:'hrefLang',inputmode:'inputMode',keyparams:'keyParams',keytype:'keyType',marginheight:'marginHeight',marginwidth:'marginWidth',maxlength:'maxLength',mediagroup:'mediaGroup',minlength:'minLength',novalidate:'noValidate',radiogroup:'radioGroup',readonly:'readOnly',rowspan:'rowSpan',spellcheck:'spellCheck',srcdoc:'srcDoc',srclang:'srcLang',srcset:'srcSet',tabindex:'tabIndex',usemap:'useMap'},namedCodesToUnicode={amp:'&',apos:'\'',gt:'>',lt:'<',nbsp:'\xA0',quot:'\u201C'},DO_NOT_PROCESS_HTML_ELEMENTS=['style','script'],ATTR_EXTRACTOR_R=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,AUTOLINK_MAILTO_CHECK_R=/mailto:/i,BLOCK_END_R=/\n{2,}$/,BLOCKQUOTE_R=/^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,BLOCKQUOTE_TRIM_LEFT_MULTILINE_R=/^ *> ?/gm,BREAK_LINE_R=/^ {2,}\n/,BREAK_THEMATIC_R=/^(?:( *[-*_]) *){3,}(?:\n *)+\n/,CODE_BLOCK_FENCED_R=/^\s*(`{3,}|~{3,}) *(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n *)+\n?/,CODE_BLOCK_R=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,CODE_INLINE_R=/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,CONSECUTIVE_NEWLINE_R=/^(?:\n *)*\n/,CR_NEWLINE_R=/\r\n?/g,FOOTNOTE_R=/^\[\^(.*)\](:.*)\n/,FOOTNOTE_REFERENCE_R=/^\[\^(.*)\]/,FORMFEED_R=/\f/g,GFM_TASK_R=/^\s*?\[(x|\s)\]/,HEADING_R=/^ *(#{1,6}) *([^\n]+)\n{0,2}/,HEADING_SETEXT_R=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,HTML_BLOCK_ELEMENT_R=/^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,HTML_CHAR_CODE_R=/&([a-z]+);/g,HTML_COMMENT_R=/^<!--.*?-->/,HTML_CUSTOM_ATTR_R=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,HTML_SELF_CLOSING_ELEMENT_R=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,INTERPOLATION_R=/^\{.*\}$/,LINK_AUTOLINK_BARE_URL_R=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,LINK_AUTOLINK_MAILTO_R=/^<([^ >]+@[^ >]+)>/,LINK_AUTOLINK_R=/^<([^ >]+:\/[^ >]+)>/,LIST_ITEM_END_R=/ *\n+$/,LIST_LOOKBEHIND_R=/(?:^|\n)( *)$/,CAPTURE_LETTER_AFTER_HYPHEN=/-([a-z])?/gi,NP_TABLE_R=/^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,PARAGRAPH_R=/^((?:[^\n]|\n(?! *\n))+)(?:\n *)+\n/,REFERENCE_IMAGE_OR_LINK=/^\[([^\]]*)\]:\s*(\S+)\s*("([^"]*)")?/,REFERENCE_IMAGE_R=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,REFERENCE_LINK_R=/^\[([^\]]*)\] ?\[([^\]]*)\]/,SQUARE_BRACKETS_R=/(\[|\])/g,SHOULD_RENDER_AS_BLOCK_R=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,TAB_R=/\t/g,TABLE_TRIM_PIPES=/(^ *\||\| *$)/g,TABLE_CENTER_ALIGN=/^ *:-+: *$/,TABLE_LEFT_ALIGN=/^ *:-+ *$/,TABLE_RIGHT_ALIGN=/^ *-+: *$/,TABLE_ROW_SPLIT=/ *\| */,TEXT_BOLD_R=/^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,TEXT_EMPHASIZED_R=/^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1)/,TEXT_STRIKETHROUGHED_R=/^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,TEXT_ESCAPED_R=/^\\([^0-9A-Za-z\s])/,TEXT_PLAIN_R=/^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,TRIM_NEWLINES_AND_TRAILING_WHITESPACE_R=/(^\n+|(\n|\s)+$)/g,HTML_LEFT_TRIM_AMOUNT_R=/^([ \t]*)/,UNESCAPE_URL_R=/\\([^0-9A-Z\s])/gi,LIST_BULLET='(?:[*+-]|\\d+\\.)',LIST_ITEM_PREFIX='( *)((?:[*+-]|\\d+\\.)) +',LIST_ITEM_PREFIX_R=/^( *)((?:[*+-]|\d+\.)) +/,LIST_ITEM_R=/( *)((?:[*+-]|\d+\.)) +[^\n]*(?:\n(?!\1(?:[*+-]|\d+\.) )[^\n]*)*(\n|$)/gm,LIST_R=/^( *)((?:[*+-]|\d+\.)) [\s\S]+?(?:\n{2,}(?! )(?!\1(?:[*+-]|\d+\.) (?!(?:[*+-]|\d+\.) ))\n*|\s*\n*$)/,LINK_INSIDE='(?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*',LINK_HREF_AND_TITLE='\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+[\'"]([\\s\\S]*?)[\'"])?\\s*',LINK_R=/^\[((?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*)\]\(\s*<?((?:[^\s\\]|\\.)*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*\)/,IMAGE_R=/^!\[((?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*)\]\(\s*<?((?:[^\s\\]|\\.)*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*\)/,BLOCK_SYNTAXES=[BLOCKQUOTE_R,CODE_BLOCK_R,CODE_BLOCK_FENCED_R,HEADING_R,HEADING_SETEXT_R,HTML_BLOCK_ELEMENT_R,HTML_COMMENT_R,HTML_SELF_CLOSING_ELEMENT_R,LIST_ITEM_R,LIST_R,NP_TABLE_R,PARAGRAPH_R];function containsBlockSyntax(a){return BLOCK_SYNTAXES.some(function(b){return b.test(a)})}function slugify(a){return a.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,'a').replace(/[çÇ]/g,'c').replace(/[ðÐ]/g,'d').replace(/[ÈÉÊËéèêë]/g,'e').replace(/[ÏïÎîÍíÌì]/g,'i').replace(/[Ññ]/g,'n').replace(/[øØœŒÕõÔôÓóÒò]/g,'o').replace(/[ÜüÛûÚúÙù]/g,'u').replace(/[ŸÿÝý]/g,'y').replace(/[^a-z0-9- ]/gi,'').replace(/ /gi,'-').toLowerCase()}function parseTableAlignCapture(a){if(TABLE_RIGHT_ALIGN.test(a))return'right';return TABLE_CENTER_ALIGN.test(a)?'center':TABLE_LEFT_ALIGN.test(a)?'left':null}function parseTableHeader(a,b,c){var d=a[1].replace(TABLE_TRIM_PIPES,'').trim().split(TABLE_ROW_SPLIT);return d.map(function(a){return b(a,c)})}function parseTableAlign(a){var b=a[2].replace(TABLE_TRIM_PIPES,'').trim().split(TABLE_ROW_SPLIT);return b.map(parseTableAlignCapture)}function parseTableCells(a,b,c){var d=a[3].trim().split('\n');return d.map(function(a){return a.replace(TABLE_TRIM_PIPES,'').split(TABLE_ROW_SPLIT).map(function(a){return b(a.trim(),c)})})}function parseTable(a,b,c){c.inline=!0;var d=parseTableHeader(a,b,c),e=parseTableAlign(a,b,c),f=parseTableCells(a,b,c);return c.inline=!1,{align:e,cells:f,header:d,type:'table'}}function getTableStyle(a,b){return a.align[b]==null?{}:{textAlign:a.align[b]}}function normalizeAttributeKey(a){var b=a.indexOf('-');return b!==-1&&a.match(HTML_CUSTOM_ATTR_R)===null&&(a=a.replace(CAPTURE_LETTER_AFTER_HYPHEN,function(a,b){return b.toUpperCase()})),a}function attributeValueToJSXPropValue(a,b){return a==='style'?b.split(/;\s?/).reduce(function(a,b){var c=b.slice(0,b.indexOf(':')),d=c.replace(/(-[a-z])/g,function(a){return a[1].toUpperCase()});return a[d]=b.slice(c.length+1).trim(),a},{}):(b.match(INTERPOLATION_R)&&(b=b.slice(1,b.length-1)),b==='true'||b!=='false'&&b)}function normalizeWhitespace(a){return a.replace(CR_NEWLINE_R,'\n').replace(FORMFEED_R,'').replace(TAB_R,'    ')}function parserFor(a){function b(d,e){for(var f=[],g='';d;)for(var l=0;l<c.length;){var h=c[l],j=a[h],k=j.match(d,e,g);if(k){var i=k[0];d=d.substring(i.length);var m=j.parse(k,b,e);m.type==null&&(m.type=h),f.push(m),g=i;break}l++}return f}var c=Object.keys(a);return ("production")!=='production'&&c.forEach(function(b){var c=a[b].order;("production")==='production'||typeof c=='number'&&isFinite(c)||console.warn('markdown-to-jsx: Invalid order for rule `'+b+'`: '+c)}),c.sort(function(b,c){var d=a[b].order,e=a[c].order;return d===e?b<c?-1:1:d-e}),function(a,c){return b(normalizeWhitespace(a),c)}}function inlineRegex(a){return function(b,c){return c.inline?a.exec(b):null}}function simpleInlineRegex(a){return function(b,c){return c.inline||c.simple?a.exec(b):null}}function blockRegex(a){return function(b,c){return c.inline||c.simple?null:a.exec(b)}}function anyScopeRegex(a){return function(b){return a.exec(b)}}function reactFor(a){return function b(c,d){if(d=d||{},Array.isArray(c)){for(var e=d.key,f=[],g=!1,h=0;h<c.length;h++){d.key=h;var j=b(c[h],d),k=typeof j=='string';k&&g?f[f.length-1]+=j:f.push(j),g=k}return d.key=e,f}return a(c,b,d)}}function sanitizeUrl(a){try{var b=decodeURIComponent(a);if(b.match(/^\s*javascript:/i))return ("production")!=='production'&&console.warn('Anchor URL contains an unsafe JavaScript expression, it will not be rendered.',b),null}catch(b){return ("production")!=='production'&&console.warn('Anchor URL could not be decoded due to malformed syntax or characters, it will not be rendered.',a),null}return a}function unescapeUrl(a){return a.replace(UNESCAPE_URL_R,'$1')}function parseInline(a,b,c){var d=c.inline||!1,e=c.simple||!1;c.inline=!0,c.simple=!0;var f=a(b,c);return c.inline=d,c.simple=e,f}function parseSimpleInline(a,b,c){var d=c.inline||!1,e=c.simple||!1;c.inline=!1,c.simple=!0;var f=a(b,c);return c.inline=d,c.simple=e,f}function parseBlock(a,b,c){return c.inline=!1,a(b+'\n\n',c)}function parseCaptureInline(a,b,c){return{content:parseInline(b,a[1],c)}}function captureNothing(){return{}}function renderNothing(){return null}function ruleOutput(a){return function(b,c,d){return a[b.type].react(b,c,d)}}function cx(){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];return b.filter(Boolean).join(' ')}function get(a,b,c){for(var d=a,e=b.split('.');e.length&&(d=d[e[0]],d!==void 0);)e.shift();return d||c}function getTag(a,b){var c=get(b,a);return c?typeof c=='function'||(typeof c=='undefined'?'undefined':_typeof(c))==='object'&&'render'in c?c:get(b,a+'.component',a):a}var PARSE_PRIORITY_MAX=1,PARSE_PRIORITY_HIGH=2,PARSE_PRIORITY_MED=3,PARSE_PRIORITY_LOW=4,PARSE_PRIORITY_MIN=5;function compiler(a,b){function d(a,c){for(var d=get(b.overrides,a+'.props',{}),e=arguments.length,g=Array(e>2?e-2:0),h=2;h<e;h++)g[h-2]=arguments[h];return f.apply(void 0,[getTag(a,b.overrides),_extends({},c,d,{className:cx(c&&c.className,d.className)||void 0})].concat(g))}function c(a){var c=!1;b.forceInline?c=!0:!b.forceBlock&&(c=SHOULD_RENDER_AS_BLOCK_R.test(a)===!1);var e=k(j(c?a:a.replace(TRIM_NEWLINES_AND_TRAILING_WHITESPACE_R,'')+'\n\n',{inline:c})),f=void 0;return e.length>1?f=c?d('span',{key:'outer'},e):d('div',{key:'outer'},e):e.length===1?(f=e[0],typeof f=='string'&&(f=d('span',{key:'outer'},f))):f=d('span',{key:'outer'}),f}function e(a){var b=a.match(ATTR_EXTRACTOR_R);return b?b.reduce(function(a,b,d){var e=b.indexOf('=');if(e!==-1){var f=normalizeAttributeKey(b.slice(0,e)).trim(),g=(0,_unquote2.default)(b.slice(e+1).trim()),h=ATTRIBUTE_TO_JSX_PROP_MAP[f]||f,i=a[h]=attributeValueToJSXPropValue(f,g);(HTML_BLOCK_ELEMENT_R.test(i)||HTML_SELF_CLOSING_ELEMENT_R.test(i))&&(a[h]=_react2.default.cloneElement(c(i.trim()),{key:d}))}else a[ATTRIBUTE_TO_JSX_PROP_MAP[b]||b]=!0;return a},{}):void 0}b=b||{},b.overrides=b.overrides||{},b.slugify=b.slugify||slugify;var f=b.createElement||_react2.default.createElement;if(false){if(typeof a!='string')throw new Error('markdown-to-jsx: the first argument must be\n                             a string');if(Object.prototype.toString.call(b.overrides)!=='[object Object]')throw new Error('markdown-to-jsx: options.overrides (second argument property) must be\n                             undefined or an object literal with shape:\n                             {\n                                htmltagname: {\n                                    component: string|ReactComponent(optional),\n                                    props: object(optional)\n                                }\n                             }')}var g=[],h={},i={blockQuote:{match:blockRegex(BLOCKQUOTE_R),order:PARSE_PRIORITY_HIGH,parse:function d(a,b,c){return{content:b(a[0].replace(BLOCKQUOTE_TRIM_LEFT_MULTILINE_R,''),c)}},react:function e(a,b,c){return d('blockquote',{key:c.key},b(a.content,c))}},breakLine:{match:anyScopeRegex(BREAK_LINE_R),order:PARSE_PRIORITY_HIGH,parse:captureNothing,react:function e(a,b,c){return d('br',{key:c.key})}},breakThematic:{match:blockRegex(BREAK_THEMATIC_R),order:PARSE_PRIORITY_HIGH,parse:captureNothing,react:function e(a,b,c){return d('hr',{key:c.key})}},codeBlock:{match:blockRegex(CODE_BLOCK_R),order:PARSE_PRIORITY_MAX,parse:function c(a){var b=a[0].replace(/^ {4}/gm,'').replace(/\n+$/,'');return{content:b,lang:void 0}},react:function e(a,b,c){return d('pre',{key:c.key},d('code',{className:a.lang?'lang-'+a.lang:''},a.content))}},codeFenced:{match:blockRegex(CODE_BLOCK_FENCED_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return{content:a[3],lang:a[2]||void 0,type:'codeBlock'}}},codeInline:{match:simpleInlineRegex(CODE_INLINE_R),order:PARSE_PRIORITY_LOW,parse:function b(a){return{content:a[2]}},react:function e(a,b,c){return d('code',{key:c.key},a.content)}},footnote:{match:blockRegex(FOOTNOTE_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return g.push({footnote:a[2],identifier:a[1]}),{}},react:renderNothing},footnoteReference:{match:inlineRegex(FOOTNOTE_REFERENCE_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{content:a[1],target:'#'+a[1]}},react:function e(a,b,c){return d('a',{key:c.key,href:sanitizeUrl(a.target)},d('sup',{key:c.key},a.content))}},gfmTask:{match:inlineRegex(GFM_TASK_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{completed:a[1].toLowerCase()==='x'}},react:function e(a,b,c){return d('input',{checked:a.completed,key:c.key,readOnly:!0,type:'checkbox'})}},heading:{match:blockRegex(HEADING_R),order:PARSE_PRIORITY_HIGH,parse:function e(a,c,d){return{content:parseInline(c,a[2],d),id:b.slugify(a[2]),level:a[1].length}},react:function f(a,b,c){var e='h'+a.level;return d(e,{id:a.id,key:c.key},b(a.content,c))}},headingSetext:{match:blockRegex(HEADING_SETEXT_R),order:PARSE_PRIORITY_MAX,parse:function d(a,b,c){return{content:parseInline(b,a[1],c),level:a[2]==='='?1:2,type:'heading'}}},htmlBlock:{match:anyScopeRegex(HTML_BLOCK_ELEMENT_R),order:PARSE_PRIORITY_HIGH,parse:function k(a,b,c){var d=a[3].match(HTML_LEFT_TRIM_AMOUNT_R),f=d[1],g=new RegExp('^'+f,'gm'),h=a[3].replace(g,''),i=containsBlockSyntax(h)?parseBlock:parseInline,j=DO_NOT_PROCESS_HTML_ELEMENTS.indexOf(a[1])!==-1;return{attrs:e(a[2]),content:j?a[3]:i(b,h,c),noInnerParse:j,tag:a[1]}},react:function e(a,b,c){return d(a.tag,_extends({key:c.key},a.attrs),a.noInnerParse?a.content:b(a.content,c))}},htmlComment:{match:anyScopeRegex(HTML_COMMENT_R),order:PARSE_PRIORITY_HIGH,parse:function a(){return{}},react:renderNothing},htmlSelfClosing:{match:anyScopeRegex(HTML_SELF_CLOSING_ELEMENT_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{attrs:e(a[2]||''),tag:a[1]}},react:function e(a,b,c){return d(a.tag,_extends({},a.attrs,{key:c.key}))}},image:{match:simpleInlineRegex(IMAGE_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{alt:a[1],target:unescapeUrl(a[2]),title:a[3]}},react:function e(a,b,c){return d('img',{key:c.key,alt:a.alt||void 0,title:a.title||void 0,src:sanitizeUrl(a.target)})}},link:{match:inlineRegex(LINK_R,!1),order:PARSE_PRIORITY_LOW,parse:function d(a,b,c){return{content:parseSimpleInline(b,a[1],c),target:unescapeUrl(a[2]),title:a[3]}},react:function e(a,b,c){return d('a',{key:c.key,href:sanitizeUrl(a.target),title:a.title},b(a.content,c))}},linkAngleBraceStyleDetector:{match:inlineRegex(LINK_AUTOLINK_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return{content:[{content:a[1],type:'text'}],target:a[1],type:'link'}}},linkBareUrlDetector:{match:inlineRegex(LINK_AUTOLINK_BARE_URL_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return{content:[{content:a[1],type:'text'}],target:a[1],title:void 0,type:'link'}}},linkMailtoDetector:{match:inlineRegex(LINK_AUTOLINK_MAILTO_R),order:PARSE_PRIORITY_MAX,parse:function d(a){var b=a[1],c=a[1];return AUTOLINK_MAILTO_CHECK_R.test(c)||(c='mailto:'+c),{content:[{content:b.replace('mailto:',''),type:'text'}],target:c,type:'link'}}},list:{match:function f(a,b,c){var d=LIST_LOOKBEHIND_R.exec(c),e=b._list||!b.inline;return d&&e?(a=d[1]+a,LIST_R.exec(a)):null},order:PARSE_PRIORITY_HIGH,parse:function j(a,b,c){var d=a[2],e=d.length>1,f=e?+d:void 0,g=a[0].replace(BLOCK_END_R,'\n').match(LIST_ITEM_R),h=!1,i=g.map(function(a,d){var e=LIST_ITEM_PREFIX_R.exec(a)[0].length,f=new RegExp('^ {1,'+e+'}','gm'),i=a.replace(f,'').replace(LIST_ITEM_PREFIX_R,''),j=d===g.length-1,k=i.indexOf('\n\n')!==-1,l=k||j&&h;h=l;var m=c.inline,n=c._list;c._list=!0;var o;l?(c.inline=!1,o=i.replace(LIST_ITEM_END_R,'\n\n')):(c.inline=!0,o=i.replace(LIST_ITEM_END_R,''));var p=b(o,c);return c.inline=m,c._list=n,p});return{items:i,ordered:e,start:f}},react:function f(a,b,c){var e=a.ordered?'ol':'ul';return d(e,{key:c.key,start:a.start},a.items.map(function(a,e){return d('li',{key:e},b(a,c))}))}},newlineCoalescer:{match:blockRegex(CONSECUTIVE_NEWLINE_R),order:PARSE_PRIORITY_LOW,parse:captureNothing,react:function a(){return'\n'}},paragraph:{match:blockRegex(PARAGRAPH_R),order:PARSE_PRIORITY_LOW,parse:parseCaptureInline,react:function e(a,b,c){return d('p',{key:c.key},b(a.content,c))}},ref:{match:inlineRegex(REFERENCE_IMAGE_OR_LINK),order:PARSE_PRIORITY_MAX,parse:function b(a){return h[a[1]]={target:a[2],title:a[4]},{}},react:renderNothing},refImage:{match:simpleInlineRegex(REFERENCE_IMAGE_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return{alt:a[1]||void 0,ref:a[2]}},react:function e(a,b,c){return d('img',{key:c.key,alt:a.alt,src:sanitizeUrl(h[a.ref].target),title:h[a.ref].title})}},refLink:{match:inlineRegex(REFERENCE_LINK_R),order:PARSE_PRIORITY_MAX,parse:function d(a,b,c){return{content:b(a[1],c),fallbackContent:b(a[0].replace(SQUARE_BRACKETS_R,'\\$1'),c),ref:a[2]}},react:function e(a,b,c){return h[a.ref]?d('a',{key:c.key,href:sanitizeUrl(h[a.ref].target),title:h[a.ref].title},b(a.content,c)):d('span',{key:c.key},b(a.fallbackContent,c))}},table:{match:blockRegex(NP_TABLE_R),order:PARSE_PRIORITY_HIGH,parse:parseTable,react:function f(a,b,e){return d('table',{key:e.key},d('thead',null,d('tr',null,a.header.map(function(c,f){return d('th',{key:f,style:getTableStyle(a,f)},b(c,e))}))),d('tbody',null,a.cells.map(function(c,f){return d('tr',{key:f},c.map(function(f,g){return d('td',{key:g,style:getTableStyle(a,g)},b(f,e))}))})))}},text:{match:anyScopeRegex(TEXT_PLAIN_R),order:PARSE_PRIORITY_MIN,parse:function b(a){return{content:a[0].replace(HTML_CHAR_CODE_R,function(a,b){return namedCodesToUnicode[b]?namedCodesToUnicode[b]:a})}},react:function b(a){return a.content}},textBolded:{match:simpleInlineRegex(TEXT_BOLD_R),order:PARSE_PRIORITY_MED,parse:function d(a,b,c){return{content:b(a[2],c)}},react:function e(a,b,c){return d('strong',{key:c.key},b(a.content,c))}},textEmphasized:{match:simpleInlineRegex(TEXT_EMPHASIZED_R),order:PARSE_PRIORITY_LOW,parse:function d(a,b,c){return{content:b(a[2],c)}},react:function e(a,b,c){return d('em',{key:c.key},b(a.content,c))}},textEscaped:{match:simpleInlineRegex(TEXT_ESCAPED_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{content:a[1],type:'text'}}},textStrikethroughed:{match:simpleInlineRegex(TEXT_STRIKETHROUGHED_R),order:PARSE_PRIORITY_LOW,parse:parseCaptureInline,react:function e(a,b,c){return d('del',{key:c.key},b(a.content,c))}}},j=parserFor(i),k=reactFor(ruleOutput(i)),l=c(a);return g.length&&l.props.children.push(d('footer',{key:'footer'},g.map(function(a){return d('div',{id:a.identifier,key:a.identifier},a.identifier,k(j(a.footnote,{inline:!0})))}))),l}function Markdown(a){var b=a.children,c=a.options,d=_objectWithoutProperties(a,['children','options']);return _react2.default.cloneElement(compiler(b,c),d)}if(false){var PropTypes=require('prop-types');Markdown.propTypes={children:PropTypes.string.isRequired,options:PropTypes.object}}
	
	//# sourceMappingURL=cjs.js.map

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	'use strict';
	
	function areInputsEqual(newInputs, lastInputs) {
	  if (newInputs.length !== lastInputs.length) {
	    return false;
	  }
	
	  for (var i = 0; i < newInputs.length; i++) {
	    if (newInputs[i] !== lastInputs[i]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function index (resultFn, isEqual) {
	  if (isEqual === void 0) {
	    isEqual = areInputsEqual;
	  }
	
	  var lastThis;
	  var lastArgs = [];
	  var lastResult;
	  var calledOnce = false;
	
	  var result = function result() {
	    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
	      newArgs[_key] = arguments[_key];
	    }
	
	    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	      return lastResult;
	    }
	
	    lastResult = resultFn.apply(this, newArgs);
	    calledOnce = true;
	    lastThis = this;
	    lastArgs = newArgs;
	    return lastResult;
	  };
	
	  return result;
	}
	
	module.exports = index;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isWhat = __webpack_require__(908);
	
	function mergeRecursively(origin, newComer, extensions) {
	    // work directly on newComer if its not an object
	    if (!isWhat.isPlainObject(newComer)) {
	        // extend merge rules
	        if (extensions && isWhat.isArray(extensions)) {
	            extensions.forEach(function (extend) {
	                newComer = extend(origin, newComer);
	            });
	        }
	        return newComer;
	    }
	    // define newObject to merge all values upon
	    var newObject = (isWhat.isPlainObject(origin))
	        ? Object.keys(origin)
	            .reduce(function (carry, key) {
	            var targetVal = origin[key];
	            // @ts-ignore
	            if (!Object.keys(newComer).includes(key))
	                carry[key] = targetVal;
	            return carry;
	        }, {})
	        : {};
	    return Object.keys(newComer)
	        .reduce(function (carry, key) {
	        // re-define the origin and newComer as targetVal and newVal
	        var newVal = newComer[key];
	        var targetVal = (isWhat.isPlainObject(origin))
	            ? origin[key]
	            : undefined;
	        // extend merge rules
	        if (extensions && isWhat.isArray(extensions)) {
	            extensions.forEach(function (extend) {
	                newVal = extend(targetVal, newVal);
	            });
	        }
	        // early return when targetVal === undefined
	        if (targetVal === undefined) {
	            carry[key] = newVal;
	            return carry;
	        }
	        // When newVal is an object do the merge recursively
	        if (isWhat.isPlainObject(newVal)) {
	            carry[key] = mergeRecursively(targetVal, newVal, extensions);
	            return carry;
	        }
	        // all the rest
	        carry[key] = newVal;
	        return carry;
	    }, newObject);
	}
	/**
	 * Merge anything recursively.
	 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
	 * Basic types overwrite objects or other basic types.
	 *
	 * @param {(IConfig | any)} origin
	 * @param {...any[]} newComers
	 * @returns the result
	 */
	function index (origin) {
	    var newComers = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        newComers[_i - 1] = arguments[_i];
	    }
	    var extensions = null;
	    var base = origin;
	    if (isWhat.isPlainObject(origin) && origin.extensions && Object.keys(origin).length === 1) {
	        base = {};
	        extensions = origin.extensions;
	    }
	    return newComers.reduce(function (result, newComer) {
	        return mergeRecursively(result, newComer, extensions);
	    }, base);
	}
	
	module.exports = index;


/***/ }),
/* 991 */,
/* 992 */,
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Changes the hue of the color. Hue is a number between 0 to 360. The first
	 * argument for adjustHue is the amount of degrees the color is rotated around
	 * the color wheel, always producing a positive hue value.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: adjustHue(180, '#448'),
	 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${adjustHue(180, '#448')};
	 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#888844";
	 *   background: "rgba(136,136,68,0.7)";
	 * }
	 */
	function adjustHue(degree, color) {
	  if (color === 'transparent') return color;
	  var hslColor = (0, _parseToHsl["default"])(color);
	  return (0, _toColorString["default"])(_extends({}, hslColor, {
	    hue: hslColor.hue + parseFloat(degree)
	  }));
	} // prettier-ignore
	
	
	var curriedAdjustHue =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(adjustHue);
	var _default = curriedAdjustHue;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = complement;
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: complement('#448'),
	 *   background: complement('rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${complement('#448')};
	 *   background: ${complement('rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#884";
	 *   background: "rgba(153,153,153,0.7)";
	 * }
	 */
	function complement(color) {
	  if (color === 'transparent') return color;
	  var hslColor = (0, _parseToHsl["default"])(color);
	  return (0, _toColorString["default"])(_extends({}, hslColor, {
	    hue: (hslColor.hue + 180) % 360
	  }));
	}
	
	module.exports = exports.default;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _guard =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(98));
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Returns a string value for the darkened color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: darken(0.2, '#FFCD64'),
	 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${darken(0.2, '#FFCD64')};
	 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#ffbd31";
	 *   background: "rgba(255,189,49,0.7)";
	 * }
	 */
	function darken(amount, color) {
	  if (color === 'transparent') return color;
	  var hslColor = (0, _parseToHsl["default"])(color);
	  return (0, _toColorString["default"])(_extends({}, hslColor, {
	    lightness: (0, _guard["default"])(0, 1, hslColor.lightness - parseFloat(amount))
	  }));
	} // prettier-ignore
	
	
	var curriedDarken =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(darken);
	var _default = curriedDarken;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _guard =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(98));
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Decreases the intensity of a color. Its range is between 0 to 1. The first
	 * argument of the desaturate function is the amount by how much the color
	 * intensity should be decreased.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: desaturate(0.2, '#CCCD64'),
	 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${desaturate(0.2, '#CCCD64')};
	 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#b8b979";
	 *   background: "rgba(184,185,121,0.7)";
	 * }
	 */
	function desaturate(amount, color) {
	  if (color === 'transparent') return color;
	  var hslColor = (0, _parseToHsl["default"])(color);
	  return (0, _toColorString["default"])(_extends({}, hslColor, {
	    saturation: (0, _guard["default"])(0, 1, hslColor.saturation - parseFloat(amount))
	  }));
	} // prettier-ignore
	
	
	var curriedDesaturate =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(desaturate);
	var _default = curriedDesaturate;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = grayscale;
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Converts the color to a grayscale, by reducing its saturation to 0.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: grayscale('#CCCD64'),
	 *   background: grayscale('rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${grayscale('#CCCD64')};
	 *   background: ${grayscale('rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#999";
	 *   background: "rgba(153,153,153,0.7)";
	 * }
	 */
	function grayscale(color) {
	  if (color === 'transparent') return color;
	  return (0, _toColorString["default"])(_extends({}, (0, _parseToHsl["default"])(color), {
	    saturation: 0
	  }));
	}
	
	module.exports = exports.default;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = hslToColorString;
	
	var _hsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(267));
	
	var _hsla =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(268));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function hslToColorString(color) {
	  if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
	    if (color.alpha && typeof color.alpha === 'number') {
	      return (0, _hsla["default"])({
	        hue: color.hue,
	        saturation: color.saturation,
	        lightness: color.lightness,
	        alpha: color.alpha
	      });
	    }
	
	    return (0, _hsl["default"])({
	      hue: color.hue,
	      saturation: color.saturation,
	      lightness: color.lightness
	    });
	  }
	
	  throw new _errors["default"](45);
	}
	
	module.exports = exports.default;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = invert;
	
	var _parseToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(71));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Inverts the red, green and blue values of a color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: invert('#CCCD64'),
	 *   background: invert('rgba(101,100,205,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${invert('#CCCD64')};
	 *   background: ${invert('rgba(101,100,205,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#33329b";
	 *   background: "rgba(154,155,50,0.7)";
	 * }
	 */
	function invert(color) {
	  if (color === 'transparent') return color; // parse color string to rgb
	
	  var value = (0, _parseToRgb["default"])(color);
	  return (0, _toColorString["default"])(_extends({}, value, {
	    red: 255 - value.red,
	    green: 255 - value.green,
	    blue: 255 - value.blue
	  }));
	}
	
	module.exports = exports.default;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _guard =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(98));
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Returns a string value for the lightened color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: lighten(0.2, '#CCCD64'),
	 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${lighten(0.2, '#FFCD64')};
	 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#e5e6b1";
	 *   background: "rgba(229,230,177,0.7)";
	 * }
	 */
	function lighten(amount, color) {
	  if (color === 'transparent') return color;
	  var hslColor = (0, _parseToHsl["default"])(color);
	  return (0, _toColorString["default"])(_extends({}, hslColor, {
	    lightness: (0, _guard["default"])(0, 1, hslColor.lightness + parseFloat(amount))
	  }));
	} // prettier-ignore
	
	
	var curriedLighten =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(lighten);
	var _default = curriedLighten;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = meetsContrastGuidelines;
	
	var _getContrast =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(434));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function meetsContrastGuidelines(color1, color2) {
	  var contrastRatio = (0, _getContrast["default"])(color1, color2);
	  return {
	    AA: contrastRatio >= 4.5,
	    AALarge: contrastRatio >= 3,
	    AAA: contrastRatio >= 7,
	    AAALarge: contrastRatio >= 4.5
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _guard =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(98));
	
	var _rgba =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(97));
	
	var _parseToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
	 *
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
	 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
	 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
	 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
	 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#fff";
	 *   background: "rgba(255,255,255,0.7)";
	 *   background: "rgba(255,0,0,0.7)";
	 * }
	 */
	function opacify(amount, color) {
	  if (color === 'transparent') return color;
	  var parsedColor = (0, _parseToRgb["default"])(color);
	  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
	
	  var colorWithAlpha = _extends({}, parsedColor, {
	    alpha: (0, _guard["default"])(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
	  });
	
	  return (0, _rgba["default"])(colorWithAlpha);
	} // prettier-ignore
	
	
	var curriedOpacify =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(opacify);
	var _default = curriedOpacify;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = readableColor;
	
	var _getLuminance =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(266));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Returns black or white (or optional light and dark return colors) for best contrast depending on the luminosity of the given color.
	 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   color: readableColor('#000'),
	 *   color: readableColor('black', '#001', '#ff8'),
	 *   color: readableColor('white', '#001', '#ff8'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   color: ${readableColor('#000')};
	 *   color: ${readableColor('black', '#001', '#ff8')};
	 *   color: ${readableColor('white', '#001', '#ff8')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   color: "#fff";
	 *   color: "#ff8";
	 *   color: "#001";
	 * }
	 */
	function readableColor(color, lightReturnColor, darkReturnColor) {
	  if (lightReturnColor === void 0) {
	    lightReturnColor = '#000';
	  }
	
	  if (darkReturnColor === void 0) {
	    darkReturnColor = '#fff';
	  }
	
	  return (0, _getLuminance["default"])(color) > 0.179 ? lightReturnColor : darkReturnColor;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = rgbToColorString;
	
	var _rgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(184));
	
	var _rgba =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(97));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function rgbToColorString(color) {
	  if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
	    if (color.alpha && typeof color.alpha === 'number') {
	      return (0, _rgba["default"])({
	        red: color.red,
	        green: color.green,
	        blue: color.blue,
	        alpha: color.alpha
	      });
	    }
	
	    return (0, _rgb["default"])({
	      red: color.red,
	      green: color.green,
	      blue: color.blue
	    });
	  }
	
	  throw new _errors["default"](46);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _guard =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(98));
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Increases the intensity of a color. Its range is between 0 to 1. The first
	 * argument of the saturate function is the amount by how much the color
	 * intensity should be increased.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: saturate(0.2, '#CCCD64'),
	 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${saturate(0.2, '#FFCD64')};
	 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#e0e250";
	 *   background: "rgba(224,226,80,0.7)";
	 * }
	 */
	function saturate(amount, color) {
	  if (color === 'transparent') return color;
	  var hslColor = (0, _parseToHsl["default"])(color);
	  return (0, _toColorString["default"])(_extends({}, hslColor, {
	    saturation: (0, _guard["default"])(0, 1, hslColor.saturation + parseFloat(amount))
	  }));
	} // prettier-ignore
	
	
	var curriedSaturate =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(saturate);
	var _default = curriedSaturate;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Sets the hue of a color to the provided value. The hue range can be
	 * from 0 and 359.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setHue(42, '#CCCD64'),
	 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setHue(42, '#CCCD64')};
	 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#cdae64";
	 *   background: "rgba(107,100,205,0.7)";
	 * }
	 */
	function setHue(hue, color) {
	  if (color === 'transparent') return color;
	  return (0, _toColorString["default"])(_extends({}, (0, _parseToHsl["default"])(color), {
	    hue: parseFloat(hue)
	  }));
	} // prettier-ignore
	
	
	var curriedSetHue =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(setHue);
	var _default = curriedSetHue;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Sets the lightness of a color to the provided value. The lightness range can be
	 * from 0 and 1.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setLightness(0.2, '#CCCD64'),
	 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setLightness(0.2, '#CCCD64')};
	 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#4d4d19";
	 *   background: "rgba(223,224,159,0.7)";
	 * }
	 */
	function setLightness(lightness, color) {
	  if (color === 'transparent') return color;
	  return (0, _toColorString["default"])(_extends({}, (0, _parseToHsl["default"])(color), {
	    lightness: parseFloat(lightness)
	  }));
	} // prettier-ignore
	
	
	var curriedSetLightness =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(setLightness);
	var _default = curriedSetLightness;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _parseToHsl =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(39));
	
	var _toColorString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(33));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Sets the saturation of a color to the provided value. The saturation range can be
	 * from 0 and 1.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setSaturation(0.2, '#CCCD64'),
	 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setSaturation(0.2, '#CCCD64')};
	 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#adad84";
	 *   background: "rgba(228,229,76,0.7)";
	 * }
	 */
	function setSaturation(saturation, color) {
	  if (color === 'transparent') return color;
	  return (0, _toColorString["default"])(_extends({}, (0, _parseToHsl["default"])(color), {
	    saturation: parseFloat(saturation)
	  }));
	} // prettier-ignore
	
	
	var curriedSetSaturation =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(setSaturation);
	var _default = curriedSetSaturation;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _mix =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(269));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Shades a color by mixing it with black. `shade` can produce
	 * hue shifts, where as `darken` manipulates the luminance channel and therefore
	 * doesn't produce hue shifts.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: shade(0.25, '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${shade(0.25, '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#00003f";
	 * }
	 */
	function shade(percentage, color) {
	  if (color === 'transparent') return color;
	  return (0, _mix["default"])(parseFloat(percentage), 'rgb(0, 0, 0)', color);
	} // prettier-ignore
	
	
	var curriedShade =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(shade);
	var _default = curriedShade;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _mix =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(269));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Tints a color by mixing it with white. `tint` can produce
	 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
	 * doesn't produce hue shifts.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: tint(0.25, '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${tint(0.25, '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#bfbfff";
	 * }
	 */
	function tint(percentage, color) {
	  if (color === 'transparent') return color;
	  return (0, _mix["default"])(parseFloat(percentage), 'rgb(255, 255, 255)', color);
	} // prettier-ignore
	
	
	var curriedTint =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(tint);
	var _default = curriedTint;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _curry =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(28));
	
	var _guard =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(98));
	
	var _rgba =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(97));
	
	var _parseToRgb =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	/**
	 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
	 *
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: transparentize(0.1, '#fff');
	 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
	 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${transparentize(0.1, '#fff')};
	 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
	 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(255,255,255,0.9)";
	 *   background: "rgba(255,255,255,0.8)";
	 *   background: "rgba(255,0,0,0.3)";
	 * }
	 */
	function transparentize(amount, color) {
	  if (color === 'transparent') return color;
	  var parsedColor = (0, _parseToRgb["default"])(color);
	  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
	
	  var colorWithAlpha = _extends({}, parsedColor, {
	    alpha: (0, _guard["default"])(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
	  });
	
	  return (0, _rgba["default"])(colorWithAlpha);
	} // prettier-ignore
	
	
	var curriedTransparentize =
	/*#__PURE__*/
	(0, _curry["default"]
	/* ::<number | string, string, string> */
	)(transparentize);
	var _default = curriedTransparentize;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _pxto =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(438));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
	 * second argument to the function.
	 * @function
	 * @param {string|number} pxval
	 * @param {string|number} [base='16px']
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'height': em('16px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   height: ${em('16px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'height': '1em'
	 * }
	 */
	var em =
	/*#__PURE__*/
	(0, _pxto["default"])('em');
	var _default = em;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = getValueAndUnit;
	var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
	/**
	 * Returns a given CSS value and its unit as elements of an array.
	 *
	 * @deprecated - getValueAndUnit has been marked for deprecation in polished 3.0 and will be fully deprecated in 4.0. It's functionality has been been moved to stripUnit as an optional return.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   '--dimension': getValueAndUnit('100px')[0],
	 *   '--unit': getValueAndUnit('100px')[1],
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   --dimension: ${getValueAndUnit('100px')[0]};
	 *   --unit: ${getValueAndUnit('100px')[1]};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   '--dimension': 100,
	 *   '--unit': 'px',
	 * }
	 */
	
	function getValueAndUnit(value) {
	  // eslint-disable-next-line no-console
	  console.warn("getValueAndUnit has been marked for deprecation in polished 3.0 and will be fully deprecated in 4.0. It's functionality has been been moved to stripUnit as an optional return.");
	  if (typeof value !== 'string') return [value, ''];
	  var matchedValue = value.match(cssRegex);
	  if (matchedValue) return [parseFloat(value), matchedValue[2]];
	  return [value, undefined];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = modularScale;
	exports.ratioNames = void 0;
	
	var _stripUnit =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(129));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var ratioNames = {
	  minorSecond: 1.067,
	  majorSecond: 1.125,
	  minorThird: 1.2,
	  majorThird: 1.25,
	  perfectFourth: 1.333,
	  augFourth: 1.414,
	  perfectFifth: 1.5,
	  minorSixth: 1.6,
	  goldenSection: 1.618,
	  majorSixth: 1.667,
	  minorSeventh: 1.778,
	  majorSeventh: 1.875,
	  octave: 2,
	  majorTenth: 2.5,
	  majorEleventh: 2.667,
	  majorTwelfth: 3,
	  doubleOctave: 4
	};
	exports.ratioNames = ratioNames;
	
	function getRatio(ratioName) {
	  return ratioNames[ratioName];
	}
	/**
	 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    // Increment two steps up the default scale
	 *   'fontSize': modularScale(2)
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *    // Increment two steps up the default scale
	 *   fontSize: ${modularScale(2)}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'fontSize': '1.77689em'
	 * }
	 */
	
	
	function modularScale(steps, base, ratio) {
	  if (base === void 0) {
	    base = '1em';
	  }
	
	  if (ratio === void 0) {
	    ratio = 1.333;
	  }
	
	  if (typeof steps !== 'number') {
	    throw new _errors["default"](42);
	  }
	
	  if (typeof ratio === 'string' && !ratioNames[ratio]) {
	    throw new _errors["default"](43);
	  }
	
	  var _ref = typeof base === 'string' ? (0, _stripUnit["default"])(base, true) : [base, ''],
	      realBase = _ref[0],
	      unit = _ref[1];
	
	  var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;
	
	  if (typeof realBase === 'string') {
	    throw new _errors["default"](44, base);
	  }
	
	  return "" + realBase * Math.pow(realRatio, steps) + unit;
	}

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _pxto =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(438));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
	 * second argument to the function.
	 * @function
	 * @param {string|number} pxval
	 * @param {string|number} [base='16px']
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'height': rem('16px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   height: ${rem('16px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'height': '1rem'
	 * }
	 */
	var rem =
	/*#__PURE__*/
	(0, _pxto["default"])('rem');
	var _default = rem;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = _default;
	
	/**
	 * Check if a string ends with something
	 * @private
	 */
	function _default(string, suffix) {
	  return string.substr(-suffix.length) === suffix;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	var namedColorMap = {
	  aliceblue: 'f0f8ff',
	  antiquewhite: 'faebd7',
	  aqua: '00ffff',
	  aquamarine: '7fffd4',
	  azure: 'f0ffff',
	  beige: 'f5f5dc',
	  bisque: 'ffe4c4',
	  black: '000',
	  blanchedalmond: 'ffebcd',
	  blue: '0000ff',
	  blueviolet: '8a2be2',
	  brown: 'a52a2a',
	  burlywood: 'deb887',
	  cadetblue: '5f9ea0',
	  chartreuse: '7fff00',
	  chocolate: 'd2691e',
	  coral: 'ff7f50',
	  cornflowerblue: '6495ed',
	  cornsilk: 'fff8dc',
	  crimson: 'dc143c',
	  cyan: '00ffff',
	  darkblue: '00008b',
	  darkcyan: '008b8b',
	  darkgoldenrod: 'b8860b',
	  darkgray: 'a9a9a9',
	  darkgreen: '006400',
	  darkgrey: 'a9a9a9',
	  darkkhaki: 'bdb76b',
	  darkmagenta: '8b008b',
	  darkolivegreen: '556b2f',
	  darkorange: 'ff8c00',
	  darkorchid: '9932cc',
	  darkred: '8b0000',
	  darksalmon: 'e9967a',
	  darkseagreen: '8fbc8f',
	  darkslateblue: '483d8b',
	  darkslategray: '2f4f4f',
	  darkslategrey: '2f4f4f',
	  darkturquoise: '00ced1',
	  darkviolet: '9400d3',
	  deeppink: 'ff1493',
	  deepskyblue: '00bfff',
	  dimgray: '696969',
	  dimgrey: '696969',
	  dodgerblue: '1e90ff',
	  firebrick: 'b22222',
	  floralwhite: 'fffaf0',
	  forestgreen: '228b22',
	  fuchsia: 'ff00ff',
	  gainsboro: 'dcdcdc',
	  ghostwhite: 'f8f8ff',
	  gold: 'ffd700',
	  goldenrod: 'daa520',
	  gray: '808080',
	  green: '008000',
	  greenyellow: 'adff2f',
	  grey: '808080',
	  honeydew: 'f0fff0',
	  hotpink: 'ff69b4',
	  indianred: 'cd5c5c',
	  indigo: '4b0082',
	  ivory: 'fffff0',
	  khaki: 'f0e68c',
	  lavender: 'e6e6fa',
	  lavenderblush: 'fff0f5',
	  lawngreen: '7cfc00',
	  lemonchiffon: 'fffacd',
	  lightblue: 'add8e6',
	  lightcoral: 'f08080',
	  lightcyan: 'e0ffff',
	  lightgoldenrodyellow: 'fafad2',
	  lightgray: 'd3d3d3',
	  lightgreen: '90ee90',
	  lightgrey: 'd3d3d3',
	  lightpink: 'ffb6c1',
	  lightsalmon: 'ffa07a',
	  lightseagreen: '20b2aa',
	  lightskyblue: '87cefa',
	  lightslategray: '789',
	  lightslategrey: '789',
	  lightsteelblue: 'b0c4de',
	  lightyellow: 'ffffe0',
	  lime: '0f0',
	  limegreen: '32cd32',
	  linen: 'faf0e6',
	  magenta: 'f0f',
	  maroon: '800000',
	  mediumaquamarine: '66cdaa',
	  mediumblue: '0000cd',
	  mediumorchid: 'ba55d3',
	  mediumpurple: '9370db',
	  mediumseagreen: '3cb371',
	  mediumslateblue: '7b68ee',
	  mediumspringgreen: '00fa9a',
	  mediumturquoise: '48d1cc',
	  mediumvioletred: 'c71585',
	  midnightblue: '191970',
	  mintcream: 'f5fffa',
	  mistyrose: 'ffe4e1',
	  moccasin: 'ffe4b5',
	  navajowhite: 'ffdead',
	  navy: '000080',
	  oldlace: 'fdf5e6',
	  olive: '808000',
	  olivedrab: '6b8e23',
	  orange: 'ffa500',
	  orangered: 'ff4500',
	  orchid: 'da70d6',
	  palegoldenrod: 'eee8aa',
	  palegreen: '98fb98',
	  paleturquoise: 'afeeee',
	  palevioletred: 'db7093',
	  papayawhip: 'ffefd5',
	  peachpuff: 'ffdab9',
	  peru: 'cd853f',
	  pink: 'ffc0cb',
	  plum: 'dda0dd',
	  powderblue: 'b0e0e6',
	  purple: '800080',
	  rebeccapurple: '639',
	  red: 'f00',
	  rosybrown: 'bc8f8f',
	  royalblue: '4169e1',
	  saddlebrown: '8b4513',
	  salmon: 'fa8072',
	  sandybrown: 'f4a460',
	  seagreen: '2e8b57',
	  seashell: 'fff5ee',
	  sienna: 'a0522d',
	  silver: 'c0c0c0',
	  skyblue: '87ceeb',
	  slateblue: '6a5acd',
	  slategray: '708090',
	  slategrey: '708090',
	  snow: 'fffafa',
	  springgreen: '00ff7f',
	  steelblue: '4682b4',
	  tan: 'd2b48c',
	  teal: '008080',
	  thistle: 'd8bfd8',
	  tomato: 'ff6347',
	  turquoise: '40e0d0',
	  violet: 'ee82ee',
	  wheat: 'f5deb3',
	  white: 'fff',
	  whitesmoke: 'f5f5f5',
	  yellow: 'ff0',
	  yellowgreen: '9acd32'
	};
	/**
	 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
	 * @private
	 */
	
	function nameToHex(color) {
	  if (typeof color !== 'string') return color;
	  var normalizedColorName = color.toLowerCase();
	  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
	}
	
	var _default = nameToHex;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function rgbToHsl(color) {
	  // make sure rgb are contained in a set of [0, 255]
	  var red = color.red / 255;
	  var green = color.green / 255;
	  var blue = color.blue / 255;
	  var max = Math.max(red, green, blue);
	  var min = Math.min(red, green, blue);
	  var lightness = (max + min) / 2;
	
	  if (max === min) {
	    // achromatic
	    if (color.alpha !== undefined) {
	      return {
	        hue: 0,
	        saturation: 0,
	        lightness: lightness,
	        alpha: color.alpha
	      };
	    } else {
	      return {
	        hue: 0,
	        saturation: 0,
	        lightness: lightness
	      };
	    }
	  }
	
	  var hue;
	  var delta = max - min;
	  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
	
	  switch (max) {
	    case red:
	      hue = (green - blue) / delta + (green < blue ? 6 : 0);
	      break;
	
	    case green:
	      hue = (blue - red) / delta + 2;
	      break;
	
	    default:
	      // blue case
	      hue = (red - green) / delta + 4;
	      break;
	  }
	
	  hue *= 60;
	
	  if (color.alpha !== undefined) {
	    return {
	      hue: hue,
	      saturation: saturation,
	      lightness: lightness,
	      alpha: color.alpha
	    };
	  }
	
	  return {
	    hue: hue,
	    saturation: saturation,
	    lightness: lightness
	  };
	}
	
	var _default = rgbToHsl;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function last() {
	  var _ref;
	
	  return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
	}
	
	function negation(a) {
	  return -a;
	}
	
	function addition(a, b) {
	  return a + b;
	}
	
	function subtraction(a, b) {
	  return a - b;
	}
	
	function multiplication(a, b) {
	  return a * b;
	}
	
	function division(a, b) {
	  return a / b;
	}
	
	function factorial(a) {
	  if (a % 1 || !(+a >= 0)) return NaN;
	  if (a > 170) return Infinity;else if (a === 0) return 1;else {
	    return a * factorial(a - 1);
	  }
	}
	
	function power(a, b) {
	  return Math.pow(a, b);
	}
	
	function sqrt(a) {
	  return Math.sqrt(a);
	}
	
	function max() {
	  return Math.max.apply(Math, arguments);
	}
	
	function min() {
	  return Math.min.apply(Math, arguments);
	}
	
	function comma() {
	  return Array.of.apply(Array, arguments);
	}
	
	var defaultMathSymbols = {
	  symbols: {
	    '!': {
	      postfix: {
	        symbol: '!',
	        f: factorial,
	        notation: 'postfix',
	        precedence: 6,
	        rightToLeft: 0,
	        argCount: 1
	      },
	      symbol: '!',
	      regSymbol: '!'
	    },
	    '^': {
	      infix: {
	        symbol: '^',
	        f: power,
	        notation: 'infix',
	        precedence: 5,
	        rightToLeft: 1,
	        argCount: 2
	      },
	      symbol: '^',
	      regSymbol: '\\^'
	    },
	    '*': {
	      infix: {
	        symbol: '*',
	        f: multiplication,
	        notation: 'infix',
	        precedence: 4,
	        rightToLeft: 0,
	        argCount: 2
	      },
	      symbol: '*',
	      regSymbol: '\\*'
	    },
	    '/': {
	      infix: {
	        symbol: '/',
	        f: division,
	        notation: 'infix',
	        precedence: 4,
	        rightToLeft: 0,
	        argCount: 2
	      },
	      symbol: '/',
	      regSymbol: '/'
	    },
	    '+': {
	      infix: {
	        symbol: '+',
	        f: addition,
	        notation: 'infix',
	        precedence: 2,
	        rightToLeft: 0,
	        argCount: 2
	      },
	      prefix: {
	        symbol: '+',
	        f: last,
	        notation: 'prefix',
	        precedence: 3,
	        rightToLeft: 0,
	        argCount: 1
	      },
	      symbol: '+',
	      regSymbol: '\\+'
	    },
	    '-': {
	      infix: {
	        symbol: '-',
	        f: subtraction,
	        notation: 'infix',
	        precedence: 2,
	        rightToLeft: 0,
	        argCount: 2
	      },
	      prefix: {
	        symbol: '-',
	        f: negation,
	        notation: 'prefix',
	        precedence: 3,
	        rightToLeft: 0,
	        argCount: 1
	      },
	      symbol: '-',
	      regSymbol: '-'
	    },
	    ',': {
	      infix: {
	        symbol: ',',
	        f: comma,
	        notation: 'infix',
	        precedence: 1,
	        rightToLeft: 0,
	        argCount: 2
	      },
	      symbol: ',',
	      regSymbol: ','
	    },
	    '(': {
	      prefix: {
	        symbol: '(',
	        f: last,
	        notation: 'prefix',
	        precedence: 0,
	        rightToLeft: 0,
	        argCount: 1
	      },
	      symbol: '(',
	      regSymbol: '\\('
	    },
	    ')': {
	      postfix: {
	        symbol: ')',
	        f: undefined,
	        notation: 'postfix',
	        precedence: 0,
	        rightToLeft: 0,
	        argCount: 1
	      },
	      symbol: ')',
	      regSymbol: '\\)'
	    },
	    min: {
	      func: {
	        symbol: 'min',
	        f: min,
	        notation: 'func',
	        precedence: 0,
	        rightToLeft: 0,
	        argCount: 1
	      },
	      symbol: 'min',
	      regSymbol: 'min\\b'
	    },
	    max: {
	      func: {
	        symbol: 'max',
	        f: max,
	        notation: 'func',
	        precedence: 0,
	        rightToLeft: 0,
	        argCount: 1
	      },
	      symbol: 'max',
	      regSymbol: 'max\\b'
	    },
	    sqrt: {
	      func: {
	        symbol: 'sqrt',
	        f: sqrt,
	        notation: 'func',
	        precedence: 0,
	        rightToLeft: 0,
	        argCount: 1
	      },
	      symbol: 'sqrt',
	      regSymbol: 'sqrt\\b'
	    }
	  }
	};
	var _default = defaultMathSymbols;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = math;
	
	var _defaultMathSymbols =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(1019));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g; // Merges additional math functionality into the defaults.
	
	function mergeSymbolMaps(additionalSymbols) {
	  var symbolMap = {};
	  symbolMap.symbols = additionalSymbols ? _extends({}, _defaultMathSymbols["default"].symbols, {}, additionalSymbols.symbols) : _extends({}, _defaultMathSymbols["default"].symbols);
	  return symbolMap;
	}
	
	function exec(operators, values) {
	  var _ref;
	
	  var op = operators.pop();
	  values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
	  return op.precedence;
	}
	
	function calculate(expression, additionalSymbols) {
	  var symbolMap = mergeSymbolMaps(additionalSymbols);
	  var match;
	  var operators = [symbolMap.symbols['('].prefix];
	  var values = [];
	  var pattern = new RegExp( // Pattern for numbers
	  "\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
	  Object.keys(symbolMap.symbols).map(function (key) {
	    return symbolMap.symbols[key];
	  }) // longer symbols should be listed first
	  // $FlowFixMe
	  .sort(function (a, b) {
	    return b.symbol.length - a.symbol.length;
	  }) // $FlowFixMe
	  .map(function (val) {
	    return val.regSymbol;
	  }).join('|') + "|(\\S)", 'g');
	  pattern.lastIndex = 0; // Reset regular expression object
	
	  var afterValue = false;
	
	  do {
	    match = pattern.exec(expression);
	
	    var _ref2 = match || [')', undefined],
	        token = _ref2[0],
	        bad = _ref2[1];
	
	    var notNumber = symbolMap.symbols[token];
	    var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
	    var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix; // Check for syntax errors:
	
	    if (bad || (afterValue ? notAfterValue : notNewValue)) {
	      throw new _errors["default"](37, match ? match.index : expression.length, expression);
	    }
	
	    if (afterValue) {
	      // We either have an infix or postfix operator (they should be mutually exclusive)
	      var curr = notNumber.postfix || notNumber.infix;
	
	      do {
	        var prev = operators[operators.length - 1];
	        if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break; // Apply previous operator, since it has precedence over current one
	      } while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function
	
	
	      afterValue = curr.notation === 'postfix';
	
	      if (curr.symbol !== ')') {
	        operators.push(curr); // Postfix always has precedence over any operator that follows after it
	
	        if (afterValue) exec(operators, values);
	      }
	    } else if (notNumber) {
	      // prefix operator or function
	      operators.push(notNumber.prefix || notNumber.func);
	
	      if (notNumber.func) {
	        // Require an opening parenthesis
	        match = pattern.exec(expression);
	
	        if (!match || match[0] !== '(') {
	          throw new _errors["default"](38, match ? match.index : expression.length, expression);
	        }
	      }
	    } else {
	      // number
	      values.push(+token);
	      afterValue = true;
	    }
	  } while (match && operators.length);
	
	  if (operators.length) {
	    throw new _errors["default"](39, match ? match.index : expression.length, expression);
	  } else if (match) {
	    throw new _errors["default"](40, match ? match.index : expression.length, expression);
	  } else {
	    return values.pop();
	  }
	}
	
	function reverseString(str) {
	  return str.split('').reverse().join('');
	}
	/**
	 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
	 *
	 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
	 *
	 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   fontSize: math('12rem + 8rem'),
	 *   fontSize: math('(12px + 2px) * 3'),
	 *   fontSize: math('3px^2 + sqrt(4)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   fontSize: ${math('12rem + 8rem')};
	 *   fontSize: ${math('(12px + 2px) * 3')};
	 *   fontSize: ${math('3px^2 + sqrt(4)')};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div: {
	 *   fontSize: '20rem',
	 *   fontSize: '42px',
	 *   fontSize: '11px',
	 * }
	 */
	
	
	function math(formula, additionalSymbols) {
	  var reversedFormula = reverseString(formula);
	  var formulaMatch = reversedFormula.match(unitRegExp); // Check that all units are the same
	
	  if (formulaMatch && !formulaMatch.every(function (unit) {
	    return unit === formulaMatch[0];
	  })) {
	    throw new _errors["default"](41);
	  }
	
	  var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
	  return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
	}
	
	module.exports = exports.default;

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = clearFix;
	
	function clearFix(parent) {
	  var _ref;
	
	  if (parent === void 0) {
	    parent = '&';
	  }
	
	  var pseudoSelector = parent + "::after";
	  return _ref = {}, _ref[pseudoSelector] = {
	    clear: 'both',
	    content: '""',
	    display: 'table'
	  }, _ref;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = cover;
	
	function cover(offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  return {
	    position: 'absolute',
	    top: offset,
	    right: offset,
	    bottom: offset,
	    left: offset
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ellipsis;
	
	function ellipsis(width) {
	  if (width === void 0) {
	    width = '100%';
	  }
	
	  return {
	    display: 'inline-block',
	    maxWidth: width,
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    wordWrap: 'normal'
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = fluidRange;
	
	var _between =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(441));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function fluidRange(cssProp, minScreen, maxScreen) {
	  if (minScreen === void 0) {
	    minScreen = '320px';
	  }
	
	  if (maxScreen === void 0) {
	    maxScreen = '1200px';
	  }
	
	  if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) {
	    throw new _errors["default"](49);
	  }
	
	  if (Array.isArray(cssProp)) {
	    var mediaQueries = {};
	    var fallbacks = {};
	
	    for (var _iterator = cssProp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _extends2, _extends3;
	
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var obj = _ref;
	
	      if (!obj.prop || !obj.fromSize || !obj.toSize) {
	        throw new _errors["default"](50);
	      }
	
	      fallbacks[obj.prop] = obj.fromSize;
	      mediaQueries["@media (min-width: " + minScreen + ")"] = _extends({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = (0, _between["default"])(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
	      mediaQueries["@media (min-width: " + maxScreen + ")"] = _extends({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
	    }
	
	    return _extends({}, fallbacks, {}, mediaQueries);
	  } else {
	    var _ref2, _ref3, _ref4;
	
	    if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) {
	      throw new _errors["default"](51);
	    }
	
	    return _ref4 = {}, _ref4[cssProp.prop] = cssProp.fromSize, _ref4["@media (min-width: " + minScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = (0, _between["default"])(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref2), _ref4["@media (min-width: " + maxScreen + ")"] = (_ref3 = {}, _ref3[cssProp.prop] = cssProp.toSize, _ref3), _ref4;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = fontFace;
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
	var formatHintMap = {
	  woff: 'woff',
	  woff2: 'woff2',
	  ttf: 'truetype',
	  otf: 'opentype',
	  eot: 'embedded-opentype',
	  svg: 'svg',
	  svgz: 'svg'
	};
	
	function generateFormatHint(format, formatHint) {
	  if (!formatHint) return '';
	  return " format(\"" + formatHintMap[format] + "\")";
	}
	
	function isDataURI(fontFilePath) {
	  return !!fontFilePath.match(dataURIRegex);
	}
	
	function generateFileReferences(fontFilePath, fileFormats, formatHint) {
	  if (isDataURI(fontFilePath)) {
	    return "url(\"" + fontFilePath + "\")" + generateFormatHint(fileFormats[0], formatHint);
	  }
	
	  var fileFontReferences = fileFormats.map(function (format) {
	    return "url(\"" + fontFilePath + "." + format + "\")" + generateFormatHint(format, formatHint);
	  });
	  return fileFontReferences.join(', ');
	}
	
	function generateLocalReferences(localFonts) {
	  var localFontReferences = localFonts.map(function (font) {
	    return "local(\"" + font + "\")";
	  });
	  return localFontReferences.join(', ');
	}
	
	function generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
	  var fontReferences = [];
	  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
	
	  if (fontFilePath) {
	    fontReferences.push(generateFileReferences(fontFilePath, fileFormats, formatHint));
	  }
	
	  return fontReferences.join(', ');
	}
	/**
	 * CSS for a @font-face declaration.
	 *
	 * @example
	 * // Styles as object basic usage
	 * const styles = {
	 *    ...fontFace({
	 *      'fontFamily': 'Sans-Pro',
	 *      'fontFilePath': 'path/to/file'
	 *    })
	 * }
	 *
	 * // styled-components basic usage
	 * const GlobalStyle = createGlobalStyle`${
	 *   fontFace({
	 *     'fontFamily': 'Sans-Pro',
	 *     'fontFilePath': 'path/to/file'
	 *   }
	 * )}`
	 *
	 * // CSS as JS Output
	 *
	 * '@font-face': {
	 *   'fontFamily': 'Sans-Pro',
	 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
	 * }
	 */
	
	
	function fontFace(_ref) {
	  var fontFamily = _ref.fontFamily,
	      fontFilePath = _ref.fontFilePath,
	      fontStretch = _ref.fontStretch,
	      fontStyle = _ref.fontStyle,
	      fontVariant = _ref.fontVariant,
	      fontWeight = _ref.fontWeight,
	      _ref$fileFormats = _ref.fileFormats,
	      fileFormats = _ref$fileFormats === void 0 ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
	      _ref$formatHint = _ref.formatHint,
	      formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint,
	      localFonts = _ref.localFonts,
	      unicodeRange = _ref.unicodeRange,
	      fontDisplay = _ref.fontDisplay,
	      fontVariationSettings = _ref.fontVariationSettings,
	      fontFeatureSettings = _ref.fontFeatureSettings;
	  // Error Handling
	  if (!fontFamily) throw new _errors["default"](55);
	
	  if (!fontFilePath && !localFonts) {
	    throw new _errors["default"](52);
	  }
	
	  if (localFonts && !Array.isArray(localFonts)) {
	    throw new _errors["default"](53);
	  }
	
	  if (!Array.isArray(fileFormats)) {
	    throw new _errors["default"](54);
	  }
	
	  var fontFaceDeclaration = {
	    '@font-face': {
	      fontFamily: fontFamily,
	      src: generateSources(fontFilePath, localFonts, fileFormats, formatHint),
	      unicodeRange: unicodeRange,
	      fontStretch: fontStretch,
	      fontStyle: fontStyle,
	      fontVariant: fontVariant,
	      fontWeight: fontWeight,
	      fontDisplay: fontDisplay,
	      fontVariationSettings: fontVariationSettings,
	      fontFeatureSettings: fontFeatureSettings
	    }
	  }; // Removes undefined fields for cleaner css object.
	
	  return JSON.parse(JSON.stringify(fontFaceDeclaration));
	}
	
	module.exports = exports.default;

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = hideText;
	
	function hideText() {
	  return {
	    textIndent: '101%',
	    overflow: 'hidden',
	    whiteSpace: 'nowrap'
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = hideVisually;
	
	function hideVisually() {
	  return {
	    border: '0',
	    clip: 'rect(0 0 0 0)',
	    clipPath: 'inset(50%)',
	    height: '1px',
	    margin: '-1px',
	    overflow: 'hidden',
	    padding: '0',
	    position: 'absolute',
	    whiteSpace: 'nowrap',
	    width: '1px'
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = linearGradient;
	
	var _constructGradientValue =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(435));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _templateObject() {
	  var data = _taggedTemplateLiteralLoose(["linear-gradient(", "", ")"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
	
	function linearGradient(_ref) {
	  var colorStops = _ref.colorStops,
	      fallback = _ref.fallback,
	      _ref$toDirection = _ref.toDirection,
	      toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;
	
	  if (!colorStops || colorStops.length < 2) {
	    throw new _errors["default"](56);
	  }
	
	  return {
	    backgroundColor: fallback || colorStops[0].split(' ')[0],
	    backgroundImage: (0, _constructGradientValue["default"])(_templateObject(), toDirection, colorStops.join(', '))
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = normalize;
	
	function normalize() {
	  var _ref;
	
	  return [(_ref = {
	    html: {
	      lineHeight: '1.15',
	      textSizeAdjust: '100%'
	    },
	    body: {
	      margin: '0'
	    },
	    h1: {
	      fontSize: '2em',
	      margin: '0.67em 0'
	    },
	    hr: {
	      boxSizing: 'content-box',
	      height: '0',
	      overflow: 'visible'
	    },
	    pre: {
	      fontFamily: 'monospace, monospace',
	      fontSize: '1em'
	    },
	    a: {
	      backgroundColor: 'transparent'
	    },
	    'abbr[title]': {
	      borderBottom: 'none',
	      textDecoration: 'underline'
	    }
	  }, _ref["b,\n    strong"] = {
	    fontWeight: 'bolder'
	  }, _ref["code,\n    kbd,\n    samp"] = {
	    fontFamily: 'monospace, monospace',
	    fontSize: '1em'
	  }, _ref.small = {
	    fontSize: '80%'
	  }, _ref["sub,\n    sup"] = {
	    fontSize: '75%',
	    lineHeight: '0',
	    position: 'relative',
	    verticalAlign: 'baseline'
	  }, _ref.sub = {
	    bottom: '-0.25em'
	  }, _ref.sup = {
	    top: '-0.5em'
	  }, _ref.img = {
	    borderStyle: 'none'
	  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
	    fontFamily: 'inherit',
	    fontSize: '100%',
	    lineHeight: '1.15',
	    margin: '0'
	  }, _ref["button,\n    input"] = {
	    overflow: 'visible'
	  }, _ref["button,\n    select"] = {
	    textTransform: 'none'
	  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
	    WebkitAppearance: 'button'
	  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
	    borderStyle: 'none',
	    padding: '0'
	  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
	    outline: '1px dotted ButtonText'
	  }, _ref.fieldset = {
	    padding: '0.35em 0.625em 0.75em'
	  }, _ref.legend = {
	    boxSizing: 'border-box',
	    color: 'inherit',
	    display: 'table',
	    maxWidth: '100%',
	    padding: '0',
	    whiteSpace: 'normal'
	  }, _ref.progress = {
	    verticalAlign: 'baseline'
	  }, _ref.textarea = {
	    overflow: 'auto'
	  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
	    boxSizing: 'border-box',
	    padding: '0'
	  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
	    height: 'auto'
	  }, _ref['[type="search"]'] = {
	    WebkitAppearance: 'textfield',
	    outlineOffset: '-2px'
	  }, _ref['[type="search"]::-webkit-search-decoration'] = {
	    WebkitAppearance: 'none'
	  }, _ref['::-webkit-file-upload-button'] = {
	    WebkitAppearance: 'button',
	    font: 'inherit'
	  }, _ref.details = {
	    display: 'block'
	  }, _ref.summary = {
	    display: 'list-item'
	  }, _ref.template = {
	    display: 'none'
	  }, _ref['[hidden]'] = {
	    display: 'none'
	  }, _ref), {
	    'abbr[title]': {
	      textDecoration: 'underline dotted'
	    }
	  }];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = radialGradient;
	
	var _constructGradientValue =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(435));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _templateObject() {
	  var data = _taggedTemplateLiteralLoose(["radial-gradient(", "", "", "", ")"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
	
	function radialGradient(_ref) {
	  var colorStops = _ref.colorStops,
	      _ref$extent = _ref.extent,
	      extent = _ref$extent === void 0 ? '' : _ref$extent,
	      fallback = _ref.fallback,
	      _ref$position = _ref.position,
	      position = _ref$position === void 0 ? '' : _ref$position,
	      _ref$shape = _ref.shape,
	      shape = _ref$shape === void 0 ? '' : _ref$shape;
	
	  if (!colorStops || colorStops.length < 2) {
	    throw new _errors["default"](57);
	  }
	
	  return {
	    backgroundColor: fallback || colorStops[0].split(' ')[0],
	    backgroundImage: (0, _constructGradientValue["default"])(_templateObject(), position, shape, extent, colorStops.join(', '))
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = retinaImage;
	
	var _hiDPI =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(442));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function retinaImage(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
	  var _ref;
	
	  if (extension === void 0) {
	    extension = 'png';
	  }
	
	  if (retinaSuffix === void 0) {
	    retinaSuffix = '_2x';
	  }
	
	  if (!filename) {
	    throw new _errors["default"](58);
	  } // Replace the dot at the beginning of the passed extension if one exists
	
	
	  var ext = extension.replace(/^\./, '');
	  var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
	  return _ref = {
	    backgroundImage: "url(" + filename + "." + ext + ")"
	  }, _ref[(0, _hiDPI["default"])()] = _extends({
	    backgroundImage: "url(" + rFilename + ")"
	  }, backgroundSize ? {
	    backgroundSize: backgroundSize
	  } : {}), _ref;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = timingFunctions;
	var functionsMap = {
	  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
	  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
	  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
	  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
	  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
	  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
	  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
	  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
	  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
	  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
	  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
	  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
	  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
	  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
	  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
	  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
	  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
	  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
	  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
	  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
	  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
	  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
	  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
	  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
	};
	/* eslint-enable key-spacing */
	
	function getTimingFunction(functionName) {
	  return functionsMap[functionName];
	}
	/**
	 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'transitionTimingFunction': timingFunctions('easeInQuad')
	 * }
	 *
	 * // styled-components usage
	 *  const div = styled.div`
	 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
	 * }
	 */
	
	
	function timingFunctions(timingFunction) {
	  return getTimingFunction(timingFunction);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = triangle;
	
	var _stripUnit =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(129));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
	  var fullWidth = "" + width[0] + (width[1] || '');
	  var halfWidth = "" + width[0] / 2 + (width[1] || '');
	  var fullHeight = "" + height[0] + (height[1] || '');
	  var halfHeight = "" + height[0] / 2 + (height[1] || '');
	
	  switch (pointingDirection) {
	    case 'top':
	      return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
	
	    case 'topLeft':
	      return fullWidth + " " + fullHeight + " 0 0";
	
	    case 'left':
	      return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
	
	    case 'bottomLeft':
	      return fullWidth + " 0 0 " + fullHeight;
	
	    case 'bottom':
	      return fullHeight + " " + halfWidth + " 0 " + halfWidth;
	
	    case 'bottomRight':
	      return "0 0 " + fullWidth + " " + fullHeight;
	
	    case 'right':
	      return halfHeight + " 0 " + halfHeight + " " + fullWidth;
	
	    case 'topRight':
	    default:
	      return "0 " + fullWidth + " " + fullHeight + " 0";
	  }
	};
	
	var getBorderColor = function getBorderColor(pointingDirection, foregroundColor, backgroundColor) {
	  switch (pointingDirection) {
	    case 'top':
	    case 'bottomRight':
	      return backgroundColor + " " + backgroundColor + " " + foregroundColor + " " + backgroundColor;
	
	    case 'right':
	    case 'bottomLeft':
	      return backgroundColor + " " + backgroundColor + " " + backgroundColor + " " + foregroundColor;
	
	    case 'bottom':
	    case 'topLeft':
	      return foregroundColor + " " + backgroundColor + " " + backgroundColor + " " + backgroundColor;
	
	    case 'left':
	    case 'topRight':
	      return backgroundColor + " " + foregroundColor + " " + backgroundColor + " " + backgroundColor;
	
	    default:
	      throw new _errors["default"](59);
	  }
	};
	/**
	 * CSS to represent triangle with any pointing direction with an optional background color.
	 *
	 * @example
	 * // Styles as object usage
	 *
	 * const styles = {
	 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
	 * }
	 *
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
	 *
	 *
	 * // CSS as JS Output
	 *
	 * div: {
	 *  'borderColor': 'transparent transparent transparent red',
	 *  'borderStyle': 'solid',
	 *  'borderWidth': '50px 0 50px 100px',
	 *  'height': '0',
	 *  'width': '0',
	 * }
	 */
	
	
	function triangle(_ref) {
	  var pointingDirection = _ref.pointingDirection,
	      height = _ref.height,
	      width = _ref.width,
	      foregroundColor = _ref.foregroundColor,
	      _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
	  var widthAndUnit = (0, _stripUnit["default"])(width, true);
	  var heightAndUnit = (0, _stripUnit["default"])(height, true);
	
	  if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) {
	    throw new _errors["default"](60);
	  }
	
	  return {
	    width: '0',
	    height: '0',
	    borderColor: getBorderColor(pointingDirection, foregroundColor, backgroundColor),
	    borderStyle: 'solid',
	    borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = wordWrap;
	
	function wordWrap(wrap) {
	  if (wrap === void 0) {
	    wrap = 'break-word';
	  }
	
	  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
	  return {
	    overflowWrap: wrap,
	    wordWrap: wrap,
	    wordBreak: wordBreak
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = animation;
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function animation() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  // Allow single or multiple animations passed
	  var multiMode = Array.isArray(args[0]);
	
	  if (!multiMode && args.length > 8) {
	    throw new _errors["default"](64);
	  }
	
	  var code = args.map(function (arg) {
	    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
	      throw new _errors["default"](65);
	    }
	
	    if (Array.isArray(arg) && arg.length > 8) {
	      throw new _errors["default"](66);
	    }
	
	    return Array.isArray(arg) ? arg.join(' ') : arg;
	  }).join(', ');
	  return {
	    animation: code
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = backgroundImages;
	
	function backgroundImages() {
	  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    backgroundImage: properties.join(', ')
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = backgrounds;
	
	function backgrounds() {
	  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    background: properties.join(', ')
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = border;
	
	var _capitalizeString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(270));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var sideMap = ['top', 'right', 'bottom', 'left'];
	/**
	 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...border('1px', 'solid', 'red')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${border('1px', 'solid', 'red')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderColor': 'red',
	 *   'borderStyle': 'solid',
	 *   'borderWidth': `1px`,
	 * }
	 *
	 * // Styles as object usage
	 * const styles = {
	 *   ...border('top', '1px', 'solid', 'red')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${border('top', '1px', 'solid', 'red')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopColor': 'red',
	 *   'borderTopStyle': 'solid',
	 *   'borderTopWidth': `1px`,
	 * }
	 */
	
	function border(sideKeyword) {
	  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
	    var _ref;
	
	    return _ref = {}, _ref["border" + (0, _capitalizeString["default"])(sideKeyword) + "Width"] = values[0], _ref["border" + (0, _capitalizeString["default"])(sideKeyword) + "Style"] = values[1], _ref["border" + (0, _capitalizeString["default"])(sideKeyword) + "Color"] = values[2], _ref;
	  } else {
	    values.unshift(sideKeyword);
	    return {
	      borderWidth: values[0],
	      borderStyle: values[1],
	      borderColor: values[2]
	    };
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = borderColor;
	
	var _directionalProperty =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function borderColor() {
	  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty["default"].apply(void 0, ['borderColor'].concat(values));
	}
	
	module.exports = exports.default;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = borderRadius;
	
	var _capitalizeString =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(270));
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function borderRadius(side, radius) {
	  var uppercaseSide = (0, _capitalizeString["default"])(side);
	
	  if (!radius && radius !== 0) {
	    throw new _errors["default"](62);
	  }
	
	  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
	    var _ref;
	
	    return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
	  }
	
	  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
	    var _ref2;
	
	    return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
	  }
	
	  throw new _errors["default"](63);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = borderStyle;
	
	var _directionalProperty =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function borderStyle() {
	  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty["default"].apply(void 0, ['borderStyle'].concat(values));
	}
	
	module.exports = exports.default;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = borderWidth;
	
	var _directionalProperty =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function borderWidth() {
	  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty["default"].apply(void 0, ['borderWidth'].concat(values));
	}
	
	module.exports = exports.default;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = buttons;
	
	var _statefulSelectors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(440));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var stateMap = [undefined, null, 'active', 'focus', 'hover'];
	
	function template(state) {
	  return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
	}
	/**
	 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   [buttons('active')]: {
	 *     'border': 'none'
	 *   }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   > ${buttons('active')} {
	 *     border: none;
	 *   }
	 * `
	 *
	 * // CSS in JS Output
	 *
	 *  'button:active,
	 *  'input[type="button"]:active,
	 *  'input[type=\"reset\"]:active,
	 *  'input[type=\"submit\"]:active: {
	 *   'border': 'none'
	 * }
	 */
	
	
	function buttons() {
	  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _statefulSelectors["default"])(states, template, stateMap);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = margin;
	
	var _directionalProperty =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function margin() {
	  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty["default"].apply(void 0, ['margin'].concat(values));
	}
	
	module.exports = exports.default;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = padding;
	
	var _directionalProperty =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function padding() {
	  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty["default"].apply(void 0, ['padding'].concat(values));
	}
	
	module.exports = exports.default;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = position;
	
	var _directionalProperty =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var positionMap = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
	/**
	 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...position('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${position('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'top': '12px',
	 *   'right': '24px',
	 *   'bottom': '36px',
	 *   'left': '48px'
	 * }
	 *
	 * // Styles as object usage
	 * const styles = {
	 *   ...position('absolute', '12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${position('absolute', '12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'position': 'absolute',
	 *   'top': '12px',
	 *   'right': '24px',
	 *   'bottom': '36px',
	 *   'left': '48px'
	 * }
	 */
	
	function position(positionKeyword) {
	  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  if (positionMap.indexOf(positionKeyword) >= 0) {
	    return _extends({
	      position: positionKeyword
	    }, _directionalProperty["default"].apply(void 0, [''].concat(values)));
	  } else {
	    var firstValue = positionKeyword; // in this case position is actually the first value
	
	    return _directionalProperty["default"].apply(void 0, ['', firstValue].concat(values));
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = size;
	
	function size(height, width) {
	  if (width === void 0) {
	    width = height;
	  }
	
	  return {
	    height: height,
	    width: width
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = textInputs;
	
	var _statefulSelectors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(440));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var stateMap = [undefined, null, 'active', 'focus', 'hover'];
	
	function template(state) {
	  return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
	}
	/**
	 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   [textInputs('active')]: {
	 *     'border': 'none'
	 *   }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   > ${textInputs('active')} {
	 *     border: none;
	 *   }
	 * `
	 *
	 * // CSS in JS Output
	 *
	 *  'input[type="color"]:active,
	 *  input[type="date"]:active,
	 *  input[type="datetime"]:active,
	 *  input[type="datetime-local"]:active,
	 *  input[type="email"]:active,
	 *  input[type="month"]:active,
	 *  input[type="number"]:active,
	 *  input[type="password"]:active,
	 *  input[type="search"]:active,
	 *  input[type="tel"]:active,
	 *  input[type="text"]:active,
	 *  input[type="time"]:active,
	 *  input[type="url"]:active,
	 *  input[type="week"]:active,
	 *  input:not([type]):active,
	 *  textarea:active': {
	 *   'border': 'none'
	 * }
	 */
	
	
	function textInputs() {
	  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _statefulSelectors["default"])(states, template, stateMap);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = transitions;
	
	var _errors =
	/*#__PURE__*/
	_interopRequireDefault(
	/*#__PURE__*/
	__webpack_require__(12));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
	 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
	 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
	 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
	 * }
	 */
	function transitions() {
	  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  if (Array.isArray(properties[0]) && properties.length === 2) {
	    var value = properties[1];
	
	    if (typeof value !== 'string') {
	      throw new _errors["default"](61);
	    }
	
	    var transitionsString = properties[0].map(function (property) {
	      return property + " " + value;
	    }).join(', ');
	    return {
	      transition: transitionsString
	    };
	  } else {
	    return {
	      transition: properties.join(', ')
	    };
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.15.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var _self = (typeof window !== 'undefined')
		? window   // if in browser
		: (
			(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
		);
	
	/**
	 * Prism: Lightweight, robust, elegant syntax highlighting
	 * MIT license http://www.opensource.org/licenses/mit-license.php/
	 * @author Lea Verou http://lea.verou.me
	 */
	
	var Prism = (function (_self){
	
	// Private helper vars
	var lang = /\blang(?:uage)?-([\w-]+)\b/i;
	var uniqueId = 0;
	
	var _ = {
		manual: _self.Prism && _self.Prism.manual,
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
		util: {
			encode: function (tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, _.util.encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(_.util.encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},
	
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},
	
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},
	
			// Deep clone a language definition (e.g. to extend it)
			clone: function deepClone(o, visited) {
				var clone, id, type = _.util.type(o);
				visited = visited || {};
	
				switch (type) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = {};
						visited[id] = clone;
	
						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}
	
						return clone;
	
					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;
	
						o.forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});
	
						return clone;
	
					default:
						return o;
				}
			}
		},
	
		languages: {
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);
	
				for (var key in redef) {
					lang[key] = redef[key];
				}
	
				return lang;
			},
	
			/**
			 * Insert a token before another token in a language literal
			 * As this needs to recreate the object (we cannot actually insert before keys in object literals),
			 * we cannot just provide an object, we need an object and a key.
			 * @param inside The key (or language id) of the parent
			 * @param before The key to insert before.
			 * @param insert Object with the key/value pairs to insert
			 * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || _.languages;
				var grammar = root[inside];
				var ret = {};
	
				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {
	
						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}
	
						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}
	
				var old = root[inside];
				root[inside] = ret;
	
				// Update references in other language definitions
				_.languages.DFS(_.languages, function(key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});
	
				return ret;
			},
	
			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};
	
				var objId = _.util.objId;
	
				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);
	
						var property = o[i],
						    propertyType = _.util.type(property);
	
						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						}
						else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},
		plugins: {},
	
		highlightAll: function(async, callback) {
			_.highlightAllUnder(document, async, callback);
		},
	
		highlightAllUnder: function(container, async, callback) {
			var env = {
				callback: callback,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};
	
			_.hooks.run("before-highlightall", env);
	
			var elements = env.elements || container.querySelectorAll(env.selector);
	
			for (var i=0, element; element = elements[i++];) {
				_.highlightElement(element, async === true, env.callback);
			}
		},
	
		highlightElement: function(element, async, callback) {
			// Find language
			var language, grammar, parent = element;
	
			while (parent && !lang.test(parent.className)) {
				parent = parent.parentNode;
			}
	
			if (parent) {
				language = (parent.className.match(lang) || [,''])[1].toLowerCase();
				grammar = _.languages[language];
			}
	
			// Set language on the element, if not present
			element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
	
			if (element.parentNode) {
				// Set language on the parent, for styling
				parent = element.parentNode;
	
				if (/pre/i.test(parent.nodeName)) {
					parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
				}
			}
	
			var code = element.textContent;
	
			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};
	
			var insertHighlightedCode = function (highlightedCode) {
				env.highlightedCode = highlightedCode;
	
				_.hooks.run('before-insert', env);
	
				env.element.innerHTML = env.highlightedCode;
	
				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}
	
			_.hooks.run('before-sanity-check', env);
	
			if (!env.code) {
				_.hooks.run('complete', env);
				return;
			}
	
			_.hooks.run('before-highlight', env);
	
			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}
	
			if (async && _self.Worker) {
				var worker = new Worker(_.filename);
	
				worker.onmessage = function(evt) {
					insertHighlightedCode(evt.data);
				};
	
				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			}
			else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},
	
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},
	
		matchGrammar: function (text, strarr, grammar, index, startPos, oneshot, target) {
			for (var token in grammar) {
				if(!grammar.hasOwnProperty(token) || !grammar[token]) {
					continue;
				}
	
				if (token == target) {
					return;
				}
	
				var patterns = grammar[token];
				patterns = (_.util.type(patterns) === "Array") ? patterns : [patterns];
	
				for (var j = 0; j < patterns.length; ++j) {
					var pattern = patterns[j],
						inside = pattern.inside,
						lookbehind = !!pattern.lookbehind,
						greedy = !!pattern.greedy,
						lookbehindLength = 0,
						alias = pattern.alias;
	
					if (greedy && !pattern.pattern.global) {
						// Without the global flag, lastIndex won't work
						var flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
						pattern.pattern = RegExp(pattern.pattern.source, flags + "g");
					}
	
					pattern = pattern.pattern || pattern;
	
					// Don’t cache length as it changes during the loop
					for (var i = index, pos = startPos; i < strarr.length; pos += strarr[i].length, ++i) {
	
						var str = strarr[i];
	
						if (strarr.length > text.length) {
							// Something went terribly wrong, ABORT, ABORT!
							return;
						}
	
						if (str instanceof Token) {
							continue;
						}
	
						if (greedy && i != strarr.length - 1) {
							pattern.lastIndex = pos;
							var match = pattern.exec(text);
							if (!match) {
								break;
							}
	
							var from = match.index + (lookbehind ? match[1].length : 0),
							    to = match.index + match[0].length,
							    k = i,
							    p = pos;
	
							for (var len = strarr.length; k < len && (p < to || (!strarr[k].type && !strarr[k - 1].greedy)); ++k) {
								p += strarr[k].length;
								// Move the index i to the element in strarr that is closest to from
								if (from >= p) {
									++i;
									pos = p;
								}
							}
	
							// If strarr[i] is a Token, then the match starts inside another Token, which is invalid
							if (strarr[i] instanceof Token) {
								continue;
							}
	
							// Number of tokens to delete and replace with the new match
							delNum = k - i;
							str = text.slice(pos, p);
							match.index -= pos;
						} else {
							pattern.lastIndex = 0;
	
							var match = pattern.exec(str),
								delNum = 1;
						}
	
						if (!match) {
							if (oneshot) {
								break;
							}
	
							continue;
						}
	
						if(lookbehind) {
							lookbehindLength = match[1] ? match[1].length : 0;
						}
	
						var from = match.index + lookbehindLength,
						    match = match[0].slice(lookbehindLength),
						    to = from + match.length,
						    before = str.slice(0, from),
						    after = str.slice(to);
	
						var args = [i, delNum];
	
						if (before) {
							++i;
							pos += before.length;
							args.push(before);
						}
	
						var wrapped = new Token(token, inside? _.tokenize(match, inside) : match, alias, match, greedy);
	
						args.push(wrapped);
	
						if (after) {
							args.push(after);
						}
	
						Array.prototype.splice.apply(strarr, args);
	
						if (delNum != 1)
							_.matchGrammar(text, strarr, grammar, i, pos, true, token);
	
						if (oneshot)
							break;
					}
				}
			}
		},
	
		tokenize: function(text, grammar) {
			var strarr = [text];
	
			var rest = grammar.rest;
	
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}
	
				delete grammar.rest;
			}
	
			_.matchGrammar(text, strarr, grammar, 0, 0, false);
	
			return strarr;
		},
	
		hooks: {
			all: {},
	
			add: function (name, callback) {
				var hooks = _.hooks.all;
	
				hooks[name] = hooks[name] || [];
	
				hooks[name].push(callback);
			},
	
			run: function (name, env) {
				var callbacks = _.hooks.all[name];
	
				if (!callbacks || !callbacks.length) {
					return;
				}
	
				for (var i=0, callback; callback = callbacks[i++];) {
					callback(env);
				}
			}
		},
	
		Token: Token
	};
	
	_self.Prism = _;
	
	function Token(type, content, alias, matchedStr, greedy) {
		this.type = type;
		this.content = content;
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || "").length|0;
		this.greedy = !!greedy;
	}
	
	Token.stringify = function(o, language, parent) {
		if (typeof o == 'string') {
			return o;
		}
	
		if (Array.isArray(o)) {
			return o.map(function(element) {
				return Token.stringify(element, language, o);
			}).join('');
		}
	
		var env = {
			type: o.type,
			content: Token.stringify(o.content, language, parent),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language,
			parent: parent
		};
	
		if (o.alias) {
			var aliases = Array.isArray(o.alias) ? o.alias : [o.alias];
			Array.prototype.push.apply(env.classes, aliases);
		}
	
		_.hooks.run('wrap', env);
	
		var attributes = Object.keys(env.attributes).map(function(name) {
			return name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}).join(' ');
	
		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + (attributes ? ' ' + attributes : '') + '>' + env.content + '</' + env.tag + '>';
	
	};
	
	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}
	
		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data),
					lang = message.language,
					code = message.code,
					immediateClose = message.immediateClose;
	
				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}
	
		return _;
	}
	
	//Get current script and highlight
	var script = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();
	
	if (script) {
		_.filename = script.src;
	
		if (!_.manual && !script.hasAttribute('data-manual')) {
			if(document.readyState !== "loading") {
				if (window.requestAnimationFrame) {
					window.requestAnimationFrame(_.highlightAll);
				} else {
					window.setTimeout(_.highlightAll, 16);
				}
			}
			else {
				document.addEventListener('DOMContentLoaded', _.highlightAll);
			}
		}
	}
	
	return _;
	
	})(_self);
	
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Prism;
	}
	
	// hack for components to work correctly in node.js
	if (typeof global !== 'undefined') {
		global.Prism = Prism;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */
/***/ (function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1055);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(136);
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(287));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(72));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(135));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(81));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(187));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _popper = _interopRequireDefault(__webpack_require__(1050));
	
	var _Manager = __webpack_require__(276);
	
	var _utils = __webpack_require__(444);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.safeInvoke)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.safeInvoke)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerContext.Consumer, null, function (_ref2) {
	    var referenceNode = _ref2.referenceNode;
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(136);
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(72));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(135));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(81));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(187));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(59));
	
	var _Manager = __webpack_require__(276);
	
	var _utils = __webpack_require__(444);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refHandler", function (node) {
	      (0, _utils.safeInvoke)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.safeInvoke)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerContext.Consumer, null, function (_ref) {
	    var setReferenceNode = _ref.setReferenceNode;
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	var _interopRequireWildcard = __webpack_require__(136);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(1057));
	
	var _Manager = _interopRequireDefault(__webpack_require__(276));
	
	var _Reference = _interopRequireDefault(__webpack_require__(1058));

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	var HTMLDOMPropertyConfig = __webpack_require__(1061);
	var SVGDOMPropertyConfig = __webpack_require__(1062);
	var injection = __webpack_require__(1063);
	
	var MUST_USE_PROPERTY = injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	/**
	 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L14-L16
	 *
	 * @param  {Number}  value
	 * @param  {Number}  bitmask
	 * @return {Boolean}
	 */
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	/**
	 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L57
	 *
	 * @param {Object}  domPropertyConfig - HTMLDOMPropertyConfig or SVGDOMPropertyConfig
	 * @param {Object}  config            - The object to be mutated
	 * @param {Boolean} isSVG             - Whether the injected config is HTML or SVG (it assumes the default is HTML)
	 */
	function injectDOMPropertyConfig(domPropertyConfig, config, isSVG) {
	  var Properties = domPropertyConfig.Properties;
	  var DOMAttributeNames = domPropertyConfig.DOMAttributeNames;
	  var attributeName;
	  var propertyName;
	  var propConfig;
	
	  for (propertyName in Properties) {
	    attributeName =
	      DOMAttributeNames[propertyName] ||
	      (isSVG ? propertyName : propertyName.toLowerCase());
	    propConfig = Properties[propertyName];
	
	    config[attributeName] = {
	      attributeName: attributeName,
	      propertyName: propertyName,
	      mustUseProperty: checkMask(propConfig, MUST_USE_PROPERTY),
	      hasBooleanValue: checkMask(propConfig, HAS_BOOLEAN_VALUE),
	      hasNumericValue: checkMask(propConfig, HAS_NUMERIC_VALUE),
	      hasPositiveNumericValue: checkMask(
	        propConfig,
	        HAS_POSITIVE_NUMERIC_VALUE
	      ),
	      hasOverloadedBooleanValue: checkMask(
	        propConfig,
	        HAS_OVERLOADED_BOOLEAN_VALUE
	      )
	    };
	  }
	}
	
	/**
	 * HTML properties config.
	 *
	 * @type {Object}
	 */
	var html = {};
	injectDOMPropertyConfig(HTMLDOMPropertyConfig, html);
	
	/**
	 * SVG properties config.
	 *
	 * @type {Object}
	 */
	var svg = {};
	injectDOMPropertyConfig(SVGDOMPropertyConfig, svg, true);
	
	/**
	 * HTML and SVG properties config.
	 *
	 * @type {Object}
	 */
	var properties = {};
	injectDOMPropertyConfig(HTMLDOMPropertyConfig, properties);
	injectDOMPropertyConfig(SVGDOMPropertyConfig, properties, true);
	
	var ATTRIBUTE_NAME_START_CHAR =
	  ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR =
	  ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	
	module.exports = {
	  html: html,
	  svg: svg,
	  properties: properties,
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   *
	   * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
	   *
	   * @param {String}
	   * @return {Boolean}
	   */
	  isCustomAttribute: RegExp.prototype.test.bind(
	    new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$')
	  )
	};


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

	module.exports = {
	  Properties: {
	    autoFocus: 4,
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: 4,
	    allowTransparency: 0,
	    alt: 0,
	    as: 0,
	    async: 4,
	    autoComplete: 0,
	    autoPlay: 4,
	    capture: 4,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: 5,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: 24,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: 4,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0,
	    dateTime: 0,
	    default: 4,
	    defer: 4,
	    dir: 0,
	    disabled: 4,
	    download: 32,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: 4,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: 4,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: 4,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    multiple: 5,
	    muted: 5,
	    name: 0,
	    nonce: 0,
	    noValidate: 4,
	    open: 4,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: 4,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: 4,
	    referrerPolicy: 0,
	    rel: 0,
	    required: 4,
	    reversed: 4,
	    role: 0,
	    rows: 24,
	    rowSpan: 8,
	    sandbox: 0,
	    scope: 0,
	    scoped: 4,
	    scrolling: 0,
	    seamless: 4,
	    selected: 5,
	    shape: 0,
	    size: 24,
	    sizes: 0,
	    span: 24,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: 8,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    property: 0,
	    resource: 0,
	    typeof: 0,
	    vocab: 0,
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    autoSave: 0,
	    color: 0,
	    itemProp: 0,
	    itemScope: 4,
	    itemType: 0,
	    itemID: 0,
	    itemRef: 0,
	    results: 0,
	    security: 0,
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  }
	};


/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	module.exports = {
	  Properties: {
	    accentHeight: 0,
	    accumulate: 0,
	    additive: 0,
	    alignmentBaseline: 0,
	    allowReorder: 0,
	    alphabetic: 0,
	    amplitude: 0,
	    arabicForm: 0,
	    ascent: 0,
	    attributeName: 0,
	    attributeType: 0,
	    autoReverse: 0,
	    azimuth: 0,
	    baseFrequency: 0,
	    baseProfile: 0,
	    baselineShift: 0,
	    bbox: 0,
	    begin: 0,
	    bias: 0,
	    by: 0,
	    calcMode: 0,
	    capHeight: 0,
	    clip: 0,
	    clipPath: 0,
	    clipRule: 0,
	    clipPathUnits: 0,
	    colorInterpolation: 0,
	    colorInterpolationFilters: 0,
	    colorProfile: 0,
	    colorRendering: 0,
	    contentScriptType: 0,
	    contentStyleType: 0,
	    cursor: 0,
	    cx: 0,
	    cy: 0,
	    d: 0,
	    decelerate: 0,
	    descent: 0,
	    diffuseConstant: 0,
	    direction: 0,
	    display: 0,
	    divisor: 0,
	    dominantBaseline: 0,
	    dur: 0,
	    dx: 0,
	    dy: 0,
	    edgeMode: 0,
	    elevation: 0,
	    enableBackground: 0,
	    end: 0,
	    exponent: 0,
	    externalResourcesRequired: 0,
	    fill: 0,
	    fillOpacity: 0,
	    fillRule: 0,
	    filter: 0,
	    filterRes: 0,
	    filterUnits: 0,
	    floodColor: 0,
	    floodOpacity: 0,
	    focusable: 0,
	    fontFamily: 0,
	    fontSize: 0,
	    fontSizeAdjust: 0,
	    fontStretch: 0,
	    fontStyle: 0,
	    fontVariant: 0,
	    fontWeight: 0,
	    format: 0,
	    from: 0,
	    fx: 0,
	    fy: 0,
	    g1: 0,
	    g2: 0,
	    glyphName: 0,
	    glyphOrientationHorizontal: 0,
	    glyphOrientationVertical: 0,
	    glyphRef: 0,
	    gradientTransform: 0,
	    gradientUnits: 0,
	    hanging: 0,
	    horizAdvX: 0,
	    horizOriginX: 0,
	    ideographic: 0,
	    imageRendering: 0,
	    in: 0,
	    in2: 0,
	    intercept: 0,
	    k: 0,
	    k1: 0,
	    k2: 0,
	    k3: 0,
	    k4: 0,
	    kernelMatrix: 0,
	    kernelUnitLength: 0,
	    kerning: 0,
	    keyPoints: 0,
	    keySplines: 0,
	    keyTimes: 0,
	    lengthAdjust: 0,
	    letterSpacing: 0,
	    lightingColor: 0,
	    limitingConeAngle: 0,
	    local: 0,
	    markerEnd: 0,
	    markerMid: 0,
	    markerStart: 0,
	    markerHeight: 0,
	    markerUnits: 0,
	    markerWidth: 0,
	    mask: 0,
	    maskContentUnits: 0,
	    maskUnits: 0,
	    mathematical: 0,
	    mode: 0,
	    numOctaves: 0,
	    offset: 0,
	    opacity: 0,
	    operator: 0,
	    order: 0,
	    orient: 0,
	    orientation: 0,
	    origin: 0,
	    overflow: 0,
	    overlinePosition: 0,
	    overlineThickness: 0,
	    paintOrder: 0,
	    panose1: 0,
	    pathLength: 0,
	    patternContentUnits: 0,
	    patternTransform: 0,
	    patternUnits: 0,
	    pointerEvents: 0,
	    points: 0,
	    pointsAtX: 0,
	    pointsAtY: 0,
	    pointsAtZ: 0,
	    preserveAlpha: 0,
	    preserveAspectRatio: 0,
	    primitiveUnits: 0,
	    r: 0,
	    radius: 0,
	    refX: 0,
	    refY: 0,
	    renderingIntent: 0,
	    repeatCount: 0,
	    repeatDur: 0,
	    requiredExtensions: 0,
	    requiredFeatures: 0,
	    restart: 0,
	    result: 0,
	    rotate: 0,
	    rx: 0,
	    ry: 0,
	    scale: 0,
	    seed: 0,
	    shapeRendering: 0,
	    slope: 0,
	    spacing: 0,
	    specularConstant: 0,
	    specularExponent: 0,
	    speed: 0,
	    spreadMethod: 0,
	    startOffset: 0,
	    stdDeviation: 0,
	    stemh: 0,
	    stemv: 0,
	    stitchTiles: 0,
	    stopColor: 0,
	    stopOpacity: 0,
	    strikethroughPosition: 0,
	    strikethroughThickness: 0,
	    string: 0,
	    stroke: 0,
	    strokeDasharray: 0,
	    strokeDashoffset: 0,
	    strokeLinecap: 0,
	    strokeLinejoin: 0,
	    strokeMiterlimit: 0,
	    strokeOpacity: 0,
	    strokeWidth: 0,
	    surfaceScale: 0,
	    systemLanguage: 0,
	    tableValues: 0,
	    targetX: 0,
	    targetY: 0,
	    textAnchor: 0,
	    textDecoration: 0,
	    textRendering: 0,
	    textLength: 0,
	    to: 0,
	    transform: 0,
	    u1: 0,
	    u2: 0,
	    underlinePosition: 0,
	    underlineThickness: 0,
	    unicode: 0,
	    unicodeBidi: 0,
	    unicodeRange: 0,
	    unitsPerEm: 0,
	    vAlphabetic: 0,
	    vHanging: 0,
	    vIdeographic: 0,
	    vMathematical: 0,
	    values: 0,
	    vectorEffect: 0,
	    version: 0,
	    vertAdvY: 0,
	    vertOriginX: 0,
	    vertOriginY: 0,
	    viewBox: 0,
	    viewTarget: 0,
	    visibility: 0,
	    widths: 0,
	    wordSpacing: 0,
	    writingMode: 0,
	    x: 0,
	    xHeight: 0,
	    x1: 0,
	    x2: 0,
	    xChannelSelector: 0,
	    xlinkActuate: 0,
	    xlinkArcrole: 0,
	    xlinkHref: 0,
	    xlinkRole: 0,
	    xlinkShow: 0,
	    xlinkTitle: 0,
	    xlinkType: 0,
	    xmlBase: 0,
	    xmlns: 0,
	    xmlnsXlink: 0,
	    xmlLang: 0,
	    xmlSpace: 0,
	    y: 0,
	    y1: 0,
	    y2: 0,
	    yChannelSelector: 0,
	    z: 0,
	    zoomAndPan: 0
	  },
	  DOMAttributeNames: {
	    accentHeight: 'accent-height',
	    alignmentBaseline: 'alignment-baseline',
	    arabicForm: 'arabic-form',
	    baselineShift: 'baseline-shift',
	    capHeight: 'cap-height',
	    clipPath: 'clip-path',
	    clipRule: 'clip-rule',
	    colorInterpolation: 'color-interpolation',
	    colorInterpolationFilters: 'color-interpolation-filters',
	    colorProfile: 'color-profile',
	    colorRendering: 'color-rendering',
	    dominantBaseline: 'dominant-baseline',
	    enableBackground: 'enable-background',
	    fillOpacity: 'fill-opacity',
	    fillRule: 'fill-rule',
	    floodColor: 'flood-color',
	    floodOpacity: 'flood-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontSizeAdjust: 'font-size-adjust',
	    fontStretch: 'font-stretch',
	    fontStyle: 'font-style',
	    fontVariant: 'font-variant',
	    fontWeight: 'font-weight',
	    glyphName: 'glyph-name',
	    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	    glyphOrientationVertical: 'glyph-orientation-vertical',
	    horizAdvX: 'horiz-adv-x',
	    horizOriginX: 'horiz-origin-x',
	    imageRendering: 'image-rendering',
	    letterSpacing: 'letter-spacing',
	    lightingColor: 'lighting-color',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    overlinePosition: 'overline-position',
	    overlineThickness: 'overline-thickness',
	    paintOrder: 'paint-order',
	    panose1: 'panose-1',
	    pointerEvents: 'pointer-events',
	    renderingIntent: 'rendering-intent',
	    shapeRendering: 'shape-rendering',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strikethroughPosition: 'strikethrough-position',
	    strikethroughThickness: 'strikethrough-thickness',
	    strokeDasharray: 'stroke-dasharray',
	    strokeDashoffset: 'stroke-dashoffset',
	    strokeLinecap: 'stroke-linecap',
	    strokeLinejoin: 'stroke-linejoin',
	    strokeMiterlimit: 'stroke-miterlimit',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    textDecoration: 'text-decoration',
	    textRendering: 'text-rendering',
	    underlinePosition: 'underline-position',
	    underlineThickness: 'underline-thickness',
	    unicodeBidi: 'unicode-bidi',
	    unicodeRange: 'unicode-range',
	    unitsPerEm: 'units-per-em',
	    vAlphabetic: 'v-alphabetic',
	    vHanging: 'v-hanging',
	    vIdeographic: 'v-ideographic',
	    vMathematical: 'v-mathematical',
	    vectorEffect: 'vector-effect',
	    vertAdvY: 'vert-adv-y',
	    vertOriginX: 'vert-origin-x',
	    vertOriginY: 'vert-origin-y',
	    wordSpacing: 'word-spacing',
	    writingMode: 'writing-mode',
	    xHeight: 'x-height',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlnsXlink: 'xmlns:xlink',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	module.exports = {
	  MUST_USE_PROPERTY: 1,
	  HAS_BOOLEAN_VALUE: 4,
	  HAS_NUMERIC_VALUE: 8,
	  HAS_POSITIVE_NUMERIC_VALUE: 24,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 32
	};


/***/ }),
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(230);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(387);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.createStyleObject = createStyleObject;
	exports.createClassNameString = createClassNameString;
	exports.createChildren = createChildren;
	exports.default = createElement;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createStyleObject(classNames) {
	  var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var stylesheet = arguments[2];
	
	  return classNames.reduce(function (styleObject, className) {
	    return (0, _extends3.default)({}, styleObject, stylesheet[className]);
	  }, elementStyle);
	}
	
	function createClassNameString(classNames) {
	  return classNames.join(' ');
	}
	
	function createChildren(stylesheet, useInlineStyles) {
	  var childrenCount = 0;
	  return function (children) {
	    childrenCount += 1;
	    return children.map(function (child, i) {
	      return createElement({
	        node: child,
	        stylesheet: stylesheet,
	        useInlineStyles: useInlineStyles,
	        key: 'code-segment-' + childrenCount + '-' + i
	      });
	    });
	  };
	}
	
	function createElement(_ref) {
	  var node = _ref.node,
	      stylesheet = _ref.stylesheet,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      useInlineStyles = _ref.useInlineStyles,
	      key = _ref.key;
	  var properties = node.properties,
	      type = node.type,
	      TagName = node.tagName,
	      value = node.value;
	
	  if (type === 'text') {
	    return value;
	  } else if (TagName) {
	    var childrenCreator = createChildren(stylesheet, useInlineStyles);
	    var nonStylesheetClassNames = useInlineStyles && properties.className && properties.className.filter(function (className) {
	      return !stylesheet[className];
	    });
	    var className = nonStylesheetClassNames && nonStylesheetClassNames.length ? nonStylesheetClassNames : undefined;
	    var props = useInlineStyles ? (0, _extends3.default)({}, properties, { className: className }, {
	      style: createStyleObject(properties.className, (0, _assign2.default)({}, properties.style, style), stylesheet)
	    }) : (0, _extends3.default)({}, properties, { className: createClassNameString(properties.className) });
	    var children = childrenCreator(node.children);
	    return _react2.default.createElement(
	      TagName,
	      (0, _extends3.default)({ key: key }, props),
	      children
	    );
	  }
	}

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(388);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(230);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = function (defaultAstGenerator, defaultStyle) {
	  return function SyntaxHighlighter(_ref6) {
	    var language = _ref6.language,
	        children = _ref6.children,
	        _ref6$style = _ref6.style,
	        style = _ref6$style === undefined ? defaultStyle : _ref6$style,
	        _ref6$customStyle = _ref6.customStyle,
	        customStyle = _ref6$customStyle === undefined ? {} : _ref6$customStyle,
	        _ref6$codeTagProps = _ref6.codeTagProps,
	        codeTagProps = _ref6$codeTagProps === undefined ? { style: style['code[class*=\"language-\"]'] } : _ref6$codeTagProps,
	        _ref6$useInlineStyles = _ref6.useInlineStyles,
	        useInlineStyles = _ref6$useInlineStyles === undefined ? true : _ref6$useInlineStyles,
	        _ref6$showLineNumbers = _ref6.showLineNumbers,
	        showLineNumbers = _ref6$showLineNumbers === undefined ? false : _ref6$showLineNumbers,
	        _ref6$startingLineNum = _ref6.startingLineNumber,
	        startingLineNumber = _ref6$startingLineNum === undefined ? 1 : _ref6$startingLineNum,
	        lineNumberContainerStyle = _ref6.lineNumberContainerStyle,
	        lineNumberStyle = _ref6.lineNumberStyle,
	        wrapLines = _ref6.wrapLines,
	        _ref6$lineProps = _ref6.lineProps,
	        lineProps = _ref6$lineProps === undefined ? {} : _ref6$lineProps,
	        renderer = _ref6.renderer,
	        _ref6$PreTag = _ref6.PreTag,
	        PreTag = _ref6$PreTag === undefined ? 'pre' : _ref6$PreTag,
	        _ref6$CodeTag = _ref6.CodeTag,
	        CodeTag = _ref6$CodeTag === undefined ? 'code' : _ref6$CodeTag,
	        _ref6$code = _ref6.code,
	        code = _ref6$code === undefined ? Array.isArray(children) ? children[0] : children : _ref6$code,
	        astGenerator = _ref6.astGenerator,
	        rest = (0, _objectWithoutProperties3.default)(_ref6, ['language', 'children', 'style', 'customStyle', 'codeTagProps', 'useInlineStyles', 'showLineNumbers', 'startingLineNumber', 'lineNumberContainerStyle', 'lineNumberStyle', 'wrapLines', 'lineProps', 'renderer', 'PreTag', 'CodeTag', 'code', 'astGenerator']);
	
	    astGenerator = astGenerator || defaultAstGenerator;
	
	    var lineNumbers = showLineNumbers ? _react2.default.createElement(LineNumbers, {
	      containerStyle: lineNumberContainerStyle,
	      codeStyle: codeTagProps.style || {},
	      numberStyle: lineNumberStyle,
	      startingLineNumber: startingLineNumber,
	      codeString: code
	    }) : null;
	
	    var defaultPreStyle = style.hljs || style['pre[class*=\"language-\"]'] || { backgroundColor: '#fff' };
	    var preProps = useInlineStyles ? (0, _assign2.default)({}, rest, { style: (0, _assign2.default)({}, defaultPreStyle, customStyle) }) : (0, _assign2.default)({}, rest, { className: 'hljs' });
	
	    if (!astGenerator) {
	      return _react2.default.createElement(
	        PreTag,
	        preProps,
	        lineNumbers,
	        _react2.default.createElement(
	          CodeTag,
	          codeTagProps,
	          code
	        )
	      );
	    }
	
	    /* 
	     * some custom renderers rely on individual row elements so we need to turn wrapLines on 
	     * if renderer is provided and wrapLines is undefined
	    */
	    wrapLines = renderer && wrapLines === undefined ? true : wrapLines;
	    renderer = renderer || defaultRenderer;
	    var defaultCodeValue = [{ type: 'text', value: code }];
	    var codeTree = getCodeTree({ astGenerator: astGenerator, language: language, code: code, defaultCodeValue: defaultCodeValue });
	    if (codeTree.language === null) {
	      codeTree.value = defaultCodeValue;
	    }
	
	    var tree = wrapLines ? wrapLinesInSpan(codeTree, lineProps) : codeTree.value;
	
	    return _react2.default.createElement(
	      PreTag,
	      preProps,
	      lineNumbers,
	      _react2.default.createElement(
	        CodeTag,
	        codeTagProps,
	        renderer({ rows: tree, stylesheet: style, useInlineStyles: useInlineStyles })
	      )
	    );
	  };
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createElement = __webpack_require__(1076);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newLineRegex = /\n/g;
	function getNewLines(str) {
	  return str.match(newLineRegex);
	}
	
	function getLineNumbers(_ref) {
	  var lines = _ref.lines,
	      startingLineNumber = _ref.startingLineNumber,
	      style = _ref.style;
	
	  return lines.map(function (_, i) {
	    var number = i + startingLineNumber;
	    return _react2.default.createElement(
	      'span',
	      {
	        key: 'line-' + i,
	        className: 'react-syntax-highlighter-line-number',
	        style: typeof style === 'function' ? style(number) : style
	      },
	      number + '\n'
	    );
	  });
	}
	
	function LineNumbers(_ref2) {
	  var codeString = _ref2.codeString,
	      codeStyle = _ref2.codeStyle,
	      _ref2$containerStyle = _ref2.containerStyle,
	      containerStyle = _ref2$containerStyle === undefined ? { float: 'left', paddingRight: '10px' } : _ref2$containerStyle,
	      _ref2$numberStyle = _ref2.numberStyle,
	      numberStyle = _ref2$numberStyle === undefined ? {} : _ref2$numberStyle,
	      startingLineNumber = _ref2.startingLineNumber;
	
	  return _react2.default.createElement(
	    'code',
	    { style: (0, _assign2.default)({}, codeStyle, containerStyle) },
	    getLineNumbers({
	      lines: codeString.replace(/\n$/, '').split('\n'),
	      style: numberStyle,
	      startingLineNumber: startingLineNumber
	    })
	  );
	}
	
	function createLineElement(_ref3) {
	  var children = _ref3.children,
	      lineNumber = _ref3.lineNumber,
	      lineProps = _ref3.lineProps,
	      _ref3$className = _ref3.className,
	      className = _ref3$className === undefined ? [] : _ref3$className;
	
	  var properties = (typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps) || {};
	  properties.className = properties.className ? className.concat(properties.className) : className;
	  return {
	    type: 'element',
	    tagName: 'span',
	    properties: properties,
	    children: children
	  };
	}
	
	function flattenCodeTree(tree) {
	  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  for (var i = 0; i < tree.length; i++) {
	    var node = tree[i];
	    if (node.type === 'text') {
	      newTree.push(createLineElement({
	        children: [node],
	        className: className
	      }));
	    } else if (node.children) {
	      var classNames = className.concat(node.properties.className);
	      newTree = newTree.concat(flattenCodeTree(node.children, classNames));
	    }
	  }
	  return newTree;
	}
	
	function wrapLinesInSpan(codeTree, lineProps) {
	  var tree = flattenCodeTree(codeTree.value);
	  var newTree = [];
	  var lastLineBreakIndex = -1;
	  var index = 0;
	
	  var _loop = function _loop() {
	    var node = tree[index];
	    var value = node.children[0].value;
	    var newLines = getNewLines(value);
	    if (newLines) {
	      var splitValue = value.split('\n');
	      splitValue.forEach(function (text, i) {
	        var lineNumber = newTree.length + 1;
	        var newChild = { type: 'text', value: text + '\n' };
	        if (i === 0) {
	          var _children = tree.slice(lastLineBreakIndex + 1, index).concat(createLineElement({ children: [newChild], className: node.properties.className }));
	          newTree.push(createLineElement({ children: _children, lineNumber: lineNumber, lineProps: lineProps }));
	        } else if (i === splitValue.length - 1) {
	          var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
	          if (stringChild) {
	            var lastLineInPreviousSpan = { type: 'text', value: '' + text };
	            var newElem = createLineElement({ children: [lastLineInPreviousSpan], className: node.properties.className });
	            tree.splice(index + 1, 0, newElem);
	          } else {
	            newTree.push(createLineElement({ children: [newChild], lineNumber: lineNumber, lineProps: lineProps, className: node.properties.className }));
	          }
	        } else {
	          newTree.push(createLineElement({ children: [newChild], lineNumber: lineNumber, lineProps: lineProps, className: node.properties.className }));
	        }
	      });
	      lastLineBreakIndex = index;
	    }
	    index++;
	  };
	
	  while (index < tree.length) {
	    _loop();
	  }
	  if (lastLineBreakIndex !== tree.length - 1) {
	    var children = tree.slice(lastLineBreakIndex + 1, tree.length);
	    if (children && children.length) {
	      newTree.push(createLineElement({ children: children, lineNumber: newTree.length + 1, lineProps: lineProps }));
	    }
	  }
	  return newTree;
	}
	
	function defaultRenderer(_ref4) {
	  var rows = _ref4.rows,
	      stylesheet = _ref4.stylesheet,
	      useInlineStyles = _ref4.useInlineStyles;
	
	  return rows.map(function (node, i) {
	    return (0, _createElement2.default)({
	      node: node,
	      stylesheet: stylesheet,
	      useInlineStyles: useInlineStyles,
	      key: 'code-segement' + i
	    });
	  });
	}
	
	function getCodeTree(_ref5) {
	  var astGenerator = _ref5.astGenerator,
	      language = _ref5.language,
	      code = _ref5.code,
	      defaultCodeValue = _ref5.defaultCodeValue;
	
	  if (astGenerator.getLanguage) {
	    var hasLanguage = language && astGenerator.getLanguage(language);
	    if (language === 'text') {
	      return { value: defaultCodeValue, language: 'text' };
	    } else if (hasLanguage) {
	      return astGenerator.highlight(language, code);
	    } else {
	      return astGenerator.highlightAuto(code);
	    }
	  }
	  try {
	    return language && language !== 'text' ? { value: astGenerator.highlight(code, language) } : { value: defaultCodeValue };
	  } catch (e) {
	    return { value: defaultCodeValue };
	  }
	}

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bash = __webpack_require__(1089);
	
	var _bash2 = _interopRequireDefault(_bash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	exports.default = _bash2.default;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _css = __webpack_require__(455);
	
	var _css2 = _interopRequireDefault(_css);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	exports.default = _css2.default;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = __webpack_require__(1092);
	
	var _jsx2 = _interopRequireDefault(_jsx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	exports.default = _jsx2.default;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _markup = __webpack_require__(456);
	
	var _markup2 = _interopRequireDefault(_markup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	exports.default = _markup2.default;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerLanguage = undefined;
	
	var _highlight = __webpack_require__(1077);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _core = __webpack_require__(1088);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var registerLanguage = exports.registerLanguage = function registerLanguage(_, language) {
	  return _core2.default.register(language);
	};
	exports.default = (0, _highlight2.default)(_core2.default, {});

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(72));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(287));
	var _inheritsLoose = _interopDefault(__webpack_require__(81));
	var _assertThisInitialized = _interopDefault(__webpack_require__(135));
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(4));
	
	var isIE = !!document.documentElement.currentStyle;
	var HIDDEN_TEXTAREA_STYLE = {
	  'min-height': '0',
	  'max-height': 'none',
	  height: '0',
	  visibility: 'hidden',
	  overflow: 'hidden',
	  position: 'absolute',
	  'z-index': '-1000',
	  top: '0',
	  right: '0'
	};
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
	var computedStyleCache = {};
	var hiddenTextarea = document.createElement('textarea');
	
	var forceHiddenStyles = function forceHiddenStyles(node) {
	  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
	    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
	  });
	};
	
	{
	  forceHiddenStyles(hiddenTextarea);
	}
	
	function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
	  if (useCache === void 0) {
	    useCache = false;
	  }
	
	  if (minRows === void 0) {
	    minRows = null;
	  }
	
	  if (maxRows === void 0) {
	    maxRows = null;
	  }
	
	  if (hiddenTextarea.parentNode === null) {
	    document.body.appendChild(hiddenTextarea);
	  } // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	
	  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);
	
	  if (nodeStyling === null) {
	    return null;
	  }
	
	  var paddingSize = nodeStyling.paddingSize,
	      borderSize = nodeStyling.borderSize,
	      boxSizing = nodeStyling.boxSizing,
	      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	  Object.keys(sizingStyle).forEach(function (key) {
	    hiddenTextarea.style[key] = sizingStyle[key];
	  });
	  forceHiddenStyles(hiddenTextarea);
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
	  var minHeight = -Infinity;
	  var maxHeight = Infinity;
	  var height = hiddenTextarea.scrollHeight;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height = height - paddingSize;
	  } // measure height of a textarea with a single row
	
	
	  hiddenTextarea.value = 'x';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize; // Stores the value's rows count rendered in `hiddenTextarea`,
	  // regardless if `maxRows` or `minRows` props are passed
	
	  var valueRowCount = Math.floor(height / singleRowHeight);
	
	  if (minRows !== null) {
	    minHeight = singleRowHeight * minRows;
	
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	
	    height = Math.max(minHeight, height);
	  }
	
	  if (maxRows !== null) {
	    maxHeight = singleRowHeight * maxRows;
	
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	
	    height = Math.min(maxHeight, height);
	  }
	
	  var rowCount = Math.floor(height / singleRowHeight);
	  return {
	    height: height,
	    minHeight: minHeight,
	    maxHeight: maxHeight,
	    rowCount: rowCount,
	    valueRowCount: valueRowCount
	  };
	}
	
	function calculateNodeStyling(node, uid, useCache) {
	  if (useCache === void 0) {
	    useCache = false;
	  }
	
	  if (useCache && computedStyleCache[uid]) {
	    return computedStyleCache[uid];
	  }
	
	  var style = window.getComputedStyle(node);
	
	  if (style === null) {
	    return null;
	  }
	
	  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
	    obj[name] = style.getPropertyValue(name);
	    return obj;
	  }, {});
	  var boxSizing = sizingStyle['box-sizing']; // probably node is detached from DOM, can't read computed dimensions
	
	  if (boxSizing === '') {
	    return null;
	  } // IE (Edge has already correct behaviour) returns content width as computed width
	  // so we need to add manually padding and border widths
	
	
	  if (isIE && boxSizing === 'border-box') {
	    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
	  }
	
	  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
	  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache) {
	    computedStyleCache[uid] = nodeInfo;
	  }
	
	  return nodeInfo;
	}
	
	var purgeCache = function purgeCache(uid) {
	  delete computedStyleCache[uid];
	};
	
	var noop = function noop() {};
	
	var uid = 0;
	
	var TextareaAutosize =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TextareaAutosize, _React$Component);
	
	  function TextareaAutosize(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	
	    _this._onRef = function (node) {
	      _this._ref = node;
	      var inputRef = _this.props.inputRef;
	
	      if (typeof inputRef === 'function') {
	        inputRef(node);
	        return;
	      }
	
	      inputRef.current = node;
	    };
	
	    _this._onChange = function (event) {
	      if (!_this._controlled) {
	        _this._resizeComponent();
	      }
	
	      _this.props.onChange(event, _assertThisInitialized(_assertThisInitialized(_this)));
	    };
	
	    _this._resizeComponent = function (callback) {
	      if (callback === void 0) {
	        callback = noop;
	      }
	
	      var nodeHeight = calculateNodeHeight(_this._ref, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);
	
	      if (nodeHeight === null) {
	        callback();
	        return;
	      }
	
	      var height = nodeHeight.height,
	          minHeight = nodeHeight.minHeight,
	          maxHeight = nodeHeight.maxHeight,
	          rowCount = nodeHeight.rowCount,
	          valueRowCount = nodeHeight.valueRowCount;
	      _this.rowCount = rowCount;
	      _this.valueRowCount = valueRowCount;
	
	      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
	        _this.setState({
	          height: height,
	          minHeight: minHeight,
	          maxHeight: maxHeight
	        }, callback);
	
	        return;
	      }
	
	      callback();
	    };
	
	    _this.state = {
	      height: props.style && props.style.height || 0,
	      minHeight: -Infinity,
	      maxHeight: Infinity
	    };
	    _this._uid = uid++;
	    _this._controlled = props.value !== undefined;
	    _this._resizeLock = false;
	    return _this;
	  }
	
	  var _proto = TextareaAutosize.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _inputRef = _this$props.inputRef,
	        _maxRows = _this$props.maxRows,
	        _minRows = _this$props.minRows,
	        _onHeightChange = _this$props.onHeightChange,
	        _useCacheForDOMMeasurements = _this$props.useCacheForDOMMeasurements,
	        props = _objectWithoutPropertiesLoose(_this$props, ["inputRef", "maxRows", "minRows", "onHeightChange", "useCacheForDOMMeasurements"]);
	
	    props.style = _extends({}, props.style, {
	      height: this.state.height
	    });
	    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);
	
	    if (maxHeight < this.state.height) {
	      props.style.overflow = 'hidden';
	    }
	
	    return React.createElement("textarea", _extends({}, props, {
	      onChange: this._onChange,
	      ref: this._onRef
	    }));
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
	    // causing competing rerenders (due to setState in the listener) in React.
	    // More can be found here - facebook/react#6324
	
	
	    this._resizeListener = function () {
	      if (_this2._resizeLock) {
	        return;
	      }
	
	      _this2._resizeLock = true;
	
	      _this2._resizeComponent(function () {
	        _this2._resizeLock = false;
	      });
	    };
	
	    window.addEventListener('resize', this._resizeListener);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps !== this.props) {
	      this._resizeComponent();
	    }
	
	    if (this.state.height !== prevState.height) {
	      this.props.onHeightChange(this.state.height, this);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this._resizeListener);
	    purgeCache(this._uid);
	  };
	
	  return TextareaAutosize;
	}(React.Component);
	
	TextareaAutosize.defaultProps = {
	  inputRef: noop,
	  onChange: noop,
	  onHeightChange: noop,
	  useCacheForDOMMeasurements: false
	};
	 false ? TextareaAutosize.propTypes = {
	  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
	    current: PropTypes.any
	  })]),
	  maxRows: PropTypes.number,
	  minRows: PropTypes.number,
	  onChange: PropTypes.func,
	  onHeightChange: PropTypes.func,
	  style: PropTypes.object,
	  useCacheForDOMMeasurements: PropTypes.bool,
	  value: PropTypes.string
	} : void 0;
	
	exports.default = TextareaAutosize;


/***/ }),
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict'
	
	/* global window, self */
	
	var restore = capture()
	
	// istanbul ignore next - Don't allow Prism to run on page load in browser or
	// to start messaging from workers.
	var ctx =
	  typeof window === 'undefined'
	    ? typeof self === 'undefined'
	      ? {}
	      : self
	    : window
	
	ctx.Prism = {manual: true, disableWorkerMessageHandler: true}
	
	// Load all stuff in `prism.js` itself, except for `prism-file-highlight.js`.
	// The wrapped non-leaky grammars are loaded instead of Prism’s originals.
	var h = __webpack_require__(1095)
	var decode = __webpack_require__(1097)
	var Prism = __webpack_require__(1051)
	var markup = __webpack_require__(456)
	var css = __webpack_require__(455)
	var clike = __webpack_require__(1090)
	var js = __webpack_require__(1091)
	
	restore()
	
	var own = {}.hasOwnProperty
	
	// Inherit.
	function Refractor() {}
	
	Refractor.prototype = Prism
	
	// Construct.
	var refract = new Refractor()
	
	// Expose.
	module.exports = refract
	
	// Create.
	refract.highlight = highlight
	refract.register = register
	refract.alias = alias
	refract.registered = registered
	refract.listLanguages = listLanguages
	
	// Register bundled grammars.
	register(markup)
	register(css)
	register(clike)
	register(js)
	
	refract.util.encode = encode
	refract.Token.stringify = stringify
	
	function register(grammar) {
	  if (typeof grammar !== 'function' || !grammar.displayName) {
	    throw new Error('Expected `function` for `grammar`, got `' + grammar + '`')
	  }
	
	  // Do not duplicate registrations.
	  if (refract.languages[grammar.displayName] === undefined) {
	    grammar(refract)
	  }
	}
	
	function alias(name, alias) {
	  var languages = refract.languages
	  var map = name
	  var key
	  var list
	  var length
	  var index
	
	  if (alias) {
	    map = {}
	    map[name] = alias
	  }
	
	  for (key in map) {
	    list = map[key]
	    list = typeof list === 'string' ? [list] : list
	    length = list.length
	    index = -1
	
	    while (++index < length) {
	      languages[list[index]] = languages[key]
	    }
	  }
	}
	
	function highlight(value, name) {
	  var sup = Prism.highlight
	  var grammar
	
	  if (typeof value !== 'string') {
	    throw new Error('Expected `string` for `value`, got `' + value + '`')
	  }
	
	  // `name` is a grammar object.
	  if (refract.util.type(name) === 'Object') {
	    grammar = name
	    name = null
	  } else {
	    if (typeof name !== 'string') {
	      throw new Error('Expected `string` for `name`, got `' + name + '`')
	    }
	
	    if (own.call(refract.languages, name)) {
	      grammar = refract.languages[name]
	    } else {
	      throw new Error('Unknown language: `' + name + '` is not registered')
	    }
	  }
	
	  return sup.call(this, value, grammar, name)
	}
	
	function registered(language) {
	  if (typeof language !== 'string') {
	    throw new Error('Expected `string` for `language`, got `' + language + '`')
	  }
	
	  return own.call(refract.languages, language)
	}
	
	function listLanguages() {
	  var languages = refract.languages
	  var list = []
	  var language
	
	  for (language in languages) {
	    if (
	      own.call(languages, language) &&
	      typeof languages[language] === 'object'
	    ) {
	      list.push(language)
	    }
	  }
	
	  return list
	}
	
	function stringify(value, language, parent) {
	  var env
	
	  if (typeof value === 'string') {
	    return {type: 'text', value: value}
	  }
	
	  if (refract.util.type(value) === 'Array') {
	    return stringifyAll(value, language)
	  }
	
	  env = {
	    type: value.type,
	    content: refract.Token.stringify(value.content, language, parent),
	    tag: 'span',
	    classes: ['token', value.type],
	    attributes: {},
	    language: language,
	    parent: parent
	  }
	
	  if (value.alias) {
	    env.classes = env.classes.concat(value.alias)
	  }
	
	  refract.hooks.run('wrap', env)
	
	  return h(
	    env.tag + '.' + env.classes.join('.'),
	    attributes(env.attributes),
	    env.content
	  )
	}
	
	function stringifyAll(values, language) {
	  var result = []
	  var length = values.length
	  var index = -1
	  var value
	
	  while (++index < length) {
	    value = values[index]
	
	    if (value !== '' && value !== null && value !== undefined) {
	      result.push(value)
	    }
	  }
	
	  index = -1
	  length = result.length
	
	  while (++index < length) {
	    value = result[index]
	    result[index] = refract.Token.stringify(value, language, result)
	  }
	
	  return result
	}
	
	function encode(tokens) {
	  return tokens
	}
	
	function attributes(attrs) {
	  var key
	
	  for (key in attrs) {
	    attrs[key] = decode(attrs[key])
	  }
	
	  return attrs
	}
	
	function capture() {
	  var defined = 'Prism' in global
	  /* istanbul ignore next */
	  var current = defined ? global.Prism : undefined
	
	  return restore
	
	  function restore() {
	    /* istanbul ignore else - Clean leaks after Prism. */
	    if (defined) {
	      global.Prism = current
	    } else {
	      delete global.Prism
	    }
	
	    defined = undefined
	    current = undefined
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = bash
	bash.displayName = 'bash'
	bash.aliases = ['shell']
	function bash(Prism) {
	  ;(function(Prism) {
	    var insideString = {
	      variable: [
	        // Arithmetic Environment
	        {
	          pattern: /\$?\(\([\s\S]+?\)\)/,
	          inside: {
	            // If there is a $ sign at the beginning highlight $(( and )) as variable
	            variable: [
	              {
	                pattern: /(^\$\(\([\s\S]+)\)\)/,
	                lookbehind: true
	              },
	              /^\$\(\(/
	            ],
	            number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee]-?\d+)?/,
	            // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
	            operator: /--?|-=|\+\+?|\+=|!=?|~|\*\*?|\*=|\/=?|%=?|<<=?|>>=?|<=?|>=?|==?|&&?|&=|\^=?|\|\|?|\|=|\?|:/,
	            // If there is no $ sign at the beginning highlight (( and )) as punctuation
	            punctuation: /\(\(?|\)\)?|,|;/
	          }
	        },
	        // Command Substitution
	        {
	          pattern: /\$\([^)]+\)|`[^`]+`/,
	          greedy: true,
	          inside: {
	            variable: /^\$\(|^`|\)$|`$/
	          }
	        },
	        /\$(?:[\w#?*!@]+|\{[^}]+\})/i
	      ]
	    }
	    Prism.languages.bash = {
	      shebang: {
	        pattern: /^#!\s*\/bin\/bash|^#!\s*\/bin\/sh/,
	        alias: 'important'
	      },
	      comment: {
	        pattern: /(^|[^"{\\])#.*/,
	        lookbehind: true
	      },
	      string: [
	        //Support for Here-Documents https://en.wikipedia.org/wiki/Here_document
	        {
	          pattern: /((?:^|[^<])<<\s*)["']?(\w+?)["']?\s*\r?\n(?:[\s\S])*?\r?\n\2/,
	          lookbehind: true,
	          greedy: true,
	          inside: insideString
	        },
	        {
	          pattern: /(["'])(?:\\[\s\S]|\$\([^)]+\)|`[^`]+`|(?!\1)[^\\])*\1/,
	          greedy: true,
	          inside: insideString
	        }
	      ],
	      variable: insideString.variable,
	      // Originally based on http://ss64.com/bash/
	      function: {
	        pattern: /(^|[\s;|&])(?:add|alias|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|builtin|bzip2|cal|cat|cd|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|comm|command|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|du|egrep|eject|enable|env|ethtool|eval|exec|expand|expect|export|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|getopts|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|hash|head|help|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logout|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|popd|pr|printcap|printenv|printf|ps|pushd|pv|pwd|quota|quotacheck|quotactl|ram|rar|rcp|read|readarray|readonly|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|shift|shopt|shutdown|sleep|slocate|sort|source|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tail|tar|tee|test|time|timeout|times|top|touch|tr|traceroute|trap|tsort|tty|type|ulimit|umask|umount|unalias|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zip|zypper)(?=$|[\s;|&])/,
	        lookbehind: true
	      },
	      keyword: {
	        pattern: /(^|[\s;|&])(?:let|:|\.|if|then|else|elif|fi|for|break|continue|while|in|case|function|select|do|done|until|echo|exit|return|set|declare)(?=$|[\s;|&])/,
	        lookbehind: true
	      },
	      boolean: {
	        pattern: /(^|[\s;|&])(?:true|false)(?=$|[\s;|&])/,
	        lookbehind: true
	      },
	      operator: /&&?|\|\|?|==?|!=?|<<<?|>>|<=?|>=?|=~/,
	      punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];]/
	    }
	    var inside = insideString.variable[1].inside
	    inside.string = Prism.languages.bash.string
	    inside['function'] = Prism.languages.bash['function']
	    inside.keyword = Prism.languages.bash.keyword
	    inside['boolean'] = Prism.languages.bash['boolean']
	    inside.operator = Prism.languages.bash.operator
	    inside.punctuation = Prism.languages.bash.punctuation
	    Prism.languages.shell = Prism.languages.bash
	  })(Prism)
	}


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = clike
	clike.displayName = 'clike'
	clike.aliases = []
	function clike(Prism) {
	  Prism.languages.clike = {
	    comment: [
	      {
	        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
	        lookbehind: true
	      },
	      {
	        pattern: /(^|[^\\:])\/\/.*/,
	        lookbehind: true,
	        greedy: true
	      }
	    ],
	    string: {
	      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
	      greedy: true
	    },
	    'class-name': {
	      pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
	      lookbehind: true,
	      inside: {
	        punctuation: /[.\\]/
	      }
	    },
	    keyword: /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
	    boolean: /\b(?:true|false)\b/,
	    function: /\w+(?=\()/,
	    number: /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i,
	    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
	    punctuation: /[{}[\];(),.:]/
	  }
	}


/***/ }),
/* 1091 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = javascript
	javascript.displayName = 'javascript'
	javascript.aliases = ['js']
	function javascript(Prism) {
	  Prism.languages.javascript = Prism.languages.extend('clike', {
	    'class-name': [
	      Prism.languages.clike['class-name'],
	      {
	        pattern: /(^|[^$\w\xA0-\uFFFF])[_$A-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\.(?:prototype|constructor))/,
	        lookbehind: true
	      }
	    ],
	    keyword: [
	      {
	        pattern: /((?:^|})\s*)(?:catch|finally)\b/,
	        lookbehind: true
	      },
	      {
	        pattern: /(^|[^.])\b(?:as|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
	        lookbehind: true
	      }
	    ],
	    number: /\b(?:(?:0[xX][\dA-Fa-f]+|0[bB][01]+|0[oO][0-7]+)n?|\d+n|NaN|Infinity)\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][+-]?\d+)?/,
	    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	    function: /[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	    operator: /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
	  })
	  Prism.languages.javascript[
	    'class-name'
	  ][0].pattern = /(\b(?:class|interface|extends|implements|instanceof|new)\s+)[\w.\\]+/
	  Prism.languages.insertBefore('javascript', 'keyword', {
	    regex: {
	      pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s])\s*)\/(\[(?:[^\]\\\r\n]|\\.)*]|\\.|[^/\\\[\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})\]]))/,
	      lookbehind: true,
	      greedy: true
	    },
	    // This must be declared before keyword because we use "function" inside the look-forward
	    'function-variable': {
	      pattern: /[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/,
	      alias: 'function'
	    },
	    parameter: [
	      {
	        pattern: /(function(?:\s+[_$A-Za-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)?\s*\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\))/,
	        lookbehind: true,
	        inside: Prism.languages.javascript
	      },
	      {
	        pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=>)/i,
	        inside: Prism.languages.javascript
	      },
	      {
	        pattern: /(\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\)\s*=>)/,
	        lookbehind: true,
	        inside: Prism.languages.javascript
	      },
	      {
	        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:[_$A-Za-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\s*)\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\)\s*\{)/,
	        lookbehind: true,
	        inside: Prism.languages.javascript
	      }
	    ],
	    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
	  })
	  Prism.languages.insertBefore('javascript', 'string', {
	    'template-string': {
	      pattern: /`(?:\\[\s\S]|\${[^}]+}|[^\\`])*`/,
	      greedy: true,
	      inside: {
	        interpolation: {
	          pattern: /\${[^}]+}/,
	          inside: {
	            'interpolation-punctuation': {
	              pattern: /^\${|}$/,
	              alias: 'punctuation'
	            },
	            rest: Prism.languages.javascript
	          }
	        },
	        string: /[\s\S]+/
	      }
	    }
	  })
	  if (Prism.languages.markup) {
	    Prism.languages.markup.tag.addInlined('script', 'javascript')
	  }
	  Prism.languages.js = Prism.languages.javascript
	}


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = jsx
	jsx.displayName = 'jsx'
	jsx.aliases = []
	function jsx(Prism) {
	  ;(function(Prism) {
	    var javascript = Prism.util.clone(Prism.languages.javascript)
	    Prism.languages.jsx = Prism.languages.extend('markup', javascript)
	    Prism.languages.jsx.tag.pattern = /<\/?(?:[\w.:-]+\s*(?:\s+(?:[\w.:-]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s{'">=]+|\{(?:\{(?:\{[^}]*\}|[^{}])*\}|[^{}])+\}))?|\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}))*\s*\/?)?>/i
	    Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/i
	    Prism.languages.jsx.tag.inside[
	      'attr-value'
	    ].pattern = /=(?!\{)(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">]+)/i
	    Prism.languages.jsx.tag.inside['tag'].inside[
	      'class-name'
	    ] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/
	    Prism.languages.insertBefore(
	      'inside',
	      'attr-name',
	      {
	        spread: {
	          pattern: /\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}/,
	          inside: {
	            punctuation: /\.{3}|[{}.]/,
	            'attr-value': /\w+/
	          }
	        }
	      },
	      Prism.languages.jsx.tag
	    )
	    Prism.languages.insertBefore(
	      'inside',
	      'attr-value',
	      {
	        script: {
	          // Allow for two levels of nesting
	          pattern: /=(\{(?:\{(?:\{[^}]*\}|[^}])*\}|[^}])+\})/i,
	          inside: {
	            'script-punctuation': {
	              pattern: /^=(?={)/,
	              alias: 'punctuation'
	            },
	            rest: Prism.languages.jsx
	          },
	          alias: 'language-javascript'
	        }
	      },
	      Prism.languages.jsx.tag
	    )
	    // The following will handle plain text inside tags
	    var stringifyToken = function(token) {
	      if (!token) {
	        return ''
	      }
	      if (typeof token === 'string') {
	        return token
	      }
	      if (typeof token.content === 'string') {
	        return token.content
	      }
	      return token.content.map(stringifyToken).join('')
	    }
	    var walkTokens = function(tokens) {
	      var openedTags = []
	      for (var i = 0; i < tokens.length; i++) {
	        var token = tokens[i]
	        var notTagNorBrace = false
	        if (typeof token !== 'string') {
	          if (
	            token.type === 'tag' &&
	            token.content[0] &&
	            token.content[0].type === 'tag'
	          ) {
	            // We found a tag, now find its kind
	            if (token.content[0].content[0].content === '</') {
	              // Closing tag
	              if (
	                openedTags.length > 0 &&
	                openedTags[openedTags.length - 1].tagName ===
	                  stringifyToken(token.content[0].content[1])
	              ) {
	                // Pop matching opening tag
	                openedTags.pop()
	              }
	            } else {
	              if (token.content[token.content.length - 1].content === '/>') {
	                // Autoclosed tag, ignore
	              } else {
	                // Opening tag
	                openedTags.push({
	                  tagName: stringifyToken(token.content[0].content[1]),
	                  openedBraces: 0
	                })
	              }
	            }
	          } else if (
	            openedTags.length > 0 &&
	            token.type === 'punctuation' &&
	            token.content === '{'
	          ) {
	            // Here we might have entered a JSX context inside a tag
	            openedTags[openedTags.length - 1].openedBraces++
	          } else if (
	            openedTags.length > 0 &&
	            openedTags[openedTags.length - 1].openedBraces > 0 &&
	            token.type === 'punctuation' &&
	            token.content === '}'
	          ) {
	            // Here we might have left a JSX context inside a tag
	            openedTags[openedTags.length - 1].openedBraces--
	          } else {
	            notTagNorBrace = true
	          }
	        }
	        if (notTagNorBrace || typeof token === 'string') {
	          if (
	            openedTags.length > 0 &&
	            openedTags[openedTags.length - 1].openedBraces === 0
	          ) {
	            // Here we are inside a tag, and not inside a JSX context.
	            // That's plain text: drop any tokens matched.
	            var plainText = stringifyToken(token)
	            // And merge text with adjacent text
	            if (
	              i < tokens.length - 1 &&
	              (typeof tokens[i + 1] === 'string' ||
	                tokens[i + 1].type === 'plain-text')
	            ) {
	              plainText += stringifyToken(tokens[i + 1])
	              tokens.splice(i + 1, 1)
	            }
	            if (
	              i > 0 &&
	              (typeof tokens[i - 1] === 'string' ||
	                tokens[i - 1].type === 'plain-text')
	            ) {
	              plainText = stringifyToken(tokens[i - 1]) + plainText
	              tokens.splice(i - 1, 1)
	              i--
	            }
	            tokens[i] = new Prism.Token(
	              'plain-text',
	              plainText,
	              null,
	              plainText
	            )
	          }
	        }
	        if (token.content && typeof token.content !== 'string') {
	          walkTokens(token.content)
	        }
	      }
	    }
	    Prism.hooks.add('after-tokenize', function(env) {
	      if (env.language !== 'jsx' && env.language !== 'tsx') {
	        return
	      }
	      walkTokens(env.tokens)
	    })
	  })(Prism)
	}


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var find = __webpack_require__(1098)
	var normalize = __webpack_require__(281)
	var parseSelector = __webpack_require__(863)
	var spaces = __webpack_require__(1113).parse
	var commas = __webpack_require__(637).parse
	
	module.exports = factory
	
	function factory(schema, defaultTagName) {
	  return h
	
	  /* Hyperscript compatible DSL for creating virtual HAST trees. */
	  function h(selector, properties) {
	    var node = parseSelector(selector, defaultTagName)
	    var children = Array.prototype.slice.call(arguments, 2)
	    var property
	
	    if (properties && isChildren(properties, node)) {
	      children.unshift(properties)
	      properties = null
	    }
	
	    if (properties) {
	      for (property in properties) {
	        addProperty(node.properties, property, properties[property])
	      }
	    }
	
	    addChild(node.children, children)
	
	    if (node.tagName === 'template') {
	      node.content = {type: 'root', children: node.children}
	      node.children = []
	    }
	
	    return node
	  }
	
	  function addProperty(properties, key, value) {
	    var info
	    var property
	    var result
	
	    /* Ignore nully and NaN values. */
	    if (value === null || value === undefined || value !== value) {
	      return
	    }
	
	    info = find(schema, key)
	    property = info.property
	    result = value
	
	    /* Handle list values. */
	    if (typeof result === 'string') {
	      if (info.spaceSeparated) {
	        result = spaces(result)
	      } else if (info.commaSeparated) {
	        result = commas(result)
	      } else if (info.commaOrSpaceSeparated) {
	        result = spaces(commas(result).join(' '))
	      }
	    }
	
	    /* Accept `object` on style. */
	    if (property === 'style' && typeof value !== 'string') {
	      result = style(result)
	    }
	
	    /* Class-names (which can be added both on the `selector` and here). */
	    if (property === 'className' && properties.className) {
	      result = properties.className.concat(result)
	    }
	
	    properties[property] = parsePrimitives(info, property, result)
	  }
	}
	
	function isChildren(value, node) {
	  return (
	    typeof value === 'string' ||
	    'length' in value ||
	    isNode(node.tagName, value)
	  )
	}
	
	function isNode(tagName, value) {
	  var type = value.type
	
	  if (tagName === 'input' || !type || typeof type !== 'string') {
	    return false
	  }
	
	  if (typeof value.children === 'object' && 'length' in value.children) {
	    return true
	  }
	
	  type = type.toLowerCase()
	
	  if (tagName === 'button') {
	    return (
	      type !== 'menu' &&
	      type !== 'submit' &&
	      type !== 'reset' &&
	      type !== 'button'
	    )
	  }
	
	  return 'value' in value
	}
	
	function addChild(nodes, value) {
	  var index
	  var length
	
	  if (typeof value === 'string' || typeof value === 'number') {
	    nodes.push({type: 'text', value: String(value)})
	    return
	  }
	
	  if (typeof value === 'object' && 'length' in value) {
	    index = -1
	    length = value.length
	
	    while (++index < length) {
	      addChild(nodes, value[index])
	    }
	
	    return
	  }
	
	  if (typeof value !== 'object' || !('type' in value)) {
	    throw new Error('Expected node, nodes, or string, got `' + value + '`')
	  }
	
	  nodes.push(value)
	}
	
	/* Parse a (list of) primitives. */
	function parsePrimitives(info, name, value) {
	  var index
	  var length
	  var result
	
	  if (typeof value !== 'object' || !('length' in value)) {
	    return parsePrimitive(info, name, value)
	  }
	
	  length = value.length
	  index = -1
	  result = []
	
	  while (++index < length) {
	    result[index] = parsePrimitive(info, name, value[index])
	  }
	
	  return result
	}
	
	/* Parse a single primitives. */
	function parsePrimitive(info, name, value) {
	  var result = value
	
	  if (info.number || info.positiveNumber) {
	    if (!isNaN(result) && result !== '') {
	      result = Number(result)
	    }
	  } else if (info.boolean || info.overloadedBoolean) {
	    /* Accept `boolean` and `string`. */
	    if (
	      typeof result === 'string' &&
	      (result === '' || normalize(value) === normalize(name))
	    ) {
	      result = true
	    }
	  }
	
	  return result
	}
	
	function style(value) {
	  var result = []
	  var key
	
	  for (key in value) {
	    result.push([key, value[key]].join(': '))
	  }
	
	  return result.join('; ')
	}


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var schema = __webpack_require__(1099)
	var factory = __webpack_require__(1093)
	
	var html = factory(schema, 'div')
	html.displayName = 'html'
	
	module.exports = html


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = __webpack_require__(1094)


/***/ }),
/* 1096 */
/***/ (function(module, exports) {

	'use strict'
	
	/* eslint-env browser */
	
	var el
	
	var semicolon = 59 //  ';'
	
	module.exports = decodeEntity
	
	function decodeEntity(characters) {
	  var entity = '&' + characters + ';'
	  var char
	
	  el = el || document.createElement('i')
	  el.innerHTML = entity
	  char = el.textContent
	
	  // Some entities do not require the closing semicolon (`&not` - for instance),
	  // which leads to situations where parsing the assumed entity of &notit; will
	  // result in the string `¬it;`.  When we encounter a trailing semicolon after
	  // parsing and the entity to decode was not a semicolon (`&semi;`), we can
	  // assume that the matching was incomplete
	  if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') {
	    return false
	  }
	
	  // If the decoded string is equal to the input, the entity was not valid
	  return char === entity ? false : char
	}


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var legacy = __webpack_require__(966)
	var invalid = __webpack_require__(967)
	var decimal = __webpack_require__(430)
	var hexadecimal = __webpack_require__(907)
	var alphanumerical = __webpack_require__(906)
	var decodeEntity = __webpack_require__(1096)
	
	module.exports = parseEntities
	
	var own = {}.hasOwnProperty
	var fromCharCode = String.fromCharCode
	var noop = Function.prototype
	
	// Default settings.
	var defaults = {
	  warning: null,
	  reference: null,
	  text: null,
	  warningContext: null,
	  referenceContext: null,
	  textContext: null,
	  position: {},
	  additional: null,
	  attribute: false,
	  nonTerminated: true
	}
	
	// Characters.
	var tab = 9 // '\t'
	var lineFeed = 10 // '\n'
	var formFeed = 12 //  '\f'
	var space = 32 // ' '
	var ampersand = 38 //  '&'
	var semicolon = 59 //  ';'
	var lessThan = 60 //  '<'
	var equalsTo = 61 //  '='
	var numberSign = 35 //  '#'
	var uppercaseX = 88 //  'X'
	var lowercaseX = 120 //  'x'
	var replacementCharacter = 65533 // '�'
	
	// Reference types.
	var name = 'named'
	var hexa = 'hexadecimal'
	var deci = 'decimal'
	
	// Map of bases.
	var bases = {}
	
	bases[hexa] = 16
	bases[deci] = 10
	
	// Map of types to tests.
	// Each type of character reference accepts different characters.
	// This test is used to detect whether a reference has ended (as the semicolon
	// is not strictly needed).
	var tests = {}
	
	tests[name] = alphanumerical
	tests[deci] = decimal
	tests[hexa] = hexadecimal
	
	// Warning types.
	var namedNotTerminated = 1
	var numericNotTerminated = 2
	var namedEmpty = 3
	var numericEmpty = 4
	var namedUnknown = 5
	var numericDisallowed = 6
	var numericProhibited = 7
	
	// Warning messages.
	var messages = {}
	
	messages[namedNotTerminated] =
	  'Named character references must be terminated by a semicolon'
	messages[numericNotTerminated] =
	  'Numeric character references must be terminated by a semicolon'
	messages[namedEmpty] = 'Named character references cannot be empty'
	messages[numericEmpty] = 'Numeric character references cannot be empty'
	messages[namedUnknown] = 'Named character references must be known'
	messages[numericDisallowed] =
	  'Numeric character references cannot be disallowed'
	messages[numericProhibited] =
	  'Numeric character references cannot be outside the permissible Unicode range'
	
	// Wrap to ensure clean parameters are given to `parse`.
	function parseEntities(value, options) {
	  var settings = {}
	  var option
	  var key
	
	  if (!options) {
	    options = {}
	  }
	
	  for (key in defaults) {
	    option = options[key]
	    settings[key] =
	      option === null || option === undefined ? defaults[key] : option
	  }
	
	  if (settings.position.indent || settings.position.start) {
	    settings.indent = settings.position.indent || []
	    settings.position = settings.position.start
	  }
	
	  return parse(value, settings)
	}
	
	// Parse entities.
	// eslint-disable-next-line complexity
	function parse(value, settings) {
	  var additional = settings.additional
	  var nonTerminated = settings.nonTerminated
	  var handleText = settings.text
	  var handleReference = settings.reference
	  var handleWarning = settings.warning
	  var textContext = settings.textContext
	  var referenceContext = settings.referenceContext
	  var warningContext = settings.warningContext
	  var pos = settings.position
	  var indent = settings.indent || []
	  var length = value.length
	  var index = 0
	  var lines = -1
	  var column = pos.column || 1
	  var line = pos.line || 1
	  var queue = ''
	  var result = []
	  var entityCharacters
	  var namedEntity
	  var terminated
	  var characters
	  var character
	  var reference
	  var following
	  var warning
	  var reason
	  var output
	  var entity
	  var begin
	  var start
	  var type
	  var test
	  var prev
	  var next
	  var diff
	  var end
	
	  if (typeof additional === 'string') {
	    additional = additional.charCodeAt(0)
	  }
	
	  // Cache the current point.
	  prev = now()
	
	  // Wrap `handleWarning`.
	  warning = handleWarning ? parseError : noop
	
	  // Ensure the algorithm walks over the first character and the end (inclusive).
	  index--
	  length++
	
	  while (++index < length) {
	    // If the previous character was a newline.
	    if (character === lineFeed) {
	      column = indent[lines] || 1
	    }
	
	    character = value.charCodeAt(index)
	
	    if (character === ampersand) {
	      following = value.charCodeAt(index + 1)
	
	      // The behaviour depends on the identity of the next character.
	      if (
	        following === tab ||
	        following === lineFeed ||
	        following === formFeed ||
	        following === space ||
	        following === ampersand ||
	        following === lessThan ||
	        following !== following ||
	        (additional && following === additional)
	      ) {
	        // Not a character reference.
	        // No characters are consumed, and nothing is returned.
	        // This is not an error, either.
	        queue += fromCharCode(character)
	        column++
	
	        continue
	      }
	
	      start = index + 1
	      begin = start
	      end = start
	
	      if (following === numberSign) {
	        // Numerical entity.
	        end = ++begin
	
	        // The behaviour further depends on the next character.
	        following = value.charCodeAt(end)
	
	        if (following === uppercaseX || following === lowercaseX) {
	          // ASCII hex digits.
	          type = hexa
	          end = ++begin
	        } else {
	          // ASCII digits.
	          type = deci
	        }
	      } else {
	        // Named entity.
	        type = name
	      }
	
	      entityCharacters = ''
	      entity = ''
	      characters = ''
	      test = tests[type]
	      end--
	
	      while (++end < length) {
	        following = value.charCodeAt(end)
	
	        if (!test(following)) {
	          break
	        }
	
	        characters += fromCharCode(following)
	
	        // Check if we can match a legacy named reference.
	        // If so, we cache that as the last viable named reference.
	        // This ensures we do not need to walk backwards later.
	        if (type === name && own.call(legacy, characters)) {
	          entityCharacters = characters
	          entity = legacy[characters]
	        }
	      }
	
	      terminated = value.charCodeAt(end) === semicolon
	
	      if (terminated) {
	        end++
	
	        namedEntity = type === name ? decodeEntity(characters) : false
	
	        if (namedEntity) {
	          entityCharacters = characters
	          entity = namedEntity
	        }
	      }
	
	      diff = 1 + end - start
	
	      if (!terminated && !nonTerminated) {
	        // Empty.
	      } else if (!characters) {
	        // An empty (possible) entity is valid, unless it’s numeric (thus an
	        // ampersand followed by an octothorp).
	        if (type !== name) {
	          warning(numericEmpty, diff)
	        }
	      } else if (type === name) {
	        // An ampersand followed by anything unknown, and not terminated, is
	        // invalid.
	        if (terminated && !entity) {
	          warning(namedUnknown, 1)
	        } else {
	          // If theres something after an entity name which is not known, cap
	          // the reference.
	          if (entityCharacters !== characters) {
	            end = begin + entityCharacters.length
	            diff = 1 + end - begin
	            terminated = false
	          }
	
	          // If the reference is not terminated, warn.
	          if (!terminated) {
	            reason = entityCharacters ? namedNotTerminated : namedEmpty
	
	            if (settings.attribute) {
	              following = value.charCodeAt(end)
	
	              if (following === equalsTo) {
	                warning(reason, diff)
	                entity = null
	              } else if (alphanumerical(following)) {
	                entity = null
	              } else {
	                warning(reason, diff)
	              }
	            } else {
	              warning(reason, diff)
	            }
	          }
	        }
	
	        reference = entity
	      } else {
	        if (!terminated) {
	          // All non-terminated numeric entities are not rendered, and trigger a
	          // warning.
	          warning(numericNotTerminated, diff)
	        }
	
	        // When terminated and number, parse as either hexadecimal or decimal.
	        reference = parseInt(characters, bases[type])
	
	        // Trigger a warning when the parsed number is prohibited, and replace
	        // with replacement character.
	        if (prohibited(reference)) {
	          warning(numericProhibited, diff)
	          reference = fromCharCode(replacementCharacter)
	        } else if (reference in invalid) {
	          // Trigger a warning when the parsed number is disallowed, and replace
	          // by an alternative.
	          warning(numericDisallowed, diff)
	          reference = invalid[reference]
	        } else {
	          // Parse the number.
	          output = ''
	
	          // Trigger a warning when the parsed number should not be used.
	          if (disallowed(reference)) {
	            warning(numericDisallowed, diff)
	          }
	
	          // Stringify the number.
	          if (reference > 0xffff) {
	            reference -= 0x10000
	            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
	            reference = 0xdc00 | (reference & 0x3ff)
	          }
	
	          reference = output + fromCharCode(reference)
	        }
	      }
	
	      // Found it!
	      // First eat the queued characters as normal text, then eat an entity.
	      if (reference) {
	        flush()
	
	        prev = now()
	        index = end - 1
	        column += end - start + 1
	        result.push(reference)
	        next = now()
	        next.offset++
	
	        if (handleReference) {
	          handleReference.call(
	            referenceContext,
	            reference,
	            {start: prev, end: next},
	            value.slice(start - 1, end)
	          )
	        }
	
	        prev = next
	      } else {
	        // If we could not find a reference, queue the checked characters (as
	        // normal characters), and move the pointer to their end.
	        // This is possible because we can be certain neither newlines nor
	        // ampersands are included.
	        characters = value.slice(start - 1, end)
	        queue += characters
	        column += characters.length
	        index = end - 1
	      }
	    } else {
	      // Handle anything other than an ampersand, including newlines and EOF.
	      if (
	        character === 10 // Line feed
	      ) {
	        line++
	        lines++
	        column = 0
	      }
	
	      if (character === character) {
	        queue += fromCharCode(character)
	        column++
	      } else {
	        flush()
	      }
	    }
	  }
	
	  // Return the reduced nodes, and any possible warnings.
	  return result.join('')
	
	  // Get current position.
	  function now() {
	    return {
	      line: line,
	      column: column,
	      offset: index + (pos.offset || 0)
	    }
	  }
	
	  // “Throw” a parse-error: a warning.
	  function parseError(code, offset) {
	    var position = now()
	
	    position.column += offset
	    position.offset += offset
	
	    handleWarning.call(warningContext, messages[code], position, code)
	  }
	
	  // Flush `queue` (normal text).
	  // Macro invoked before each entity and at the end of `value`.
	  // Does nothing when `queue` is empty.
	  function flush() {
	    if (queue) {
	      result.push(queue)
	
	      if (handleText) {
	        handleText.call(textContext, queue, {start: prev, end: now()})
	      }
	
	      queue = ''
	    }
	  }
	}
	
	// Check if `character` is outside the permissible unicode range.
	function prohibited(code) {
	  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
	}
	
	// Check if `character` is disallowed.
	function disallowed(code) {
	  return (
	    (code >= 0x0001 && code <= 0x0008) ||
	    code === 0x000b ||
	    (code >= 0x000d && code <= 0x001f) ||
	    (code >= 0x007f && code <= 0x009f) ||
	    (code >= 0xfdd0 && code <= 0xfdef) ||
	    (code & 0xffff) === 0xffff ||
	    (code & 0xffff) === 0xfffe
	  )
	}


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(281)
	var DefinedInfo = __webpack_require__(458)
	var Info = __webpack_require__(459)
	
	var data = 'data'
	
	module.exports = find
	
	var valid = /^data[-a-z0-9.:_]+$/i
	var dash = /-[a-z]/g
	var cap = /[A-Z]/g
	
	function find(schema, value) {
	  var normal = normalize(value)
	  var prop = value
	  var Type = Info
	
	  if (normal in schema.normal) {
	    return schema.property[schema.normal[normal]]
	  }
	
	  if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
	    // Attribute or property.
	    if (value.charAt(4) === '-') {
	      prop = datasetToProperty(value)
	    } else {
	      value = datasetToAttribute(value)
	    }
	
	    Type = DefinedInfo
	  }
	
	  return new Type(prop, value)
	}
	
	function datasetToProperty(attribute) {
	  var value = attribute.slice(5).replace(dash, camelcase)
	  return data + value.charAt(0).toUpperCase() + value.slice(1)
	}
	
	function datasetToAttribute(property) {
	  var value = property.slice(4)
	
	  if (dash.test(value)) {
	    return property
	  }
	
	  value = value.replace(cap, kebab)
	
	  if (value.charAt(0) !== '-') {
	    value = '-' + value
	  }
	
	  return data + value
	}
	
	function kebab($0) {
	  return '-' + $0.toLowerCase()
	}
	
	function camelcase($0) {
	  return $0.charAt(1).toUpperCase()
	}


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var merge = __webpack_require__(1103)
	var xlink = __webpack_require__(1104)
	var xml = __webpack_require__(1105)
	var xmlns = __webpack_require__(1106)
	var aria = __webpack_require__(1100)
	var html = __webpack_require__(1101)
	
	module.exports = merge([xml, xlink, xmlns, aria, html])


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(280)
	var create = __webpack_require__(132)
	
	var booleanish = types.booleanish
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	
	module.exports = create({
	  transform: ariaTransform,
	  properties: {
	    ariaActiveDescendant: null,
	    ariaAtomic: booleanish,
	    ariaAutoComplete: null,
	    ariaBusy: booleanish,
	    ariaChecked: booleanish,
	    ariaColCount: number,
	    ariaColIndex: number,
	    ariaColSpan: number,
	    ariaControls: spaceSeparated,
	    ariaCurrent: null,
	    ariaDescribedBy: spaceSeparated,
	    ariaDetails: null,
	    ariaDisabled: booleanish,
	    ariaDropEffect: spaceSeparated,
	    ariaErrorMessage: null,
	    ariaExpanded: booleanish,
	    ariaFlowTo: spaceSeparated,
	    ariaGrabbed: booleanish,
	    ariaHasPopup: null,
	    ariaHidden: booleanish,
	    ariaInvalid: null,
	    ariaKeyShortcuts: null,
	    ariaLabel: null,
	    ariaLabelledBy: spaceSeparated,
	    ariaLevel: number,
	    ariaLive: null,
	    ariaModal: booleanish,
	    ariaMultiLine: booleanish,
	    ariaMultiSelectable: booleanish,
	    ariaOrientation: null,
	    ariaOwns: spaceSeparated,
	    ariaPlaceholder: null,
	    ariaPosInSet: number,
	    ariaPressed: booleanish,
	    ariaReadOnly: booleanish,
	    ariaRelevant: null,
	    ariaRequired: booleanish,
	    ariaRoleDescription: spaceSeparated,
	    ariaRowCount: number,
	    ariaRowIndex: number,
	    ariaRowSpan: number,
	    ariaSelected: booleanish,
	    ariaSetSize: number,
	    ariaSort: null,
	    ariaValueMax: number,
	    ariaValueMin: number,
	    ariaValueNow: number,
	    ariaValueText: null,
	    role: null
	  }
	})
	
	function ariaTransform(_, prop) {
	  return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
	}


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(280)
	var create = __webpack_require__(132)
	var caseInsensitiveTransform = __webpack_require__(457)
	
	var boolean = types.boolean
	var overloadedBoolean = types.overloadedBoolean
	var booleanish = types.booleanish
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	var commaSeparated = types.commaSeparated
	
	module.exports = create({
	  space: 'html',
	  attributes: {
	    acceptcharset: 'accept-charset',
	    classname: 'class',
	    htmlfor: 'for',
	    httpequiv: 'http-equiv'
	  },
	  transform: caseInsensitiveTransform,
	  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
	  properties: {
	    // Standard Properties.
	    abbr: null,
	    accept: commaSeparated,
	    acceptCharset: spaceSeparated,
	    accessKey: spaceSeparated,
	    action: null,
	    allow: null,
	    allowFullScreen: boolean,
	    allowPaymentRequest: boolean,
	    allowUserMedia: boolean,
	    alt: null,
	    as: null,
	    async: boolean,
	    autoCapitalize: null,
	    autoComplete: spaceSeparated,
	    autoFocus: boolean,
	    autoPlay: boolean,
	    capture: boolean,
	    charSet: null,
	    checked: boolean,
	    cite: null,
	    className: spaceSeparated,
	    cols: number,
	    colSpan: null,
	    content: null,
	    contentEditable: booleanish,
	    controls: boolean,
	    controlsList: spaceSeparated,
	    coords: number | commaSeparated,
	    crossOrigin: null,
	    data: null,
	    dateTime: null,
	    decoding: null,
	    default: boolean,
	    defer: boolean,
	    dir: null,
	    dirName: null,
	    disabled: boolean,
	    download: overloadedBoolean,
	    draggable: booleanish,
	    encType: null,
	    enterKeyHint: null,
	    form: null,
	    formAction: null,
	    formEncType: null,
	    formMethod: null,
	    formNoValidate: boolean,
	    formTarget: null,
	    headers: spaceSeparated,
	    height: number,
	    hidden: boolean,
	    high: number,
	    href: null,
	    hrefLang: null,
	    htmlFor: spaceSeparated,
	    httpEquiv: spaceSeparated,
	    id: null,
	    imageSizes: null,
	    imageSrcSet: commaSeparated,
	    inputMode: null,
	    integrity: null,
	    is: null,
	    isMap: boolean,
	    itemId: null,
	    itemProp: spaceSeparated,
	    itemRef: spaceSeparated,
	    itemScope: boolean,
	    itemType: spaceSeparated,
	    kind: null,
	    label: null,
	    lang: null,
	    language: null,
	    list: null,
	    loop: boolean,
	    low: number,
	    manifest: null,
	    max: null,
	    maxLength: number,
	    media: null,
	    method: null,
	    min: null,
	    minLength: number,
	    multiple: boolean,
	    muted: boolean,
	    name: null,
	    nonce: null,
	    noModule: boolean,
	    noValidate: boolean,
	    open: boolean,
	    optimum: number,
	    pattern: null,
	    ping: spaceSeparated,
	    placeholder: null,
	    playsInline: boolean,
	    poster: null,
	    preload: null,
	    readOnly: boolean,
	    referrerPolicy: null,
	    rel: spaceSeparated,
	    required: boolean,
	    reversed: boolean,
	    rows: number,
	    rowSpan: number,
	    sandbox: spaceSeparated,
	    scope: null,
	    scoped: boolean,
	    seamless: boolean,
	    selected: boolean,
	    shape: null,
	    size: number,
	    sizes: null,
	    slot: null,
	    span: number,
	    spellCheck: booleanish,
	    src: null,
	    srcDoc: null,
	    srcLang: null,
	    srcSet: commaSeparated,
	    start: number,
	    step: null,
	    style: null,
	    tabIndex: number,
	    target: null,
	    title: null,
	    translate: null,
	    type: null,
	    typeMustMatch: boolean,
	    useMap: null,
	    value: booleanish,
	    width: number,
	    wrap: null,
	
	    // Legacy.
	    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
	    align: null, // Several. Use CSS `text-align` instead,
	    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
	    archive: spaceSeparated, // `<object>`. List of URIs to archives
	    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
	    background: null, // `<body>`. Use CSS `background-image` instead
	    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
	    border: number, // `<table>`. Use CSS `border-width` instead,
	    borderColor: null, // `<table>`. Use CSS `border-color` instead,
	    bottomMargin: number, // `<body>`
	    cellPadding: null, // `<table>`
	    cellSpacing: null, // `<table>`
	    char: null, // Several table elements. When `align=char`, sets the character to align on
	    charOff: null, // Several table elements. When `char`, offsets the alignment
	    classId: null, // `<object>`
	    clear: null, // `<br>`. Use CSS `clear` instead
	    code: null, // `<object>`
	    codeBase: null, // `<object>`
	    codeType: null, // `<object>`
	    color: null, // `<font>` and `<hr>`. Use CSS instead
	    compact: boolean, // Lists. Use CSS to reduce space between items instead
	    declare: boolean, // `<object>`
	    event: null, // `<script>`
	    face: null, // `<font>`. Use CSS instead
	    frame: null, // `<table>`
	    frameBorder: null, // `<iframe>`. Use CSS `border` instead
	    hSpace: number, // `<img>` and `<object>`
	    leftMargin: number, // `<body>`
	    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
	    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
	    lowSrc: null, // `<img>`. Use a `<picture>`
	    marginHeight: number, // `<body>`
	    marginWidth: number, // `<body>`
	    noResize: boolean, // `<frame>`
	    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
	    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
	    noWrap: boolean, // `<td>` and `<th>`
	    object: null, // `<applet>`
	    profile: null, // `<head>`
	    prompt: null, // `<isindex>`
	    rev: null, // `<link>`
	    rightMargin: number, // `<body>`
	    rules: null, // `<table>`
	    scheme: null, // `<meta>`
	    scrolling: booleanish, // `<frame>`. Use overflow in the child context
	    standby: null, // `<object>`
	    summary: null, // `<table>`
	    text: null, // `<body>`. Use CSS `color` instead
	    topMargin: number, // `<body>`
	    valueType: null, // `<param>`
	    version: null, // `<html>`. Use a doctype.
	    vAlign: null, // Several. Use CSS `vertical-align` instead
	    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
	    vSpace: number, // `<img>` and `<object>`
	
	    // Non-standard Properties.
	    allowTransparency: null,
	    autoCorrect: null,
	    autoSave: null,
	    prefix: null,
	    property: null,
	    results: number,
	    security: null,
	    unselectable: null
	  }
	})


/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = caseSensitiveTransform
	
	function caseSensitiveTransform(attributes, attribute) {
	  return attribute in attributes ? attributes[attribute] : attribute
	}


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(1172)
	var Schema = __webpack_require__(460)
	
	module.exports = merge
	
	function merge(definitions) {
	  var length = definitions.length
	  var property = []
	  var normal = []
	  var index = -1
	  var info
	  var space
	
	  while (++index < length) {
	    info = definitions[index]
	    property.push(info.property)
	    normal.push(info.normal)
	    space = info.space
	  }
	
	  return new Schema(
	    xtend.apply(null, property),
	    xtend.apply(null, normal),
	    space
	  )
	}


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(132)
	
	module.exports = create({
	  space: 'xlink',
	  transform: xlinkTransform,
	  properties: {
	    xLinkActuate: null,
	    xLinkArcRole: null,
	    xLinkHref: null,
	    xLinkRole: null,
	    xLinkShow: null,
	    xLinkTitle: null,
	    xLinkType: null
	  }
	})
	
	function xlinkTransform(_, prop) {
	  return 'xlink:' + prop.slice(5).toLowerCase()
	}


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(132)
	
	module.exports = create({
	  space: 'xml',
	  transform: xmlTransform,
	  properties: {
	    xmlLang: null,
	    xmlBase: null,
	    xmlSpace: null
	  }
	})
	
	function xmlTransform(_, prop) {
	  return 'xml:' + prop.slice(3).toLowerCase()
	}


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(132)
	var caseInsensitiveTransform = __webpack_require__(457)
	
	module.exports = create({
	  space: 'xmlns',
	  attributes: {
	    xmlnsxlink: 'xmlns:xlink'
	  },
	  transform: caseInsensitiveTransform,
	  properties: {
	    xmlns: null,
	    xmlnsXLink: null
	  }
	})


/***/ }),
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * simplebar-react - v1.0.0-alpha.9
	 * React component for SimpleBar
	 * https://grsmto.github.io/simplebar/
	 *
	 * Made by Adrien Denat
	 * Under MIT License
	 */
	
	!function(e,r){ true?module.exports=r(__webpack_require__(1),__webpack_require__(4),__webpack_require__(1112)):"function"==typeof define&&define.amd?define(["react","prop-types","simplebar"],r):(e=e||self).SimpleBar=r(e.React,e.PropTypes)}(this,function(e,r){"use strict";function a(){return(a=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var a=arguments[r];for(var t in a)Object.prototype.hasOwnProperty.call(a,t)&&(e[t]=a[t])}return e}).apply(this,arguments)}function t(e,r){if(null==e)return{};var a,t,l=function(e,r){if(null==e)return{};var a,t,l={},s=Object.keys(e);for(t=0;t<s.length;t++)a=s[t],r.indexOf(a)>=0||(l[a]=e[a]);return l}(e,r);if(Object.getOwnPropertySymbols){var s=Object.getOwnPropertySymbols(e);for(t=0;t<s.length;t++)a=s[t],r.indexOf(a)>=0||Object.prototype.propertyIsEnumerable.call(e,a)&&(l[a]=e[a])}return l}function l(r){var l=r.children,s=r.scrollableNodeProps,n=t(r,["children","scrollableNodeProps"]);return e.createElement("div",a({"data-simplebar":!0},n),e.createElement("div",{className:"simplebar-wrapper"},e.createElement("div",{className:"simplebar-height-auto-observer-wrapper"},e.createElement("div",{className:"simplebar-height-auto-observer"})),e.createElement("div",{className:"simplebar-mask"},e.createElement("div",{className:"simplebar-offset"},e.createElement("div",{className:"simplebar-content-wrapper"},e.createElement("div",a({},s,{className:"simplebar-content".concat(s&&s.className?" ".concat(s.className):"")}),l)))),e.createElement("div",{className:"simplebar-placeholder"})),e.createElement("div",{className:"simplebar-track simplebar-horizontal"},e.createElement("div",{className:"simplebar-scrollbar"})),e.createElement("div",{className:"simplebar-track simplebar-vertical"},e.createElement("div",{className:"simplebar-scrollbar"})))}return e=e&&e.hasOwnProperty("default")?e.default:e,r=r&&r.hasOwnProperty("default")?r.default:r,l.propTypes={children:r.node},l});


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * SimpleBar.js - v4.0.0-alpha.9
	 * Scrollbars, simpler.
	 * https://grsmto.github.io/simplebar/
	 *
	 * Made by Adrien Denat from a fork by Jonathan Nicol
	 * Under MIT License
	 */
	
	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t=t||self).SimpleBar=e()}(this,function(){"use strict";var t=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t},e=function(t){try{return!!t()}catch(t){return!0}},i={}.toString,r=function(t){return i.call(t).slice(8,-1)},n="".split,s=e(function(){return!Object("z").propertyIsEnumerable(0)})?function(t){return"String"==r(t)?n.call(t,""):Object(t)}:Object,o=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t},a=function(t){return Object(o(t))},l=Math.ceil,c=Math.floor,u=function(t){return isNaN(t=+t)?0:(t>0?c:l)(t)},h=Math.min,f=function(t){return t>0?h(u(t),9007199254740991):0},d=function(t){return"object"==typeof t?null!==t:"function"==typeof t},p=Array.isArray||function(t){return"Array"==r(t)},v="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function g(t,e){return t(e={exports:{}},e.exports),e.exports}var b,m,y,x,E="object"==typeof window&&window&&window.Math==Math?window:"object"==typeof self&&self&&self.Math==Math?self:Function("return this")(),w=!e(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),O=E.document,_=d(O)&&d(O.createElement),S=!w&&!e(function(){return 7!=Object.defineProperty((t="div",_?O.createElement(t):{}),"a",{get:function(){return 7}}).a;var t}),A=function(t){if(!d(t))throw TypeError(String(t)+" is not an object");return t},L=function(t,e){if(!d(t))return t;var i,r;if(e&&"function"==typeof(i=t.toString)&&!d(r=i.call(t)))return r;if("function"==typeof(i=t.valueOf)&&!d(r=i.call(t)))return r;if(!e&&"function"==typeof(i=t.toString)&&!d(r=i.call(t)))return r;throw TypeError("Can't convert object to primitive value")},M=Object.defineProperty,k={f:w?M:function(t,e,i){if(A(t),e=L(e,!0),A(i),S)try{return M(t,e,i)}catch(t){}if("get"in i||"set"in i)throw TypeError("Accessors not supported");return"value"in i&&(t[e]=i.value),t}},W=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},T=w?function(t,e,i){return k.f(t,e,W(1,i))}:function(t,e,i){return t[e]=i,t},j=function(t,e){try{T(E,t,e)}catch(i){E[t]=e}return e},R=g(function(t){var e=E["__core-js_shared__"]||j("__core-js_shared__",{});(t.exports=function(t,i){return e[t]||(e[t]=void 0!==i?i:{})})("versions",[]).push({version:"3.0.1",mode:"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})}),N=0,z=Math.random(),C=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++N+z).toString(36))},V=!e(function(){return!String(Symbol())}),D=R("wks"),B=E.Symbol,I=function(t){return D[t]||(D[t]=V&&B[t]||(V?B:C)("Symbol."+t))},P=I("species"),H=function(t,e){var i;return p(t)&&("function"!=typeof(i=t.constructor)||i!==Array&&!p(i.prototype)?d(i)&&null===(i=i[P])&&(i=void 0):i=void 0),new(void 0===i?Array:i)(0===e?0:e)},q=function(e,i){var r=1==e,n=2==e,o=3==e,l=4==e,c=6==e,u=5==e||c,h=i||H;return function(i,d,p){for(var v,g,b=a(i),m=s(b),y=function(e,i,r){if(t(e),void 0===i)return e;switch(r){case 0:return function(){return e.call(i)};case 1:return function(t){return e.call(i,t)};case 2:return function(t,r){return e.call(i,t,r)};case 3:return function(t,r,n){return e.call(i,t,r,n)}}return function(){return e.apply(i,arguments)}}(d,p,3),x=f(m.length),E=0,w=r?h(i,x):n?h(i,0):void 0;x>E;E++)if((u||E in m)&&(g=y(v=m[E],E,b),e))if(r)w[E]=g;else if(g)switch(e){case 3:return!0;case 5:return v;case 6:return E;case 2:w.push(v)}else if(l)return!1;return c?-1:o||l?l:w}},F=I("species"),$={}.propertyIsEnumerable,X=Object.getOwnPropertyDescriptor,Y={f:X&&!$.call({1:2},1)?function(t){var e=X(this,t);return!!e&&e.enumerable}:$},G=function(t){return s(o(t))},K={}.hasOwnProperty,U=function(t,e){return K.call(t,e)},J=Object.getOwnPropertyDescriptor,Q={f:w?J:function(t,e){if(t=G(t),e=L(e,!0),S)try{return J(t,e)}catch(t){}if(U(t,e))return W(!Y.f.call(t,e),t[e])}},Z=R("native-function-to-string",Function.toString),tt=E.WeakMap,et="function"==typeof tt&&/native code/.test(Z.call(tt)),it=R("keys"),rt={},nt=E.WeakMap;if(et){var st=new nt,ot=st.get,at=st.has,lt=st.set;b=function(t,e){return lt.call(st,t,e),e},m=function(t){return ot.call(st,t)||{}},y=function(t){return at.call(st,t)}}else{var ct=it[x="state"]||(it[x]=C(x));rt[ct]=!0,b=function(t,e){return T(t,ct,e),e},m=function(t){return U(t,ct)?t[ct]:{}},y=function(t){return U(t,ct)}}var ut,ht,ft={set:b,get:m,has:y,enforce:function(t){return y(t)?m(t):b(t,{})},getterFor:function(t){return function(e){var i;if(!d(e)||(i=m(e)).type!==t)throw TypeError("Incompatible receiver, "+t+" required");return i}}},dt=g(function(t){var e=ft.get,i=ft.enforce,r=String(Z).split("toString");R("inspectSource",function(t){return Z.call(t)}),(t.exports=function(t,e,n,s){var o=!!s&&!!s.unsafe,a=!!s&&!!s.enumerable,l=!!s&&!!s.noTargetGet;"function"==typeof n&&("string"!=typeof e||U(n,"name")||T(n,"name",e),i(n).source=r.join("string"==typeof e?e:"")),t!==E?(o?!l&&t[e]&&(a=!0):delete t[e],a?t[e]=n:T(t,e,n)):a?t[e]=n:j(e,n)})(Function.prototype,"toString",function(){return"function"==typeof this&&e(this).source||Z.call(this)})}),pt=Math.max,vt=Math.min,gt=(ut=!1,function(t,e,i){var r,n=G(t),s=f(n.length),o=function(t,e){var i=u(t);return i<0?pt(i+e,0):vt(i,e)}(i,s);if(ut&&e!=e){for(;s>o;)if((r=n[o++])!=r)return!0}else for(;s>o;o++)if((ut||o in n)&&n[o]===e)return ut||o||0;return!ut&&-1}),bt=function(t,e){var i,r=G(t),n=0,s=[];for(i in r)!U(rt,i)&&U(r,i)&&s.push(i);for(;e.length>n;)U(r,i=e[n++])&&(~gt(s,i)||s.push(i));return s},mt=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],yt=mt.concat("length","prototype"),xt={f:Object.getOwnPropertyNames||function(t){return bt(t,yt)}},Et={f:Object.getOwnPropertySymbols},wt=E.Reflect,Ot=wt&&wt.ownKeys||function(t){var e=xt.f(A(t)),i=Et.f;return i?e.concat(i(t)):e},_t=function(t,e){for(var i=Ot(e),r=k.f,n=Q.f,s=0;s<i.length;s++){var o=i[s];U(t,o)||r(t,o,n(e,o))}},St=/#|\.prototype\./,At=function(t,i){var r=Mt[Lt(t)];return r==Wt||r!=kt&&("function"==typeof i?e(i):!!i)},Lt=At.normalize=function(t){return String(t).replace(St,".").toLowerCase()},Mt=At.data={},kt=At.NATIVE="N",Wt=At.POLYFILL="P",Tt=At,jt=Q.f,Rt=function(t,e){var i,r,n,s,o,a=t.target,l=t.global,c=t.stat;if(i=l?E:c?E[a]||j(a,{}):(E[a]||{}).prototype)for(r in e){if(s=e[r],n=t.noTargetGet?(o=jt(i,r))&&o.value:i[r],!Tt(l?r:a+(c?".":"#")+r,t.forced)&&void 0!==n){if(typeof s==typeof n)continue;_t(s,n)}(t.sham||n&&n.sham)&&T(s,"sham",!0),dt(i,r,s,t)}},Nt=q(2);Rt({target:"Array",proto:!0,forced:!(ht="filter",!e(function(){var t=[];return(t.constructor={})[F]=function(){return{foo:1}},1!==t[ht](Boolean).foo}))},{filter:function(t){return Nt(this,t,arguments[1])}});var zt=function(t,i){var r=[][t];return!r||!e(function(){r.call(null,i||function(){throw 1},1)})},Ct=[].forEach,Vt=q(0),Dt=zt("forEach")?function(t){return Vt(this,t,arguments[1])}:Ct;Rt({target:"Array",proto:!0,forced:[].forEach!=Dt},{forEach:Dt});Rt({target:"Array",proto:!0,forced:zt("reduce")},{reduce:function(e){return function(e,i,r,n,o){t(i);var l=a(e),c=s(l),u=f(l.length),h=o?u-1:0,d=o?-1:1;if(r<2)for(;;){if(h in c){n=c[h],h+=d;break}if(h+=d,o?h<0:u<=h)throw TypeError("Reduce of empty array with no initial value")}for(;o?h>=0:u>h;h+=d)h in c&&(n=i(n,c[h],h,l));return n}(this,e,arguments.length,arguments[1],!1)}});var Bt=k.f,It=Function.prototype,Pt=It.toString,Ht=/^\s*function ([^ (]*)/;!w||"name"in It||Bt(It,"name",{configurable:!0,get:function(){try{return Pt.call(this).match(Ht)[1]}catch(t){return""}}});var qt=Object.keys||function(t){return bt(t,mt)},Ft=Object.assign,$t=!Ft||e(function(){var t={},e={},i=Symbol();return t[i]=7,"abcdefghijklmnopqrst".split("").forEach(function(t){e[t]=t}),7!=Ft({},t)[i]||"abcdefghijklmnopqrst"!=qt(Ft({},e)).join("")})?function(t,e){for(var i=a(t),r=arguments.length,n=1,o=Et.f,l=Y.f;r>n;)for(var c,u=s(arguments[n++]),h=o?qt(u).concat(o(u)):qt(u),f=h.length,d=0;f>d;)l.call(u,c=h[d++])&&(i[c]=u[c]);return i}:Ft;Rt({target:"Object",stat:!0,forced:Object.assign!==$t},{assign:$t});var Xt="\t\n\v\f\r                　\u2028\u2029\ufeff",Yt="["+Xt+"]",Gt=RegExp("^"+Yt+Yt+"*"),Kt=RegExp(Yt+Yt+"*$"),Ut=E.parseInt,Jt=/^[-+]?0[xX]/,Qt=8!==Ut(Xt+"08")||22!==Ut(Xt+"0x16")?function(t,e){var i=function(t,e){return t=String(o(t)),1&e&&(t=t.replace(Gt,"")),2&e&&(t=t.replace(Kt,"")),t}(String(t),3);return Ut(i,e>>>0||(Jt.test(i)?16:10))}:Ut;Rt({global:!0,forced:parseInt!=Qt},{parseInt:Qt});var Zt,te,ee=RegExp.prototype.exec,ie=String.prototype.replace,re=ee,ne=(Zt=/a/,te=/b*/g,ee.call(Zt,"a"),ee.call(te,"a"),0!==Zt.lastIndex||0!==te.lastIndex),se=void 0!==/()??/.exec("")[1];(ne||se)&&(re=function(t){var e,i,r,n,s=this;return se&&(i=new RegExp("^"+s.source+"$(?!\\s)",function(){var t=A(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}.call(s))),ne&&(e=s.lastIndex),r=ee.call(s,t),ne&&r&&(s.lastIndex=s.global?r.index+r[0].length:e),se&&r&&r.length>1&&ie.call(r[0],i,function(){for(n=1;n<arguments.length-2;n++)void 0===arguments[n]&&(r[n]=void 0)}),r});var oe=re;Rt({target:"RegExp",proto:!0,forced:/./.exec!==oe},{exec:oe});var ae=function(t,e,i){return e+(i?function(t,e,i){var r,n,s=String(o(t)),a=u(e),l=s.length;return a<0||a>=l?i?"":void 0:(r=s.charCodeAt(a))<55296||r>56319||a+1===l||(n=s.charCodeAt(a+1))<56320||n>57343?i?s.charAt(a):r:i?s.slice(a,a+2):n-56320+(r-55296<<10)+65536}(t,e,!0).length:1)},le=function(t,e){var i=t.exec;if("function"==typeof i){var n=i.call(t,e);if("object"!=typeof n)throw TypeError("RegExp exec method returned something other than an Object or null");return n}if("RegExp"!==r(t))throw TypeError("RegExp#exec called on incompatible receiver");return oe.call(t,e)},ce=I("species"),ue=!e(function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}),he=!e(function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var i="ab".split(t);return 2!==i.length||"a"!==i[0]||"b"!==i[1]}),fe=function(t,i,r,n){var s=I(t),o=!e(function(){var e={};return e[s]=function(){return 7},7!=""[t](e)}),a=o&&!e(function(){var e=!1,i=/a/;return i.exec=function(){return e=!0,null},"split"===t&&(i.constructor={},i.constructor[ce]=function(){return i}),i[s](""),!e});if(!o||!a||"replace"===t&&!ue||"split"===t&&!he){var l=/./[s],c=r(s,""[t],function(t,e,i,r,n){return e.exec===oe?o&&!n?{done:!0,value:l.call(e,i,r)}:{done:!0,value:t.call(i,e,r)}:{done:!1}}),u=c[0],h=c[1];dt(String.prototype,t,u),dt(RegExp.prototype,s,2==i?function(t,e){return h.call(t,this,e)}:function(t){return h.call(t,this)}),n&&T(RegExp.prototype[s],"sham",!0)}};fe("match",1,function(t,e,i){return[function(e){var i=o(this),r=null==e?void 0:e[t];return void 0!==r?r.call(e,i):new RegExp(e)[t](String(i))},function(t){var r=i(e,t,this);if(r.done)return r.value;var n=A(t),s=String(this);if(!n.global)return le(n,s);var o=n.unicode;n.lastIndex=0;for(var a,l=[],c=0;null!==(a=le(n,s));){var u=String(a[0]);l[c]=u,""===u&&(n.lastIndex=ae(s,f(n.lastIndex),o)),c++}return 0===c?null:l}]});var de=Math.max,pe=Math.min,ve=Math.floor,ge=/\$([$&`']|\d\d?|<[^>]*>)/g,be=/\$([$&`']|\d\d?)/g;fe("replace",2,function(t,e,i){return[function(i,r){var n=o(this),s=null==i?void 0:i[t];return void 0!==s?s.call(i,n,r):e.call(String(n),i,r)},function(t,n){var s=i(e,t,this,n);if(s.done)return s.value;var o=A(t),a=String(this),l="function"==typeof n;l||(n=String(n));var c=o.global;if(c){var h=o.unicode;o.lastIndex=0}for(var d=[];;){var p=le(o,a);if(null===p)break;if(d.push(p),!c)break;""===String(p[0])&&(o.lastIndex=ae(a,f(o.lastIndex),h))}for(var v,g="",b=0,m=0;m<d.length;m++){p=d[m];for(var y=String(p[0]),x=de(pe(u(p.index),a.length),0),E=[],w=1;w<p.length;w++)E.push(void 0===(v=p[w])?v:String(v));var O=p.groups;if(l){var _=[y].concat(E,x,a);void 0!==O&&_.push(O);var S=String(n.apply(void 0,_))}else S=r(y,a,x,E,O,n);x>=b&&(g+=a.slice(b,x)+S,b=x+y.length)}return g+a.slice(b)}];function r(t,i,r,n,s,o){var l=r+t.length,c=n.length,u=be;return void 0!==s&&(s=a(s),u=ge),e.call(o,u,function(e,o){var a;switch(o.charAt(0)){case"$":return"$";case"&":return t;case"`":return i.slice(0,r);case"'":return i.slice(l);case"<":a=s[o.slice(1,-1)];break;default:var u=+o;if(0===u)return e;if(u>c){var h=ve(u/10);return 0===h?e:h<=c?void 0===n[h-1]?o.charAt(1):n[h-1]+o.charAt(1):e}a=n[u-1]}return void 0===a?"":a})}});for(var me in{CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}){var ye=E[me],xe=ye&&ye.prototype;if(xe&&xe.forEach!==Dt)try{T(xe,"forEach",Dt)}catch(t){xe.forEach=Dt}}var Ee=g(function(t,e){t.exports=function(){if("undefined"==typeof document)return 0;var t,e=document.body,i=document.createElement("div"),r=i.style;return r.position="absolute",r.top=r.left="-9999px",r.width=r.height="100px",r.overflow="scroll",e.appendChild(i),t=i.offsetWidth-i.clientWidth,e.removeChild(i),t}}),we="Expected a function",Oe=NaN,_e="[object Symbol]",Se=/^\s+|\s+$/g,Ae=/^[-+]0x[0-9a-f]+$/i,Le=/^0b[01]+$/i,Me=/^0o[0-7]+$/i,ke=parseInt,We="object"==typeof v&&v&&v.Object===Object&&v,Te="object"==typeof self&&self&&self.Object===Object&&self,je=We||Te||Function("return this")(),Re=Object.prototype.toString,Ne=Math.max,ze=Math.min,Ce=function(){return je.Date.now()};function Ve(t,e,i){var r,n,s,o,a,l,c=0,u=!1,h=!1,f=!0;if("function"!=typeof t)throw new TypeError(we);function d(e){var i=r,s=n;return r=n=void 0,c=e,o=t.apply(s,i)}function p(t){var i=t-l;return void 0===l||i>=e||i<0||h&&t-c>=s}function v(){var t=Ce();if(p(t))return g(t);a=setTimeout(v,function(t){var i=e-(t-l);return h?ze(i,s-(t-c)):i}(t))}function g(t){return a=void 0,f&&r?d(t):(r=n=void 0,o)}function b(){var t=Ce(),i=p(t);if(r=arguments,n=this,l=t,i){if(void 0===a)return function(t){return c=t,a=setTimeout(v,e),u?d(t):o}(l);if(h)return a=setTimeout(v,e),d(l)}return void 0===a&&(a=setTimeout(v,e)),o}return e=Be(e)||0,De(i)&&(u=!!i.leading,s=(h="maxWait"in i)?Ne(Be(i.maxWait)||0,e):s,f="trailing"in i?!!i.trailing:f),b.cancel=function(){void 0!==a&&clearTimeout(a),c=0,r=l=n=a=void 0},b.flush=function(){return void 0===a?o:g(Ce())},b}function De(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function Be(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return!!t&&"object"==typeof t}(t)&&Re.call(t)==_e}(t))return Oe;if(De(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=De(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(Se,"");var i=Le.test(t);return i||Me.test(t)?ke(t.slice(2),i?2:8):Ae.test(t)?Oe:+t}var Ie=function(t,e,i){var r=!0,n=!0;if("function"!=typeof t)throw new TypeError(we);return De(i)&&(r="leading"in i?!!i.leading:r,n="trailing"in i?!!i.trailing:n),Ve(t,e,{leading:r,maxWait:e,trailing:n})},Pe="Expected a function",He=NaN,qe="[object Symbol]",Fe=/^\s+|\s+$/g,$e=/^[-+]0x[0-9a-f]+$/i,Xe=/^0b[01]+$/i,Ye=/^0o[0-7]+$/i,Ge=parseInt,Ke="object"==typeof v&&v&&v.Object===Object&&v,Ue="object"==typeof self&&self&&self.Object===Object&&self,Je=Ke||Ue||Function("return this")(),Qe=Object.prototype.toString,Ze=Math.max,ti=Math.min,ei=function(){return Je.Date.now()};function ii(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function ri(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return!!t&&"object"==typeof t}(t)&&Qe.call(t)==qe}(t))return He;if(ii(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=ii(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(Fe,"");var i=Xe.test(t);return i||Ye.test(t)?Ge(t.slice(2),i?2:8):$e.test(t)?He:+t}var ni=function(t,e,i){var r,n,s,o,a,l,c=0,u=!1,h=!1,f=!0;if("function"!=typeof t)throw new TypeError(Pe);function d(e){var i=r,s=n;return r=n=void 0,c=e,o=t.apply(s,i)}function p(t){var i=t-l;return void 0===l||i>=e||i<0||h&&t-c>=s}function v(){var t=ei();if(p(t))return g(t);a=setTimeout(v,function(t){var i=e-(t-l);return h?ti(i,s-(t-c)):i}(t))}function g(t){return a=void 0,f&&r?d(t):(r=n=void 0,o)}function b(){var t=ei(),i=p(t);if(r=arguments,n=this,l=t,i){if(void 0===a)return function(t){return c=t,a=setTimeout(v,e),u?d(t):o}(l);if(h)return a=setTimeout(v,e),d(l)}return void 0===a&&(a=setTimeout(v,e)),o}return e=ri(e)||0,ii(i)&&(u=!!i.leading,s=(h="maxWait"in i)?Ze(ri(i.maxWait)||0,e):s,f="trailing"in i?!!i.trailing:f),b.cancel=function(){void 0!==a&&clearTimeout(a),c=0,r=l=n=a=void 0},b.flush=function(){return void 0===a?o:g(ei())},b},si="Expected a function",oi="__lodash_hash_undefined__",ai="[object Function]",li="[object GeneratorFunction]",ci=/^\[object .+?Constructor\]$/,ui="object"==typeof v&&v&&v.Object===Object&&v,hi="object"==typeof self&&self&&self.Object===Object&&self,fi=ui||hi||Function("return this")();var di=Array.prototype,pi=Function.prototype,vi=Object.prototype,gi=fi["__core-js_shared__"],bi=function(){var t=/[^.]+$/.exec(gi&&gi.keys&&gi.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}(),mi=pi.toString,yi=vi.hasOwnProperty,xi=vi.toString,Ei=RegExp("^"+mi.call(yi).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),wi=di.splice,Oi=Ti(fi,"Map"),_i=Ti(Object,"create");function Si(t){var e=-1,i=t?t.length:0;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}function Ai(t){var e=-1,i=t?t.length:0;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}function Li(t){var e=-1,i=t?t.length:0;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}function Mi(t,e){for(var i,r,n=t.length;n--;)if((i=t[n][0])===(r=e)||i!=i&&r!=r)return n;return-1}function ki(t){return!(!Ri(t)||(e=t,bi&&bi in e))&&(function(t){var e=Ri(t)?xi.call(t):"";return e==ai||e==li}(t)||function(t){var e=!1;if(null!=t&&"function"!=typeof t.toString)try{e=!!(t+"")}catch(t){}return e}(t)?Ei:ci).test(function(t){if(null!=t){try{return mi.call(t)}catch(t){}try{return t+""}catch(t){}}return""}(t));var e}function Wi(t,e){var i,r,n=t.__data__;return("string"==(r=typeof(i=e))||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==i:null===i)?n["string"==typeof e?"string":"hash"]:n.map}function Ti(t,e){var i=function(t,e){return null==t?void 0:t[e]}(t,e);return ki(i)?i:void 0}function ji(t,e){if("function"!=typeof t||e&&"function"!=typeof e)throw new TypeError(si);var i=function(){var r=arguments,n=e?e.apply(this,r):r[0],s=i.cache;if(s.has(n))return s.get(n);var o=t.apply(this,r);return i.cache=s.set(n,o),o};return i.cache=new(ji.Cache||Li),i}function Ri(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}Si.prototype.clear=function(){this.__data__=_i?_i(null):{}},Si.prototype.delete=function(t){return this.has(t)&&delete this.__data__[t]},Si.prototype.get=function(t){var e=this.__data__;if(_i){var i=e[t];return i===oi?void 0:i}return yi.call(e,t)?e[t]:void 0},Si.prototype.has=function(t){var e=this.__data__;return _i?void 0!==e[t]:yi.call(e,t)},Si.prototype.set=function(t,e){return this.__data__[t]=_i&&void 0===e?oi:e,this},Ai.prototype.clear=function(){this.__data__=[]},Ai.prototype.delete=function(t){var e=this.__data__,i=Mi(e,t);return!(i<0||(i==e.length-1?e.pop():wi.call(e,i,1),0))},Ai.prototype.get=function(t){var e=this.__data__,i=Mi(e,t);return i<0?void 0:e[i][1]},Ai.prototype.has=function(t){return Mi(this.__data__,t)>-1},Ai.prototype.set=function(t,e){var i=this.__data__,r=Mi(i,t);return r<0?i.push([t,e]):i[r][1]=e,this},Li.prototype.clear=function(){this.__data__={hash:new Si,map:new(Oi||Ai),string:new Si}},Li.prototype.delete=function(t){return Wi(this,t).delete(t)},Li.prototype.get=function(t){return Wi(this,t).get(t)},Li.prototype.has=function(t){return Wi(this,t).has(t)},Li.prototype.set=function(t,e){return Wi(this,t).set(t,e),this},ji.Cache=Li;var Ni=ji,zi=function(){if("undefined"!=typeof Map)return Map;function t(t,e){var i=-1;return t.some(function(t,r){return t[0]===e&&(i=r,!0)}),i}return function(){function e(){this.__entries__=[]}return Object.defineProperty(e.prototype,"size",{get:function(){return this.__entries__.length},enumerable:!0,configurable:!0}),e.prototype.get=function(e){var i=t(this.__entries__,e),r=this.__entries__[i];return r&&r[1]},e.prototype.set=function(e,i){var r=t(this.__entries__,e);~r?this.__entries__[r][1]=i:this.__entries__.push([e,i])},e.prototype.delete=function(e){var i=this.__entries__,r=t(i,e);~r&&i.splice(r,1)},e.prototype.has=function(e){return!!~t(this.__entries__,e)},e.prototype.clear=function(){this.__entries__.splice(0)},e.prototype.forEach=function(t,e){void 0===e&&(e=null);for(var i=0,r=this.__entries__;i<r.length;i++){var n=r[i];t.call(e,n[1],n[0])}},e}()}(),Ci="undefined"!=typeof window&&"undefined"!=typeof document&&window.document===document,Vi="undefined"!=typeof global&&global.Math===Math?global:"undefined"!=typeof self&&self.Math===Math?self:"undefined"!=typeof window&&window.Math===Math?window:Function("return this")(),Di="function"==typeof requestAnimationFrame?requestAnimationFrame.bind(Vi):function(t){return setTimeout(function(){return t(Date.now())},1e3/60)},Bi=2;var Ii=20,Pi=["top","right","bottom","left","width","height","size","weight"],Hi="undefined"!=typeof MutationObserver,qi=function(){function t(){this.connected_=!1,this.mutationEventsAdded_=!1,this.mutationsObserver_=null,this.observers_=[],this.onTransitionEnd_=this.onTransitionEnd_.bind(this),this.refresh=function(t,e){var i=!1,r=!1,n=0;function s(){i&&(i=!1,t()),r&&a()}function o(){Di(s)}function a(){var t=Date.now();if(i){if(t-n<Bi)return;r=!0}else i=!0,r=!1,setTimeout(o,e);n=t}return a}(this.refresh.bind(this),Ii)}return t.prototype.addObserver=function(t){~this.observers_.indexOf(t)||this.observers_.push(t),this.connected_||this.connect_()},t.prototype.removeObserver=function(t){var e=this.observers_,i=e.indexOf(t);~i&&e.splice(i,1),!e.length&&this.connected_&&this.disconnect_()},t.prototype.refresh=function(){this.updateObservers_()&&this.refresh()},t.prototype.updateObservers_=function(){var t=this.observers_.filter(function(t){return t.gatherActive(),t.hasActive()});return t.forEach(function(t){return t.broadcastActive()}),t.length>0},t.prototype.connect_=function(){Ci&&!this.connected_&&(document.addEventListener("transitionend",this.onTransitionEnd_),window.addEventListener("resize",this.refresh),Hi?(this.mutationsObserver_=new MutationObserver(this.refresh),this.mutationsObserver_.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0})):(document.addEventListener("DOMSubtreeModified",this.refresh),this.mutationEventsAdded_=!0),this.connected_=!0)},t.prototype.disconnect_=function(){Ci&&this.connected_&&(document.removeEventListener("transitionend",this.onTransitionEnd_),window.removeEventListener("resize",this.refresh),this.mutationsObserver_&&this.mutationsObserver_.disconnect(),this.mutationEventsAdded_&&document.removeEventListener("DOMSubtreeModified",this.refresh),this.mutationsObserver_=null,this.mutationEventsAdded_=!1,this.connected_=!1)},t.prototype.onTransitionEnd_=function(t){var e=t.propertyName,i=void 0===e?"":e;Pi.some(function(t){return!!~i.indexOf(t)})&&this.refresh()},t.getInstance=function(){return this.instance_||(this.instance_=new t),this.instance_},t.instance_=null,t}(),Fi=function(t,e){for(var i=0,r=Object.keys(e);i<r.length;i++){var n=r[i];Object.defineProperty(t,n,{value:e[n],enumerable:!1,writable:!1,configurable:!0})}return t},$i=function(t){return t&&t.ownerDocument&&t.ownerDocument.defaultView||Vi},Xi=Qi(0,0,0,0);function Yi(t){return parseFloat(t)||0}function Gi(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];return e.reduce(function(e,i){return e+Yi(t["border-"+i+"-width"])},0)}function Ki(t){var e=t.clientWidth,i=t.clientHeight;if(!e&&!i)return Xi;var r=$i(t).getComputedStyle(t),n=function(t){for(var e={},i=0,r=["top","right","bottom","left"];i<r.length;i++){var n=r[i],s=t["padding-"+n];e[n]=Yi(s)}return e}(r),s=n.left+n.right,o=n.top+n.bottom,a=Yi(r.width),l=Yi(r.height);if("border-box"===r.boxSizing&&(Math.round(a+s)!==e&&(a-=Gi(r,"left","right")+s),Math.round(l+o)!==i&&(l-=Gi(r,"top","bottom")+o)),!function(t){return t===$i(t).document.documentElement}(t)){var c=Math.round(a+s)-e,u=Math.round(l+o)-i;1!==Math.abs(c)&&(a-=c),1!==Math.abs(u)&&(l-=u)}return Qi(n.left,n.top,a,l)}var Ui="undefined"!=typeof SVGGraphicsElement?function(t){return t instanceof $i(t).SVGGraphicsElement}:function(t){return t instanceof $i(t).SVGElement&&"function"==typeof t.getBBox};function Ji(t){return Ci?Ui(t)?function(t){var e=t.getBBox();return Qi(0,0,e.width,e.height)}(t):Ki(t):Xi}function Qi(t,e,i,r){return{x:t,y:e,width:i,height:r}}var Zi=function(){function t(t){this.broadcastWidth=0,this.broadcastHeight=0,this.contentRect_=Qi(0,0,0,0),this.target=t}return t.prototype.isActive=function(){var t=Ji(this.target);return this.contentRect_=t,t.width!==this.broadcastWidth||t.height!==this.broadcastHeight},t.prototype.broadcastRect=function(){var t=this.contentRect_;return this.broadcastWidth=t.width,this.broadcastHeight=t.height,t},t}(),tr=function(){return function(t,e){var i,r,n,s,o,a,l,c=(r=(i=e).x,n=i.y,s=i.width,o=i.height,a="undefined"!=typeof DOMRectReadOnly?DOMRectReadOnly:Object,l=Object.create(a.prototype),Fi(l,{x:r,y:n,width:s,height:o,top:n,right:r+s,bottom:o+n,left:r}),l);Fi(this,{target:t,contentRect:c})}}(),er=function(){function t(t,e,i){if(this.activeObservations_=[],this.observations_=new zi,"function"!=typeof t)throw new TypeError("The callback provided as parameter 1 is not a function.");this.callback_=t,this.controller_=e,this.callbackCtx_=i}return t.prototype.observe=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof $i(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)||(e.set(t,new Zi(t)),this.controller_.addObserver(this),this.controller_.refresh())}},t.prototype.unobserve=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof $i(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)&&(e.delete(t),e.size||this.controller_.removeObserver(this))}},t.prototype.disconnect=function(){this.clearActive(),this.observations_.clear(),this.controller_.removeObserver(this)},t.prototype.gatherActive=function(){var t=this;this.clearActive(),this.observations_.forEach(function(e){e.isActive()&&t.activeObservations_.push(e)})},t.prototype.broadcastActive=function(){if(this.hasActive()){var t=this.callbackCtx_,e=this.activeObservations_.map(function(t){return new tr(t.target,t.broadcastRect())});this.callback_.call(t,e,t),this.clearActive()}},t.prototype.clearActive=function(){this.activeObservations_.splice(0)},t.prototype.hasActive=function(){return this.activeObservations_.length>0},t}(),ir="undefined"!=typeof WeakMap?new WeakMap:new zi,rr=function(){return function t(e){if(!(this instanceof t))throw new TypeError("Cannot call a class as a function.");if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");var i=qi.getInstance(),r=new er(e,i,this);ir.set(this,r)}}();["observe","unobserve","disconnect"].forEach(function(t){rr.prototype[t]=function(){var e;return(e=ir.get(this))[t].apply(e,arguments)}});var nr=void 0!==Vi.ResizeObserver?Vi.ResizeObserver:rr,sr=!("undefined"==typeof window||!window.document||!window.document.createElement),or=function(){function t(e,i){var r=this;this.onScroll=function(){r.scrollXTicking||(window.requestAnimationFrame(r.scrollX),r.scrollXTicking=!0),r.scrollYTicking||(window.requestAnimationFrame(r.scrollY),r.scrollYTicking=!0)},this.scrollX=function(){r.axis.x.isOverflowing&&(r.showScrollbar("x"),r.positionScrollbar("x")),r.scrollXTicking=!1},this.scrollY=function(){r.axis.y.isOverflowing&&(r.showScrollbar("y"),r.positionScrollbar("y")),r.scrollYTicking=!1},this.onMouseEnter=function(){r.showScrollbar("x"),r.showScrollbar("y")},this.onMouseMove=function(t){r.mouseX=t.clientX,r.mouseY=t.clientY,(r.axis.x.isOverflowing||r.axis.x.forceVisible)&&r.onMouseMoveForAxis("x"),(r.axis.y.isOverflowing||r.axis.y.forceVisible)&&r.onMouseMoveForAxis("y")},this.onMouseLeave=function(){r.onMouseMove.cancel(),(r.axis.x.isOverflowing||r.axis.x.forceVisible)&&r.onMouseLeaveForAxis("x"),(r.axis.y.isOverflowing||r.axis.y.forceVisible)&&r.onMouseLeaveForAxis("y"),r.mouseX=-1,r.mouseY=-1},this.onWindowResize=function(){r.scrollbarWidth=Ee(),r.hideNativeScrollbar()},this.hideScrollbars=function(){r.axis.x.track.rect=r.axis.x.track.el.getBoundingClientRect(),r.axis.y.track.rect=r.axis.y.track.el.getBoundingClientRect(),r.isWithinBounds(r.axis.y.track.rect)||(r.axis.y.scrollbar.el.classList.remove(r.classNames.visible),r.axis.y.isVisible=!1),r.isWithinBounds(r.axis.x.track.rect)||(r.axis.x.scrollbar.el.classList.remove(r.classNames.visible),r.axis.x.isVisible=!1)},this.onPointerEvent=function(t){var e,i;r.axis.x.scrollbar.rect=r.axis.x.scrollbar.el.getBoundingClientRect(),r.axis.y.scrollbar.rect=r.axis.y.scrollbar.el.getBoundingClientRect(),(r.axis.x.isOverflowing||r.axis.x.forceVisible)&&(i=r.isWithinBounds(r.axis.x.scrollbar.rect)),(r.axis.y.isOverflowing||r.axis.y.forceVisible)&&(e=r.isWithinBounds(r.axis.y.scrollbar.rect)),(e||i)&&(t.preventDefault(),t.stopPropagation(),"mousedown"===t.type&&(e&&r.onDragStart(t,"y"),i&&r.onDragStart(t,"x")))},this.drag=function(e){var i=r.axis[r.draggedAxis].track,n=i.rect[r.axis[r.draggedAxis].sizeAttr],s=r.axis[r.draggedAxis].scrollbar;e.preventDefault(),e.stopPropagation();var o=(("y"===r.draggedAxis?e.pageY:e.pageX)-i.rect[r.axis[r.draggedAxis].offsetAttr]-r.axis[r.draggedAxis].dragOffset)/i.rect[r.axis[r.draggedAxis].sizeAttr]*r.contentWrapperEl[r.axis[r.draggedAxis].scrollSizeAttr];"x"===r.draggedAxis&&(o=r.isRtl&&t.getRtlHelpers().isRtlScrollbarInverted?o-(n+s.size):o,o=r.isRtl&&t.getRtlHelpers().isRtlScrollingInverted?-o:o),r.contentWrapperEl[r.axis[r.draggedAxis].scrollOffsetAttr]=o},this.onEndDrag=function(t){t.preventDefault(),t.stopPropagation(),r.el.classList.remove(r.classNames.dragging),document.removeEventListener("mousemove",r.drag,!0),document.removeEventListener("mouseup",r.onEndDrag,!0)},this.el=e,this.flashTimeout,this.contentEl,this.contentWrapperEl,this.offsetEl,this.maskEl,this.globalObserver,this.mutationObserver,this.resizeObserver,this.scrollbarWidth,this.minScrollbarWidth=20,this.options=Object.assign({},t.defaultOptions,i),this.classNames=Object.assign({},t.defaultOptions.classNames,this.options.classNames),this.isRtl,this.axis={x:{scrollOffsetAttr:"scrollLeft",sizeAttr:"width",scrollSizeAttr:"scrollWidth",offsetAttr:"left",overflowAttr:"overflowX",dragOffset:0,isOverflowing:!0,isVisible:!1,forceVisible:!1,track:{},scrollbar:{}},y:{scrollOffsetAttr:"scrollTop",sizeAttr:"height",scrollSizeAttr:"scrollHeight",offsetAttr:"top",overflowAttr:"overflowY",dragOffset:0,isOverflowing:!0,isVisible:!1,forceVisible:!1,track:{},scrollbar:{}}},this.el.SimpleBar||(this.recalculate=Ie(this.recalculate.bind(this),64),this.onMouseMove=Ie(this.onMouseMove.bind(this),64),this.hideScrollbars=ni(this.hideScrollbars.bind(this),this.options.timeout),this.onWindowResize=ni(this.onWindowResize.bind(this),64,{leading:!0}),t.getRtlHelpers=Ni(t.getRtlHelpers),this.init())}t.getRtlHelpers=function(){var e=document.createElement("div");e.innerHTML='<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';var i=e.firstElementChild;document.body.appendChild(i);var r=i.firstElementChild;i.scrollLeft=0;var n=t.getOffset(i),s=t.getOffset(r);i.scrollLeft=999;var o=t.getOffset(r);return{isRtlScrollingInverted:n.left!==s.left&&s.left-o.left!=0,isRtlScrollbarInverted:n.left!==s.left}},t.initHtmlApi=function(){this.initDOMLoadedElements=this.initDOMLoadedElements.bind(this),"undefined"!=typeof MutationObserver&&(this.globalObserver=new MutationObserver(function(e){e.forEach(function(e){Array.prototype.forEach.call(e.addedNodes,function(e){1===e.nodeType&&(e.hasAttribute("data-simplebar")?!e.SimpleBar&&new t(e,t.getElOptions(e)):Array.prototype.forEach.call(e.querySelectorAll("[data-simplebar]"),function(e){!e.SimpleBar&&new t(e,t.getElOptions(e))}))}),Array.prototype.forEach.call(e.removedNodes,function(t){1===t.nodeType&&(t.hasAttribute("data-simplebar")?t.SimpleBar&&t.SimpleBar.unMount():Array.prototype.forEach.call(t.querySelectorAll("[data-simplebar]"),function(t){t.SimpleBar&&t.SimpleBar.unMount()}))})})}),this.globalObserver.observe(document,{childList:!0,subtree:!0})),"complete"===document.readyState||"loading"!==document.readyState&&!document.documentElement.doScroll?window.setTimeout(this.initDOMLoadedElements):(document.addEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.addEventListener("load",this.initDOMLoadedElements))},t.getElOptions=function(t){return Array.prototype.reduce.call(t.attributes,function(t,e){var i=e.name.match(/data-simplebar-(.+)/);if(i){var r=i[1].replace(/\W+(.)/g,function(t,e){return e.toUpperCase()});switch(e.value){case"true":t[r]=!0;break;case"false":t[r]=!1;break;case void 0:t[r]=!0;break;default:t[r]=e.value}}return t},{})},t.removeObserver=function(){this.globalObserver.disconnect()},t.initDOMLoadedElements=function(){document.removeEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.removeEventListener("load",this.initDOMLoadedElements),Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"),function(e){e.SimpleBar||new t(e,t.getElOptions(e))})},t.getOffset=function(t){var e=t.getBoundingClientRect();return{top:e.top+(window.pageYOffset||document.documentElement.scrollTop),left:e.left+(window.pageXOffset||document.documentElement.scrollLeft)}};var e=t.prototype;return e.init=function(){this.el.SimpleBar=this,sr&&(this.initDOM(),this.scrollbarWidth=Ee(),this.recalculate(),this.initListeners())},e.initDOM=function(){var t=this;if(Array.prototype.filter.call(this.el.children,function(e){return e.classList.contains(t.classNames.wrapper)}).length)this.wrapperEl=this.el.querySelector("."+this.classNames.wrapper),this.contentWrapperEl=this.el.querySelector("."+this.classNames.contentWrapper),this.offsetEl=this.el.querySelector("."+this.classNames.offset),this.maskEl=this.el.querySelector("."+this.classNames.mask),this.contentEl=this.el.querySelector("."+this.classNames.contentEl),this.placeholderEl=this.el.querySelector("."+this.classNames.placeholder),this.heightAutoObserverWrapperEl=this.el.querySelector("."+this.classNames.heightAutoObserverWrapperEl),this.heightAutoObserverEl=this.el.querySelector("."+this.classNames.heightAutoObserverEl),this.axis.x.track.el=this.el.querySelector("."+this.classNames.track+"."+this.classNames.horizontal),this.axis.y.track.el=this.el.querySelector("."+this.classNames.track+"."+this.classNames.vertical);else{for(this.wrapperEl=document.createElement("div"),this.contentWrapperEl=document.createElement("div"),this.offsetEl=document.createElement("div"),this.maskEl=document.createElement("div"),this.contentEl=document.createElement("div"),this.placeholderEl=document.createElement("div"),this.heightAutoObserverWrapperEl=document.createElement("div"),this.heightAutoObserverEl=document.createElement("div"),this.wrapperEl.classList.add(this.classNames.wrapper),this.contentWrapperEl.classList.add(this.classNames.contentWrapper),this.offsetEl.classList.add(this.classNames.offset),this.maskEl.classList.add(this.classNames.mask),this.contentEl.classList.add(this.classNames.contentEl),this.placeholderEl.classList.add(this.classNames.placeholder),this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl),this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);this.el.firstChild;)this.contentEl.appendChild(this.el.firstChild);this.contentWrapperEl.appendChild(this.contentEl),this.offsetEl.appendChild(this.contentWrapperEl),this.maskEl.appendChild(this.offsetEl),this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl),this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl),this.wrapperEl.appendChild(this.maskEl),this.wrapperEl.appendChild(this.placeholderEl),this.el.appendChild(this.wrapperEl)}if(!this.axis.x.track.el||!this.axis.y.track.el){var e=document.createElement("div"),i=document.createElement("div");e.classList.add(this.classNames.track),i.classList.add(this.classNames.scrollbar),e.appendChild(i),this.axis.x.track.el=e.cloneNode(!0),this.axis.x.track.el.classList.add(this.classNames.horizontal),this.axis.y.track.el=e.cloneNode(!0),this.axis.y.track.el.classList.add(this.classNames.vertical),this.el.appendChild(this.axis.x.track.el),this.el.appendChild(this.axis.y.track.el)}this.axis.x.scrollbar.el=this.axis.x.track.el.querySelector("."+this.classNames.scrollbar),this.axis.y.scrollbar.el=this.axis.y.track.el.querySelector("."+this.classNames.scrollbar),this.options.autoHide||(this.axis.x.scrollbar.el.classList.add(this.classNames.visible),this.axis.y.scrollbar.el.classList.add(this.classNames.visible)),this.el.setAttribute("data-simplebar","init")},e.initListeners=function(){var t=this;this.options.autoHide&&this.el.addEventListener("mouseenter",this.onMouseEnter),["mousedown","click","dblclick","touchstart","touchend","touchmove"].forEach(function(e){t.el.addEventListener(e,t.onPointerEvent,!0)}),this.el.addEventListener("mousemove",this.onMouseMove),this.el.addEventListener("mouseleave",this.onMouseLeave),this.contentWrapperEl.addEventListener("scroll",this.onScroll),window.addEventListener("resize",this.onWindowResize),this.resizeObserver=new nr(this.recalculate),this.resizeObserver.observe(this.el),this.resizeObserver.observe(this.contentEl)},e.recalculate=function(){var t=this.heightAutoObserverEl.offsetHeight<=1,e=this.heightAutoObserverEl.offsetWidth<=1;this.elStyles=window.getComputedStyle(this.el),this.isRtl="rtl"===this.elStyles.direction,this.contentEl.style.padding=this.elStyles.paddingTop+" "+this.elStyles.paddingRight+" "+this.elStyles.paddingBottom+" "+this.elStyles.paddingLeft,this.wrapperEl.style.margin="-"+this.elStyles.paddingTop+" -"+this.elStyles.paddingRight+" -"+this.elStyles.paddingBottom+" -"+this.elStyles.paddingLeft,this.contentWrapperEl.style.height=t?"auto":"100%",this.placeholderEl.style.width=e?this.contentEl.offsetWidth+"px":"auto",this.placeholderEl.style.height=this.contentEl.scrollHeight+"px",this.axis.x.isOverflowing=this.contentWrapperEl.scrollWidth>this.contentWrapperEl.offsetWidth,this.axis.y.isOverflowing=this.contentWrapperEl.scrollHeight>this.contentWrapperEl.offsetHeight,this.axis.x.isOverflowing="hidden"!==this.elStyles.overflowX&&this.axis.x.isOverflowing,this.axis.y.isOverflowing="hidden"!==this.elStyles.overflowY&&this.axis.y.isOverflowing,this.axis.x.forceVisible="x"===this.options.forceVisible||!0===this.options.forceVisible,this.axis.y.forceVisible="y"===this.options.forceVisible||!0===this.options.forceVisible,this.hideNativeScrollbar(),this.axis.x.track.rect=this.axis.x.track.el.getBoundingClientRect(),this.axis.y.track.rect=this.axis.y.track.el.getBoundingClientRect(),this.axis.x.scrollbar.size=this.getScrollbarSize("x"),this.axis.y.scrollbar.size=this.getScrollbarSize("y"),this.axis.x.scrollbar.el.style.width=this.axis.x.scrollbar.size+"px",this.axis.y.scrollbar.el.style.height=this.axis.y.scrollbar.size+"px",this.positionScrollbar("x"),this.positionScrollbar("y"),this.toggleTrackVisibility("x"),this.toggleTrackVisibility("y")},e.getScrollbarSize=function(t){void 0===t&&(t="y");var e,i=this.scrollbarWidth?this.contentWrapperEl[this.axis[t].scrollSizeAttr]:this.contentWrapperEl[this.axis[t].scrollSizeAttr]-this.minScrollbarWidth,r=this.axis[t].track.rect[this.axis[t].sizeAttr];if(this.axis[t].isOverflowing){var n=r/i;return e=Math.max(~~(n*r),this.options.scrollbarMinSize),this.options.scrollbarMaxSize&&(e=Math.min(e,this.options.scrollbarMaxSize)),e}},e.positionScrollbar=function(e){void 0===e&&(e="y");var i=this.contentWrapperEl[this.axis[e].scrollSizeAttr],r=this.axis[e].track.rect[this.axis[e].sizeAttr],n=parseInt(this.elStyles[this.axis[e].sizeAttr],10),s=this.axis[e].scrollbar,o=this.contentWrapperEl[this.axis[e].scrollOffsetAttr],a=(o="x"===e&&this.isRtl&&t.getRtlHelpers().isRtlScrollingInverted?-o:o)/(i-n),l=~~((r-s.size)*a);l="x"===e&&this.isRtl&&t.getRtlHelpers().isRtlScrollbarInverted?l+(r-s.size):l,s.el.style.transform="x"===e?"translate3d("+l+"px, 0, 0)":"translate3d(0, "+l+"px, 0)"},e.toggleTrackVisibility=function(t){void 0===t&&(t="y");var e=this.axis[t].track.el,i=this.axis[t].scrollbar.el;this.axis[t].isOverflowing||this.axis[t].forceVisible?(e.style.visibility="visible",this.contentWrapperEl.style[this.axis[t].overflowAttr]="scroll"):(e.style.visibility="hidden",this.contentWrapperEl.style[this.axis[t].overflowAttr]="hidden"),this.axis[t].isOverflowing?i.style.display="block":i.style.display="none"},e.hideNativeScrollbar=function(){if(this.offsetEl.style[this.isRtl?"left":"right"]=this.axis.y.isOverflowing||this.axis.y.forceVisible?"-"+(this.scrollbarWidth||this.minScrollbarWidth)+"px":0,this.offsetEl.style.bottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?"-"+(this.scrollbarWidth||this.minScrollbarWidth)+"px":0,!this.scrollbarWidth){var t=[this.isRtl?"paddingLeft":"paddingRight"];this.contentWrapperEl.style[t]=this.axis.y.isOverflowing||this.axis.y.forceVisible?this.minScrollbarWidth+"px":0,this.contentWrapperEl.style.paddingBottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?this.minScrollbarWidth+"px":0}},e.onMouseMoveForAxis=function(t){void 0===t&&(t="y"),this.axis[t].track.rect=this.axis[t].track.el.getBoundingClientRect(),this.axis[t].scrollbar.rect=this.axis[t].scrollbar.el.getBoundingClientRect(),this.isWithinBounds(this.axis[t].scrollbar.rect)?this.axis[t].scrollbar.el.classList.add(this.classNames.hover):this.axis[t].scrollbar.el.classList.remove(this.classNames.hover),this.isWithinBounds(this.axis[t].track.rect)?(this.showScrollbar(t),this.axis[t].track.el.classList.add(this.classNames.hover)):this.axis[t].track.el.classList.remove(this.classNames.hover)},e.onMouseLeaveForAxis=function(t){void 0===t&&(t="y"),this.axis[t].track.el.classList.remove(this.classNames.hover),this.axis[t].scrollbar.el.classList.remove(this.classNames.hover)},e.showScrollbar=function(t){void 0===t&&(t="y");var e=this.axis[t].scrollbar.el;this.axis[t].isVisible||(e.classList.add(this.classNames.visible),this.axis[t].isVisible=!0),this.options.autoHide&&this.hideScrollbars()},e.onDragStart=function(t,e){void 0===e&&(e="y");var i=this.axis[e].scrollbar.el,r="y"===e?t.pageY:t.pageX;this.axis[e].dragOffset=r-i.getBoundingClientRect()[this.axis[e].offsetAttr],this.draggedAxis=e,this.el.classList.add(this.classNames.dragging),document.addEventListener("mousemove",this.drag,!0),document.addEventListener("mouseup",this.onEndDrag,!0)},e.getContentElement=function(){return this.contentEl},e.getScrollElement=function(){return this.contentWrapperEl},e.removeListeners=function(){var t=this;this.options.autoHide&&this.el.removeEventListener("mouseenter",this.onMouseEnter),["mousedown","click","dblclick","touchstart","touchend","touchmove"].forEach(function(e){t.el.removeEventListener(e,t.onPointerEvent)}),this.el.removeEventListener("mousemove",this.onMouseMove),this.el.removeEventListener("mouseleave",this.onMouseLeave),this.contentWrapperEl.removeEventListener("scroll",this.onScroll),window.removeEventListener("resize",this.onWindowResize),this.mutationObserver&&this.mutationObserver.disconnect(),this.resizeObserver.disconnect(),this.recalculate.cancel(),this.onMouseMove.cancel(),this.hideScrollbars.cancel(),this.onWindowResize.cancel()},e.unMount=function(){this.removeListeners(),this.el.SimpleBar=null},e.isChildNode=function(t){return null!==t&&(t===this.el||this.isChildNode(t.parentNode))},e.isWithinBounds=function(t){return this.mouseX>=t.left&&this.mouseX<=t.left+t.width&&this.mouseY>=t.top&&this.mouseY<=t.top+t.height},t}();return or.defaultOptions={autoHide:!0,forceVisible:!1,classNames:{contentEl:"simplebar-content",contentWrapper:"simplebar-content-wrapper",offset:"simplebar-offset",mask:"simplebar-mask",wrapper:"simplebar-wrapper",placeholder:"simplebar-placeholder",scrollbar:"simplebar-scrollbar",track:"simplebar-track",heightAutoObserverWrapperEl:"simplebar-height-auto-observer-wrapper",heightAutoObserverEl:"simplebar-height-auto-observer",visible:"simplebar-visible",horizontal:"simplebar-horizontal",vertical:"simplebar-vertical",hover:"simplebar-hover",dragging:"simplebar-dragging"},scrollbarMinSize:25,scrollbarMaxSize:0,timeout:1e3},sr&&or.initHtmlApi(),or});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var empty = ''
	var space = ' '
	var whiteSpace = /[ \t\n\r\f]+/g
	
	function parse(value) {
	  var input = String(value || empty).trim()
	  return input === empty ? [] : input.split(whiteSpace)
	}
	
	function stringify(values) {
	  return values.join(space).trim()
	}


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(875);
	
	/**
	 * Parses inline style to object.
	 *
	 * @example
	 * // returns { 'line-height': '42' }
	 * StyleToObject('line-height: 42;');
	 *
	 * @param  {String}      style      - The inline style.
	 * @param  {Function}    [iterator] - The iterator function.
	 * @return {null|Object}
	 */
	function StyleToObject(style, iterator) {
	  var output = null;
	  if (!style || typeof style !== 'string') {
	    return output;
	  }
	
	  var declaration;
	  var declarations = parse(style);
	  var hasIterator = typeof iterator === 'function';
	  var property;
	  var value;
	
	  for (var i = 0, len = declarations.length; i < len; i++) {
	    declaration = declarations[i];
	    property = declaration.property;
	    value = declaration.value;
	
	    if (hasIterator) {
	      iterator(property, value, declaration);
	    } else if (value) {
	      output || (output = {});
	      output[property] = value;
	    }
	  }
	
	  return output;
	}
	
	module.exports = StyleToObject;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)(module)))

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
	//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 1117 */,
/* 1118 */
/***/ (function(module, exports) {

	var reg = /[\'\"]/
	
	module.exports = function unquote(str) {
	  if (!str) {
	    return ''
	  }
	  if (reg.test(str.charAt(0))) {
	    str = str.substr(1)
	  }
	  if (reg.test(str.charAt(str.length - 1))) {
	    str = str.substr(0, str.length - 1)
	  }
	  return str
	}


/***/ }),
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ })
]);


// WEBPACK FOOTER //
// component---src-templates-docstemplate-jsx-8b8e02930f993d1db6ec.js